import { jsx as b, Fragment as St, jsxs as ie } from "react/jsx-runtime";
import * as d from "react";
import j, { forwardRef as fe, useLayoutEffect as S9, useEffect as dn, useState as Yt, createElement as $t, createContext as _o, useId as zS, useContext as Yn, useRef as Lt, useCallback as be, useMemo as Te, memo as lt, cloneElement as YS, Component as GS, isValidElement as KS, Fragment as C2 } from "react";
import * as R0 from "react-dom";
import tg, { unstable_batchedUpdates as ZS } from "react-dom";
function n8(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function vr(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = n8(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : n8(e[o], null);
        }
      };
  };
}
function ke(...e) {
  return d.useCallback(vr(...e), e);
}
// @__NO_SIDE_EFFECTS__
function $r(e) {
  const t = /* @__PURE__ */ XS(e), n = d.forwardRef((r, o) => {
    const { children: i, ...a } = r, s = d.Children.toArray(i), l = s.find(QS);
    if (l) {
      const c = l.props.children, f = s.map((u) => u === l ? d.Children.count(c) > 1 ? d.Children.only(null) : d.isValidElement(c) ? c.props.children : null : u);
      return /* @__PURE__ */ b(t, { ...a, ref: o, children: d.isValidElement(c) ? d.cloneElement(c, void 0, f) : null });
    }
    return /* @__PURE__ */ b(t, { ...a, ref: o, children: i });
  });
  return n.displayName = `${e}.Slot`, n;
}
var ng = /* @__PURE__ */ $r("Slot");
// @__NO_SIDE_EFFECTS__
function XS(e) {
  const t = d.forwardRef((n, r) => {
    const { children: o, ...i } = n;
    if (d.isValidElement(o)) {
      const a = eM(o), s = JS(i, o.props);
      return o.type !== d.Fragment && (s.ref = r ? vr(r, a) : a), d.cloneElement(o, s);
    }
    return d.Children.count(o) > 1 ? d.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var rg = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function og(e) {
  const t = ({ children: n }) => /* @__PURE__ */ b(St, { children: n });
  return t.displayName = `${e}.Slottable`, t.__radixId = rg, t;
}
function QS(e) {
  return d.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === rg;
}
function JS(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...s) => {
      const l = i(...s);
      return o(...s), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function eM(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function ig(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = ig(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function ag() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = ig(e)) && (r && (r += " "), r += t);
  return r;
}
const r8 = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, o8 = ag, Dn = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null) return o8(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: o, defaultVariants: i } = t, a = Object.keys(o).map((c) => {
    const f = n == null ? void 0 : n[c], u = i == null ? void 0 : i[c];
    if (f === null) return null;
    const h = r8(f) || r8(u);
    return o[c][h];
  }), s = n && Object.entries(n).reduce((c, f) => {
    let [u, h] = f;
    return h === void 0 || (c[u] = h), c;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((c, f) => {
    let { class: u, className: h, ...m } = f;
    return Object.entries(m).every((g) => {
      let [p, v] = g;
      return Array.isArray(v) ? v.includes({
        ...i,
        ...s
      }[p]) : {
        ...i,
        ...s
      }[p] === v;
    }) ? [
      ...c,
      u,
      h
    ] : c;
  }, []);
  return o8(e, a, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, M9 = "-", tM = (e) => {
  const t = rM(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (a) => {
      const s = a.split(M9);
      return s[0] === "" && s.length !== 1 && s.shift(), sg(s, t) || nM(a);
    },
    getConflictingClassGroupIds: (a, s) => {
      const l = n[a] || [];
      return s && r[a] ? [...l, ...r[a]] : l;
    }
  };
}, sg = (e, t) => {
  var a;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), o = r ? sg(e.slice(1), r) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const i = e.join(M9);
  return (a = t.validators.find(({
    validator: s
  }) => s(i))) == null ? void 0 : a.classGroupId;
}, i8 = /^\[(.+)\]$/, nM = (e) => {
  if (i8.test(e)) {
    const t = i8.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, rM = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return iM(Object.entries(e.classGroups), n).forEach(([i, a]) => {
    w2(a, r, i, t);
  }), r;
}, w2 = (e, t, n, r) => {
  e.forEach((o) => {
    if (typeof o == "string") {
      const i = o === "" ? t : a8(t, o);
      i.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (oM(o)) {
        w2(o(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(([i, a]) => {
      w2(a, a8(t, i), n, r);
    });
  });
}, a8 = (e, t) => {
  let n = e;
  return t.split(M9).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, oM = (e) => e.isThemeGetter, iM = (e, t) => t ? e.map(([n, r]) => {
  const o = r.map((i) => typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([a, s]) => [t + a, s])) : i);
  return [n, o];
}) : e, aM = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const o = (i, a) => {
    n.set(i, a), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(i) {
      let a = n.get(i);
      if (a !== void 0)
        return a;
      if ((a = r.get(i)) !== void 0)
        return o(i, a), a;
    },
    set(i, a) {
      n.has(i) ? n.set(i, a) : o(i, a);
    }
  };
}, lg = "!", sM = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, o = t[0], i = t.length, a = (s) => {
    const l = [];
    let c = 0, f = 0, u;
    for (let v = 0; v < s.length; v++) {
      let y = s[v];
      if (c === 0) {
        if (y === o && (r || s.slice(v, v + i) === t)) {
          l.push(s.slice(f, v)), f = v + i;
          continue;
        }
        if (y === "/") {
          u = v;
          continue;
        }
      }
      y === "[" ? c++ : y === "]" && c--;
    }
    const h = l.length === 0 ? s : s.substring(f), m = h.startsWith(lg), g = m ? h.substring(1) : h, p = u && u > f ? u - f : void 0;
    return {
      modifiers: l,
      hasImportantModifier: m,
      baseClassName: g,
      maybePostfixModifierPosition: p
    };
  };
  return n ? (s) => n({
    className: s,
    parseClassName: a
  }) : a;
}, lM = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, cM = (e) => ({
  cache: aM(e.cacheSize),
  parseClassName: sM(e),
  ...tM(e)
}), uM = /\s+/, dM = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: o
  } = t, i = [], a = e.trim().split(uM);
  let s = "";
  for (let l = a.length - 1; l >= 0; l -= 1) {
    const c = a[l], {
      modifiers: f,
      hasImportantModifier: u,
      baseClassName: h,
      maybePostfixModifierPosition: m
    } = n(c);
    let g = !!m, p = r(g ? h.substring(0, m) : h);
    if (!p) {
      if (!g) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (p = r(h), !p) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      g = !1;
    }
    const v = lM(f).join(":"), y = u ? v + lg : v, C = y + p;
    if (i.includes(C))
      continue;
    i.push(C);
    const w = o(p, g);
    for (let _ = 0; _ < w.length; ++_) {
      const x = w[_];
      i.push(y + x);
    }
    s = c + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function fM() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = cg(t)) && (r && (r += " "), r += n);
  return r;
}
const cg = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = cg(e[r])) && (n && (n += " "), n += t);
  return n;
};
function hM(e, ...t) {
  let n, r, o, i = a;
  function a(l) {
    const c = t.reduce((f, u) => u(f), e());
    return n = cM(c), r = n.cache.get, o = n.cache.set, i = s, s(l);
  }
  function s(l) {
    const c = r(l);
    if (c)
      return c;
    const f = dM(l, n);
    return o(l, f), f;
  }
  return function() {
    return i(fM.apply(null, arguments));
  };
}
const wt = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, ug = /^\[(?:([a-z-]+):)?(.+)\]$/i, mM = /^\d+\/\d+$/, pM = /* @__PURE__ */ new Set(["px", "full", "screen"]), gM = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, vM = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, bM = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, yM = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, CM = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, cr = (e) => Xo(e) || pM.has(e) || mM.test(e), Er = (e) => vi(e, "length", LM), Xo = (e) => !!e && !Number.isNaN(Number(e)), Ac = (e) => vi(e, "number", Xo), Fi = (e) => !!e && Number.isInteger(Number(e)), wM = (e) => e.endsWith("%") && Xo(e.slice(0, -1)), Ne = (e) => ug.test(e), Lr = (e) => gM.test(e), xM = /* @__PURE__ */ new Set(["length", "size", "percentage"]), _M = (e) => vi(e, xM, dg), kM = (e) => vi(e, "position", dg), SM = /* @__PURE__ */ new Set(["image", "url"]), MM = (e) => vi(e, SM, PM), EM = (e) => vi(e, "", TM), Wi = () => !0, vi = (e, t, n) => {
  const r = ug.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, LM = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  vM.test(e) && !bM.test(e)
), dg = () => !1, TM = (e) => yM.test(e), PM = (e) => CM.test(e), RM = () => {
  const e = wt("colors"), t = wt("spacing"), n = wt("blur"), r = wt("brightness"), o = wt("borderColor"), i = wt("borderRadius"), a = wt("borderSpacing"), s = wt("borderWidth"), l = wt("contrast"), c = wt("grayscale"), f = wt("hueRotate"), u = wt("invert"), h = wt("gap"), m = wt("gradientColorStops"), g = wt("gradientColorStopPositions"), p = wt("inset"), v = wt("margin"), y = wt("opacity"), C = wt("padding"), w = wt("saturate"), _ = wt("scale"), x = wt("sepia"), k = wt("skew"), S = wt("space"), T = wt("translate"), L = () => ["auto", "contain", "none"], R = () => ["auto", "hidden", "clip", "visible", "scroll"], M = () => ["auto", Ne, t], A = () => [Ne, t], O = () => ["", cr, Er], I = () => ["auto", Xo, Ne], W = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], N = () => ["solid", "dashed", "dotted", "double", "none"], H = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], q = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], D = () => ["", "0", Ne], $ = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], U = () => [Xo, Ne];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Wi],
      spacing: [cr, Er],
      blur: ["none", "", Lr, Ne],
      brightness: U(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Lr, Ne],
      borderSpacing: A(),
      borderWidth: O(),
      contrast: U(),
      grayscale: D(),
      hueRotate: U(),
      invert: D(),
      gap: A(),
      gradientColorStops: [e],
      gradientColorStopPositions: [wM, Er],
      inset: M(),
      margin: M(),
      opacity: U(),
      padding: A(),
      saturate: U(),
      scale: U(),
      sepia: D(),
      skew: U(),
      space: A(),
      translate: A()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", Ne]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Lr]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": $()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": $()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...W(), Ne]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: R()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": R()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": R()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: L()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": L()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": L()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [p]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [p]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [p]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [p]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [p]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [p]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [p]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [p]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [p]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Fi, Ne]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: M()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", Ne]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: D()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: D()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Fi, Ne]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Wi]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Fi, Ne]
        }, Ne]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": I()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": I()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Wi]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Fi, Ne]
        }, Ne]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": I()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": I()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", Ne]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", Ne]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [h]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [h]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [h]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...q()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...q(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...q(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [C]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [C]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [C]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [C]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [C]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [C]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [C]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [C]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [C]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [v]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [v]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [v]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [v]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [v]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [v]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [v]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [v]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [v]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [S]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [S]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", Ne, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [Ne, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [Ne, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Lr]
        }, Lr]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [Ne, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [Ne, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [Ne, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [Ne, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Lr, Er]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Ac]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Wi]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", Ne]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Xo, Ac]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", cr, Ne]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", Ne]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", Ne]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [y]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [y]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...N(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", cr, Er]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", cr, Ne]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: A()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", Ne]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", Ne]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [y]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...W(), kM]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", _M]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, MM]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [g]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [g]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [g]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [m]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [y]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...N(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [y]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: N()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [o]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...N()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [cr, Ne]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [cr, Er]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: O()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [y]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [cr, Er]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Lr, EM]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Wi]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [y]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...H(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": H()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Lr, Ne]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [f]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [u]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [w]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [x]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [f]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [u]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [y]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [w]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [x]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", Ne]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: U()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", Ne]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: U()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", Ne]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [_]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [_]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [_]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Fi, Ne]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [T]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [T]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [k]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [k]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", Ne]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", Ne]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": A()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": A()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": A()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": A()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": A()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": A()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": A()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": A()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": A()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": A()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": A()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": A()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": A()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": A()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": A()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": A()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": A()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": A()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", Ne]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [cr, Er, Ac]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, AM = /* @__PURE__ */ hM(RM);
function Q(...e) {
  return AM(ag(e));
}
const co = Dn(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full text-sm font-medium transition-colors duration-500 ease-in-out focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&:is(a)]:no-underline [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-slate-700 text-white shadow hover:bg-indigo-500",
        destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline: "border border-slate-200 bg-white text-slate-700 hover:divide-indigo-500 hover:border-indigo-500 hover:text-indigo-500",
        secondary: "bg-slate-200 text-slate-700 shadow-sm hover:bg-indigo-200",
        ghost: "hover:bg-indigo-100 hover:text-accent-foreground",
        link: "text-slate-700 underline underline-offset-4 hover:text-indigo-500 [&:is(a)]:no-underline"
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-6 px-3 py-2 text-xs",
        lg: "h-10 px-8 py-2",
        icon: "size-9 p-2"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), Or = d.forwardRef(
  ({ className: e, variant: t, size: n, asChild: r = !1, ...o }, i) => /* @__PURE__ */ b(
    r ? ng : "button",
    {
      ...o,
      className: Q(co({ variant: t, size: n }), e),
      style: void 0,
      ref: i
    }
  )
);
Or.displayName = "LBButton";
function ne(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function OM(e, t) {
  const n = d.createContext(t), r = (i) => {
    const { children: a, ...s } = i, l = d.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ b(n.Provider, { value: l, children: a });
  };
  r.displayName = e + "Provider";
  function o(i) {
    const a = d.useContext(n);
    if (a) return a;
    if (t !== void 0) return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return [r, o];
}
function Ot(e, t = []) {
  let n = [];
  function r(i, a) {
    const s = d.createContext(a), l = n.length;
    n = [...n, a];
    const c = (u) => {
      var y;
      const { scope: h, children: m, ...g } = u, p = ((y = h == null ? void 0 : h[e]) == null ? void 0 : y[l]) || s, v = d.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ b(p.Provider, { value: v, children: m });
    };
    c.displayName = i + "Provider";
    function f(u, h) {
      var p;
      const m = ((p = h == null ? void 0 : h[e]) == null ? void 0 : p[l]) || s, g = d.useContext(m);
      if (g) return g;
      if (a !== void 0) return a;
      throw new Error(`\`${u}\` must be used within \`${i}\``);
    }
    return [c, f];
  }
  const o = () => {
    const i = n.map((a) => d.createContext(a));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || i;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return o.scopeName = e, [r, NM(o, ...t)];
}
function NM(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const a = r.reduce((s, { useScope: l, scopeName: c }) => {
        const u = l(i)[`__scope${c}`];
        return { ...s, ...u };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function A0(e) {
  const t = e + "CollectionProvider", [n, r] = Ot(t), [o, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = (p) => {
    const { scope: v, children: y } = p, C = j.useRef(null), w = j.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ b(o, { scope: v, itemMap: w, collectionRef: C, children: y });
  };
  a.displayName = t;
  const s = e + "CollectionSlot", l = /* @__PURE__ */ $r(s), c = j.forwardRef(
    (p, v) => {
      const { scope: y, children: C } = p, w = i(s, y), _ = ke(v, w.collectionRef);
      return /* @__PURE__ */ b(l, { ref: _, children: C });
    }
  );
  c.displayName = s;
  const f = e + "CollectionItemSlot", u = "data-radix-collection-item", h = /* @__PURE__ */ $r(f), m = j.forwardRef(
    (p, v) => {
      const { scope: y, children: C, ...w } = p, _ = j.useRef(null), x = ke(v, _), k = i(f, y);
      return j.useEffect(() => (k.itemMap.set(_, { ref: _, ...w }), () => void k.itemMap.delete(_))), /* @__PURE__ */ b(h, { [u]: "", ref: x, children: C });
    }
  );
  m.displayName = f;
  function g(p) {
    const v = i(e + "CollectionConsumer", p);
    return j.useCallback(() => {
      const C = v.collectionRef.current;
      if (!C) return [];
      const w = Array.from(C.querySelectorAll(`[${u}]`));
      return Array.from(v.itemMap.values()).sort(
        (k, S) => w.indexOf(k.ref.current) - w.indexOf(S.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: a, Slot: c, ItemSlot: m },
    g,
    r
  ];
}
var At = globalThis != null && globalThis.document ? d.useLayoutEffect : () => {
}, DM = d[" useId ".trim().toString()] || (() => {
}), IM = 0;
function Tt(e) {
  const [t, n] = d.useState(DM());
  return At(() => {
    n((r) => r ?? String(IM++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
var BM = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], ce = BM.reduce((e, t) => {
  const n = /* @__PURE__ */ $r(`Primitive.${t}`), r = d.forwardRef((o, i) => {
    const { asChild: a, ...s } = o, l = a ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ b(l, { ...s, ref: i });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function fg(e, t) {
  e && R0.flushSync(() => e.dispatchEvent(t));
}
function qt(e) {
  const t = d.useRef(e);
  return d.useEffect(() => {
    t.current = e;
  }), d.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
var $M = d[" useInsertionEffect ".trim().toString()] || At;
function Jt({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [o, i, a] = FM({
    defaultProp: t,
    onChange: n
  }), s = e !== void 0, l = s ? e : o;
  {
    const f = d.useRef(e !== void 0);
    d.useEffect(() => {
      const u = f.current;
      u !== s && console.warn(
        `${r} is changing from ${u ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), f.current = s;
    }, [s, r]);
  }
  const c = d.useCallback(
    (f) => {
      var u;
      if (s) {
        const h = WM(f) ? f(e) : f;
        h !== e && ((u = a.current) == null || u.call(a, h));
      } else
        i(f);
    },
    [s, e, i, a]
  );
  return [l, c];
}
function FM({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = d.useState(e), o = d.useRef(n), i = d.useRef(t);
  return $M(() => {
    i.current = t;
  }, [t]), d.useEffect(() => {
    var a;
    o.current !== n && ((a = i.current) == null || a.call(i, n), o.current = n);
  }, [n, o]), [n, r, i];
}
function WM(e) {
  return typeof e == "function";
}
var qM = d.createContext(void 0);
function ko(e) {
  const t = d.useContext(qM);
  return e || t || "ltr";
}
var Oc = "rovingFocusGroup.onEntryFocus", jM = { bubbles: !1, cancelable: !0 }, za = "RovingFocusGroup", [x2, hg, HM] = A0(za), [VM, bi] = Ot(
  za,
  [HM]
), [UM, zM] = VM(za), mg = d.forwardRef(
  (e, t) => /* @__PURE__ */ b(x2.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ b(x2.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ b(YM, { ...e, ref: t }) }) })
);
mg.displayName = za;
var YM = d.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: i,
    currentTabStopId: a,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: f = !1,
    ...u
  } = e, h = d.useRef(null), m = ke(t, h), g = ko(i), [p, v] = Jt({
    prop: a,
    defaultProp: s ?? null,
    onChange: l,
    caller: za
  }), [y, C] = d.useState(!1), w = qt(c), _ = hg(n), x = d.useRef(!1), [k, S] = d.useState(0);
  return d.useEffect(() => {
    const T = h.current;
    if (T)
      return T.addEventListener(Oc, w), () => T.removeEventListener(Oc, w);
  }, [w]), /* @__PURE__ */ b(
    UM,
    {
      scope: n,
      orientation: r,
      dir: g,
      loop: o,
      currentTabStopId: p,
      onItemFocus: d.useCallback(
        (T) => v(T),
        [v]
      ),
      onItemShiftTab: d.useCallback(() => C(!0), []),
      onFocusableItemAdd: d.useCallback(
        () => S((T) => T + 1),
        []
      ),
      onFocusableItemRemove: d.useCallback(
        () => S((T) => T - 1),
        []
      ),
      children: /* @__PURE__ */ b(
        ce.div,
        {
          tabIndex: y || k === 0 ? -1 : 0,
          "data-orientation": r,
          ...u,
          ref: m,
          style: { outline: "none", ...e.style },
          onMouseDown: ne(e.onMouseDown, () => {
            x.current = !0;
          }),
          onFocus: ne(e.onFocus, (T) => {
            const L = !x.current;
            if (T.target === T.currentTarget && L && !y) {
              const R = new CustomEvent(Oc, jM);
              if (T.currentTarget.dispatchEvent(R), !R.defaultPrevented) {
                const M = _().filter((N) => N.focusable), A = M.find((N) => N.active), O = M.find((N) => N.id === p), W = [A, O, ...M].filter(
                  Boolean
                ).map((N) => N.ref.current);
                vg(W, f);
              }
            }
            x.current = !1;
          }),
          onBlur: ne(e.onBlur, () => C(!1))
        }
      )
    }
  );
}), pg = "RovingFocusGroupItem", gg = d.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: i,
      children: a,
      ...s
    } = e, l = Tt(), c = i || l, f = zM(pg, n), u = f.currentTabStopId === c, h = hg(n), { onFocusableItemAdd: m, onFocusableItemRemove: g, currentTabStopId: p } = f;
    return d.useEffect(() => {
      if (r)
        return m(), () => g();
    }, [r, m, g]), /* @__PURE__ */ b(
      x2.ItemSlot,
      {
        scope: n,
        id: c,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ b(
          ce.span,
          {
            tabIndex: u ? 0 : -1,
            "data-orientation": f.orientation,
            ...s,
            ref: t,
            onMouseDown: ne(e.onMouseDown, (v) => {
              r ? f.onItemFocus(c) : v.preventDefault();
            }),
            onFocus: ne(e.onFocus, () => f.onItemFocus(c)),
            onKeyDown: ne(e.onKeyDown, (v) => {
              if (v.key === "Tab" && v.shiftKey) {
                f.onItemShiftTab();
                return;
              }
              if (v.target !== v.currentTarget) return;
              const y = ZM(v, f.orientation, f.dir);
              if (y !== void 0) {
                if (v.metaKey || v.ctrlKey || v.altKey || v.shiftKey) return;
                v.preventDefault();
                let w = h().filter((_) => _.focusable).map((_) => _.ref.current);
                if (y === "last") w.reverse();
                else if (y === "prev" || y === "next") {
                  y === "prev" && w.reverse();
                  const _ = w.indexOf(v.currentTarget);
                  w = f.loop ? XM(w, _ + 1) : w.slice(_ + 1);
                }
                setTimeout(() => vg(w));
              }
            }),
            children: typeof a == "function" ? a({ isCurrentTabStop: u, hasTabStop: p != null }) : a
          }
        )
      }
    );
  }
);
gg.displayName = pg;
var GM = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function KM(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function ZM(e, t, n) {
  const r = KM(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return GM[r];
}
function vg(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function XM(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var E9 = mg, L9 = gg;
function QM(e, t) {
  return d.useReducer((n, r) => t[n][r] ?? n, e);
}
var Nt = (e) => {
  const { present: t, children: n } = e, r = JM(t), o = typeof n == "function" ? n({ present: r.isPresent }) : d.Children.only(n), i = ke(r.ref, eE(o));
  return typeof n == "function" || r.isPresent ? d.cloneElement(o, { ref: i }) : null;
};
Nt.displayName = "Presence";
function JM(e) {
  const [t, n] = d.useState(), r = d.useRef(null), o = d.useRef(e), i = d.useRef("none"), a = e ? "mounted" : "unmounted", [s, l] = QM(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return d.useEffect(() => {
    const c = ws(r.current);
    i.current = s === "mounted" ? c : "none";
  }, [s]), At(() => {
    const c = r.current, f = o.current;
    if (f !== e) {
      const h = i.current, m = ws(c);
      e ? l("MOUNT") : m === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(f && h !== m ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, l]), At(() => {
    if (t) {
      let c;
      const f = t.ownerDocument.defaultView ?? window, u = (m) => {
        const p = ws(r.current).includes(m.animationName);
        if (m.target === t && p && (l("ANIMATION_END"), !o.current)) {
          const v = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = f.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = v);
          });
        }
      }, h = (m) => {
        m.target === t && (i.current = ws(r.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        f.clearTimeout(c), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: d.useCallback((c) => {
      r.current = c ? getComputedStyle(c) : null, n(c);
    }, [])
  };
}
function ws(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function eE(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var O0 = "Tabs", [tE, gJ] = Ot(O0, [
  bi
]), bg = bi(), [nE, T9] = tE(O0), yg = d.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: n,
      value: r,
      onValueChange: o,
      defaultValue: i,
      orientation: a = "horizontal",
      dir: s,
      activationMode: l = "automatic",
      ...c
    } = e, f = ko(s), [u, h] = Jt({
      prop: r,
      onChange: o,
      defaultProp: i ?? "",
      caller: O0
    });
    return /* @__PURE__ */ b(
      nE,
      {
        scope: n,
        baseId: Tt(),
        value: u,
        onValueChange: h,
        orientation: a,
        dir: f,
        activationMode: l,
        children: /* @__PURE__ */ b(
          ce.div,
          {
            dir: f,
            "data-orientation": a,
            ...c,
            ref: t
          }
        )
      }
    );
  }
);
yg.displayName = O0;
var Cg = "TabsList", wg = d.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, loop: r = !0, ...o } = e, i = T9(Cg, n), a = bg(n);
    return /* @__PURE__ */ b(
      E9,
      {
        asChild: !0,
        ...a,
        orientation: i.orientation,
        dir: i.dir,
        loop: r,
        children: /* @__PURE__ */ b(
          ce.div,
          {
            role: "tablist",
            "aria-orientation": i.orientation,
            ...o,
            ref: t
          }
        )
      }
    );
  }
);
wg.displayName = Cg;
var xg = "TabsTrigger", _g = d.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, disabled: o = !1, ...i } = e, a = T9(xg, n), s = bg(n), l = Mg(a.baseId, r), c = Eg(a.baseId, r), f = r === a.value;
    return /* @__PURE__ */ b(
      L9,
      {
        asChild: !0,
        ...s,
        focusable: !o,
        active: f,
        children: /* @__PURE__ */ b(
          ce.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": f,
            "aria-controls": c,
            "data-state": f ? "active" : "inactive",
            "data-disabled": o ? "" : void 0,
            disabled: o,
            id: l,
            ...i,
            ref: t,
            onMouseDown: ne(e.onMouseDown, (u) => {
              !o && u.button === 0 && u.ctrlKey === !1 ? a.onValueChange(r) : u.preventDefault();
            }),
            onKeyDown: ne(e.onKeyDown, (u) => {
              [" ", "Enter"].includes(u.key) && a.onValueChange(r);
            }),
            onFocus: ne(e.onFocus, () => {
              const u = a.activationMode !== "manual";
              !f && !o && u && a.onValueChange(r);
            })
          }
        )
      }
    );
  }
);
_g.displayName = xg;
var kg = "TabsContent", Sg = d.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, forceMount: o, children: i, ...a } = e, s = T9(kg, n), l = Mg(s.baseId, r), c = Eg(s.baseId, r), f = r === s.value, u = d.useRef(f);
    return d.useEffect(() => {
      const h = requestAnimationFrame(() => u.current = !1);
      return () => cancelAnimationFrame(h);
    }, []), /* @__PURE__ */ b(Nt, { present: o || f, children: ({ present: h }) => /* @__PURE__ */ b(
      ce.div,
      {
        "data-state": f ? "active" : "inactive",
        "data-orientation": s.orientation,
        role: "tabpanel",
        "aria-labelledby": l,
        hidden: !h,
        id: c,
        tabIndex: 0,
        ...a,
        ref: t,
        style: {
          ...e.style,
          animationDuration: u.current ? "0s" : void 0
        },
        children: h && i
      }
    ) });
  }
);
Sg.displayName = kg;
function Mg(e, t) {
  return `${e}-trigger-${t}`;
}
function Eg(e, t) {
  return `${e}-content-${t}`;
}
var rE = yg, oE = wg, iE = _g, aE = Sg;
const sE = rE;
sE.displayName = "LBTabs";
const lE = fe(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  oE,
  {
    ref: n,
    ...t,
    style: void 0,
    className: Q(
      "inline-flex h-9 items-center justify-center gap-1 rounded-full border border-slate-200 bg-white px-0.75",
      e
    )
  }
));
lE.displayName = "LBTabsList";
const cE = fe(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  iE,
  {
    ref: n,
    ...t,
    style: void 0,
    className: Q(
      "inline-flex w-full items-center justify-center whitespace-nowrap rounded-full px-3 py-1 text-sm font-medium text-slate-700 ring-offset-background transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-slate-200 [&:is(a)]:no-underline",
      e
    )
  }
));
cE.displayName = "LBTabsTrigger";
const uE = fe(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  aE,
  {
    ref: n,
    ...t,
    style: void 0,
    className: Q(
      "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      e
    )
  }
));
uE.displayName = "LBTabsContent";
function dE(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = qt(e);
  d.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var fE = "DismissableLayer", _2 = "dismissableLayer.update", hE = "dismissableLayer.pointerDownOutside", mE = "dismissableLayer.focusOutside", s8, Lg = d.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), So = d.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: a,
      onDismiss: s,
      ...l
    } = e, c = d.useContext(Lg), [f, u] = d.useState(null), h = (f == null ? void 0 : f.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, m] = d.useState({}), g = ke(t, (S) => u(S)), p = Array.from(c.layers), [v] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), y = p.indexOf(v), C = f ? p.indexOf(f) : -1, w = c.layersWithOutsidePointerEventsDisabled.size > 0, _ = C >= y, x = vE((S) => {
      const T = S.target, L = [...c.branches].some((R) => R.contains(T));
      !_ || L || (o == null || o(S), a == null || a(S), S.defaultPrevented || s == null || s());
    }, h), k = bE((S) => {
      const T = S.target;
      [...c.branches].some((R) => R.contains(T)) || (i == null || i(S), a == null || a(S), S.defaultPrevented || s == null || s());
    }, h);
    return dE((S) => {
      C === c.layers.size - 1 && (r == null || r(S), !S.defaultPrevented && s && (S.preventDefault(), s()));
    }, h), d.useEffect(() => {
      if (f)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (s8 = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(f)), c.layers.add(f), l8(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = s8);
        };
    }, [f, h, n, c]), d.useEffect(() => () => {
      f && (c.layers.delete(f), c.layersWithOutsidePointerEventsDisabled.delete(f), l8());
    }, [f, c]), d.useEffect(() => {
      const S = () => m({});
      return document.addEventListener(_2, S), () => document.removeEventListener(_2, S);
    }, []), /* @__PURE__ */ b(
      ce.div,
      {
        ...l,
        ref: g,
        style: {
          pointerEvents: w ? _ ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: ne(e.onFocusCapture, k.onFocusCapture),
        onBlurCapture: ne(e.onBlurCapture, k.onBlurCapture),
        onPointerDownCapture: ne(
          e.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
So.displayName = fE;
var pE = "DismissableLayerBranch", gE = d.forwardRef((e, t) => {
  const n = d.useContext(Lg), r = d.useRef(null), o = ke(t, r);
  return d.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ b(ce.div, { ...e, ref: o });
});
gE.displayName = pE;
function vE(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = qt(e), r = d.useRef(!1), o = d.useRef(() => {
  });
  return d.useEffect(() => {
    const i = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          Tg(
            hE,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function bE(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = qt(e), r = d.useRef(!1);
  return d.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && Tg(mE, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function l8() {
  const e = new CustomEvent(_2);
  document.dispatchEvent(e);
}
function Tg(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? fg(o, i) : o.dispatchEvent(i);
}
var Nc = 0;
function N0() {
  d.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? c8()), document.body.insertAdjacentElement("beforeend", e[1] ?? c8()), Nc++, () => {
      Nc === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Nc--;
    };
  }, []);
}
function c8() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Dc = "focusScope.autoFocusOnMount", Ic = "focusScope.autoFocusOnUnmount", u8 = { bubbles: !1, cancelable: !0 }, yE = "FocusScope", Ya = d.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...a
  } = e, [s, l] = d.useState(null), c = qt(o), f = qt(i), u = d.useRef(null), h = ke(t, (p) => l(p)), m = d.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  d.useEffect(() => {
    if (r) {
      let p = function(w) {
        if (m.paused || !s) return;
        const _ = w.target;
        s.contains(_) ? u.current = _ : Rr(u.current, { select: !0 });
      }, v = function(w) {
        if (m.paused || !s) return;
        const _ = w.relatedTarget;
        _ !== null && (s.contains(_) || Rr(u.current, { select: !0 }));
      }, y = function(w) {
        if (document.activeElement === document.body)
          for (const x of w)
            x.removedNodes.length > 0 && Rr(s);
      };
      document.addEventListener("focusin", p), document.addEventListener("focusout", v);
      const C = new MutationObserver(y);
      return s && C.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", v), C.disconnect();
      };
    }
  }, [r, s, m.paused]), d.useEffect(() => {
    if (s) {
      f8.add(m);
      const p = document.activeElement;
      if (!s.contains(p)) {
        const y = new CustomEvent(Dc, u8);
        s.addEventListener(Dc, c), s.dispatchEvent(y), y.defaultPrevented || (CE(SE(Pg(s)), { select: !0 }), document.activeElement === p && Rr(s));
      }
      return () => {
        s.removeEventListener(Dc, c), setTimeout(() => {
          const y = new CustomEvent(Ic, u8);
          s.addEventListener(Ic, f), s.dispatchEvent(y), y.defaultPrevented || Rr(p ?? document.body, { select: !0 }), s.removeEventListener(Ic, f), f8.remove(m);
        }, 0);
      };
    }
  }, [s, c, f, m]);
  const g = d.useCallback(
    (p) => {
      if (!n && !r || m.paused) return;
      const v = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, y = document.activeElement;
      if (v && y) {
        const C = p.currentTarget, [w, _] = wE(C);
        w && _ ? !p.shiftKey && y === _ ? (p.preventDefault(), n && Rr(w, { select: !0 })) : p.shiftKey && y === w && (p.preventDefault(), n && Rr(_, { select: !0 })) : y === C && p.preventDefault();
      }
    },
    [n, r, m.paused]
  );
  return /* @__PURE__ */ b(ce.div, { tabIndex: -1, ...a, ref: h, onKeyDown: g });
});
Ya.displayName = yE;
function CE(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Rr(r, { select: t }), document.activeElement !== n) return;
}
function wE(e) {
  const t = Pg(e), n = d8(t, e), r = d8(t.reverse(), e);
  return [n, r];
}
function Pg(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function d8(e, t) {
  for (const n of e)
    if (!xE(n, { upTo: t })) return n;
}
function xE(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function _E(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Rr(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && _E(e) && t && e.select();
  }
}
var f8 = kE();
function kE() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = h8(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = h8(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function h8(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function SE(e) {
  return e.filter((t) => t.tagName !== "A");
}
const ME = ["top", "right", "bottom", "left"], Fr = Math.min, pn = Math.max, Gs = Math.round, xs = Math.floor, Un = (e) => ({
  x: e,
  y: e
}), EE = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, LE = {
  start: "end",
  end: "start"
};
function k2(e, t, n) {
  return pn(e, Fr(t, n));
}
function br(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function yr(e) {
  return e.split("-")[0];
}
function yi(e) {
  return e.split("-")[1];
}
function P9(e) {
  return e === "x" ? "y" : "x";
}
function R9(e) {
  return e === "y" ? "height" : "width";
}
function Wr(e) {
  return ["top", "bottom"].includes(yr(e)) ? "y" : "x";
}
function A9(e) {
  return P9(Wr(e));
}
function TE(e, t, n) {
  n === void 0 && (n = !1);
  const r = yi(e), o = A9(e), i = R9(o);
  let a = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (a = Ks(a)), [a, Ks(a)];
}
function PE(e) {
  const t = Ks(e);
  return [S2(e), t, S2(t)];
}
function S2(e) {
  return e.replace(/start|end/g, (t) => LE[t]);
}
function RE(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? i : a;
    default:
      return [];
  }
}
function AE(e, t, n, r) {
  const o = yi(e);
  let i = RE(yr(e), n === "start", r);
  return o && (i = i.map((a) => a + "-" + o), t && (i = i.concat(i.map(S2)))), i;
}
function Ks(e) {
  return e.replace(/left|right|bottom|top/g, (t) => EE[t]);
}
function OE(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Rg(e) {
  return typeof e != "number" ? OE(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Zs(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function m8(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = Wr(t), a = A9(t), s = R9(a), l = yr(t), c = i === "y", f = r.x + r.width / 2 - o.width / 2, u = r.y + r.height / 2 - o.height / 2, h = r[s] / 2 - o[s] / 2;
  let m;
  switch (l) {
    case "top":
      m = {
        x: f,
        y: r.y - o.height
      };
      break;
    case "bottom":
      m = {
        x: f,
        y: r.y + r.height
      };
      break;
    case "right":
      m = {
        x: r.x + r.width,
        y: u
      };
      break;
    case "left":
      m = {
        x: r.x - o.width,
        y: u
      };
      break;
    default:
      m = {
        x: r.x,
        y: r.y
      };
  }
  switch (yi(t)) {
    case "start":
      m[a] -= h * (n && c ? -1 : 1);
      break;
    case "end":
      m[a] += h * (n && c ? -1 : 1);
      break;
  }
  return m;
}
const NE = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: a
  } = n, s = i.filter(Boolean), l = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let c = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: f,
    y: u
  } = m8(c, r, l), h = r, m = {}, g = 0;
  for (let p = 0; p < s.length; p++) {
    const {
      name: v,
      fn: y
    } = s[p], {
      x: C,
      y: w,
      data: _,
      reset: x
    } = await y({
      x: f,
      y: u,
      initialPlacement: r,
      placement: h,
      strategy: o,
      middlewareData: m,
      rects: c,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    f = C ?? f, u = w ?? u, m = {
      ...m,
      [v]: {
        ...m[v],
        ..._
      }
    }, x && g <= 50 && (g++, typeof x == "object" && (x.placement && (h = x.placement), x.rects && (c = x.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : x.rects), {
      x: f,
      y: u
    } = m8(c, h, l)), p = -1);
  }
  return {
    x: f,
    y: u,
    placement: h,
    strategy: o,
    middlewareData: m
  };
};
async function ba(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: a,
    elements: s,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: u = "floating",
    altBoundary: h = !1,
    padding: m = 0
  } = br(t, e), g = Rg(m), v = s[h ? u === "floating" ? "reference" : "floating" : u], y = Zs(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(v))) == null || n ? v : v.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: f,
    strategy: l
  })), C = u === "floating" ? {
    x: r,
    y: o,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, w = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), _ = await (i.isElement == null ? void 0 : i.isElement(w)) ? await (i.getScale == null ? void 0 : i.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = Zs(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: C,
    offsetParent: w,
    strategy: l
  }) : C);
  return {
    top: (y.top - x.top + g.top) / _.y,
    bottom: (x.bottom - y.bottom + g.bottom) / _.y,
    left: (y.left - x.left + g.left) / _.x,
    right: (x.right - y.right + g.right) / _.x
  };
}
const DE = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: a,
      elements: s,
      middlewareData: l
    } = t, {
      element: c,
      padding: f = 0
    } = br(e, t) || {};
    if (c == null)
      return {};
    const u = Rg(f), h = {
      x: n,
      y: r
    }, m = A9(o), g = R9(m), p = await a.getDimensions(c), v = m === "y", y = v ? "top" : "left", C = v ? "bottom" : "right", w = v ? "clientHeight" : "clientWidth", _ = i.reference[g] + i.reference[m] - h[m] - i.floating[g], x = h[m] - i.reference[m], k = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c));
    let S = k ? k[w] : 0;
    (!S || !await (a.isElement == null ? void 0 : a.isElement(k))) && (S = s.floating[w] || i.floating[g]);
    const T = _ / 2 - x / 2, L = S / 2 - p[g] / 2 - 1, R = Fr(u[y], L), M = Fr(u[C], L), A = R, O = S - p[g] - M, I = S / 2 - p[g] / 2 + T, W = k2(A, I, O), N = !l.arrow && yi(o) != null && I !== W && i.reference[g] / 2 - (I < A ? R : M) - p[g] / 2 < 0, H = N ? I < A ? I - A : I - O : 0;
    return {
      [m]: h[m] + H,
      data: {
        [m]: W,
        centerOffset: I - W - H,
        ...N && {
          alignmentOffset: H
        }
      },
      reset: N
    };
  }
}), IE = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: a,
        initialPlacement: s,
        platform: l,
        elements: c
      } = t, {
        mainAxis: f = !0,
        crossAxis: u = !0,
        fallbackPlacements: h,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: p = !0,
        ...v
      } = br(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const y = yr(o), C = Wr(s), w = yr(s) === s, _ = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), x = h || (w || !p ? [Ks(s)] : PE(s)), k = g !== "none";
      !h && k && x.push(...AE(s, p, g, _));
      const S = [s, ...x], T = await ba(t, v), L = [];
      let R = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (f && L.push(T[y]), u) {
        const I = TE(o, a, _);
        L.push(T[I[0]], T[I[1]]);
      }
      if (R = [...R, {
        placement: o,
        overflows: L
      }], !L.every((I) => I <= 0)) {
        var M, A;
        const I = (((M = i.flip) == null ? void 0 : M.index) || 0) + 1, W = S[I];
        if (W)
          return {
            data: {
              index: I,
              overflows: R
            },
            reset: {
              placement: W
            }
          };
        let N = (A = R.filter((H) => H.overflows[0] <= 0).sort((H, q) => H.overflows[1] - q.overflows[1])[0]) == null ? void 0 : A.placement;
        if (!N)
          switch (m) {
            case "bestFit": {
              var O;
              const H = (O = R.filter((q) => {
                if (k) {
                  const D = Wr(q.placement);
                  return D === C || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  D === "y";
                }
                return !0;
              }).map((q) => [q.placement, q.overflows.filter((D) => D > 0).reduce((D, $) => D + $, 0)]).sort((q, D) => q[1] - D[1])[0]) == null ? void 0 : O[0];
              H && (N = H);
              break;
            }
            case "initialPlacement":
              N = s;
              break;
          }
        if (o !== N)
          return {
            reset: {
              placement: N
            }
          };
      }
      return {};
    }
  };
};
function p8(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function g8(e) {
  return ME.some((t) => e[t] >= 0);
}
const BE = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = br(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await ba(t, {
            ...o,
            elementContext: "reference"
          }), a = p8(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: g8(a)
            }
          };
        }
        case "escaped": {
          const i = await ba(t, {
            ...o,
            altBoundary: !0
          }), a = p8(i, n.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: g8(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function $E(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), a = yr(n), s = yi(n), l = Wr(n) === "y", c = ["left", "top"].includes(a) ? -1 : 1, f = i && l ? -1 : 1, u = br(t, e);
  let {
    mainAxis: h,
    crossAxis: m,
    alignmentAxis: g
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: u.mainAxis || 0,
    crossAxis: u.crossAxis || 0,
    alignmentAxis: u.alignmentAxis
  };
  return s && typeof g == "number" && (m = s === "end" ? g * -1 : g), l ? {
    x: m * f,
    y: h * c
  } : {
    x: h * c,
    y: m * f
  };
}
const FE = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: a,
        middlewareData: s
      } = t, l = await $E(t, e);
      return a === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: o + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: a
        }
      };
    }
  };
}, WE = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: a = !1,
        limiter: s = {
          fn: (v) => {
            let {
              x: y,
              y: C
            } = v;
            return {
              x: y,
              y: C
            };
          }
        },
        ...l
      } = br(e, t), c = {
        x: n,
        y: r
      }, f = await ba(t, l), u = Wr(yr(o)), h = P9(u);
      let m = c[h], g = c[u];
      if (i) {
        const v = h === "y" ? "top" : "left", y = h === "y" ? "bottom" : "right", C = m + f[v], w = m - f[y];
        m = k2(C, m, w);
      }
      if (a) {
        const v = u === "y" ? "top" : "left", y = u === "y" ? "bottom" : "right", C = g + f[v], w = g - f[y];
        g = k2(C, g, w);
      }
      const p = s.fn({
        ...t,
        [h]: m,
        [u]: g
      });
      return {
        ...p,
        data: {
          x: p.x - n,
          y: p.y - r,
          enabled: {
            [h]: i,
            [u]: a
          }
        }
      };
    }
  };
}, qE = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: i,
        middlewareData: a
      } = t, {
        offset: s = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = br(e, t), f = {
        x: n,
        y: r
      }, u = Wr(o), h = P9(u);
      let m = f[h], g = f[u];
      const p = br(s, t), v = typeof p == "number" ? {
        mainAxis: p,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...p
      };
      if (l) {
        const w = h === "y" ? "height" : "width", _ = i.reference[h] - i.floating[w] + v.mainAxis, x = i.reference[h] + i.reference[w] - v.mainAxis;
        m < _ ? m = _ : m > x && (m = x);
      }
      if (c) {
        var y, C;
        const w = h === "y" ? "width" : "height", _ = ["top", "left"].includes(yr(o)), x = i.reference[u] - i.floating[w] + (_ && ((y = a.offset) == null ? void 0 : y[u]) || 0) + (_ ? 0 : v.crossAxis), k = i.reference[u] + i.reference[w] + (_ ? 0 : ((C = a.offset) == null ? void 0 : C[u]) || 0) - (_ ? v.crossAxis : 0);
        g < x ? g = x : g > k && (g = k);
      }
      return {
        [h]: m,
        [u]: g
      };
    }
  };
}, jE = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        rects: i,
        platform: a,
        elements: s
      } = t, {
        apply: l = () => {
        },
        ...c
      } = br(e, t), f = await ba(t, c), u = yr(o), h = yi(o), m = Wr(o) === "y", {
        width: g,
        height: p
      } = i.floating;
      let v, y;
      u === "top" || u === "bottom" ? (v = u, y = h === (await (a.isRTL == null ? void 0 : a.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (y = u, v = h === "end" ? "top" : "bottom");
      const C = p - f.top - f.bottom, w = g - f.left - f.right, _ = Fr(p - f[v], C), x = Fr(g - f[y], w), k = !t.middlewareData.shift;
      let S = _, T = x;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (T = w), (r = t.middlewareData.shift) != null && r.enabled.y && (S = C), k && !h) {
        const R = pn(f.left, 0), M = pn(f.right, 0), A = pn(f.top, 0), O = pn(f.bottom, 0);
        m ? T = g - 2 * (R !== 0 || M !== 0 ? R + M : pn(f.left, f.right)) : S = p - 2 * (A !== 0 || O !== 0 ? A + O : pn(f.top, f.bottom));
      }
      await l({
        ...t,
        availableWidth: T,
        availableHeight: S
      });
      const L = await a.getDimensions(s.floating);
      return g !== L.width || p !== L.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function D0() {
  return typeof window < "u";
}
function Ci(e) {
  return Ag(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function gn(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Jn(e) {
  var t;
  return (t = (Ag(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Ag(e) {
  return D0() ? e instanceof Node || e instanceof gn(e).Node : !1;
}
function An(e) {
  return D0() ? e instanceof Element || e instanceof gn(e).Element : !1;
}
function Gn(e) {
  return D0() ? e instanceof HTMLElement || e instanceof gn(e).HTMLElement : !1;
}
function v8(e) {
  return !D0() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof gn(e).ShadowRoot;
}
function Ga(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = On(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function HE(e) {
  return ["table", "td", "th"].includes(Ci(e));
}
function I0(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function O9(e) {
  const t = N9(), n = An(e) ? On(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function VE(e) {
  let t = qr(e);
  for (; Gn(t) && !ii(t); ) {
    if (O9(t))
      return t;
    if (I0(t))
      return null;
    t = qr(t);
  }
  return null;
}
function N9() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function ii(e) {
  return ["html", "body", "#document"].includes(Ci(e));
}
function On(e) {
  return gn(e).getComputedStyle(e);
}
function B0(e) {
  return An(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function qr(e) {
  if (Ci(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    v8(e) && e.host || // Fallback.
    Jn(e)
  );
  return v8(t) ? t.host : t;
}
function Og(e) {
  const t = qr(e);
  return ii(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Gn(t) && Ga(t) ? t : Og(t);
}
function ya(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = Og(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), a = gn(o);
  if (i) {
    const s = M2(a);
    return t.concat(a, a.visualViewport || [], Ga(o) ? o : [], s && n ? ya(s) : []);
  }
  return t.concat(o, ya(o, [], n));
}
function M2(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Ng(e) {
  const t = On(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = Gn(e), i = o ? e.offsetWidth : n, a = o ? e.offsetHeight : r, s = Gs(n) !== i || Gs(r) !== a;
  return s && (n = i, r = a), {
    width: n,
    height: r,
    $: s
  };
}
function D9(e) {
  return An(e) ? e : e.contextElement;
}
function Qo(e) {
  const t = D9(e);
  if (!Gn(t))
    return Un(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = Ng(t);
  let a = (i ? Gs(n.width) : n.width) / r, s = (i ? Gs(n.height) : n.height) / o;
  return (!a || !Number.isFinite(a)) && (a = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: a,
    y: s
  };
}
const UE = /* @__PURE__ */ Un(0);
function Dg(e) {
  const t = gn(e);
  return !N9() || !t.visualViewport ? UE : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function zE(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== gn(e) ? !1 : t;
}
function uo(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = D9(e);
  let a = Un(1);
  t && (r ? An(r) && (a = Qo(r)) : a = Qo(e));
  const s = zE(i, n, r) ? Dg(i) : Un(0);
  let l = (o.left + s.x) / a.x, c = (o.top + s.y) / a.y, f = o.width / a.x, u = o.height / a.y;
  if (i) {
    const h = gn(i), m = r && An(r) ? gn(r) : r;
    let g = h, p = M2(g);
    for (; p && r && m !== g; ) {
      const v = Qo(p), y = p.getBoundingClientRect(), C = On(p), w = y.left + (p.clientLeft + parseFloat(C.paddingLeft)) * v.x, _ = y.top + (p.clientTop + parseFloat(C.paddingTop)) * v.y;
      l *= v.x, c *= v.y, f *= v.x, u *= v.y, l += w, c += _, g = gn(p), p = M2(g);
    }
  }
  return Zs({
    width: f,
    height: u,
    x: l,
    y: c
  });
}
function I9(e, t) {
  const n = B0(e).scrollLeft;
  return t ? t.left + n : uo(Jn(e)).left + n;
}
function Ig(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), o = r.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    I9(e, r)
  )), i = r.top + t.scrollTop;
  return {
    x: o,
    y: i
  };
}
function YE(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", a = Jn(r), s = t ? I0(t.floating) : !1;
  if (r === a || s && i)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = Un(1);
  const f = Un(0), u = Gn(r);
  if ((u || !u && !i) && ((Ci(r) !== "body" || Ga(a)) && (l = B0(r)), Gn(r))) {
    const m = uo(r);
    c = Qo(r), f.x = m.x + r.clientLeft, f.y = m.y + r.clientTop;
  }
  const h = a && !u && !i ? Ig(a, l, !0) : Un(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + f.x + h.x,
    y: n.y * c.y - l.scrollTop * c.y + f.y + h.y
  };
}
function GE(e) {
  return Array.from(e.getClientRects());
}
function KE(e) {
  const t = Jn(e), n = B0(e), r = e.ownerDocument.body, o = pn(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = pn(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + I9(e);
  const s = -n.scrollTop;
  return On(r).direction === "rtl" && (a += pn(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: a,
    y: s
  };
}
function ZE(e, t) {
  const n = gn(e), r = Jn(e), o = n.visualViewport;
  let i = r.clientWidth, a = r.clientHeight, s = 0, l = 0;
  if (o) {
    i = o.width, a = o.height;
    const c = N9();
    (!c || c && t === "fixed") && (s = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: s,
    y: l
  };
}
function XE(e, t) {
  const n = uo(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = Gn(e) ? Qo(e) : Un(1), a = e.clientWidth * i.x, s = e.clientHeight * i.y, l = o * i.x, c = r * i.y;
  return {
    width: a,
    height: s,
    x: l,
    y: c
  };
}
function b8(e, t, n) {
  let r;
  if (t === "viewport")
    r = ZE(e, n);
  else if (t === "document")
    r = KE(Jn(e));
  else if (An(t))
    r = XE(t, n);
  else {
    const o = Dg(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return Zs(r);
}
function Bg(e, t) {
  const n = qr(e);
  return n === t || !An(n) || ii(n) ? !1 : On(n).position === "fixed" || Bg(n, t);
}
function QE(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = ya(e, [], !1).filter((s) => An(s) && Ci(s) !== "body"), o = null;
  const i = On(e).position === "fixed";
  let a = i ? qr(e) : e;
  for (; An(a) && !ii(a); ) {
    const s = On(a), l = O9(a);
    !l && s.position === "fixed" && (o = null), (i ? !l && !o : !l && s.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || Ga(a) && !l && Bg(e, a)) ? r = r.filter((f) => f !== a) : o = s, a = qr(a);
  }
  return t.set(e, r), r;
}
function JE(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const a = [...n === "clippingAncestors" ? I0(t) ? [] : QE(t, this._c) : [].concat(n), r], s = a[0], l = a.reduce((c, f) => {
    const u = b8(t, f, o);
    return c.top = pn(u.top, c.top), c.right = Fr(u.right, c.right), c.bottom = Fr(u.bottom, c.bottom), c.left = pn(u.left, c.left), c;
  }, b8(t, s, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function eL(e) {
  const {
    width: t,
    height: n
  } = Ng(e);
  return {
    width: t,
    height: n
  };
}
function tL(e, t, n) {
  const r = Gn(t), o = Jn(t), i = n === "fixed", a = uo(e, !0, i, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Un(0);
  if (r || !r && !i)
    if ((Ci(t) !== "body" || Ga(o)) && (s = B0(t)), r) {
      const h = uo(t, !0, i, t);
      l.x = h.x + t.clientLeft, l.y = h.y + t.clientTop;
    } else o && (l.x = I9(o));
  const c = o && !r && !i ? Ig(o, s) : Un(0), f = a.left + s.scrollLeft - l.x - c.x, u = a.top + s.scrollTop - l.y - c.y;
  return {
    x: f,
    y: u,
    width: a.width,
    height: a.height
  };
}
function Bc(e) {
  return On(e).position === "static";
}
function y8(e, t) {
  if (!Gn(e) || On(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Jn(e) === n && (n = n.ownerDocument.body), n;
}
function $g(e, t) {
  const n = gn(e);
  if (I0(e))
    return n;
  if (!Gn(e)) {
    let o = qr(e);
    for (; o && !ii(o); ) {
      if (An(o) && !Bc(o))
        return o;
      o = qr(o);
    }
    return n;
  }
  let r = y8(e, t);
  for (; r && HE(r) && Bc(r); )
    r = y8(r, t);
  return r && ii(r) && Bc(r) && !O9(r) ? n : r || VE(e) || n;
}
const nL = async function(e) {
  const t = this.getOffsetParent || $g, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: tL(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function rL(e) {
  return On(e).direction === "rtl";
}
const oL = {
  convertOffsetParentRelativeRectToViewportRelativeRect: YE,
  getDocumentElement: Jn,
  getClippingRect: JE,
  getOffsetParent: $g,
  getElementRects: nL,
  getClientRects: GE,
  getDimensions: eL,
  getScale: Qo,
  isElement: An,
  isRTL: rL
};
function Fg(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function iL(e, t) {
  let n = null, r;
  const o = Jn(e);
  function i() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function a(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), i();
    const c = e.getBoundingClientRect(), {
      left: f,
      top: u,
      width: h,
      height: m
    } = c;
    if (s || t(), !h || !m)
      return;
    const g = xs(u), p = xs(o.clientWidth - (f + h)), v = xs(o.clientHeight - (u + m)), y = xs(f), w = {
      rootMargin: -g + "px " + -p + "px " + -v + "px " + -y + "px",
      threshold: pn(0, Fr(1, l)) || 1
    };
    let _ = !0;
    function x(k) {
      const S = k[0].intersectionRatio;
      if (S !== l) {
        if (!_)
          return a();
        S ? a(!1, S) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      S === 1 && !Fg(c, e.getBoundingClientRect()) && a(), _ = !1;
    }
    try {
      n = new IntersectionObserver(x, {
        ...w,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(x, w);
    }
    n.observe(e);
  }
  return a(!0), i;
}
function aL(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = D9(e), f = o || i ? [...c ? ya(c) : [], ...ya(t)] : [];
  f.forEach((y) => {
    o && y.addEventListener("scroll", n, {
      passive: !0
    }), i && y.addEventListener("resize", n);
  });
  const u = c && s ? iL(c, n) : null;
  let h = -1, m = null;
  a && (m = new ResizeObserver((y) => {
    let [C] = y;
    C && C.target === c && m && (m.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var w;
      (w = m) == null || w.observe(t);
    })), n();
  }), c && !l && m.observe(c), m.observe(t));
  let g, p = l ? uo(e) : null;
  l && v();
  function v() {
    const y = uo(e);
    p && !Fg(p, y) && n(), p = y, g = requestAnimationFrame(v);
  }
  return n(), () => {
    var y;
    f.forEach((C) => {
      o && C.removeEventListener("scroll", n), i && C.removeEventListener("resize", n);
    }), u == null || u(), (y = m) == null || y.disconnect(), m = null, l && cancelAnimationFrame(g);
  };
}
const sL = FE, lL = WE, cL = IE, uL = jE, dL = BE, C8 = DE, fL = qE, hL = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: oL,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return NE(e, t, {
    ...o,
    platform: i
  });
};
var js = typeof document < "u" ? S9 : dn;
function Xs(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!Xs(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !Xs(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Wg(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function w8(e, t) {
  const n = Wg(e);
  return Math.round(t * n) / n;
}
function $c(e) {
  const t = d.useRef(e);
  return js(() => {
    t.current = e;
  }), t;
}
function mL(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: a
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: c
  } = e, [f, u] = d.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [h, m] = d.useState(r);
  Xs(h, r) || m(r);
  const [g, p] = d.useState(null), [v, y] = d.useState(null), C = d.useCallback((q) => {
    q !== k.current && (k.current = q, p(q));
  }, []), w = d.useCallback((q) => {
    q !== S.current && (S.current = q, y(q));
  }, []), _ = i || g, x = a || v, k = d.useRef(null), S = d.useRef(null), T = d.useRef(f), L = l != null, R = $c(l), M = $c(o), A = $c(c), O = d.useCallback(() => {
    if (!k.current || !S.current)
      return;
    const q = {
      placement: t,
      strategy: n,
      middleware: h
    };
    M.current && (q.platform = M.current), hL(k.current, S.current, q).then((D) => {
      const $ = {
        ...D,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: A.current !== !1
      };
      I.current && !Xs(T.current, $) && (T.current = $, R0.flushSync(() => {
        u($);
      }));
    });
  }, [h, t, n, M, A]);
  js(() => {
    c === !1 && T.current.isPositioned && (T.current.isPositioned = !1, u((q) => ({
      ...q,
      isPositioned: !1
    })));
  }, [c]);
  const I = d.useRef(!1);
  js(() => (I.current = !0, () => {
    I.current = !1;
  }), []), js(() => {
    if (_ && (k.current = _), x && (S.current = x), _ && x) {
      if (R.current)
        return R.current(_, x, O);
      O();
    }
  }, [_, x, O, R, L]);
  const W = d.useMemo(() => ({
    reference: k,
    floating: S,
    setReference: C,
    setFloating: w
  }), [C, w]), N = d.useMemo(() => ({
    reference: _,
    floating: x
  }), [_, x]), H = d.useMemo(() => {
    const q = {
      position: n,
      left: 0,
      top: 0
    };
    if (!N.floating)
      return q;
    const D = w8(N.floating, f.x), $ = w8(N.floating, f.y);
    return s ? {
      ...q,
      transform: "translate(" + D + "px, " + $ + "px)",
      ...Wg(N.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: D,
      top: $
    };
  }, [n, s, N.floating, f.x, f.y]);
  return d.useMemo(() => ({
    ...f,
    update: O,
    refs: W,
    elements: N,
    floatingStyles: H
  }), [f, O, W, N, H]);
}
const pL = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? C8({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? C8({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, gL = (e, t) => ({
  ...sL(e),
  options: [e, t]
}), vL = (e, t) => ({
  ...lL(e),
  options: [e, t]
}), bL = (e, t) => ({
  ...fL(e),
  options: [e, t]
}), yL = (e, t) => ({
  ...cL(e),
  options: [e, t]
}), CL = (e, t) => ({
  ...uL(e),
  options: [e, t]
}), wL = (e, t) => ({
  ...dL(e),
  options: [e, t]
}), xL = (e, t) => ({
  ...pL(e),
  options: [e, t]
});
var _L = "Arrow", qg = d.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ b(
    ce.svg,
    {
      ...i,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ b("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
qg.displayName = _L;
var kL = qg;
function $0(e) {
  const [t, n] = d.useState(void 0);
  return At(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let a, s;
        if ("borderBoxSize" in i) {
          const l = i.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          a = c.inlineSize, s = c.blockSize;
        } else
          a = e.offsetWidth, s = e.offsetHeight;
        n({ width: a, height: s });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var B9 = "Popper", [jg, er] = Ot(B9), [SL, Hg] = jg(B9), Vg = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = d.useState(null);
  return /* @__PURE__ */ b(SL, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
Vg.displayName = B9;
var Ug = "PopperAnchor", zg = d.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, i = Hg(Ug, n), a = d.useRef(null), s = ke(t, a);
    return d.useEffect(() => {
      i.onAnchorChange((r == null ? void 0 : r.current) || a.current);
    }), r ? null : /* @__PURE__ */ b(ce.div, { ...o, ref: s });
  }
);
zg.displayName = Ug;
var $9 = "PopperContent", [ML, EL] = jg($9), Yg = d.forwardRef(
  (e, t) => {
    var V, Y, P, F, z, E;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: i = "center",
      alignOffset: a = 0,
      arrowPadding: s = 0,
      avoidCollisions: l = !0,
      collisionBoundary: c = [],
      collisionPadding: f = 0,
      sticky: u = "partial",
      hideWhenDetached: h = !1,
      updatePositionStrategy: m = "optimized",
      onPlaced: g,
      ...p
    } = e, v = Hg($9, n), [y, C] = d.useState(null), w = ke(t, (re) => C(re)), [_, x] = d.useState(null), k = $0(_), S = (k == null ? void 0 : k.width) ?? 0, T = (k == null ? void 0 : k.height) ?? 0, L = r + (i !== "center" ? "-" + i : ""), R = typeof f == "number" ? f : { top: 0, right: 0, bottom: 0, left: 0, ...f }, M = Array.isArray(c) ? c : [c], A = M.length > 0, O = {
      padding: R,
      boundary: M.filter(TL),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: A
    }, { refs: I, floatingStyles: W, placement: N, isPositioned: H, middlewareData: q } = mL({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: L,
      whileElementsMounted: (...re) => aL(...re, {
        animationFrame: m === "always"
      }),
      elements: {
        reference: v.anchor
      },
      middleware: [
        gL({ mainAxis: o + T, alignmentAxis: a }),
        l && vL({
          mainAxis: !0,
          crossAxis: !1,
          limiter: u === "partial" ? bL() : void 0,
          ...O
        }),
        l && yL({ ...O }),
        CL({
          ...O,
          apply: ({ elements: re, rects: ee, availableWidth: oe, availableHeight: ue }) => {
            const { width: le, height: Ae } = ee.reference, Ie = re.floating.style;
            Ie.setProperty("--radix-popper-available-width", `${oe}px`), Ie.setProperty("--radix-popper-available-height", `${ue}px`), Ie.setProperty("--radix-popper-anchor-width", `${le}px`), Ie.setProperty("--radix-popper-anchor-height", `${Ae}px`);
          }
        }),
        _ && xL({ element: _, padding: s }),
        PL({ arrowWidth: S, arrowHeight: T }),
        h && wL({ strategy: "referenceHidden", ...O })
      ]
    }), [D, $] = Zg(N), U = qt(g);
    At(() => {
      H && (U == null || U());
    }, [H, U]);
    const B = (V = q.arrow) == null ? void 0 : V.x, K = (Y = q.arrow) == null ? void 0 : Y.y, X = ((P = q.arrow) == null ? void 0 : P.centerOffset) !== 0, [Z, G] = d.useState();
    return At(() => {
      y && G(window.getComputedStyle(y).zIndex);
    }, [y]), /* @__PURE__ */ b(
      "div",
      {
        ref: I.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...W,
          transform: H ? W.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: Z,
          "--radix-popper-transform-origin": [
            (F = q.transformOrigin) == null ? void 0 : F.x,
            (z = q.transformOrigin) == null ? void 0 : z.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((E = q.hide) == null ? void 0 : E.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ b(
          ML,
          {
            scope: n,
            placedSide: D,
            onArrowChange: x,
            arrowX: B,
            arrowY: K,
            shouldHideArrow: X,
            children: /* @__PURE__ */ b(
              ce.div,
              {
                "data-side": D,
                "data-align": $,
                ...p,
                ref: w,
                style: {
                  ...p.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: H ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Yg.displayName = $9;
var Gg = "PopperArrow", LL = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Kg = d.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, i = EL(Gg, r), a = LL[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ b(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [a]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ b(
          kL,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Kg.displayName = Gg;
function TL(e) {
  return e !== null;
}
var PL = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var v, y, C;
    const { placement: n, rects: r, middlewareData: o } = t, a = ((v = o.arrow) == null ? void 0 : v.centerOffset) !== 0, s = a ? 0 : e.arrowWidth, l = a ? 0 : e.arrowHeight, [c, f] = Zg(n), u = { start: "0%", center: "50%", end: "100%" }[f], h = (((y = o.arrow) == null ? void 0 : y.x) ?? 0) + s / 2, m = (((C = o.arrow) == null ? void 0 : C.y) ?? 0) + l / 2;
    let g = "", p = "";
    return c === "bottom" ? (g = a ? u : `${h}px`, p = `${-l}px`) : c === "top" ? (g = a ? u : `${h}px`, p = `${r.floating.height + l}px`) : c === "right" ? (g = `${-l}px`, p = a ? u : `${m}px`) : c === "left" && (g = `${r.floating.width + l}px`, p = a ? u : `${m}px`), { data: { x: g, y: p } };
  }
});
function Zg(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var wi = Vg, xi = zg, Ka = Yg, Za = Kg, RL = "Portal", _i = d.forwardRef((e, t) => {
  var s;
  const { container: n, ...r } = e, [o, i] = d.useState(!1);
  At(() => i(!0), []);
  const a = n || o && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return a ? tg.createPortal(/* @__PURE__ */ b(ce.div, { ...r, ref: t }), a) : null;
});
_i.displayName = RL;
var AL = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Io = /* @__PURE__ */ new WeakMap(), _s = /* @__PURE__ */ new WeakMap(), ks = {}, Fc = 0, Xg = function(e) {
  return e && (e.host || Xg(e.parentNode));
}, OL = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = Xg(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, NL = function(e, t, n, r) {
  var o = OL(t, Array.isArray(e) ? e : [e]);
  ks[n] || (ks[n] = /* @__PURE__ */ new WeakMap());
  var i = ks[n], a = [], s = /* @__PURE__ */ new Set(), l = new Set(o), c = function(u) {
    !u || s.has(u) || (s.add(u), c(u.parentNode));
  };
  o.forEach(c);
  var f = function(u) {
    !u || l.has(u) || Array.prototype.forEach.call(u.children, function(h) {
      if (s.has(h))
        f(h);
      else
        try {
          var m = h.getAttribute(r), g = m !== null && m !== "false", p = (Io.get(h) || 0) + 1, v = (i.get(h) || 0) + 1;
          Io.set(h, p), i.set(h, v), a.push(h), p === 1 && g && _s.set(h, !0), v === 1 && h.setAttribute(n, "true"), g || h.setAttribute(r, "true");
        } catch (y) {
          console.error("aria-hidden: cannot operate on ", h, y);
        }
    });
  };
  return f(t), s.clear(), Fc++, function() {
    a.forEach(function(u) {
      var h = Io.get(u) - 1, m = i.get(u) - 1;
      Io.set(u, h), i.set(u, m), h || (_s.has(u) || u.removeAttribute(r), _s.delete(u)), m || u.removeAttribute(n);
    }), Fc--, Fc || (Io = /* @__PURE__ */ new WeakMap(), Io = /* @__PURE__ */ new WeakMap(), _s = /* @__PURE__ */ new WeakMap(), ks = {});
  };
}, F0 = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = AL(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), NL(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, Hn = function() {
  return Hn = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Hn.apply(this, arguments);
};
function Qg(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function DL(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, i; r < o; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var Hs = "right-scroll-bar-position", Vs = "width-before-scroll-bar", IL = "with-scroll-bars-hidden", BL = "--removed-body-scroll-bar-size";
function Wc(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function $L(e, t) {
  var n = Yt(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var FL = typeof window < "u" ? d.useLayoutEffect : d.useEffect, x8 = /* @__PURE__ */ new WeakMap();
function WL(e, t) {
  var n = $L(null, function(r) {
    return e.forEach(function(o) {
      return Wc(o, r);
    });
  });
  return FL(function() {
    var r = x8.get(n);
    if (r) {
      var o = new Set(r), i = new Set(e), a = n.current;
      o.forEach(function(s) {
        i.has(s) || Wc(s, null);
      }), i.forEach(function(s) {
        o.has(s) || Wc(s, a);
      });
    }
    x8.set(n, e);
  }, [e]), n;
}
function qL(e) {
  return e;
}
function jL(e, t) {
  t === void 0 && (t = qL);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var a = t(i, r);
      return n.push(a), function() {
        n = n.filter(function(s) {
          return s !== a;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(i);
      }
      n = {
        push: function(s) {
          return i(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var a = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(i), a = n;
      }
      var l = function() {
        var f = a;
        a = [], f.forEach(i);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(f) {
          a.push(f), c();
        },
        filter: function(f) {
          return a = a.filter(f), n;
        }
      };
    }
  };
  return o;
}
function HL(e) {
  e === void 0 && (e = {});
  var t = jL(null);
  return t.options = Hn({ async: !0, ssr: !1 }, e), t;
}
var Jg = function(e) {
  var t = e.sideCar, n = Qg(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return d.createElement(r, Hn({}, n));
};
Jg.isSideCarExport = !0;
function VL(e, t) {
  return e.useMedium(t), Jg;
}
var ev = HL(), qc = function() {
}, W0 = d.forwardRef(function(e, t) {
  var n = d.useRef(null), r = d.useState({
    onScrollCapture: qc,
    onWheelCapture: qc,
    onTouchMoveCapture: qc
  }), o = r[0], i = r[1], a = e.forwardProps, s = e.children, l = e.className, c = e.removeScrollBar, f = e.enabled, u = e.shards, h = e.sideCar, m = e.noIsolation, g = e.inert, p = e.allowPinchZoom, v = e.as, y = v === void 0 ? "div" : v, C = e.gapMode, w = Qg(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), _ = h, x = WL([n, t]), k = Hn(Hn({}, w), o);
  return d.createElement(
    d.Fragment,
    null,
    f && d.createElement(_, { sideCar: ev, removeScrollBar: c, shards: u, noIsolation: m, inert: g, setCallbacks: i, allowPinchZoom: !!p, lockRef: n, gapMode: C }),
    a ? d.cloneElement(d.Children.only(s), Hn(Hn({}, k), { ref: x })) : d.createElement(y, Hn({}, k, { className: l, ref: x }), s)
  );
});
W0.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
W0.classNames = {
  fullWidth: Vs,
  zeroRight: Hs
};
var UL = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function zL() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = UL();
  return t && e.setAttribute("nonce", t), e;
}
function YL(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function GL(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var KL = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = zL()) && (YL(t, n), GL(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, ZL = function() {
  var e = KL();
  return function(t, n) {
    d.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, tv = function() {
  var e = ZL(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, XL = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, jc = function(e) {
  return parseInt(e || "", 10) || 0;
}, QL = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [jc(n), jc(r), jc(o)];
}, JL = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return XL;
  var t = QL(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, eT = tv(), Jo = "data-scroll-locked", tT = function(e, t, n, r) {
  var o = e.left, i = e.top, a = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(IL, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(Jo, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Hs, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Vs, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Hs, " .").concat(Hs, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(Vs, " .").concat(Vs, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(Jo, `] {
    `).concat(BL, ": ").concat(s, `px;
  }
`);
}, _8 = function() {
  var e = parseInt(document.body.getAttribute(Jo) || "0", 10);
  return isFinite(e) ? e : 0;
}, nT = function() {
  d.useEffect(function() {
    return document.body.setAttribute(Jo, (_8() + 1).toString()), function() {
      var e = _8() - 1;
      e <= 0 ? document.body.removeAttribute(Jo) : document.body.setAttribute(Jo, e.toString());
    };
  }, []);
}, rT = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  nT();
  var i = d.useMemo(function() {
    return JL(o);
  }, [o]);
  return d.createElement(eT, { styles: tT(i, !t, o, n ? "" : "!important") });
}, E2 = !1;
if (typeof window < "u")
  try {
    var Ss = Object.defineProperty({}, "passive", {
      get: function() {
        return E2 = !0, !0;
      }
    });
    window.addEventListener("test", Ss, Ss), window.removeEventListener("test", Ss, Ss);
  } catch {
    E2 = !1;
  }
var Bo = E2 ? { passive: !1 } : !1, oT = function(e) {
  return e.tagName === "TEXTAREA";
}, nv = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !oT(e) && n[t] === "visible")
  );
}, iT = function(e) {
  return nv(e, "overflowY");
}, aT = function(e) {
  return nv(e, "overflowX");
}, k8 = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = rv(e, r);
    if (o) {
      var i = ov(e, r), a = i[1], s = i[2];
      if (a > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, sT = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, lT = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, rv = function(e, t) {
  return e === "v" ? iT(t) : aT(t);
}, ov = function(e, t) {
  return e === "v" ? sT(t) : lT(t);
}, cT = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, uT = function(e, t, n, r, o) {
  var i = cT(e, window.getComputedStyle(t).direction), a = i * r, s = n.target, l = t.contains(s), c = !1, f = a > 0, u = 0, h = 0;
  do {
    var m = ov(e, s), g = m[0], p = m[1], v = m[2], y = p - v - i * g;
    (g || y) && rv(e, s) && (u += y, h += g), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (f && Math.abs(u) < 1 || !f && Math.abs(h) < 1) && (c = !0), c;
}, Ms = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, S8 = function(e) {
  return [e.deltaX, e.deltaY];
}, M8 = function(e) {
  return e && "current" in e ? e.current : e;
}, dT = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, fT = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, hT = 0, $o = [];
function mT(e) {
  var t = d.useRef([]), n = d.useRef([0, 0]), r = d.useRef(), o = d.useState(hT++)[0], i = d.useState(tv)[0], a = d.useRef(e);
  d.useEffect(function() {
    a.current = e;
  }, [e]), d.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var p = DL([e.lockRef.current], (e.shards || []).map(M8), !0).filter(Boolean);
      return p.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), p.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = d.useCallback(function(p, v) {
    if ("touches" in p && p.touches.length === 2 || p.type === "wheel" && p.ctrlKey)
      return !a.current.allowPinchZoom;
    var y = Ms(p), C = n.current, w = "deltaX" in p ? p.deltaX : C[0] - y[0], _ = "deltaY" in p ? p.deltaY : C[1] - y[1], x, k = p.target, S = Math.abs(w) > Math.abs(_) ? "h" : "v";
    if ("touches" in p && S === "h" && k.type === "range")
      return !1;
    var T = k8(S, k);
    if (!T)
      return !0;
    if (T ? x = S : (x = S === "v" ? "h" : "v", T = k8(S, k)), !T)
      return !1;
    if (!r.current && "changedTouches" in p && (w || _) && (r.current = x), !x)
      return !0;
    var L = r.current || x;
    return uT(L, v, p, L === "h" ? w : _);
  }, []), l = d.useCallback(function(p) {
    var v = p;
    if (!(!$o.length || $o[$o.length - 1] !== i)) {
      var y = "deltaY" in v ? S8(v) : Ms(v), C = t.current.filter(function(x) {
        return x.name === v.type && (x.target === v.target || v.target === x.shadowParent) && dT(x.delta, y);
      })[0];
      if (C && C.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!C) {
        var w = (a.current.shards || []).map(M8).filter(Boolean).filter(function(x) {
          return x.contains(v.target);
        }), _ = w.length > 0 ? s(v, w[0]) : !a.current.noIsolation;
        _ && v.cancelable && v.preventDefault();
      }
    }
  }, []), c = d.useCallback(function(p, v, y, C) {
    var w = { name: p, delta: v, target: y, should: C, shadowParent: pT(y) };
    t.current.push(w), setTimeout(function() {
      t.current = t.current.filter(function(_) {
        return _ !== w;
      });
    }, 1);
  }, []), f = d.useCallback(function(p) {
    n.current = Ms(p), r.current = void 0;
  }, []), u = d.useCallback(function(p) {
    c(p.type, S8(p), p.target, s(p, e.lockRef.current));
  }, []), h = d.useCallback(function(p) {
    c(p.type, Ms(p), p.target, s(p, e.lockRef.current));
  }, []);
  d.useEffect(function() {
    return $o.push(i), e.setCallbacks({
      onScrollCapture: u,
      onWheelCapture: u,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", l, Bo), document.addEventListener("touchmove", l, Bo), document.addEventListener("touchstart", f, Bo), function() {
      $o = $o.filter(function(p) {
        return p !== i;
      }), document.removeEventListener("wheel", l, Bo), document.removeEventListener("touchmove", l, Bo), document.removeEventListener("touchstart", f, Bo);
    };
  }, []);
  var m = e.removeScrollBar, g = e.inert;
  return d.createElement(
    d.Fragment,
    null,
    g ? d.createElement(i, { styles: fT(o) }) : null,
    m ? d.createElement(rT, { gapMode: e.gapMode }) : null
  );
}
function pT(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const gT = VL(ev, mT);
var Xa = d.forwardRef(function(e, t) {
  return d.createElement(W0, Hn({}, e, { ref: t, sideCar: gT }));
});
Xa.classNames = W0.classNames;
var L2 = ["Enter", " "], vT = ["ArrowDown", "PageUp", "Home"], iv = ["ArrowUp", "PageDown", "End"], bT = [...vT, ...iv], yT = {
  ltr: [...L2, "ArrowRight"],
  rtl: [...L2, "ArrowLeft"]
}, CT = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, Qa = "Menu", [Ca, wT, xT] = A0(Qa), [Mo, av] = Ot(Qa, [
  xT,
  er,
  bi
]), Ja = er(), sv = bi(), [lv, zr] = Mo(Qa), [_T, es] = Mo(Qa), cv = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: o, onOpenChange: i, modal: a = !0 } = e, s = Ja(t), [l, c] = d.useState(null), f = d.useRef(!1), u = qt(i), h = ko(o);
  return d.useEffect(() => {
    const m = () => {
      f.current = !0, document.addEventListener("pointerdown", g, { capture: !0, once: !0 }), document.addEventListener("pointermove", g, { capture: !0, once: !0 });
    }, g = () => f.current = !1;
    return document.addEventListener("keydown", m, { capture: !0 }), () => {
      document.removeEventListener("keydown", m, { capture: !0 }), document.removeEventListener("pointerdown", g, { capture: !0 }), document.removeEventListener("pointermove", g, { capture: !0 });
    };
  }, []), /* @__PURE__ */ b(wi, { ...s, children: /* @__PURE__ */ b(
    lv,
    {
      scope: t,
      open: n,
      onOpenChange: u,
      content: l,
      onContentChange: c,
      children: /* @__PURE__ */ b(
        _T,
        {
          scope: t,
          onClose: d.useCallback(() => u(!1), [u]),
          isUsingKeyboardRef: f,
          dir: h,
          modal: a,
          children: r
        }
      )
    }
  ) });
};
cv.displayName = Qa;
var kT = "MenuAnchor", F9 = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = Ja(n);
    return /* @__PURE__ */ b(xi, { ...o, ...r, ref: t });
  }
);
F9.displayName = kT;
var W9 = "MenuPortal", [ST, uv] = Mo(W9, {
  forceMount: void 0
}), dv = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: o } = e, i = zr(W9, t);
  return /* @__PURE__ */ b(ST, { scope: t, forceMount: n, children: /* @__PURE__ */ b(Nt, { present: n || i.open, children: /* @__PURE__ */ b(_i, { asChild: !0, container: o, children: r }) }) });
};
dv.displayName = W9;
var Cn = "MenuContent", [MT, q9] = Mo(Cn), fv = d.forwardRef(
  (e, t) => {
    const n = uv(Cn, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, i = zr(Cn, e.__scopeMenu), a = es(Cn, e.__scopeMenu);
    return /* @__PURE__ */ b(Ca.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ b(Nt, { present: r || i.open, children: /* @__PURE__ */ b(Ca.Slot, { scope: e.__scopeMenu, children: a.modal ? /* @__PURE__ */ b(ET, { ...o, ref: t }) : /* @__PURE__ */ b(LT, { ...o, ref: t }) }) }) });
  }
), ET = d.forwardRef(
  (e, t) => {
    const n = zr(Cn, e.__scopeMenu), r = d.useRef(null), o = ke(t, r);
    return d.useEffect(() => {
      const i = r.current;
      if (i) return F0(i);
    }, []), /* @__PURE__ */ b(
      j9,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: ne(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), LT = d.forwardRef((e, t) => {
  const n = zr(Cn, e.__scopeMenu);
  return /* @__PURE__ */ b(
    j9,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), TT = /* @__PURE__ */ $r("MenuContent.ScrollLock"), j9 = d.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: o,
      onOpenAutoFocus: i,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: s,
      onEntryFocus: l,
      onEscapeKeyDown: c,
      onPointerDownOutside: f,
      onFocusOutside: u,
      onInteractOutside: h,
      onDismiss: m,
      disableOutsideScroll: g,
      ...p
    } = e, v = zr(Cn, n), y = es(Cn, n), C = Ja(n), w = sv(n), _ = wT(n), [x, k] = d.useState(null), S = d.useRef(null), T = ke(t, S, v.onContentChange), L = d.useRef(0), R = d.useRef(""), M = d.useRef(0), A = d.useRef(null), O = d.useRef("right"), I = d.useRef(0), W = g ? Xa : d.Fragment, N = g ? { as: TT, allowPinchZoom: !0 } : void 0, H = (D) => {
      var V, Y;
      const $ = R.current + D, U = _().filter((P) => !P.disabled), B = document.activeElement, K = (V = U.find((P) => P.ref.current === B)) == null ? void 0 : V.textValue, X = U.map((P) => P.textValue), Z = qT(X, $, K), G = (Y = U.find((P) => P.textValue === Z)) == null ? void 0 : Y.ref.current;
      (function P(F) {
        R.current = F, window.clearTimeout(L.current), F !== "" && (L.current = window.setTimeout(() => P(""), 1e3));
      })($), G && setTimeout(() => G.focus());
    };
    d.useEffect(() => () => window.clearTimeout(L.current), []), N0();
    const q = d.useCallback((D) => {
      var U, B;
      return O.current === ((U = A.current) == null ? void 0 : U.side) && HT(D, (B = A.current) == null ? void 0 : B.area);
    }, []);
    return /* @__PURE__ */ b(
      MT,
      {
        scope: n,
        searchRef: R,
        onItemEnter: d.useCallback(
          (D) => {
            q(D) && D.preventDefault();
          },
          [q]
        ),
        onItemLeave: d.useCallback(
          (D) => {
            var $;
            q(D) || (($ = S.current) == null || $.focus(), k(null));
          },
          [q]
        ),
        onTriggerLeave: d.useCallback(
          (D) => {
            q(D) && D.preventDefault();
          },
          [q]
        ),
        pointerGraceTimerRef: M,
        onPointerGraceIntentChange: d.useCallback((D) => {
          A.current = D;
        }, []),
        children: /* @__PURE__ */ b(W, { ...N, children: /* @__PURE__ */ b(
          Ya,
          {
            asChild: !0,
            trapped: o,
            onMountAutoFocus: ne(i, (D) => {
              var $;
              D.preventDefault(), ($ = S.current) == null || $.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: a,
            children: /* @__PURE__ */ b(
              So,
              {
                asChild: !0,
                disableOutsidePointerEvents: s,
                onEscapeKeyDown: c,
                onPointerDownOutside: f,
                onFocusOutside: u,
                onInteractOutside: h,
                onDismiss: m,
                children: /* @__PURE__ */ b(
                  E9,
                  {
                    asChild: !0,
                    ...w,
                    dir: y.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: x,
                    onCurrentTabStopIdChange: k,
                    onEntryFocus: ne(l, (D) => {
                      y.isUsingKeyboardRef.current || D.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ b(
                      Ka,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": Tv(v.open),
                        "data-radix-menu-content": "",
                        dir: y.dir,
                        ...C,
                        ...p,
                        ref: T,
                        style: { outline: "none", ...p.style },
                        onKeyDown: ne(p.onKeyDown, (D) => {
                          const U = D.target.closest("[data-radix-menu-content]") === D.currentTarget, B = D.ctrlKey || D.altKey || D.metaKey, K = D.key.length === 1;
                          U && (D.key === "Tab" && D.preventDefault(), !B && K && H(D.key));
                          const X = S.current;
                          if (D.target !== X || !bT.includes(D.key)) return;
                          D.preventDefault();
                          const G = _().filter((V) => !V.disabled).map((V) => V.ref.current);
                          iv.includes(D.key) && G.reverse(), FT(G);
                        }),
                        onBlur: ne(e.onBlur, (D) => {
                          D.currentTarget.contains(D.target) || (window.clearTimeout(L.current), R.current = "");
                        }),
                        onPointerMove: ne(
                          e.onPointerMove,
                          wa((D) => {
                            const $ = D.target, U = I.current !== D.clientX;
                            if (D.currentTarget.contains($) && U) {
                              const B = D.clientX > I.current ? "right" : "left";
                              O.current = B, I.current = D.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
fv.displayName = Cn;
var PT = "MenuGroup", H9 = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ b(ce.div, { role: "group", ...r, ref: t });
  }
);
H9.displayName = PT;
var RT = "MenuLabel", hv = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ b(ce.div, { ...r, ref: t });
  }
);
hv.displayName = RT;
var Qs = "MenuItem", E8 = "menu.itemSelect", q0 = d.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...o } = e, i = d.useRef(null), a = es(Qs, e.__scopeMenu), s = q9(Qs, e.__scopeMenu), l = ke(t, i), c = d.useRef(!1), f = () => {
      const u = i.current;
      if (!n && u) {
        const h = new CustomEvent(E8, { bubbles: !0, cancelable: !0 });
        u.addEventListener(E8, (m) => r == null ? void 0 : r(m), { once: !0 }), fg(u, h), h.defaultPrevented ? c.current = !1 : a.onClose();
      }
    };
    return /* @__PURE__ */ b(
      mv,
      {
        ...o,
        ref: l,
        disabled: n,
        onClick: ne(e.onClick, f),
        onPointerDown: (u) => {
          var h;
          (h = e.onPointerDown) == null || h.call(e, u), c.current = !0;
        },
        onPointerUp: ne(e.onPointerUp, (u) => {
          var h;
          c.current || (h = u.currentTarget) == null || h.click();
        }),
        onKeyDown: ne(e.onKeyDown, (u) => {
          const h = s.searchRef.current !== "";
          n || h && u.key === " " || L2.includes(u.key) && (u.currentTarget.click(), u.preventDefault());
        })
      }
    );
  }
);
q0.displayName = Qs;
var mv = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: o, ...i } = e, a = q9(Qs, n), s = sv(n), l = d.useRef(null), c = ke(t, l), [f, u] = d.useState(!1), [h, m] = d.useState("");
    return d.useEffect(() => {
      const g = l.current;
      g && m((g.textContent ?? "").trim());
    }, [i.children]), /* @__PURE__ */ b(
      Ca.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: o ?? h,
        children: /* @__PURE__ */ b(L9, { asChild: !0, ...s, focusable: !r, children: /* @__PURE__ */ b(
          ce.div,
          {
            role: "menuitem",
            "data-highlighted": f ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...i,
            ref: c,
            onPointerMove: ne(
              e.onPointerMove,
              wa((g) => {
                r ? a.onItemLeave(g) : (a.onItemEnter(g), g.defaultPrevented || g.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: ne(
              e.onPointerLeave,
              wa((g) => a.onItemLeave(g))
            ),
            onFocus: ne(e.onFocus, () => u(!0)),
            onBlur: ne(e.onBlur, () => u(!1))
          }
        ) })
      }
    );
  }
), AT = "MenuCheckboxItem", pv = d.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...o } = e;
    return /* @__PURE__ */ b(Cv, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ b(
      q0,
      {
        role: "menuitemcheckbox",
        "aria-checked": Js(n) ? "mixed" : n,
        ...o,
        ref: t,
        "data-state": z9(n),
        onSelect: ne(
          o.onSelect,
          () => r == null ? void 0 : r(Js(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
pv.displayName = AT;
var gv = "MenuRadioGroup", [OT, NT] = Mo(
  gv,
  { value: void 0, onValueChange: () => {
  } }
), vv = d.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...o } = e, i = qt(r);
    return /* @__PURE__ */ b(OT, { scope: e.__scopeMenu, value: n, onValueChange: i, children: /* @__PURE__ */ b(H9, { ...o, ref: t }) });
  }
);
vv.displayName = gv;
var bv = "MenuRadioItem", yv = d.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, o = NT(bv, e.__scopeMenu), i = n === o.value;
    return /* @__PURE__ */ b(Cv, { scope: e.__scopeMenu, checked: i, children: /* @__PURE__ */ b(
      q0,
      {
        role: "menuitemradio",
        "aria-checked": i,
        ...r,
        ref: t,
        "data-state": z9(i),
        onSelect: ne(
          r.onSelect,
          () => {
            var a;
            return (a = o.onValueChange) == null ? void 0 : a.call(o, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
yv.displayName = bv;
var V9 = "MenuItemIndicator", [Cv, DT] = Mo(
  V9,
  { checked: !1 }
), wv = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...o } = e, i = DT(V9, n);
    return /* @__PURE__ */ b(
      Nt,
      {
        present: r || Js(i.checked) || i.checked === !0,
        children: /* @__PURE__ */ b(
          ce.span,
          {
            ...o,
            ref: t,
            "data-state": z9(i.checked)
          }
        )
      }
    );
  }
);
wv.displayName = V9;
var IT = "MenuSeparator", xv = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ b(
      ce.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
xv.displayName = IT;
var BT = "MenuArrow", _v = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = Ja(n);
    return /* @__PURE__ */ b(Za, { ...o, ...r, ref: t });
  }
);
_v.displayName = BT;
var U9 = "MenuSub", [$T, kv] = Mo(U9), Sv = (e) => {
  const { __scopeMenu: t, children: n, open: r = !1, onOpenChange: o } = e, i = zr(U9, t), a = Ja(t), [s, l] = d.useState(null), [c, f] = d.useState(null), u = qt(o);
  return d.useEffect(() => (i.open === !1 && u(!1), () => u(!1)), [i.open, u]), /* @__PURE__ */ b(wi, { ...a, children: /* @__PURE__ */ b(
    lv,
    {
      scope: t,
      open: r,
      onOpenChange: u,
      content: c,
      onContentChange: f,
      children: /* @__PURE__ */ b(
        $T,
        {
          scope: t,
          contentId: Tt(),
          triggerId: Tt(),
          trigger: s,
          onTriggerChange: l,
          children: n
        }
      )
    }
  ) });
};
Sv.displayName = U9;
var ra = "MenuSubTrigger", Mv = d.forwardRef(
  (e, t) => {
    const n = zr(ra, e.__scopeMenu), r = es(ra, e.__scopeMenu), o = kv(ra, e.__scopeMenu), i = q9(ra, e.__scopeMenu), a = d.useRef(null), { pointerGraceTimerRef: s, onPointerGraceIntentChange: l } = i, c = { __scopeMenu: e.__scopeMenu }, f = d.useCallback(() => {
      a.current && window.clearTimeout(a.current), a.current = null;
    }, []);
    return d.useEffect(() => f, [f]), d.useEffect(() => {
      const u = s.current;
      return () => {
        window.clearTimeout(u), l(null);
      };
    }, [s, l]), /* @__PURE__ */ b(F9, { asChild: !0, ...c, children: /* @__PURE__ */ b(
      mv,
      {
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": o.contentId,
        "data-state": Tv(n.open),
        ...e,
        ref: vr(t, o.onTriggerChange),
        onClick: (u) => {
          var h;
          (h = e.onClick) == null || h.call(e, u), !(e.disabled || u.defaultPrevented) && (u.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: ne(
          e.onPointerMove,
          wa((u) => {
            i.onItemEnter(u), !u.defaultPrevented && !e.disabled && !n.open && !a.current && (i.onPointerGraceIntentChange(null), a.current = window.setTimeout(() => {
              n.onOpenChange(!0), f();
            }, 100));
          })
        ),
        onPointerLeave: ne(
          e.onPointerLeave,
          wa((u) => {
            var m, g;
            f();
            const h = (m = n.content) == null ? void 0 : m.getBoundingClientRect();
            if (h) {
              const p = (g = n.content) == null ? void 0 : g.dataset.side, v = p === "right", y = v ? -5 : 5, C = h[v ? "left" : "right"], w = h[v ? "right" : "left"];
              i.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: u.clientX + y, y: u.clientY },
                  { x: C, y: h.top },
                  { x: w, y: h.top },
                  { x: w, y: h.bottom },
                  { x: C, y: h.bottom }
                ],
                side: p
              }), window.clearTimeout(s.current), s.current = window.setTimeout(
                () => i.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (i.onTriggerLeave(u), u.defaultPrevented) return;
              i.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: ne(e.onKeyDown, (u) => {
          var m;
          const h = i.searchRef.current !== "";
          e.disabled || h && u.key === " " || yT[r.dir].includes(u.key) && (n.onOpenChange(!0), (m = n.content) == null || m.focus(), u.preventDefault());
        })
      }
    ) });
  }
);
Mv.displayName = ra;
var Ev = "MenuSubContent", Lv = d.forwardRef(
  (e, t) => {
    const n = uv(Cn, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, i = zr(Cn, e.__scopeMenu), a = es(Cn, e.__scopeMenu), s = kv(Ev, e.__scopeMenu), l = d.useRef(null), c = ke(t, l);
    return /* @__PURE__ */ b(Ca.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ b(Nt, { present: r || i.open, children: /* @__PURE__ */ b(Ca.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ b(
      j9,
      {
        id: s.contentId,
        "aria-labelledby": s.triggerId,
        ...o,
        ref: c,
        align: "start",
        side: a.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (f) => {
          var u;
          a.isUsingKeyboardRef.current && ((u = l.current) == null || u.focus()), f.preventDefault();
        },
        onCloseAutoFocus: (f) => f.preventDefault(),
        onFocusOutside: ne(e.onFocusOutside, (f) => {
          f.target !== s.trigger && i.onOpenChange(!1);
        }),
        onEscapeKeyDown: ne(e.onEscapeKeyDown, (f) => {
          a.onClose(), f.preventDefault();
        }),
        onKeyDown: ne(e.onKeyDown, (f) => {
          var m;
          const u = f.currentTarget.contains(f.target), h = CT[a.dir].includes(f.key);
          u && h && (i.onOpenChange(!1), (m = s.trigger) == null || m.focus(), f.preventDefault());
        })
      }
    ) }) }) });
  }
);
Lv.displayName = Ev;
function Tv(e) {
  return e ? "open" : "closed";
}
function Js(e) {
  return e === "indeterminate";
}
function z9(e) {
  return Js(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function FT(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function WT(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function qT(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((c) => c === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let a = WT(e, Math.max(i, 0));
  o.length === 1 && (a = a.filter((c) => c !== n));
  const l = a.find(
    (c) => c.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function jT(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, a = t.length - 1; i < t.length; a = i++) {
    const s = t[i], l = t[a], c = s.x, f = s.y, u = l.x, h = l.y;
    f > r != h > r && n < (u - c) * (r - f) / (h - f) + c && (o = !o);
  }
  return o;
}
function HT(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return jT(n, t);
}
function wa(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var VT = cv, UT = F9, zT = dv, YT = fv, GT = H9, KT = hv, ZT = q0, XT = pv, QT = vv, JT = yv, eP = wv, tP = xv, nP = _v, rP = Sv, oP = Mv, iP = Lv, j0 = "DropdownMenu", [aP, vJ] = Ot(
  j0,
  [av]
), en = av(), [sP, Pv] = aP(j0), Rv = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: r,
    open: o,
    defaultOpen: i,
    onOpenChange: a,
    modal: s = !0
  } = e, l = en(t), c = d.useRef(null), [f, u] = Jt({
    prop: o,
    defaultProp: i ?? !1,
    onChange: a,
    caller: j0
  });
  return /* @__PURE__ */ b(
    sP,
    {
      scope: t,
      triggerId: Tt(),
      triggerRef: c,
      contentId: Tt(),
      open: f,
      onOpenChange: u,
      onOpenToggle: d.useCallback(() => u((h) => !h), [u]),
      modal: s,
      children: /* @__PURE__ */ b(VT, { ...l, open: f, onOpenChange: u, dir: r, modal: s, children: n })
    }
  );
};
Rv.displayName = j0;
var Av = "DropdownMenuTrigger", Ov = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...o } = e, i = Pv(Av, n), a = en(n);
    return /* @__PURE__ */ b(UT, { asChild: !0, ...a, children: /* @__PURE__ */ b(
      ce.button,
      {
        type: "button",
        id: i.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": i.open,
        "aria-controls": i.open ? i.contentId : void 0,
        "data-state": i.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...o,
        ref: vr(t, i.triggerRef),
        onPointerDown: ne(e.onPointerDown, (s) => {
          !r && s.button === 0 && s.ctrlKey === !1 && (i.onOpenToggle(), i.open || s.preventDefault());
        }),
        onKeyDown: ne(e.onKeyDown, (s) => {
          r || (["Enter", " "].includes(s.key) && i.onOpenToggle(), s.key === "ArrowDown" && i.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(s.key) && s.preventDefault());
        })
      }
    ) });
  }
);
Ov.displayName = Av;
var lP = "DropdownMenuPortal", Nv = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = en(t);
  return /* @__PURE__ */ b(zT, { ...r, ...n });
};
Nv.displayName = lP;
var Dv = "DropdownMenuContent", Iv = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Pv(Dv, n), i = en(n), a = d.useRef(!1);
    return /* @__PURE__ */ b(
      YT,
      {
        id: o.contentId,
        "aria-labelledby": o.triggerId,
        ...i,
        ...r,
        ref: t,
        onCloseAutoFocus: ne(e.onCloseAutoFocus, (s) => {
          var l;
          a.current || (l = o.triggerRef.current) == null || l.focus(), a.current = !1, s.preventDefault();
        }),
        onInteractOutside: ne(e.onInteractOutside, (s) => {
          const l = s.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0, f = l.button === 2 || c;
          (!o.modal || f) && (a.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
Iv.displayName = Dv;
var cP = "DropdownMenuGroup", Bv = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = en(n);
    return /* @__PURE__ */ b(GT, { ...o, ...r, ref: t });
  }
);
Bv.displayName = cP;
var uP = "DropdownMenuLabel", $v = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = en(n);
    return /* @__PURE__ */ b(KT, { ...o, ...r, ref: t });
  }
);
$v.displayName = uP;
var dP = "DropdownMenuItem", Fv = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = en(n);
    return /* @__PURE__ */ b(ZT, { ...o, ...r, ref: t });
  }
);
Fv.displayName = dP;
var fP = "DropdownMenuCheckboxItem", Wv = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = en(n);
  return /* @__PURE__ */ b(XT, { ...o, ...r, ref: t });
});
Wv.displayName = fP;
var hP = "DropdownMenuRadioGroup", qv = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = en(n);
  return /* @__PURE__ */ b(QT, { ...o, ...r, ref: t });
});
qv.displayName = hP;
var mP = "DropdownMenuRadioItem", jv = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = en(n);
  return /* @__PURE__ */ b(JT, { ...o, ...r, ref: t });
});
jv.displayName = mP;
var pP = "DropdownMenuItemIndicator", Hv = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = en(n);
  return /* @__PURE__ */ b(eP, { ...o, ...r, ref: t });
});
Hv.displayName = pP;
var gP = "DropdownMenuSeparator", Vv = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = en(n);
  return /* @__PURE__ */ b(tP, { ...o, ...r, ref: t });
});
Vv.displayName = gP;
var vP = "DropdownMenuArrow", bP = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = en(n);
    return /* @__PURE__ */ b(nP, { ...o, ...r, ref: t });
  }
);
bP.displayName = vP;
var yP = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: r, onOpenChange: o, defaultOpen: i } = e, a = en(t), [s, l] = Jt({
    prop: r,
    defaultProp: i ?? !1,
    onChange: o,
    caller: "DropdownMenuSub"
  });
  return /* @__PURE__ */ b(rP, { ...a, open: s, onOpenChange: l, children: n });
}, CP = "DropdownMenuSubTrigger", Uv = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = en(n);
  return /* @__PURE__ */ b(oP, { ...o, ...r, ref: t });
});
Uv.displayName = CP;
var wP = "DropdownMenuSubContent", zv = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = en(n);
  return /* @__PURE__ */ b(
    iP,
    {
      ...o,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
zv.displayName = wP;
var xP = Rv, _P = Ov, Yv = Nv, kP = Iv, SP = Bv, MP = $v, EP = Fv, LP = Wv, TP = qv, Gv = jv, Y9 = Hv, PP = Vv, RP = yP, AP = Uv, OP = zv;
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NP = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), DP = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (t, n, r) => r ? r.toUpperCase() : n.toLowerCase()
), L8 = (e) => {
  const t = DP(e);
  return t.charAt(0).toUpperCase() + t.slice(1);
}, Kv = (...e) => e.filter((t, n, r) => !!t && t.trim() !== "" && r.indexOf(t) === n).join(" ").trim(), IP = (e) => {
  for (const t in e)
    if (t.startsWith("aria-") || t === "role" || t === "title")
      return !0;
};
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var BP = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $P = fe(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: r,
    className: o = "",
    children: i,
    iconNode: a,
    ...s
  }, l) => $t(
    "svg",
    {
      ref: l,
      ...BP,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: r ? Number(n) * 24 / Number(t) : n,
      className: Kv("lucide", o),
      ...!i && !IP(s) && { "aria-hidden": "true" },
      ...s
    },
    [
      ...a.map(([c, f]) => $t(c, f)),
      ...Array.isArray(i) ? i : [i]
    ]
  )
);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H0 = (e, t) => {
  const n = fe(
    ({ className: r, ...o }, i) => $t($P, {
      ref: i,
      iconNode: t,
      className: Kv(
        `lucide-${NP(L8(e))}`,
        `lucide-${e}`,
        r
      ),
      ...o
    })
  );
  return n.displayName = L8(e), n;
};
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FP = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
], Zv = H0("calendar", FP);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WP = [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]], T8 = H0("chevron-left", WP);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qP = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], P8 = H0("chevron-right", qP);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jP = [["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]], G9 = H0("circle", jP), bJ = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M10.296 1.510848C9.8016 1.577856 9.387096000000001 1.8774 9.152448 2.33724C8.988840000000001 2.657856 9.000864 1.90068 9.000408 11.91L9 21 8.256576 21L7.513176 21 7.506456 16.362000000000002C7.500024 11.931672 7.497744 11.718096000000001 7.455552000000001 11.592C7.284576 11.081136 6.896903999999999 10.697735999999999 6.396 10.54416C6.261792000000001 10.503 6.132936 10.5 4.5 10.5C2.867064 10.5 2.738208 10.503 2.604 10.54416C2.1030960000000003 10.697735999999999 1.715424 11.081136 1.544448 11.592C1.502256 11.718096000000001 1.4999760000000002 11.931624000000001 1.493544 16.360608L1.4868240000000001 20.997216 1.013424 21.004608C0.5691120000000001 21.011544 0.533088 21.015528000000003 0.427608 21.069456C-0.004416 21.290304 -0.13272 21.828984000000002 0.156504 22.207752C0.26748 22.35312 0.44325600000000004 22.456992 0.629328 22.487184C0.8386560000000001 22.521144 23.161344 22.521144 23.370672000000003 22.487184C23.632248 22.444728 23.879952000000003 22.242936 23.953632 22.012224C23.969112 21.963696 23.991288 21.913752 24.002904 21.9012C24.026664 21.87552 24.032496000000002 21.535512 24.008760000000002 21.559248C24.000384 21.567624 23.963856 21.512712 23.927616 21.437231999999998C23.846496000000002 21.268344000000003 23.71752 21.142056 23.544 21.061656C23.417424 21.002976 23.393520000000002 21.000456 22.96236 21.00024L22.512719999999998 21 22.505832 14.118C22.499256000000003 7.5504240000000005 22.496952 7.229424 22.455408000000002 7.0920000000000005C22.298976 6.5748240000000004 21.840792 6.140904 21.33876 6.0344880000000005C21.10596 5.985144 17.89404 5.985144 17.66124 6.0344880000000005C17.159232 6.140904 16.701 6.574871999999999 16.544591999999998 7.0920000000000005C16.503048 7.229424 16.500743999999997 7.5504240000000005 16.494168 14.118L16.487280000000002 21 15.743640000000001 21L15 21 14.999592 11.91C14.999136000000002 1.9012559999999998 15.011136000000002 2.658 14.847648000000001 2.33724C14.653056 1.955448 14.305968 1.6630559999999999 13.908 1.5456720000000002C13.777104000000001 1.50708 13.612128 1.502736 12.096 1.49808C11.1786 1.495272 10.368599999999999 1.5010080000000001 10.296 1.510848M10.512 12L10.512 21 12 21L13.488 21 13.488 12L13.488 3 12 3L10.512 3 10.512 12M18 14.256L18 21 19.5 21L21 21 21 14.256L21 7.5120000000000005 19.5 7.5120000000000005L18 7.5120000000000005 18 14.256M3 16.5L3 21 4.5 21L6 21 6 16.5L6 12 4.5 12L3 12 3 16.5M0.008064 21.744C0.008064 21.843 0.012312 21.883512 0.017472 21.834C0.022656 21.784512 0.022656 21.703512 0.017472 21.654C0.012312 21.604512 0.008064 21.645 0.008064 21.744", stroke: "none", fill: "currentColor", fillRule: "evenodd", strokeWidth: 0.024 })), yJ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M13.1 3.37567L3.15625 13.3194", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M3.15625 3.94442V13.3194H12.5312", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" })), CJ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M13.1562 13.6319L3.2125 3.68817", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M12.5874 3.68817L3.2124 3.68817L3.2124 13.0632", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" })), wJ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M3 3.37567L12.9438 13.3194", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M3.56885 13.3194H12.9438V3.94442", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" })), xJ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M2.84375 13.5319L12.7875 3.58817", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M12.7876 12.9632L12.7876 3.58817L3.4126 3.58817", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" })), _J = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17404_192090)" }, /* @__PURE__ */ d.createElement("path", { d: "M8 1.50067V15.5632", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M1.4375 9.00067L8 15.5632L14.5625 9.00067", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17404_192090" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.531921)" })))), kJ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M15.0312 8.53192H0.96875", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M7.53125 1.96942L0.96875 8.53192L7.53125 15.0944", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" })), SJ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M0.96875 8.53192H15.0312", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8.46875 15.0944L15.0312 8.53192L8.46875 1.96942", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" })), MJ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17404_192084)" }, /* @__PURE__ */ d.createElement("path", { d: "M8 15.5632V1.50067", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M14.5625 8.06317L8 1.50067L1.4375 8.06317", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17404_192084" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.531921)" })))), EJ = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M11.040000000000001 0.035904C8.6556 0.237768 6.436751999999999 1.1044559999999999 4.596 2.552928C0.097776 6.092592 -1.29048 12.297192 1.276704 17.388C3.326592 21.452952000000003 7.457352 24 12 24C13.890528000000002 24 15.702048 23.570591999999998 17.388 22.722792000000002C19.507656 21.656928 21.267984000000002 19.983552 22.444584000000003 17.916C23.304456000000002 16.404984000000002 23.866968 14.548704 23.966616000000002 12.89328C23.975592 12.744384 23.992176 12.616848000000001 24.003456 12.609863999999998C24.01476 12.60288 24.023832000000002 12.314304 24.02364 11.968584C24.023424000000002 11.622864 24.014256000000003 11.354208 24.00324 11.37156C23.99148 11.390136 23.976528000000002 11.286336 23.966952000000003 11.11956C23.882568 9.650112 23.434824000000003 8.027976 22.722792000000002 6.612C20.944128000000003 3.074832 17.531015999999997 0.6356160000000001 13.620000000000001 0.106584C12.849120000000001 0.002304 11.782104 -0.026928000000000004 11.040000000000001 0.035904M11.268 1.526496C10.389864000000001 1.6122960000000002 9.461688 1.77096 9.438936 1.8391680000000001C9.431592 1.8612 11.002080000000001 7.578072 11.02056 7.596576C11.024952 7.600944 11.102496 7.58904 11.192904 7.570080000000001C11.465496 7.5129600000000005 11.967096000000002 7.4873520000000005 12.319992 7.512576C12.802248 7.54704 13.219728 7.641552000000001 13.664952000000001 7.817088L13.877880000000001 7.90104 13.93164 7.84452C13.98636 7.786968 17.617056 3.2256 17.646144 3.177864C17.667144 3.143376 17.04048 2.779008 16.573608 2.5542480000000003C15.488664 2.03196 14.432687999999999 1.723872 13.200000000000001 1.570032C12.915888 1.53456 11.509704000000001 1.50288 11.268 1.526496M7.656000000000001 2.444856C6.823224 2.830848 6.149496 3.2434800000000004 5.482896 3.7758C3.2744400000000002 5.539272 1.913664 7.988544 1.567056 10.824C1.5064080000000002 11.320152 1.5064080000000002 12.679848 1.567056 13.176C1.913784 16.012368000000002 3.2695920000000003 18.452592 5.484 20.225808C6.989808000000001 21.431592 8.810256 22.183896 10.824 22.432512C11.321159999999999 22.493904 12.67884 22.493904 13.176 22.432512C13.533432000000001 22.3884 14.067816 22.299648 14.086488000000001 22.281336C14.097144 22.270848 14.01984 21.92436 13.227696 18.432000000000002C12.778584 16.452024 12.778584 16.452 12.719280000000001 16.456104C12.686688 16.458384 12.5088 16.471464 12.324 16.485167999999998C11.492448 16.54692 10.700664 16.386264 9.96 16.005528C9.092688 15.559655999999999 8.440344 14.907312000000001 7.994472 14.040000000000001C7.33392 12.755040000000001 7.33392 11.24496 7.994472 9.96C8.33772 9.29232 8.810952 8.743584 9.393096 8.33832C9.505536000000001 8.260056 9.598080000000001 8.182392 9.598752 8.16576C9.59964 8.144064 8.104152000000001 2.696352 8.00112 2.346C7.994327999999999 2.3228880000000003 7.981392 2.304408 7.972392 2.304912C7.963368000000001 2.305416 7.821 2.368392 7.656000000000001 2.444856M17.124 6.254952C16.1736 7.449864 15.338232 8.502072 15.2676 8.593224L15.139199999999999 8.758944000000001 15.334655999999999 8.981472C15.888696 9.61224 16.260096 10.345583999999999 16.414176 11.113007999999999C16.601424 12.045552 16.46748 13.124592 16.064952 13.926048L15.955704 14.143608 18.11184 16.300704L20.268 18.457824000000002 20.335224 18.378912C20.57436 18.098184 21.089184 17.282424 21.346776 16.776C21.920592 15.647976000000002 22.270584 14.48748 22.432512 13.176C22.493904 12.67884 22.493904 11.321159999999999 22.432512 10.824C22.151616 8.548872 21.264264 6.598704000000001 19.74948 4.927272C19.469256 4.618056 18.90924 4.078776 18.870912 4.0812C18.86052 4.081848 18.0744 5.06004 17.124 6.254952M11.642376 9.025152C10.508304 9.1674 9.523992000000002 9.967104 9.169032 11.034648C9.046968 11.401752 9.016632 11.593944 9.016632 12C9.016632 12.406056 9.046968 12.598248 9.169032 12.965352C9.312576 13.39704 9.548615999999999 13.774176 9.887232000000001 14.112768C10.318272 14.543807999999999 10.80972 14.806920000000002 11.436 14.941968000000001C11.700216000000001 14.998944000000002 12.299351999999999 14.998992 12.564 14.942064C13.172256 14.81124 13.675416 14.54568 14.086872 14.138328C14.54016 13.689576 14.804015999999999 13.203768000000002 14.941968000000001 12.564C14.998992 12.299496000000001 14.998992 11.700504 14.941968000000001 11.436C14.808456 10.816752 14.545224000000001 10.32156 14.12448 9.898128000000002C13.695528000000001 9.466416 13.170792 9.184008 12.570048 9.061512C12.336792 9.013944 11.875680000000001 8.995872 11.642376 9.025152M0.010488 12C0.010488 12.349800000000002 0.013848 12.492912 0.017928 12.318C0.022032000000000003 12.143088 0.022032000000000003 11.856912000000001 0.017928 11.682C0.013848 11.507088 0.010488 11.6502 0.010488 12M14.974295999999999 15.374592C14.926848 15.432528000000001 14.513256000000002 15.73812 14.345088 15.839496C14.214839999999999 15.918023999999999 14.207544 15.927287999999999 14.222351999999999 15.995496000000001C14.38884 16.762415999999998 15.550199999999998 21.846192000000002 15.56148 21.857471999999998C15.603216000000002 21.899208 16.704528 21.403272 17.196 21.121416C17.601696 20.888736 18.170832 20.502264 18.516000000000002 20.225088C18.811848 19.987488 19.229015999999998 19.621128000000002 19.242024 19.58748C19.245312000000002 19.578936 18.294168 18.618096 17.12832 17.45232C15.190824000000001 15.514920000000002 15.005664 15.336312000000001 14.974295999999999 15.374592", stroke: "none", fill: "currentColor", fillRule: "evenodd", strokeWidth: 0.024 })), V0 = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M14.1169 6.63109L8.8311 11.9163C8.7876 11.9598 8.73597 11.9943 8.67916 12.0179C8.62229 12.0415 8.56135 12.0536 8.49985 12.0536C8.43835 12.0536 8.37741 12.0415 8.32054 12.0179C8.26372 11.9943 8.2121 11.9598 8.1686 11.9163L2.88281 6.63109", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), HP = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M9.44901 14.4717L4.16323 9.18587C4.11969 9.14239 4.08514 9.09075 4.06158 9.03391C4.03801 8.97707 4.02588 8.91615 4.02588 8.85462C4.02588 8.79309 4.03801 8.73216 4.06158 8.67532C4.08514 8.61848 4.11969 8.56684 4.16323 8.52337L9.44901 3.23758", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), Xv = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M5.14453 2.23758L10.4303 7.52337C10.4739 7.56684 10.5084 7.61848 10.532 7.67532C10.5555 7.73216 10.5677 7.79309 10.5677 7.85462C10.5677 7.91615 10.5555 7.97707 10.532 8.03391C10.5084 8.09075 10.4739 8.14239 10.4303 8.18587L5.14453 13.4717", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), LJ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M7.61687 13.8942L2.33171 8.60841C2.28815 8.56491 2.25365 8.51329 2.23009 8.45648C2.20646 8.3996 2.19434 8.33866 2.19434 8.27716C2.19434 8.21566 2.20646 8.15472 2.23009 8.09785C2.25365 8.04104 2.28815 7.98941 2.33171 7.94591L7.61687 2.66013M14.0394 13.8942L8.75426 8.60841C8.71069 8.56491 8.6762 8.51329 8.65263 8.45648C8.62901 8.3996 8.61688 8.33866 8.61688 8.27716C8.61688 8.21566 8.62901 8.15472 8.65263 8.09785C8.6762 8.04104 8.71069 7.98941 8.75426 7.94591L14.0394 2.66013", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), TJ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M8.61688 2.66013L13.902 7.94591C13.9456 7.98941 13.9801 8.04104 14.0037 8.09785C14.0273 8.15472 14.0394 8.21566 14.0394 8.27716C14.0394 8.33866 14.0273 8.3996 14.0037 8.45648C13.9801 8.51329 13.9456 8.56491 13.902 8.60841L8.61688 13.8942M2.19434 2.66013L7.4795 7.94591C7.52306 7.98941 7.55756 8.04104 7.58112 8.09785C7.60475 8.15472 7.61687 8.21566 7.61687 8.27716C7.61687 8.33866 7.60475 8.3996 7.58112 8.45648C7.55756 8.51329 7.52306 8.56491 7.4795 8.60841L2.19434 13.8942", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), VP = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M1.88281 10.3906L7.1686 5.10547C7.21208 5.06193 7.26371 5.02739 7.32055 5.00382C7.37739 4.98025 7.43832 4.96812 7.49985 4.96812C7.56138 4.96812 7.62231 4.98025 7.67915 5.00382C7.73599 5.02739 7.78762 5.06193 7.8311 5.10547L13.1169 10.3906", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), UP = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M2.84375 10.2296L7.66875 15.0546C7.75672 15.1422 7.87583 15.1914 8 15.1914C8.12417 15.1914 8.24328 15.1422 8.33125 15.0546L13.1562 10.2296", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M2.84375 6.47961L7.66875 1.65461C7.71223 1.61107 7.76386 1.57653 7.8207 1.55296C7.87754 1.5294 7.93847 1.51727 8 1.51727C8.06153 1.51727 8.12246 1.5294 8.1793 1.55296C8.23614 1.57653 8.28777 1.61107 8.33125 1.65461L13.1562 6.47961", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), PJ = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M19.740000000000002 5.256L16.26 5.268 16.152 5.332032C15.889704000000002 5.487528 15.75912 5.708880000000001 15.757944 6C15.75696 6.237288 15.823991999999999 6.390599999999999 15.998304000000001 6.549936C16.225656 6.757728 16.02048 6.744 18.898272 6.744048L21.444 6.744096000000001 18.072 10.113744C15.725136000000001 12.458952000000002 14.668872 13.498895999999998 14.597591999999999 13.534392C14.386655999999999 13.639439999999999 14.107488 13.642992 13.908479999999999 13.543152000000001C13.868616000000001 13.52316 13.069199999999999 12.743136000000002 12.132 11.809776000000001C11.032440000000001 10.714728000000001 10.377048 10.079616 10.28436 10.019352000000001C9.829392 9.723504 9.420936 9.60852 8.905752 9.631248000000001C8.342016000000001 9.656112 7.912656 9.831384 7.481256 10.21272C7.372776000000001 10.308648 5.6736 12.00012 3.705312 13.971552C0.810024 16.871496 0.11568 17.57892 0.069312 17.676000000000002C0.0228 17.773392 0.012 17.834448 0.012 18C0.012 18.240576 0.06336 18.36972 0.222264 18.528624C0.371472 18.677832000000002 0.48427200000000004 18.726552 0.709152 18.738888000000003C1.077648 18.759144 0.702936 19.10112 4.86 14.950728C7.4448240000000006 12.37008 8.588472000000001 11.24376 8.664 11.204400000000001C8.755176 11.156903999999999 8.807544 11.148144 9 11.148144C9.192864 11.148144 9.244632 11.156832 9.336 11.204640000000001C9.409176 11.242944000000001 9.993312 11.808336 11.148 12.958464000000001C12.173232 13.979664 12.904584000000002 14.689656 12.984 14.740824000000002C13.441512 15.035616000000001 13.811304 15.135384 14.364 15.11316C14.702280000000002 15.099576 14.90772 15.053208 15.183432000000002 14.928192000000001C15.561408000000002 14.756808 15.525912 14.790408000000001 19.085256 11.235432L22.486536 7.838352 22.493256000000002 10.381176L22.5 12.924 22.555152 13.044C22.662576 13.277736 22.881312 13.44924 23.120712 13.487400000000001C23.482704000000002 13.54512 23.825064 13.347912 23.954568 13.007040000000002C23.998392 12.89172 24 12.763032 24 9.372648C24 5.881896 23.999664 5.8568880000000005 23.950536 5.725608C23.858208 5.47884 23.587944 5.273544 23.328 5.252664C23.2686 5.247912 21.654 5.2494 19.740000000000002 5.256", stroke: "none", fill: "currentColor", fillRule: "evenodd", strokeWidth: 0.024 })), RJ = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M8.589984 3.538872C8.133456 3.655416 7.790616 3.93228 7.577304 4.356648C7.531032000000001 4.448688 6.90732 5.903328 6.191280000000001 7.58916C4.758768000000001 10.961808000000001 4.84368 10.787232000000001 4.570584 10.921632L4.452 10.98 2.508 10.992C0.57168 11.003952 0.563544 11.004216000000001 0.45036000000000004 11.056488C0.38786400000000004 11.08536 0.284112 11.161584 0.219816 11.225904C-0.143568 11.589288 -0.037896 12.196416000000001 0.42859200000000003 12.42552L0.5640000000000001 12.492 2.58 12.492L4.596 12.492 4.8 12.437712000000001C5.4309840000000005 12.269832000000001 5.962079999999999 11.845368 6.248568000000001 11.28C6.305424 11.1678 6.928512 9.71808 7.6332 8.058432C8.337888 6.39876 8.921496 5.048760000000001 8.930112000000001 5.058432C8.938704000000001 5.06808 10.005528 8.3754 11.300808 12.408C12.985032 17.651496 13.683888000000001 19.796015999999998 13.754256000000002 19.936632C13.942775999999999 20.313336 14.290920000000002 20.590392 14.714808 20.701008C14.906400000000001 20.751024 15.250079999999999 20.750808 15.444 20.700576C15.87564 20.58876 16.231392 20.295552 16.422792 19.893864C16.481976 19.76964 17.106648 18.140784 17.810952 16.274184C19.036176 13.02708 19.09608 12.875304 19.197167999999998 12.762863999999999C19.255296 12.698231999999999 19.357992 12.616248 19.425408 12.580680000000001L19.548000000000002 12.516 21.492 12.504L23.436 12.492 23.573136 12.424655999999999C23.735712000000003 12.344832000000002 23.885256000000002 12.184344 23.942736 12.028008C23.965392 11.9664 23.992944 11.905728 24.00396 11.8932C24.030383999999998 11.863128000000001 24.03 11.561448 24.003552000000003 11.577792C23.99232 11.584752 23.970768000000003 11.549208 23.955672 11.498808C23.888328 11.274000000000001 23.642256000000003 11.064912 23.388 11.016432C23.284896 10.9968 22.698768 10.991496 21.324 10.997832C19.598376000000002 11.005776000000001 19.388208 11.010888 19.248 11.04816C18.805775999999998 11.165784 18.499752 11.33544 18.183312 11.638344C17.974872 11.837904 17.83188 12.037392 17.714928 12.291744C17.664288 12.40188 17.051616000000003 14.006447999999999 16.353432 15.857448C15.481008000000001 18.1704 15.078287999999999 19.209936 15.065688 19.181448C15.055632 19.158648000000003 13.989047999999999 15.846 12.695496000000002 11.82C11.29716 7.4678640000000005 10.308864 4.4290080000000005 10.257935999999999 4.324896C10.118928 4.040712 9.821808 3.7572000000000005 9.53412 3.6342239999999997C9.257760000000001 3.5160959999999997 8.843184 3.4742159999999997 8.589984 3.538872M0.007872 11.748000000000001C0.007992 11.8404 0.012312 11.875248000000001 0.01752 11.825472000000001C0.022704 11.775672 0.022632 11.700072 0.017328 11.657472C0.012024 11.614848 0.007776000000000001 11.6556 0.007872 11.748000000000001", stroke: "none", fill: "currentColor", fillRule: "evenodd", strokeWidth: 0.024 })), AJ = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M2.563824 0.79128C2.10852 0.887304 1.7771040000000002 1.060944 1.44384 1.378056C1.126584 1.679928 0.9269040000000001 2.026224 0.799272 2.496C0.7591680000000001 2.643624 0.7565040000000001 3.1470719999999996 0.749592 11.868C0.7443839999999999 18.451176 0.7498319999999999 21.141792000000002 0.7686240000000001 21.286272C0.886992 22.1964 1.535592 22.928544 2.4468 23.180592L2.676 23.244 12 23.244L21.324 23.244 21.5532 23.180592C22.449312000000003 22.93272 23.081352 22.234992 23.221344000000002 21.339024C23.25312 21.135744 23.256576 19.999512 23.250264 11.88C23.243496 3.147336 23.240832 2.643624 23.200728 2.496C22.985496 1.70388 22.460184 1.1196 21.744336 0.8761200000000001C21.3282 0.734568 22.022448 0.743856 11.97936 0.74568C3.153816 0.7473120000000001 2.76336 0.749208 2.563824 0.79128M2.751888 2.293104C2.54304 2.3698319999999997 2.351616 2.569872 2.2894560000000004 2.77644C2.2614 2.86968 2.2560000000000002 3.5627280000000003 2.2560000000000002 7.071768L2.2560000000000002 11.255904 12.000264000000001 11.255904L21.744528000000003 11.255904 21.738264 7.025952L21.732 2.7960000000000003 21.672312 2.679144C21.596256 2.5301760000000004 21.460296 2.3942400000000004 21.31668 2.323512L21.204 2.2680000000000002 12.024000000000001 2.263632C4.17744 2.259912 2.830632 2.264208 2.751888 2.293104M2.261736 16.973928L2.2680000000000002 21.204 2.331864 21.32496C2.417544 21.487296 2.578272 21.630432000000003 2.744856 21.69276L2.8818 21.744 7.068960000000001 21.744L11.25612 21.744 11.250072 17.25L11.244 12.756 6.7497359999999995 12.749927999999999L2.2554719999999997 12.74388 2.261736 16.973928M12.760008000000001 12.760008000000001C12.751199999999999 12.768792000000001 12.744 14.793792 12.744 17.260008000000003L12.744 21.744 16.931088 21.744L21.118199999999998 21.744 21.255144 21.69276C21.421728 21.630432000000003 21.582456 21.487296 21.668136 21.32496L21.732 21.204 21.738264 16.974L21.744528000000003 12.744 17.260272 12.744C14.793912 12.744 12.768792000000001 12.751199999999999 12.760008000000001 12.760008000000001", stroke: "none", fill: "currentColor", fillRule: "evenodd", strokeWidth: 0.024 })), OJ = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M3.4859280000000004 0.026208000000000002C3.215112 0.058128000000000006 3.032568 0.11268 2.76828 0.240624C2.136816 0.5463600000000001 1.6919520000000001 1.1149440000000002 1.5424560000000003 1.807368C1.502232 1.993656 1.5 2.529624 1.5 12C1.5 20.130768 1.505856 22.02696 1.531392 22.161888C1.6856879999999999 22.9776 2.266776 23.637168 3.072 23.910576L3.3000000000000003 23.988 12 23.988L20.7 23.988 20.928 23.910576C21.709296 23.645304 22.258344 23.043216 22.457904 22.232856C22.495488 22.080312000000003 22.499088 21.5502 22.506072000000003 15.132C22.511064 10.527984 22.505376000000002 8.112792 22.489079999999998 7.948512C22.445976 7.513776 22.343136 7.219128 22.114776 6.876C21.932064 6.601512 15.865272000000001 0.53844 15.612 0.377232C15.397848 0.24091200000000002 15.154752 0.134856 14.90052 0.066816L14.700000000000001 0.013152 9.18 0.009408C6.144 0.007368 3.581664 0.014928 3.4859280000000004 0.026208000000000002M3.544224 1.54812C3.330168 1.6069440000000002 3.132 1.7882639999999999 3.050592 1.999776C3.015408 2.091144 3.0113760000000003 2.9676 3.004992 11.928C2.999904 19.055136 3.005304 21.795576 3.0246239999999998 21.900000000000002C3.057912 22.079856 3.1767600000000003 22.266696 3.3210480000000002 22.365984C3.5499359999999998 22.523448 2.8697280000000003 22.512 12 22.512C21.124248 22.512 20.450352 22.523256 20.677296 22.367112C20.814768 22.272528 20.928552 22.104288 20.967792 21.937608C20.993327999999998 21.8292 20.999328 20.59884 20.999616 15.415128000000001L21 9.026232 18.222 9.01764C15.722256000000002 9.009912 15.427272 9.005016 15.277104000000001 8.968752C14.398584000000001 8.75664 13.756272000000001 8.113776 13.54272 7.232856000000001C13.506888000000002 7.085016 13.501895999999999 6.781248000000001 13.49436 4.29L13.485936 1.512 8.572968 1.514136C4.572048000000001 1.515888 3.6384960000000004 1.5222 3.544224 1.54812M15.000383999999999 4.320048C15.000672000000002 6.2834639999999995 15.007344000000002 6.832007999999999 15.032208 6.937608C15.071496000000002 7.10448 15.185256 7.272552000000001 15.323160000000001 7.367424C15.539976000000001 7.516584 15.462384 7.512840000000001 18.187056 7.50612L20.664072 7.5 17.832048 4.668048000000001L15 1.8360720000000001 15.000383999999999 4.320048M9.489768 8.888856C9.344784 8.92512 9.231624 8.99148 9.129071999999999 9.100416000000001C9.087864 9.144192 8.581392 9.8118 8.003592000000001 10.584C7.425768 11.356200000000001 6.948864 11.992824 6.9437999999999995 11.998704C6.938736 12.004584 6.646007999999999 11.722392 6.293304 11.371608C5.700888 10.782408 5.641032 10.729728 5.508 10.680528C5.142024 10.54512 4.732272 10.719168 4.56696 11.080248000000001C4.520016 11.1828 4.506672 11.250936 4.506672 11.388C4.506672 11.706479999999999 4.534008 11.744688 5.323032 12.528C6.04908 13.248816 6.136488000000001 13.318512 6.459960000000001 13.434552C6.611928000000001 13.489056 6.675384 13.49784 6.924 13.498848C7.157184 13.499784 7.243968 13.489872 7.38 13.446768C7.590048 13.380216 7.808712 13.251456000000001 7.96524 13.102152C8.151192 12.924816 10.333656000000001 10.001088 10.378632 9.869088C10.420968 9.744864 10.427159999999999 9.533184 10.392168 9.40716C10.289280000000002 9.036864 9.867216 8.79444 9.489768 8.888856M12.576 12.032568000000001C12.242616 12.104712000000001 11.999688 12.417648000000002 12.00024 12.774263999999999C12.000648 13.042176 12.163968 13.299696 12.42 13.436064L12.540000000000001 13.5 15 13.5L17.46 13.5 17.580000000000002 13.436064C18.00744 13.208376000000001 18.13044 12.680015999999998 17.843496000000002 12.304248000000001C17.737896 12.165936 17.560488 12.057912 17.385912 12.025632C17.181288 11.987808000000001 12.753383999999999 11.994192 12.576 12.032568000000001M9.440760000000001 15.648743999999999C9.222432 15.716040000000001 9.173136 15.773328 8.057447999999999 17.256C7.466424 18.0414 6.972887999999999 18.7002 6.960696 18.72C6.943175999999999 18.748416 6.80568 18.623688 6.307248 18.1272C5.590896 17.413656 5.560992 17.392680000000002 5.256 17.390736C5.111016 17.3898 5.05032 17.401608 4.944 17.451504C4.664592 17.582568 4.506672 17.828304 4.506672 18.132C4.506672 18.450984000000002 4.532784 18.487368 5.33496 19.28556C5.980872000000001 19.928256 6.051312 19.990968 6.230735999999999 20.08308C6.337848 20.138064 6.494447999999999 20.199288 6.578735999999999 20.219160000000002C6.774888 20.265408 7.097112000000001 20.265408 7.293264000000001 20.219160000000002C7.4833680000000005 20.174352 7.774296 20.024544 7.928472 19.892112C8.059872 19.779216 10.239696 16.890768 10.341000000000001 16.695312C10.395528 16.590096 10.403952 16.544567999999998 10.403592 16.356863999999998C10.403112 16.10772 10.361136 16.001136000000002 10.200000000000001 15.84C10.05204 15.69204 9.930552 15.640848 9.708 15.63264C9.602400000000001 15.628752 9.482136 15.636000000000001 9.440760000000001 15.648743999999999M12.576 18.032568C12.242616 18.104712000000003 11.999688 18.417648 12.00024 18.774264C12.000648 19.042176 12.163968 19.299696 12.42 19.436064000000002L12.540000000000001 19.5 15 19.5L17.46 19.5 17.580000000000002 19.436064000000002C18.00744 19.208376 18.13044 18.680016 17.843496000000002 18.304248C17.737896 18.165936 17.560488 18.057912 17.385912 18.025632C17.181288 17.987808 12.753383999999999 17.994192 12.576 18.032568", stroke: "none", fill: "currentColor", fillRule: "evenodd", strokeWidth: 0.024 })), NJ = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M6.96 3.026472C6.241848 3.1072080000000004 5.450232 3.3886559999999997 4.872 3.7688159999999997C4.53756 3.9887040000000002 4.38468 4.110768 4.107480000000001 4.3792800000000005C2.79096 5.654472 2.299344 7.551648 2.833776 9.294456C3.392664 11.116896 4.973376 12.461471999999999 6.845184000000001 12.706584000000001C7.141296 12.745368000000001 7.200311999999999 12.768 7.005288 12.768C6.830976000000001 12.768 6.352488 12.828287999999999 6.04476 12.889032C4.856663999999999 13.123536 3.717072 13.658856 2.760288 14.431920000000002C2.4869280000000002 14.652792 1.855008 15.292848000000001 1.6341119999999998 15.572591999999998C0.6130800000000001 16.865712000000002 0.026112000000000003 18.472392 0.01524 20.004C0.012048 20.454743999999998 0.012744 20.461392 0.075936 20.580000000000002C0.318264 21.034920000000003 0.9041279999999999 21.14064 1.26096 20.793816C1.4499360000000001 20.610144 1.487328 20.493288 1.51248 20.007504C1.524384 19.777608 1.5515280000000002 19.47756 1.572792 19.34076C1.9449600000000002 16.94592 3.7291440000000002 14.99928 6.077112 14.42628C6.6012 14.29836 6.8644799999999995 14.269344000000002 7.5 14.269344000000002C8.135520000000001 14.269344000000002 8.3988 14.29836 8.922888 14.42628C10.753776 14.873088 12.294599999999999 16.183272 13.017 17.907552000000003C13.310496 18.608040000000003 13.443096 19.203072000000002 13.487448 20.018616C13.506768000000001 20.373504 13.5174 20.443464000000002 13.569168 20.556576C13.832927999999999 21.13272 14.628264 21.146472 14.92248 20.580000000000002C15.001584000000001 20.427648 15.017520000000001 20.1624 14.977392 19.665143999999998C14.855784 18.158304 14.306904 16.76436 13.365888000000002 15.572591999999998C13.117439999999998 15.257952000000001 12.494591999999999 14.635128000000002 12.175152 14.381904C11.250048 13.648536 10.144728 13.13172 9.00672 12.900408000000002C8.666640000000001 12.831287999999999 8.182968 12.768 7.994712 12.768C7.799688000000001 12.768 7.858704 12.745368000000001 8.154816 12.706584000000001C11.045856 12.328008 12.96084 9.457992 12.213096 6.624384000000001C11.699615999999999 4.678536 10.025640000000001 3.244848 8.010936 3.025392C7.743672000000001 2.99628 7.223808000000001 2.996808 6.96 3.026472M16.080000000000002 3.013608C16.047 3.019248 15.922800000000002 3.035856 15.804 3.05052C15.249672 3.1189200000000006 14.552832000000002 3.362952 14.03124 3.6713280000000004C13.678416 3.879936 13.565184 4.0155840000000005 13.512648000000002 4.292568C13.455048 4.596312 13.623216000000001 4.9345680000000005 13.90584 5.083416C14.013504 5.140128 14.055144 5.147784000000001 14.256768000000001 5.14788L14.485536 5.148 14.700768000000002 5.024592C15.178536 4.75068 15.467256 4.64064 15.924 4.558416C16.171416 4.513872 16.2678 4.508424 16.608 4.519896C17.183256 4.539288 17.55984 4.63548 18.050352 4.888392C18.37872 5.057688 18.656760000000002 5.267784000000001 18.928296 5.551824C19.843439999999998 6.509064 20.113728000000002 7.874016 19.631928 9.105096000000001C19.095576 10.475592 17.72052 11.34156 16.255896 11.231208C15.70512 11.189712 15.234816 11.040887999999999 14.750712000000002 10.754952C14.490264 10.601136 14.40564 10.575744 14.198712000000002 10.589304C13.909104000000001 10.608312 13.67376 10.771152 13.551648000000002 11.037072C13.438775999999999 11.282856 13.5084 11.654352000000001 13.704047999999998 11.850264000000001C13.791048 11.93736 14.077656 12.115392 14.352 12.252696C14.763743999999999 12.458808 15.386351999999999 12.649464000000002 15.815496000000001 12.700872C16.065048 12.730775999999999 16.155192 12.768 15.978024 12.768C15.686088 12.768 14.876664 12.906287999999998 14.68152 12.989496C14.529936 13.054152 14.344655999999999 13.25748 14.291496 13.417536C14.234471999999998 13.589208 14.250504 13.846656 14.327736000000002 13.999608C14.398248 14.139216000000001 14.558112 14.291712000000002 14.699616 14.354304C14.867040000000001 14.428368 14.990496000000002 14.433888000000001 15.277488 14.380128000000001C15.822696 14.278056 15.921672000000001 14.269079999999999 16.5 14.2692C17.116704000000002 14.269319999999999 17.37168 14.296415999999999 17.861064 14.413824C19.72308 14.860512 21.236448 16.124856 21.995544 17.868000000000002C22.2996 18.566208 22.442472 19.191792 22.487688 20.022888000000002C22.506768 20.373456 22.517471999999998 20.443656 22.569167999999998 20.556576C22.832976000000002 21.132768000000002 23.627280000000003 21.146520000000002 23.922719999999998 20.580000000000002C23.975328 20.479128 23.98692 20.420424 23.995464000000002 20.211576C24.011856 19.810944 23.9376 19.140408 23.817312 18.602928C23.519280000000002 17.270976 22.842336 16.019976 21.888888 15.039167999999998C20.629632 13.743744 18.964416 12.940895999999999 17.215680000000003 12.786024C17.041704 12.770616 16.90464 12.749448 16.911096 12.739008C16.917552 12.728544 16.96332 12.72 17.012784 12.72C17.062272 12.72 17.215992 12.699192000000002 17.354400000000002 12.673775999999998C18.336312 12.493368 19.164047999999998 12.068760000000001 19.877448 11.379504C20.675328 10.608672 21.166608 9.647856 21.327288 8.544C21.371088 8.243136 21.376704 7.562112000000001 21.337752 7.272C21.073848 5.305848 19.699632 3.711648 17.811287999999998 3.18096C17.397384 3.064632 17.079984000000003 3.0204 16.596 3.011616C16.3452 3.007056 16.113 3.007968 16.080000000000002 3.013608M7.008 4.53972C6.454104 4.632096 5.952912 4.837776000000001 5.5171920000000005 5.15148C5.272368 5.3277600000000005 4.8697680000000005 5.744016 4.708104 5.988C4.453320000000001 6.372528 4.264872 6.834336 4.183752 7.272936C4.121616 7.608887999999999 4.127664 8.212776 4.1964 8.536512C4.450416 9.73296 5.2724400000000005 10.668096 6.418968 11.064912C7.08756 11.29632 7.91244 11.29632 8.581032 11.064912C10.421280000000001 10.428 11.344968 8.407416000000001 10.619568000000001 6.605568000000001C10.230408 5.638896 9.348840000000001 4.869048 8.331840000000001 4.607760000000001C7.982184 4.517904000000001 7.337400000000001 4.484784 7.008 4.53972", stroke: "none", fill: "currentColor", fillRule: "evenodd", strokeWidth: 0.024 })), DJ = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M11.736 0.052176C11.628864 0.09249600000000001 11.556456 0.149904 11.351616 0.356928C10.940328 0.772632 10.476672 1.363992 10.130400000000002 1.914504C9.276576 3.2719679999999998 8.778576000000001 4.752312 8.6268 6.384C8.587728 6.804096 8.582304 7.638408 8.616192 8.014608C8.628624 8.15244 8.635704 8.268312 8.631912 8.27208C8.628143999999999 8.275848 8.54472 8.22888 8.446536 8.16768C8.1918 8.008944000000001 7.688184000000001 7.745280000000001 7.38 7.60932C6.299208 7.132536000000001 5.205528 6.8802 4.08 6.847944000000001C3.6430560000000005 6.83544 3.60312 6.837912 3.47832 6.885384C3.321096 6.945168000000001 3.1550160000000003 7.10016 3.07008 7.266336000000001C3.0144480000000002 7.375224 3.012072 7.399152 3.013728 7.836C3.020544 9.629136 3.67788 11.534736 4.809144 13.04088C5.682984 14.20428 6.807528 15.127199999999998 8.115936 15.754752C9.033936 16.195056 9.9192 16.456248000000002 10.92 16.582032L11.244 16.62276 11.256 18.169392L11.268 19.716 11.324016 19.824C11.465232 20.09628 11.699976000000001 20.241144 12 20.241144C12.23196 20.241144 12.389184 20.17476 12.540576 20.012904C12.743064 19.796424000000002 12.730488000000001 19.910448 12.744 18.169392L12.756 16.62276 13.08 16.582032C14.478288 16.406280000000002 15.751704 15.935784 16.945968 15.153672C19.006248 13.804416 20.449224 11.601216 20.866248000000002 9.168000000000001C20.959751999999998 8.622432 20.9844 8.351496 20.986272 7.848C20.987904 7.405536000000001 20.984976 7.373856000000001 20.932488 7.267320000000001C20.86584 7.13196 20.714376 6.975336 20.581224000000002 6.904056C20.490192 6.855312 20.452608 6.852096 19.992 6.853632C18.550968 6.858456 16.962623999999998 7.319592 15.639816 8.117208C15.509904 8.195544 15.3996 8.255592 15.394680000000001 8.250696C15.38976 8.245776000000001 15.395976000000001 8.118048 15.408479999999999 7.9668719999999995C15.461256000000002 7.328712 15.423816 6.431448 15.31488 5.724C15.021168 3.816552 14.206199999999999 2.087304 12.898752 0.597216C12.596952000000002 0.253296 12.432144 0.10848 12.275928 0.05004C12.105504 -0.013727999999999999 11.90904 -0.012936000000000001 11.736 0.052176M11.875368 2.053848C11.238648 2.8467360000000004 10.690536000000002 3.941664 10.402824 4.99536C10.201128 5.734032 10.128816 6.238128000000001 10.111032 7.028976000000001C10.092048 7.873463999999999 10.14624 8.426664 10.321752 9.18C10.448568000000002 9.724416000000002 10.523208 9.926568000000001 10.653408 10.078176C11.093664 10.590816 11.537112 11.284176 11.856 11.958432C11.9286 12.111936 11.993400000000001 12.237528 12 12.237528C12.006599999999999 12.237528 12.0714 12.111936 12.144 11.958432C12.468408000000002 11.272488000000001 12.918576 10.571544 13.362792 10.06068C13.511928 9.889175999999999 13.576775999999999 9.717384000000001 13.70424 9.156C13.877472 8.393184 13.932648000000002 7.826352000000001 13.9128 7.0134479999999995C13.877328 5.560248 13.486368 4.1901600000000006 12.752088 2.945544C12.571368000000001 2.639256 12.237792 2.151768 12.100848000000001 1.993848L12.008784 1.887696 11.875368 2.053848M4.5504 8.398007999999999C4.535880000000001 8.425104 4.63128 9.01524 4.69428 9.288C5.3505840000000005 12.129624 7.541112000000001 14.31324 10.386312 14.962104000000002C10.684992000000001 15.030216000000001 11.179488000000001 15.108504 11.197464 15.090528C11.21316 15.074832 11.147544 14.625167999999999 11.08632 14.328648000000001C10.870416 13.283304000000001 10.37532 12.190968 9.733152 11.343096000000001C8.694672 9.972024 7.25136 9.006864 5.600688 8.579664C5.2074240000000005 8.47788 4.566936 8.367096 4.5504 8.398007999999999M19.356 8.39292C17.524632 8.640312 15.881256000000002 9.497232 14.700000000000001 10.820664C13.632768 12.016392 13.027272 13.345752 12.804576 14.982000000000001C12.785736000000002 15.12048 12.760248 15.117144 13.228104000000002 15.03732C15.287136000000002 14.686008000000001 17.10012 13.503383999999999 18.252408000000003 11.76C18.8184 10.903632 19.225632 9.867672 19.389192 8.868C19.449408000000002 8.499984 19.463352 8.375112000000001 19.44372 8.3796C19.43508 8.381568000000001 19.395599999999998 8.387568000000002 19.356 8.39292M4.98 21.047304C4.9125119999999995 21.074136000000003 4.781208 21.164687999999998 4.68 21.254232C4.241064000000001 21.642504 3.933576 21.849024 3.4557840000000004 22.076472C2.74308 22.415712000000003 2.02332 22.561032 1.240344 22.523736C0.6416879999999999 22.495224 0.5887920000000001 22.499184 0.412968 22.585704C-0.134688 22.8552 -0.131496 23.633616 0.418488 23.923872L0.54 23.988 1.364592 23.99544C2.2302 24.003264 2.325816 23.996256000000002 2.8018080000000003 23.889936C3.645192 23.701584 4.404744 23.352576 5.192424 22.791552C5.211168 22.778208 5.298096 22.828896 5.442504 22.937328C7.200048000000001 24.257136000000003 9.584808 24.356712 11.448 23.188032C11.5206 23.142504 11.674224 23.035680000000003 11.7894 22.950648L11.998824 22.796064 12.2454 22.974888C14.155680000000002 24.36036 16.69644 24.341231999999998 18.5712 22.927248000000002C18.681504 22.844064 18.778008 22.776 18.785688 22.776C18.793368 22.776 18.854616 22.816944 18.921816 22.866984000000002C19.62516 23.390712 20.55324 23.78052 21.5022 23.9508C21.74244 23.993904 21.875088 24 22.573439999999998 24C23.53284 24 23.549927999999998 23.996760000000002 23.772000000000002 23.773056C23.877768 23.666520000000002 23.930328 23.589528 23.97 23.483064000000002C24.025152000000002 23.335008000000002 24.045768000000002 23.071704 24 23.1C23.986656 23.108232 23.975904 23.090208 23.975784 23.059416C23.975448 22.981224 23.849664 22.7712 23.755416 22.691496C23.631552000000003 22.586736000000002 23.445456 22.511448 23.300784 22.50756C23.22996 22.505664 22.986432 22.512936 22.759656 22.523736C21.535968 22.582008000000002 20.369208 22.165368 19.404 21.325464C19.082736 21.045912 18.960768 20.98992 18.708000000000002 21.00588C18.484944000000002 21.019992 18.344904 21.094392 18.132 21.311880000000002C17.583816 21.871920000000003 16.895064 22.252728 16.130784 22.418328C15.773328 22.495800000000003 15.147167999999999 22.50732 14.770800000000001 22.443384C14.232912 22.351992 13.671432000000001 22.128696 13.244904 21.836592C13.123584000000001 21.75348 12.891576 21.559464000000002 12.729312000000002 21.405456C12.3636 21.058296 12.2778 21.012 12 21.012C11.723784 21.012 11.642304000000001 21.055992 11.271984 21.405192000000003C10.833648 21.818496000000003 10.463184 22.05732 9.970824 22.244040000000002C8.97708 22.620912 7.887887999999999 22.565352 6.93168 22.088976000000002C6.537336000000001 21.892536 6.2506319999999995 21.683568 5.88 21.322464C5.621592000000001 21.070704000000003 5.521896 21.018168 5.282664 21.007632C5.14248 21.001464000000002 5.072088 21.01068 4.98 21.047304M0.00768 23.256C0.00768 23.341800000000003 0.012048 23.376912 0.017352 23.334C0.02268 23.291088 0.02268 23.220912000000002 0.017352 23.178C0.012048 23.135088 0.00768 23.170199999999998 0.00768 23.256", stroke: "none", fill: "currentColor", fillRule: "evenodd", strokeWidth: 0.024 })), IJ = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M11.628 0.013488000000000002C11.5884 0.018840000000000003 11.4642 0.035232 11.352 0.049872C10.449504000000001 0.16776000000000002 9.564504000000001 0.600768 8.884824 1.2570000000000001C8.188368 1.929432 7.815767999999999 2.617464 7.574447999999999 3.6767999999999996L7.559688 3.7416240000000003 5.861832 3.7500959999999997C3.918816 3.7597919999999996 3.9840959999999996 3.753288 3.516 3.983376C2.931288 4.270776000000001 2.502288 4.784472 2.3228880000000003 5.412L2.2680000000000002 5.604 2.2680000000000002 13.884L2.2680000000000002 22.164 2.334216 22.375128C2.485728 22.858128 2.767608 23.26596 3.1390320000000003 23.53956C3.420528 23.746896 3.624168 23.844504 3.984 23.944608000000002C4.1330160000000005 23.986056 4.492032 23.988 12.012 23.988L19.884 23.988 20.1 23.921448C20.881128 23.680752 21.424608 23.14404 21.665784 22.375128L21.732 22.164 21.738576000000002 13.98C21.743184 8.2512 21.737448 5.745624 21.719448 5.62812C21.613152 4.933872 21.140544000000002 4.304544 20.484 3.982968C20.015064000000002 3.753264 20.08068 3.7597919999999996 18.138168 3.7500959999999997L16.440312000000002 3.7416240000000003 16.425552 3.6767999999999996C16.184496000000003 2.61864 15.810863999999999 1.928688 15.115176 1.2570000000000001C14.452056 0.616752 13.650336000000001 0.21516 12.72 0.057192C12.522456 0.02364 11.774184 -0.006288 11.628 0.013488000000000002M11.616 1.52628C11.176344 1.6045200000000002 10.814256 1.72956 10.500960000000001 1.911336C10.251048 2.056368 10.13148 2.147808 9.915336 2.3592C9.373464 2.889192 9.083856 3.509832 9.022776 4.272C9.008472000000001 4.450200000000001 8.980824 4.652496 8.961312 4.721568C8.893056 4.963032 8.665583999999999 5.177951999999999 8.423207999999999 5.2299359999999995C8.34132 5.24748 7.659719999999999 5.256 6.335088 5.256C4.452168 5.256 4.3633440000000006 5.257968 4.24692 5.3022C4.060944 5.3728560000000005 3.926256 5.497152 3.8352000000000004 5.68212L3.7560000000000002 5.842992 3.749184 13.775496C3.7443120000000003 19.426416 3.74988 21.752256000000003 3.768552 21.86184C3.782952 21.946464000000002 3.810936 22.047 3.8307360000000004 22.08528C3.8977440000000003 22.21488 4.043375999999999 22.3512 4.188 22.419719999999998L4.332 22.487952 12 22.487952L19.668 22.487952 19.812 22.419719999999998C19.957248 22.350912 20.102304 22.214807999999998 20.170056 22.083744C20.190288 22.044624 20.218176 21.938664 20.232 21.848304C20.249256000000003 21.735576000000002 20.255088 19.197623999999998 20.250576 13.763496000000002L20.244 5.842992 20.164800000000003 5.68212C20.073743999999998 5.497152 19.939056 5.3728560000000005 19.75308 5.3022C19.636656 5.257968 19.547832000000003 5.256 17.664912 5.256C16.34028 5.256 15.658680000000002 5.24748 15.576792000000001 5.2299359999999995C15.334416 5.177951999999999 15.106944 4.963032 15.038687999999999 4.721568C15.019176 4.652496 14.991528 4.450200000000001 14.977224000000001 4.272C14.916144 3.509832 14.626536 2.889192 14.084664 2.3592C13.781232 2.06244 13.472976000000001 1.8627360000000002 13.092 1.716096C12.712944 1.5702 12.513192000000002 1.5325199999999999 12.072000000000001 1.523592C11.8542 1.5191999999999999 11.649000000000001 1.5204 11.616 1.52628M11.786256 3.0271440000000003C11.49504 3.07548 11.15484 3.322584 11.010792 3.590376C10.780512 4.01844 10.840416000000001 4.5297600000000005 11.162064 4.881672C11.39292 5.134296 11.665392 5.256 12 5.256C12.334608000000001 5.256 12.60708 5.134296 12.837936 4.881672C13.066176 4.631952 13.161144 4.3157760000000005 13.111488000000001 3.9710640000000006C13.043040000000001 3.49584 12.659424 3.101424 12.192 3.025656C12.014568 2.99688 11.967504 2.997072 11.786256 3.0271440000000003M16.032 10.562688000000001C15.9096 10.609608 15.691199999999998 10.821888 13.03176 13.47864C11.45424 15.0546 10.152792 16.344 10.139664 16.344C10.126536000000002 16.344 9.668856000000002 15.896976 9.122615999999999 15.350616C8.428656 14.656488000000001 8.096088 14.340336 8.018735999999999 14.301143999999999C7.859640000000001 14.220576 7.594296 14.210424 7.41432 14.278008000000002C7.257096000000001 14.337048 7.0913520000000005 14.491464 7.006080000000001 14.658336C6.922248000000001 14.822376000000002 6.922584 15.128160000000001 7.0068 15.3C7.09512 15.480216 9.116832 17.496744 9.336 17.623248C9.838152000000001 17.913048 10.453608000000001 17.909424 10.961808000000001 17.613672C11.066544 17.552712000000003 11.806583999999999 16.827192 14.018808 14.616624C16.379640000000002 12.257544 16.948536 11.677056 16.994808 11.58C17.041392000000002 11.482248 17.051904 11.422152 17.051424 11.256C17.050944 11.082504 17.041368000000002 11.034048 16.987488 10.932C16.911168 10.787424 16.778280000000002 10.655904 16.632 10.580184000000001C16.479216 10.501104 16.212912 10.493352 16.032 10.562688000000001", stroke: "none", fill: "currentColor", fillRule: "evenodd", strokeWidth: 0.024 })), ts = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M3.3125 13.0421L12.6875 3.66711", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M3.3125 3.66711L12.6875 13.0421", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), U0 = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17349_742)" }, /* @__PURE__ */ d.createElement("path", { d: "M15.0312 1.32274L5.59875 14.7971C5.4743 14.9759 5.30913 15.1226 5.11686 15.2251C4.92459 15.3276 4.71072 15.3829 4.49288 15.3865C4.27503 15.3901 4.05945 15.3419 3.8639 15.2458C3.66835 15.1498 3.49842 15.0086 3.36812 14.834L0.96875 11.6352", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17349_742" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), BJ = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17390_168)" }, /* @__PURE__ */ d.createElement("path", { d: "M14.3687 2.16317C14.1559 1.9512 13.9032 1.7835 13.6251 1.66977C13.3471 1.55603 13.0493 1.49852 12.7489 1.50056C12.4485 1.50259 12.1515 1.56413 11.875 1.68162C11.5985 1.7991 11.3481 1.97021 11.1381 2.18505L2.07562 11.2475L0.96875 15.5632L5.28438 14.4563L14.3469 5.3938C14.5617 5.18384 14.7328 4.93339 14.8503 4.65692C14.9678 4.38045 15.0293 4.08344 15.0314 3.78305C15.0334 3.48265 14.9759 3.18484 14.8622 2.9068C14.7484 2.62876 14.5807 2.37602 14.3687 2.16317Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M10.8789 2.44442L14.0877 5.65317", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.56982 3.75317L12.7786 6.96192", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M2.07568 11.2475L5.28756 14.4532", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17390_168" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.531921)" })))), $J = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M5.65625 3.35461H10.8125C11.3098 3.35461 11.7867 3.55216 12.1383 3.90379C12.49 4.25542 12.6875 4.73233 12.6875 5.22961V9.44836", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M10.3438 13.6671H5.1875C4.69022 13.6671 4.21331 13.4696 3.86167 13.1179C3.51004 12.7663 3.3125 12.2894 3.3125 11.7921V7.57336", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M10.3438 7.10274L12.6875 9.44649L15.0312 7.10274", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M5.65625 9.91524L3.3125 7.57149L0.96875 9.91524", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), FJ = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17821_3680)" }, /* @__PURE__ */ d.createElement("path", { d: "M0.96875 8.35461H15.0312", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8 1.32336V15.3859", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17821_3680" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), zP = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M6.76164 3.95908C6.57411 3.77155 6.46875 3.51719 6.46875 3.25198C6.46875 2.98676 6.57411 2.73241 6.76164 2.54487C6.94918 2.35733 7.20353 2.25198 7.46875 2.25198C7.73397 2.25198 7.98832 2.35733 8.17586 2.54487C8.36339 2.73241 8.46875 2.98676 8.46875 3.25198C8.46875 3.51719 8.36339 3.77155 8.17586 3.95908C7.98832 4.14662 7.73397 4.25198 7.46875 4.25198C7.20353 4.25198 6.94918 4.14662 6.76164 3.95908Z", fill: "#18181B", stroke: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M6.76164 9.06173C6.57411 8.87419 6.46875 8.61983 6.46875 8.35462C6.46875 8.0894 6.57411 7.83505 6.76164 7.64751C6.94918 7.45997 7.20353 7.35462 7.46875 7.35462C7.73397 7.35462 7.98832 7.45997 8.17586 7.64751C8.36339 7.83505 8.46875 8.0894 8.46875 8.35462C8.46875 8.61983 8.36339 8.87419 8.17586 9.06173C7.98832 9.24926 7.73397 9.35462 7.46875 9.35462C7.20353 9.35462 6.94918 9.24926 6.76164 9.06173Z", fill: "#18181B", stroke: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M6.76164 14.1644C6.57411 13.9768 6.46875 13.7225 6.46875 13.4573C6.46875 13.192 6.57411 12.9377 6.76164 12.7502C6.94918 12.5626 7.20353 12.4573 7.46875 12.4573C7.73397 12.4573 7.98832 12.5626 8.17586 12.7502C8.36339 12.9377 8.46875 13.192 8.46875 13.4573C8.46875 13.7225 8.36339 13.9768 8.17586 14.1644C7.98832 14.3519 7.73397 14.4573 7.46875 14.4573C7.20353 14.4573 6.94918 14.3519 6.76164 14.1644Z", fill: "#18181B", stroke: "currentColor" })), WJ = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17818_2400)" }, /* @__PURE__ */ d.createElement("path", { d: "M0.96875 11.2672L4.95192 15.386H11.0481L15.0312 11.2672V5.44211L11.0481 1.32336H4.95192L0.96875 5.44211V11.2672Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8 11.5407C7.87056 11.5407 7.76562 11.4357 7.76562 11.3063C7.76562 11.1768 7.87056 11.0719 8 11.0719", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8 11.5407C8.12944 11.5407 8.23438 11.4357 8.23438 11.3063C8.23438 11.1768 8.12944 11.0719 8 11.0719", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8 9.19693V4.04065", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17818_2400" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), qJ = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17902_126)" }, /* @__PURE__ */ d.createElement("path", { d: "M1.64941 2.99774C1.64941 3.35296 1.79053 3.69364 2.04171 3.94482C2.29289 4.196 2.63356 4.33711 2.98879 4.33711C3.34401 4.33711 3.68469 4.196 3.93587 3.94482C4.18705 3.69364 4.32816 3.35296 4.32816 2.99774C4.32816 2.64251 4.18705 2.30184 3.93587 2.05066C3.68469 1.79948 3.34401 1.65836 2.98879 1.65836C2.63356 1.65836 2.29289 1.79948 2.04171 2.05066C1.79053 2.30184 1.64941 2.64251 1.64941 2.99774Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M4.99992 7.18274C4.99992 6.64998 4.78829 6.13905 4.41157 5.76234C4.03486 5.38562 3.52393 5.17399 2.99117 5.17399C2.45842 5.17399 1.94748 5.38562 1.57077 5.76234C1.19406 6.13905 0.982422 6.64998 0.982422 7.18274", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M1.64941 10.5309C1.64941 10.8861 1.79053 11.2268 2.04171 11.4779C2.29289 11.7291 2.63356 11.8702 2.98879 11.8702C3.34401 11.8702 3.68469 11.7291 3.93587 11.4779C4.18705 11.2268 4.32816 10.8861 4.32816 10.5309C4.32816 10.1756 4.18705 9.83497 3.93587 9.58378C3.68469 9.3326 3.34401 9.19149 2.98879 9.19149C2.63356 9.19149 2.29289 9.3326 2.04171 9.58378C1.79053 9.83497 1.64941 10.1756 1.64941 10.5309Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M4.99992 14.7165C4.99992 14.1837 4.78829 13.6728 4.41157 13.2961C4.03486 12.9194 3.52393 12.7077 2.99117 12.7077C2.45842 12.7077 1.94748 12.9194 1.57077 13.2961C1.19406 13.6728 0.982422 14.1837 0.982422 14.7165", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M7.00684 3.35461H14.395C14.5607 3.35461 14.7197 3.42046 14.8369 3.53767C14.9541 3.65488 15.02 3.81385 15.02 3.97961V5.51961C15.02 5.68537 14.9541 5.84435 14.8369 5.96156C14.7197 6.07877 14.5607 6.14461 14.395 6.14461H7.00684V3.35461Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M7.00684 10.7427H10.7343C10.9001 10.7427 11.0591 10.8086 11.1763 10.9258C11.2935 11.043 11.3593 11.202 11.3593 11.3677V12.9077C11.3593 13.0735 11.2935 13.2325 11.1763 13.3497C11.0591 13.4669 10.9001 13.5327 10.7343 13.5327H7.00684V10.7427Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M7.00684 1.32336V15.3859", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17902_126" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), jJ = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17839_3671)" }, /* @__PURE__ */ d.createElement("path", { d: "M6.1249 12.8471C5.94909 13.0229 5.71068 13.1216 5.46209 13.1216C5.2135 13.1216 4.97508 13.0229 4.79927 12.8471L1.4374 9.48586C1.35028 9.3988 1.28117 9.29543 1.23402 9.18168C1.18687 9.06786 1.1626 8.94593 1.1626 8.82274C1.1626 8.69961 1.18687 8.57761 1.23402 8.46386C1.28117 8.35005 1.35028 8.24668 1.4374 8.15961L7.99991 1.59713C8.08697 1.51009 8.19041 1.44106 8.30416 1.39398C8.41797 1.3469 8.53991 1.3227 8.66304 1.32275H12.0243C12.2729 1.32275 12.5113 1.42153 12.6872 1.59734C12.863 1.77316 12.9618 2.01161 12.9618 2.26025V5.62213C12.9617 5.87059 12.863 6.10888 12.6874 6.28463", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M10.6182 3.90088C10.4887 3.90088 10.3838 3.79594 10.3838 3.6665C10.3838 3.53706 10.4887 3.43213 10.6182 3.43213", stroke: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M10.6182 3.90088C10.7476 3.90088 10.8525 3.79594 10.8525 3.6665C10.8525 3.53706 10.7476 3.43213 10.6182 3.43213", stroke: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M11.0869 10.229V13.0415", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.68066 11.6352H12.4932", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M11.0869 15.3852C13.158 15.3852 14.8369 13.7063 14.8369 11.6352C14.8369 9.56418 13.158 7.88524 11.0869 7.88524C9.01585 7.88524 7.33691 9.56418 7.33691 11.6352C7.33691 13.7063 9.01585 15.3852 11.0869 15.3852Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17839_3671" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), HJ = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17842_9319)" }, /* @__PURE__ */ d.createElement("path", { d: "M5.65625 2.72961H15.0312", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M5.65625 8.35461H15.0312", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M5.65625 13.9796H15.0312", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M1.4375 1.32336H3.3125C3.3125 1.32336 3.78125 1.32336 3.78125 1.79211V3.66711C3.78125 3.66711 3.78125 4.13586 3.3125 4.13586H1.4375C1.4375 4.13586 0.96875 4.13586 0.96875 3.66711V1.79211C0.96875 1.79211 0.96875 1.32336 1.4375 1.32336Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M1.4375 6.94836H3.3125C3.3125 6.94836 3.78125 6.94836 3.78125 7.41711V9.29211C3.78125 9.29211 3.78125 9.76086 3.3125 9.76086H1.4375C1.4375 9.76086 0.96875 9.76086 0.96875 9.29211V7.41711C0.96875 7.41711 0.96875 6.94836 1.4375 6.94836Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M1.4375 12.5734H3.3125C3.3125 12.5734 3.78125 12.5734 3.78125 13.0421V14.9171C3.78125 14.9171 3.78125 15.3859 3.3125 15.3859H1.4375C1.4375 15.3859 0.96875 15.3859 0.96875 14.9171V13.0421C0.96875 13.0421 0.96875 12.5734 1.4375 12.5734Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17842_9319" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), VJ = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17868_3485)" }, /* @__PURE__ */ d.createElement("path", { d: "M13.1562 8.04211V11.6359C13.1562 11.8845 13.0575 12.123 12.8817 12.2988C12.7059 12.4746 12.4674 12.5734 12.2188 12.5734H5.65625L2.84375 15.3859V12.5734H1.90625C1.65761 12.5734 1.41915 12.4746 1.24334 12.2988C1.06752 12.123 0.96875 11.8845 0.96875 11.6359V4.13586C0.96875 3.88723 1.06752 3.64876 1.24334 3.47295C1.41915 3.29714 1.65761 3.19836 1.90625 3.19836H8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M15.0312 1.32336L9.67969 6.67493", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M15.0312 6.01086V1.32336H10.3438", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17868_3485" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), UJ = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17390_95)" }, /* @__PURE__ */ d.createElement("path", { d: "M14.0938 14.4552C14.0938 14.7039 13.995 14.9423 13.8192 15.1181C13.6433 15.294 13.4049 15.3927 13.1562 15.3927H2.84375C2.59511 15.3927 2.35665 15.294 2.18084 15.1181C2.00502 14.9423 1.90625 14.7039 1.90625 14.4552V2.26773C1.90625 2.01909 2.00502 1.78063 2.18084 1.60482C2.35665 1.429 2.59511 1.33023 2.84375 1.33023H9.48687C9.73534 1.33028 9.97363 1.42897 10.1494 1.60461L13.8194 5.27461C13.995 5.45035 14.0937 5.68864 14.0938 5.93711V14.4552Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M14.0938 6.01773H10.3438C10.0951 6.01773 9.85665 5.91896 9.68084 5.74314C9.50502 5.56733 9.40625 5.32887 9.40625 5.08023V1.33023", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M6.54313 6.86649L5.21063 8.64274C5.17031 8.69641 5.11894 8.74081 5.05999 8.77291C5.00103 8.80502 4.93587 8.82409 4.86891 8.82883C4.80194 8.83357 4.73474 8.82387 4.67185 8.80039C4.60896 8.77691 4.55185 8.7402 4.50437 8.69274L3.78125 7.97024", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M6.54313 11.0852L5.21063 12.8615C5.17031 12.9152 5.11894 12.9596 5.05999 12.9917C5.00103 13.0238 4.93587 13.0428 4.86891 13.0476C4.80194 13.0523 4.73474 13.0426 4.67185 13.0191C4.60896 12.9957 4.55185 12.9589 4.50437 12.9115L3.78125 12.1884", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8.46875 8.83023H11.2812", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8.46875 12.5802H11.2812", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17390_95" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), zJ = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17820_2445)" }, /* @__PURE__ */ d.createElement("path", { d: "M15.0269 15.3859H0.96875V1.32336", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M0.96875 13.5695L6.125 10.4394L7.6875 11.5987L13 12.9898L14.875 9.97574", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M0.96875 8.12024L5.48047 3.12024L9.66019 9.68274L14.875 3.12024", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17820_2445" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), YJ = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17349_737)" }, /* @__PURE__ */ d.createElement("path", { d: "M7.53125 11.6359C7.53125 12.6304 7.92634 13.5843 8.6296 14.2875C9.33286 14.9908 10.2867 15.3859 11.2812 15.3859C12.2758 15.3859 13.2296 14.9908 13.9329 14.2875C14.6362 13.5843 15.0312 12.6304 15.0312 11.6359C15.0312 10.6413 14.6362 9.68748 13.9329 8.98421C13.2296 8.28095 12.2758 7.88586 11.2812 7.88586C10.2867 7.88586 9.33286 8.28095 8.6296 8.98421C7.92634 9.68748 7.53125 10.6413 7.53125 11.6359Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M11.2812 9.76086V13.5109", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.40625 11.6359H13.1562", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M0.96875 11.6359C0.969225 10.9384 1.14253 10.252 1.47316 9.63787C1.80379 9.02378 2.28145 8.5012 2.86343 8.11685C3.44541 7.7325 4.11356 7.49835 4.80815 7.43536C5.50274 7.37236 6.20212 7.48248 6.84375 7.75586", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M2.60938 3.90149C2.60938 4.58525 2.881 5.24101 3.36449 5.7245C3.84798 6.20799 4.50374 6.47961 5.1875 6.47961C5.87126 6.47961 6.52702 6.20799 7.01051 5.7245C7.494 5.24101 7.76563 4.58525 7.76562 3.90149C7.76563 3.21773 7.494 2.56197 7.01051 2.07848C6.52702 1.59499 5.87126 1.32336 5.1875 1.32336C4.50374 1.32336 3.84798 1.59499 3.36449 2.07848C2.881 2.56197 2.60938 3.21773 2.60938 3.90149Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17349_737" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), GJ = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M11.544 0.024192C10.662431999999999 0.14541600000000002 9.898176 0.5306879999999999 9.3 1.155408C8.611224 1.87476 8.257728 2.753736 8.256432 3.750264C8.255112 4.757592 8.637936 5.685672 9.347904 6.396384C9.834456000000001 6.88344 10.411871999999999 7.2140640000000005 11.064 7.379016C11.260824000000001 7.4287920000000005 11.44224 7.4598960000000005 11.748000000000001 7.496256C11.7876 7.500960000000001 11.7444 7.506648 11.652000000000001 7.50888C10.973880000000001 7.525272 10.091496 7.758 9.370632 8.110584C7.481232 9.034656 6.233256 10.833168 6.024696 12.932544C6.010992 13.070352 6 13.783704 6 14.533632C6 15.840768 6.001656 15.890640000000001 6.049464 16.018392C6.112368 16.186512 6.270912 16.351368 6.45072 16.435655999999998L6.588 16.5 7.453463999999999 16.507800000000003L8.318928 16.515624 8.637648 19.7118C9.033144 23.677872 9.005712 23.437776 9.079896 23.582784C9.151463999999999 23.722728 9.28404 23.853984 9.432 23.931456L9.540000000000001 23.988 12 23.988L14.46 23.988 14.568 23.931456C14.812536 23.803416 14.953296 23.60076 14.995439999999999 23.316C15.00912 23.2236 15.168984000000002 21.655704 15.350688 19.8318L15.681072000000002 16.515624 16.546536 16.507800000000003L17.412 16.5 17.54928 16.435655999999998C17.73108 16.350456 17.88756 16.186728 17.95212 16.014143999999998C18.002592 15.87924 18.003072000000003 15.860544 17.993736000000002 14.37684C17.983584 12.764232 17.979864 12.708383999999999 17.84424 12.132C17.27148 9.698088 15.25944 7.8806400000000005 12.768 7.546704000000001C12.6294 7.528128000000001 12.4404 7.511112000000001 12.348 7.50888C12.2556 7.506648 12.2124 7.500960000000001 12.252 7.496256C13.123776 7.3926 13.669680000000001 7.186152 14.267952000000001 6.7338960000000005C15.200088000000001 6.0292319999999995 15.745104000000001 4.927248 15.743568 3.750264C15.742272 2.753736 15.388776 1.87476 14.700000000000001 1.155408C14.1636 0.5952000000000001 13.509792000000001 0.23532 12.732000000000001 0.07212C12.458808 0.014784 11.804376 -0.011616 11.544 0.024192M11.652000000000001 1.5276C10.797696 1.6640160000000002 10.074576 2.31072 9.839903999999999 3.1481760000000003C9.73992 3.5050320000000004 9.735936 3.962376 9.829656 4.328016C9.883464 4.5379439999999995 10.058736 4.897464 10.200552 5.088768C10.516752 5.515272 11.000208 5.827416 11.528544 5.946192C11.75676 5.99748 12.24324 5.99748 12.471456 5.946192C13.230552000000001 5.775552 13.843176 5.237376 14.110752 4.506072C14.304792 3.975744 14.278464000000001 3.342072 14.0406 2.8174799999999998C13.818336 2.3273040000000003 13.378104000000002 1.897272 12.886104000000001 1.689768C12.575040000000001 1.5585840000000002 12.451056 1.533408 12.072000000000001 1.524384C11.8806 1.519848 11.6916 1.521288 11.652000000000001 1.5276M4.152 3.01452C3.649416 3.106872 3.453288 3.167616 3.141 3.3276719999999997C2.20824 3.805704 1.603416 4.7034720000000005 1.5144 5.742C1.3845120000000002 7.257648 2.40948 8.634936 3.892992 8.938176C3.9947280000000003 8.958984000000001 4.10724 8.976 4.143 8.976C4.277496 8.976 4.1718 9.004056 3.9085680000000003 9.038232C2.928264 9.165456 2.032944 9.609408 1.321176 10.321176C0.741168 10.901184 0.347088 11.585280000000001 0.144432 12.363912000000001C0.013104000000000001 12.868488000000001 0 13.066392 0 14.544336000000001C0 15.840672000000001 0.0016800000000000003 15.890687999999999 0.049464 16.018392C0.112536 16.186992 0.271416 16.351872 0.45072 16.434816C0.5824320000000001 16.495752 0.6081840000000001 16.498728 1.085424 16.507872L1.582848 16.517424000000002 1.5957599999999998 16.592712000000002C1.602864 16.634112 1.75464 17.8398 1.933032 19.272000000000002C2.111424 20.7042 2.267136 21.911592 2.279064 21.955128000000002C2.336472 22.164576 2.556216 22.401432 2.755128 22.4682C2.8744560000000003 22.508256000000003 5.860152 22.526232 6.104304 22.488336C6.2927040000000005 22.459104 6.442512 22.381032 6.5541599999999995 22.253880000000002C6.886728000000001 21.875088 6.770136 21.290832 6.317495999999999 21.067895999999998L6.204 21.012 4.938312 21.005376000000002L3.6726 20.998776 3.6610080000000003 20.945376000000003C3.6546240000000005 20.916024 3.4994400000000003 19.687800000000003 3.316176 18.216C2.9469600000000002 15.251064000000001 2.9759520000000004 15.409991999999999 2.768064 15.212544C2.573928 15.028128 2.516856 15.012936 1.986 15.004199999999999L1.512 14.996400000000001 1.512072 14.104199999999999C1.512144 13.40424 1.520232 13.165464000000002 1.5496079999999999 12.996C1.7124 12.05736 2.318904 11.241048000000001 3.1621680000000003 10.82568C3.563976 10.627752 3.8792159999999996 10.545912000000001 4.378416 10.509888C4.62084 10.492392 4.715448 10.475112000000001 4.810416 10.431023999999999C5.296632000000001 10.205304 5.398008 9.543840000000001 5.000088 9.193584C4.940040000000001 9.140712 4.8360959999999995 9.077016 4.7691360000000005 9.052032L4.647384 9.006599999999999 4.78968 8.989536000000001C5.318256 8.926152 5.774736 8.759856000000001 6.1817519999999995 8.482416C6.93468 7.969200000000001 7.407552000000001 7.162392 7.48548 6.258C7.615896 4.744632 6.609096000000001 3.3882000000000003 5.112 3.060216C4.938048 3.022104 4.2809040000000005 2.990832 4.152 3.01452M19.152 3.01452C18.649416 3.106872 18.453288 3.167616 18.141000000000002 3.3276719999999997C17.20824 3.805704 16.603416 4.7034720000000005 16.514400000000002 5.742C16.411848 6.938688000000001 17.021928 8.070408 18.07596 8.638776C18.415944 8.822112 18.728184 8.922144 19.136496 8.978592L19.348968 9.007968 19.22904 9.052704C19.163088000000002 9.077304 19.05996 9.140712 18.999912000000002 9.193584C18.68136 9.473976 18.669719999999998 9.976296 18.974712 10.281288C19.129512000000002 10.436088 19.265616 10.484184 19.621584000000002 10.509888C20.120784 10.545912000000001 20.436024 10.627752 20.837832000000002 10.82568C21.548784 11.175864 22.085808 11.798712 22.34364 12.572111999999999C22.472160000000002 12.957696 22.487832 13.124112 22.487928 14.104199999999999L22.488 14.996400000000001 22.014 15.004199999999999C21.483144 15.012936 21.426072 15.028128 21.231936 15.212544C21.024048 15.409991999999999 21.053040000000003 15.251064000000001 20.683824 18.216C20.50056 19.687800000000003 20.345376 20.916024 20.338992 20.945376000000003L20.3274 20.998776 19.061688 21.005376000000002L17.796 21.012 17.68332 21.067512C17.621351999999998 21.098015999999998 17.525976 21.167664 17.471376000000003 21.222264C17.321687999999998 21.371976 17.273471999999998 21.48408 17.260968000000002 21.711552C17.251608 21.882264 17.257776 21.923544 17.309544 22.036656C17.430024 22.299816 17.618952 22.4454 17.895696 22.488336C18.139848 22.526232 21.125544 22.508256000000003 21.244872 22.4682C21.443784 22.401432 21.663528000000003 22.164576 21.720936000000002 21.955128000000002C21.732864 21.911592 21.888576 20.7042 22.066968 19.272000000000002C22.24536 17.8398 22.397136000000003 16.634112 22.40424 16.592712000000002L22.417152 16.517424000000002 22.914576 16.507872C23.391816 16.498728 23.417568 16.495752 23.54928 16.434816C23.7306 16.350936 23.887392000000002 16.187184000000002 23.952168 16.014072000000002C24.002688 15.879048 24.00312 15.861216 23.992752 14.412768000000002C23.984376 13.241015999999998 23.975016 12.9096 23.946 12.756C23.763047999999998 11.787312 23.348592 10.990944 22.678824000000002 10.321176C21.968064000000002 9.610392 21.070392000000002 9.165288 20.091432 9.038232C19.8282 9.004056 19.722504 8.976 19.857 8.976C19.89276 8.976 20.005272 8.958984000000001 20.107008 8.938176C21.399816 8.673912 22.371672 7.578768 22.48548 6.258C22.615896 4.744632 21.609096 3.3882000000000003 20.112000000000002 3.060216C19.938048 3.022104 19.280904 2.990832 19.152 3.01452M4.133208000000001 4.546776C3.7484880000000005 4.639944 3.3365039999999997 4.971576 3.162696 5.328C2.79456 6.0829439999999995 3.10356 6.986904 3.8517600000000005 7.343952C4.083912000000001 7.454712 4.233648 7.488 4.5 7.488C4.766352 7.488 4.916088 7.454712 5.1482399999999995 7.343952C5.506968 7.17276 5.795544 6.845544 5.920752 6.468C5.974824 6.304944000000001 5.984424 6.234384 5.984424 6C5.984424 5.7656160000000005 5.974824 5.695056 5.920752 5.532C5.839392 5.286648 5.703576 5.080512 5.501016 4.894896C5.323848 4.732584 5.039016 4.581408 4.828824 4.53816C4.661232 4.503696 4.292304000000001 4.508256 4.133208000000001 4.546776M19.133208 4.546776C18.748488000000002 4.639944 18.336503999999998 4.971576 18.162696 5.328C17.79456 6.0829439999999995 18.10356 6.986904 18.851760000000002 7.343952C19.083912 7.454712 19.233648000000002 7.488 19.5 7.488C19.766351999999998 7.488 19.916088 7.454712 20.14824 7.343952C20.506968 7.17276 20.795544 6.845544 20.920752 6.468C20.974824 6.304944000000001 20.984424 6.234384 20.984424 6C20.984424 5.7656160000000005 20.974824 5.695056 20.920752 5.532C20.839392 5.286648 20.703576 5.080512 20.501016 4.894896C20.323848 4.732584 20.039016 4.581408 19.828824 4.53816C19.661232 4.503696 19.292304 4.508256 19.133208 4.546776M11.544 9.027288C10.510968 9.133152 9.555648 9.592656 8.81076 10.341912C8.240568000000001 10.915464 7.852320000000001 11.596128 7.645968 12.384C7.529472 12.828768000000002 7.5120000000000005 13.047623999999999 7.5120000000000005 14.061072000000001L7.5120000000000005 15 8.312184 15C9.190824000000001 15 9.250464 15.007488 9.435936 15.140927999999999C9.563136 15.232439999999999 9.684576 15.407231999999999 9.721536 15.552C9.736704000000001 15.611400000000001 9.902112 17.1936 10.089096000000001 19.068L10.42908 22.476 12 22.476L13.570920000000001 22.476 13.910904 19.068C14.097888000000001 17.1936 14.263296 15.611400000000001 14.278464000000001 15.552C14.315424 15.407231999999999 14.436863999999998 15.232439999999999 14.564064 15.140927999999999C14.749535999999999 15.007488 14.809175999999999 15 15.687816 15L16.488 15 16.488 14.061072000000001C16.488 13.075464000000002 16.470432000000002 12.838680000000002 16.366848 12.429216C16.036752 11.124168000000001 15.113616 9.993024 13.930488 9.443904C13.147464000000001 9.080472 12.362328 8.943408 11.544 9.027288", stroke: "none", fill: "currentColor", fillRule: "evenodd", strokeWidth: 0.024 })), KJ = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17349_733)" }, /* @__PURE__ */ d.createElement("path", { d: "M0.96875 11.6359C0.969225 10.9384 1.14253 10.252 1.47316 9.63787C1.80379 9.02378 2.28145 8.5012 2.86343 8.11685C3.44541 7.7325 4.11356 7.49835 4.80815 7.43536C5.50274 7.37236 6.20212 7.48248 6.84375 7.75586", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M2.60938 3.90149C2.60938 4.58525 2.881 5.24101 3.36449 5.7245C3.84798 6.20799 4.50374 6.47961 5.1875 6.47961C5.87126 6.47961 6.52702 6.20799 7.01051 5.7245C7.494 5.24101 7.76563 4.58525 7.76562 3.90149C7.76563 3.21773 7.494 2.56197 7.01051 2.07848C6.52702 1.59499 5.87126 1.32336 5.1875 1.32336C4.50374 1.32336 3.84798 1.59499 3.36449 2.07848C2.881 2.56197 2.60938 3.21773 2.60938 3.90149Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M7.53125 11.6352C7.53125 12.6298 7.92634 13.5836 8.6296 14.2869C9.33286 14.9902 10.2867 15.3852 11.2812 15.3852C12.2758 15.3852 13.2296 14.9902 13.9329 14.2869C14.6362 13.5836 15.0312 12.6298 15.0312 11.6352C15.0312 10.6407 14.6362 9.68685 13.9329 8.98359C13.2296 8.28033 12.2758 7.88524 11.2812 7.88524C10.2867 7.88524 9.33286 8.28033 8.6296 8.98359C7.92634 9.68685 7.53125 10.6407 7.53125 11.6352Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.40625 11.6352H13.1562", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17349_733" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), ZJ = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17830_3731)" }, /* @__PURE__ */ d.createElement("path", { d: "M4.71875 4.60461C4.71875 5.47486 5.06445 6.30945 5.67981 6.92481C6.29516 7.54016 7.12976 7.88586 8 7.88586C8.87024 7.88586 9.70484 7.54016 10.3202 6.92481C10.9355 6.30945 11.2812 5.47486 11.2812 4.60461C11.2812 3.73437 10.9355 2.89977 10.3202 2.28442C9.70484 1.66907 8.87024 1.32336 8 1.32336C7.12976 1.32336 6.29516 1.66907 5.67981 2.28442C5.06445 2.89977 4.71875 3.73437 4.71875 4.60461Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M1.90625 15.3859C1.90625 13.7697 2.54827 12.2197 3.69107 11.0769C4.83387 9.93413 6.38384 9.29211 8 9.29211C9.61616 9.29211 11.1661 9.93413 12.3089 11.0769C13.4517 12.2197 14.0937 13.7697 14.0938 15.3859", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17830_3731" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), XJ = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17687_480)" }, /* @__PURE__ */ d.createElement("path", { d: "M12.21 9.47961C13.9225 10.0777 15.0312 11.0321 15.0312 12.1077C15.0312 13.9202 11.8831 15.389 8 15.389C4.11687 15.389 0.96875 13.9171 0.96875 12.1046C0.96875 11.0327 2.06937 10.0815 3.77187 9.48274", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M6.35938 2.96399C6.35938 3.39911 6.53223 3.81641 6.8399 4.12409C7.14758 4.43176 7.56488 4.60461 8 4.60461C8.43512 4.60461 8.85242 4.43176 9.1601 4.12409C9.46777 3.81641 9.64062 3.39911 9.64062 2.96399C9.64062 2.52887 9.46777 2.11157 9.1601 1.80389C8.85242 1.49622 8.43512 1.32336 8 1.32336C7.56488 1.32336 7.14758 1.49622 6.8399 1.80389C6.53223 2.11157 6.35938 2.52887 6.35938 2.96399Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M10.3438 8.82024V7.41711C10.3437 6.79551 10.0968 6.19937 9.65728 5.75983C9.21774 5.32029 8.6216 5.07336 8 5.07336C7.3784 5.07336 6.78226 5.32029 6.34272 5.75983C5.90318 6.19937 5.65625 6.79551 5.65625 7.41711V8.82336H6.59375L7.0625 12.5734H8.9375L9.40625 8.82336L10.3438 8.82024Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17687_480" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), QJ = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17349_730)" }, /* @__PURE__ */ d.createElement("path", { d: "M14.6438 10.1477L9.875 14.9171L7.53125 15.3859L8 13.0421L12.7688 8.27275C13.0168 8.02482 13.3531 7.88554 13.7037 7.88554C14.0544 7.88554 14.3907 8.02482 14.6388 8.27275L14.6438 8.27837C14.7666 8.40103 14.8641 8.54673 14.9307 8.70711C14.9972 8.8675 15.0314 9.03943 15.0314 9.21306C15.0314 9.38669 14.9972 9.55862 14.9307 9.71901C14.8641 9.87939 14.7666 10.0251 14.6438 10.1477Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M2.60938 3.90149C2.60938 4.58525 2.881 5.24101 3.36449 5.7245C3.84798 6.20799 4.50374 6.47961 5.1875 6.47961C5.87126 6.47961 6.52702 6.20799 7.01051 5.7245C7.494 5.24101 7.76563 4.58525 7.76562 3.90149C7.76563 3.21773 7.494 2.56197 7.01051 2.07848C6.52702 1.59499 5.87126 1.32336 5.1875 1.32336C4.50374 1.32336 3.84798 1.59499 3.36449 2.07848C2.881 2.56197 2.60938 3.21773 2.60938 3.90149Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8.83627 9.55399C8.37873 8.7439 7.66548 8.1084 6.80818 7.74697C5.95088 7.38553 4.99794 7.31858 4.09852 7.55658C3.19911 7.79458 2.404 8.3241 1.83767 9.06225C1.27135 9.80039 0.965765 10.7055 0.968772 11.6359", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17349_730" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), JJ = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M8.00049 3.19836V10.6984", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M5.18799 7.88586L8.00049 10.6984L10.813 7.88586", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M15.0317 10.6984V11.6359C15.0317 12.1331 14.8342 12.6101 14.4826 12.9617C14.1309 13.3133 13.654 13.5109 13.1567 13.5109H2.84424C2.34696 13.5109 1.87004 13.3133 1.51841 12.9617C1.16678 12.6101 0.969238 12.1331 0.969238 11.6359V10.6984", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), eee = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17349_740)" }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip1_17349_740)" }, /* @__PURE__ */ d.createElement("path", { d: "M10.0622 11.5156V8L14.93 3.13221C15.2004 2.86178 15.2905 2.59134 15.2905 2.23077C15.2905 1.50961 14.7497 0.96875 14.0285 0.96875H2.49005C1.7689 0.96875 1.22803 1.50961 1.22803 2.23077C1.22803 2.59134 1.31818 2.86178 1.58861 3.13221L6.4564 8V15.0312L10.0622 11.5156Z", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }))), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17349_740" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })), /* @__PURE__ */ d.createElement("clipPath", { id: "clip1_17349_740" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0.259277)" })))), tee = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17349_741)" }, /* @__PURE__ */ d.createElement("path", { d: "M1.94629 4.40428L6.36383 8.8218V15.2027L9.63608 12.0123V11.7451M9.63608 9.91124V8.8218L14.0536 4.40428C14.299 4.15886 14.3808 3.91345 14.3808 3.58622C14.3808 2.93177 13.89 2.44093 13.2356 2.44093H2.76435C2.60741 2.44093 2.45988 2.46916 2.32626 2.5211", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M0.96875 1.32336L15.0312 15.3859", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17349_741" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), nee = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M7.99995 4.1365C5.48058 4.094 2.87495 5.85462 1.23683 7.65775C1.06488 7.84864 0.969727 8.09645 0.969727 8.35337C0.969727 8.61029 1.06488 8.8581 1.23683 9.049C2.83933 10.814 5.43745 12.6152 7.99995 12.5721C10.5625 12.6152 13.1612 10.814 14.765 9.049C14.9369 8.8581 15.0321 8.61029 15.0321 8.35337C15.0321 8.09645 14.9369 7.84864 14.765 7.65775C13.125 5.85462 10.5193 4.094 7.99995 4.1365Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M10.3438 8.35461C10.3436 8.81814 10.2061 9.27122 9.94845 9.65656C9.69084 10.0419 9.32476 10.3422 8.89648 10.5195C8.46821 10.6968 7.99698 10.7431 7.54237 10.6526C7.08777 10.5621 6.67022 10.3389 6.3425 10.011C6.01478 9.68325 5.79162 9.26563 5.70124 8.811C5.61086 8.35638 5.65731 7.88516 5.83472 7.45693C6.01213 7.0287 6.31253 6.6627 6.69795 6.40519C7.08336 6.14768 7.53648 6.01024 8 6.01024C8.30786 6.01016 8.61272 6.07074 8.89716 6.18854C9.18159 6.30633 9.44003 6.47903 9.65769 6.69674C9.87535 6.91446 10.048 7.17294 10.1657 7.45741C10.2834 7.74188 10.3439 8.04675 10.3438 8.35461Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), ree = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M1.09298 8.74024C1.0122 8.62788 0.96875 8.49299 0.96875 8.35461C0.96875 8.21623 1.0122 8.08135 1.09298 7.96899C1.84048 6.92774 4.19861 4.13586 7.99986 4.13586C11.8011 4.13586 14.1592 6.92774 14.9067 7.96899C14.9875 8.08135 15.031 8.21623 15.031 8.35461C15.031 8.49299 14.9875 8.62788 14.9067 8.74024C14.1592 9.78211 11.8011 12.5734 7.99986 12.5734C4.19861 12.5734 1.84048 9.78211 1.09298 8.74024Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M11.3169 4.89961L4.68311 11.8096", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M10.3438 8.35461C10.3437 8.97622 10.0968 9.57236 9.65728 10.0119C9.21774 10.4514 8.6216 10.6984 8 10.6984", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M5.65625 8.35461C5.65625 7.73301 5.90318 7.13687 6.34272 6.69733C6.78226 6.25779 7.3784 6.01086 8 6.01086", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), oee = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17390_169)" }, /* @__PURE__ */ d.createElement("path", { d: "M7.99998 9.69398C7.99998 11.2036 7.4003 12.6513 6.33287 13.7187C5.26544 14.7862 3.81768 15.3859 2.30811 15.3859", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M13.6919 15.3859C12.1823 15.3859 10.7345 14.7862 9.66711 13.7187C8.59968 12.6513 8 11.2036 8 9.69398", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8 9.69399V1.32336", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M3.98193 5.34149L8.00006 1.32336L12.0182 5.34149", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17390_169" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), iee = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17349_744)" }, /* @__PURE__ */ d.createElement("path", { d: "M8 10.8546C8 8.09143 5.49288 3.31514 1.125 1.47961", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8 10.8546C8 8.09143 10.5071 3.31514 14.875 1.47961", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8 10.8546V15.2296", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M1.125 6.47961V1.47961H6.125", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M14.875 6.47961V1.47961H9.875", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17349_744" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), aee = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17870_3816)" }, /* @__PURE__ */ d.createElement("path", { d: "M12.6875 5.38586H14.4062C14.7514 5.38586 15.0312 5.66569 15.0312 6.01086V14.7609C15.0312 15.1061 14.7514 15.3859 14.4062 15.3859H5.65625C5.31107 15.3859 5.03125 15.1061 5.03125 14.7609V13.0421", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M0.96875 1.94836C0.96875 1.60318 1.24858 1.32336 1.59375 1.32336H10.3438C10.6889 1.32336 10.9688 1.60319 10.9688 1.94836V10.6984C10.9688 11.0436 10.6889 11.3234 10.3438 11.3234H1.59375C1.24857 11.3234 0.96875 11.0436 0.96875 10.6984V1.94836Z", stroke: "currentColor", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17870_3816" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), see = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17982_2694)" }, /* @__PURE__ */ d.createElement("path", { d: "M4.25 9.11899L5.78125 11.2921C5.83933 11.3789 5.9173 11.4505 6.00865 11.5011C6.10001 11.5516 6.20212 11.5796 6.30648 11.5827C6.41084 11.5858 6.51444 11.564 6.60865 11.519C6.70286 11.474 6.78497 11.4071 6.84812 11.324L11.75 5.12211", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M0.96875 8.35399C0.96875 10.2188 1.70954 12.0072 3.02816 13.3258C4.34677 14.6444 6.1352 15.3852 8 15.3852C9.8648 15.3852 11.6532 14.6444 12.9718 13.3258C14.2905 12.0072 15.0312 10.2188 15.0312 8.35399C15.0312 6.48919 14.2905 4.70076 12.9718 3.38214C11.6532 2.06353 9.8648 1.32274 8 1.32274C6.1352 1.32274 4.34677 2.06353 3.02816 3.38214C1.70954 4.70076 0.96875 6.48919 0.96875 8.35399Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17982_2694" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), lee = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17982_2695)" }, /* @__PURE__ */ d.createElement("path", { d: "M8 11.6359C7.87056 11.6359 7.76562 11.5309 7.76562 11.4015C7.76562 11.2721 7.87056 11.1671 8 11.1671", stroke: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M8 11.6359C8.12944 11.6359 8.23438 11.5309 8.23438 11.4015C8.23438 11.2721 8.12944 11.1671 8 11.1671", stroke: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M8 9.29211V4.13586", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8 15.3859C11.8832 15.3859 15.0312 12.2379 15.0312 8.35461C15.0312 4.47136 11.8832 1.32336 8 1.32336C4.11675 1.32336 0.96875 4.47136 0.96875 8.35461C0.96875 12.2379 4.11675 15.3859 8 15.3859Z", stroke: "currentColor", strokeMiterlimit: 10 })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17982_2695" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), cee = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_18077_259)" }, /* @__PURE__ */ d.createElement("path", { d: "M13.1562 12.5734V13.5109C13.1562 13.7595 13.0575 13.998 12.8817 14.1738C12.7059 14.3496 12.4674 14.4484 12.2188 14.4484H9.40625", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.40625 3.19836H12.2188C12.4674 3.19836 12.7059 3.29714 12.8817 3.47295C13.0575 3.64876 13.1562 3.88723 13.1562 4.13586V5.07336", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M6.99375 15.3796L1.36877 14.6046C1.25672 14.588 1.15446 14.5314 1.08093 14.4452C1.00739 14.359 0.967553 14.2491 0.968777 14.1359V3.17959C0.970574 3.07401 1.00796 2.97213 1.07489 2.89046C1.14182 2.80878 1.23436 2.7521 1.33752 2.72959L6.9625 1.34209C7.03081 1.32718 7.10156 1.32773 7.16962 1.3437C7.23769 1.35967 7.30131 1.39067 7.35588 1.43441C7.41038 1.47815 7.45444 1.53353 7.48481 1.5965C7.51513 1.65948 7.531 1.72844 7.53125 1.79834V14.9234C7.53125 14.9904 7.51663 15.0567 7.4885 15.1176C7.46031 15.1784 7.41919 15.2324 7.36806 15.2758C7.31694 15.3192 7.257 15.351 7.19238 15.3689C7.12769 15.3868 7.05994 15.3905 6.99375 15.3796Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M13.1562 6.94836L15.0312 8.82336H9.875", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M13.1562 10.6984L15.0312 8.82336", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M5.10938 8.56974C4.97993 8.56974 4.875 8.4648 4.875 8.33537C4.875 8.20593 4.97993 8.10099 5.10938 8.10099", stroke: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M5.10938 8.56974C5.23882 8.56974 5.34375 8.4648 5.34375 8.33537C5.34375 8.20593 5.23882 8.10099 5.10938 8.10099", stroke: "currentColor" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_18077_259" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), uee = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M5.05347 15.1012H10.7832", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M12.1558 7.46469C12.1558 9.79291 10.2932 11.6555 7.96498 11.6555C5.63675 11.6555 3.77417 9.79291 3.77417 7.46469V2.80824H12.1558V7.46469Z", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M7.96509 11.6555V15.1012", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M12.415 3.98359C13.7893 3.98359 14.8691 5.00801 14.8691 6.31181C14.8691 7.61562 13.7893 8.64003 12.415 8.64003", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M3.77685 3.98359C2.40256 3.98359 1.32275 5.00801 1.32275 6.31181C1.32275 7.61562 2.40256 8.64003 3.77685 8.64003", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" })), dee = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_18122_224)" }, /* @__PURE__ */ d.createElement("path", { d: "M15.0312 15.3951C14.4843 15.2574 13.9932 14.9542 13.625 14.527C13.4 14.8108 13.1155 15.0418 12.7915 15.2038C12.4676 15.3658 12.1121 15.4548 11.75 15.4645V15.4476C11.391 15.4311 11.0393 15.3408 10.7167 15.1824C10.3941 15.024 10.1076 14.8009 9.875 14.527C9.64999 14.8108 9.3655 15.0418 9.04154 15.2038C8.71759 15.3658 8.36206 15.4548 8 15.4645V15.4476C7.64101 15.4311 7.28927 15.3408 6.96669 15.1824C6.6441 15.024 6.35759 14.8009 6.125 14.527C5.89999 14.8108 5.6155 15.0418 5.29154 15.2038C4.96759 15.3658 4.61206 15.4548 4.25 15.4645V15.4476C3.89101 15.4311 3.53927 15.3408 3.21669 15.1824C2.8941 15.024 2.60759 14.8009 2.375 14.527C2.01875 14.9718 1.52359 15.2843 0.96875 15.4145", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M5.86742 13.1207V12.1326C5.54532 11.8911 5.28385 11.5779 5.10367 11.2179C4.9235 10.8578 4.82956 10.4608 4.82929 10.0582V8.8251C4.82887 8.49463 4.76523 8.16728 4.64179 7.86073L3.33992 4.6026C3.27169 4.43164 3.26426 4.24243 3.31888 4.06665C3.37349 3.89087 3.48683 3.73918 3.63992 3.63698C3.73463 3.57392 3.84165 3.53171 3.95391 3.51314C4.06616 3.49456 4.18108 3.50006 4.29105 3.52925C4.40103 3.55844 4.50354 3.61067 4.59181 3.68247C4.68007 3.75427 4.75207 3.844 4.80304 3.94573L6.12492 6.59448L5.42804 3.10073C5.38315 2.8761 5.42647 2.64281 5.54902 2.44928C5.67156 2.25575 5.86392 2.11683 6.08617 2.06135C6.20296 2.03219 6.32446 2.02699 6.44332 2.04606C6.56218 2.06514 6.67594 2.1081 6.77775 2.17235C6.87955 2.23659 6.96728 2.3208 7.03565 2.41988C7.10402 2.51897 7.15161 2.63087 7.17554 2.74885L7.85804 6.15948V2.2676C7.85804 2.03813 7.94916 1.81805 8.11136 1.65573C8.27356 1.49342 8.49357 1.40214 8.72304 1.40198C8.95262 1.40198 9.17279 1.49318 9.33513 1.65551C9.49747 1.81785 9.58867 2.03802 9.58867 2.2676V6.16198L10.2662 2.77573C10.2904 2.65432 10.339 2.53909 10.4091 2.43703C10.4792 2.33497 10.5692 2.24821 10.6738 2.182C10.7784 2.11578 10.8954 2.0715 11.0176 2.05184C11.1399 2.03218 11.2648 2.03754 11.3849 2.0676C11.6043 2.12253 11.7955 2.2568 11.9217 2.44449C12.0479 2.63218 12.1 2.85997 12.068 3.08385L11.318 8.3251L12.7443 7.46948C12.943 7.35025 13.18 7.31211 13.4061 7.36296C13.6323 7.41382 13.8301 7.54977 13.9587 7.7426C14.0698 7.90922 14.1223 8.10812 14.1078 8.30788C14.0933 8.50764 14.0127 8.69688 13.8787 8.84573L11.2262 11.7926V13.1207", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_18122_224" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.433228)" })))), fee = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_18122_223)" }, /* @__PURE__ */ d.createElement("path", { d: "M7.12492 7.27261C7.55437 7.78478 7.81639 8.41635 7.87562 9.08211C7.93486 9.74788 7.78845 10.4158 7.45617 10.9957C7.162 11.0185 6.87018 10.9286 6.63974 10.7444C6.4093 10.5601 6.25746 10.2952 6.21492 10.0032C5.77443 10.2439 5.41188 10.6055 5.16994 11.0453C4.92801 11.4851 4.81676 11.9848 4.84929 12.4857C4.84929 12.877 4.92636 13.2644 5.07609 13.6258C5.22583 13.9872 5.4453 14.3156 5.72197 14.5922C5.99864 14.8689 6.32708 15.0883 6.68855 15.2379C7.05003 15.3876 7.43744 15.4646 7.82867 15.4645C8.61536 15.4538 9.36683 15.1365 9.92316 14.5802C10.4795 14.0239 10.7967 13.2724 10.8074 12.4857C10.9174 9.54761 9.21117 7.95511 7.12492 7.27261Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M13.3857 5.15135H13.1563L11.5113 7.2076C10.8879 5.30779 10.9677 3.24722 11.7363 1.40135C10.3041 1.47394 8.91445 1.91309 7.70059 2.67673C6.48672 3.44038 5.48929 4.50293 4.80383 5.7626L3.31258 4.30823C2.44081 5.19794 1.84026 6.31738 1.58111 7.53574C1.32195 8.75411 1.41489 10.0211 1.84907 11.1886C2.28325 12.3561 3.04074 13.3759 4.03301 14.1288C5.02528 14.8818 6.21135 15.3368 7.45263 15.4407C8.69391 15.5446 9.93912 15.2931 11.0428 14.7156C12.1464 14.138 13.0629 13.2583 13.6851 12.1792C14.3073 11.1002 14.6096 9.86629 14.5566 8.6218C14.5035 7.37731 14.0974 6.1736 13.3857 5.15135Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_18122_223" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.433228)" })))), hee = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17349_735)" }, /* @__PURE__ */ d.createElement("path", { d: "M7.53125 13.5109L9.40625 15.3859L11.2812 13.5109", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.40625 15.3859V9.76086", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M11.2812 11.6359L13.1562 9.76086L15.0312 11.6359", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M13.1562 9.76086V15.3859", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M5.27169 14.2602L0.96875 15.3859L2.09126 11.0711M5.27169 14.2602L2.09126 11.0711M5.27169 14.2602L5.83294 13.6974M2.09126 11.0711L11.1337 2.00362C12.0068 1.12815 13.4411 1.06561 14.3764 2.00362C15.2495 2.8791 15.2495 4.31735 14.3764 5.25536L11.7207 7.91105M10.8842 2.25374L14.1315 5.50101M12.5075 7.12436L9.26281 3.87968", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17349_735" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), mee = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M0.648926 8.72791C0.648926 10.3104 1.27757 11.8281 2.39656 12.9471C3.51555 14.0661 5.03323 14.6947 6.61572 14.6947C8.19822 14.6947 9.71589 14.0661 10.8349 12.9471C11.9539 11.8281 12.5825 10.3104 12.5825 8.72791C12.5825 7.14541 11.9539 5.62773 10.8349 4.50874C9.71589 3.38975 8.19822 2.76111 6.61572 2.76111C5.03323 2.76111 3.51555 3.38975 2.39656 4.50874C1.27757 5.62773 0.648926 7.14541 0.648926 8.72791Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M11.3574 3.17988C12.1085 3.47713 12.7986 3.92659 13.3808 4.5088C14.4998 5.6278 15.1284 7.14547 15.1284 8.72797C15.1284 10.3105 14.4998 11.8281 13.3808 12.9471C12.7986 13.5293 12.1085 13.9788 11.3574 14.2761", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M3.83105 7.53455C3.83105 8.27304 4.12442 8.98129 4.64662 9.50349C5.16881 10.0257 5.87706 10.3191 6.61556 10.3191C7.35406 10.3191 8.06231 10.0257 8.5845 9.50349C9.1067 8.98129 9.40007 8.27304 9.40007 7.53455C9.40007 6.79605 9.1067 6.0878 8.5845 5.5656C8.06231 5.04341 7.35406 4.75004 6.61556 4.75004C5.87706 4.75004 5.16881 5.04341 4.64662 5.5656C4.12442 6.0878 3.83105 6.79605 3.83105 7.53455Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M10.2823 13.4357C9.80187 12.9523 9.2306 12.5686 8.60135 12.3068C7.9721 12.045 7.29729 11.9102 6.61575 11.9102C5.93421 11.9102 5.2594 12.045 4.63015 12.3068C4.0009 12.5686 3.42963 12.9523 2.94922 13.4357", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), pee = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_18698_80)" }, /* @__PURE__ */ d.createElement("path", { d: "M8.00122 11.634V15.384", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8.00122 1.32149V5.07149", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M4.71997 8.35274H0.969971", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M15.0325 8.35274H11.2825", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M2.84497 8.35336C2.84497 9.03049 2.97834 9.70099 3.23747 10.3266C3.49659 10.9522 3.8764 11.5206 4.3552 11.9994C4.834 12.4782 5.40242 12.858 6.02801 13.1171C6.65359 13.3762 7.32409 13.5096 8.00122 13.5096C8.67835 13.5096 9.34885 13.3762 9.97443 13.1171C10.6 12.858 11.1684 12.4782 11.6472 11.9994C12.126 11.5206 12.5058 10.9522 12.765 10.3266C13.0241 9.70099 13.1575 9.03049 13.1575 8.35336C13.1575 6.98584 12.6142 5.67433 11.6472 4.70735C10.6803 3.74036 9.36874 3.19711 8.00122 3.19711C6.6337 3.19711 5.32219 3.74036 4.3552 4.70735C3.38822 5.67433 2.84497 6.98584 2.84497 8.35336Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_18698_80" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), gee = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_18144_258)" }, /* @__PURE__ */ d.createElement("path", { d: "M8.46875 1.32336C7.30187 1.32407 6.15631 1.6362 5.15035 2.22751C4.14439 2.81883 3.31447 3.66791 2.74627 4.68711C2.17806 5.70631 1.89217 6.85869 1.9181 8.02528C1.94402 9.19188 2.28083 10.3304 2.89375 11.3234L0.96875 15.3859L5.0125 13.4609C5.8754 13.9967 6.85092 14.325 7.86224 14.4197C8.87356 14.5145 9.89307 14.3732 10.8405 14.007C11.7879 13.6408 12.6374 13.0597 13.3221 12.3094C14.0068 11.5591 14.508 10.6601 14.7861 9.68314C15.0643 8.70622 15.1119 7.67807 14.9252 6.67963C14.7385 5.68118 14.3226 4.73971 13.7102 3.92933C13.0978 3.11894 12.3057 2.46178 11.3961 2.00958C10.4866 1.55737 9.4845 1.32247 8.46875 1.32336Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.875 7.41711C9.99932 7.41711 10.1185 7.36773 10.2065 7.27982C10.2944 7.19191 10.3438 7.07268 10.3438 6.94836C10.3438 6.82404 10.2944 6.70482 10.2065 6.61691C10.1185 6.529 9.99932 6.47961 9.875 6.47961C9.75068 6.47961 9.63145 6.529 9.54354 6.61691C9.45564 6.70482 9.40625 6.82404 9.40625 6.94836C9.40625 7.07268 9.45564 7.19191 9.54354 7.27982C9.63145 7.36773 9.75068 7.41711 9.875 7.41711Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.98145 9.45462C10.2695 9.32215 10.516 9.11365 10.6944 8.85155C10.8728 8.58946 10.9764 8.28368 10.9939 7.96712C10.9939 7.34212 10.6752 6.55461 9.9502 6.48586", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M6.6001 7.41711C6.72442 7.41711 6.84365 7.36773 6.93155 7.27982C7.01946 7.19191 7.06885 7.07268 7.06885 6.94836C7.06885 6.82404 7.01946 6.70482 6.93155 6.61691C6.84365 6.529 6.72442 6.47961 6.6001 6.47961C6.47578 6.47961 6.35655 6.529 6.26864 6.61691C6.18073 6.70482 6.13135 6.82404 6.13135 6.94836C6.13135 7.07268 6.18073 7.19191 6.26864 7.27982C6.35655 7.36773 6.47578 7.41711 6.6001 7.41711Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M6.7002 9.45462C6.98825 9.32215 7.23473 9.11365 7.41313 8.85155C7.59154 8.58946 7.6951 8.28368 7.7127 7.96712C7.7127 7.34212 7.39395 6.55461 6.66895 6.48586", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_18144_258" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), vee = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M8.00049 10.6984V3.19836", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M10.813 6.01086L8.00049 3.19836L5.18799 6.01086", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M15.0317 10.6984V11.6359C15.0317 12.1331 14.8342 12.6101 14.4826 12.9617C14.1309 13.3133 13.654 13.5109 13.1567 13.5109H2.84424C2.34696 13.5109 1.87004 13.3133 1.51841 12.9617C1.16678 12.6101 0.969238 12.1331 0.969238 11.6359V10.6984", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), YP = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17982_2708)" }, /* @__PURE__ */ d.createElement("path", { d: "M1.42001 9.20272C1.71096 9.88732 2.1339 10.5079 2.66468 11.0291C3.19546 11.5502 3.8237 11.9617 4.51351 12.2401C5.20332 12.5184 5.94121 12.6582 6.68504 12.6513C7.42886 12.6445 8.16406 12.4913 8.84866 12.2003C9.53326 11.9094 10.1538 11.4864 10.675 10.9557C11.1961 10.4249 11.6076 9.79664 11.886 9.10682C12.1643 8.41701 12.3041 7.67912 12.2973 6.9353C12.2905 6.19147 12.1372 5.45627 11.8462 4.77167C11.5553 4.08708 11.1324 3.46649 10.6016 2.94534C10.0708 2.42419 9.44257 2.0127 8.75275 1.73434C8.06294 1.45599 7.32505 1.31623 6.58123 1.32305C5.8374 1.32986 5.1022 1.48312 4.4176 1.77406C3.733 2.06501 3.11242 2.48795 2.59127 3.01874C2.07013 3.54952 1.65863 4.17775 1.38028 4.86757C1.10193 5.55738 0.96217 6.29527 0.968988 7.0391C0.975805 7.78292 1.12906 8.51812 1.42001 9.20272Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M10.6382 10.9921L15.0313 15.3859", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17982_2708" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), Qv = xP;
Qv.displayName = "LBDropdownMenu";
const Jv = _P;
Jv.displayName = "LBDropdownMenuTrigger";
const GP = SP;
GP.displayName = "LBDropdownMenuGroup";
const KP = Yv;
KP.displayName = "LBDropdownMenuPortal";
const ZP = RP;
ZP.displayName = "LBDropdownMenuSub";
const eb = TP;
eb.displayName = "LBDropdownMenuRadioGroup";
const XP = d.forwardRef(({ children: e, className: t, ...n }, r) => /* @__PURE__ */ ie(
  AP,
  {
    ref: r,
    ...n,
    className: Q(
      "flex cursor-default select-none items-center gap-2 py-1 px-3 text-sm outline-none focus:bg-secondary data-[state=open]:bg-secondary [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      t
    ),
    style: void 0,
    children: [
      e,
      /* @__PURE__ */ b(Xv, { className: "ml-auto" })
    ]
  }
));
XP.displayName = "LBDropdownMenuSubContent";
const QP = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  OP,
  {
    ref: n,
    ...t,
    className: Q(
      "rounded-md z-50 min-w-[8rem] overflow-hidden border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    style: void 0
  }
));
QP.displayName = "LBDropdownMenuSubContent";
const tb = d.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ b(Yv, { children: /* @__PURE__ */ b(
  kP,
  {
    ref: r,
    sideOffset: t,
    ...n,
    className: Q(
      "rounded-md z-50 min-w-[8rem] overflow-hidden border bg-popover p-1 text-popover-foreground shadow-md",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    style: void 0
  }
) }));
tb.displayName = "LBDropdownMenuContent";
const JP = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  EP,
  {
    ref: n,
    ...t,
    className: Q(
      "relative flex cursor-default select-none items-center gap-2 py-1 px-3 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&>svg]:size-4",
      e
    ),
    style: void 0
  }
));
JP.displayName = "LBDropdownMenuItem";
const eR = d.forwardRef(({ children: e, checked: t, className: n, ...r }, o) => /* @__PURE__ */ ie(
  LP,
  {
    ref: o,
    ...r,
    className: Q(
      "relative flex cursor-default select-none items-center py-1 pl-8 pr-3 text-sm outline-none transition-colors focus:bg-secondary focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      n
    ),
    checked: t,
    children: [
      /* @__PURE__ */ b("span", { className: "absolute left-3 flex size-3 items-center justify-center", children: /* @__PURE__ */ b(Y9, { children: /* @__PURE__ */ b(U0, { className: "size-4" }) }) }),
      e
    ]
  }
));
eR.displayName = "LBDropdownMenuCheckboxItem";
const tR = d.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ ie(
  Gv,
  {
    ref: r,
    ...n,
    className: Q(
      "relative flex cursor-default select-none items-center py-1 pl-8 pr-3 text-sm outline-none transition-colors focus:bg-secondary focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    style: void 0,
    children: [
      /* @__PURE__ */ b("span", { className: "absolute left-3 flex size-3 items-center justify-center", children: /* @__PURE__ */ b(Y9, { children: /* @__PURE__ */ b(G9, { className: "size-2 fill-current" }) }) }),
      t
    ]
  }
));
tR.displayName = "LBDropdownMenuRadioItem";
const nR = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  MP,
  {
    ref: n,
    ...t,
    className: Q("p-2 text-sm font-semibold", e),
    style: void 0
  }
));
nR.displayName = "LBDropdownMenuItem";
const rR = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  PP,
  {
    ref: n,
    ...t,
    className: Q("my-2 h-[1px] bg-secondary", e),
    style: void 0
  }
));
rR.displayName = "LBDropdownMenuSeparator";
function oR({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ b(
    "span",
    {
      ...t,
      className: Q("ml-auto text-xs tracking-widest opacity-60", e),
      style: void 0
    }
  );
}
oR.displayName = "LBDropdownMenuShortcut";
function z0(e) {
  const t = d.useRef({ value: e, previous: e });
  return d.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var Y0 = "Checkbox", [iR, bee] = Ot(Y0), [aR, K9] = iR(Y0);
function sR(e) {
  const {
    __scopeCheckbox: t,
    checked: n,
    children: r,
    defaultChecked: o,
    disabled: i,
    form: a,
    name: s,
    onCheckedChange: l,
    required: c,
    value: f = "on",
    // @ts-expect-error
    internal_do_not_use_render: u
  } = e, [h, m] = Jt({
    prop: n,
    defaultProp: o ?? !1,
    onChange: l,
    caller: Y0
  }), [g, p] = d.useState(null), [v, y] = d.useState(null), C = d.useRef(!1), w = g ? !!a || !!g.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), _ = {
    checked: h,
    disabled: i,
    setChecked: m,
    control: g,
    setControl: p,
    name: s,
    form: a,
    value: f,
    hasConsumerStoppedPropagationRef: C,
    required: c,
    defaultChecked: Ir(o) ? !1 : o,
    isFormControl: w,
    bubbleInput: v,
    setBubbleInput: y
  };
  return /* @__PURE__ */ b(
    aR,
    {
      scope: t,
      ..._,
      children: lR(u) ? u(_) : r
    }
  );
}
var nb = "CheckboxTrigger", rb = d.forwardRef(
  ({ __scopeCheckbox: e, onKeyDown: t, onClick: n, ...r }, o) => {
    const {
      control: i,
      value: a,
      disabled: s,
      checked: l,
      required: c,
      setControl: f,
      setChecked: u,
      hasConsumerStoppedPropagationRef: h,
      isFormControl: m,
      bubbleInput: g
    } = K9(nb, e), p = ke(o, f), v = d.useRef(l);
    return d.useEffect(() => {
      const y = i == null ? void 0 : i.form;
      if (y) {
        const C = () => u(v.current);
        return y.addEventListener("reset", C), () => y.removeEventListener("reset", C);
      }
    }, [i, u]), /* @__PURE__ */ b(
      ce.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": Ir(l) ? "mixed" : l,
        "aria-required": c,
        "data-state": sb(l),
        "data-disabled": s ? "" : void 0,
        disabled: s,
        value: a,
        ...r,
        ref: p,
        onKeyDown: ne(t, (y) => {
          y.key === "Enter" && y.preventDefault();
        }),
        onClick: ne(n, (y) => {
          u((C) => Ir(C) ? !0 : !C), g && m && (h.current = y.isPropagationStopped(), h.current || y.stopPropagation());
        })
      }
    );
  }
);
rb.displayName = nb;
var Z9 = d.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: n,
      name: r,
      checked: o,
      defaultChecked: i,
      required: a,
      disabled: s,
      value: l,
      onCheckedChange: c,
      form: f,
      ...u
    } = e;
    return /* @__PURE__ */ b(
      sR,
      {
        __scopeCheckbox: n,
        checked: o,
        defaultChecked: i,
        disabled: s,
        required: a,
        onCheckedChange: c,
        name: r,
        form: f,
        value: l,
        internal_do_not_use_render: ({ isFormControl: h }) => /* @__PURE__ */ ie(St, { children: [
          /* @__PURE__ */ b(
            rb,
            {
              ...u,
              ref: t,
              __scopeCheckbox: n
            }
          ),
          h && /* @__PURE__ */ b(
            ab,
            {
              __scopeCheckbox: n
            }
          )
        ] })
      }
    );
  }
);
Z9.displayName = Y0;
var ob = "CheckboxIndicator", X9 = d.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: n, forceMount: r, ...o } = e, i = K9(ob, n);
    return /* @__PURE__ */ b(
      Nt,
      {
        present: r || Ir(i.checked) || i.checked === !0,
        children: /* @__PURE__ */ b(
          ce.span,
          {
            "data-state": sb(i.checked),
            "data-disabled": i.disabled ? "" : void 0,
            ...o,
            ref: t,
            style: { pointerEvents: "none", ...e.style }
          }
        )
      }
    );
  }
);
X9.displayName = ob;
var ib = "CheckboxBubbleInput", ab = d.forwardRef(
  ({ __scopeCheckbox: e, ...t }, n) => {
    const {
      control: r,
      hasConsumerStoppedPropagationRef: o,
      checked: i,
      defaultChecked: a,
      required: s,
      disabled: l,
      name: c,
      value: f,
      form: u,
      bubbleInput: h,
      setBubbleInput: m
    } = K9(ib, e), g = ke(n, m), p = z0(i), v = $0(r);
    d.useEffect(() => {
      const C = h;
      if (!C) return;
      const w = window.HTMLInputElement.prototype, x = Object.getOwnPropertyDescriptor(
        w,
        "checked"
      ).set, k = !o.current;
      if (p !== i && x) {
        const S = new Event("click", { bubbles: k });
        C.indeterminate = Ir(i), x.call(C, Ir(i) ? !1 : i), C.dispatchEvent(S);
      }
    }, [h, p, i, o]);
    const y = d.useRef(Ir(i) ? !1 : i);
    return /* @__PURE__ */ b(
      ce.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: a ?? y.current,
        required: s,
        disabled: l,
        name: c,
        value: f,
        form: u,
        ...t,
        tabIndex: -1,
        ref: g,
        style: {
          ...t.style,
          ...v,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
ab.displayName = ib;
function lR(e) {
  return typeof e == "function";
}
function Ir(e) {
  return e === "indeterminate";
}
function sb(e) {
  return Ir(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
const cR = fe(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  Z9,
  {
    ref: n,
    ...t,
    style: void 0,
    className: Q(
      "peer size-4 shrink-0 rounded-sm border border-primary focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:enabled:hover:bg-indigo-500 data-[state=checked]:text-primary-foreground flex items-center justify-center enabled:hover:border-indigo-500",
      e
    ),
    children: /* @__PURE__ */ b(X9, { className: "flex items-center justify-center text-current", children: /* @__PURE__ */ b(U0, { className: "size-3" }) })
  }
));
cR.displayName = "LBCheckbox";
var G0 = "Switch", [uR, yee] = Ot(G0), [dR, fR] = uR(G0), lb = d.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: n,
      name: r,
      checked: o,
      defaultChecked: i,
      required: a,
      disabled: s,
      value: l = "on",
      onCheckedChange: c,
      form: f,
      ...u
    } = e, [h, m] = d.useState(null), g = ke(t, (w) => m(w)), p = d.useRef(!1), v = h ? f || !!h.closest("form") : !0, [y, C] = Jt({
      prop: o,
      defaultProp: i ?? !1,
      onChange: c,
      caller: G0
    });
    return /* @__PURE__ */ ie(dR, { scope: n, checked: y, disabled: s, children: [
      /* @__PURE__ */ b(
        ce.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": y,
          "aria-required": a,
          "data-state": fb(y),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: l,
          ...u,
          ref: g,
          onClick: ne(e.onClick, (w) => {
            C((_) => !_), v && (p.current = w.isPropagationStopped(), p.current || w.stopPropagation());
          })
        }
      ),
      v && /* @__PURE__ */ b(
        db,
        {
          control: h,
          bubbles: !p.current,
          name: r,
          value: l,
          checked: y,
          required: a,
          disabled: s,
          form: f,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
lb.displayName = G0;
var cb = "SwitchThumb", ub = d.forwardRef(
  (e, t) => {
    const { __scopeSwitch: n, ...r } = e, o = fR(cb, n);
    return /* @__PURE__ */ b(
      ce.span,
      {
        "data-state": fb(o.checked),
        "data-disabled": o.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
ub.displayName = cb;
var hR = "SwitchBubbleInput", db = d.forwardRef(
  ({
    __scopeSwitch: e,
    control: t,
    checked: n,
    bubbles: r = !0,
    ...o
  }, i) => {
    const a = d.useRef(null), s = ke(a, i), l = z0(n), c = $0(t);
    return d.useEffect(() => {
      const f = a.current;
      if (!f) return;
      const u = window.HTMLInputElement.prototype, m = Object.getOwnPropertyDescriptor(
        u,
        "checked"
      ).set;
      if (l !== n && m) {
        const g = new Event("click", { bubbles: r });
        m.call(f, n), f.dispatchEvent(g);
      }
    }, [l, n, r]), /* @__PURE__ */ b(
      "input",
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: n,
        ...o,
        tabIndex: -1,
        ref: s,
        style: {
          ...o.style,
          ...c,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
db.displayName = hR;
function fb(e) {
  return e ? "checked" : "unchecked";
}
var mR = lb, pR = ub;
const gR = fe((e, t) => /* @__PURE__ */ b(
  mR,
  {
    ...e,
    style: void 0,
    className: "peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input",
    ref: t,
    children: /* @__PURE__ */ b(pR, { className: "pointer-events-none block size-4 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0" })
  }
));
gR.displayName = "LBSwitch";
const vR = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  "div",
  {
    ref: n,
    ...t,
    style: void 0,
    className: Q(
      "size-full border bg-card text-card-foreground shadow",
      e
    )
  }
));
vR.displayName = "LBCard";
const bR = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  "div",
  {
    ref: n,
    ...t,
    style: void 0,
    className: Q("flex flex-col space-y-2 p-6", e)
  }
));
bR.displayName = "LBCardHeader";
const yR = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  "div",
  {
    ref: n,
    ...t,
    style: void 0,
    className: Q(
      "text-base font-semibold leading-none tracking-tight",
      e
    )
  }
));
yR.displayName = "LBCardTitle";
const CR = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  "div",
  {
    ref: n,
    ...t,
    style: void 0,
    className: Q("text-sm text-muted-foreground", e)
  }
));
CR.displayName = "LBCardDescription";
const wR = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  "div",
  {
    ref: n,
    ...t,
    style: void 0,
    className: Q("p-6 pt-0", e)
  }
));
wR.displayName = "LBCardContent";
const xR = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  "div",
  {
    ref: n,
    ...t,
    style: void 0,
    className: Q("flex items-center p-6 pt-0", e)
  }
));
xR.displayName = "LBCardFooter";
function T2(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
var hb = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), _R = "VisuallyHidden", mb = d.forwardRef(
  (e, t) => /* @__PURE__ */ b(
    ce.span,
    {
      ...e,
      ref: t,
      style: { ...hb, ...e.style }
    }
  )
);
mb.displayName = _R;
var kR = mb, SR = [" ", "Enter", "ArrowUp", "ArrowDown"], MR = [" ", "Enter"], fo = "Select", [K0, Z0, ER] = A0(fo), [ki, Cee] = Ot(fo, [
  ER,
  er
]), X0 = er(), [LR, Yr] = ki(fo), [TR, PR] = ki(fo), pb = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    value: a,
    defaultValue: s,
    onValueChange: l,
    dir: c,
    name: f,
    autoComplete: u,
    disabled: h,
    required: m,
    form: g
  } = e, p = X0(t), [v, y] = d.useState(null), [C, w] = d.useState(null), [_, x] = d.useState(!1), k = ko(c), [S, T] = Jt({
    prop: r,
    defaultProp: o ?? !1,
    onChange: i,
    caller: fo
  }), [L, R] = Jt({
    prop: a,
    defaultProp: s,
    onChange: l,
    caller: fo
  }), M = d.useRef(null), A = v ? g || !!v.closest("form") : !0, [O, I] = d.useState(/* @__PURE__ */ new Set()), W = Array.from(O).map((N) => N.props.value).join(";");
  return /* @__PURE__ */ b(wi, { ...p, children: /* @__PURE__ */ ie(
    LR,
    {
      required: m,
      scope: t,
      trigger: v,
      onTriggerChange: y,
      valueNode: C,
      onValueNodeChange: w,
      valueNodeHasChildren: _,
      onValueNodeHasChildrenChange: x,
      contentId: Tt(),
      value: L,
      onValueChange: R,
      open: S,
      onOpenChange: T,
      dir: k,
      triggerPointerDownPosRef: M,
      disabled: h,
      children: [
        /* @__PURE__ */ b(K0.Provider, { scope: t, children: /* @__PURE__ */ b(
          TR,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: d.useCallback((N) => {
              I((H) => new Set(H).add(N));
            }, []),
            onNativeOptionRemove: d.useCallback((N) => {
              I((H) => {
                const q = new Set(H);
                return q.delete(N), q;
              });
            }, []),
            children: n
          }
        ) }),
        A ? /* @__PURE__ */ ie(
          Wb,
          {
            "aria-hidden": !0,
            required: m,
            tabIndex: -1,
            name: f,
            autoComplete: u,
            value: L,
            onChange: (N) => R(N.target.value),
            disabled: h,
            form: g,
            children: [
              L === void 0 ? /* @__PURE__ */ b("option", { value: "" }) : null,
              Array.from(O)
            ]
          },
          W
        ) : null
      ]
    }
  ) });
};
pb.displayName = fo;
var gb = "SelectTrigger", vb = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: r = !1, ...o } = e, i = X0(n), a = Yr(gb, n), s = a.disabled || r, l = ke(t, a.onTriggerChange), c = Z0(n), f = d.useRef("touch"), [u, h, m] = jb((p) => {
      const v = c().filter((w) => !w.disabled), y = v.find((w) => w.value === a.value), C = Hb(v, p, y);
      C !== void 0 && a.onValueChange(C.value);
    }), g = (p) => {
      s || (a.onOpenChange(!0), m()), p && (a.triggerPointerDownPosRef.current = {
        x: Math.round(p.pageX),
        y: Math.round(p.pageY)
      });
    };
    return /* @__PURE__ */ b(xi, { asChild: !0, ...i, children: /* @__PURE__ */ b(
      ce.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": a.contentId,
        "aria-expanded": a.open,
        "aria-required": a.required,
        "aria-autocomplete": "none",
        dir: a.dir,
        "data-state": a.open ? "open" : "closed",
        disabled: s,
        "data-disabled": s ? "" : void 0,
        "data-placeholder": qb(a.value) ? "" : void 0,
        ...o,
        ref: l,
        onClick: ne(o.onClick, (p) => {
          p.currentTarget.focus(), f.current !== "mouse" && g(p);
        }),
        onPointerDown: ne(o.onPointerDown, (p) => {
          f.current = p.pointerType;
          const v = p.target;
          v.hasPointerCapture(p.pointerId) && v.releasePointerCapture(p.pointerId), p.button === 0 && p.ctrlKey === !1 && p.pointerType === "mouse" && (g(p), p.preventDefault());
        }),
        onKeyDown: ne(o.onKeyDown, (p) => {
          const v = u.current !== "";
          !(p.ctrlKey || p.altKey || p.metaKey) && p.key.length === 1 && h(p.key), !(v && p.key === " ") && SR.includes(p.key) && (g(), p.preventDefault());
        })
      }
    ) });
  }
);
vb.displayName = gb;
var bb = "SelectValue", yb = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, children: i, placeholder: a = "", ...s } = e, l = Yr(bb, n), { onValueNodeHasChildrenChange: c } = l, f = i !== void 0, u = ke(t, l.onValueNodeChange);
    return At(() => {
      c(f);
    }, [c, f]), /* @__PURE__ */ b(
      ce.span,
      {
        ...s,
        ref: u,
        style: { pointerEvents: "none" },
        children: qb(l.value) ? /* @__PURE__ */ b(St, { children: a }) : i
      }
    );
  }
);
yb.displayName = bb;
var RR = "SelectIcon", Cb = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: r, ...o } = e;
    return /* @__PURE__ */ b(ce.span, { "aria-hidden": !0, ...o, ref: t, children: r || "▼" });
  }
);
Cb.displayName = RR;
var AR = "SelectPortal", wb = (e) => /* @__PURE__ */ b(_i, { asChild: !0, ...e });
wb.displayName = AR;
var ho = "SelectContent", xb = d.forwardRef(
  (e, t) => {
    const n = Yr(ho, e.__scopeSelect), [r, o] = d.useState();
    if (At(() => {
      o(new DocumentFragment());
    }, []), !n.open) {
      const i = r;
      return i ? R0.createPortal(
        /* @__PURE__ */ b(_b, { scope: e.__scopeSelect, children: /* @__PURE__ */ b(K0.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ b("div", { children: e.children }) }) }),
        i
      ) : null;
    }
    return /* @__PURE__ */ b(kb, { ...e, ref: t });
  }
);
xb.displayName = ho;
var En = 10, [_b, Gr] = ki(ho), OR = "SelectContentImpl", NR = /* @__PURE__ */ $r("SelectContent.RemoveScroll"), kb = d.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: o,
      onEscapeKeyDown: i,
      onPointerDownOutside: a,
      //
      // PopperContent props
      side: s,
      sideOffset: l,
      align: c,
      alignOffset: f,
      arrowPadding: u,
      collisionBoundary: h,
      collisionPadding: m,
      sticky: g,
      hideWhenDetached: p,
      avoidCollisions: v,
      //
      ...y
    } = e, C = Yr(ho, n), [w, _] = d.useState(null), [x, k] = d.useState(null), S = ke(t, (V) => _(V)), [T, L] = d.useState(null), [R, M] = d.useState(
      null
    ), A = Z0(n), [O, I] = d.useState(!1), W = d.useRef(!1);
    d.useEffect(() => {
      if (w) return F0(w);
    }, [w]), N0();
    const N = d.useCallback(
      (V) => {
        const [Y, ...P] = A().map((E) => E.ref.current), [F] = P.slice(-1), z = document.activeElement;
        for (const E of V)
          if (E === z || (E == null || E.scrollIntoView({ block: "nearest" }), E === Y && x && (x.scrollTop = 0), E === F && x && (x.scrollTop = x.scrollHeight), E == null || E.focus(), document.activeElement !== z)) return;
      },
      [A, x]
    ), H = d.useCallback(
      () => N([T, w]),
      [N, T, w]
    );
    d.useEffect(() => {
      O && H();
    }, [O, H]);
    const { onOpenChange: q, triggerPointerDownPosRef: D } = C;
    d.useEffect(() => {
      if (w) {
        let V = { x: 0, y: 0 };
        const Y = (F) => {
          var z, E;
          V = {
            x: Math.abs(Math.round(F.pageX) - (((z = D.current) == null ? void 0 : z.x) ?? 0)),
            y: Math.abs(Math.round(F.pageY) - (((E = D.current) == null ? void 0 : E.y) ?? 0))
          };
        }, P = (F) => {
          V.x <= 10 && V.y <= 10 ? F.preventDefault() : w.contains(F.target) || q(!1), document.removeEventListener("pointermove", Y), D.current = null;
        };
        return D.current !== null && (document.addEventListener("pointermove", Y), document.addEventListener("pointerup", P, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", Y), document.removeEventListener("pointerup", P, { capture: !0 });
        };
      }
    }, [w, q, D]), d.useEffect(() => {
      const V = () => q(!1);
      return window.addEventListener("blur", V), window.addEventListener("resize", V), () => {
        window.removeEventListener("blur", V), window.removeEventListener("resize", V);
      };
    }, [q]);
    const [$, U] = jb((V) => {
      const Y = A().filter((z) => !z.disabled), P = Y.find((z) => z.ref.current === document.activeElement), F = Hb(Y, V, P);
      F && setTimeout(() => F.ref.current.focus());
    }), B = d.useCallback(
      (V, Y, P) => {
        const F = !W.current && !P;
        (C.value !== void 0 && C.value === Y || F) && (L(V), F && (W.current = !0));
      },
      [C.value]
    ), K = d.useCallback(() => w == null ? void 0 : w.focus(), [w]), X = d.useCallback(
      (V, Y, P) => {
        const F = !W.current && !P;
        (C.value !== void 0 && C.value === Y || F) && M(V);
      },
      [C.value]
    ), Z = r === "popper" ? P2 : Sb, G = Z === P2 ? {
      side: s,
      sideOffset: l,
      align: c,
      alignOffset: f,
      arrowPadding: u,
      collisionBoundary: h,
      collisionPadding: m,
      sticky: g,
      hideWhenDetached: p,
      avoidCollisions: v
    } : {};
    return /* @__PURE__ */ b(
      _b,
      {
        scope: n,
        content: w,
        viewport: x,
        onViewportChange: k,
        itemRefCallback: B,
        selectedItem: T,
        onItemLeave: K,
        itemTextRefCallback: X,
        focusSelectedItem: H,
        selectedItemText: R,
        position: r,
        isPositioned: O,
        searchRef: $,
        children: /* @__PURE__ */ b(Xa, { as: NR, allowPinchZoom: !0, children: /* @__PURE__ */ b(
          Ya,
          {
            asChild: !0,
            trapped: C.open,
            onMountAutoFocus: (V) => {
              V.preventDefault();
            },
            onUnmountAutoFocus: ne(o, (V) => {
              var Y;
              (Y = C.trigger) == null || Y.focus({ preventScroll: !0 }), V.preventDefault();
            }),
            children: /* @__PURE__ */ b(
              So,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: i,
                onPointerDownOutside: a,
                onFocusOutside: (V) => V.preventDefault(),
                onDismiss: () => C.onOpenChange(!1),
                children: /* @__PURE__ */ b(
                  Z,
                  {
                    role: "listbox",
                    id: C.contentId,
                    "data-state": C.open ? "open" : "closed",
                    dir: C.dir,
                    onContextMenu: (V) => V.preventDefault(),
                    ...y,
                    ...G,
                    onPlaced: () => I(!0),
                    ref: S,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...y.style
                    },
                    onKeyDown: ne(y.onKeyDown, (V) => {
                      const Y = V.ctrlKey || V.altKey || V.metaKey;
                      if (V.key === "Tab" && V.preventDefault(), !Y && V.key.length === 1 && U(V.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(V.key)) {
                        let F = A().filter((z) => !z.disabled).map((z) => z.ref.current);
                        if (["ArrowUp", "End"].includes(V.key) && (F = F.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(V.key)) {
                          const z = V.target, E = F.indexOf(z);
                          F = F.slice(E + 1);
                        }
                        setTimeout(() => N(F)), V.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
kb.displayName = OR;
var DR = "SelectItemAlignedPosition", Sb = d.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...o } = e, i = Yr(ho, n), a = Gr(ho, n), [s, l] = d.useState(null), [c, f] = d.useState(null), u = ke(t, (S) => f(S)), h = Z0(n), m = d.useRef(!1), g = d.useRef(!0), { viewport: p, selectedItem: v, selectedItemText: y, focusSelectedItem: C } = a, w = d.useCallback(() => {
    if (i.trigger && i.valueNode && s && c && p && v && y) {
      const S = i.trigger.getBoundingClientRect(), T = c.getBoundingClientRect(), L = i.valueNode.getBoundingClientRect(), R = y.getBoundingClientRect();
      if (i.dir !== "rtl") {
        const z = R.left - T.left, E = L.left - z, re = S.left - E, ee = S.width + re, oe = Math.max(ee, T.width), ue = window.innerWidth - En, le = T2(E, [
          En,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(En, ue - oe)
        ]);
        s.style.minWidth = ee + "px", s.style.left = le + "px";
      } else {
        const z = T.right - R.right, E = window.innerWidth - L.right - z, re = window.innerWidth - S.right - E, ee = S.width + re, oe = Math.max(ee, T.width), ue = window.innerWidth - En, le = T2(E, [
          En,
          Math.max(En, ue - oe)
        ]);
        s.style.minWidth = ee + "px", s.style.right = le + "px";
      }
      const M = h(), A = window.innerHeight - En * 2, O = p.scrollHeight, I = window.getComputedStyle(c), W = parseInt(I.borderTopWidth, 10), N = parseInt(I.paddingTop, 10), H = parseInt(I.borderBottomWidth, 10), q = parseInt(I.paddingBottom, 10), D = W + N + O + q + H, $ = Math.min(v.offsetHeight * 5, D), U = window.getComputedStyle(p), B = parseInt(U.paddingTop, 10), K = parseInt(U.paddingBottom, 10), X = S.top + S.height / 2 - En, Z = A - X, G = v.offsetHeight / 2, V = v.offsetTop + G, Y = W + N + V, P = D - Y;
      if (Y <= X) {
        const z = M.length > 0 && v === M[M.length - 1].ref.current;
        s.style.bottom = "0px";
        const E = c.clientHeight - p.offsetTop - p.offsetHeight, re = Math.max(
          Z,
          G + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (z ? K : 0) + E + H
        ), ee = Y + re;
        s.style.height = ee + "px";
      } else {
        const z = M.length > 0 && v === M[0].ref.current;
        s.style.top = "0px";
        const re = Math.max(
          X,
          W + p.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (z ? B : 0) + G
        ) + P;
        s.style.height = re + "px", p.scrollTop = Y - X + p.offsetTop;
      }
      s.style.margin = `${En}px 0`, s.style.minHeight = $ + "px", s.style.maxHeight = A + "px", r == null || r(), requestAnimationFrame(() => m.current = !0);
    }
  }, [
    h,
    i.trigger,
    i.valueNode,
    s,
    c,
    p,
    v,
    y,
    i.dir,
    r
  ]);
  At(() => w(), [w]);
  const [_, x] = d.useState();
  At(() => {
    c && x(window.getComputedStyle(c).zIndex);
  }, [c]);
  const k = d.useCallback(
    (S) => {
      S && g.current === !0 && (w(), C == null || C(), g.current = !1);
    },
    [w, C]
  );
  return /* @__PURE__ */ b(
    BR,
    {
      scope: n,
      contentWrapper: s,
      shouldExpandOnScrollRef: m,
      onScrollButtonChange: k,
      children: /* @__PURE__ */ b(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: _
          },
          children: /* @__PURE__ */ b(
            ce.div,
            {
              ...o,
              ref: u,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...o.style
              }
            }
          )
        }
      )
    }
  );
});
Sb.displayName = DR;
var IR = "SelectPopperPosition", P2 = d.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: o = En,
    ...i
  } = e, a = X0(n);
  return /* @__PURE__ */ b(
    Ka,
    {
      ...a,
      ...i,
      ref: t,
      align: r,
      collisionPadding: o,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...i.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
P2.displayName = IR;
var [BR, Q9] = ki(ho, {}), R2 = "SelectViewport", Mb = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: r, ...o } = e, i = Gr(R2, n), a = Q9(R2, n), s = ke(t, i.onViewportChange), l = d.useRef(0);
    return /* @__PURE__ */ ie(St, { children: [
      /* @__PURE__ */ b(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ b(K0.Slot, { scope: n, children: /* @__PURE__ */ b(
        ce.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...o,
          ref: s,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...o.style
          },
          onScroll: ne(o.onScroll, (c) => {
            const f = c.currentTarget, { contentWrapper: u, shouldExpandOnScrollRef: h } = a;
            if (h != null && h.current && u) {
              const m = Math.abs(l.current - f.scrollTop);
              if (m > 0) {
                const g = window.innerHeight - En * 2, p = parseFloat(u.style.minHeight), v = parseFloat(u.style.height), y = Math.max(p, v);
                if (y < g) {
                  const C = y + m, w = Math.min(g, C), _ = C - w;
                  u.style.height = w + "px", u.style.bottom === "0px" && (f.scrollTop = _ > 0 ? _ : 0, u.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = f.scrollTop;
          })
        }
      ) })
    ] });
  }
);
Mb.displayName = R2;
var Eb = "SelectGroup", [$R, FR] = ki(Eb), Lb = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = Tt();
    return /* @__PURE__ */ b($R, { scope: n, id: o, children: /* @__PURE__ */ b(ce.div, { role: "group", "aria-labelledby": o, ...r, ref: t }) });
  }
);
Lb.displayName = Eb;
var Tb = "SelectLabel", Pb = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = FR(Tb, n);
    return /* @__PURE__ */ b(ce.div, { id: o.id, ...r, ref: t });
  }
);
Pb.displayName = Tb;
var e0 = "SelectItem", [WR, Rb] = ki(e0), Ab = d.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: o = !1,
      textValue: i,
      ...a
    } = e, s = Yr(e0, n), l = Gr(e0, n), c = s.value === r, [f, u] = d.useState(i ?? ""), [h, m] = d.useState(!1), g = ke(
      t,
      (C) => {
        var w;
        return (w = l.itemRefCallback) == null ? void 0 : w.call(l, C, r, o);
      }
    ), p = Tt(), v = d.useRef("touch"), y = () => {
      o || (s.onValueChange(r), s.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ b(
      WR,
      {
        scope: n,
        value: r,
        disabled: o,
        textId: p,
        isSelected: c,
        onItemTextChange: d.useCallback((C) => {
          u((w) => w || ((C == null ? void 0 : C.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ b(
          K0.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: o,
            textValue: f,
            children: /* @__PURE__ */ b(
              ce.div,
              {
                role: "option",
                "aria-labelledby": p,
                "data-highlighted": h ? "" : void 0,
                "aria-selected": c && h,
                "data-state": c ? "checked" : "unchecked",
                "aria-disabled": o || void 0,
                "data-disabled": o ? "" : void 0,
                tabIndex: o ? void 0 : -1,
                ...a,
                ref: g,
                onFocus: ne(a.onFocus, () => m(!0)),
                onBlur: ne(a.onBlur, () => m(!1)),
                onClick: ne(a.onClick, () => {
                  v.current !== "mouse" && y();
                }),
                onPointerUp: ne(a.onPointerUp, () => {
                  v.current === "mouse" && y();
                }),
                onPointerDown: ne(a.onPointerDown, (C) => {
                  v.current = C.pointerType;
                }),
                onPointerMove: ne(a.onPointerMove, (C) => {
                  var w;
                  v.current = C.pointerType, o ? (w = l.onItemLeave) == null || w.call(l) : v.current === "mouse" && C.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: ne(a.onPointerLeave, (C) => {
                  var w;
                  C.currentTarget === document.activeElement && ((w = l.onItemLeave) == null || w.call(l));
                }),
                onKeyDown: ne(a.onKeyDown, (C) => {
                  var _;
                  ((_ = l.searchRef) == null ? void 0 : _.current) !== "" && C.key === " " || (MR.includes(C.key) && y(), C.key === " " && C.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
Ab.displayName = e0;
var oa = "SelectItemText", Ob = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, ...i } = e, a = Yr(oa, n), s = Gr(oa, n), l = Rb(oa, n), c = PR(oa, n), [f, u] = d.useState(null), h = ke(
      t,
      (y) => u(y),
      l.onItemTextChange,
      (y) => {
        var C;
        return (C = s.itemTextRefCallback) == null ? void 0 : C.call(s, y, l.value, l.disabled);
      }
    ), m = f == null ? void 0 : f.textContent, g = d.useMemo(
      () => /* @__PURE__ */ b("option", { value: l.value, disabled: l.disabled, children: m }, l.value),
      [l.disabled, l.value, m]
    ), { onNativeOptionAdd: p, onNativeOptionRemove: v } = c;
    return At(() => (p(g), () => v(g)), [p, v, g]), /* @__PURE__ */ ie(St, { children: [
      /* @__PURE__ */ b(ce.span, { id: l.textId, ...i, ref: h }),
      l.isSelected && a.valueNode && !a.valueNodeHasChildren ? R0.createPortal(i.children, a.valueNode) : null
    ] });
  }
);
Ob.displayName = oa;
var Nb = "SelectItemIndicator", Db = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return Rb(Nb, n).isSelected ? /* @__PURE__ */ b(ce.span, { "aria-hidden": !0, ...r, ref: t }) : null;
  }
);
Db.displayName = Nb;
var A2 = "SelectScrollUpButton", Ib = d.forwardRef((e, t) => {
  const n = Gr(A2, e.__scopeSelect), r = Q9(A2, e.__scopeSelect), [o, i] = d.useState(!1), a = ke(t, r.onScrollButtonChange);
  return At(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const c = l.scrollTop > 0;
        i(c);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ b(
    $b,
    {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
Ib.displayName = A2;
var O2 = "SelectScrollDownButton", Bb = d.forwardRef((e, t) => {
  const n = Gr(O2, e.__scopeSelect), r = Q9(O2, e.__scopeSelect), [o, i] = d.useState(!1), a = ke(t, r.onScrollButtonChange);
  return At(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const c = l.scrollHeight - l.clientHeight, f = Math.ceil(l.scrollTop) < c;
        i(f);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ b(
    $b,
    {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
Bb.displayName = O2;
var $b = d.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...o } = e, i = Gr("SelectScrollButton", n), a = d.useRef(null), s = Z0(n), l = d.useCallback(() => {
    a.current !== null && (window.clearInterval(a.current), a.current = null);
  }, []);
  return d.useEffect(() => () => l(), [l]), At(() => {
    var f;
    const c = s().find((u) => u.ref.current === document.activeElement);
    (f = c == null ? void 0 : c.ref.current) == null || f.scrollIntoView({ block: "nearest" });
  }, [s]), /* @__PURE__ */ b(
    ce.div,
    {
      "aria-hidden": !0,
      ...o,
      ref: t,
      style: { flexShrink: 0, ...o.style },
      onPointerDown: ne(o.onPointerDown, () => {
        a.current === null && (a.current = window.setInterval(r, 50));
      }),
      onPointerMove: ne(o.onPointerMove, () => {
        var c;
        (c = i.onItemLeave) == null || c.call(i), a.current === null && (a.current = window.setInterval(r, 50));
      }),
      onPointerLeave: ne(o.onPointerLeave, () => {
        l();
      })
    }
  );
}), qR = "SelectSeparator", Fb = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return /* @__PURE__ */ b(ce.div, { "aria-hidden": !0, ...r, ref: t });
  }
);
Fb.displayName = qR;
var N2 = "SelectArrow", jR = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = X0(n), i = Yr(N2, n), a = Gr(N2, n);
    return i.open && a.position === "popper" ? /* @__PURE__ */ b(Za, { ...o, ...r, ref: t }) : null;
  }
);
jR.displayName = N2;
var HR = "SelectBubbleInput", Wb = d.forwardRef(
  ({ __scopeSelect: e, value: t, ...n }, r) => {
    const o = d.useRef(null), i = ke(r, o), a = z0(t);
    return d.useEffect(() => {
      const s = o.current;
      if (!s) return;
      const l = window.HTMLSelectElement.prototype, f = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (a !== t && f) {
        const u = new Event("change", { bubbles: !0 });
        f.call(s, t), s.dispatchEvent(u);
      }
    }, [a, t]), /* @__PURE__ */ b(
      ce.select,
      {
        ...n,
        style: { ...hb, ...n.style },
        ref: i,
        defaultValue: t
      }
    );
  }
);
Wb.displayName = HR;
function qb(e) {
  return e === "" || e === void 0;
}
function jb(e) {
  const t = qt(e), n = d.useRef(""), r = d.useRef(0), o = d.useCallback(
    (a) => {
      const s = n.current + a;
      t(s), function l(c) {
        n.current = c, window.clearTimeout(r.current), c !== "" && (r.current = window.setTimeout(() => l(""), 1e3));
      }(s);
    },
    [t]
  ), i = d.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return d.useEffect(() => () => window.clearTimeout(r.current), []), [n, o, i];
}
function Hb(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((c) => c === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let a = VR(e, Math.max(i, 0));
  o.length === 1 && (a = a.filter((c) => c !== n));
  const l = a.find(
    (c) => c.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function VR(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var UR = pb, zR = vb, YR = yb, GR = Cb, Vb = wb, Ub = xb, zb = Mb, KR = Lb, ZR = Pb, Yb = Ab, Gb = Ob, XR = Db, QR = Ib, JR = Bb, eA = Fb;
const Kb = UR;
Kb.displayName = "LBSelect";
const tA = KR;
tA.displayName = "LBSelectGroup";
const Zb = YR;
Zb.displayName = "LBSelectValue";
const Xb = fe(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ ie(
  zR,
  {
    ref: r,
    ...n,
    style: void 0,
    className: Q(
      "flex h-9 items-center justify-between whitespace-nowrap rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1",
      e
    ),
    children: [
      t,
      /* @__PURE__ */ b(GR, { asChild: !0, children: /* @__PURE__ */ b(V0, { className: "ml-1 size-4 opacity-50" }) })
    ]
  }
));
Xb.displayName = "LBSelectTrigger";
const Qb = fe((e, t) => /* @__PURE__ */ b(
  QR,
  {
    ref: t,
    ...e,
    style: void 0,
    className: "flex cursor-default items-center justify-center py-1",
    children: /* @__PURE__ */ b(VP, { className: "size-4" })
  }
));
Qb.displayName = "LBSelectScrollUpButton";
const Jb = fe((e, t) => /* @__PURE__ */ b(
  JR,
  {
    ref: t,
    ...e,
    className: "flex cursor-default items-center justify-center py-1",
    children: /* @__PURE__ */ b(V0, { className: "size-4" })
  }
));
Jb.displayName = "LBSelectScrollDownButton";
const nA = fe(({ className: e, children: t, position: n = "popper", ...r }, o) => /* @__PURE__ */ b(Vb, { children: /* @__PURE__ */ ie(
  Ub,
  {
    ref: o,
    className: Q(
      "relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      e
    ),
    position: n,
    ...r,
    children: [
      /* @__PURE__ */ b(Qb, {}),
      /* @__PURE__ */ b(
        zb,
        {
          className: Q(
            "p-1",
            n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
          ),
          children: t
        }
      ),
      /* @__PURE__ */ b(Jb, {})
    ]
  }
) }));
nA.displayName = "LBSelectContent";
const rA = fe((e, t) => /* @__PURE__ */ b(
  ZR,
  {
    ref: t,
    ...e,
    style: void 0,
    className: "p-2 text-sm font-semibold"
  }
));
rA.displayName = "LBSelectLabel";
const oA = fe(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ ie(
  Yb,
  {
    ref: r,
    ...n,
    style: void 0,
    className: Q(
      "relative flex w-full cursor-default select-none items-center rounded-sm py-2 pl-2 pr-8 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    children: [
      /* @__PURE__ */ b("span", { className: "absolute right-2 flex size-4 items-center justify-center", children: /* @__PURE__ */ b(XR, { children: /* @__PURE__ */ b(U0, { className: "size-4" }) }) }),
      /* @__PURE__ */ b(Gb, { children: t })
    ]
  }
));
oA.displayName = "LBSelectItem";
const iA = fe((e, t) => /* @__PURE__ */ b(
  eA,
  {
    ref: t,
    className: "m-1 h-[1px] bg-muted",
    ...e
  }
));
iA.displayName = "LBSelectSeparator";
var Q0 = "Popover", [ey, wee] = Ot(Q0, [
  er
]), ns = er(), [aA, Kr] = ey(Q0), ty = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: a = !1
  } = e, s = ns(t), l = d.useRef(null), [c, f] = d.useState(!1), [u, h] = Jt({
    prop: r,
    defaultProp: o ?? !1,
    onChange: i,
    caller: Q0
  });
  return /* @__PURE__ */ b(wi, { ...s, children: /* @__PURE__ */ b(
    aA,
    {
      scope: t,
      contentId: Tt(),
      triggerRef: l,
      open: u,
      onOpenChange: h,
      onOpenToggle: d.useCallback(() => h((m) => !m), [h]),
      hasCustomAnchor: c,
      onCustomAnchorAdd: d.useCallback(() => f(!0), []),
      onCustomAnchorRemove: d.useCallback(() => f(!1), []),
      modal: a,
      children: n
    }
  ) });
};
ty.displayName = Q0;
var ny = "PopoverAnchor", ry = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = Kr(ny, n), i = ns(n), { onCustomAnchorAdd: a, onCustomAnchorRemove: s } = o;
    return d.useEffect(() => (a(), () => s()), [a, s]), /* @__PURE__ */ b(xi, { ...i, ...r, ref: t });
  }
);
ry.displayName = ny;
var oy = "PopoverTrigger", iy = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = Kr(oy, n), i = ns(n), a = ke(t, o.triggerRef), s = /* @__PURE__ */ b(
      ce.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": uy(o.open),
        ...r,
        ref: a,
        onClick: ne(e.onClick, o.onOpenToggle)
      }
    );
    return o.hasCustomAnchor ? s : /* @__PURE__ */ b(xi, { asChild: !0, ...i, children: s });
  }
);
iy.displayName = oy;
var J9 = "PopoverPortal", [sA, lA] = ey(J9, {
  forceMount: void 0
}), ay = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: o } = e, i = Kr(J9, t);
  return /* @__PURE__ */ b(sA, { scope: t, forceMount: n, children: /* @__PURE__ */ b(Nt, { present: n || i.open, children: /* @__PURE__ */ b(_i, { asChild: !0, container: o, children: r }) }) });
};
ay.displayName = J9;
var ai = "PopoverContent", sy = d.forwardRef(
  (e, t) => {
    const n = lA(ai, e.__scopePopover), { forceMount: r = n.forceMount, ...o } = e, i = Kr(ai, e.__scopePopover);
    return /* @__PURE__ */ b(Nt, { present: r || i.open, children: i.modal ? /* @__PURE__ */ b(uA, { ...o, ref: t }) : /* @__PURE__ */ b(dA, { ...o, ref: t }) });
  }
);
sy.displayName = ai;
var cA = /* @__PURE__ */ $r("PopoverContent.RemoveScroll"), uA = d.forwardRef(
  (e, t) => {
    const n = Kr(ai, e.__scopePopover), r = d.useRef(null), o = ke(t, r), i = d.useRef(!1);
    return d.useEffect(() => {
      const a = r.current;
      if (a) return F0(a);
    }, []), /* @__PURE__ */ b(Xa, { as: cA, allowPinchZoom: !0, children: /* @__PURE__ */ b(
      ly,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: ne(e.onCloseAutoFocus, (a) => {
          var s;
          a.preventDefault(), i.current || (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: ne(
          e.onPointerDownOutside,
          (a) => {
            const s = a.detail.originalEvent, l = s.button === 0 && s.ctrlKey === !0, c = s.button === 2 || l;
            i.current = c;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: ne(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), dA = d.forwardRef(
  (e, t) => {
    const n = Kr(ai, e.__scopePopover), r = d.useRef(!1), o = d.useRef(!1);
    return /* @__PURE__ */ b(
      ly,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var a, s;
          (a = e.onCloseAutoFocus) == null || a.call(e, i), i.defaultPrevented || (r.current || (s = n.triggerRef.current) == null || s.focus(), i.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          var l, c;
          (l = e.onInteractOutside) == null || l.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const a = i.target;
          ((c = n.triggerRef.current) == null ? void 0 : c.contains(a)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), ly = d.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: r,
      onOpenAutoFocus: o,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: a,
      onEscapeKeyDown: s,
      onPointerDownOutside: l,
      onFocusOutside: c,
      onInteractOutside: f,
      ...u
    } = e, h = Kr(ai, n), m = ns(n);
    return N0(), /* @__PURE__ */ b(
      Ya,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: o,
        onUnmountAutoFocus: i,
        children: /* @__PURE__ */ b(
          So,
          {
            asChild: !0,
            disableOutsidePointerEvents: a,
            onInteractOutside: f,
            onEscapeKeyDown: s,
            onPointerDownOutside: l,
            onFocusOutside: c,
            onDismiss: () => h.onOpenChange(!1),
            children: /* @__PURE__ */ b(
              Ka,
              {
                "data-state": uy(h.open),
                role: "dialog",
                id: h.contentId,
                ...m,
                ...u,
                ref: t,
                style: {
                  ...u.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), cy = "PopoverClose", fA = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = Kr(cy, n);
    return /* @__PURE__ */ b(
      ce.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: ne(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
fA.displayName = cy;
var hA = "PopoverArrow", mA = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = ns(n);
    return /* @__PURE__ */ b(Za, { ...o, ...r, ref: t });
  }
);
mA.displayName = hA;
function uy(e) {
  return e ? "open" : "closed";
}
var pA = ty, gA = ry, vA = iy, bA = ay, yA = sy;
const J0 = pA;
J0.displayName = "LBPopover";
const el = vA;
el.displayName = "LBPopoverTrigger";
const CA = gA;
CA.displayName = "LBPopoverAnchor";
const tl = fe(({ className: e, align: t = "center", sideOffset: n = 4, ...r }, o) => /* @__PURE__ */ b(bA, { children: /* @__PURE__ */ b(
  yA,
  {
    ref: o,
    align: t,
    sideOffset: n,
    ...r,
    style: void 0,
    className: Q(
      "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    )
  }
) }));
tl.displayName = "LBPopoverContent";
var nl = "Dialog", [dy, fy] = Ot(nl), [wA, In] = dy(nl), hy = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: a = !0
  } = e, s = d.useRef(null), l = d.useRef(null), [c, f] = Jt({
    prop: r,
    defaultProp: o ?? !1,
    onChange: i,
    caller: nl
  });
  return /* @__PURE__ */ b(
    wA,
    {
      scope: t,
      triggerRef: s,
      contentRef: l,
      contentId: Tt(),
      titleId: Tt(),
      descriptionId: Tt(),
      open: c,
      onOpenChange: f,
      onOpenToggle: d.useCallback(() => f((u) => !u), [f]),
      modal: a,
      children: n
    }
  );
};
hy.displayName = nl;
var my = "DialogTrigger", py = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = In(my, n), i = ke(t, o.triggerRef);
    return /* @__PURE__ */ b(
      ce.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": nh(o.open),
        ...r,
        ref: i,
        onClick: ne(e.onClick, o.onOpenToggle)
      }
    );
  }
);
py.displayName = my;
var eh = "DialogPortal", [xA, gy] = dy(eh, {
  forceMount: void 0
}), vy = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, i = In(eh, t);
  return /* @__PURE__ */ b(xA, { scope: t, forceMount: n, children: d.Children.map(r, (a) => /* @__PURE__ */ b(Nt, { present: n || i.open, children: /* @__PURE__ */ b(_i, { asChild: !0, container: o, children: a }) })) });
};
vy.displayName = eh;
var t0 = "DialogOverlay", by = d.forwardRef(
  (e, t) => {
    const n = gy(t0, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = In(t0, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ b(Nt, { present: r || i.open, children: /* @__PURE__ */ b(kA, { ...o, ref: t }) }) : null;
  }
);
by.displayName = t0;
var _A = /* @__PURE__ */ $r("DialogOverlay.RemoveScroll"), kA = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = In(t0, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ b(Xa, { as: _A, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ b(
        ce.div,
        {
          "data-state": nh(o.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), mo = "DialogContent", yy = d.forwardRef(
  (e, t) => {
    const n = gy(mo, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = In(mo, e.__scopeDialog);
    return /* @__PURE__ */ b(Nt, { present: r || i.open, children: i.modal ? /* @__PURE__ */ b(SA, { ...o, ref: t }) : /* @__PURE__ */ b(MA, { ...o, ref: t }) });
  }
);
yy.displayName = mo;
var SA = d.forwardRef(
  (e, t) => {
    const n = In(mo, e.__scopeDialog), r = d.useRef(null), o = ke(t, n.contentRef, r);
    return d.useEffect(() => {
      const i = r.current;
      if (i) return F0(i);
    }, []), /* @__PURE__ */ b(
      Cy,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: ne(e.onCloseAutoFocus, (i) => {
          var a;
          i.preventDefault(), (a = n.triggerRef.current) == null || a.focus();
        }),
        onPointerDownOutside: ne(e.onPointerDownOutside, (i) => {
          const a = i.detail.originalEvent, s = a.button === 0 && a.ctrlKey === !0;
          (a.button === 2 || s) && i.preventDefault();
        }),
        onFocusOutside: ne(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), MA = d.forwardRef(
  (e, t) => {
    const n = In(mo, e.__scopeDialog), r = d.useRef(!1), o = d.useRef(!1);
    return /* @__PURE__ */ b(
      Cy,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var a, s;
          (a = e.onCloseAutoFocus) == null || a.call(e, i), i.defaultPrevented || (r.current || (s = n.triggerRef.current) == null || s.focus(), i.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          var l, c;
          (l = e.onInteractOutside) == null || l.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const a = i.target;
          ((c = n.triggerRef.current) == null ? void 0 : c.contains(a)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), Cy = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, ...a } = e, s = In(mo, n), l = d.useRef(null), c = ke(t, l);
    return N0(), /* @__PURE__ */ ie(St, { children: [
      /* @__PURE__ */ b(
        Ya,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ b(
            So,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": nh(s.open),
              ...a,
              ref: c,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ ie(St, { children: [
        /* @__PURE__ */ b(LA, { titleId: s.titleId }),
        /* @__PURE__ */ b(PA, { contentRef: l, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), th = "DialogTitle", wy = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = In(th, n);
    return /* @__PURE__ */ b(ce.h2, { id: o.titleId, ...r, ref: t });
  }
);
wy.displayName = th;
var xy = "DialogDescription", _y = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = In(xy, n);
    return /* @__PURE__ */ b(ce.p, { id: o.descriptionId, ...r, ref: t });
  }
);
_y.displayName = xy;
var ky = "DialogClose", Sy = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = In(ky, n);
    return /* @__PURE__ */ b(
      ce.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: ne(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
Sy.displayName = ky;
function nh(e) {
  return e ? "open" : "closed";
}
var My = "DialogTitleWarning", [EA, Ey] = OM(My, {
  contentName: mo,
  titleName: th,
  docsSlug: "dialog"
}), LA = ({ titleId: e }) => {
  const t = Ey(My), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return d.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, TA = "DialogDescriptionWarning", PA = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Ey(TA).contentName}}.`;
  return d.useEffect(() => {
    var i;
    const o = (i = e.current) == null ? void 0 : i.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, rl = hy, rh = py, ol = vy, rs = by, Si = yy, il = wy, oh = _y, os = Sy;
const Ly = rl;
Ly.displayName = "LBDialog";
const RA = rh;
RA.displayName = "LBDialogTrigger";
const ih = ol;
ih.displayName = "LBDialogPortal";
const ah = os;
ah.displayName = "LBDialogClose";
const sh = fe(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  rs,
  {
    ref: n,
    ...t,
    className: Q(
      "fixed inset-0 z-50 bg-black/25 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    )
  }
));
sh.displayName = "LBDialogOverlay";
const Ty = fe(({ className: e, children: t, overlayClassName: n, ...r }, o) => /* @__PURE__ */ ie(ih, { children: [
  /* @__PURE__ */ b(sh, { className: n }),
  /* @__PURE__ */ ie(
    Si,
    {
      ref: o,
      ...r,
      className: Q(
        "fixed left-1/2 top-1/2 z-50 grid w-full max-w-lg -translate-x-1/2 -translate-y-1/2 gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
        e
      ),
      style: void 0,
      children: [
        t,
        /* @__PURE__ */ ie(ah, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground", children: [
          /* @__PURE__ */ b(ts, { className: "size-3" }),
          /* @__PURE__ */ b("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
Ty.displayName = "LBDialogContent";
function AA({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ b(
    "div",
    {
      className: Q(
        "flex flex-col space-y-2 text-center sm:text-left",
        e
      ),
      ...t
    }
  );
}
AA.displayName = "LBDialogHeader";
function OA({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ b(
    "div",
    {
      className: Q(
        "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
        e
      ),
      ...t
    }
  );
}
OA.displayName = "LBDialogFooter";
const NA = fe(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  il,
  {
    ref: n,
    ...t,
    className: Q(
      "text-lg font-semibold leading-none tracking-tight",
      e
    ),
    style: void 0
  }
));
NA.displayName = "LBDialogTitle";
const DA = fe(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  oh,
  {
    ref: n,
    ...t,
    style: void 0,
    className: Q("text-sm text-muted-foreground", e)
  }
));
DA.displayName = "LBDialogDescription";
var R8 = 1, IA = 0.9, BA = 0.8, $A = 0.17, Hc = 0.1, Vc = 0.999, FA = 0.9999, WA = 0.99, qA = /[\\\/_+.#"@\[\(\{&]/, jA = /[\\\/_+.#"@\[\(\{&]/g, HA = /[\s-]/, Py = /[\s-]/g;
function D2(e, t, n, r, o, i, a) {
  if (i === t.length) return o === e.length ? R8 : WA;
  var s = `${o},${i}`;
  if (a[s] !== void 0) return a[s];
  for (var l = r.charAt(i), c = n.indexOf(l, o), f = 0, u, h, m, g; c >= 0; ) u = D2(e, t, n, r, c + 1, i + 1, a), u > f && (c === o ? u *= R8 : qA.test(e.charAt(c - 1)) ? (u *= BA, m = e.slice(o, c - 1).match(jA), m && o > 0 && (u *= Math.pow(Vc, m.length))) : HA.test(e.charAt(c - 1)) ? (u *= IA, g = e.slice(o, c - 1).match(Py), g && o > 0 && (u *= Math.pow(Vc, g.length))) : (u *= $A, o > 0 && (u *= Math.pow(Vc, c - o))), e.charAt(c) !== t.charAt(i) && (u *= FA)), (u < Hc && n.charAt(c - 1) === r.charAt(i + 1) || r.charAt(i + 1) === r.charAt(i) && n.charAt(c - 1) !== r.charAt(i)) && (h = D2(e, t, n, r, c + 1, i + 2, a), h * Hc > u && (u = h * Hc)), u > f && (f = u), c = n.indexOf(l, c + 1);
  return a[s] = f, f;
}
function A8(e) {
  return e.toLowerCase().replace(Py, " ");
}
function VA(e, t, n) {
  return e = n && n.length > 0 ? `${e + " " + n.join(" ")}` : e, D2(e, t, A8(e), A8(t), 0, 0, {});
}
var qi = '[cmdk-group=""]', Uc = '[cmdk-group-items=""]', UA = '[cmdk-group-heading=""]', Ry = '[cmdk-item=""]', O8 = `${Ry}:not([aria-disabled="true"])`, I2 = "cmdk-item-select", Yo = "data-value", zA = (e, t, n) => VA(e, t, n), Ay = d.createContext(void 0), is = () => d.useContext(Ay), Oy = d.createContext(void 0), lh = () => d.useContext(Oy), Ny = d.createContext(void 0), Dy = d.forwardRef((e, t) => {
  let n = Go(() => {
    var B, K;
    return { search: "", value: (K = (B = e.value) != null ? B : e.defaultValue) != null ? K : "", selectedItemId: void 0, filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), r = Go(() => /* @__PURE__ */ new Set()), o = Go(() => /* @__PURE__ */ new Map()), i = Go(() => /* @__PURE__ */ new Map()), a = Go(() => /* @__PURE__ */ new Set()), s = Iy(e), { label: l, children: c, value: f, onValueChange: u, filter: h, shouldFilter: m, loop: g, disablePointerSelection: p = !1, vimBindings: v = !0, ...y } = e, C = Tt(), w = Tt(), _ = Tt(), x = d.useRef(null), k = rO();
  po(() => {
    if (f !== void 0) {
      let B = f.trim();
      n.current.value = B, S.emit();
    }
  }, [f]), po(() => {
    k(6, O);
  }, []);
  let S = d.useMemo(() => ({ subscribe: (B) => (a.current.add(B), () => a.current.delete(B)), snapshot: () => n.current, setState: (B, K, X) => {
    var Z, G, V, Y;
    if (!Object.is(n.current[B], K)) {
      if (n.current[B] = K, B === "search") A(), R(), k(1, M);
      else if (B === "value") {
        if (document.activeElement.hasAttribute("cmdk-input") || document.activeElement.hasAttribute("cmdk-root")) {
          let P = document.getElementById(_);
          P ? P.focus() : (Z = document.getElementById(C)) == null || Z.focus();
        }
        if (k(7, () => {
          var P;
          n.current.selectedItemId = (P = I()) == null ? void 0 : P.id, S.emit();
        }), X || k(5, O), ((G = s.current) == null ? void 0 : G.value) !== void 0) {
          let P = K ?? "";
          (Y = (V = s.current).onValueChange) == null || Y.call(V, P);
          return;
        }
      }
      S.emit();
    }
  }, emit: () => {
    a.current.forEach((B) => B());
  } }), []), T = d.useMemo(() => ({ value: (B, K, X) => {
    var Z;
    K !== ((Z = i.current.get(B)) == null ? void 0 : Z.value) && (i.current.set(B, { value: K, keywords: X }), n.current.filtered.items.set(B, L(K, X)), k(2, () => {
      R(), S.emit();
    }));
  }, item: (B, K) => (r.current.add(B), K && (o.current.has(K) ? o.current.get(K).add(B) : o.current.set(K, /* @__PURE__ */ new Set([B]))), k(3, () => {
    A(), R(), n.current.value || M(), S.emit();
  }), () => {
    i.current.delete(B), r.current.delete(B), n.current.filtered.items.delete(B);
    let X = I();
    k(4, () => {
      A(), (X == null ? void 0 : X.getAttribute("id")) === B && M(), S.emit();
    });
  }), group: (B) => (o.current.has(B) || o.current.set(B, /* @__PURE__ */ new Set()), () => {
    i.current.delete(B), o.current.delete(B);
  }), filter: () => s.current.shouldFilter, label: l || e["aria-label"], getDisablePointerSelection: () => s.current.disablePointerSelection, listId: C, inputId: _, labelId: w, listInnerRef: x }), []);
  function L(B, K) {
    var X, Z;
    let G = (Z = (X = s.current) == null ? void 0 : X.filter) != null ? Z : zA;
    return B ? G(B, n.current.search, K) : 0;
  }
  function R() {
    if (!n.current.search || s.current.shouldFilter === !1) return;
    let B = n.current.filtered.items, K = [];
    n.current.filtered.groups.forEach((Z) => {
      let G = o.current.get(Z), V = 0;
      G.forEach((Y) => {
        let P = B.get(Y);
        V = Math.max(P, V);
      }), K.push([Z, V]);
    });
    let X = x.current;
    W().sort((Z, G) => {
      var V, Y;
      let P = Z.getAttribute("id"), F = G.getAttribute("id");
      return ((V = B.get(F)) != null ? V : 0) - ((Y = B.get(P)) != null ? Y : 0);
    }).forEach((Z) => {
      let G = Z.closest(Uc);
      G ? G.appendChild(Z.parentElement === G ? Z : Z.closest(`${Uc} > *`)) : X.appendChild(Z.parentElement === X ? Z : Z.closest(`${Uc} > *`));
    }), K.sort((Z, G) => G[1] - Z[1]).forEach((Z) => {
      var G;
      let V = (G = x.current) == null ? void 0 : G.querySelector(`${qi}[${Yo}="${encodeURIComponent(Z[0])}"]`);
      V == null || V.parentElement.appendChild(V);
    });
  }
  function M() {
    let B = W().find((X) => X.getAttribute("aria-disabled") !== "true"), K = B == null ? void 0 : B.getAttribute(Yo);
    S.setState("value", K || void 0);
  }
  function A() {
    var B, K, X, Z;
    if (!n.current.search || s.current.shouldFilter === !1) {
      n.current.filtered.count = r.current.size;
      return;
    }
    n.current.filtered.groups = /* @__PURE__ */ new Set();
    let G = 0;
    for (let V of r.current) {
      let Y = (K = (B = i.current.get(V)) == null ? void 0 : B.value) != null ? K : "", P = (Z = (X = i.current.get(V)) == null ? void 0 : X.keywords) != null ? Z : [], F = L(Y, P);
      n.current.filtered.items.set(V, F), F > 0 && G++;
    }
    for (let [V, Y] of o.current) for (let P of Y) if (n.current.filtered.items.get(P) > 0) {
      n.current.filtered.groups.add(V);
      break;
    }
    n.current.filtered.count = G;
  }
  function O() {
    var B, K, X;
    let Z = I();
    Z && (((B = Z.parentElement) == null ? void 0 : B.firstChild) === Z && ((X = (K = Z.closest(qi)) == null ? void 0 : K.querySelector(UA)) == null || X.scrollIntoView({ block: "nearest" })), Z.scrollIntoView({ block: "nearest" }));
  }
  function I() {
    var B;
    return (B = x.current) == null ? void 0 : B.querySelector(`${Ry}[aria-selected="true"]`);
  }
  function W() {
    var B;
    return Array.from(((B = x.current) == null ? void 0 : B.querySelectorAll(O8)) || []);
  }
  function N(B) {
    let K = W()[B];
    K && S.setState("value", K.getAttribute(Yo));
  }
  function H(B) {
    var K;
    let X = I(), Z = W(), G = Z.findIndex((Y) => Y === X), V = Z[G + B];
    (K = s.current) != null && K.loop && (V = G + B < 0 ? Z[Z.length - 1] : G + B === Z.length ? Z[0] : Z[G + B]), V && S.setState("value", V.getAttribute(Yo));
  }
  function q(B) {
    let K = I(), X = K == null ? void 0 : K.closest(qi), Z;
    for (; X && !Z; ) X = B > 0 ? tO(X, qi) : nO(X, qi), Z = X == null ? void 0 : X.querySelector(O8);
    Z ? S.setState("value", Z.getAttribute(Yo)) : H(B);
  }
  let D = () => N(W().length - 1), $ = (B) => {
    B.preventDefault(), B.metaKey ? D() : B.altKey ? q(1) : H(1);
  }, U = (B) => {
    B.preventDefault(), B.metaKey ? N(0) : B.altKey ? q(-1) : H(-1);
  };
  return d.createElement(ce.div, { ref: t, tabIndex: -1, ...y, "cmdk-root": "", onKeyDown: (B) => {
    var K;
    (K = y.onKeyDown) == null || K.call(y, B);
    let X = B.nativeEvent.isComposing || B.keyCode === 229;
    if (!(B.defaultPrevented || X)) switch (B.key) {
      case "n":
      case "j": {
        v && B.ctrlKey && $(B);
        break;
      }
      case "ArrowDown": {
        $(B);
        break;
      }
      case "p":
      case "k": {
        v && B.ctrlKey && U(B);
        break;
      }
      case "ArrowUp": {
        U(B);
        break;
      }
      case "Home": {
        B.preventDefault(), N(0);
        break;
      }
      case "End": {
        B.preventDefault(), D();
        break;
      }
      case "Enter": {
        B.preventDefault();
        let Z = I();
        if (Z) {
          let G = new Event(I2);
          Z.dispatchEvent(G);
        }
      }
    }
  } }, d.createElement("label", { "cmdk-label": "", htmlFor: T.inputId, id: T.labelId, style: iO }, l), al(e, (B) => d.createElement(Oy.Provider, { value: S }, d.createElement(Ay.Provider, { value: T }, B))));
}), YA = d.forwardRef((e, t) => {
  var n, r;
  let o = Tt(), i = d.useRef(null), a = d.useContext(Ny), s = is(), l = Iy(e), c = (r = (n = l.current) == null ? void 0 : n.forceMount) != null ? r : a == null ? void 0 : a.forceMount;
  po(() => {
    if (!c) return s.item(o, a == null ? void 0 : a.id);
  }, [c]);
  let f = By(o, i, [e.value, e.children, i], e.keywords), u = lh(), h = jr((k) => k.value && k.value === f.current), m = jr((k) => c || s.filter() === !1 ? !0 : k.search ? k.filtered.items.get(o) > 0 : !0);
  d.useEffect(() => {
    let k = i.current;
    if (!(!k || e.disabled)) return k.addEventListener(I2, g), () => k.removeEventListener(I2, g);
  }, [m, e.onSelect, e.disabled]);
  function g() {
    var k, S;
    p(), (S = (k = l.current).onSelect) == null || S.call(k, f.current);
  }
  function p() {
    u.setState("value", f.current, !0);
  }
  if (!m) return null;
  let { disabled: v, value: y, onSelect: C, forceMount: w, keywords: _, ...x } = e;
  return d.createElement(ce.div, { ref: vr(i, t), ...x, id: o, "cmdk-item": "", role: "option", "aria-disabled": !!v, "aria-selected": !!h, "data-disabled": !!v, "data-selected": !!h, onPointerMove: v || s.getDisablePointerSelection() ? void 0 : p, onClick: v ? void 0 : g }, e.children);
}), GA = d.forwardRef((e, t) => {
  let { heading: n, children: r, forceMount: o, ...i } = e, a = Tt(), s = d.useRef(null), l = d.useRef(null), c = Tt(), f = is(), u = jr((m) => o || f.filter() === !1 ? !0 : m.search ? m.filtered.groups.has(a) : !0);
  po(() => f.group(a), []), By(a, s, [e.value, e.heading, l]);
  let h = d.useMemo(() => ({ id: a, forceMount: o }), [o]);
  return d.createElement(ce.div, { ref: vr(s, t), ...i, "cmdk-group": "", role: "presentation", hidden: u ? void 0 : !0 }, n && d.createElement("div", { ref: l, "cmdk-group-heading": "", "aria-hidden": !0, id: c }, n), al(e, (m) => d.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": n ? c : void 0 }, d.createElement(Ny.Provider, { value: h }, m))));
}), KA = d.forwardRef((e, t) => {
  let { alwaysRender: n, ...r } = e, o = d.useRef(null), i = jr((a) => !a.search);
  return !n && !i ? null : d.createElement(ce.div, { ref: vr(o, t), ...r, "cmdk-separator": "", role: "separator" });
}), ZA = d.forwardRef((e, t) => {
  let { onValueChange: n, ...r } = e, o = e.value != null, i = lh(), a = jr((c) => c.search), s = jr((c) => c.selectedItemId), l = is();
  return d.useEffect(() => {
    e.value != null && i.setState("search", e.value);
  }, [e.value]), d.createElement(ce.input, { ref: t, ...r, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": l.listId, "aria-labelledby": l.labelId, "aria-activedescendant": s, id: l.inputId, type: "text", value: o ? e.value : a, onChange: (c) => {
    o || i.setState("search", c.target.value), n == null || n(c.target.value);
  } });
}), XA = d.forwardRef((e, t) => {
  let { children: n, label: r = "Suggestions", ...o } = e, i = d.useRef(null), a = d.useRef(null), s = jr((c) => c.selectedItemId), l = is();
  return d.useEffect(() => {
    if (a.current && i.current) {
      let c = a.current, f = i.current, u, h = new ResizeObserver(() => {
        u = requestAnimationFrame(() => {
          let m = c.offsetHeight;
          f.style.setProperty("--cmdk-list-height", m.toFixed(1) + "px");
        });
      });
      return h.observe(c), () => {
        cancelAnimationFrame(u), h.unobserve(c);
      };
    }
  }, []), d.createElement(ce.div, { ref: vr(i, t), ...o, "cmdk-list": "", role: "listbox", tabIndex: -1, "aria-activedescendant": s, "aria-label": r, id: l.listId }, al(e, (c) => d.createElement("div", { ref: vr(a, l.listInnerRef), "cmdk-list-sizer": "" }, c)));
}), QA = d.forwardRef((e, t) => {
  let { open: n, onOpenChange: r, overlayClassName: o, contentClassName: i, container: a, ...s } = e;
  return d.createElement(rl, { open: n, onOpenChange: r }, d.createElement(ol, { container: a }, d.createElement(rs, { "cmdk-overlay": "", className: o }), d.createElement(Si, { "aria-label": e.label, "cmdk-dialog": "", className: i }, d.createElement(Dy, { ref: t, ...s }))));
}), JA = d.forwardRef((e, t) => jr((n) => n.filtered.count === 0) ? d.createElement(ce.div, { ref: t, ...e, "cmdk-empty": "", role: "presentation" }) : null), eO = d.forwardRef((e, t) => {
  let { progress: n, children: r, label: o = "Loading...", ...i } = e;
  return d.createElement(ce.div, { ref: t, ...i, "cmdk-loading": "", role: "progressbar", "aria-valuenow": n, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": o }, al(e, (a) => d.createElement("div", { "aria-hidden": !0 }, a)));
}), Zr = Object.assign(Dy, { List: XA, Item: YA, Input: ZA, Group: GA, Separator: KA, Dialog: QA, Empty: JA, Loading: eO });
function tO(e, t) {
  let n = e.nextElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.nextElementSibling;
  }
}
function nO(e, t) {
  let n = e.previousElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.previousElementSibling;
  }
}
function Iy(e) {
  let t = d.useRef(e);
  return po(() => {
    t.current = e;
  }), t;
}
var po = typeof window > "u" ? d.useEffect : d.useLayoutEffect;
function Go(e) {
  let t = d.useRef();
  return t.current === void 0 && (t.current = e()), t;
}
function jr(e) {
  let t = lh(), n = () => e(t.snapshot());
  return d.useSyncExternalStore(t.subscribe, n, n);
}
function By(e, t, n, r = []) {
  let o = d.useRef(), i = is();
  return po(() => {
    var a;
    let s = (() => {
      var c;
      for (let f of n) {
        if (typeof f == "string") return f.trim();
        if (typeof f == "object" && "current" in f) return f.current ? (c = f.current.textContent) == null ? void 0 : c.trim() : o.current;
      }
    })(), l = r.map((c) => c.trim());
    i.value(e, s, l), (a = t.current) == null || a.setAttribute(Yo, s), o.current = s;
  }), o;
}
var rO = () => {
  let [e, t] = d.useState(), n = Go(() => /* @__PURE__ */ new Map());
  return po(() => {
    n.current.forEach((r) => r()), n.current = /* @__PURE__ */ new Map();
  }, [e]), (r, o) => {
    n.current.set(r, o), t({});
  };
};
function oO(e) {
  let t = e.type;
  return typeof t == "function" ? t(e.props) : "render" in t ? t.render(e.props) : e;
}
function al({ asChild: e, children: t }, n) {
  return e && d.isValidElement(t) ? d.cloneElement(oO(t), { ref: t.ref }, n(t.props.children)) : n(t);
}
var iO = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
const ch = fe(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  Zr,
  {
    ref: n,
    className: Q(
      "flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground",
      e
    ),
    ...t
  }
));
ch.displayName = "LBCommand";
function aO({ children: e, ...t }) {
  return /* @__PURE__ */ b(Ly, { ...t, children: /* @__PURE__ */ b(Ty, { className: "overflow-hidden p-0", children: /* @__PURE__ */ b(ch, { className: "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:size-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:size-5", children: e }) }) });
}
aO.displayName = "LBCommandDialog";
const $y = fe(({ className: e, ...t }, n) => (
  // eslint-disable-next-line react/no-unknown-property
  /* @__PURE__ */ ie("div", { className: "flex items-center border-b px-3", "cmdk-input-wrapper": "", children: [
    /* @__PURE__ */ b(YP, { className: "mr-2 size-4 shrink-0 opacity-50" }),
    /* @__PURE__ */ b(
      Zr.Input,
      {
        ref: n,
        className: Q(
          "flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
          e
        ),
        ...t
      }
    )
  ] })
));
$y.displayName = "LBCommandInput";
const Fy = fe(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  Zr.List,
  {
    ref: n,
    className: Q("max-h-[300px] overflow-y-auto overflow-x-hidden", e),
    ...t
  }
));
Fy.displayName = "LBCommandList";
const Wy = fe((e, t) => /* @__PURE__ */ b(
  Zr.Empty,
  {
    ref: t,
    className: "py-6 text-center text-sm",
    ...e
  }
));
Wy.displayName = "LBCommandEmpty";
const qy = fe(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  Zr.Group,
  {
    ref: n,
    className: Q(
      "overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-2 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground",
      e
    ),
    ...t
  }
));
qy.displayName = "LBCommandGroup";
const sO = fe(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  Zr.Separator,
  {
    ref: n,
    className: Q("-mx-1 h-[1px] bg-border", e),
    ...t
  }
));
sO.displayName = "LBCommandSeparator";
const jy = fe(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  Zr.Item,
  {
    ref: n,
    className: Q(
      "relative flex cursor-default gap-2 select-none items-center rounded-sm px-2 py-2 text-sm outline-none data-[disabled=true]:pointer-events-none data-[selected='true']:bg-accent data-[selected=true]:text-accent-foreground data-[disabled=true]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      e
    ),
    ...t
  }
));
jy.displayName = "LBCommandItem";
function lO({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ b(
    "span",
    {
      className: Q(
        "ml-auto text-xs tracking-widest text-muted-foreground",
        e
      ),
      ...t
    }
  );
}
lO.displayName = "LBCommandShortcut";
const Hy = fe((e, t) => /* @__PURE__ */ b(
  Zr.Loading,
  {
    className: "relative flex animate-pulse cursor-default select-none items-center gap-2 rounded-sm p-2 text-sm outline-none [&_svg]:pointer-events-none  [&_svg]:size-4 [&_svg]:shrink-0",
    ref: t,
    ...e
  }
));
Hy.displayName = "LBCommandLoading";
var [sl, xee] = Ot("Tooltip", [
  er
]), ll = er(), Vy = "TooltipProvider", cO = 700, B2 = "tooltip.open", [uO, uh] = sl(Vy), Uy = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = cO,
    skipDelayDuration: r = 300,
    disableHoverableContent: o = !1,
    children: i
  } = e, a = d.useRef(!0), s = d.useRef(!1), l = d.useRef(0);
  return d.useEffect(() => {
    const c = l.current;
    return () => window.clearTimeout(c);
  }, []), /* @__PURE__ */ b(
    uO,
    {
      scope: t,
      isOpenDelayedRef: a,
      delayDuration: n,
      onOpen: d.useCallback(() => {
        window.clearTimeout(l.current), a.current = !1;
      }, []),
      onClose: d.useCallback(() => {
        window.clearTimeout(l.current), l.current = window.setTimeout(
          () => a.current = !0,
          r
        );
      }, [r]),
      isPointerInTransitRef: s,
      onPointerInTransitChange: d.useCallback((c) => {
        s.current = c;
      }, []),
      disableHoverableContent: o,
      children: i
    }
  );
};
Uy.displayName = Vy;
var xa = "Tooltip", [dO, as] = sl(xa), zy = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    disableHoverableContent: a,
    delayDuration: s
  } = e, l = uh(xa, e.__scopeTooltip), c = ll(t), [f, u] = d.useState(null), h = Tt(), m = d.useRef(0), g = a ?? l.disableHoverableContent, p = s ?? l.delayDuration, v = d.useRef(!1), [y, C] = Jt({
    prop: r,
    defaultProp: o ?? !1,
    onChange: (S) => {
      S ? (l.onOpen(), document.dispatchEvent(new CustomEvent(B2))) : l.onClose(), i == null || i(S);
    },
    caller: xa
  }), w = d.useMemo(() => y ? v.current ? "delayed-open" : "instant-open" : "closed", [y]), _ = d.useCallback(() => {
    window.clearTimeout(m.current), m.current = 0, v.current = !1, C(!0);
  }, [C]), x = d.useCallback(() => {
    window.clearTimeout(m.current), m.current = 0, C(!1);
  }, [C]), k = d.useCallback(() => {
    window.clearTimeout(m.current), m.current = window.setTimeout(() => {
      v.current = !0, C(!0), m.current = 0;
    }, p);
  }, [p, C]);
  return d.useEffect(() => () => {
    m.current && (window.clearTimeout(m.current), m.current = 0);
  }, []), /* @__PURE__ */ b(wi, { ...c, children: /* @__PURE__ */ b(
    dO,
    {
      scope: t,
      contentId: h,
      open: y,
      stateAttribute: w,
      trigger: f,
      onTriggerChange: u,
      onTriggerEnter: d.useCallback(() => {
        l.isOpenDelayedRef.current ? k() : _();
      }, [l.isOpenDelayedRef, k, _]),
      onTriggerLeave: d.useCallback(() => {
        g ? x() : (window.clearTimeout(m.current), m.current = 0);
      }, [x, g]),
      onOpen: _,
      onClose: x,
      disableHoverableContent: g,
      children: n
    }
  ) });
};
zy.displayName = xa;
var $2 = "TooltipTrigger", Yy = d.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = as($2, n), i = uh($2, n), a = ll(n), s = d.useRef(null), l = ke(t, s, o.onTriggerChange), c = d.useRef(!1), f = d.useRef(!1), u = d.useCallback(() => c.current = !1, []);
    return d.useEffect(() => () => document.removeEventListener("pointerup", u), [u]), /* @__PURE__ */ b(xi, { asChild: !0, ...a, children: /* @__PURE__ */ b(
      ce.button,
      {
        "aria-describedby": o.open ? o.contentId : void 0,
        "data-state": o.stateAttribute,
        ...r,
        ref: l,
        onPointerMove: ne(e.onPointerMove, (h) => {
          h.pointerType !== "touch" && !f.current && !i.isPointerInTransitRef.current && (o.onTriggerEnter(), f.current = !0);
        }),
        onPointerLeave: ne(e.onPointerLeave, () => {
          o.onTriggerLeave(), f.current = !1;
        }),
        onPointerDown: ne(e.onPointerDown, () => {
          o.open && o.onClose(), c.current = !0, document.addEventListener("pointerup", u, { once: !0 });
        }),
        onFocus: ne(e.onFocus, () => {
          c.current || o.onOpen();
        }),
        onBlur: ne(e.onBlur, o.onClose),
        onClick: ne(e.onClick, o.onClose)
      }
    ) });
  }
);
Yy.displayName = $2;
var dh = "TooltipPortal", [fO, hO] = sl(dh, {
  forceMount: void 0
}), Gy = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: o } = e, i = as(dh, t);
  return /* @__PURE__ */ b(fO, { scope: t, forceMount: n, children: /* @__PURE__ */ b(Nt, { present: n || i.open, children: /* @__PURE__ */ b(_i, { asChild: !0, container: o, children: r }) }) });
};
Gy.displayName = dh;
var si = "TooltipContent", Ky = d.forwardRef(
  (e, t) => {
    const n = hO(si, e.__scopeTooltip), { forceMount: r = n.forceMount, side: o = "top", ...i } = e, a = as(si, e.__scopeTooltip);
    return /* @__PURE__ */ b(Nt, { present: r || a.open, children: a.disableHoverableContent ? /* @__PURE__ */ b(Zy, { side: o, ...i, ref: t }) : /* @__PURE__ */ b(mO, { side: o, ...i, ref: t }) });
  }
), mO = d.forwardRef((e, t) => {
  const n = as(si, e.__scopeTooltip), r = uh(si, e.__scopeTooltip), o = d.useRef(null), i = ke(t, o), [a, s] = d.useState(null), { trigger: l, onClose: c } = n, f = o.current, { onPointerInTransitChange: u } = r, h = d.useCallback(() => {
    s(null), u(!1);
  }, [u]), m = d.useCallback(
    (g, p) => {
      const v = g.currentTarget, y = { x: g.clientX, y: g.clientY }, C = yO(y, v.getBoundingClientRect()), w = CO(y, C), _ = wO(p.getBoundingClientRect()), x = _O([...w, ..._]);
      s(x), u(!0);
    },
    [u]
  );
  return d.useEffect(() => () => h(), [h]), d.useEffect(() => {
    if (l && f) {
      const g = (v) => m(v, f), p = (v) => m(v, l);
      return l.addEventListener("pointerleave", g), f.addEventListener("pointerleave", p), () => {
        l.removeEventListener("pointerleave", g), f.removeEventListener("pointerleave", p);
      };
    }
  }, [l, f, m, h]), d.useEffect(() => {
    if (a) {
      const g = (p) => {
        const v = p.target, y = { x: p.clientX, y: p.clientY }, C = (l == null ? void 0 : l.contains(v)) || (f == null ? void 0 : f.contains(v)), w = !xO(y, a);
        C ? h() : w && (h(), c());
      };
      return document.addEventListener("pointermove", g), () => document.removeEventListener("pointermove", g);
    }
  }, [l, f, a, c, h]), /* @__PURE__ */ b(Zy, { ...e, ref: i });
}), [pO, gO] = sl(xa, { isInside: !1 }), vO = /* @__PURE__ */ og("TooltipContent"), Zy = d.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": o,
      onEscapeKeyDown: i,
      onPointerDownOutside: a,
      ...s
    } = e, l = as(si, n), c = ll(n), { onClose: f } = l;
    return d.useEffect(() => (document.addEventListener(B2, f), () => document.removeEventListener(B2, f)), [f]), d.useEffect(() => {
      if (l.trigger) {
        const u = (h) => {
          const m = h.target;
          m != null && m.contains(l.trigger) && f();
        };
        return window.addEventListener("scroll", u, { capture: !0 }), () => window.removeEventListener("scroll", u, { capture: !0 });
      }
    }, [l.trigger, f]), /* @__PURE__ */ b(
      So,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: i,
        onPointerDownOutside: a,
        onFocusOutside: (u) => u.preventDefault(),
        onDismiss: f,
        children: /* @__PURE__ */ ie(
          Ka,
          {
            "data-state": l.stateAttribute,
            ...c,
            ...s,
            ref: t,
            style: {
              ...s.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ b(vO, { children: r }),
              /* @__PURE__ */ b(pO, { scope: n, isInside: !0, children: /* @__PURE__ */ b(kR, { id: l.contentId, role: "tooltip", children: o || r }) })
            ]
          }
        )
      }
    );
  }
);
Ky.displayName = si;
var Xy = "TooltipArrow", bO = d.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = ll(n);
    return gO(
      Xy,
      n
    ).isInside ? null : /* @__PURE__ */ b(Za, { ...o, ...r, ref: t });
  }
);
bO.displayName = Xy;
function yO(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), i = Math.abs(t.left - e.x);
  switch (Math.min(n, r, o, i)) {
    case i:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function CO(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
function wO(e) {
  const { top: t, right: n, bottom: r, left: o } = e;
  return [
    { x: o, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: o, y: r }
  ];
}
function xO(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, a = t.length - 1; i < t.length; a = i++) {
    const s = t[i], l = t[a], c = s.x, f = s.y, u = l.x, h = l.y;
    f > r != h > r && n < (u - c) * (r - f) / (h - f) + c && (o = !o);
  }
  return o;
}
function _O(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), kO(t);
}
function kO(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const o = e[r];
    for (; t.length >= 2; ) {
      const i = t[t.length - 1], a = t[t.length - 2];
      if ((i.x - a.x) * (o.y - a.y) >= (i.y - a.y) * (o.x - a.x)) t.pop();
      else break;
    }
    t.push(o);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const o = e[r];
    for (; n.length >= 2; ) {
      const i = n[n.length - 1], a = n[n.length - 2];
      if ((i.x - a.x) * (o.y - a.y) >= (i.y - a.y) * (o.x - a.x)) n.pop();
      else break;
    }
    n.push(o);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var SO = Uy, MO = zy, EO = Yy, LO = Gy, TO = Ky;
const _ee = SO, kee = MO, See = EO, PO = fe(({ sideOffset: e = 4, ...t }, n) => /* @__PURE__ */ b(LO, { children: /* @__PURE__ */ b(
  TO,
  {
    ref: n,
    sideOffset: e,
    ...t,
    style: void 0,
    className: "z-50 overflow-hidden rounded-md bg-card px-3 py-2 text-xs text-primary shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 dark:bg-accent"
  }
) }));
PO.displayName = "LBTooltipContent";
function hn({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ b(
    "div",
    {
      className: Q("animate-pulse rounded-md bg-muted", e),
      ...t
    }
  );
}
hn.displayName = "LBSkeleton";
const fh = Dn(
  "inline-flex h-6 flex-row items-center gap-1 rounded-sm px-2 py-1 text-xs font-normal uppercase",
  {
    variants: {
      variant: {
        default: "bg-gray-100 focus-visible:bg-gray-600 focus-visible:text-white",
        blue: "bg-blue-100 text-blue-800 focus-visible:bg-blue-600 focus-visible:text-white",
        green: "bg-green-100 text-green-800 focus-visible:bg-green-600 focus-visible:text-white"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), Qy = fe(
  ({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ b(
    "div",
    {
      className: Q(fh({ variant: t }), e),
      ...n,
      ref: r
    }
  )
);
Qy.displayName = "LBJiraStatusBadge";
var Es = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ht(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ls = { exports: {} }, zc = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var N8;
function RO() {
  if (N8) return zc;
  N8 = 1;
  var e = j;
  function t(u, h) {
    return u === h && (u !== 0 || 1 / u === 1 / h) || u !== u && h !== h;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, o = e.useEffect, i = e.useLayoutEffect, a = e.useDebugValue;
  function s(u, h) {
    var m = h(), g = r({ inst: { value: m, getSnapshot: h } }), p = g[0].inst, v = g[1];
    return i(
      function() {
        p.value = m, p.getSnapshot = h, l(p) && v({ inst: p });
      },
      [u, m, h]
    ), o(
      function() {
        return l(p) && v({ inst: p }), u(function() {
          l(p) && v({ inst: p });
        });
      },
      [u]
    ), a(m), m;
  }
  function l(u) {
    var h = u.getSnapshot;
    u = u.value;
    try {
      var m = h();
      return !n(u, m);
    } catch {
      return !0;
    }
  }
  function c(u, h) {
    return h();
  }
  var f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : s;
  return zc.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : f, zc;
}
var Yc = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var D8;
function AO() {
  return D8 || (D8 = 1, process.env.NODE_ENV !== "production" && function() {
    function e(m, g) {
      return m === g && (m !== 0 || 1 / m === 1 / g) || m !== m && g !== g;
    }
    function t(m, g) {
      f || o.startTransition === void 0 || (f = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var p = g();
      if (!u) {
        var v = g();
        i(p, v) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), u = !0);
      }
      v = a({
        inst: { value: p, getSnapshot: g }
      });
      var y = v[0].inst, C = v[1];
      return l(
        function() {
          y.value = p, y.getSnapshot = g, n(y) && C({ inst: y });
        },
        [m, p, g]
      ), s(
        function() {
          return n(y) && C({ inst: y }), m(function() {
            n(y) && C({ inst: y });
          });
        },
        [m]
      ), c(p), p;
    }
    function n(m) {
      var g = m.getSnapshot;
      m = m.value;
      try {
        var p = g();
        return !i(m, p);
      } catch {
        return !0;
      }
    }
    function r(m, g) {
      return g();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var o = j, i = typeof Object.is == "function" ? Object.is : e, a = o.useState, s = o.useEffect, l = o.useLayoutEffect, c = o.useDebugValue, f = !1, u = !1, h = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : t;
    Yc.useSyncExternalStore = o.useSyncExternalStore !== void 0 ? o.useSyncExternalStore : h, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), Yc;
}
var I8;
function OO() {
  return I8 || (I8 = 1, process.env.NODE_ENV === "production" ? Ls.exports = RO() : Ls.exports = AO()), Ls.exports;
}
var NO = OO();
function DO() {
  return NO.useSyncExternalStore(
    IO,
    () => !0,
    () => !1
  );
}
function IO() {
  return () => {
  };
}
var hh = "Avatar", [BO, Mee] = Ot(hh), [$O, Jy] = BO(hh), eC = d.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, ...r } = e, [o, i] = d.useState("idle");
    return /* @__PURE__ */ b(
      $O,
      {
        scope: n,
        imageLoadingStatus: o,
        onImageLoadingStatusChange: i,
        children: /* @__PURE__ */ b(ce.span, { ...r, ref: t })
      }
    );
  }
);
eC.displayName = hh;
var tC = "AvatarImage", nC = d.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, src: r, onLoadingStatusChange: o = () => {
    }, ...i } = e, a = Jy(tC, n), s = FO(r, i), l = qt((c) => {
      o(c), a.onImageLoadingStatusChange(c);
    });
    return At(() => {
      s !== "idle" && l(s);
    }, [s, l]), s === "loaded" ? /* @__PURE__ */ b(ce.img, { ...i, ref: t, src: r }) : null;
  }
);
nC.displayName = tC;
var rC = "AvatarFallback", oC = d.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, delayMs: r, ...o } = e, i = Jy(rC, n), [a, s] = d.useState(r === void 0);
    return d.useEffect(() => {
      if (r !== void 0) {
        const l = window.setTimeout(() => s(!0), r);
        return () => window.clearTimeout(l);
      }
    }, [r]), a && i.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ b(ce.span, { ...o, ref: t }) : null;
  }
);
oC.displayName = rC;
function B8(e, t) {
  return e ? t ? (e.src !== t && (e.src = t), e.complete && e.naturalWidth > 0 ? "loaded" : "loading") : "error" : "idle";
}
function FO(e, { referrerPolicy: t, crossOrigin: n }) {
  const r = DO(), o = d.useRef(null), i = r ? (o.current || (o.current = new window.Image()), o.current) : null, [a, s] = d.useState(
    () => B8(i, e)
  );
  return At(() => {
    s(B8(i, e));
  }, [i, e]), At(() => {
    const l = (u) => () => {
      s(u);
    };
    if (!i) return;
    const c = l("loaded"), f = l("error");
    return i.addEventListener("load", c), i.addEventListener("error", f), t && (i.referrerPolicy = t), typeof n == "string" && (i.crossOrigin = n), () => {
      i.removeEventListener("load", c), i.removeEventListener("error", f);
    };
  }, [i, n, t]), a;
}
var WO = eC, qO = nC, jO = oC;
const iC = fe(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  WO,
  {
    ref: n,
    className: Q(
      "relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full",
      e
    ),
    ...t
  }
));
iC.displayName = "LBAvatar";
const aC = fe(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  qO,
  {
    ref: n,
    className: Q("aspect-square h-full w-full", e),
    ...t
  }
));
aC.displayName = "LBAvatarImage";
const sC = fe(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  jO,
  {
    ref: n,
    className: Q(
      "flex h-full w-full items-center justify-center rounded-full bg-muted",
      e
    ),
    ...t
  }
));
sC.displayName = "LBAvatarFallback";
const HO = d.forwardRef(({ className: e, type: t, ...n }, r) => /* @__PURE__ */ b(
  "input",
  {
    type: t,
    className: Q(
      "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
      e
    ),
    ref: r,
    ...n
  }
));
HO.displayName = "LBInput";
var VO = "Label", lC = d.forwardRef((e, t) => /* @__PURE__ */ b(
  ce.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      var o;
      n.target.closest("button, input, select, textarea") || ((o = e.onMouseDown) == null || o.call(e, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
lC.displayName = VO;
var UO = lC;
const zO = Dn(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), cC = fe(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  UO,
  {
    ref: n,
    className: Q(zO(), e),
    ...t
  }
));
cC.displayName = "LBLabel";
const YO = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  "textarea",
  {
    className: Q(
      "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
      e
    ),
    ref: n,
    ...t
  }
));
YO.displayName = "LBTextarea";
var GO = (e) => e.type === "checkbox", KO = (e) => e instanceof Date, uC = (e) => e == null;
const ZO = (e) => typeof e == "object";
var Mi = (e) => !uC(e) && !Array.isArray(e) && ZO(e) && !KO(e), XO = (e) => Mi(e) && e.target ? GO(e.target) ? e.target.checked : e.target.value : e, QO = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, JO = (e, t) => e.has(QO(t)), eN = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return Mi(t) && t.hasOwnProperty("isPrototypeOf");
}, tN = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function mh(e) {
  let t;
  const n = Array.isArray(e), r = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    t = new Date(e);
  else if (e instanceof Set)
    t = new Set(e);
  else if (!(tN && (e instanceof Blob || r)) && (n || Mi(e)))
    if (t = n ? [] : {}, !n && !eN(e))
      t = e;
    else
      for (const o in e)
        e.hasOwnProperty(o) && (t[o] = mh(e[o]));
  else
    return e;
  return t;
}
var dC = (e) => Array.isArray(e) ? e.filter(Boolean) : [], F2 = (e) => e === void 0, sn = (e, t, n) => {
  if (!t || !Mi(e))
    return n;
  const r = dC(t.split(/[,[\].]+?/)).reduce((o, i) => uC(o) ? o : o[i], e);
  return F2(r) || r === e ? F2(e[t]) ? n : e[t] : r;
}, $8 = (e) => typeof e == "boolean", nN = (e) => /^\w*$/.test(e), rN = (e) => dC(e.replace(/["|']|\]/g, "").split(/\.|\[/)), F8 = (e, t, n) => {
  let r = -1;
  const o = nN(t) ? [t] : rN(t), i = o.length, a = i - 1;
  for (; ++r < i; ) {
    const s = o[r];
    let l = n;
    if (r !== a) {
      const c = e[s];
      l = Mi(c) || Array.isArray(c) ? c : isNaN(+o[r + 1]) ? {} : [];
    }
    if (s === "__proto__" || s === "constructor" || s === "prototype")
      return;
    e[s] = l, e = e[s];
  }
  return e;
};
const W8 = {
  BLUR: "blur",
  CHANGE: "change"
}, q8 = {
  all: "all"
}, fC = j.createContext(null), cl = () => j.useContext(fC), oN = (e) => {
  const { children: t, ...n } = e;
  return j.createElement(fC.Provider, { value: n }, t);
};
var iN = (e, t, n, r = !0) => {
  const o = {
    defaultValues: t._defaultValues
  };
  for (const i in e)
    Object.defineProperty(o, i, {
      get: () => {
        const a = i;
        return t._proxyFormState[a] !== q8.all && (t._proxyFormState[a] = !r || q8.all), n && (n[a] = !0), e[a];
      }
    });
  return o;
}, aN = (e) => Mi(e) && !Object.keys(e).length, sN = (e, t, n, r) => {
  n(e);
  const { name: o, ...i } = e;
  return aN(i) || Object.keys(i).length >= Object.keys(t).length || Object.keys(i).find((a) => t[a] === !0);
}, lN = (e) => Array.isArray(e) ? e : [e], hC = (e, t, n) => !e || !t || e === t || lN(e).some((r) => r && (n ? r === t : r.startsWith(t) || t.startsWith(r)));
function mC(e) {
  const t = j.useRef(e);
  t.current = e, j.useEffect(() => {
    const n = !e.disabled && t.current.subject && t.current.subject.subscribe({
      next: t.current.next
    });
    return () => {
      n && n.unsubscribe();
    };
  }, [e.disabled]);
}
function cN(e) {
  const t = cl(), { control: n = t.control, disabled: r, name: o, exact: i } = e || {}, [a, s] = j.useState(n._formState), l = j.useRef(!0), c = j.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), f = j.useRef(o);
  return f.current = o, mC({
    disabled: r,
    next: (u) => l.current && hC(f.current, u.name, i) && sN(u, c.current, n._updateFormState) && s({
      ...n._formState,
      ...u
    }),
    subject: n._subjects.state
  }), j.useEffect(() => (l.current = !0, c.current.isValid && n._updateValid(!0), () => {
    l.current = !1;
  }), [n]), j.useMemo(() => iN(a, n, c.current, !1), [a, n]);
}
var uN = (e) => typeof e == "string", dN = (e, t, n, r, o) => uN(e) ? sn(n, e, o) : Array.isArray(e) ? e.map((i) => sn(n, i)) : n;
function fN(e) {
  const t = cl(), { control: n = t.control, name: r, defaultValue: o, disabled: i, exact: a } = e || {}, s = j.useRef(r);
  s.current = r, mC({
    disabled: i,
    subject: n._subjects.values,
    next: (f) => {
      hC(s.current, f.name, a) && c(mh(dN(s.current, n._names, f.values || n._formValues, !1, o)));
    }
  });
  const [l, c] = j.useState(n._getWatch(r, o));
  return j.useEffect(() => n._removeUnmounted()), l;
}
function hN(e) {
  const t = cl(), { name: n, disabled: r, control: o = t.control, shouldUnregister: i } = e, a = JO(o._names.array, n), s = fN({
    control: o,
    name: n,
    defaultValue: sn(o._formValues, n, sn(o._defaultValues, n, e.defaultValue)),
    exact: !0
  }), l = cN({
    control: o,
    name: n,
    exact: !0
  }), c = j.useRef(o.register(n, {
    ...e.rules,
    value: s,
    ...$8(e.disabled) ? { disabled: e.disabled } : {}
  })), f = j.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!sn(l.errors, n)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!sn(l.dirtyFields, n)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!sn(l.touchedFields, n)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!sn(l.validatingFields, n)
    },
    error: {
      enumerable: !0,
      get: () => sn(l.errors, n)
    }
  }), [l, n]), u = j.useMemo(() => ({
    name: n,
    value: s,
    ...$8(r) || l.disabled ? { disabled: l.disabled || r } : {},
    onChange: (h) => c.current.onChange({
      target: {
        value: XO(h),
        name: n
      },
      type: W8.CHANGE
    }),
    onBlur: () => c.current.onBlur({
      target: {
        value: sn(o._formValues, n),
        name: n
      },
      type: W8.BLUR
    }),
    ref: (h) => {
      const m = sn(o._fields, n);
      m && h && (m._f.ref = {
        focus: () => h.focus(),
        select: () => h.select(),
        setCustomValidity: (g) => h.setCustomValidity(g),
        reportValidity: () => h.reportValidity()
      });
    }
  }), [
    n,
    o._formValues,
    r,
    l.disabled,
    s,
    o._fields
  ]);
  return j.useEffect(() => {
    const h = o._options.shouldUnregister || i, m = (g, p) => {
      const v = sn(o._fields, g);
      v && v._f && (v._f.mount = p);
    };
    if (m(n, !0), h) {
      const g = mh(sn(o._options.defaultValues, n));
      F8(o._defaultValues, n, g), F2(sn(o._formValues, n)) && F8(o._formValues, n, g);
    }
    return !a && o.register(n), () => {
      (a ? h && !o._state.action : h) ? o.unregister(n) : m(n, !1);
    };
  }, [n, o, a, i]), j.useEffect(() => {
    o._updateDisabledField({
      disabled: r,
      fields: o._fields,
      name: n
    });
  }, [r, n, o]), j.useMemo(() => ({
    field: u,
    formState: l,
    fieldState: f
  }), [u, l, f]);
}
const mN = (e) => e.render(hN(e)), Eee = oN, pC = _o(
  {}
);
function Lee({ ...e }) {
  return /* @__PURE__ */ b(pC.Provider, { value: { name: e.name }, children: /* @__PURE__ */ b(mN, { ...e }) });
}
function ul() {
  const e = Yn(pC), t = Yn(gC), { getFieldState: n, formState: r } = cl(), o = n(e.name, r);
  if (!e)
    throw new Error("useFormField should be used within <FormField>");
  const { id: i } = t;
  return {
    id: i,
    name: e.name,
    formItemId: `${i}-form-item`,
    formDescriptionId: `${i}-form-item-description`,
    formMessageId: `${i}-form-item-message`,
    ...o
  };
}
const gC = _o(
  {}
), pN = fe(({ className: e, ...t }, n) => {
  const r = zS();
  return /* @__PURE__ */ b(gC.Provider, { value: { id: r }, children: /* @__PURE__ */ b("div", { ref: n, className: Q("space-y-2", e), ...t }) });
});
pN.displayName = "LBFormItem";
const gN = fe(({ className: e, ...t }, n) => {
  const { error: r, formItemId: o } = ul();
  return /* @__PURE__ */ b(
    cC,
    {
      ref: n,
      className: Q(r && "text-destructive", e),
      htmlFor: o,
      ...t
    }
  );
});
gN.displayName = "LBFormLabel";
const vN = fe(({ ...e }, t) => {
  const { error: n, formItemId: r, formDescriptionId: o, formMessageId: i } = ul();
  return /* @__PURE__ */ b(
    ng,
    {
      ref: t,
      id: r,
      "aria-describedby": n ? `${o} ${i}` : `${o}`,
      "aria-invalid": !!n,
      ...e
    }
  );
});
vN.displayName = "LBFormControl";
const bN = fe(({ className: e, ...t }, n) => {
  const { formDescriptionId: r } = ul();
  return /* @__PURE__ */ b(
    "p",
    {
      ref: n,
      id: r,
      className: Q("text-[0.8rem] text-muted-foreground", e),
      ...t
    }
  );
});
bN.displayName = "LBFormDescription";
const yN = fe(({ className: e, children: t, ...n }, r) => {
  const { error: o, formMessageId: i } = ul(), a = o ? String(o == null ? void 0 : o.message) : t;
  return a ? /* @__PURE__ */ b(
    "p",
    {
      ref: r,
      id: i,
      className: Q("text-[0.8rem] font-medium text-destructive", e),
      ...n,
      children: a
    }
  ) : null;
});
yN.displayName = "LBFormMessage";
var Gc, dl = "HoverCard", [vC, Tee] = Ot(dl, [
  er
]), fl = er(), [CN, ph] = vC(dl), bC = (e) => {
  const {
    __scopeHoverCard: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    openDelay: a = 700,
    closeDelay: s = 300
  } = e, l = fl(t), c = d.useRef(0), f = d.useRef(0), u = d.useRef(!1), h = d.useRef(!1), [m, g] = Jt({
    prop: r,
    defaultProp: o ?? !1,
    onChange: i,
    caller: dl
  }), p = d.useCallback(() => {
    clearTimeout(f.current), c.current = window.setTimeout(() => g(!0), a);
  }, [a, g]), v = d.useCallback(() => {
    clearTimeout(c.current), !u.current && !h.current && (f.current = window.setTimeout(() => g(!1), s));
  }, [s, g]), y = d.useCallback(() => g(!1), [g]);
  return d.useEffect(() => () => {
    clearTimeout(c.current), clearTimeout(f.current);
  }, []), /* @__PURE__ */ b(
    CN,
    {
      scope: t,
      open: m,
      onOpenChange: g,
      onOpen: p,
      onClose: v,
      onDismiss: y,
      hasSelectionRef: u,
      isPointerDownOnContentRef: h,
      children: /* @__PURE__ */ b(wi, { ...l, children: n })
    }
  );
};
bC.displayName = dl;
var yC = "HoverCardTrigger", CC = d.forwardRef(
  (e, t) => {
    const { __scopeHoverCard: n, ...r } = e, o = ph(yC, n), i = fl(n);
    return /* @__PURE__ */ b(xi, { asChild: !0, ...i, children: /* @__PURE__ */ b(
      ce.a,
      {
        "data-state": o.open ? "open" : "closed",
        ...r,
        ref: t,
        onPointerEnter: ne(e.onPointerEnter, r0(o.onOpen)),
        onPointerLeave: ne(e.onPointerLeave, r0(o.onClose)),
        onFocus: ne(e.onFocus, o.onOpen),
        onBlur: ne(e.onBlur, o.onClose),
        onTouchStart: ne(e.onTouchStart, (a) => a.preventDefault())
      }
    ) });
  }
);
CC.displayName = yC;
var wN = "HoverCardPortal", [Pee, xN] = vC(wN, {
  forceMount: void 0
}), n0 = "HoverCardContent", wC = d.forwardRef(
  (e, t) => {
    const n = xN(n0, e.__scopeHoverCard), { forceMount: r = n.forceMount, ...o } = e, i = ph(n0, e.__scopeHoverCard);
    return /* @__PURE__ */ b(Nt, { present: r || i.open, children: /* @__PURE__ */ b(
      _N,
      {
        "data-state": i.open ? "open" : "closed",
        ...o,
        onPointerEnter: ne(e.onPointerEnter, r0(i.onOpen)),
        onPointerLeave: ne(e.onPointerLeave, r0(i.onClose)),
        ref: t
      }
    ) });
  }
);
wC.displayName = n0;
var _N = d.forwardRef((e, t) => {
  const {
    __scopeHoverCard: n,
    onEscapeKeyDown: r,
    onPointerDownOutside: o,
    onFocusOutside: i,
    onInteractOutside: a,
    ...s
  } = e, l = ph(n0, n), c = fl(n), f = d.useRef(null), u = ke(t, f), [h, m] = d.useState(!1);
  return d.useEffect(() => {
    if (h) {
      const g = document.body;
      return Gc = g.style.userSelect || g.style.webkitUserSelect, g.style.userSelect = "none", g.style.webkitUserSelect = "none", () => {
        g.style.userSelect = Gc, g.style.webkitUserSelect = Gc;
      };
    }
  }, [h]), d.useEffect(() => {
    if (f.current) {
      const g = () => {
        m(!1), l.isPointerDownOnContentRef.current = !1, setTimeout(() => {
          var v;
          ((v = document.getSelection()) == null ? void 0 : v.toString()) !== "" && (l.hasSelectionRef.current = !0);
        });
      };
      return document.addEventListener("pointerup", g), () => {
        document.removeEventListener("pointerup", g), l.hasSelectionRef.current = !1, l.isPointerDownOnContentRef.current = !1;
      };
    }
  }, [l.isPointerDownOnContentRef, l.hasSelectionRef]), d.useEffect(() => {
    f.current && MN(f.current).forEach((p) => p.setAttribute("tabindex", "-1"));
  }), /* @__PURE__ */ b(
    So,
    {
      asChild: !0,
      disableOutsidePointerEvents: !1,
      onInteractOutside: a,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: ne(i, (g) => {
        g.preventDefault();
      }),
      onDismiss: l.onDismiss,
      children: /* @__PURE__ */ b(
        Ka,
        {
          ...c,
          ...s,
          onPointerDown: ne(s.onPointerDown, (g) => {
            g.currentTarget.contains(g.target) && m(!0), l.hasSelectionRef.current = !1, l.isPointerDownOnContentRef.current = !0;
          }),
          ref: u,
          style: {
            ...s.style,
            userSelect: h ? "text" : void 0,
            // Safari requires prefix
            WebkitUserSelect: h ? "text" : void 0,
            "--radix-hover-card-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-hover-card-content-available-width": "var(--radix-popper-available-width)",
            "--radix-hover-card-content-available-height": "var(--radix-popper-available-height)",
            "--radix-hover-card-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-hover-card-trigger-height": "var(--radix-popper-anchor-height)"
          }
        }
      )
    }
  );
}), kN = "HoverCardArrow", SN = d.forwardRef(
  (e, t) => {
    const { __scopeHoverCard: n, ...r } = e, o = fl(n);
    return /* @__PURE__ */ b(Za, { ...o, ...r, ref: t });
  }
);
SN.displayName = kN;
function r0(e) {
  return (t) => t.pointerType === "touch" ? void 0 : e();
}
function MN(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
var EN = bC, LN = CC, TN = wC;
const Ree = EN, Aee = LN, PN = fe(({ className: e, align: t = "center", sideOffset: n = 4, ...r }, o) => /* @__PURE__ */ b(
  TN,
  {
    ref: o,
    align: t,
    sideOffset: n,
    className: Q(
      "z-50 w-64 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...r
  }
));
PN.displayName = "LBHoverCardContent";
var gh = "Radio", [RN, xC] = Ot(gh), [AN, ON] = RN(gh), _C = d.forwardRef(
  (e, t) => {
    const {
      __scopeRadio: n,
      name: r,
      checked: o = !1,
      required: i,
      disabled: a,
      value: s = "on",
      onCheck: l,
      form: c,
      ...f
    } = e, [u, h] = d.useState(null), m = ke(t, (v) => h(v)), g = d.useRef(!1), p = u ? c || !!u.closest("form") : !0;
    return /* @__PURE__ */ ie(AN, { scope: n, checked: o, disabled: a, children: [
      /* @__PURE__ */ b(
        ce.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": o,
          "data-state": EC(o),
          "data-disabled": a ? "" : void 0,
          disabled: a,
          value: s,
          ...f,
          ref: m,
          onClick: ne(e.onClick, (v) => {
            o || l == null || l(), p && (g.current = v.isPropagationStopped(), g.current || v.stopPropagation());
          })
        }
      ),
      p && /* @__PURE__ */ b(
        MC,
        {
          control: u,
          bubbles: !g.current,
          name: r,
          value: s,
          checked: o,
          required: i,
          disabled: a,
          form: c,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
_C.displayName = gh;
var kC = "RadioIndicator", SC = d.forwardRef(
  (e, t) => {
    const { __scopeRadio: n, forceMount: r, ...o } = e, i = ON(kC, n);
    return /* @__PURE__ */ b(Nt, { present: r || i.checked, children: /* @__PURE__ */ b(
      ce.span,
      {
        "data-state": EC(i.checked),
        "data-disabled": i.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    ) });
  }
);
SC.displayName = kC;
var NN = "RadioBubbleInput", MC = d.forwardRef(
  ({
    __scopeRadio: e,
    control: t,
    checked: n,
    bubbles: r = !0,
    ...o
  }, i) => {
    const a = d.useRef(null), s = ke(a, i), l = z0(n), c = $0(t);
    return d.useEffect(() => {
      const f = a.current;
      if (!f) return;
      const u = window.HTMLInputElement.prototype, m = Object.getOwnPropertyDescriptor(
        u,
        "checked"
      ).set;
      if (l !== n && m) {
        const g = new Event("click", { bubbles: r });
        m.call(f, n), f.dispatchEvent(g);
      }
    }, [l, n, r]), /* @__PURE__ */ b(
      ce.input,
      {
        type: "radio",
        "aria-hidden": !0,
        defaultChecked: n,
        ...o,
        tabIndex: -1,
        ref: s,
        style: {
          ...o.style,
          ...c,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
MC.displayName = NN;
function EC(e) {
  return e ? "checked" : "unchecked";
}
var DN = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], hl = "RadioGroup", [IN, Oee] = Ot(hl, [
  bi,
  xC
]), LC = bi(), TC = xC(), [BN, $N] = IN(hl), PC = d.forwardRef(
  (e, t) => {
    const {
      __scopeRadioGroup: n,
      name: r,
      defaultValue: o,
      value: i,
      required: a = !1,
      disabled: s = !1,
      orientation: l,
      dir: c,
      loop: f = !0,
      onValueChange: u,
      ...h
    } = e, m = LC(n), g = ko(c), [p, v] = Jt({
      prop: i,
      defaultProp: o ?? null,
      onChange: u,
      caller: hl
    });
    return /* @__PURE__ */ b(
      BN,
      {
        scope: n,
        name: r,
        required: a,
        disabled: s,
        value: p,
        onValueChange: v,
        children: /* @__PURE__ */ b(
          E9,
          {
            asChild: !0,
            ...m,
            orientation: l,
            dir: g,
            loop: f,
            children: /* @__PURE__ */ b(
              ce.div,
              {
                role: "radiogroup",
                "aria-required": a,
                "aria-orientation": l,
                "data-disabled": s ? "" : void 0,
                dir: g,
                ...h,
                ref: t
              }
            )
          }
        )
      }
    );
  }
);
PC.displayName = hl;
var RC = "RadioGroupItem", AC = d.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, disabled: r, ...o } = e, i = $N(RC, n), a = i.disabled || r, s = LC(n), l = TC(n), c = d.useRef(null), f = ke(t, c), u = i.value === o.value, h = d.useRef(!1);
    return d.useEffect(() => {
      const m = (p) => {
        DN.includes(p.key) && (h.current = !0);
      }, g = () => h.current = !1;
      return document.addEventListener("keydown", m), document.addEventListener("keyup", g), () => {
        document.removeEventListener("keydown", m), document.removeEventListener("keyup", g);
      };
    }, []), /* @__PURE__ */ b(
      L9,
      {
        asChild: !0,
        ...s,
        focusable: !a,
        active: u,
        children: /* @__PURE__ */ b(
          _C,
          {
            disabled: a,
            required: i.required,
            checked: u,
            ...l,
            ...o,
            name: i.name,
            ref: f,
            onCheck: () => i.onValueChange(o.value),
            onKeyDown: ne((m) => {
              m.key === "Enter" && m.preventDefault();
            }),
            onFocus: ne(o.onFocus, () => {
              var m;
              h.current && ((m = c.current) == null || m.click());
            })
          }
        )
      }
    );
  }
);
AC.displayName = RC;
var FN = "RadioGroupIndicator", OC = d.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, ...r } = e, o = TC(n);
    return /* @__PURE__ */ b(SC, { ...o, ...r, ref: t });
  }
);
OC.displayName = FN;
var WN = PC, qN = AC, jN = OC;
const HN = fe(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  WN,
  {
    className: Q("grid gap-6", e),
    ...t,
    ref: n
  }
));
HN.displayName = "LBRadioGroup";
const VN = fe(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  qN,
  {
    ref: n,
    className: Q(
      "peer group aspect-square size-5 rounded-full border border-primary text-primary focus:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 enabled:hover:border-indigo-500",
      e
    ),
    ...t,
    children: /* @__PURE__ */ b(jN, { className: "flex items-center justify-center", children: /* @__PURE__ */ b(G9, { className: "size-4 fill-primary group-hover:fill-indigo-500 group-hover:text-indigo-500" }) })
  }
));
VN.displayName = "LBRadioGroupItem";
const UN = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ b("div", { className: "relative w-full overflow-auto", children: /* @__PURE__ */ b(
  "table",
  {
    ref: n,
    className: Q("w-full caption-bottom text-sm", e),
    ...t
  }
) }));
UN.displayName = "LBTable";
const zN = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ b("thead", { ref: n, className: Q("[&_tr]:border-b", e), ...t }));
zN.displayName = "LBTableHeader";
const YN = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  "tbody",
  {
    ref: n,
    className: Q("[&_tr:last-child]:border-0", e),
    ...t
  }
));
YN.displayName = "LBTableBody";
const GN = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  "tfoot",
  {
    ref: n,
    className: Q(
      "border-t bg-muted/50 font-medium [&>tr]:last:border-b-0",
      e
    ),
    ...t
  }
));
GN.displayName = "LBTableFooter";
const KN = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  "tr",
  {
    ref: n,
    className: Q(
      "border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted",
      e
    ),
    ...t
  }
));
KN.displayName = "LBTableRow";
const ZN = d.forwardRef(({ className: e, width: t, ...n }, r) => {
  const o = typeof t < "u", i = o ? { "--lb-header-width": `${t}px` } : void 0;
  return /* @__PURE__ */ b(
    "th",
    {
      style: i,
      ref: r,
      className: Q(
        "h-10 px-2 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
        { "max-w-[var(--lb-header-width)]": o },
        e
      ),
      ...n
    }
  );
});
ZN.displayName = "LBTableHead";
const XN = d.forwardRef(({ className: e, width: t, ...n }, r) => {
  const o = typeof t < "u", i = o ? { "--lb-cell-width": `${t}px` } : void 0;
  return /* @__PURE__ */ b(
    "td",
    {
      style: i,
      ref: r,
      className: Q(
        "p-2 align-middle [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
        { "max-w-[var(--lb-cell-width)]": o },
        e
      ),
      ...n
    }
  );
});
XN.displayName = "LBTableCell";
const QN = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  "caption",
  {
    ref: n,
    className: Q("mt-4 text-sm text-muted-foreground", e),
    ...t
  }
));
QN.displayName = "LBTableCaption";
function JN({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ b(
    "nav",
    {
      role: "navigation",
      "aria-label": "pagination",
      className: Q("mx-auto flex w-full justify-center", e),
      ...t
    }
  );
}
JN.displayName = "LBPagination";
const eD = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  "ul",
  {
    ref: n,
    className: Q("flex flex-row items-center gap-1", e),
    ...t
  }
));
eD.displayName = "LBPaginationContent";
const tD = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ b("li", { ref: n, className: Q("", e), ...t }));
tD.displayName = "LBPaginationItem";
function vh({
  className: e,
  isActive: t,
  size: n = "icon",
  ...r
}) {
  return /* @__PURE__ */ b(
    Or,
    {
      "aria-current": t ? "page" : void 0,
      variant: t ? "outline" : "ghost",
      size: n,
      className: e,
      ...r
    }
  );
}
vh.displayName = "LBPaginationLink";
function nD({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ ie(
    vh,
    {
      "aria-label": "Go to previous page",
      size: "default",
      className: Q("gap-1 pl-3", e),
      ...t,
      children: [
        /* @__PURE__ */ b(HP, { className: "size-4" }),
        /* @__PURE__ */ b("span", { children: "Previous" })
      ]
    }
  );
}
nD.displayName = "LBPaginationPrevious";
function rD({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ ie(
    vh,
    {
      "aria-label": "Go to next page",
      size: "default",
      className: Q("gap-1 pr-3", e),
      ...t,
      children: [
        /* @__PURE__ */ b("span", { children: "Next" }),
        /* @__PURE__ */ b(Xv, { className: "size-4" })
      ]
    }
  );
}
rD.displayName = "LBPaginationNext";
function oD({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ ie(
    "span",
    {
      "aria-hidden": !0,
      className: Q("flex h-9 w-9 items-center justify-center", e),
      ...t,
      children: [
        /* @__PURE__ */ b(zP, { className: "size-4 rotate-90" }),
        /* @__PURE__ */ b("span", { className: "sr-only", children: "More pages" })
      ]
    }
  );
}
oD.displayName = "LBPaginationEllipsis";
const iD = rl;
iD.displayName = "LBSheet";
const aD = rh;
aD.displayName = "LBSheetTrigger";
const Nee = os, sD = ol, NC = fe(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  rs,
  {
    className: Q(
      "fixed inset-0 z-50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t,
    ref: n
  }
));
NC.displayName = rs.displayName;
const lD = Dn(
  "fixed z-50 gap-4 bg-background p-6 shadow-lg transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500 data-[state=open]:animate-in data-[state=closed]:animate-out",
  {
    variants: {
      side: {
        top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
        bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
        left: "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
        right: "inset-y-0 right-0 h-full w-3/4 border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }
), cD = fe(({ side: e = "right", className: t, children: n, ...r }, o) => /* @__PURE__ */ ie(sD, { children: [
  /* @__PURE__ */ b(NC, {}),
  /* @__PURE__ */ ie(
    Si,
    {
      ref: o,
      className: Q(lD({ side: e }), t),
      ...r,
      children: [
        /* @__PURE__ */ ie(os, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-secondary", children: [
          /* @__PURE__ */ b(ts, { className: "size-3" }),
          /* @__PURE__ */ b("span", { className: "sr-only", children: "Close" })
        ] }),
        n
      ]
    }
  )
] }));
cD.displayName = Si.displayName;
function uD({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ b(
    "div",
    {
      className: Q(
        "flex flex-col space-y-2 text-center sm:text-left",
        e
      ),
      ...t
    }
  );
}
uD.displayName = "LBSheetHeader";
const dD = fe(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  il,
  {
    ref: n,
    className: Q("text-lg font-semibold text-foreground", e),
    ...t
  }
));
dD.displayName = "LBSheetTitle";
const fD = fe(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  oh,
  {
    ref: n,
    className: Q("text-sm text-muted-foreground", e),
    ...t
  }
));
fD.displayName = "LBSheetDescription";
function hD(e) {
  if (typeof document > "u") return;
  let t = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
  n.type = "text/css", t.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
}
const mD = (e) => {
  switch (e) {
    case "success":
      return vD;
    case "info":
      return yD;
    case "warning":
      return bD;
    case "error":
      return CD;
    default:
      return null;
  }
}, pD = Array(12).fill(0), gD = ({ visible: e, className: t }) => /* @__PURE__ */ j.createElement("div", {
  className: [
    "sonner-loading-wrapper",
    t
  ].filter(Boolean).join(" "),
  "data-visible": e
}, /* @__PURE__ */ j.createElement("div", {
  className: "sonner-spinner"
}, pD.map((n, r) => /* @__PURE__ */ j.createElement("div", {
  className: "sonner-loading-bar",
  key: `spinner-bar-${r}`
})))), vD = /* @__PURE__ */ j.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ j.createElement("path", {
  fillRule: "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z",
  clipRule: "evenodd"
})), bD = /* @__PURE__ */ j.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ j.createElement("path", {
  fillRule: "evenodd",
  d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
  clipRule: "evenodd"
})), yD = /* @__PURE__ */ j.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ j.createElement("path", {
  fillRule: "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z",
  clipRule: "evenodd"
})), CD = /* @__PURE__ */ j.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ j.createElement("path", {
  fillRule: "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z",
  clipRule: "evenodd"
})), wD = /* @__PURE__ */ j.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /* @__PURE__ */ j.createElement("line", {
  x1: "18",
  y1: "6",
  x2: "6",
  y2: "18"
}), /* @__PURE__ */ j.createElement("line", {
  x1: "6",
  y1: "6",
  x2: "18",
  y2: "18"
})), xD = () => {
  const [e, t] = j.useState(document.hidden);
  return j.useEffect(() => {
    const n = () => {
      t(document.hidden);
    };
    return document.addEventListener("visibilitychange", n), () => window.removeEventListener("visibilitychange", n);
  }, []), e;
};
let W2 = 1;
class _D {
  constructor() {
    this.subscribe = (t) => (this.subscribers.push(t), () => {
      const n = this.subscribers.indexOf(t);
      this.subscribers.splice(n, 1);
    }), this.publish = (t) => {
      this.subscribers.forEach((n) => n(t));
    }, this.addToast = (t) => {
      this.publish(t), this.toasts = [
        ...this.toasts,
        t
      ];
    }, this.create = (t) => {
      var n;
      const { message: r, ...o } = t, i = typeof (t == null ? void 0 : t.id) == "number" || ((n = t.id) == null ? void 0 : n.length) > 0 ? t.id : W2++, a = this.toasts.find((l) => l.id === i), s = t.dismissible === void 0 ? !0 : t.dismissible;
      return this.dismissedToasts.has(i) && this.dismissedToasts.delete(i), a ? this.toasts = this.toasts.map((l) => l.id === i ? (this.publish({
        ...l,
        ...t,
        id: i,
        title: r
      }), {
        ...l,
        ...t,
        id: i,
        dismissible: s,
        title: r
      }) : l) : this.addToast({
        title: r,
        ...o,
        dismissible: s,
        id: i
      }), i;
    }, this.dismiss = (t) => (t ? (this.dismissedToasts.add(t), requestAnimationFrame(() => this.subscribers.forEach((n) => n({
      id: t,
      dismiss: !0
    })))) : this.toasts.forEach((n) => {
      this.subscribers.forEach((r) => r({
        id: n.id,
        dismiss: !0
      }));
    }), t), this.message = (t, n) => this.create({
      ...n,
      message: t
    }), this.error = (t, n) => this.create({
      ...n,
      message: t,
      type: "error"
    }), this.success = (t, n) => this.create({
      ...n,
      type: "success",
      message: t
    }), this.info = (t, n) => this.create({
      ...n,
      type: "info",
      message: t
    }), this.warning = (t, n) => this.create({
      ...n,
      type: "warning",
      message: t
    }), this.loading = (t, n) => this.create({
      ...n,
      type: "loading",
      message: t
    }), this.promise = (t, n) => {
      if (!n)
        return;
      let r;
      n.loading !== void 0 && (r = this.create({
        ...n,
        promise: t,
        type: "loading",
        message: n.loading,
        description: typeof n.description != "function" ? n.description : void 0
      }));
      const o = Promise.resolve(t instanceof Function ? t() : t);
      let i = r !== void 0, a;
      const s = o.then(async (c) => {
        if (a = [
          "resolve",
          c
        ], j.isValidElement(c))
          i = !1, this.create({
            id: r,
            type: "default",
            message: c
          });
        else if (SD(c) && !c.ok) {
          i = !1;
          const u = typeof n.error == "function" ? await n.error(`HTTP error! status: ${c.status}`) : n.error, h = typeof n.description == "function" ? await n.description(`HTTP error! status: ${c.status}`) : n.description, g = typeof u == "object" && !j.isValidElement(u) ? u : {
            message: u
          };
          this.create({
            id: r,
            type: "error",
            description: h,
            ...g
          });
        } else if (c instanceof Error) {
          i = !1;
          const u = typeof n.error == "function" ? await n.error(c) : n.error, h = typeof n.description == "function" ? await n.description(c) : n.description, g = typeof u == "object" && !j.isValidElement(u) ? u : {
            message: u
          };
          this.create({
            id: r,
            type: "error",
            description: h,
            ...g
          });
        } else if (n.success !== void 0) {
          i = !1;
          const u = typeof n.success == "function" ? await n.success(c) : n.success, h = typeof n.description == "function" ? await n.description(c) : n.description, g = typeof u == "object" && !j.isValidElement(u) ? u : {
            message: u
          };
          this.create({
            id: r,
            type: "success",
            description: h,
            ...g
          });
        }
      }).catch(async (c) => {
        if (a = [
          "reject",
          c
        ], n.error !== void 0) {
          i = !1;
          const f = typeof n.error == "function" ? await n.error(c) : n.error, u = typeof n.description == "function" ? await n.description(c) : n.description, m = typeof f == "object" && !j.isValidElement(f) ? f : {
            message: f
          };
          this.create({
            id: r,
            type: "error",
            description: u,
            ...m
          });
        }
      }).finally(() => {
        i && (this.dismiss(r), r = void 0), n.finally == null || n.finally.call(n);
      }), l = () => new Promise((c, f) => s.then(() => a[0] === "reject" ? f(a[1]) : c(a[1])).catch(f));
      return typeof r != "string" && typeof r != "number" ? {
        unwrap: l
      } : Object.assign(r, {
        unwrap: l
      });
    }, this.custom = (t, n) => {
      const r = (n == null ? void 0 : n.id) || W2++;
      return this.create({
        jsx: t(r),
        id: r,
        ...n
      }), r;
    }, this.getActiveToasts = () => this.toasts.filter((t) => !this.dismissedToasts.has(t.id)), this.subscribers = [], this.toasts = [], this.dismissedToasts = /* @__PURE__ */ new Set();
  }
}
const ln = new _D(), kD = (e, t) => {
  const n = (t == null ? void 0 : t.id) || W2++;
  return ln.addToast({
    title: e,
    ...t,
    id: n
  }), n;
}, SD = (e) => e && typeof e == "object" && "ok" in e && typeof e.ok == "boolean" && "status" in e && typeof e.status == "number", MD = kD, ED = () => ln.toasts, LD = () => ln.getActiveToasts(), q2 = Object.assign(MD, {
  success: ln.success,
  info: ln.info,
  warning: ln.warning,
  error: ln.error,
  custom: ln.custom,
  message: ln.message,
  promise: ln.promise,
  dismiss: ln.dismiss,
  loading: ln.loading
}, {
  getHistory: ED,
  getToasts: LD
});
hD("[data-sonner-toaster][dir=ltr],html[dir=ltr]{--toast-icon-margin-start:-3px;--toast-icon-margin-end:4px;--toast-svg-margin-start:-1px;--toast-svg-margin-end:0px;--toast-button-margin-start:auto;--toast-button-margin-end:0;--toast-close-button-start:0;--toast-close-button-end:unset;--toast-close-button-transform:translate(-35%, -35%)}[data-sonner-toaster][dir=rtl],html[dir=rtl]{--toast-icon-margin-start:4px;--toast-icon-margin-end:-3px;--toast-svg-margin-start:0px;--toast-svg-margin-end:-1px;--toast-button-margin-start:0;--toast-button-margin-end:auto;--toast-close-button-start:unset;--toast-close-button-end:0;--toast-close-button-transform:translate(35%, -35%)}[data-sonner-toaster]{position:fixed;width:var(--width);font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;--gray1:hsl(0, 0%, 99%);--gray2:hsl(0, 0%, 97.3%);--gray3:hsl(0, 0%, 95.1%);--gray4:hsl(0, 0%, 93%);--gray5:hsl(0, 0%, 90.9%);--gray6:hsl(0, 0%, 88.7%);--gray7:hsl(0, 0%, 85.8%);--gray8:hsl(0, 0%, 78%);--gray9:hsl(0, 0%, 56.1%);--gray10:hsl(0, 0%, 52.3%);--gray11:hsl(0, 0%, 43.5%);--gray12:hsl(0, 0%, 9%);--border-radius:8px;box-sizing:border-box;padding:0;margin:0;list-style:none;outline:0;z-index:999999999;transition:transform .4s ease}@media (hover:none) and (pointer:coarse){[data-sonner-toaster][data-lifted=true]{transform:none}}[data-sonner-toaster][data-x-position=right]{right:var(--offset-right)}[data-sonner-toaster][data-x-position=left]{left:var(--offset-left)}[data-sonner-toaster][data-x-position=center]{left:50%;transform:translateX(-50%)}[data-sonner-toaster][data-y-position=top]{top:var(--offset-top)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--offset-bottom)}[data-sonner-toast]{--y:translateY(100%);--lift-amount:calc(var(--lift) * var(--gap));z-index:var(--z-index);position:absolute;opacity:0;transform:var(--y);touch-action:none;transition:transform .4s,opacity .4s,height .4s,box-shadow .2s;box-sizing:border-box;outline:0;overflow-wrap:anywhere}[data-sonner-toast][data-styled=true]{padding:16px;background:var(--normal-bg);border:1px solid var(--normal-border);color:var(--normal-text);border-radius:var(--border-radius);box-shadow:0 4px 12px rgba(0,0,0,.1);width:var(--width);font-size:13px;display:flex;align-items:center;gap:6px}[data-sonner-toast]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-y-position=top]{top:0;--y:translateY(-100%);--lift:1;--lift-amount:calc(1 * var(--gap))}[data-sonner-toast][data-y-position=bottom]{bottom:0;--y:translateY(100%);--lift:-1;--lift-amount:calc(var(--lift) * var(--gap))}[data-sonner-toast][data-styled=true] [data-description]{font-weight:400;line-height:1.4;color:#3f3f3f}[data-rich-colors=true][data-sonner-toast][data-styled=true] [data-description]{color:inherit}[data-sonner-toaster][data-sonner-theme=dark] [data-description]{color:#e8e8e8}[data-sonner-toast][data-styled=true] [data-title]{font-weight:500;line-height:1.5;color:inherit}[data-sonner-toast][data-styled=true] [data-icon]{display:flex;height:16px;width:16px;position:relative;justify-content:flex-start;align-items:center;flex-shrink:0;margin-left:var(--toast-icon-margin-start);margin-right:var(--toast-icon-margin-end)}[data-sonner-toast][data-promise=true] [data-icon]>svg{opacity:0;transform:scale(.8);transform-origin:center;animation:sonner-fade-in .3s ease forwards}[data-sonner-toast][data-styled=true] [data-icon]>*{flex-shrink:0}[data-sonner-toast][data-styled=true] [data-icon] svg{margin-left:var(--toast-svg-margin-start);margin-right:var(--toast-svg-margin-end)}[data-sonner-toast][data-styled=true] [data-content]{display:flex;flex-direction:column;gap:2px}[data-sonner-toast][data-styled=true] [data-button]{border-radius:4px;padding-left:8px;padding-right:8px;height:24px;font-size:12px;color:var(--normal-bg);background:var(--normal-text);margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end);border:none;font-weight:500;cursor:pointer;outline:0;display:flex;align-items:center;flex-shrink:0;transition:opacity .4s,box-shadow .2s}[data-sonner-toast][data-styled=true] [data-button]:focus-visible{box-shadow:0 0 0 2px rgba(0,0,0,.4)}[data-sonner-toast][data-styled=true] [data-button]:first-of-type{margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}[data-sonner-toast][data-styled=true] [data-cancel]{color:var(--normal-text);background:rgba(0,0,0,.08)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-styled=true] [data-cancel]{background:rgba(255,255,255,.3)}[data-sonner-toast][data-styled=true] [data-close-button]{position:absolute;left:var(--toast-close-button-start);right:var(--toast-close-button-end);top:0;height:20px;width:20px;display:flex;justify-content:center;align-items:center;padding:0;color:var(--gray12);background:var(--normal-bg);border:1px solid var(--gray4);transform:var(--toast-close-button-transform);border-radius:50%;cursor:pointer;z-index:1;transition:opacity .1s,background .2s,border-color .2s}[data-sonner-toast][data-styled=true] [data-close-button]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-styled=true] [data-disabled=true]{cursor:not-allowed}[data-sonner-toast][data-styled=true]:hover [data-close-button]:hover{background:var(--gray2);border-color:var(--gray5)}[data-sonner-toast][data-swiping=true]::before{content:'';position:absolute;left:-100%;right:-100%;height:100%;z-index:-1}[data-sonner-toast][data-y-position=top][data-swiping=true]::before{bottom:50%;transform:scaleY(3) translateY(50%)}[data-sonner-toast][data-y-position=bottom][data-swiping=true]::before{top:50%;transform:scaleY(3) translateY(-50%)}[data-sonner-toast][data-swiping=false][data-removed=true]::before{content:'';position:absolute;inset:0;transform:scaleY(2)}[data-sonner-toast][data-expanded=true]::after{content:'';position:absolute;left:0;height:calc(var(--gap) + 1px);bottom:100%;width:100%}[data-sonner-toast][data-mounted=true]{--y:translateY(0);opacity:1}[data-sonner-toast][data-expanded=false][data-front=false]{--scale:var(--toasts-before) * 0.05 + 1;--y:translateY(calc(var(--lift-amount) * var(--toasts-before))) scale(calc(-1 * var(--scale)));height:var(--front-toast-height)}[data-sonner-toast]>*{transition:opacity .4s}[data-sonner-toast][data-x-position=right]{right:0}[data-sonner-toast][data-x-position=left]{left:0}[data-sonner-toast][data-expanded=false][data-front=false][data-styled=true]>*{opacity:0}[data-sonner-toast][data-visible=false]{opacity:0;pointer-events:none}[data-sonner-toast][data-mounted=true][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset)));height:var(--initial-height)}[data-sonner-toast][data-removed=true][data-front=true][data-swipe-out=false]{--y:translateY(calc(var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset) + var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=false]{--y:translateY(40%);opacity:0;transition:transform .5s,opacity .2s}[data-sonner-toast][data-removed=true][data-front=false]::before{height:calc(var(--initial-height) + 20%)}[data-sonner-toast][data-swiping=true]{transform:var(--y) translateY(var(--swipe-amount-y,0)) translateX(var(--swipe-amount-x,0));transition:none}[data-sonner-toast][data-swiped=true]{user-select:none}[data-sonner-toast][data-swipe-out=true][data-y-position=bottom],[data-sonner-toast][data-swipe-out=true][data-y-position=top]{animation-duration:.2s;animation-timing-function:ease-out;animation-fill-mode:forwards}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=left]{animation-name:swipe-out-left}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=right]{animation-name:swipe-out-right}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=up]{animation-name:swipe-out-up}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=down]{animation-name:swipe-out-down}@keyframes swipe-out-left{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) - 100%));opacity:0}}@keyframes swipe-out-right{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) + 100%));opacity:0}}@keyframes swipe-out-up{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) - 100%));opacity:0}}@keyframes swipe-out-down{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) + 100%));opacity:0}}@media (max-width:600px){[data-sonner-toaster]{position:fixed;right:var(--mobile-offset-right);left:var(--mobile-offset-left);width:100%}[data-sonner-toaster][dir=rtl]{left:calc(var(--mobile-offset-left) * -1)}[data-sonner-toaster] [data-sonner-toast]{left:0;right:0;width:calc(100% - var(--mobile-offset-left) * 2)}[data-sonner-toaster][data-x-position=left]{left:var(--mobile-offset-left)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--mobile-offset-bottom)}[data-sonner-toaster][data-y-position=top]{top:var(--mobile-offset-top)}[data-sonner-toaster][data-x-position=center]{left:var(--mobile-offset-left);right:var(--mobile-offset-right);transform:none}}[data-sonner-toaster][data-sonner-theme=light]{--normal-bg:#fff;--normal-border:var(--gray4);--normal-text:var(--gray12);--success-bg:hsl(143, 85%, 96%);--success-border:hsl(145, 92%, 87%);--success-text:hsl(140, 100%, 27%);--info-bg:hsl(208, 100%, 97%);--info-border:hsl(221, 91%, 93%);--info-text:hsl(210, 92%, 45%);--warning-bg:hsl(49, 100%, 97%);--warning-border:hsl(49, 91%, 84%);--warning-text:hsl(31, 92%, 45%);--error-bg:hsl(359, 100%, 97%);--error-border:hsl(359, 100%, 94%);--error-text:hsl(360, 100%, 45%)}[data-sonner-toaster][data-sonner-theme=light] [data-sonner-toast][data-invert=true]{--normal-bg:#000;--normal-border:hsl(0, 0%, 20%);--normal-text:var(--gray1)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-invert=true]{--normal-bg:#fff;--normal-border:var(--gray3);--normal-text:var(--gray12)}[data-sonner-toaster][data-sonner-theme=dark]{--normal-bg:#000;--normal-bg-hover:hsl(0, 0%, 12%);--normal-border:hsl(0, 0%, 20%);--normal-border-hover:hsl(0, 0%, 25%);--normal-text:var(--gray1);--success-bg:hsl(150, 100%, 6%);--success-border:hsl(147, 100%, 12%);--success-text:hsl(150, 86%, 65%);--info-bg:hsl(215, 100%, 6%);--info-border:hsl(223, 43%, 17%);--info-text:hsl(216, 87%, 65%);--warning-bg:hsl(64, 100%, 6%);--warning-border:hsl(60, 100%, 9%);--warning-text:hsl(46, 87%, 65%);--error-bg:hsl(358, 76%, 10%);--error-border:hsl(357, 89%, 16%);--error-text:hsl(358, 100%, 81%)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]{background:var(--normal-bg);border-color:var(--normal-border);color:var(--normal-text)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]:hover{background:var(--normal-bg-hover);border-color:var(--normal-border-hover)}[data-rich-colors=true][data-sonner-toast][data-type=success]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=success] [data-close-button]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=info]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=info] [data-close-button]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning] [data-close-button]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=error]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}[data-rich-colors=true][data-sonner-toast][data-type=error] [data-close-button]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}.sonner-loading-wrapper{--size:16px;height:var(--size);width:var(--size);position:absolute;inset:0;z-index:10}.sonner-loading-wrapper[data-visible=false]{transform-origin:center;animation:sonner-fade-out .2s ease forwards}.sonner-spinner{position:relative;top:50%;left:50%;height:var(--size);width:var(--size)}.sonner-loading-bar{animation:sonner-spin 1.2s linear infinite;background:var(--gray11);border-radius:6px;height:8%;left:-10%;position:absolute;top:-3.9%;width:24%}.sonner-loading-bar:first-child{animation-delay:-1.2s;transform:rotate(.0001deg) translate(146%)}.sonner-loading-bar:nth-child(2){animation-delay:-1.1s;transform:rotate(30deg) translate(146%)}.sonner-loading-bar:nth-child(3){animation-delay:-1s;transform:rotate(60deg) translate(146%)}.sonner-loading-bar:nth-child(4){animation-delay:-.9s;transform:rotate(90deg) translate(146%)}.sonner-loading-bar:nth-child(5){animation-delay:-.8s;transform:rotate(120deg) translate(146%)}.sonner-loading-bar:nth-child(6){animation-delay:-.7s;transform:rotate(150deg) translate(146%)}.sonner-loading-bar:nth-child(7){animation-delay:-.6s;transform:rotate(180deg) translate(146%)}.sonner-loading-bar:nth-child(8){animation-delay:-.5s;transform:rotate(210deg) translate(146%)}.sonner-loading-bar:nth-child(9){animation-delay:-.4s;transform:rotate(240deg) translate(146%)}.sonner-loading-bar:nth-child(10){animation-delay:-.3s;transform:rotate(270deg) translate(146%)}.sonner-loading-bar:nth-child(11){animation-delay:-.2s;transform:rotate(300deg) translate(146%)}.sonner-loading-bar:nth-child(12){animation-delay:-.1s;transform:rotate(330deg) translate(146%)}@keyframes sonner-fade-in{0%{opacity:0;transform:scale(.8)}100%{opacity:1;transform:scale(1)}}@keyframes sonner-fade-out{0%{opacity:1;transform:scale(1)}100%{opacity:0;transform:scale(.8)}}@keyframes sonner-spin{0%{opacity:1}100%{opacity:.15}}@media (prefers-reduced-motion){.sonner-loading-bar,[data-sonner-toast],[data-sonner-toast]>*{transition:none!important;animation:none!important}}.sonner-loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transform-origin:center;transition:opacity .2s,transform .2s}.sonner-loader[data-visible=false]{opacity:0;transform:scale(.8) translate(-50%,-50%)}");
function Ts(e) {
  return e.label !== void 0;
}
const TD = 3, PD = "24px", RD = "16px", j8 = 4e3, AD = 356, OD = 14, ND = 45, DD = 200;
function Wn(...e) {
  return e.filter(Boolean).join(" ");
}
function ID(e) {
  const [t, n] = e.split("-"), r = [];
  return t && r.push(t), n && r.push(n), r;
}
const BD = (e) => {
  var t, n, r, o, i, a, s, l, c;
  const { invert: f, toast: u, unstyled: h, interacting: m, setHeights: g, visibleToasts: p, heights: v, index: y, toasts: C, expanded: w, removeToast: _, defaultRichColors: x, closeButton: k, style: S, cancelButtonStyle: T, actionButtonStyle: L, className: R = "", descriptionClassName: M = "", duration: A, position: O, gap: I, expandByDefault: W, classNames: N, icons: H, closeButtonAriaLabel: q = "Close toast" } = e, [D, $] = j.useState(null), [U, B] = j.useState(null), [K, X] = j.useState(!1), [Z, G] = j.useState(!1), [V, Y] = j.useState(!1), [P, F] = j.useState(!1), [z, E] = j.useState(!1), [re, ee] = j.useState(0), [oe, ue] = j.useState(0), le = j.useRef(u.duration || A || j8), Ae = j.useRef(null), Ie = j.useRef(null), bt = y === 0, He = y + 1 <= p, Me = u.type, Pe = u.dismissible !== !1, rt = u.className || "", ft = u.descriptionClassName || "", Xe = j.useMemo(() => v.findIndex((de) => de.toastId === u.id) || 0, [
    v,
    u.id
  ]), ht = j.useMemo(() => {
    var de;
    return (de = u.closeButton) != null ? de : k;
  }, [
    u.closeButton,
    k
  ]), Ge = j.useMemo(() => u.duration || A || j8, [
    u.duration,
    A
  ]), Ve = j.useRef(0), Be = j.useRef(0), ct = j.useRef(0), ot = j.useRef(null), [it, mt] = O.split("-"), Qe = j.useMemo(() => v.reduce((de, xe, Ee) => Ee >= Xe ? de : de + xe.height, 0), [
    v,
    Xe
  ]), ut = xD(), Dt = u.invert || f, pe = Me === "loading";
  Be.current = j.useMemo(() => Xe * I + Qe, [
    Xe,
    Qe
  ]), j.useEffect(() => {
    le.current = Ge;
  }, [
    Ge
  ]), j.useEffect(() => {
    X(!0);
  }, []), j.useEffect(() => {
    const de = Ie.current;
    if (de) {
      const xe = de.getBoundingClientRect().height;
      return ue(xe), g((Ee) => [
        {
          toastId: u.id,
          height: xe,
          position: u.position
        },
        ...Ee
      ]), () => g((Ee) => Ee.filter((me) => me.toastId !== u.id));
    }
  }, [
    g,
    u.id
  ]), j.useLayoutEffect(() => {
    if (!K) return;
    const de = Ie.current, xe = de.style.height;
    de.style.height = "auto";
    const Ee = de.getBoundingClientRect().height;
    de.style.height = xe, ue(Ee), g((me) => me.find((qe) => qe.toastId === u.id) ? me.map((qe) => qe.toastId === u.id ? {
      ...qe,
      height: Ee
    } : qe) : [
      {
        toastId: u.id,
        height: Ee,
        position: u.position
      },
      ...me
    ]);
  }, [
    K,
    u.title,
    u.description,
    g,
    u.id,
    u.jsx,
    u.action,
    u.cancel
  ]);
  const ae = j.useCallback(() => {
    G(!0), ee(Be.current), g((de) => de.filter((xe) => xe.toastId !== u.id)), setTimeout(() => {
      _(u);
    }, DD);
  }, [
    u,
    _,
    g,
    Be
  ]);
  j.useEffect(() => {
    if (u.promise && Me === "loading" || u.duration === 1 / 0 || u.type === "loading") return;
    let de;
    return w || m || ut ? (() => {
      if (ct.current < Ve.current) {
        const me = (/* @__PURE__ */ new Date()).getTime() - Ve.current;
        le.current = le.current - me;
      }
      ct.current = (/* @__PURE__ */ new Date()).getTime();
    })() : (() => {
      le.current !== 1 / 0 && (Ve.current = (/* @__PURE__ */ new Date()).getTime(), de = setTimeout(() => {
        u.onAutoClose == null || u.onAutoClose.call(u, u), ae();
      }, le.current));
    })(), () => clearTimeout(de);
  }, [
    w,
    m,
    u,
    Me,
    ut,
    ae
  ]), j.useEffect(() => {
    u.delete && (ae(), u.onDismiss == null || u.onDismiss.call(u, u));
  }, [
    ae,
    u.delete
  ]);
  function ge() {
    var de;
    if (H != null && H.loading) {
      var xe;
      return /* @__PURE__ */ j.createElement("div", {
        className: Wn(N == null ? void 0 : N.loader, u == null || (xe = u.classNames) == null ? void 0 : xe.loader, "sonner-loader"),
        "data-visible": Me === "loading"
      }, H.loading);
    }
    return /* @__PURE__ */ j.createElement(gD, {
      className: Wn(N == null ? void 0 : N.loader, u == null || (de = u.classNames) == null ? void 0 : de.loader),
      visible: Me === "loading"
    });
  }
  const we = u.icon || (H == null ? void 0 : H[Me]) || mD(Me);
  var We, Oe;
  return /* @__PURE__ */ j.createElement("li", {
    tabIndex: 0,
    ref: Ie,
    className: Wn(R, rt, N == null ? void 0 : N.toast, u == null || (t = u.classNames) == null ? void 0 : t.toast, N == null ? void 0 : N.default, N == null ? void 0 : N[Me], u == null || (n = u.classNames) == null ? void 0 : n[Me]),
    "data-sonner-toast": "",
    "data-rich-colors": (We = u.richColors) != null ? We : x,
    "data-styled": !(u.jsx || u.unstyled || h),
    "data-mounted": K,
    "data-promise": !!u.promise,
    "data-swiped": z,
    "data-removed": Z,
    "data-visible": He,
    "data-y-position": it,
    "data-x-position": mt,
    "data-index": y,
    "data-front": bt,
    "data-swiping": V,
    "data-dismissible": Pe,
    "data-type": Me,
    "data-invert": Dt,
    "data-swipe-out": P,
    "data-swipe-direction": U,
    "data-expanded": !!(w || W && K),
    style: {
      "--index": y,
      "--toasts-before": y,
      "--z-index": C.length - y,
      "--offset": `${Z ? re : Be.current}px`,
      "--initial-height": W ? "auto" : `${oe}px`,
      ...S,
      ...u.style
    },
    onDragEnd: () => {
      Y(!1), $(null), ot.current = null;
    },
    onPointerDown: (de) => {
      pe || !Pe || (Ae.current = /* @__PURE__ */ new Date(), ee(Be.current), de.target.setPointerCapture(de.pointerId), de.target.tagName !== "BUTTON" && (Y(!0), ot.current = {
        x: de.clientX,
        y: de.clientY
      }));
    },
    onPointerUp: () => {
      var de, xe, Ee;
      if (P || !Pe) return;
      ot.current = null;
      const me = Number(((de = Ie.current) == null ? void 0 : de.style.getPropertyValue("--swipe-amount-x").replace("px", "")) || 0), Pt = Number(((xe = Ie.current) == null ? void 0 : xe.style.getPropertyValue("--swipe-amount-y").replace("px", "")) || 0), qe = (/* @__PURE__ */ new Date()).getTime() - ((Ee = Ae.current) == null ? void 0 : Ee.getTime()), yt = D === "x" ? me : Pt, Mt = Math.abs(yt) / qe;
      if (Math.abs(yt) >= ND || Mt > 0.11) {
        ee(Be.current), u.onDismiss == null || u.onDismiss.call(u, u), B(D === "x" ? me > 0 ? "right" : "left" : Pt > 0 ? "down" : "up"), ae(), F(!0);
        return;
      } else {
        var se, ve;
        (se = Ie.current) == null || se.style.setProperty("--swipe-amount-x", "0px"), (ve = Ie.current) == null || ve.style.setProperty("--swipe-amount-y", "0px");
      }
      E(!1), Y(!1), $(null);
    },
    onPointerMove: (de) => {
      var xe, Ee, me;
      if (!ot.current || !Pe || ((xe = window.getSelection()) == null ? void 0 : xe.toString().length) > 0) return;
      const qe = de.clientY - ot.current.y, yt = de.clientX - ot.current.x;
      var Mt;
      const se = (Mt = e.swipeDirections) != null ? Mt : ID(O);
      !D && (Math.abs(yt) > 1 || Math.abs(qe) > 1) && $(Math.abs(yt) > Math.abs(qe) ? "x" : "y");
      let ve = {
        x: 0,
        y: 0
      };
      const $e = (Fe) => 1 / (1.5 + Math.abs(Fe) / 20);
      if (D === "y") {
        if (se.includes("top") || se.includes("bottom"))
          if (se.includes("top") && qe < 0 || se.includes("bottom") && qe > 0)
            ve.y = qe;
          else {
            const Fe = qe * $e(qe);
            ve.y = Math.abs(Fe) < Math.abs(qe) ? Fe : qe;
          }
      } else if (D === "x" && (se.includes("left") || se.includes("right")))
        if (se.includes("left") && yt < 0 || se.includes("right") && yt > 0)
          ve.x = yt;
        else {
          const Fe = yt * $e(yt);
          ve.x = Math.abs(Fe) < Math.abs(yt) ? Fe : yt;
        }
      (Math.abs(ve.x) > 0 || Math.abs(ve.y) > 0) && E(!0), (Ee = Ie.current) == null || Ee.style.setProperty("--swipe-amount-x", `${ve.x}px`), (me = Ie.current) == null || me.style.setProperty("--swipe-amount-y", `${ve.y}px`);
    }
  }, ht && !u.jsx && Me !== "loading" ? /* @__PURE__ */ j.createElement("button", {
    "aria-label": q,
    "data-disabled": pe,
    "data-close-button": !0,
    onClick: pe || !Pe ? () => {
    } : () => {
      ae(), u.onDismiss == null || u.onDismiss.call(u, u);
    },
    className: Wn(N == null ? void 0 : N.closeButton, u == null || (r = u.classNames) == null ? void 0 : r.closeButton)
  }, (Oe = H == null ? void 0 : H.close) != null ? Oe : wD) : null, (Me || u.icon || u.promise) && u.icon !== null && ((H == null ? void 0 : H[Me]) !== null || u.icon) ? /* @__PURE__ */ j.createElement("div", {
    "data-icon": "",
    className: Wn(N == null ? void 0 : N.icon, u == null || (o = u.classNames) == null ? void 0 : o.icon)
  }, u.promise || u.type === "loading" && !u.icon ? u.icon || ge() : null, u.type !== "loading" ? we : null) : null, /* @__PURE__ */ j.createElement("div", {
    "data-content": "",
    className: Wn(N == null ? void 0 : N.content, u == null || (i = u.classNames) == null ? void 0 : i.content)
  }, /* @__PURE__ */ j.createElement("div", {
    "data-title": "",
    className: Wn(N == null ? void 0 : N.title, u == null || (a = u.classNames) == null ? void 0 : a.title)
  }, u.jsx ? u.jsx : typeof u.title == "function" ? u.title() : u.title), u.description ? /* @__PURE__ */ j.createElement("div", {
    "data-description": "",
    className: Wn(M, ft, N == null ? void 0 : N.description, u == null || (s = u.classNames) == null ? void 0 : s.description)
  }, typeof u.description == "function" ? u.description() : u.description) : null), /* @__PURE__ */ j.isValidElement(u.cancel) ? u.cancel : u.cancel && Ts(u.cancel) ? /* @__PURE__ */ j.createElement("button", {
    "data-button": !0,
    "data-cancel": !0,
    style: u.cancelButtonStyle || T,
    onClick: (de) => {
      Ts(u.cancel) && Pe && (u.cancel.onClick == null || u.cancel.onClick.call(u.cancel, de), ae());
    },
    className: Wn(N == null ? void 0 : N.cancelButton, u == null || (l = u.classNames) == null ? void 0 : l.cancelButton)
  }, u.cancel.label) : null, /* @__PURE__ */ j.isValidElement(u.action) ? u.action : u.action && Ts(u.action) ? /* @__PURE__ */ j.createElement("button", {
    "data-button": !0,
    "data-action": !0,
    style: u.actionButtonStyle || L,
    onClick: (de) => {
      Ts(u.action) && (u.action.onClick == null || u.action.onClick.call(u.action, de), !de.defaultPrevented && ae());
    },
    className: Wn(N == null ? void 0 : N.actionButton, u == null || (c = u.classNames) == null ? void 0 : c.actionButton)
  }, u.action.label) : null);
};
function H8() {
  if (typeof window > "u" || typeof document > "u") return "ltr";
  const e = document.documentElement.getAttribute("dir");
  return e === "auto" || !e ? window.getComputedStyle(document.documentElement).direction : e;
}
function $D(e, t) {
  const n = {};
  return [
    e,
    t
  ].forEach((r, o) => {
    const i = o === 1, a = i ? "--mobile-offset" : "--offset", s = i ? RD : PD;
    function l(c) {
      [
        "top",
        "right",
        "bottom",
        "left"
      ].forEach((f) => {
        n[`${a}-${f}`] = typeof c == "number" ? `${c}px` : c;
      });
    }
    typeof r == "number" || typeof r == "string" ? l(r) : typeof r == "object" ? [
      "top",
      "right",
      "bottom",
      "left"
    ].forEach((c) => {
      r[c] === void 0 ? n[`${a}-${c}`] = s : n[`${a}-${c}`] = typeof r[c] == "number" ? `${r[c]}px` : r[c];
    }) : l(s);
  }), n;
}
const FD = /* @__PURE__ */ j.forwardRef(function(t, n) {
  const { invert: r, position: o = "bottom-right", hotkey: i = [
    "altKey",
    "KeyT"
  ], expand: a, closeButton: s, className: l, offset: c, mobileOffset: f, theme: u = "light", richColors: h, duration: m, style: g, visibleToasts: p = TD, toastOptions: v, dir: y = H8(), gap: C = OD, icons: w, containerAriaLabel: _ = "Notifications" } = t, [x, k] = j.useState([]), S = j.useMemo(() => Array.from(new Set([
    o
  ].concat(x.filter((U) => U.position).map((U) => U.position)))), [
    x,
    o
  ]), [T, L] = j.useState([]), [R, M] = j.useState(!1), [A, O] = j.useState(!1), [I, W] = j.useState(u !== "system" ? u : typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"), N = j.useRef(null), H = i.join("+").replace(/Key/g, "").replace(/Digit/g, ""), q = j.useRef(null), D = j.useRef(!1), $ = j.useCallback((U) => {
    k((B) => {
      var K;
      return (K = B.find((X) => X.id === U.id)) != null && K.delete || ln.dismiss(U.id), B.filter(({ id: X }) => X !== U.id);
    });
  }, []);
  return j.useEffect(() => ln.subscribe((U) => {
    if (U.dismiss) {
      requestAnimationFrame(() => {
        k((B) => B.map((K) => K.id === U.id ? {
          ...K,
          delete: !0
        } : K));
      });
      return;
    }
    setTimeout(() => {
      tg.flushSync(() => {
        k((B) => {
          const K = B.findIndex((X) => X.id === U.id);
          return K !== -1 ? [
            ...B.slice(0, K),
            {
              ...B[K],
              ...U
            },
            ...B.slice(K + 1)
          ] : [
            U,
            ...B
          ];
        });
      });
    });
  }), [
    x
  ]), j.useEffect(() => {
    if (u !== "system") {
      W(u);
      return;
    }
    if (u === "system" && (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? W("dark") : W("light")), typeof window > "u") return;
    const U = window.matchMedia("(prefers-color-scheme: dark)");
    try {
      U.addEventListener("change", ({ matches: B }) => {
        W(B ? "dark" : "light");
      });
    } catch {
      U.addListener(({ matches: K }) => {
        try {
          W(K ? "dark" : "light");
        } catch (X) {
          console.error(X);
        }
      });
    }
  }, [
    u
  ]), j.useEffect(() => {
    x.length <= 1 && M(!1);
  }, [
    x
  ]), j.useEffect(() => {
    const U = (B) => {
      var K;
      if (i.every((G) => B[G] || B.code === G)) {
        var Z;
        M(!0), (Z = N.current) == null || Z.focus();
      }
      B.code === "Escape" && (document.activeElement === N.current || (K = N.current) != null && K.contains(document.activeElement)) && M(!1);
    };
    return document.addEventListener("keydown", U), () => document.removeEventListener("keydown", U);
  }, [
    i
  ]), j.useEffect(() => {
    if (N.current)
      return () => {
        q.current && (q.current.focus({
          preventScroll: !0
        }), q.current = null, D.current = !1);
      };
  }, [
    N.current
  ]), // Remove item from normal navigation flow, only available via hotkey
  /* @__PURE__ */ j.createElement("section", {
    ref: n,
    "aria-label": `${_} ${H}`,
    tabIndex: -1,
    "aria-live": "polite",
    "aria-relevant": "additions text",
    "aria-atomic": "false",
    suppressHydrationWarning: !0
  }, S.map((U, B) => {
    var K;
    const [X, Z] = U.split("-");
    return x.length ? /* @__PURE__ */ j.createElement("ol", {
      key: U,
      dir: y === "auto" ? H8() : y,
      tabIndex: -1,
      ref: N,
      className: l,
      "data-sonner-toaster": !0,
      "data-sonner-theme": I,
      "data-y-position": X,
      "data-x-position": Z,
      style: {
        "--front-toast-height": `${((K = T[0]) == null ? void 0 : K.height) || 0}px`,
        "--width": `${AD}px`,
        "--gap": `${C}px`,
        ...g,
        ...$D(c, f)
      },
      onBlur: (G) => {
        D.current && !G.currentTarget.contains(G.relatedTarget) && (D.current = !1, q.current && (q.current.focus({
          preventScroll: !0
        }), q.current = null));
      },
      onFocus: (G) => {
        G.target instanceof HTMLElement && G.target.dataset.dismissible === "false" || D.current || (D.current = !0, q.current = G.relatedTarget);
      },
      onMouseEnter: () => M(!0),
      onMouseMove: () => M(!0),
      onMouseLeave: () => {
        A || M(!1);
      },
      onDragEnd: () => M(!1),
      onPointerDown: (G) => {
        G.target instanceof HTMLElement && G.target.dataset.dismissible === "false" || O(!0);
      },
      onPointerUp: () => O(!1)
    }, x.filter((G) => !G.position && B === 0 || G.position === U).map((G, V) => {
      var Y, P;
      return /* @__PURE__ */ j.createElement(BD, {
        key: G.id,
        icons: w,
        index: V,
        toast: G,
        defaultRichColors: h,
        duration: (Y = v == null ? void 0 : v.duration) != null ? Y : m,
        className: v == null ? void 0 : v.className,
        descriptionClassName: v == null ? void 0 : v.descriptionClassName,
        invert: r,
        visibleToasts: p,
        closeButton: (P = v == null ? void 0 : v.closeButton) != null ? P : s,
        interacting: A,
        position: U,
        style: v == null ? void 0 : v.style,
        unstyled: v == null ? void 0 : v.unstyled,
        classNames: v == null ? void 0 : v.classNames,
        cancelButtonStyle: v == null ? void 0 : v.cancelButtonStyle,
        actionButtonStyle: v == null ? void 0 : v.actionButtonStyle,
        closeButtonAriaLabel: v == null ? void 0 : v.closeButtonAriaLabel,
        removeToast: $,
        toasts: x.filter((F) => F.position == G.position),
        heights: T.filter((F) => F.position == G.position),
        setHeights: L,
        expandByDefault: a,
        gap: C,
        expanded: R,
        swipeDirections: t.swipeDirections
      });
    })) : null;
  }));
}), WD = FD;
WD.displayName = "LBToaster";
const qD = Dn(
  "flex min-w-[388px] items-center gap-2 rounded-md border p-4 pr-6 shadow-lg",
  {
    variants: {
      variant: {
        default: "bg-card",
        destructive: "bg-destructive text-destructive-foreground",
        success: "bg-success text-success-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), jD = Dn(
  "flex h-9 items-center justify-center whitespace-nowrap rounded-full border px-4 py-2 text-sm",
  {
    variants: {
      variant: {
        default: "hover:divide-indigo-500 hover:border-indigo-500 hover:text-indigo-500",
        destructive: "border-destructive-foreground text-destructive-foreground hover:bg-destructive/10",
        success: "border-success-foreground text-success-foreground hover:bg-success/10"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), HD = Dn("rounded-md p-1", {
  variants: {
    variant: {
      default: "opacity-50 hover:opacity-100",
      destructive: "text-red-300 opacity-50 hover:opacity-100",
      success: "text-green-300 opacity-50 hover:opacity-100"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
function VD(e) {
  const {
    title: t,
    description: n,
    button: r,
    id: o,
    variant: i,
    closeButton: a
  } = e;
  return /* @__PURE__ */ ie("div", { className: Q(qD({ variant: i }), "relative"), children: [
    /* @__PURE__ */ ie("div", { className: "flex w-full flex-row items-center", children: [
      /* @__PURE__ */ ie("div", { className: "flex w-full flex-col items-start", children: [
        /* @__PURE__ */ b("h3", { className: "text-sm font-semibold leading-5", children: t }),
        /* @__PURE__ */ b("p", { className: "text-sm leading-5", children: n })
      ] }),
      r && /* @__PURE__ */ b("div", { className: "flex w-fit items-center justify-end", children: /* @__PURE__ */ b(
        "button",
        {
          className: jD({
            variant: i
          }),
          onClick: () => {
            var s;
            (s = r == null ? void 0 : r.onClick) == null || s.call(r), q2.dismiss(o);
          },
          children: r.label
        }
      ) })
    ] }),
    a && /* @__PURE__ */ ie(
      "button",
      {
        className: Q(
          HD({ variant: i }),
          "absolute top-1 right-1"
        ),
        onClick: () => q2.dismiss(o),
        children: [
          /* @__PURE__ */ b(ts, { className: "size-3" }),
          /* @__PURE__ */ b("span", { className: "sr-only", children: "Close" })
        ]
      }
    )
  ] });
}
function Dee(e, t) {
  return q2.custom((n) => /* @__PURE__ */ b(VD, { id: n, ...e }), t);
}
function UD(...e) {
  return { getAll: () => e, get: (t) => e.find((n) => n.id === t), getIndex: (t) => e.findIndex((n) => n.id === t), getByIndex: (t) => e[t], getFirst: () => e[0], getLast: () => e[e.length - 1], getNext: (t) => e[e.findIndex((n) => n.id === t) + 1], getPrev: (t) => e[e.findIndex((n) => n.id === t) - 1], getNeighbors(t) {
    const n = e.findIndex((r) => r.id === t);
    return { prev: n > 0 ? e[n - 1] : null, next: n < e.length - 1 ? e[n + 1] : null };
  } };
}
function V8(e, t) {
  return Math.max(e.findIndex((n) => n.id === t), 0);
}
function U8(e, t) {
  return e.reduce((n, r) => (n[r.id] = (t == null ? void 0 : t[r.id]) ?? null, n), {});
}
function zD(e, t, n) {
  return { switch(r) {
    const o = r[t.id];
    return o == null ? void 0 : o(t);
  }, when(r, o, i) {
    const a = e[n];
    return (Array.isArray(r) ? a.id === r[0] && r.slice(1).every(Boolean) : a.id === r) ? o == null ? void 0 : o(a) : i == null ? void 0 : i(a);
  }, match(r, o) {
    const i = e.find((s) => s.id === r);
    if (!i) return null;
    const a = o[r];
    return (a == null ? void 0 : a(i)) ?? null;
  } };
}
async function z8(e, t) {
  const n = await e();
  return !t || n === !0;
}
var Fo = async ({ stepper: e, direction: t, callback: n, before: r, targetId: o }) => {
  (!r || await z8(n, !0)) && (t === "next" ? e.next() : t === "prev" ? e.prev() : t === "goTo" && o && e.goTo(o), r || await z8(n, !1));
}, Ps = (e, t, n) => {
  t < 0 && Y8({ steps: e, newIndex: t, direction: "next", reason: "it is the first step" }), t >= e.length && Y8({ steps: e, newIndex: t, direction: "prev", reason: "it is the last step" }), n(t);
}, Y8 = ({ steps: e, newIndex: t, direction: n, reason: r }) => {
  throw new Error(`Cannot navigate ${n} from step "${e[t].id}": ${r}`);
}, Iee = (...e) => {
  const t = d.createContext(null), n = UD(...e), r = (o) => {
    const { initialStep: i, initialMetadata: a } = o ?? {}, s = d.useMemo(() => V8(e, i), [i]), [l, c] = d.useState(s), [f, u] = d.useState(() => U8(e, a)), h = d.useMemo(() => {
      const m = e[l], g = l === e.length - 1;
      return { all: e, current: m, isLast: g, isFirst: l === 0, metadata: f, setMetadata(p, v) {
        u((y) => y[p] === v ? y : { ...y, [p]: v });
      }, getMetadata: (p) => f[p], resetMetadata(p) {
        u(U8(e, p ? a : void 0));
      }, next() {
        Ps(e, l + 1, (p) => {
          c(p);
        });
      }, prev() {
        Ps(e, l - 1, (p) => {
          c(p);
        });
      }, get: (p) => e.find((v) => v.id === p), goTo(p) {
        const v = e.findIndex((y) => y.id === p);
        if (v === -1) throw new Error(`Step with id "${p}" not found.`);
        Ps(e, v, (y) => {
          c(y);
        });
      }, reset() {
        Ps(e, V8(e, i), (p) => {
          c(p);
        });
      }, async beforeNext(p) {
        await Fo({ stepper: h, direction: "next", callback: p, before: !0 });
      }, async afterNext(p) {
        this.next(), await Fo({ stepper: h, direction: "next", callback: p, before: !1 });
      }, async beforePrev(p) {
        await Fo({ stepper: h, direction: "prev", callback: p, before: !0 });
      }, async afterPrev(p) {
        this.prev(), await Fo({ stepper: h, direction: "prev", callback: p, before: !1 });
      }, async beforeGoTo(p, v) {
        await Fo({ stepper: h, direction: "goTo", callback: v, before: !0, targetId: p });
      }, async afterGoTo(p, v) {
        this.goTo(p), await Fo({ stepper: h, direction: "goTo", callback: v, before: !1, targetId: p });
      }, ...zD(e, m, l) };
    }, [l, f]);
    return h;
  };
  return { steps: e, utils: n, Scoped: ({ initialStep: o, initialMetadata: i, children: a }) => d.createElement(t.Provider, { value: r({ initialStep: o, initialMetadata: i }) }, a), useStepper: (o = {}) => d.useContext(t) ?? r(o) };
};
const YD = Dn(
  "peer flex size-9 items-center justify-center gap-2 rounded-full p-2 focus-visible:ring-1 disabled:cursor-not-allowed disabled:border disabled:border-slate-200 disabled:text-slate-800 disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "cursor-default border border-slate-200 bg-white text-slate-700",
        complete: "bg-slate-700 text-white shadow hover:bg-indigo-500"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), GD = fe(
  ({ className: e, variant: t, title: n, ...r }, o) => /* @__PURE__ */ ie("div", { className: "flex shrink-0 flex-row items-center gap-5", ref: o, children: [
    /* @__PURE__ */ b(
      "button",
      {
        ...r,
        type: "button",
        className: Q(YD({ variant: t }), e),
        style: void 0
      }
    ),
    /* @__PURE__ */ b("span", { className: "text-base peer-disabled:text-slate-800 peer-disabled:opacity-40", children: n })
  ] })
);
GD.displayName = "LBStep";
const KD = fe(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ b(
  "nav",
  {
    "aria-label": "Checkout Steps",
    className: Q("my-4 flex flex-col", e),
    ref: r,
    ...n,
    children: t
  }
));
KD.displayName = "LBStepper";
function Bee() {
  return /* @__PURE__ */ b("div", { className: "ml-[17.5px] h-20 w-[1px] divide-dotted border border-dashed border-slate-500" });
}
var ml = "Collapsible", [ZD, DC] = Ot(ml), [XD, bh] = ZD(ml), IC = d.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: n,
      open: r,
      defaultOpen: o,
      disabled: i,
      onOpenChange: a,
      ...s
    } = e, [l, c] = Jt({
      prop: r,
      defaultProp: o ?? !1,
      onChange: a,
      caller: ml
    });
    return /* @__PURE__ */ b(
      XD,
      {
        scope: n,
        disabled: i,
        contentId: Tt(),
        open: l,
        onOpenToggle: d.useCallback(() => c((f) => !f), [c]),
        children: /* @__PURE__ */ b(
          ce.div,
          {
            "data-state": xh(l),
            "data-disabled": i ? "" : void 0,
            ...s,
            ref: t
          }
        )
      }
    );
  }
);
IC.displayName = ml;
var BC = "CollapsibleTrigger", yh = d.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: n, ...r } = e, o = bh(BC, n);
    return /* @__PURE__ */ b(
      ce.button,
      {
        type: "button",
        "aria-controls": o.contentId,
        "aria-expanded": o.open || !1,
        "data-state": xh(o.open),
        "data-disabled": o.disabled ? "" : void 0,
        disabled: o.disabled,
        ...r,
        ref: t,
        onClick: ne(e.onClick, o.onOpenToggle)
      }
    );
  }
);
yh.displayName = BC;
var Ch = "CollapsibleContent", wh = d.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, o = bh(Ch, e.__scopeCollapsible);
    return /* @__PURE__ */ b(Nt, { present: n || o.open, children: ({ present: i }) => /* @__PURE__ */ b(QD, { ...r, ref: t, present: i }) });
  }
);
wh.displayName = Ch;
var QD = d.forwardRef((e, t) => {
  const { __scopeCollapsible: n, present: r, children: o, ...i } = e, a = bh(Ch, n), [s, l] = d.useState(r), c = d.useRef(null), f = ke(t, c), u = d.useRef(0), h = u.current, m = d.useRef(0), g = m.current, p = a.open || s, v = d.useRef(p), y = d.useRef(void 0);
  return d.useEffect(() => {
    const C = requestAnimationFrame(() => v.current = !1);
    return () => cancelAnimationFrame(C);
  }, []), At(() => {
    const C = c.current;
    if (C) {
      y.current = y.current || {
        transitionDuration: C.style.transitionDuration,
        animationName: C.style.animationName
      }, C.style.transitionDuration = "0s", C.style.animationName = "none";
      const w = C.getBoundingClientRect();
      u.current = w.height, m.current = w.width, v.current || (C.style.transitionDuration = y.current.transitionDuration, C.style.animationName = y.current.animationName), l(r);
    }
  }, [a.open, r]), /* @__PURE__ */ b(
    ce.div,
    {
      "data-state": xh(a.open),
      "data-disabled": a.disabled ? "" : void 0,
      id: a.contentId,
      hidden: !p,
      ...i,
      ref: f,
      style: {
        "--radix-collapsible-content-height": h ? `${h}px` : void 0,
        "--radix-collapsible-content-width": g ? `${g}px` : void 0,
        ...e.style
      },
      children: p && o
    }
  );
});
function xh(e) {
  return e ? "open" : "closed";
}
var $C = IC, JD = yh, eI = wh, Bn = "Accordion", tI = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [_h, nI, rI] = A0(Bn), [pl, $ee] = Ot(Bn, [
  rI,
  DC
]), kh = DC(), FC = j.forwardRef(
  (e, t) => {
    const { type: n, ...r } = e, o = r, i = r;
    return /* @__PURE__ */ b(_h.Provider, { scope: e.__scopeAccordion, children: n === "multiple" ? /* @__PURE__ */ b(sI, { ...i, ref: t }) : /* @__PURE__ */ b(aI, { ...o, ref: t }) });
  }
);
FC.displayName = Bn;
var [WC, oI] = pl(Bn), [qC, iI] = pl(
  Bn,
  { collapsible: !1 }
), aI = j.forwardRef(
  (e, t) => {
    const {
      value: n,
      defaultValue: r,
      onValueChange: o = () => {
      },
      collapsible: i = !1,
      ...a
    } = e, [s, l] = Jt({
      prop: n,
      defaultProp: r ?? "",
      onChange: o,
      caller: Bn
    });
    return /* @__PURE__ */ b(
      WC,
      {
        scope: e.__scopeAccordion,
        value: j.useMemo(() => s ? [s] : [], [s]),
        onItemOpen: l,
        onItemClose: j.useCallback(() => i && l(""), [i, l]),
        children: /* @__PURE__ */ b(qC, { scope: e.__scopeAccordion, collapsible: i, children: /* @__PURE__ */ b(jC, { ...a, ref: t }) })
      }
    );
  }
), sI = j.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: o = () => {
    },
    ...i
  } = e, [a, s] = Jt({
    prop: n,
    defaultProp: r ?? [],
    onChange: o,
    caller: Bn
  }), l = j.useCallback(
    (f) => s((u = []) => [...u, f]),
    [s]
  ), c = j.useCallback(
    (f) => s((u = []) => u.filter((h) => h !== f)),
    [s]
  );
  return /* @__PURE__ */ b(
    WC,
    {
      scope: e.__scopeAccordion,
      value: a,
      onItemOpen: l,
      onItemClose: c,
      children: /* @__PURE__ */ b(qC, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ b(jC, { ...i, ref: t }) })
    }
  );
}), [lI, gl] = pl(Bn), jC = j.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, disabled: r, dir: o, orientation: i = "vertical", ...a } = e, s = j.useRef(null), l = ke(s, t), c = nI(n), u = ko(o) === "ltr", h = ne(e.onKeyDown, (m) => {
      var T;
      if (!tI.includes(m.key)) return;
      const g = m.target, p = c().filter((L) => {
        var R;
        return !((R = L.ref.current) != null && R.disabled);
      }), v = p.findIndex((L) => L.ref.current === g), y = p.length;
      if (v === -1) return;
      m.preventDefault();
      let C = v;
      const w = 0, _ = y - 1, x = () => {
        C = v + 1, C > _ && (C = w);
      }, k = () => {
        C = v - 1, C < w && (C = _);
      };
      switch (m.key) {
        case "Home":
          C = w;
          break;
        case "End":
          C = _;
          break;
        case "ArrowRight":
          i === "horizontal" && (u ? x() : k());
          break;
        case "ArrowDown":
          i === "vertical" && x();
          break;
        case "ArrowLeft":
          i === "horizontal" && (u ? k() : x());
          break;
        case "ArrowUp":
          i === "vertical" && k();
          break;
      }
      const S = C % y;
      (T = p[S].ref.current) == null || T.focus();
    });
    return /* @__PURE__ */ b(
      lI,
      {
        scope: n,
        disabled: r,
        direction: o,
        orientation: i,
        children: /* @__PURE__ */ b(_h.Slot, { scope: n, children: /* @__PURE__ */ b(
          ce.div,
          {
            ...a,
            "data-orientation": i,
            ref: l,
            onKeyDown: r ? void 0 : h
          }
        ) })
      }
    );
  }
), o0 = "AccordionItem", [cI, Sh] = pl(o0), HC = j.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, value: r, ...o } = e, i = gl(o0, n), a = oI(o0, n), s = kh(n), l = Tt(), c = r && a.value.includes(r) || !1, f = i.disabled || e.disabled;
    return /* @__PURE__ */ b(
      cI,
      {
        scope: n,
        open: c,
        disabled: f,
        triggerId: l,
        children: /* @__PURE__ */ b(
          $C,
          {
            "data-orientation": i.orientation,
            "data-state": KC(c),
            ...s,
            ...o,
            ref: t,
            disabled: f,
            open: c,
            onOpenChange: (u) => {
              u ? a.onItemOpen(r) : a.onItemClose(r);
            }
          }
        )
      }
    );
  }
);
HC.displayName = o0;
var VC = "AccordionHeader", UC = j.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, o = gl(Bn, n), i = Sh(VC, n);
    return /* @__PURE__ */ b(
      ce.h3,
      {
        "data-orientation": o.orientation,
        "data-state": KC(i.open),
        "data-disabled": i.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
UC.displayName = VC;
var j2 = "AccordionTrigger", zC = j.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, o = gl(Bn, n), i = Sh(j2, n), a = iI(j2, n), s = kh(n);
    return /* @__PURE__ */ b(_h.ItemSlot, { scope: n, children: /* @__PURE__ */ b(
      JD,
      {
        "aria-disabled": i.open && !a.collapsible || void 0,
        "data-orientation": o.orientation,
        id: i.triggerId,
        ...s,
        ...r,
        ref: t
      }
    ) });
  }
);
zC.displayName = j2;
var YC = "AccordionContent", GC = j.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, o = gl(Bn, n), i = Sh(YC, n), a = kh(n);
    return /* @__PURE__ */ b(
      eI,
      {
        role: "region",
        "aria-labelledby": i.triggerId,
        "data-orientation": o.orientation,
        ...a,
        ...r,
        ref: t,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
GC.displayName = YC;
function KC(e) {
  return e ? "open" : "closed";
}
var uI = FC, dI = HC, fI = UC, hI = zC, mI = GC;
const pI = uI;
pI.displayName = "LBAccordion";
const gI = fe(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  dI,
  {
    ref: n,
    className: Q("border-b", e),
    ...t
  }
));
gI.displayName = "LBAccordionItem";
const vI = fe(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ b(fI, { className: "flex", children: /* @__PURE__ */ ie(
  hI,
  {
    ref: r,
    className: Q(
      "flex flex-1 items-center justify-between py-4 text-sm font-medium transition-all hover:underline text-left [&[data-state=open]>svg]:rotate-180",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ b(V0, { className: "size-4 shrink-0 text-muted-foreground transition-transform duration-200" })
    ]
  }
) }));
vI.displayName = "LBAccordionTrigger";
const bI = fe(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ b(
  mI,
  {
    ref: r,
    className: "overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
    ...n,
    children: /* @__PURE__ */ b("div", { className: Q("pb-4 pt-0", e), children: t })
  }
));
bI.displayName = "LBAccordionContent";
var Rs = { exports: {} }, As = { exports: {} }, tt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var G8;
function yI() {
  if (G8) return tt;
  G8 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, p = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, y = e ? Symbol.for("react.responder") : 60118, C = e ? Symbol.for("react.scope") : 60119;
  function w(x) {
    if (typeof x == "object" && x !== null) {
      var k = x.$$typeof;
      switch (k) {
        case t:
          switch (x = x.type, x) {
            case l:
            case c:
            case r:
            case i:
            case o:
            case u:
              return x;
            default:
              switch (x = x && x.$$typeof, x) {
                case s:
                case f:
                case g:
                case m:
                case a:
                  return x;
                default:
                  return k;
              }
          }
        case n:
          return k;
      }
    }
  }
  function _(x) {
    return w(x) === c;
  }
  return tt.AsyncMode = l, tt.ConcurrentMode = c, tt.ContextConsumer = s, tt.ContextProvider = a, tt.Element = t, tt.ForwardRef = f, tt.Fragment = r, tt.Lazy = g, tt.Memo = m, tt.Portal = n, tt.Profiler = i, tt.StrictMode = o, tt.Suspense = u, tt.isAsyncMode = function(x) {
    return _(x) || w(x) === l;
  }, tt.isConcurrentMode = _, tt.isContextConsumer = function(x) {
    return w(x) === s;
  }, tt.isContextProvider = function(x) {
    return w(x) === a;
  }, tt.isElement = function(x) {
    return typeof x == "object" && x !== null && x.$$typeof === t;
  }, tt.isForwardRef = function(x) {
    return w(x) === f;
  }, tt.isFragment = function(x) {
    return w(x) === r;
  }, tt.isLazy = function(x) {
    return w(x) === g;
  }, tt.isMemo = function(x) {
    return w(x) === m;
  }, tt.isPortal = function(x) {
    return w(x) === n;
  }, tt.isProfiler = function(x) {
    return w(x) === i;
  }, tt.isStrictMode = function(x) {
    return w(x) === o;
  }, tt.isSuspense = function(x) {
    return w(x) === u;
  }, tt.isValidElementType = function(x) {
    return typeof x == "string" || typeof x == "function" || x === r || x === c || x === i || x === o || x === u || x === h || typeof x == "object" && x !== null && (x.$$typeof === g || x.$$typeof === m || x.$$typeof === a || x.$$typeof === s || x.$$typeof === f || x.$$typeof === v || x.$$typeof === y || x.$$typeof === C || x.$$typeof === p);
  }, tt.typeOf = w, tt;
}
var nt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var K8;
function CI() {
  return K8 || (K8 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, p = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, y = e ? Symbol.for("react.responder") : 60118, C = e ? Symbol.for("react.scope") : 60119;
    function w(E) {
      return typeof E == "string" || typeof E == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      E === r || E === c || E === i || E === o || E === u || E === h || typeof E == "object" && E !== null && (E.$$typeof === g || E.$$typeof === m || E.$$typeof === a || E.$$typeof === s || E.$$typeof === f || E.$$typeof === v || E.$$typeof === y || E.$$typeof === C || E.$$typeof === p);
    }
    function _(E) {
      if (typeof E == "object" && E !== null) {
        var re = E.$$typeof;
        switch (re) {
          case t:
            var ee = E.type;
            switch (ee) {
              case l:
              case c:
              case r:
              case i:
              case o:
              case u:
                return ee;
              default:
                var oe = ee && ee.$$typeof;
                switch (oe) {
                  case s:
                  case f:
                  case g:
                  case m:
                  case a:
                    return oe;
                  default:
                    return re;
                }
            }
          case n:
            return re;
        }
      }
    }
    var x = l, k = c, S = s, T = a, L = t, R = f, M = r, A = g, O = m, I = n, W = i, N = o, H = u, q = !1;
    function D(E) {
      return q || (q = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), $(E) || _(E) === l;
    }
    function $(E) {
      return _(E) === c;
    }
    function U(E) {
      return _(E) === s;
    }
    function B(E) {
      return _(E) === a;
    }
    function K(E) {
      return typeof E == "object" && E !== null && E.$$typeof === t;
    }
    function X(E) {
      return _(E) === f;
    }
    function Z(E) {
      return _(E) === r;
    }
    function G(E) {
      return _(E) === g;
    }
    function V(E) {
      return _(E) === m;
    }
    function Y(E) {
      return _(E) === n;
    }
    function P(E) {
      return _(E) === i;
    }
    function F(E) {
      return _(E) === o;
    }
    function z(E) {
      return _(E) === u;
    }
    nt.AsyncMode = x, nt.ConcurrentMode = k, nt.ContextConsumer = S, nt.ContextProvider = T, nt.Element = L, nt.ForwardRef = R, nt.Fragment = M, nt.Lazy = A, nt.Memo = O, nt.Portal = I, nt.Profiler = W, nt.StrictMode = N, nt.Suspense = H, nt.isAsyncMode = D, nt.isConcurrentMode = $, nt.isContextConsumer = U, nt.isContextProvider = B, nt.isElement = K, nt.isForwardRef = X, nt.isFragment = Z, nt.isLazy = G, nt.isMemo = V, nt.isPortal = Y, nt.isProfiler = P, nt.isStrictMode = F, nt.isSuspense = z, nt.isValidElementType = w, nt.typeOf = _;
  }()), nt;
}
var Z8;
function ZC() {
  return Z8 || (Z8 = 1, process.env.NODE_ENV === "production" ? As.exports = yI() : As.exports = CI()), As.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Kc, X8;
function wI() {
  if (X8) return Kc;
  X8 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(a).map(function(f) {
        return a[f];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        c[f] = f;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Kc = o() ? Object.assign : function(i, a) {
    for (var s, l = r(i), c, f = 1; f < arguments.length; f++) {
      s = Object(arguments[f]);
      for (var u in s)
        t.call(s, u) && (l[u] = s[u]);
      if (e) {
        c = e(s);
        for (var h = 0; h < c.length; h++)
          n.call(s, c[h]) && (l[c[h]] = s[c[h]]);
      }
    }
    return l;
  }, Kc;
}
var Zc, Q8;
function Mh() {
  if (Q8) return Zc;
  Q8 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Zc = e, Zc;
}
var Xc, J8;
function XC() {
  return J8 || (J8 = 1, Xc = Function.call.bind(Object.prototype.hasOwnProperty)), Xc;
}
var Qc, e3;
function xI() {
  if (e3) return Qc;
  e3 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ Mh(), n = {}, r = /* @__PURE__ */ XC();
    e = function(i) {
      var a = "Warning: " + i;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function o(i, a, s, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in i)
        if (r(i, f)) {
          var u;
          try {
            if (typeof i[f] != "function") {
              var h = Error(
                (l || "React class") + ": " + s + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            u = i[f](a, f, l, s, null, t);
          } catch (g) {
            u = g;
          }
          if (u && !(u instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), u instanceof Error && !(u.message in n)) {
            n[u.message] = !0;
            var m = c ? c() : "";
            e(
              "Failed " + s + " type: " + u.message + (m ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Qc = o, Qc;
}
var Jc, t3;
function _I() {
  if (t3) return Jc;
  t3 = 1;
  var e = ZC(), t = wI(), n = /* @__PURE__ */ Mh(), r = /* @__PURE__ */ XC(), o = /* @__PURE__ */ xI(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return Jc = function(s, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function u($) {
      var U = $ && (c && $[c] || $[f]);
      if (typeof U == "function")
        return U;
    }
    var h = "<<anonymous>>", m = {
      array: y("array"),
      bigint: y("bigint"),
      bool: y("boolean"),
      func: y("function"),
      number: y("number"),
      object: y("object"),
      string: y("string"),
      symbol: y("symbol"),
      any: C(),
      arrayOf: w,
      element: _(),
      elementType: x(),
      instanceOf: k,
      node: R(),
      objectOf: T,
      oneOf: S,
      oneOfType: L,
      shape: A,
      exact: O
    };
    function g($, U) {
      return $ === U ? $ !== 0 || 1 / $ === 1 / U : $ !== $ && U !== U;
    }
    function p($, U) {
      this.message = $, this.data = U && typeof U == "object" ? U : {}, this.stack = "";
    }
    p.prototype = Error.prototype;
    function v($) {
      if (process.env.NODE_ENV !== "production")
        var U = {}, B = 0;
      function K(Z, G, V, Y, P, F, z) {
        if (Y = Y || h, F = F || V, z !== n) {
          if (l) {
            var E = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw E.name = "Invariant Violation", E;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var re = Y + ":" + V;
            !U[re] && // Avoid spamming the console because they are often not actionable except for lib authors
            B < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + F + "` prop on `" + Y + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), U[re] = !0, B++);
          }
        }
        return G[V] == null ? Z ? G[V] === null ? new p("The " + P + " `" + F + "` is marked as required " + ("in `" + Y + "`, but its value is `null`.")) : new p("The " + P + " `" + F + "` is marked as required in " + ("`" + Y + "`, but its value is `undefined`.")) : null : $(G, V, Y, P, F);
      }
      var X = K.bind(null, !1);
      return X.isRequired = K.bind(null, !0), X;
    }
    function y($) {
      function U(B, K, X, Z, G, V) {
        var Y = B[K], P = N(Y);
        if (P !== $) {
          var F = H(Y);
          return new p(
            "Invalid " + Z + " `" + G + "` of type " + ("`" + F + "` supplied to `" + X + "`, expected ") + ("`" + $ + "`."),
            { expectedType: $ }
          );
        }
        return null;
      }
      return v(U);
    }
    function C() {
      return v(a);
    }
    function w($) {
      function U(B, K, X, Z, G) {
        if (typeof $ != "function")
          return new p("Property `" + G + "` of component `" + X + "` has invalid PropType notation inside arrayOf.");
        var V = B[K];
        if (!Array.isArray(V)) {
          var Y = N(V);
          return new p("Invalid " + Z + " `" + G + "` of type " + ("`" + Y + "` supplied to `" + X + "`, expected an array."));
        }
        for (var P = 0; P < V.length; P++) {
          var F = $(V, P, X, Z, G + "[" + P + "]", n);
          if (F instanceof Error)
            return F;
        }
        return null;
      }
      return v(U);
    }
    function _() {
      function $(U, B, K, X, Z) {
        var G = U[B];
        if (!s(G)) {
          var V = N(G);
          return new p("Invalid " + X + " `" + Z + "` of type " + ("`" + V + "` supplied to `" + K + "`, expected a single ReactElement."));
        }
        return null;
      }
      return v($);
    }
    function x() {
      function $(U, B, K, X, Z) {
        var G = U[B];
        if (!e.isValidElementType(G)) {
          var V = N(G);
          return new p("Invalid " + X + " `" + Z + "` of type " + ("`" + V + "` supplied to `" + K + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return v($);
    }
    function k($) {
      function U(B, K, X, Z, G) {
        if (!(B[K] instanceof $)) {
          var V = $.name || h, Y = D(B[K]);
          return new p("Invalid " + Z + " `" + G + "` of type " + ("`" + Y + "` supplied to `" + X + "`, expected ") + ("instance of `" + V + "`."));
        }
        return null;
      }
      return v(U);
    }
    function S($) {
      if (!Array.isArray($))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), a;
      function U(B, K, X, Z, G) {
        for (var V = B[K], Y = 0; Y < $.length; Y++)
          if (g(V, $[Y]))
            return null;
        var P = JSON.stringify($, function(z, E) {
          var re = H(E);
          return re === "symbol" ? String(E) : E;
        });
        return new p("Invalid " + Z + " `" + G + "` of value `" + String(V) + "` " + ("supplied to `" + X + "`, expected one of " + P + "."));
      }
      return v(U);
    }
    function T($) {
      function U(B, K, X, Z, G) {
        if (typeof $ != "function")
          return new p("Property `" + G + "` of component `" + X + "` has invalid PropType notation inside objectOf.");
        var V = B[K], Y = N(V);
        if (Y !== "object")
          return new p("Invalid " + Z + " `" + G + "` of type " + ("`" + Y + "` supplied to `" + X + "`, expected an object."));
        for (var P in V)
          if (r(V, P)) {
            var F = $(V, P, X, Z, G + "." + P, n);
            if (F instanceof Error)
              return F;
          }
        return null;
      }
      return v(U);
    }
    function L($) {
      if (!Array.isArray($))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var U = 0; U < $.length; U++) {
        var B = $[U];
        if (typeof B != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + q(B) + " at index " + U + "."
          ), a;
      }
      function K(X, Z, G, V, Y) {
        for (var P = [], F = 0; F < $.length; F++) {
          var z = $[F], E = z(X, Z, G, V, Y, n);
          if (E == null)
            return null;
          E.data && r(E.data, "expectedType") && P.push(E.data.expectedType);
        }
        var re = P.length > 0 ? ", expected one of type [" + P.join(", ") + "]" : "";
        return new p("Invalid " + V + " `" + Y + "` supplied to " + ("`" + G + "`" + re + "."));
      }
      return v(K);
    }
    function R() {
      function $(U, B, K, X, Z) {
        return I(U[B]) ? null : new p("Invalid " + X + " `" + Z + "` supplied to " + ("`" + K + "`, expected a ReactNode."));
      }
      return v($);
    }
    function M($, U, B, K, X) {
      return new p(
        ($ || "React class") + ": " + U + " type `" + B + "." + K + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + X + "`."
      );
    }
    function A($) {
      function U(B, K, X, Z, G) {
        var V = B[K], Y = N(V);
        if (Y !== "object")
          return new p("Invalid " + Z + " `" + G + "` of type `" + Y + "` " + ("supplied to `" + X + "`, expected `object`."));
        for (var P in $) {
          var F = $[P];
          if (typeof F != "function")
            return M(X, Z, G, P, H(F));
          var z = F(V, P, X, Z, G + "." + P, n);
          if (z)
            return z;
        }
        return null;
      }
      return v(U);
    }
    function O($) {
      function U(B, K, X, Z, G) {
        var V = B[K], Y = N(V);
        if (Y !== "object")
          return new p("Invalid " + Z + " `" + G + "` of type `" + Y + "` " + ("supplied to `" + X + "`, expected `object`."));
        var P = t({}, B[K], $);
        for (var F in P) {
          var z = $[F];
          if (r($, F) && typeof z != "function")
            return M(X, Z, G, F, H(z));
          if (!z)
            return new p(
              "Invalid " + Z + " `" + G + "` key `" + F + "` supplied to `" + X + "`.\nBad object: " + JSON.stringify(B[K], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys($), null, "  ")
            );
          var E = z(V, F, X, Z, G + "." + F, n);
          if (E)
            return E;
        }
        return null;
      }
      return v(U);
    }
    function I($) {
      switch (typeof $) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !$;
        case "object":
          if (Array.isArray($))
            return $.every(I);
          if ($ === null || s($))
            return !0;
          var U = u($);
          if (U) {
            var B = U.call($), K;
            if (U !== $.entries) {
              for (; !(K = B.next()).done; )
                if (!I(K.value))
                  return !1;
            } else
              for (; !(K = B.next()).done; ) {
                var X = K.value;
                if (X && !I(X[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function W($, U) {
      return $ === "symbol" ? !0 : U ? U["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && U instanceof Symbol : !1;
    }
    function N($) {
      var U = typeof $;
      return Array.isArray($) ? "array" : $ instanceof RegExp ? "object" : W(U, $) ? "symbol" : U;
    }
    function H($) {
      if (typeof $ > "u" || $ === null)
        return "" + $;
      var U = N($);
      if (U === "object") {
        if ($ instanceof Date)
          return "date";
        if ($ instanceof RegExp)
          return "regexp";
      }
      return U;
    }
    function q($) {
      var U = H($);
      switch (U) {
        case "array":
        case "object":
          return "an " + U;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + U;
        default:
          return U;
      }
    }
    function D($) {
      return !$.constructor || !$.constructor.name ? h : $.constructor.name;
    }
    return m.checkPropTypes = o, m.resetWarningCache = o.resetWarningCache, m.PropTypes = m, m;
  }, Jc;
}
var e1, n3;
function kI() {
  if (n3) return e1;
  n3 = 1;
  var e = /* @__PURE__ */ Mh();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, e1 = function() {
    function r(a, s, l, c, f, u) {
      if (u !== e) {
        var h = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw h.name = "Invariant Violation", h;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, e1;
}
var r3;
function SI() {
  if (r3) return Rs.exports;
  if (r3 = 1, process.env.NODE_ENV !== "production") {
    var e = ZC(), t = !0;
    Rs.exports = /* @__PURE__ */ _I()(e.isElement, t);
  } else
    Rs.exports = /* @__PURE__ */ kI()();
  return Rs.exports;
}
var MI = /* @__PURE__ */ SI();
const J = /* @__PURE__ */ Ht(MI);
var Eh = ls(), Re = (e) => ss(e, Eh), Lh = ls();
Re.write = (e) => ss(e, Lh);
var vl = ls();
Re.onStart = (e) => ss(e, vl);
var Th = ls();
Re.onFrame = (e) => ss(e, Th);
var Ph = ls();
Re.onFinish = (e) => ss(e, Ph);
var ei = [];
Re.setTimeout = (e, t) => {
  const n = Re.now() + t, r = () => {
    const i = ei.findIndex((a) => a.cancel == r);
    ~i && ei.splice(i, 1), Dr -= ~i ? 1 : 0;
  }, o = { time: n, handler: e, cancel: r };
  return ei.splice(QC(n), 0, o), Dr += 1, JC(), o;
};
var QC = (e) => ~(~ei.findIndex((t) => t.time > e) || ~ei.length);
Re.cancel = (e) => {
  vl.delete(e), Th.delete(e), Ph.delete(e), Eh.delete(e), Lh.delete(e);
};
Re.sync = (e) => {
  H2 = !0, Re.batchedUpdates(e), H2 = !1;
};
Re.throttle = (e) => {
  let t;
  function n() {
    try {
      e(...t);
    } finally {
      t = null;
    }
  }
  function r(...o) {
    t = o, Re.onStart(n);
  }
  return r.handler = e, r.cancel = () => {
    vl.delete(n), t = null;
  }, r;
};
var Rh = typeof window < "u" ? window.requestAnimationFrame : (
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  () => {
  }
);
Re.use = (e) => Rh = e;
Re.now = typeof performance < "u" ? () => performance.now() : Date.now;
Re.batchedUpdates = (e) => e();
Re.catch = console.error;
Re.frameLoop = "always";
Re.advance = () => {
  Re.frameLoop !== "demand" ? console.warn(
    "Cannot call the manual advancement of rafz whilst frameLoop is not set as demand"
  ) : tw();
};
var Nr = -1, Dr = 0, H2 = !1;
function ss(e, t) {
  H2 ? (t.delete(e), e(0)) : (t.add(e), JC());
}
function JC() {
  Nr < 0 && (Nr = 0, Re.frameLoop !== "demand" && Rh(ew));
}
function EI() {
  Nr = -1;
}
function ew() {
  ~Nr && (Rh(ew), Re.batchedUpdates(tw));
}
function tw() {
  const e = Nr;
  Nr = Re.now();
  const t = QC(Nr);
  if (t && (nw(ei.splice(0, t), (n) => n.handler()), Dr -= t), !Dr) {
    EI();
    return;
  }
  vl.flush(), Eh.flush(e ? Math.min(64, Nr - e) : 16.667), Th.flush(), Lh.flush(), Ph.flush();
}
function ls() {
  let e = /* @__PURE__ */ new Set(), t = e;
  return {
    add(n) {
      Dr += t == e && !e.has(n) ? 1 : 0, e.add(n);
    },
    delete(n) {
      return Dr -= t == e && e.has(n) ? 1 : 0, e.delete(n);
    },
    flush(n) {
      t.size && (e = /* @__PURE__ */ new Set(), Dr -= t.size, nw(t, (r) => r(n) && e.add(r)), Dr += e.size, t = e);
    }
  };
}
function nw(e, t) {
  e.forEach((n) => {
    try {
      t(n);
    } catch (r) {
      Re.catch(r);
    }
  });
}
var LI = Object.defineProperty, TI = (e, t) => {
  for (var n in t)
    LI(e, n, { get: t[n], enumerable: !0 });
}, Nn = {};
TI(Nn, {
  assign: () => RI,
  colors: () => Br,
  createStringInterpolator: () => Oh,
  skipAnimation: () => ow,
  to: () => rw,
  willAdvance: () => Nh
});
function V2() {
}
var PI = (e, t, n) => Object.defineProperty(e, t, { value: n, writable: !0, configurable: !0 }), te = {
  arr: Array.isArray,
  obj: (e) => !!e && e.constructor.name === "Object",
  fun: (e) => typeof e == "function",
  str: (e) => typeof e == "string",
  num: (e) => typeof e == "number",
  und: (e) => e === void 0
};
function dr(e, t) {
  if (te.arr(e)) {
    if (!te.arr(t) || e.length !== t.length)
      return !1;
    for (let n = 0; n < e.length; n++)
      if (e[n] !== t[n])
        return !1;
    return !0;
  }
  return e === t;
}
var Le = (e, t) => e.forEach(t);
function Kn(e, t, n) {
  if (te.arr(e)) {
    for (let r = 0; r < e.length; r++)
      t.call(n, e[r], `${r}`);
    return;
  }
  for (const r in e)
    e.hasOwnProperty(r) && t.call(n, e[r], r);
}
var nn = (e) => te.und(e) ? [] : te.arr(e) ? e : [e];
function da(e, t) {
  if (e.size) {
    const n = Array.from(e);
    e.clear(), Le(n, t);
  }
}
var ia = (e, ...t) => da(e, (n) => n(...t)), Ah = () => typeof window > "u" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent), Oh, rw, Br = null, ow = !1, Nh = V2, RI = (e) => {
  e.to && (rw = e.to), e.now && (Re.now = e.now), e.colors !== void 0 && (Br = e.colors), e.skipAnimation != null && (ow = e.skipAnimation), e.createStringInterpolator && (Oh = e.createStringInterpolator), e.requestAnimationFrame && Re.use(e.requestAnimationFrame), e.batchedUpdates && (Re.batchedUpdates = e.batchedUpdates), e.willAdvance && (Nh = e.willAdvance), e.frameLoop && (Re.frameLoop = e.frameLoop);
}, fa = /* @__PURE__ */ new Set(), bn = [], t1 = [], i0 = 0, bl = {
  get idle() {
    return !fa.size && !bn.length;
  },
  /** Advance the given animation on every frame until idle. */
  start(e) {
    i0 > e.priority ? (fa.add(e), Re.onStart(AI)) : (iw(e), Re(U2));
  },
  /** Advance all animations by the given time. */
  advance: U2,
  /** Call this when an animation's priority changes. */
  sort(e) {
    if (i0)
      Re.onFrame(() => bl.sort(e));
    else {
      const t = bn.indexOf(e);
      ~t && (bn.splice(t, 1), aw(e));
    }
  },
  /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */
  clear() {
    bn = [], fa.clear();
  }
};
function AI() {
  fa.forEach(iw), fa.clear(), Re(U2);
}
function iw(e) {
  bn.includes(e) || aw(e);
}
function aw(e) {
  bn.splice(
    OI(bn, (t) => t.priority > e.priority),
    0,
    e
  );
}
function U2(e) {
  const t = t1;
  for (let n = 0; n < bn.length; n++) {
    const r = bn[n];
    i0 = r.priority, r.idle || (Nh(r), r.advance(e), r.idle || t.push(r));
  }
  return i0 = 0, t1 = bn, t1.length = 0, bn = t, bn.length > 0;
}
function OI(e, t) {
  const n = e.findIndex(t);
  return n < 0 ? e.length : n;
}
var NI = {
  transparent: 0,
  aliceblue: 4042850303,
  antiquewhite: 4209760255,
  aqua: 16777215,
  aquamarine: 2147472639,
  azure: 4043309055,
  beige: 4126530815,
  bisque: 4293182719,
  black: 255,
  blanchedalmond: 4293643775,
  blue: 65535,
  blueviolet: 2318131967,
  brown: 2771004159,
  burlywood: 3736635391,
  burntsienna: 3934150143,
  cadetblue: 1604231423,
  chartreuse: 2147418367,
  chocolate: 3530104575,
  coral: 4286533887,
  cornflowerblue: 1687547391,
  cornsilk: 4294499583,
  crimson: 3692313855,
  cyan: 16777215,
  darkblue: 35839,
  darkcyan: 9145343,
  darkgoldenrod: 3095792639,
  darkgray: 2846468607,
  darkgreen: 6553855,
  darkgrey: 2846468607,
  darkkhaki: 3182914559,
  darkmagenta: 2332068863,
  darkolivegreen: 1433087999,
  darkorange: 4287365375,
  darkorchid: 2570243327,
  darkred: 2332033279,
  darksalmon: 3918953215,
  darkseagreen: 2411499519,
  darkslateblue: 1211993087,
  darkslategray: 793726975,
  darkslategrey: 793726975,
  darkturquoise: 13554175,
  darkviolet: 2483082239,
  deeppink: 4279538687,
  deepskyblue: 12582911,
  dimgray: 1768516095,
  dimgrey: 1768516095,
  dodgerblue: 512819199,
  firebrick: 2988581631,
  floralwhite: 4294635775,
  forestgreen: 579543807,
  fuchsia: 4278255615,
  gainsboro: 3705462015,
  ghostwhite: 4177068031,
  gold: 4292280575,
  goldenrod: 3668254975,
  gray: 2155905279,
  green: 8388863,
  greenyellow: 2919182335,
  grey: 2155905279,
  honeydew: 4043305215,
  hotpink: 4285117695,
  indianred: 3445382399,
  indigo: 1258324735,
  ivory: 4294963455,
  khaki: 4041641215,
  lavender: 3873897215,
  lavenderblush: 4293981695,
  lawngreen: 2096890111,
  lemonchiffon: 4294626815,
  lightblue: 2916673279,
  lightcoral: 4034953471,
  lightcyan: 3774873599,
  lightgoldenrodyellow: 4210742015,
  lightgray: 3553874943,
  lightgreen: 2431553791,
  lightgrey: 3553874943,
  lightpink: 4290167295,
  lightsalmon: 4288707327,
  lightseagreen: 548580095,
  lightskyblue: 2278488831,
  lightslategray: 2005441023,
  lightslategrey: 2005441023,
  lightsteelblue: 2965692159,
  lightyellow: 4294959359,
  lime: 16711935,
  limegreen: 852308735,
  linen: 4210091775,
  magenta: 4278255615,
  maroon: 2147483903,
  mediumaquamarine: 1724754687,
  mediumblue: 52735,
  mediumorchid: 3126187007,
  mediumpurple: 2473647103,
  mediumseagreen: 1018393087,
  mediumslateblue: 2070474495,
  mediumspringgreen: 16423679,
  mediumturquoise: 1221709055,
  mediumvioletred: 3340076543,
  midnightblue: 421097727,
  mintcream: 4127193855,
  mistyrose: 4293190143,
  moccasin: 4293178879,
  navajowhite: 4292783615,
  navy: 33023,
  oldlace: 4260751103,
  olive: 2155872511,
  olivedrab: 1804477439,
  orange: 4289003775,
  orangered: 4282712319,
  orchid: 3664828159,
  palegoldenrod: 4008225535,
  palegreen: 2566625535,
  paleturquoise: 2951671551,
  palevioletred: 3681588223,
  papayawhip: 4293907967,
  peachpuff: 4292524543,
  peru: 3448061951,
  pink: 4290825215,
  plum: 3718307327,
  powderblue: 2967529215,
  purple: 2147516671,
  rebeccapurple: 1714657791,
  red: 4278190335,
  rosybrown: 3163525119,
  royalblue: 1097458175,
  saddlebrown: 2336560127,
  salmon: 4202722047,
  sandybrown: 4104413439,
  seagreen: 780883967,
  seashell: 4294307583,
  sienna: 2689740287,
  silver: 3233857791,
  skyblue: 2278484991,
  slateblue: 1784335871,
  slategray: 1887473919,
  slategrey: 1887473919,
  snow: 4294638335,
  springgreen: 16744447,
  steelblue: 1182971135,
  tan: 3535047935,
  teal: 8421631,
  thistle: 3636451583,
  tomato: 4284696575,
  turquoise: 1088475391,
  violet: 4001558271,
  wheat: 4125012991,
  white: 4294967295,
  whitesmoke: 4126537215,
  yellow: 4294902015,
  yellowgreen: 2597139199
}, Pn = "[-+]?\\d*\\.?\\d+", a0 = Pn + "%";
function yl(...e) {
  return "\\(\\s*(" + e.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var DI = new RegExp("rgb" + yl(Pn, Pn, Pn)), II = new RegExp("rgba" + yl(Pn, Pn, Pn, Pn)), BI = new RegExp("hsl" + yl(Pn, a0, a0)), $I = new RegExp(
  "hsla" + yl(Pn, a0, a0, Pn)
), FI = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, WI = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, qI = /^#([0-9a-fA-F]{6})$/, jI = /^#([0-9a-fA-F]{8})$/;
function HI(e) {
  let t;
  return typeof e == "number" ? e >>> 0 === e && e >= 0 && e <= 4294967295 ? e : null : (t = qI.exec(e)) ? parseInt(t[1] + "ff", 16) >>> 0 : Br && Br[e] !== void 0 ? Br[e] : (t = DI.exec(e)) ? (Wo(t[1]) << 24 | // r
  Wo(t[2]) << 16 | // g
  Wo(t[3]) << 8 | // b
  255) >>> // a
  0 : (t = II.exec(e)) ? (Wo(t[1]) << 24 | // r
  Wo(t[2]) << 16 | // g
  Wo(t[3]) << 8 | // b
  a3(t[4])) >>> // a
  0 : (t = FI.exec(e)) ? parseInt(
    t[1] + t[1] + // r
    t[2] + t[2] + // g
    t[3] + t[3] + // b
    "ff",
    // a
    16
  ) >>> 0 : (t = jI.exec(e)) ? parseInt(t[1], 16) >>> 0 : (t = WI.exec(e)) ? parseInt(
    t[1] + t[1] + // r
    t[2] + t[2] + // g
    t[3] + t[3] + // b
    t[4] + t[4],
    // a
    16
  ) >>> 0 : (t = BI.exec(e)) ? (o3(
    i3(t[1]),
    // h
    Os(t[2]),
    // s
    Os(t[3])
    // l
  ) | 255) >>> // a
  0 : (t = $I.exec(e)) ? (o3(
    i3(t[1]),
    // h
    Os(t[2]),
    // s
    Os(t[3])
    // l
  ) | a3(t[4])) >>> // a
  0 : null;
}
function n1(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function o3(e, t, n) {
  const r = n < 0.5 ? n * (1 + t) : n + t - n * t, o = 2 * n - r, i = n1(o, r, e + 1 / 3), a = n1(o, r, e), s = n1(o, r, e - 1 / 3);
  return Math.round(i * 255) << 24 | Math.round(a * 255) << 16 | Math.round(s * 255) << 8;
}
function Wo(e) {
  const t = parseInt(e, 10);
  return t < 0 ? 0 : t > 255 ? 255 : t;
}
function i3(e) {
  return (parseFloat(e) % 360 + 360) % 360 / 360;
}
function a3(e) {
  const t = parseFloat(e);
  return t < 0 ? 0 : t > 1 ? 255 : Math.round(t * 255);
}
function Os(e) {
  const t = parseFloat(e);
  return t < 0 ? 0 : t > 100 ? 1 : t / 100;
}
function s3(e) {
  let t = HI(e);
  if (t === null)
    return e;
  t = t || 0;
  const n = (t & 4278190080) >>> 24, r = (t & 16711680) >>> 16, o = (t & 65280) >>> 8, i = (t & 255) / 255;
  return `rgba(${n}, ${r}, ${o}, ${i})`;
}
var _a = (e, t, n) => {
  if (te.fun(e))
    return e;
  if (te.arr(e))
    return _a({
      range: e,
      output: t,
      extrapolate: n
    });
  if (te.str(e.output[0]))
    return Oh(e);
  const r = e, o = r.output, i = r.range || [0, 1], a = r.extrapolateLeft || r.extrapolate || "extend", s = r.extrapolateRight || r.extrapolate || "extend", l = r.easing || ((c) => c);
  return (c) => {
    const f = UI(c, i);
    return VI(
      c,
      i[f],
      i[f + 1],
      o[f],
      o[f + 1],
      l,
      a,
      s,
      r.map
    );
  };
};
function VI(e, t, n, r, o, i, a, s, l) {
  let c = l ? l(e) : e;
  if (c < t) {
    if (a === "identity")
      return c;
    a === "clamp" && (c = t);
  }
  if (c > n) {
    if (s === "identity")
      return c;
    s === "clamp" && (c = n);
  }
  return r === o ? r : t === n ? e <= t ? r : o : (t === -1 / 0 ? c = -c : n === 1 / 0 ? c = c - t : c = (c - t) / (n - t), c = i(c), r === -1 / 0 ? c = -c : o === 1 / 0 ? c = c + r : c = c * (o - r) + r, c);
}
function UI(e, t) {
  for (var n = 1; n < t.length - 1 && !(t[n] >= e); ++n)
    ;
  return n - 1;
}
var zI = {
  linear: (e) => e
}, ka = Symbol.for("FluidValue.get"), li = Symbol.for("FluidValue.observers"), vn = (e) => !!(e && e[ka]), cn = (e) => e && e[ka] ? e[ka]() : e, l3 = (e) => e[li] || null;
function YI(e, t) {
  e.eventObserved ? e.eventObserved(t) : e(t);
}
function Sa(e, t) {
  const n = e[li];
  n && n.forEach((r) => {
    YI(r, t);
  });
}
var sw = class {
  constructor(e) {
    if (!e && !(e = this.get))
      throw Error("Unknown getter");
    GI(this, e);
  }
}, GI = (e, t) => lw(e, ka, t);
function Ei(e, t) {
  if (e[ka]) {
    let n = e[li];
    n || lw(e, li, n = /* @__PURE__ */ new Set()), n.has(t) || (n.add(t), e.observerAdded && e.observerAdded(n.size, t));
  }
  return t;
}
function Ma(e, t) {
  const n = e[li];
  if (n && n.has(t)) {
    const r = n.size - 1;
    r ? n.delete(t) : e[li] = null, e.observerRemoved && e.observerRemoved(r, t);
  }
}
var lw = (e, t, n) => Object.defineProperty(e, t, {
  value: n,
  writable: !0,
  configurable: !0
}), Us = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, KI = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi, c3 = new RegExp(`(${Us.source})(%|[a-z]+)`, "i"), ZI = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi, Cl = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/, cw = (e) => {
  const [t, n] = XI(e);
  if (!t || Ah())
    return e;
  const r = window.getComputedStyle(document.documentElement).getPropertyValue(t);
  if (r)
    return r.trim();
  if (n && n.startsWith("--")) {
    const o = window.getComputedStyle(document.documentElement).getPropertyValue(n);
    return o || e;
  } else {
    if (n && Cl.test(n))
      return cw(n);
    if (n)
      return n;
  }
  return e;
}, XI = (e) => {
  const t = Cl.exec(e);
  if (!t)
    return [,];
  const [, n, r] = t;
  return [n, r];
}, r1, QI = (e, t, n, r, o) => `rgba(${Math.round(t)}, ${Math.round(n)}, ${Math.round(r)}, ${o})`, uw = (e) => {
  r1 || (r1 = Br ? (
    // match color names, ignore partial matches
    new RegExp(`(${Object.keys(Br).join("|")})(?!\\w)`, "g")
  ) : (
    // never match
    /^\b$/
  ));
  const t = e.output.map((i) => cn(i).replace(Cl, cw).replace(KI, s3).replace(r1, s3)), n = t.map((i) => i.match(Us).map(Number)), o = n[0].map(
    (i, a) => n.map((s) => {
      if (!(a in s))
        throw Error('The arity of each "output" value must be equal');
      return s[a];
    })
  ).map(
    (i) => _a({ ...e, output: i })
  );
  return (i) => {
    var l;
    const a = !c3.test(t[0]) && ((l = t.find((c) => c3.test(c))) == null ? void 0 : l.replace(Us, ""));
    let s = 0;
    return t[0].replace(
      Us,
      () => `${o[s++](i)}${a || ""}`
    ).replace(ZI, QI);
  };
}, Dh = "react-spring: ", dw = (e) => {
  const t = e;
  let n = !1;
  if (typeof t != "function")
    throw new TypeError(`${Dh}once requires a function parameter`);
  return (...r) => {
    n || (t(...r), n = !0);
  };
}, JI = dw(console.warn);
function eB() {
  JI(
    `${Dh}The "interpolate" function is deprecated in v9 (use "to" instead)`
  );
}
var tB = dw(console.warn);
function nB() {
  tB(
    `${Dh}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`
  );
}
function wl(e) {
  return te.str(e) && (e[0] == "#" || /\d/.test(e) || // Do not identify a CSS variable as an AnimatedString if its SSR
  !Ah() && Cl.test(e) || e in (Br || {}));
}
var to = Ah() ? dn : S9, rB = () => {
  const e = Lt(!1);
  return to(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
};
function Ih() {
  const e = Yt()[1], t = rB();
  return () => {
    t.current && e(Math.random());
  };
}
function oB(e, t) {
  const [n] = Yt(
    () => ({
      inputs: t,
      result: e()
    })
  ), r = Lt(), o = r.current;
  let i = o;
  return i ? t && i.inputs && iB(t, i.inputs) || (i = {
    inputs: t,
    result: e()
  }) : i = n, dn(() => {
    r.current = i, o == n && (n.inputs = n.result = void 0);
  }, [i]), i.result;
}
function iB(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
var Bh = (e) => dn(e, aB), aB = [];
function z2(e) {
  const t = Lt();
  return dn(() => {
    t.current = e;
  }), t.current;
}
var Ea = Symbol.for("Animated:node"), sB = (e) => !!e && e[Ea] === e, jn = (e) => e && e[Ea], $h = (e, t) => PI(e, Ea, t), xl = (e) => e && e[Ea] && e[Ea].getPayload(), fw = class {
  constructor() {
    $h(this, this);
  }
  /** Get every `AnimatedValue` used by this node. */
  getPayload() {
    return this.payload || [];
  }
}, cs = class extends fw {
  constructor(e) {
    super(), this._value = e, this.done = !0, this.durationProgress = 0, te.num(this._value) && (this.lastPosition = this._value);
  }
  /** @internal */
  static create(e) {
    return new cs(e);
  }
  getPayload() {
    return [this];
  }
  getValue() {
    return this._value;
  }
  setValue(e, t) {
    return te.num(e) && (this.lastPosition = e, t && (e = Math.round(e / t) * t, this.done && (this.lastPosition = e))), this._value === e ? !1 : (this._value = e, !0);
  }
  reset() {
    const { done: e } = this;
    this.done = !1, te.num(this._value) && (this.elapsedTime = 0, this.durationProgress = 0, this.lastPosition = this._value, e && (this.lastVelocity = null), this.v0 = null);
  }
}, La = class extends cs {
  constructor(e) {
    super(0), this._string = null, this._toString = _a({
      output: [e, e]
    });
  }
  /** @internal */
  static create(e) {
    return new La(e);
  }
  getValue() {
    const e = this._string;
    return e ?? (this._string = this._toString(this._value));
  }
  setValue(e) {
    if (te.str(e)) {
      if (e == this._string)
        return !1;
      this._string = e, this._value = 1;
    } else if (super.setValue(e))
      this._string = null;
    else
      return !1;
    return !0;
  }
  reset(e) {
    e && (this._toString = _a({
      output: [this.getValue(), e]
    })), this._value = 0, super.reset();
  }
}, s0 = { dependencies: null }, _l = class extends fw {
  constructor(e) {
    super(), this.source = e, this.setValue(e);
  }
  getValue(e) {
    const t = {};
    return Kn(this.source, (n, r) => {
      sB(n) ? t[r] = n.getValue(e) : vn(n) ? t[r] = cn(n) : e || (t[r] = n);
    }), t;
  }
  /** Replace the raw object data */
  setValue(e) {
    this.source = e, this.payload = this._makePayload(e);
  }
  reset() {
    this.payload && Le(this.payload, (e) => e.reset());
  }
  /** Create a payload set. */
  _makePayload(e) {
    if (e) {
      const t = /* @__PURE__ */ new Set();
      return Kn(e, this._addToPayload, t), Array.from(t);
    }
  }
  /** Add to a payload set. */
  _addToPayload(e) {
    s0.dependencies && vn(e) && s0.dependencies.add(e);
    const t = xl(e);
    t && Le(t, (n) => this.add(n));
  }
}, hw = class extends _l {
  constructor(e) {
    super(e);
  }
  /** @internal */
  static create(e) {
    return new hw(e);
  }
  getValue() {
    return this.source.map((e) => e.getValue());
  }
  setValue(e) {
    const t = this.getPayload();
    return e.length == t.length ? t.map((n, r) => n.setValue(e[r])).some(Boolean) : (super.setValue(e.map(lB)), !0);
  }
};
function lB(e) {
  return (wl(e) ? La : cs).create(e);
}
function Y2(e) {
  const t = jn(e);
  return t ? t.constructor : te.arr(e) ? hw : wl(e) ? La : cs;
}
var u3 = (e, t) => {
  const n = (
    // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !te.fun(e) || e.prototype && e.prototype.isReactComponent
  );
  return fe((r, o) => {
    const i = Lt(null), a = n && // eslint-disable-next-line react-hooks/rules-of-hooks
    be(
      (g) => {
        i.current = dB(o, g);
      },
      [o]
    ), [s, l] = uB(r, t), c = Ih(), f = () => {
      const g = i.current;
      if (n && !g)
        return;
      (g ? t.applyAnimatedValues(g, s.getValue(!0)) : !1) === !1 && c();
    }, u = new cB(f, l), h = Lt();
    to(() => (h.current = u, Le(l, (g) => Ei(g, u)), () => {
      h.current && (Le(
        h.current.deps,
        (g) => Ma(g, h.current)
      ), Re.cancel(h.current.update));
    })), dn(f, []), Bh(() => () => {
      const g = h.current;
      Le(g.deps, (p) => Ma(p, g));
    });
    const m = t.getComponentProps(s.getValue());
    return /* @__PURE__ */ d.createElement(e, { ...m, ref: a });
  });
}, cB = class {
  constructor(e, t) {
    this.update = e, this.deps = t;
  }
  eventObserved(e) {
    e.type == "change" && Re.write(this.update);
  }
};
function uB(e, t) {
  const n = /* @__PURE__ */ new Set();
  return s0.dependencies = n, e.style && (e = {
    ...e,
    style: t.createAnimatedStyle(e.style)
  }), e = new _l(e), s0.dependencies = null, [e, n];
}
function dB(e, t) {
  return e && (te.fun(e) ? e(t) : e.current = t), t;
}
var d3 = Symbol.for("AnimatedComponent"), fB = (e, {
  applyAnimatedValues: t = () => !1,
  createAnimatedStyle: n = (o) => new _l(o),
  getComponentProps: r = (o) => o
} = {}) => {
  const o = {
    applyAnimatedValues: t,
    createAnimatedStyle: n,
    getComponentProps: r
  }, i = (a) => {
    const s = f3(a) || "Anonymous";
    return te.str(a) ? a = i[a] || (i[a] = u3(a, o)) : a = a[d3] || (a[d3] = u3(a, o)), a.displayName = `Animated(${s})`, a;
  };
  return Kn(e, (a, s) => {
    te.arr(e) && (s = f3(a)), i[s] = i(a);
  }), {
    animated: i
  };
}, f3 = (e) => te.str(e) ? e : e && te.str(e.displayName) ? e.displayName : te.fun(e) && e.name || null;
function un(e, ...t) {
  return te.fun(e) ? e(...t) : e;
}
var ha = (e, t) => e === !0 || !!(t && e && (te.fun(e) ? e(t) : nn(e).includes(t))), mw = (e, t) => te.obj(e) ? t && e[t] : e, pw = (e, t) => e.default === !0 ? e[t] : e.default ? e.default[t] : void 0, hB = (e) => e, kl = (e, t = hB) => {
  let n = mB;
  e.default && e.default !== !0 && (e = e.default, n = Object.keys(e));
  const r = {};
  for (const o of n) {
    const i = t(e[o], o);
    te.und(i) || (r[o] = i);
  }
  return r;
}, mB = [
  "config",
  "onProps",
  "onStart",
  "onChange",
  "onPause",
  "onResume",
  "onRest"
], pB = {
  config: 1,
  from: 1,
  to: 1,
  ref: 1,
  loop: 1,
  reset: 1,
  pause: 1,
  cancel: 1,
  reverse: 1,
  immediate: 1,
  default: 1,
  delay: 1,
  onProps: 1,
  onStart: 1,
  onChange: 1,
  onPause: 1,
  onResume: 1,
  onRest: 1,
  onResolve: 1,
  // Transition props
  items: 1,
  trail: 1,
  sort: 1,
  expires: 1,
  initial: 1,
  enter: 1,
  update: 1,
  leave: 1,
  children: 1,
  onDestroyed: 1,
  // Internal props
  keys: 1,
  callId: 1,
  parentId: 1
};
function gB(e) {
  const t = {};
  let n = 0;
  if (Kn(e, (r, o) => {
    pB[o] || (t[o] = r, n++);
  }), n)
    return t;
}
function Fh(e) {
  const t = gB(e);
  if (t) {
    const n = { to: t };
    return Kn(e, (r, o) => o in t || (n[o] = r)), n;
  }
  return { ...e };
}
function Ta(e) {
  return e = cn(e), te.arr(e) ? e.map(Ta) : wl(e) ? Nn.createStringInterpolator({
    range: [0, 1],
    output: [e, e]
  })(1) : e;
}
function gw(e) {
  for (const t in e)
    return !0;
  return !1;
}
function G2(e) {
  return te.fun(e) || te.arr(e) && te.obj(e[0]);
}
function K2(e, t) {
  var n;
  (n = e.ref) == null || n.delete(e), t == null || t.delete(e);
}
function vw(e, t) {
  var n;
  t && e.ref !== t && ((n = e.ref) == null || n.delete(e), t.add(e), e.ref = t);
}
var Wh = {
  default: { tension: 170, friction: 26 },
  gentle: { tension: 120, friction: 14 },
  wobbly: { tension: 180, friction: 12 },
  stiff: { tension: 210, friction: 20 },
  slow: { tension: 280, friction: 60 },
  molasses: { tension: 280, friction: 120 }
}, Z2 = {
  ...Wh.default,
  mass: 1,
  damping: 1,
  easing: zI.linear,
  clamp: !1
}, vB = class {
  constructor() {
    this.velocity = 0, Object.assign(this, Z2);
  }
};
function bB(e, t, n) {
  n && (n = { ...n }, h3(n, t), t = { ...n, ...t }), h3(e, t), Object.assign(e, t);
  for (const a in Z2)
    e[a] == null && (e[a] = Z2[a]);
  let { frequency: r, damping: o } = e;
  const { mass: i } = e;
  return te.und(r) || (r < 0.01 && (r = 0.01), o < 0 && (o = 0), e.tension = Math.pow(2 * Math.PI / r, 2) * i, e.friction = 4 * Math.PI * o * i / r), e;
}
function h3(e, t) {
  if (!te.und(t.decay))
    e.duration = void 0;
  else {
    const n = !te.und(t.tension) || !te.und(t.friction);
    (n || !te.und(t.frequency) || !te.und(t.damping) || !te.und(t.mass)) && (e.duration = void 0, e.decay = void 0), n && (e.frequency = void 0);
  }
}
var m3 = [], yB = class {
  constructor() {
    this.changed = !1, this.values = m3, this.toValues = null, this.fromValues = m3, this.config = new vB(), this.immediate = !1;
  }
};
function bw(e, { key: t, props: n, defaultProps: r, state: o, actions: i }) {
  return new Promise((a, s) => {
    let l, c, f = ha(n.cancel ?? (r == null ? void 0 : r.cancel), t);
    if (f)
      m();
    else {
      te.und(n.pause) || (o.paused = ha(n.pause, t));
      let g = r == null ? void 0 : r.pause;
      g !== !0 && (g = o.paused || ha(g, t)), l = un(n.delay || 0, t), g ? (o.resumeQueue.add(h), i.pause()) : (i.resume(), h());
    }
    function u() {
      o.resumeQueue.add(h), o.timeouts.delete(c), c.cancel(), l = c.time - Re.now();
    }
    function h() {
      l > 0 && !Nn.skipAnimation ? (o.delayed = !0, c = Re.setTimeout(m, l), o.pauseQueue.add(u), o.timeouts.add(c)) : m();
    }
    function m() {
      o.delayed && (o.delayed = !1), o.pauseQueue.delete(u), o.timeouts.delete(c), e <= (o.cancelId || 0) && (f = !0);
      try {
        i.start({ ...n, callId: e, cancel: f }, a);
      } catch (g) {
        s(g);
      }
    }
  });
}
var qh = (e, t) => t.length == 1 ? t[0] : t.some((n) => n.cancelled) ? ti(e.get()) : t.every((n) => n.noop) ? yw(e.get()) : Ln(
  e.get(),
  t.every((n) => n.finished)
), yw = (e) => ({
  value: e,
  noop: !0,
  finished: !0,
  cancelled: !1
}), Ln = (e, t, n = !1) => ({
  value: e,
  finished: t,
  cancelled: n
}), ti = (e) => ({
  value: e,
  cancelled: !0,
  finished: !1
});
function Cw(e, t, n, r) {
  const { callId: o, parentId: i, onRest: a } = t, { asyncTo: s, promise: l } = n;
  return !i && e === s && !t.reset ? l : n.promise = (async () => {
    n.asyncId = o, n.asyncTo = e;
    const c = kl(
      t,
      (v, y) => (
        // The `onRest` prop is only called when the `runAsync` promise is resolved.
        y === "onRest" ? void 0 : v
      )
    );
    let f, u;
    const h = new Promise(
      (v, y) => (f = v, u = y)
    ), m = (v) => {
      const y = (
        // The `cancel` prop or `stop` method was used.
        o <= (n.cancelId || 0) && ti(r) || // The async `to` prop was replaced.
        o !== n.asyncId && Ln(r, !1)
      );
      if (y)
        throw v.result = y, u(v), v;
    }, g = (v, y) => {
      const C = new p3(), w = new g3();
      return (async () => {
        if (Nn.skipAnimation)
          throw Pa(n), w.result = Ln(r, !1), u(w), w;
        m(C);
        const _ = te.obj(v) ? { ...v } : { ...y, to: v };
        _.parentId = o, Kn(c, (k, S) => {
          te.und(_[S]) && (_[S] = k);
        });
        const x = await r.start(_);
        return m(C), n.paused && await new Promise((k) => {
          n.resumeQueue.add(k);
        }), x;
      })();
    };
    let p;
    if (Nn.skipAnimation)
      return Pa(n), Ln(r, !1);
    try {
      let v;
      te.arr(e) ? v = (async (y) => {
        for (const C of y)
          await g(C);
      })(e) : v = Promise.resolve(e(g, r.stop.bind(r))), await Promise.all([v.then(f), h]), p = Ln(r.get(), !0, !1);
    } catch (v) {
      if (v instanceof p3)
        p = v.result;
      else if (v instanceof g3)
        p = v.result;
      else
        throw v;
    } finally {
      o == n.asyncId && (n.asyncId = i, n.asyncTo = i ? s : void 0, n.promise = i ? l : void 0);
    }
    return te.fun(a) && Re.batchedUpdates(() => {
      a(p, r, r.item);
    }), p;
  })();
}
function Pa(e, t) {
  da(e.timeouts, (n) => n.cancel()), e.pauseQueue.clear(), e.resumeQueue.clear(), e.asyncId = e.asyncTo = e.promise = void 0, t && (e.cancelId = t);
}
var p3 = class extends Error {
  constructor() {
    super(
      "An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise."
    );
  }
}, g3 = class extends Error {
  constructor() {
    super("SkipAnimationSignal");
  }
}, X2 = (e) => e instanceof jh, CB = 1, jh = class extends sw {
  constructor() {
    super(...arguments), this.id = CB++, this._priority = 0;
  }
  get priority() {
    return this._priority;
  }
  set priority(e) {
    this._priority != e && (this._priority = e, this._onPriorityChange(e));
  }
  /** Get the current value */
  get() {
    const e = jn(this);
    return e && e.getValue();
  }
  /** Create a spring that maps our value to another value */
  to(...e) {
    return Nn.to(this, e);
  }
  /** @deprecated Use the `to` method instead. */
  interpolate(...e) {
    return eB(), Nn.to(this, e);
  }
  toJSON() {
    return this.get();
  }
  observerAdded(e) {
    e == 1 && this._attach();
  }
  observerRemoved(e) {
    e == 0 && this._detach();
  }
  /** Called when the first child is added. */
  _attach() {
  }
  /** Called when the last child is removed. */
  _detach() {
  }
  /** Tell our children about our new value */
  _onChange(e, t = !1) {
    Sa(this, {
      type: "change",
      parent: this,
      value: e,
      idle: t
    });
  }
  /** Tell our children about our new priority */
  _onPriorityChange(e) {
    this.idle || bl.sort(this), Sa(this, {
      type: "priority",
      parent: this,
      priority: e
    });
  }
}, go = Symbol.for("SpringPhase"), ww = 1, xw = 2, _w = 4, o1 = (e) => (e[go] & ww) > 0, Tr = (e) => (e[go] & xw) > 0, ji = (e) => (e[go] & _w) > 0, v3 = (e, t) => t ? e[go] |= xw | ww : e[go] &= -3, b3 = (e, t) => t ? e[go] |= _w : e[go] &= -5, wB = class extends jh {
  constructor(e, t) {
    if (super(), this.animation = new yB(), this.defaultProps = {}, this._state = {
      paused: !1,
      delayed: !1,
      pauseQueue: /* @__PURE__ */ new Set(),
      resumeQueue: /* @__PURE__ */ new Set(),
      timeouts: /* @__PURE__ */ new Set()
    }, this._pendingCalls = /* @__PURE__ */ new Set(), this._lastCallId = 0, this._lastToId = 0, this._memoizedDuration = 0, !te.und(e) || !te.und(t)) {
      const n = te.obj(e) ? { ...e } : { ...t, from: e };
      te.und(n.default) && (n.default = !0), this.start(n);
    }
  }
  /** Equals true when not advancing on each frame. */
  get idle() {
    return !(Tr(this) || this._state.asyncTo) || ji(this);
  }
  get goal() {
    return cn(this.animation.to);
  }
  get velocity() {
    const e = jn(this);
    return e instanceof cs ? e.lastVelocity || 0 : e.getPayload().map((t) => t.lastVelocity || 0);
  }
  /**
   * When true, this value has been animated at least once.
   */
  get hasAnimated() {
    return o1(this);
  }
  /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */
  get isAnimating() {
    return Tr(this);
  }
  /**
   * When true, all current and future animations are paused.
   */
  get isPaused() {
    return ji(this);
  }
  /**
   *
   *
   */
  get isDelayed() {
    return this._state.delayed;
  }
  /** Advance the current animation by a number of milliseconds */
  advance(e) {
    let t = !0, n = !1;
    const r = this.animation;
    let { toValues: o } = r;
    const { config: i } = r, a = xl(r.to);
    !a && vn(r.to) && (o = nn(cn(r.to))), r.values.forEach((c, f) => {
      if (c.done)
        return;
      const u = (
        // Animated strings always go from 0 to 1.
        c.constructor == La ? 1 : a ? a[f].lastPosition : o[f]
      );
      let h = r.immediate, m = u;
      if (!h) {
        if (m = c.lastPosition, i.tension <= 0) {
          c.done = !0;
          return;
        }
        let g = c.elapsedTime += e;
        const p = r.fromValues[f], v = c.v0 != null ? c.v0 : c.v0 = te.arr(i.velocity) ? i.velocity[f] : i.velocity;
        let y;
        const C = i.precision || (p == u ? 5e-3 : Math.min(1, Math.abs(u - p) * 1e-3));
        if (te.und(i.duration))
          if (i.decay) {
            const w = i.decay === !0 ? 0.998 : i.decay, _ = Math.exp(-(1 - w) * g);
            m = p + v / (1 - w) * (1 - _), h = Math.abs(c.lastPosition - m) <= C, y = v * _;
          } else {
            y = c.lastVelocity == null ? v : c.lastVelocity;
            const w = i.restVelocity || C / 10, _ = i.clamp ? 0 : i.bounce, x = !te.und(_), k = p == u ? c.v0 > 0 : p < u;
            let S, T = !1;
            const L = 1, R = Math.ceil(e / L);
            for (let M = 0; M < R && (S = Math.abs(y) > w, !(!S && (h = Math.abs(u - m) <= C, h))); ++M) {
              x && (T = m == u || m > u == k, T && (y = -y * _, m = u));
              const A = -i.tension * 1e-6 * (m - u), O = -i.friction * 1e-3 * y, I = (A + O) / i.mass;
              y = y + I * L, m = m + y * L;
            }
          }
        else {
          let w = 1;
          i.duration > 0 && (this._memoizedDuration !== i.duration && (this._memoizedDuration = i.duration, c.durationProgress > 0 && (c.elapsedTime = i.duration * c.durationProgress, g = c.elapsedTime += e)), w = (i.progress || 0) + g / this._memoizedDuration, w = w > 1 ? 1 : w < 0 ? 0 : w, c.durationProgress = w), m = p + i.easing(w) * (u - p), y = (m - c.lastPosition) / e, h = w == 1;
        }
        c.lastVelocity = y, Number.isNaN(m) && (console.warn("Got NaN while animating:", this), h = !0);
      }
      a && !a[f].done && (h = !1), h ? c.done = !0 : t = !1, c.setValue(m, i.round) && (n = !0);
    });
    const s = jn(this), l = s.getValue();
    if (t) {
      const c = cn(r.to);
      (l !== c || n) && !i.decay ? (s.setValue(c), this._onChange(c)) : n && i.decay && this._onChange(l), this._stop();
    } else n && this._onChange(l);
  }
  /** Set the current value, while stopping the current animation */
  set(e) {
    return Re.batchedUpdates(() => {
      this._stop(), this._focus(e), this._set(e);
    }), this;
  }
  /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */
  pause() {
    this._update({ pause: !0 });
  }
  /** Resume the animation if paused. */
  resume() {
    this._update({ pause: !1 });
  }
  /** Skip to the end of the current animation. */
  finish() {
    if (Tr(this)) {
      const { to: e, config: t } = this.animation;
      Re.batchedUpdates(() => {
        this._onStart(), t.decay || this._set(e, !1), this._stop();
      });
    }
    return this;
  }
  /** Push props into the pending queue. */
  update(e) {
    return (this.queue || (this.queue = [])).push(e), this;
  }
  start(e, t) {
    let n;
    return te.und(e) ? (n = this.queue || [], this.queue = []) : n = [te.obj(e) ? e : { ...t, to: e }], Promise.all(
      n.map((r) => this._update(r))
    ).then((r) => qh(this, r));
  }
  /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */
  stop(e) {
    const { to: t } = this.animation;
    return this._focus(this.get()), Pa(this._state, e && this._lastCallId), Re.batchedUpdates(() => this._stop(t, e)), this;
  }
  /** Restart the animation. */
  reset() {
    this._update({ reset: !0 });
  }
  /** @internal */
  eventObserved(e) {
    e.type == "change" ? this._start() : e.type == "priority" && (this.priority = e.priority + 1);
  }
  /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */
  _prepareNode(e) {
    const t = this.key || "";
    let { to: n, from: r } = e;
    n = te.obj(n) ? n[t] : n, (n == null || G2(n)) && (n = void 0), r = te.obj(r) ? r[t] : r, r == null && (r = void 0);
    const o = { to: n, from: r };
    return o1(this) || (e.reverse && ([n, r] = [r, n]), r = cn(r), te.und(r) ? jn(this) || this._set(n) : this._set(r)), o;
  }
  /** Every update is processed by this method before merging. */
  _update({ ...e }, t) {
    const { key: n, defaultProps: r } = this;
    e.default && Object.assign(
      r,
      kl(
        e,
        (a, s) => /^on/.test(s) ? mw(a, n) : a
      )
    ), C3(this, e, "onProps"), Vi(this, "onProps", e, this);
    const o = this._prepareNode(e);
    if (Object.isFrozen(this))
      throw Error(
        "Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?"
      );
    const i = this._state;
    return bw(++this._lastCallId, {
      key: n,
      props: e,
      defaultProps: r,
      state: i,
      actions: {
        pause: () => {
          ji(this) || (b3(this, !0), ia(i.pauseQueue), Vi(
            this,
            "onPause",
            Ln(this, Hi(this, this.animation.to)),
            this
          ));
        },
        resume: () => {
          ji(this) && (b3(this, !1), Tr(this) && this._resume(), ia(i.resumeQueue), Vi(
            this,
            "onResume",
            Ln(this, Hi(this, this.animation.to)),
            this
          ));
        },
        start: this._merge.bind(this, o)
      }
    }).then((a) => {
      if (e.loop && a.finished && !(t && a.noop)) {
        const s = kw(e);
        if (s)
          return this._update(s, !0);
      }
      return a;
    });
  }
  /** Merge props into the current animation */
  _merge(e, t, n) {
    if (t.cancel)
      return this.stop(!0), n(ti(this));
    const r = !te.und(e.to), o = !te.und(e.from);
    if (r || o)
      if (t.callId > this._lastToId)
        this._lastToId = t.callId;
      else
        return n(ti(this));
    const { key: i, defaultProps: a, animation: s } = this, { to: l, from: c } = s;
    let { to: f = l, from: u = c } = e;
    o && !r && (!t.default || te.und(f)) && (f = u), t.reverse && ([f, u] = [u, f]);
    const h = !dr(u, c);
    h && (s.from = u), u = cn(u);
    const m = !dr(f, l);
    m && this._focus(f);
    const g = G2(t.to), { config: p } = s, { decay: v, velocity: y } = p;
    (r || o) && (p.velocity = 0), t.config && !g && bB(
      p,
      un(t.config, i),
      // Avoid calling the same "config" prop twice.
      t.config !== a.config ? un(a.config, i) : void 0
    );
    let C = jn(this);
    if (!C || te.und(f))
      return n(Ln(this, !0));
    const w = (
      // When `reset` is undefined, the `from` prop implies `reset: true`,
      // except for declarative updates. When `reset` is defined, there
      // must exist a value to animate from.
      te.und(t.reset) ? o && !t.default : !te.und(u) && ha(t.reset, i)
    ), _ = w ? u : this.get(), x = Ta(f), k = te.num(x) || te.arr(x) || wl(x), S = !g && (!k || ha(a.immediate || t.immediate, i));
    if (m) {
      const M = Y2(f);
      if (M !== C.constructor)
        if (S)
          C = this._set(x);
        else
          throw Error(
            `Cannot animate between ${C.constructor.name} and ${M.name}, as the "to" prop suggests`
          );
    }
    const T = C.constructor;
    let L = vn(f), R = !1;
    if (!L) {
      const M = w || !o1(this) && h;
      (m || M) && (R = dr(Ta(_), x), L = !R), (!dr(s.immediate, S) && !S || !dr(p.decay, v) || !dr(p.velocity, y)) && (L = !0);
    }
    if (R && Tr(this) && (s.changed && !w ? L = !0 : L || this._stop(l)), !g && ((L || vn(l)) && (s.values = C.getPayload(), s.toValues = vn(f) ? null : T == La ? [1] : nn(x)), s.immediate != S && (s.immediate = S, !S && !w && this._set(l)), L)) {
      const { onRest: M } = s;
      Le(_B, (O) => C3(this, t, O));
      const A = Ln(this, Hi(this, l));
      ia(this._pendingCalls, A), this._pendingCalls.add(n), s.changed && Re.batchedUpdates(() => {
        var O;
        s.changed = !w, M == null || M(A, this), w ? un(a.onRest, A) : (O = s.onStart) == null || O.call(s, A, this);
      });
    }
    w && this._set(_), g ? n(Cw(t.to, t, this._state, this)) : L ? this._start() : Tr(this) && !m ? this._pendingCalls.add(n) : n(yw(_));
  }
  /** Update the `animation.to` value, which might be a `FluidValue` */
  _focus(e) {
    const t = this.animation;
    e !== t.to && (l3(this) && this._detach(), t.to = e, l3(this) && this._attach());
  }
  _attach() {
    let e = 0;
    const { to: t } = this.animation;
    vn(t) && (Ei(t, this), X2(t) && (e = t.priority + 1)), this.priority = e;
  }
  _detach() {
    const { to: e } = this.animation;
    vn(e) && Ma(e, this);
  }
  /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */
  _set(e, t = !0) {
    const n = cn(e);
    if (!te.und(n)) {
      const r = jn(this);
      if (!r || !dr(n, r.getValue())) {
        const o = Y2(n);
        !r || r.constructor != o ? $h(this, o.create(n)) : r.setValue(n), r && Re.batchedUpdates(() => {
          this._onChange(n, t);
        });
      }
    }
    return jn(this);
  }
  _onStart() {
    const e = this.animation;
    e.changed || (e.changed = !0, Vi(
      this,
      "onStart",
      Ln(this, Hi(this, e.to)),
      this
    ));
  }
  _onChange(e, t) {
    t || (this._onStart(), un(this.animation.onChange, e, this)), un(this.defaultProps.onChange, e, this), super._onChange(e, t);
  }
  // This method resets the animation state (even if already animating) to
  // ensure the latest from/to range is used, and it also ensures this spring
  // is added to the frameloop.
  _start() {
    const e = this.animation;
    jn(this).reset(cn(e.to)), e.immediate || (e.fromValues = e.values.map((t) => t.lastPosition)), Tr(this) || (v3(this, !0), ji(this) || this._resume());
  }
  _resume() {
    Nn.skipAnimation ? this.finish() : bl.start(this);
  }
  /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */
  _stop(e, t) {
    if (Tr(this)) {
      v3(this, !1);
      const n = this.animation;
      Le(n.values, (o) => {
        o.done = !0;
      }), n.toValues && (n.onChange = n.onPause = n.onResume = void 0), Sa(this, {
        type: "idle",
        parent: this
      });
      const r = t ? ti(this.get()) : Ln(this.get(), Hi(this, e ?? n.to));
      ia(this._pendingCalls, r), n.changed && (n.changed = !1, Vi(this, "onRest", r, this));
    }
  }
};
function Hi(e, t) {
  const n = Ta(t), r = Ta(e.get());
  return dr(r, n);
}
function kw(e, t = e.loop, n = e.to) {
  const r = un(t);
  if (r) {
    const o = r !== !0 && Fh(r), i = (o || e).reverse, a = !o || o.reset;
    return Ra({
      ...e,
      loop: t,
      // Avoid updating default props when looping.
      default: !1,
      // Never loop the `pause` prop.
      pause: void 0,
      // For the "reverse" prop to loop as expected, the "to" prop
      // must be undefined. The "reverse" prop is ignored when the
      // "to" prop is an array or function.
      to: !i || G2(n) ? n : void 0,
      // Ignore the "from" prop except on reset.
      from: a ? e.from : void 0,
      reset: a,
      // The "loop" prop can return a "useSpring" props object to
      // override any of the original props.
      ...o
    });
  }
}
function Ra(e) {
  const { to: t, from: n } = e = Fh(e), r = /* @__PURE__ */ new Set();
  return te.obj(t) && y3(t, r), te.obj(n) && y3(n, r), e.keys = r.size ? Array.from(r) : null, e;
}
function xB(e) {
  const t = Ra(e);
  return te.und(t.default) && (t.default = kl(t)), t;
}
function y3(e, t) {
  Kn(e, (n, r) => n != null && t.add(r));
}
var _B = [
  "onStart",
  "onRest",
  "onChange",
  "onPause",
  "onResume"
];
function C3(e, t, n) {
  e.animation[n] = t[n] !== pw(t, n) ? mw(t[n], e.key) : void 0;
}
function Vi(e, t, ...n) {
  var r, o, i, a;
  (o = (r = e.animation)[t]) == null || o.call(r, ...n), (a = (i = e.defaultProps)[t]) == null || a.call(i, ...n);
}
var kB = ["onStart", "onChange", "onRest"], SB = 1, Sw = class {
  constructor(e, t) {
    this.id = SB++, this.springs = {}, this.queue = [], this._lastAsyncId = 0, this._active = /* @__PURE__ */ new Set(), this._changed = /* @__PURE__ */ new Set(), this._started = !1, this._state = {
      paused: !1,
      pauseQueue: /* @__PURE__ */ new Set(),
      resumeQueue: /* @__PURE__ */ new Set(),
      timeouts: /* @__PURE__ */ new Set()
    }, this._events = {
      onStart: /* @__PURE__ */ new Map(),
      onChange: /* @__PURE__ */ new Map(),
      onRest: /* @__PURE__ */ new Map()
    }, this._onFrame = this._onFrame.bind(this), t && (this._flush = t), e && this.start({ default: !0, ...e });
  }
  /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */
  get idle() {
    return !this._state.asyncTo && Object.values(this.springs).every((e) => e.idle && !e.isDelayed && !e.isPaused);
  }
  get item() {
    return this._item;
  }
  set item(e) {
    this._item = e;
  }
  /** Get the current values of our springs */
  get() {
    const e = {};
    return this.each((t, n) => e[n] = t.get()), e;
  }
  /** Set the current values without animating. */
  set(e) {
    for (const t in e) {
      const n = e[t];
      te.und(n) || this.springs[t].set(n);
    }
  }
  /** Push an update onto the queue of each value. */
  update(e) {
    return e && this.queue.push(Ra(e)), this;
  }
  /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */
  start(e) {
    let { queue: t } = this;
    return e ? t = nn(e).map(Ra) : this.queue = [], this._flush ? this._flush(this, t) : (Pw(this, t), Q2(this, t));
  }
  /** @internal */
  stop(e, t) {
    if (e !== !!e && (t = e), t) {
      const n = this.springs;
      Le(nn(t), (r) => n[r].stop(!!e));
    } else
      Pa(this._state, this._lastAsyncId), this.each((n) => n.stop(!!e));
    return this;
  }
  /** Freeze the active animation in time */
  pause(e) {
    if (te.und(e))
      this.start({ pause: !0 });
    else {
      const t = this.springs;
      Le(nn(e), (n) => t[n].pause());
    }
    return this;
  }
  /** Resume the animation if paused. */
  resume(e) {
    if (te.und(e))
      this.start({ pause: !1 });
    else {
      const t = this.springs;
      Le(nn(e), (n) => t[n].resume());
    }
    return this;
  }
  /** Call a function once per spring value */
  each(e) {
    Kn(this.springs, e);
  }
  /** @internal Called at the end of every animation frame */
  _onFrame() {
    const { onStart: e, onChange: t, onRest: n } = this._events, r = this._active.size > 0, o = this._changed.size > 0;
    (r && !this._started || o && !this._started) && (this._started = !0, da(e, ([s, l]) => {
      l.value = this.get(), s(l, this, this._item);
    }));
    const i = !r && this._started, a = o || i && n.size ? this.get() : null;
    o && t.size && da(t, ([s, l]) => {
      l.value = a, s(l, this, this._item);
    }), i && (this._started = !1, da(n, ([s, l]) => {
      l.value = a, s(l, this, this._item);
    }));
  }
  /** @internal */
  eventObserved(e) {
    if (e.type == "change")
      this._changed.add(e.parent), e.idle || this._active.add(e.parent);
    else if (e.type == "idle")
      this._active.delete(e.parent);
    else
      return;
    Re.onFrame(this._onFrame);
  }
};
function Q2(e, t) {
  return Promise.all(t.map((n) => Mw(e, n))).then(
    (n) => qh(e, n)
  );
}
async function Mw(e, t, n) {
  const { keys: r, to: o, from: i, loop: a, onRest: s, onResolve: l } = t, c = te.obj(t.default) && t.default;
  a && (t.loop = !1), o === !1 && (t.to = null), i === !1 && (t.from = null);
  const f = te.arr(o) || te.fun(o) ? o : void 0;
  f ? (t.to = void 0, t.onRest = void 0, c && (c.onRest = void 0)) : Le(kB, (p) => {
    const v = t[p];
    if (te.fun(v)) {
      const y = e._events[p];
      t[p] = ({ finished: C, cancelled: w }) => {
        const _ = y.get(v);
        _ ? (C || (_.finished = !1), w && (_.cancelled = !0)) : y.set(v, {
          value: null,
          finished: C || !1,
          cancelled: w || !1
        });
      }, c && (c[p] = t[p]);
    }
  });
  const u = e._state;
  t.pause === !u.paused ? (u.paused = t.pause, ia(t.pause ? u.pauseQueue : u.resumeQueue)) : u.paused && (t.pause = !0);
  const h = (r || Object.keys(e.springs)).map(
    (p) => e.springs[p].start(t)
  ), m = t.cancel === !0 || pw(t, "cancel") === !0;
  (f || m && u.asyncId) && h.push(
    bw(++e._lastAsyncId, {
      props: t,
      state: u,
      actions: {
        pause: V2,
        resume: V2,
        start(p, v) {
          m ? (Pa(u, e._lastAsyncId), v(ti(e))) : (p.onRest = s, v(
            Cw(
              f,
              p,
              u,
              e
            )
          ));
        }
      }
    })
  ), u.paused && await new Promise((p) => {
    u.resumeQueue.add(p);
  });
  const g = qh(e, await Promise.all(h));
  if (a && g.finished && !(n && g.noop)) {
    const p = kw(t, a, o);
    if (p)
      return Pw(e, [p]), Mw(e, p, !0);
  }
  return l && Re.batchedUpdates(() => l(g, e, e.item)), g;
}
function J2(e, t) {
  const n = { ...e.springs };
  return t && Le(nn(t), (r) => {
    te.und(r.keys) && (r = Ra(r)), te.obj(r.to) || (r = { ...r, to: void 0 }), Tw(n, r, (o) => Lw(o));
  }), Ew(e, n), n;
}
function Ew(e, t) {
  Kn(t, (n, r) => {
    e.springs[r] || (e.springs[r] = n, Ei(n, e));
  });
}
function Lw(e, t) {
  const n = new wB();
  return n.key = e, t && Ei(n, t), n;
}
function Tw(e, t, n) {
  t.keys && Le(t.keys, (r) => {
    (e[r] || (e[r] = n(r)))._prepareNode(t);
  });
}
function Pw(e, t) {
  Le(t, (n) => {
    Tw(e.springs, n, (r) => Lw(r, e));
  });
}
var us = ({
  children: e,
  ...t
}) => {
  const n = Yn(l0), r = t.pause || !!n.pause, o = t.immediate || !!n.immediate;
  t = oB(() => ({ pause: r, immediate: o }), [r, o]);
  const { Provider: i } = l0;
  return /* @__PURE__ */ d.createElement(i, { value: t }, e);
}, l0 = MB(us, {});
us.Provider = l0.Provider;
us.Consumer = l0.Consumer;
function MB(e, t) {
  return Object.assign(e, d.createContext(t)), e.Provider._context = e, e.Consumer._context = e, e;
}
var Rw = () => {
  const e = [], t = function(r) {
    nB();
    const o = [];
    return Le(e, (i, a) => {
      if (te.und(r))
        o.push(i.start());
      else {
        const s = n(r, i, a);
        s && o.push(i.start(s));
      }
    }), o;
  };
  t.current = e, t.add = function(r) {
    e.includes(r) || e.push(r);
  }, t.delete = function(r) {
    const o = e.indexOf(r);
    ~o && e.splice(o, 1);
  }, t.pause = function() {
    return Le(e, (r) => r.pause(...arguments)), this;
  }, t.resume = function() {
    return Le(e, (r) => r.resume(...arguments)), this;
  }, t.set = function(r) {
    Le(e, (o, i) => {
      const a = te.fun(r) ? r(i, o) : r;
      a && o.set(a);
    });
  }, t.start = function(r) {
    const o = [];
    return Le(e, (i, a) => {
      if (te.und(r))
        o.push(i.start());
      else {
        const s = this._getProps(r, i, a);
        s && o.push(i.start(s));
      }
    }), o;
  }, t.stop = function() {
    return Le(e, (r) => r.stop(...arguments)), this;
  }, t.update = function(r) {
    return Le(e, (o, i) => o.update(this._getProps(r, o, i))), this;
  };
  const n = function(r, o, i) {
    return te.fun(r) ? r(i, o) : r;
  };
  return t._getProps = n, t;
};
function EB(e, t, n) {
  const r = te.fun(t) && t;
  r && !n && (n = []);
  const o = Te(
    () => r || arguments.length == 3 ? Rw() : void 0,
    []
  ), i = Lt(0), a = Ih(), s = Te(
    () => ({
      ctrls: [],
      queue: [],
      flush(y, C) {
        const w = J2(y, C);
        return i.current > 0 && !s.queue.length && !Object.keys(w).some((x) => !y.springs[x]) ? Q2(y, C) : new Promise((x) => {
          Ew(y, w), s.queue.push(() => {
            x(Q2(y, C));
          }), a();
        });
      }
    }),
    []
  ), l = Lt([...s.ctrls]), c = [], f = z2(e) || 0;
  Te(() => {
    Le(l.current.slice(e, f), (y) => {
      K2(y, o), y.stop(!0);
    }), l.current.length = e, u(f, e);
  }, [e]), Te(() => {
    u(0, Math.min(f, e));
  }, n);
  function u(y, C) {
    for (let w = y; w < C; w++) {
      const _ = l.current[w] || (l.current[w] = new Sw(null, s.flush)), x = r ? r(w, _) : t[w];
      x && (c[w] = xB(x));
    }
  }
  const h = l.current.map((y, C) => J2(y, c[C])), m = Yn(us), g = z2(m), p = m !== g && gw(m);
  to(() => {
    i.current++, s.ctrls = l.current;
    const { queue: y } = s;
    y.length && (s.queue = [], Le(y, (C) => C())), Le(l.current, (C, w) => {
      o == null || o.add(C), p && C.start({ default: m });
      const _ = c[w];
      _ && (vw(C, _.ref), C.ref ? C.queue.push(_) : C.start(_));
    });
  }), Bh(() => () => {
    Le(s.ctrls, (y) => y.stop(!0));
  });
  const v = h.map((y) => ({ ...y }));
  return o ? [v, o] : v;
}
function tr(e, t) {
  const n = te.fun(e), [[r], o] = EB(
    1,
    n ? e : [e],
    n ? [] : t
  );
  return n || arguments.length == 2 ? [r, o] : r;
}
function Sl(e, t, n) {
  const r = te.fun(t) && t, {
    reset: o,
    sort: i,
    trail: a = 0,
    expires: s = !0,
    exitBeforeEnter: l = !1,
    onDestroyed: c,
    ref: f,
    config: u
  } = r ? r() : t, h = Te(
    () => r || arguments.length == 3 ? Rw() : void 0,
    []
  ), m = nn(e), g = [], p = Lt(null), v = o ? null : p.current;
  to(() => {
    p.current = g;
  }), Bh(() => (Le(g, (I) => {
    h == null || h.add(I.ctrl), I.ctrl.ref = h;
  }), () => {
    Le(p.current, (I) => {
      I.expired && clearTimeout(I.expirationId), K2(I.ctrl, h), I.ctrl.stop(!0);
    });
  }));
  const y = TB(m, r ? r() : t, v), C = o && p.current || [];
  to(
    () => Le(C, ({ ctrl: I, item: W, key: N }) => {
      K2(I, h), un(c, W, N);
    })
  );
  const w = [];
  if (v && Le(v, (I, W) => {
    I.expired ? (clearTimeout(I.expirationId), C.push(I)) : (W = w[W] = y.indexOf(I.key), ~W && (g[W] = I));
  }), Le(m, (I, W) => {
    g[W] || (g[W] = {
      key: y[W],
      item: I,
      phase: "mount",
      ctrl: new Sw()
    }, g[W].ctrl.item = I);
  }), w.length) {
    let I = -1;
    const { leave: W } = r ? r() : t;
    Le(w, (N, H) => {
      const q = v[H];
      ~N ? (I = g.indexOf(q), g[I] = { ...q, item: m[N] }) : W && g.splice(++I, 0, q);
    });
  }
  te.fun(i) && g.sort((I, W) => i(I.item, W.item));
  let _ = -a;
  const x = Ih(), k = kl(t), S = /* @__PURE__ */ new Map(), T = Lt(/* @__PURE__ */ new Map()), L = Lt(!1);
  Le(g, (I, W) => {
    const N = I.key, H = I.phase, q = r ? r() : t;
    let D, $;
    const U = un(q.delay || 0, N);
    if (H == "mount")
      D = q.enter, $ = "enter";
    else {
      const Z = y.indexOf(N) < 0;
      if (H != "leave")
        if (Z)
          D = q.leave, $ = "leave";
        else if (D = q.update)
          $ = "update";
        else
          return;
      else if (!Z)
        D = q.enter, $ = "enter";
      else
        return;
    }
    if (D = un(D, I.item, W), D = te.obj(D) ? Fh(D) : { to: D }, !D.config) {
      const Z = u || k.config;
      D.config = un(Z, I.item, W, $);
    }
    _ += a;
    const B = {
      ...k,
      // we need to add our props.delay value you here.
      delay: U + _,
      ref: f,
      immediate: q.immediate,
      // This prevents implied resets.
      reset: !1,
      // Merge any phase-specific props.
      ...D
    };
    if ($ == "enter" && te.und(B.from)) {
      const Z = r ? r() : t, G = te.und(Z.initial) || v ? Z.from : Z.initial;
      B.from = un(G, I.item, W);
    }
    const { onResolve: K } = B;
    B.onResolve = (Z) => {
      un(K, Z);
      const G = p.current, V = G.find((Y) => Y.key === N);
      if (V && !(Z.cancelled && V.phase != "update") && V.ctrl.idle) {
        const Y = G.every((P) => P.ctrl.idle);
        if (V.phase == "leave") {
          const P = un(s, V.item);
          if (P !== !1) {
            const F = P === !0 ? 0 : P;
            if (V.expired = !0, !Y && F > 0) {
              F <= 2147483647 && (V.expirationId = setTimeout(x, F));
              return;
            }
          }
        }
        Y && G.some((P) => P.expired) && (T.current.delete(V), l && (L.current = !0), x());
      }
    };
    const X = J2(I.ctrl, B);
    $ === "leave" && l ? T.current.set(I, { phase: $, springs: X, payload: B }) : S.set(I, { phase: $, springs: X, payload: B });
  });
  const R = Yn(us), M = z2(R), A = R !== M && gw(R);
  to(() => {
    A && Le(g, (I) => {
      I.ctrl.start({ default: R });
    });
  }, [R]), Le(S, (I, W) => {
    if (T.current.size) {
      const N = g.findIndex((H) => H.key === W.key);
      g.splice(N, 1);
    }
  }), to(
    () => {
      Le(
        T.current.size ? T.current : S,
        ({ phase: I, payload: W }, N) => {
          const { ctrl: H } = N;
          N.phase = I, h == null || h.add(H), A && I == "enter" && H.start({ default: R }), W && (vw(H, W.ref), (H.ref || h) && !L.current ? H.update(W) : (H.start(W), L.current && (L.current = !1)));
        }
      );
    },
    o ? void 0 : n
  );
  const O = (I) => /* @__PURE__ */ d.createElement(d.Fragment, null, g.map((W, N) => {
    const { springs: H } = S.get(W) || W.ctrl, q = I({ ...H }, W.item, W, N);
    return q && q.type ? /* @__PURE__ */ d.createElement(
      q.type,
      {
        ...q.props,
        key: te.str(W.key) || te.num(W.key) ? W.key : W.ctrl.id,
        ref: q.ref
      }
    ) : q;
  }));
  return h ? [O, h] : O;
}
var LB = 1;
function TB(e, { key: t, keys: n = t }, r) {
  if (n === null) {
    const o = /* @__PURE__ */ new Set();
    return e.map((i) => {
      const a = r && r.find(
        (s) => s.item === i && s.phase !== "leave" && !o.has(s)
      );
      return a ? (o.add(a), a.key) : LB++;
    });
  }
  return te.und(n) ? e : te.fun(n) ? e.map(n) : nn(n);
}
var Aw = class extends jh {
  constructor(e, t) {
    super(), this.source = e, this.idle = !0, this._active = /* @__PURE__ */ new Set(), this.calc = _a(...t);
    const n = this._get(), r = Y2(n);
    $h(this, r.create(n));
  }
  advance(e) {
    const t = this._get(), n = this.get();
    dr(t, n) || (jn(this).setValue(t), this._onChange(t, this.idle)), !this.idle && w3(this._active) && i1(this);
  }
  _get() {
    const e = te.arr(this.source) ? this.source.map(cn) : nn(cn(this.source));
    return this.calc(...e);
  }
  _start() {
    this.idle && !w3(this._active) && (this.idle = !1, Le(xl(this), (e) => {
      e.done = !1;
    }), Nn.skipAnimation ? (Re.batchedUpdates(() => this.advance()), i1(this)) : bl.start(this));
  }
  // Observe our sources only when we're observed.
  _attach() {
    let e = 1;
    Le(nn(this.source), (t) => {
      vn(t) && Ei(t, this), X2(t) && (t.idle || this._active.add(t), e = Math.max(e, t.priority + 1));
    }), this.priority = e, this._start();
  }
  // Stop observing our sources once we have no observers.
  _detach() {
    Le(nn(this.source), (e) => {
      vn(e) && Ma(e, this);
    }), this._active.clear(), i1(this);
  }
  /** @internal */
  eventObserved(e) {
    e.type == "change" ? e.idle ? this.advance() : (this._active.add(e.parent), this._start()) : e.type == "idle" ? this._active.delete(e.parent) : e.type == "priority" && (this.priority = nn(this.source).reduce(
      (t, n) => Math.max(t, (X2(n) ? n.priority : 0) + 1),
      0
    ));
  }
};
function PB(e) {
  return e.idle !== !1;
}
function w3(e) {
  return !e.size || Array.from(e).every(PB);
}
function i1(e) {
  e.idle || (e.idle = !0, Le(xl(e), (t) => {
    t.done = !0;
  }), Sa(e, {
    type: "idle",
    parent: e
  }));
}
var e9 = (e, ...t) => new Aw(e, t);
Nn.assign({
  createStringInterpolator: uw,
  to: (e, t) => new Aw(e, t)
});
var Ow = /^--/;
function RB(e, t) {
  return t == null || typeof t == "boolean" || t === "" ? "" : typeof t == "number" && t !== 0 && !Ow.test(e) && !(ma.hasOwnProperty(e) && ma[e]) ? t + "px" : ("" + t).trim();
}
var x3 = {};
function AB(e, t) {
  if (!e.nodeType || !e.setAttribute)
    return !1;
  const n = e.nodeName === "filter" || e.parentNode && e.parentNode.nodeName === "filter", {
    className: r,
    style: o,
    children: i,
    scrollTop: a,
    scrollLeft: s,
    viewBox: l,
    ...c
  } = t, f = Object.values(c), u = Object.keys(c).map(
    (h) => n || e.hasAttribute(h) ? h : x3[h] || (x3[h] = h.replace(
      /([A-Z])/g,
      // Attributes are written in dash case
      (m) => "-" + m.toLowerCase()
    ))
  );
  i !== void 0 && (e.textContent = i);
  for (const h in o)
    if (o.hasOwnProperty(h)) {
      const m = RB(h, o[h]);
      Ow.test(h) ? e.style.setProperty(h, m) : e.style[h] = m;
    }
  u.forEach((h, m) => {
    e.setAttribute(h, f[m]);
  }), r !== void 0 && (e.className = r), a !== void 0 && (e.scrollTop = a), s !== void 0 && (e.scrollLeft = s), l !== void 0 && e.setAttribute("viewBox", l);
}
var ma = {
  animationIterationCount: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  // SVG-related properties
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
}, OB = (e, t) => e + t.charAt(0).toUpperCase() + t.substring(1), NB = ["Webkit", "Ms", "Moz", "O"];
ma = Object.keys(ma).reduce((e, t) => (NB.forEach((n) => e[OB(n, t)] = e[t]), e), ma);
var DB = /^(matrix|translate|scale|rotate|skew)/, IB = /^(translate)/, BB = /^(rotate|skew)/, a1 = (e, t) => te.num(e) && e !== 0 ? e + t : e, zs = (e, t) => te.arr(e) ? e.every((n) => zs(n, t)) : te.num(e) ? e === t : parseFloat(e) === t, $B = class extends _l {
  constructor({ x: e, y: t, z: n, ...r }) {
    const o = [], i = [];
    (e || t || n) && (o.push([e || 0, t || 0, n || 0]), i.push((a) => [
      `translate3d(${a.map((s) => a1(s, "px")).join(",")})`,
      // prettier-ignore
      zs(a, 0)
    ])), Kn(r, (a, s) => {
      if (s === "transform")
        o.push([a || ""]), i.push((l) => [l, l === ""]);
      else if (DB.test(s)) {
        if (delete r[s], te.und(a))
          return;
        const l = IB.test(s) ? "px" : BB.test(s) ? "deg" : "";
        o.push(nn(a)), i.push(
          s === "rotate3d" ? ([c, f, u, h]) => [
            `rotate3d(${c},${f},${u},${a1(h, l)})`,
            zs(h, 0)
          ] : (c) => [
            `${s}(${c.map((f) => a1(f, l)).join(",")})`,
            zs(c, s.startsWith("scale") ? 1 : 0)
          ]
        );
      }
    }), o.length && (r.transform = new FB(o, i)), super(r);
  }
}, FB = class extends sw {
  constructor(e, t) {
    super(), this.inputs = e, this.transforms = t, this._value = null;
  }
  get() {
    return this._value || (this._value = this._get());
  }
  _get() {
    let e = "", t = !0;
    return Le(this.inputs, (n, r) => {
      const o = cn(n[0]), [i, a] = this.transforms[r](
        te.arr(o) ? o : n.map(cn)
      );
      e += " " + i, t = t && a;
    }), t ? "none" : e;
  }
  // Start observing our inputs once we have an observer.
  observerAdded(e) {
    e == 1 && Le(
      this.inputs,
      (t) => Le(
        t,
        (n) => vn(n) && Ei(n, this)
      )
    );
  }
  // Stop observing our inputs once we have no observers.
  observerRemoved(e) {
    e == 0 && Le(
      this.inputs,
      (t) => Le(
        t,
        (n) => vn(n) && Ma(n, this)
      )
    );
  }
  eventObserved(e) {
    e.type == "change" && (this._value = null), Sa(this, e);
  }
}, WB = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
];
Nn.assign({
  batchedUpdates: ZS,
  createStringInterpolator: uw,
  colors: NI
});
var qB = fB(WB, {
  applyAnimatedValues: AB,
  createAnimatedStyle: (e) => new $B(e),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getComponentProps: ({ scrollTop: e, scrollLeft: t, ...n }) => n
}), _t = qB.animated;
function vo() {
  return vo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, vo.apply(this, arguments);
}
var jB = { pointerEvents: "none", position: "absolute", zIndex: 10, top: 0, left: 0 }, _3 = function(e, t) {
  return "translate(" + e + "px, " + t + "px)";
}, Nw = lt(function(e) {
  var t, n = e.position, r = e.anchor, o = e.children, i = xt(), a = kn(), s = a.animate, l = a.config, c = A_(), f = c[0], u = c[1], h = Lt(!1), m = void 0, g = !1, p = u.width > 0 && u.height > 0, v = Math.round(n[0]), y = Math.round(n[1]);
  p && (r === "top" ? (v -= u.width / 2, y -= u.height + 14) : r === "right" ? (v += 14, y -= u.height / 2) : r === "bottom" ? (v -= u.width / 2, y += 14) : r === "left" ? (v -= u.width + 14, y -= u.height / 2) : r === "center" && (v -= u.width / 2, y -= u.height / 2), m = { transform: _3(v, y) }, h.current || (g = !0), h.current = [v, y]);
  var C = tr({ to: m, config: l, immediate: !s || g }), w = vo({}, jB, i.tooltip.wrapper, { transform: (t = C.transform) != null ? t : _3(v, y), opacity: C.transform ? 1 : 0 });
  return b(_t.div, { ref: f, style: w, children: o });
});
Nw.displayName = "TooltipWrapper";
var Dw = lt(function(e) {
  var t = e.size, n = t === void 0 ? 12 : t, r = e.color, o = e.style;
  return b("span", { style: vo({ display: "block", width: n, height: n, background: r }, o === void 0 ? {} : o) });
}), Iw = lt(function(e) {
  var t, n = e.id, r = e.value, o = e.format, i = e.enableChip, a = i !== void 0 && i, s = e.color, l = e.renderContent, c = xt(), f = Fa(o);
  if (typeof l == "function") t = l();
  else {
    var u = r;
    f !== void 0 && u !== void 0 && (u = f(u)), t = ie("div", { style: c.tooltip.basic, children: [a && b(Dw, { color: s, style: c.tooltip.chip }), u !== void 0 ? ie("span", { children: [n, ": ", b("strong", { children: "" + u })] }) : n] });
  }
  return b("div", { style: c.tooltip.container, children: t });
}), HB = { width: "100%", borderCollapse: "collapse" }, Bw = lt(function(e) {
  var t, n = e.title, r = e.rows, o = r === void 0 ? [] : r, i = e.renderContent, a = xt();
  return o.length ? (t = typeof i == "function" ? i() : ie("div", { children: [n && n, b("table", { style: vo({}, HB, a.tooltip.table), children: b("tbody", { children: o.map(function(s, l) {
    return b("tr", { children: s.map(function(c, f) {
      return b("td", { style: a.tooltip.tableCell, children: c }, f);
    }) }, l);
  }) }) })] }), b("div", { style: a.tooltip.container, children: t })) : null;
});
Bw.displayName = "TableTooltip";
var t9 = lt(function(e) {
  var t = e.x0, n = e.x1, r = e.y0, o = e.y1, i = xt(), a = kn(), s = a.animate, l = a.config, c = Te(function() {
    return vo({}, i.crosshair.line, { pointerEvents: "none" });
  }, [i.crosshair.line]), f = tr({ x1: t, x2: n, y1: r, y2: o, config: l, immediate: !s });
  return b(_t.line, vo({}, f, { fill: "none", style: c }));
});
t9.displayName = "CrosshairLine";
var n9 = lt(function(e) {
  var t, n, r = e.width, o = e.height, i = e.type, a = e.x, s = e.y;
  return i === "cross" ? (t = { x0: a, x1: a, y0: 0, y1: o }, n = { x0: 0, x1: r, y0: s, y1: s }) : i === "top-left" ? (t = { x0: a, x1: a, y0: 0, y1: s }, n = { x0: 0, x1: a, y0: s, y1: s }) : i === "top" ? t = { x0: a, x1: a, y0: 0, y1: s } : i === "top-right" ? (t = { x0: a, x1: a, y0: 0, y1: s }, n = { x0: a, x1: r, y0: s, y1: s }) : i === "right" ? n = { x0: a, x1: r, y0: s, y1: s } : i === "bottom-right" ? (t = { x0: a, x1: a, y0: s, y1: o }, n = { x0: a, x1: r, y0: s, y1: s }) : i === "bottom" ? t = { x0: a, x1: a, y0: s, y1: o } : i === "bottom-left" ? (t = { x0: a, x1: a, y0: s, y1: o }, n = { x0: 0, x1: a, y0: s, y1: s }) : i === "left" ? n = { x0: 0, x1: a, y0: s, y1: s } : i === "x" ? t = { x0: a, x1: a, y0: 0, y1: o } : i === "y" && (n = { x0: 0, x1: r, y0: s, y1: s }), ie(St, { children: [t && b(t9, { x0: t.x0, x1: t.x1, y0: t.y0, y1: t.y1 }), n && b(t9, { x0: n.x0, x1: n.x1, y0: n.y0, y1: n.y1 })] });
});
n9.displayName = "Crosshair";
var $w = _o({ showTooltipAt: function() {
}, showTooltipFromEvent: function() {
}, hideTooltip: function() {
} }), r9 = { isVisible: !1, position: [null, null], content: null, anchor: null }, Fw = _o(r9), VB = function(e) {
  var t = Yt(r9), n = t[0], r = t[1], o = be(function(s, l, c) {
    var f = l[0], u = l[1];
    c === void 0 && (c = "top"), r({ isVisible: !0, position: [f, u], anchor: c, content: s });
  }, [r]), i = be(function(s, l, c) {
    c === void 0 && (c = "top");
    var f = e.current.getBoundingClientRect(), u = e.current.offsetWidth, h = u === f.width ? 1 : u / f.width, m = "touches" in l ? l.touches[0] : l, g = m.clientX, p = m.clientY, v = (g - f.left) * h, y = (p - f.top) * h;
    c !== "left" && c !== "right" || (c = v < f.width / 2 ? "right" : "left"), r({ isVisible: !0, position: [v, y], anchor: c, content: s });
  }, [e, r]), a = be(function() {
    r(r9);
  }, [r]);
  return { actions: Te(function() {
    return { showTooltipAt: o, showTooltipFromEvent: i, hideTooltip: a };
  }, [o, i, a]), state: n };
}, Li = function() {
  var e = Yn($w);
  if (e === void 0) throw new Error("useTooltip must be used within a TooltipProvider");
  return e;
}, UB = function() {
  var e = Yn(Fw);
  if (e === void 0) throw new Error("useTooltipState must be used within a TooltipProvider");
  return e;
}, zB = function(e) {
  return e.isVisible;
}, YB = function() {
  var e = UB();
  return zB(e) ? b(Nw, { position: e.position, anchor: e.anchor, children: e.content }) : null;
}, GB = function(e) {
  var t = e.container, n = e.children, r = VB(t), o = r.actions, i = r.state;
  return b($w.Provider, { value: o, children: b(Fw.Provider, { value: i, children: n }) });
}, s1, k3;
function KB() {
  if (k3) return s1;
  k3 = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return s1 = e, s1;
}
var l1, S3;
function ds() {
  if (S3) return l1;
  S3 = 1;
  function e(t, n) {
    return t === n || t !== t && n !== n;
  }
  return l1 = e, l1;
}
var c1, M3;
function Ml() {
  if (M3) return c1;
  M3 = 1;
  var e = ds();
  function t(n, r) {
    for (var o = n.length; o--; )
      if (e(n[o][0], r))
        return o;
    return -1;
  }
  return c1 = t, c1;
}
var u1, E3;
function ZB() {
  if (E3) return u1;
  E3 = 1;
  var e = Ml(), t = Array.prototype, n = t.splice;
  function r(o) {
    var i = this.__data__, a = e(i, o);
    if (a < 0)
      return !1;
    var s = i.length - 1;
    return a == s ? i.pop() : n.call(i, a, 1), --this.size, !0;
  }
  return u1 = r, u1;
}
var d1, L3;
function XB() {
  if (L3) return d1;
  L3 = 1;
  var e = Ml();
  function t(n) {
    var r = this.__data__, o = e(r, n);
    return o < 0 ? void 0 : r[o][1];
  }
  return d1 = t, d1;
}
var f1, T3;
function QB() {
  if (T3) return f1;
  T3 = 1;
  var e = Ml();
  function t(n) {
    return e(this.__data__, n) > -1;
  }
  return f1 = t, f1;
}
var h1, P3;
function JB() {
  if (P3) return h1;
  P3 = 1;
  var e = Ml();
  function t(n, r) {
    var o = this.__data__, i = e(o, n);
    return i < 0 ? (++this.size, o.push([n, r])) : o[i][1] = r, this;
  }
  return h1 = t, h1;
}
var m1, R3;
function El() {
  if (R3) return m1;
  R3 = 1;
  var e = KB(), t = ZB(), n = XB(), r = QB(), o = JB();
  function i(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var c = a[s];
      this.set(c[0], c[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, m1 = i, m1;
}
var p1, A3;
function e$() {
  if (A3) return p1;
  A3 = 1;
  var e = El();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return p1 = t, p1;
}
var g1, O3;
function t$() {
  if (O3) return g1;
  O3 = 1;
  function e(t) {
    var n = this.__data__, r = n.delete(t);
    return this.size = n.size, r;
  }
  return g1 = e, g1;
}
var v1, N3;
function n$() {
  if (N3) return v1;
  N3 = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return v1 = e, v1;
}
var b1, D3;
function r$() {
  if (D3) return b1;
  D3 = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return b1 = e, b1;
}
var y1, I3;
function Ww() {
  if (I3) return y1;
  I3 = 1;
  var e = typeof Es == "object" && Es && Es.Object === Object && Es;
  return y1 = e, y1;
}
var C1, B3;
function nr() {
  if (B3) return C1;
  B3 = 1;
  var e = Ww(), t = typeof self == "object" && self && self.Object === Object && self, n = e || t || Function("return this")();
  return C1 = n, C1;
}
var w1, $3;
function Ti() {
  if ($3) return w1;
  $3 = 1;
  var e = nr(), t = e.Symbol;
  return w1 = t, w1;
}
var x1, F3;
function o$() {
  if (F3) return x1;
  F3 = 1;
  var e = Ti(), t = Object.prototype, n = t.hasOwnProperty, r = t.toString, o = e ? e.toStringTag : void 0;
  function i(a) {
    var s = n.call(a, o), l = a[o];
    try {
      a[o] = void 0;
      var c = !0;
    } catch {
    }
    var f = r.call(a);
    return c && (s ? a[o] = l : delete a[o]), f;
  }
  return x1 = i, x1;
}
var _1, W3;
function i$() {
  if (W3) return _1;
  W3 = 1;
  var e = Object.prototype, t = e.toString;
  function n(r) {
    return t.call(r);
  }
  return _1 = n, _1;
}
var k1, q3;
function _r() {
  if (q3) return k1;
  q3 = 1;
  var e = Ti(), t = o$(), n = i$(), r = "[object Null]", o = "[object Undefined]", i = e ? e.toStringTag : void 0;
  function a(s) {
    return s == null ? s === void 0 ? o : r : i && i in Object(s) ? t(s) : n(s);
  }
  return k1 = a, k1;
}
var S1, j3;
function rr() {
  if (j3) return S1;
  j3 = 1;
  function e(t) {
    var n = typeof t;
    return t != null && (n == "object" || n == "function");
  }
  return S1 = e, S1;
}
var M1, H3;
function Ll() {
  if (H3) return M1;
  H3 = 1;
  var e = _r(), t = rr(), n = "[object AsyncFunction]", r = "[object Function]", o = "[object GeneratorFunction]", i = "[object Proxy]";
  function a(s) {
    if (!t(s))
      return !1;
    var l = e(s);
    return l == r || l == o || l == n || l == i;
  }
  return M1 = a, M1;
}
var E1, V3;
function a$() {
  if (V3) return E1;
  V3 = 1;
  var e = nr(), t = e["__core-js_shared__"];
  return E1 = t, E1;
}
var L1, U3;
function s$() {
  if (U3) return L1;
  U3 = 1;
  var e = a$(), t = function() {
    var r = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return r ? "Symbol(src)_1." + r : "";
  }();
  function n(r) {
    return !!t && t in r;
  }
  return L1 = n, L1;
}
var T1, z3;
function qw() {
  if (z3) return T1;
  z3 = 1;
  var e = Function.prototype, t = e.toString;
  function n(r) {
    if (r != null) {
      try {
        return t.call(r);
      } catch {
      }
      try {
        return r + "";
      } catch {
      }
    }
    return "";
  }
  return T1 = n, T1;
}
var P1, Y3;
function l$() {
  if (Y3) return P1;
  Y3 = 1;
  var e = Ll(), t = s$(), n = rr(), r = qw(), o = /[\\^$.*+?()[\]{}|]/g, i = /^\[object .+?Constructor\]$/, a = Function.prototype, s = Object.prototype, l = a.toString, c = s.hasOwnProperty, f = RegExp(
    "^" + l.call(c).replace(o, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function u(h) {
    if (!n(h) || t(h))
      return !1;
    var m = e(h) ? f : i;
    return m.test(r(h));
  }
  return P1 = u, P1;
}
var R1, G3;
function c$() {
  if (G3) return R1;
  G3 = 1;
  function e(t, n) {
    return t == null ? void 0 : t[n];
  }
  return R1 = e, R1;
}
var A1, K3;
function Eo() {
  if (K3) return A1;
  K3 = 1;
  var e = l$(), t = c$();
  function n(r, o) {
    var i = t(r, o);
    return e(i) ? i : void 0;
  }
  return A1 = n, A1;
}
var O1, Z3;
function Hh() {
  if (Z3) return O1;
  Z3 = 1;
  var e = Eo(), t = nr(), n = e(t, "Map");
  return O1 = n, O1;
}
var N1, X3;
function Tl() {
  if (X3) return N1;
  X3 = 1;
  var e = Eo(), t = e(Object, "create");
  return N1 = t, N1;
}
var D1, Q3;
function u$() {
  if (Q3) return D1;
  Q3 = 1;
  var e = Tl();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return D1 = t, D1;
}
var I1, J3;
function d$() {
  if (J3) return I1;
  J3 = 1;
  function e(t) {
    var n = this.has(t) && delete this.__data__[t];
    return this.size -= n ? 1 : 0, n;
  }
  return I1 = e, I1;
}
var B1, e6;
function f$() {
  if (e6) return B1;
  e6 = 1;
  var e = Tl(), t = "__lodash_hash_undefined__", n = Object.prototype, r = n.hasOwnProperty;
  function o(i) {
    var a = this.__data__;
    if (e) {
      var s = a[i];
      return s === t ? void 0 : s;
    }
    return r.call(a, i) ? a[i] : void 0;
  }
  return B1 = o, B1;
}
var $1, t6;
function h$() {
  if (t6) return $1;
  t6 = 1;
  var e = Tl(), t = Object.prototype, n = t.hasOwnProperty;
  function r(o) {
    var i = this.__data__;
    return e ? i[o] !== void 0 : n.call(i, o);
  }
  return $1 = r, $1;
}
var F1, n6;
function m$() {
  if (n6) return F1;
  n6 = 1;
  var e = Tl(), t = "__lodash_hash_undefined__";
  function n(r, o) {
    var i = this.__data__;
    return this.size += this.has(r) ? 0 : 1, i[r] = e && o === void 0 ? t : o, this;
  }
  return F1 = n, F1;
}
var W1, r6;
function p$() {
  if (r6) return W1;
  r6 = 1;
  var e = u$(), t = d$(), n = f$(), r = h$(), o = m$();
  function i(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var c = a[s];
      this.set(c[0], c[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, W1 = i, W1;
}
var q1, o6;
function g$() {
  if (o6) return q1;
  o6 = 1;
  var e = p$(), t = El(), n = Hh();
  function r() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (n || t)(),
      string: new e()
    };
  }
  return q1 = r, q1;
}
var j1, i6;
function v$() {
  if (i6) return j1;
  i6 = 1;
  function e(t) {
    var n = typeof t;
    return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? t !== "__proto__" : t === null;
  }
  return j1 = e, j1;
}
var H1, a6;
function Pl() {
  if (a6) return H1;
  a6 = 1;
  var e = v$();
  function t(n, r) {
    var o = n.__data__;
    return e(r) ? o[typeof r == "string" ? "string" : "hash"] : o.map;
  }
  return H1 = t, H1;
}
var V1, s6;
function b$() {
  if (s6) return V1;
  s6 = 1;
  var e = Pl();
  function t(n) {
    var r = e(this, n).delete(n);
    return this.size -= r ? 1 : 0, r;
  }
  return V1 = t, V1;
}
var U1, l6;
function y$() {
  if (l6) return U1;
  l6 = 1;
  var e = Pl();
  function t(n) {
    return e(this, n).get(n);
  }
  return U1 = t, U1;
}
var z1, c6;
function C$() {
  if (c6) return z1;
  c6 = 1;
  var e = Pl();
  function t(n) {
    return e(this, n).has(n);
  }
  return z1 = t, z1;
}
var Y1, u6;
function w$() {
  if (u6) return Y1;
  u6 = 1;
  var e = Pl();
  function t(n, r) {
    var o = e(this, n), i = o.size;
    return o.set(n, r), this.size += o.size == i ? 0 : 1, this;
  }
  return Y1 = t, Y1;
}
var G1, d6;
function Vh() {
  if (d6) return G1;
  d6 = 1;
  var e = g$(), t = b$(), n = y$(), r = C$(), o = w$();
  function i(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var c = a[s];
      this.set(c[0], c[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, G1 = i, G1;
}
var K1, f6;
function x$() {
  if (f6) return K1;
  f6 = 1;
  var e = El(), t = Hh(), n = Vh(), r = 200;
  function o(i, a) {
    var s = this.__data__;
    if (s instanceof e) {
      var l = s.__data__;
      if (!t || l.length < r - 1)
        return l.push([i, a]), this.size = ++s.size, this;
      s = this.__data__ = new n(l);
    }
    return s.set(i, a), this.size = s.size, this;
  }
  return K1 = o, K1;
}
var Z1, h6;
function Rl() {
  if (h6) return Z1;
  h6 = 1;
  var e = El(), t = e$(), n = t$(), r = n$(), o = r$(), i = x$();
  function a(s) {
    var l = this.__data__ = new e(s);
    this.size = l.size;
  }
  return a.prototype.clear = t, a.prototype.delete = n, a.prototype.get = r, a.prototype.has = o, a.prototype.set = i, Z1 = a, Z1;
}
var X1, m6;
function jw() {
  if (m6) return X1;
  m6 = 1;
  var e = Eo(), t = function() {
    try {
      var n = e(Object, "defineProperty");
      return n({}, "", {}), n;
    } catch {
    }
  }();
  return X1 = t, X1;
}
var Q1, p6;
function Uh() {
  if (p6) return Q1;
  p6 = 1;
  var e = jw();
  function t(n, r, o) {
    r == "__proto__" && e ? e(n, r, {
      configurable: !0,
      enumerable: !0,
      value: o,
      writable: !0
    }) : n[r] = o;
  }
  return Q1 = t, Q1;
}
var J1, g6;
function Hw() {
  if (g6) return J1;
  g6 = 1;
  var e = Uh(), t = ds();
  function n(r, o, i) {
    (i !== void 0 && !t(r[o], i) || i === void 0 && !(o in r)) && e(r, o, i);
  }
  return J1 = n, J1;
}
var eu, v6;
function _$() {
  if (v6) return eu;
  v6 = 1;
  function e(t) {
    return function(n, r, o) {
      for (var i = -1, a = Object(n), s = o(n), l = s.length; l--; ) {
        var c = s[t ? l : ++i];
        if (r(a[c], c, a) === !1)
          break;
      }
      return n;
    };
  }
  return eu = e, eu;
}
var tu, b6;
function Vw() {
  if (b6) return tu;
  b6 = 1;
  var e = _$(), t = e();
  return tu = t, tu;
}
var aa = { exports: {} };
aa.exports;
var y6;
function Uw() {
  return y6 || (y6 = 1, function(e, t) {
    var n = nr(), r = t && !t.nodeType && t, o = r && !0 && e && !e.nodeType && e, i = o && o.exports === r, a = i ? n.Buffer : void 0, s = a ? a.allocUnsafe : void 0;
    function l(c, f) {
      if (f)
        return c.slice();
      var u = c.length, h = s ? s(u) : new c.constructor(u);
      return c.copy(h), h;
    }
    e.exports = l;
  }(aa, aa.exports)), aa.exports;
}
var nu, C6;
function zw() {
  if (C6) return nu;
  C6 = 1;
  var e = nr(), t = e.Uint8Array;
  return nu = t, nu;
}
var ru, w6;
function zh() {
  if (w6) return ru;
  w6 = 1;
  var e = zw();
  function t(n) {
    var r = new n.constructor(n.byteLength);
    return new e(r).set(new e(n)), r;
  }
  return ru = t, ru;
}
var ou, x6;
function Yw() {
  if (x6) return ou;
  x6 = 1;
  var e = zh();
  function t(n, r) {
    var o = r ? e(n.buffer) : n.buffer;
    return new n.constructor(o, n.byteOffset, n.length);
  }
  return ou = t, ou;
}
var iu, _6;
function Gw() {
  if (_6) return iu;
  _6 = 1;
  function e(t, n) {
    var r = -1, o = t.length;
    for (n || (n = Array(o)); ++r < o; )
      n[r] = t[r];
    return n;
  }
  return iu = e, iu;
}
var au, k6;
function k$() {
  if (k6) return au;
  k6 = 1;
  var e = rr(), t = Object.create, n = /* @__PURE__ */ function() {
    function r() {
    }
    return function(o) {
      if (!e(o))
        return {};
      if (t)
        return t(o);
      r.prototype = o;
      var i = new r();
      return r.prototype = void 0, i;
    };
  }();
  return au = n, au;
}
var su, S6;
function Kw() {
  if (S6) return su;
  S6 = 1;
  function e(t, n) {
    return function(r) {
      return t(n(r));
    };
  }
  return su = e, su;
}
var lu, M6;
function Yh() {
  if (M6) return lu;
  M6 = 1;
  var e = Kw(), t = e(Object.getPrototypeOf, Object);
  return lu = t, lu;
}
var cu, E6;
function Gh() {
  if (E6) return cu;
  E6 = 1;
  var e = Object.prototype;
  function t(n) {
    var r = n && n.constructor, o = typeof r == "function" && r.prototype || e;
    return n === o;
  }
  return cu = t, cu;
}
var uu, L6;
function Zw() {
  if (L6) return uu;
  L6 = 1;
  var e = k$(), t = Yh(), n = Gh();
  function r(o) {
    return typeof o.constructor == "function" && !n(o) ? e(t(o)) : {};
  }
  return uu = r, uu;
}
var du, T6;
function _n() {
  if (T6) return du;
  T6 = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return du = e, du;
}
var fu, P6;
function S$() {
  if (P6) return fu;
  P6 = 1;
  var e = _r(), t = _n(), n = "[object Arguments]";
  function r(o) {
    return t(o) && e(o) == n;
  }
  return fu = r, fu;
}
var hu, R6;
function Al() {
  if (R6) return hu;
  R6 = 1;
  var e = S$(), t = _n(), n = Object.prototype, r = n.hasOwnProperty, o = n.propertyIsEnumerable, i = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(a) {
    return t(a) && r.call(a, "callee") && !o.call(a, "callee");
  };
  return hu = i, hu;
}
var mu, A6;
function on() {
  if (A6) return mu;
  A6 = 1;
  var e = Array.isArray;
  return mu = e, mu;
}
var pu, O6;
function Kh() {
  if (O6) return pu;
  O6 = 1;
  var e = 9007199254740991;
  function t(n) {
    return typeof n == "number" && n > -1 && n % 1 == 0 && n <= e;
  }
  return pu = t, pu;
}
var gu, N6;
function Pi() {
  if (N6) return gu;
  N6 = 1;
  var e = Ll(), t = Kh();
  function n(r) {
    return r != null && t(r.length) && !e(r);
  }
  return gu = n, gu;
}
var vu, D6;
function Xw() {
  if (D6) return vu;
  D6 = 1;
  var e = Pi(), t = _n();
  function n(r) {
    return t(r) && e(r);
  }
  return vu = n, vu;
}
var sa = { exports: {} }, bu, I6;
function M$() {
  if (I6) return bu;
  I6 = 1;
  function e() {
    return !1;
  }
  return bu = e, bu;
}
sa.exports;
var B6;
function Ol() {
  return B6 || (B6 = 1, function(e, t) {
    var n = nr(), r = M$(), o = t && !t.nodeType && t, i = o && !0 && e && !e.nodeType && e, a = i && i.exports === o, s = a ? n.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || r;
    e.exports = c;
  }(sa, sa.exports)), sa.exports;
}
var yu, $6;
function Zh() {
  if ($6) return yu;
  $6 = 1;
  var e = _r(), t = Yh(), n = _n(), r = "[object Object]", o = Function.prototype, i = Object.prototype, a = o.toString, s = i.hasOwnProperty, l = a.call(Object);
  function c(f) {
    if (!n(f) || e(f) != r)
      return !1;
    var u = t(f);
    if (u === null)
      return !0;
    var h = s.call(u, "constructor") && u.constructor;
    return typeof h == "function" && h instanceof h && a.call(h) == l;
  }
  return yu = c, yu;
}
var Cu, F6;
function E$() {
  if (F6) return Cu;
  F6 = 1;
  var e = _r(), t = Kh(), n = _n(), r = "[object Arguments]", o = "[object Array]", i = "[object Boolean]", a = "[object Date]", s = "[object Error]", l = "[object Function]", c = "[object Map]", f = "[object Number]", u = "[object Object]", h = "[object RegExp]", m = "[object Set]", g = "[object String]", p = "[object WeakMap]", v = "[object ArrayBuffer]", y = "[object DataView]", C = "[object Float32Array]", w = "[object Float64Array]", _ = "[object Int8Array]", x = "[object Int16Array]", k = "[object Int32Array]", S = "[object Uint8Array]", T = "[object Uint8ClampedArray]", L = "[object Uint16Array]", R = "[object Uint32Array]", M = {};
  M[C] = M[w] = M[_] = M[x] = M[k] = M[S] = M[T] = M[L] = M[R] = !0, M[r] = M[o] = M[v] = M[i] = M[y] = M[a] = M[s] = M[l] = M[c] = M[f] = M[u] = M[h] = M[m] = M[g] = M[p] = !1;
  function A(O) {
    return n(O) && t(O.length) && !!M[e(O)];
  }
  return Cu = A, Cu;
}
var wu, W6;
function Ri() {
  if (W6) return wu;
  W6 = 1;
  function e(t) {
    return function(n) {
      return t(n);
    };
  }
  return wu = e, wu;
}
var la = { exports: {} };
la.exports;
var q6;
function Nl() {
  return q6 || (q6 = 1, function(e, t) {
    var n = Ww(), r = t && !t.nodeType && t, o = r && !0 && e && !e.nodeType && e, i = o && o.exports === r, a = i && n.process, s = function() {
      try {
        var l = o && o.require && o.require("util").types;
        return l || a && a.binding && a.binding("util");
      } catch {
      }
    }();
    e.exports = s;
  }(la, la.exports)), la.exports;
}
var xu, j6;
function Xh() {
  if (j6) return xu;
  j6 = 1;
  var e = E$(), t = Ri(), n = Nl(), r = n && n.isTypedArray, o = r ? t(r) : e;
  return xu = o, xu;
}
var _u, H6;
function Qw() {
  if (H6) return _u;
  H6 = 1;
  function e(t, n) {
    if (!(n === "constructor" && typeof t[n] == "function") && n != "__proto__")
      return t[n];
  }
  return _u = e, _u;
}
var ku, V6;
function Qh() {
  if (V6) return ku;
  V6 = 1;
  var e = Uh(), t = ds(), n = Object.prototype, r = n.hasOwnProperty;
  function o(i, a, s) {
    var l = i[a];
    (!(r.call(i, a) && t(l, s)) || s === void 0 && !(a in i)) && e(i, a, s);
  }
  return ku = o, ku;
}
var Su, U6;
function Ai() {
  if (U6) return Su;
  U6 = 1;
  var e = Qh(), t = Uh();
  function n(r, o, i, a) {
    var s = !i;
    i || (i = {});
    for (var l = -1, c = o.length; ++l < c; ) {
      var f = o[l], u = a ? a(i[f], r[f], f, i, r) : void 0;
      u === void 0 && (u = r[f]), s ? t(i, f, u) : e(i, f, u);
    }
    return i;
  }
  return Su = n, Su;
}
var Mu, z6;
function L$() {
  if (z6) return Mu;
  z6 = 1;
  function e(t, n) {
    for (var r = -1, o = Array(t); ++r < t; )
      o[r] = n(r);
    return o;
  }
  return Mu = e, Mu;
}
var Eu, Y6;
function Dl() {
  if (Y6) return Eu;
  Y6 = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function n(r, o) {
    var i = typeof r;
    return o = o ?? e, !!o && (i == "number" || i != "symbol" && t.test(r)) && r > -1 && r % 1 == 0 && r < o;
  }
  return Eu = n, Eu;
}
var Lu, G6;
function Jw() {
  if (G6) return Lu;
  G6 = 1;
  var e = L$(), t = Al(), n = on(), r = Ol(), o = Dl(), i = Xh(), a = Object.prototype, s = a.hasOwnProperty;
  function l(c, f) {
    var u = n(c), h = !u && t(c), m = !u && !h && r(c), g = !u && !h && !m && i(c), p = u || h || m || g, v = p ? e(c.length, String) : [], y = v.length;
    for (var C in c)
      (f || s.call(c, C)) && !(p && // Safari 9 has enumerable `arguments.length` in strict mode.
      (C == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      m && (C == "offset" || C == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      g && (C == "buffer" || C == "byteLength" || C == "byteOffset") || // Skip index properties.
      o(C, y))) && v.push(C);
    return v;
  }
  return Lu = l, Lu;
}
var Tu, K6;
function T$() {
  if (K6) return Tu;
  K6 = 1;
  function e(t) {
    var n = [];
    if (t != null)
      for (var r in Object(t))
        n.push(r);
    return n;
  }
  return Tu = e, Tu;
}
var Pu, Z6;
function P$() {
  if (Z6) return Pu;
  Z6 = 1;
  var e = rr(), t = Gh(), n = T$(), r = Object.prototype, o = r.hasOwnProperty;
  function i(a) {
    if (!e(a))
      return n(a);
    var s = t(a), l = [];
    for (var c in a)
      c == "constructor" && (s || !o.call(a, c)) || l.push(c);
    return l;
  }
  return Pu = i, Pu;
}
var Ru, X6;
function fs() {
  if (X6) return Ru;
  X6 = 1;
  var e = Jw(), t = P$(), n = Pi();
  function r(o) {
    return n(o) ? e(o, !0) : t(o);
  }
  return Ru = r, Ru;
}
var Au, Q6;
function R$() {
  if (Q6) return Au;
  Q6 = 1;
  var e = Ai(), t = fs();
  function n(r) {
    return e(r, t(r));
  }
  return Au = n, Au;
}
var Ou, J6;
function A$() {
  if (J6) return Ou;
  J6 = 1;
  var e = Hw(), t = Uw(), n = Yw(), r = Gw(), o = Zw(), i = Al(), a = on(), s = Xw(), l = Ol(), c = Ll(), f = rr(), u = Zh(), h = Xh(), m = Qw(), g = R$();
  function p(v, y, C, w, _, x, k) {
    var S = m(v, C), T = m(y, C), L = k.get(T);
    if (L) {
      e(v, C, L);
      return;
    }
    var R = x ? x(S, T, C + "", v, y, k) : void 0, M = R === void 0;
    if (M) {
      var A = a(T), O = !A && l(T), I = !A && !O && h(T);
      R = T, A || O || I ? a(S) ? R = S : s(S) ? R = r(S) : O ? (M = !1, R = t(T, !0)) : I ? (M = !1, R = n(T, !0)) : R = [] : u(T) || i(T) ? (R = S, i(S) ? R = g(S) : (!f(S) || c(S)) && (R = o(T))) : M = !1;
    }
    M && (k.set(T, R), _(R, T, w, x, k), k.delete(T)), e(v, C, R);
  }
  return Ou = p, Ou;
}
var Nu, e5;
function O$() {
  if (e5) return Nu;
  e5 = 1;
  var e = Rl(), t = Hw(), n = Vw(), r = A$(), o = rr(), i = fs(), a = Qw();
  function s(l, c, f, u, h) {
    l !== c && n(c, function(m, g) {
      if (h || (h = new e()), o(m))
        r(l, c, g, f, s, u, h);
      else {
        var p = u ? u(a(l, g), m, g + "", l, c, h) : void 0;
        p === void 0 && (p = m), t(l, g, p);
      }
    }, i);
  }
  return Nu = s, Nu;
}
var Du, t5;
function Il() {
  if (t5) return Du;
  t5 = 1;
  function e(t) {
    return t;
  }
  return Du = e, Du;
}
var Iu, n5;
function N$() {
  if (n5) return Iu;
  n5 = 1;
  function e(t, n, r) {
    switch (r.length) {
      case 0:
        return t.call(n);
      case 1:
        return t.call(n, r[0]);
      case 2:
        return t.call(n, r[0], r[1]);
      case 3:
        return t.call(n, r[0], r[1], r[2]);
    }
    return t.apply(n, r);
  }
  return Iu = e, Iu;
}
var Bu, r5;
function ex() {
  if (r5) return Bu;
  r5 = 1;
  var e = N$(), t = Math.max;
  function n(r, o, i) {
    return o = t(o === void 0 ? r.length - 1 : o, 0), function() {
      for (var a = arguments, s = -1, l = t(a.length - o, 0), c = Array(l); ++s < l; )
        c[s] = a[o + s];
      s = -1;
      for (var f = Array(o + 1); ++s < o; )
        f[s] = a[s];
      return f[o] = i(c), e(r, this, f);
    };
  }
  return Bu = n, Bu;
}
var $u, o5;
function D$() {
  if (o5) return $u;
  o5 = 1;
  function e(t) {
    return function() {
      return t;
    };
  }
  return $u = e, $u;
}
var Fu, i5;
function I$() {
  if (i5) return Fu;
  i5 = 1;
  var e = D$(), t = jw(), n = Il(), r = t ? function(o, i) {
    return t(o, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(i),
      writable: !0
    });
  } : n;
  return Fu = r, Fu;
}
var Wu, a5;
function B$() {
  if (a5) return Wu;
  a5 = 1;
  var e = 800, t = 16, n = Date.now;
  function r(o) {
    var i = 0, a = 0;
    return function() {
      var s = n(), l = t - (s - a);
      if (a = s, l > 0) {
        if (++i >= e)
          return arguments[0];
      } else
        i = 0;
      return o.apply(void 0, arguments);
    };
  }
  return Wu = r, Wu;
}
var qu, s5;
function tx() {
  if (s5) return qu;
  s5 = 1;
  var e = I$(), t = B$(), n = t(e);
  return qu = n, qu;
}
var ju, l5;
function Jh() {
  if (l5) return ju;
  l5 = 1;
  var e = Il(), t = ex(), n = tx();
  function r(o, i) {
    return n(t(o, i, e), o + "");
  }
  return ju = r, ju;
}
var Hu, c5;
function nx() {
  if (c5) return Hu;
  c5 = 1;
  var e = ds(), t = Pi(), n = Dl(), r = rr();
  function o(i, a, s) {
    if (!r(s))
      return !1;
    var l = typeof a;
    return (l == "number" ? t(s) && n(a, s.length) : l == "string" && a in s) ? e(s[a], i) : !1;
  }
  return Hu = o, Hu;
}
var Vu, u5;
function $$() {
  if (u5) return Vu;
  u5 = 1;
  var e = Jh(), t = nx();
  function n(r) {
    return e(function(o, i) {
      var a = -1, s = i.length, l = s > 1 ? i[s - 1] : void 0, c = s > 2 ? i[2] : void 0;
      for (l = r.length > 3 && typeof l == "function" ? (s--, l) : void 0, c && t(i[0], i[1], c) && (l = s < 3 ? void 0 : l, s = 1), o = Object(o); ++a < s; ) {
        var f = i[a];
        f && r(o, f, a, l);
      }
      return o;
    });
  }
  return Vu = n, Vu;
}
var Uu, d5;
function F$() {
  if (d5) return Uu;
  d5 = 1;
  var e = O$(), t = $$(), n = t(function(r, o, i) {
    e(r, o, i);
  });
  return Uu = n, Uu;
}
var W$ = F$();
const q$ = /* @__PURE__ */ Ht(W$);
var zu, f5;
function Bl() {
  if (f5) return zu;
  f5 = 1;
  var e = _r(), t = _n(), n = "[object Symbol]";
  function r(o) {
    return typeof o == "symbol" || t(o) && e(o) == n;
  }
  return zu = r, zu;
}
var Yu, h5;
function e4() {
  if (h5) return Yu;
  h5 = 1;
  var e = on(), t = Bl(), n = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, r = /^\w*$/;
  function o(i, a) {
    if (e(i))
      return !1;
    var s = typeof i;
    return s == "number" || s == "symbol" || s == "boolean" || i == null || t(i) ? !0 : r.test(i) || !n.test(i) || a != null && i in Object(a);
  }
  return Yu = o, Yu;
}
var Gu, m5;
function j$() {
  if (m5) return Gu;
  m5 = 1;
  var e = Vh(), t = "Expected a function";
  function n(r, o) {
    if (typeof r != "function" || o != null && typeof o != "function")
      throw new TypeError(t);
    var i = function() {
      var a = arguments, s = o ? o.apply(this, a) : a[0], l = i.cache;
      if (l.has(s))
        return l.get(s);
      var c = r.apply(this, a);
      return i.cache = l.set(s, c) || l, c;
    };
    return i.cache = new (n.Cache || e)(), i;
  }
  return n.Cache = e, Gu = n, Gu;
}
var Ku, p5;
function H$() {
  if (p5) return Ku;
  p5 = 1;
  var e = j$(), t = 500;
  function n(r) {
    var o = e(r, function(a) {
      return i.size === t && i.clear(), a;
    }), i = o.cache;
    return o;
  }
  return Ku = n, Ku;
}
var Zu, g5;
function V$() {
  if (g5) return Zu;
  g5 = 1;
  var e = H$(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, n = /\\(\\)?/g, r = e(function(o) {
    var i = [];
    return o.charCodeAt(0) === 46 && i.push(""), o.replace(t, function(a, s, l, c) {
      i.push(l ? c.replace(n, "$1") : s || a);
    }), i;
  });
  return Zu = r, Zu;
}
var Xu, v5;
function $l() {
  if (v5) return Xu;
  v5 = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length, i = Array(o); ++r < o; )
      i[r] = n(t[r], r, t);
    return i;
  }
  return Xu = e, Xu;
}
var Qu, b5;
function U$() {
  if (b5) return Qu;
  b5 = 1;
  var e = Ti(), t = $l(), n = on(), r = Bl(), o = e ? e.prototype : void 0, i = o ? o.toString : void 0;
  function a(s) {
    if (typeof s == "string")
      return s;
    if (n(s))
      return t(s, a) + "";
    if (r(s))
      return i ? i.call(s) : "";
    var l = s + "";
    return l == "0" && 1 / s == -1 / 0 ? "-0" : l;
  }
  return Qu = a, Qu;
}
var Ju, y5;
function rx() {
  if (y5) return Ju;
  y5 = 1;
  var e = U$();
  function t(n) {
    return n == null ? "" : e(n);
  }
  return Ju = t, Ju;
}
var ed, C5;
function Oi() {
  if (C5) return ed;
  C5 = 1;
  var e = on(), t = e4(), n = V$(), r = rx();
  function o(i, a) {
    return e(i) ? i : t(i, a) ? [i] : n(r(i));
  }
  return ed = o, ed;
}
var td, w5;
function Ni() {
  if (w5) return td;
  w5 = 1;
  var e = Bl();
  function t(n) {
    if (typeof n == "string" || e(n))
      return n;
    var r = n + "";
    return r == "0" && 1 / n == -1 / 0 ? "-0" : r;
  }
  return td = t, td;
}
var nd, x5;
function hs() {
  if (x5) return nd;
  x5 = 1;
  var e = Oi(), t = Ni();
  function n(r, o) {
    o = e(o, r);
    for (var i = 0, a = o.length; r != null && i < a; )
      r = r[t(o[i++])];
    return i && i == a ? r : void 0;
  }
  return nd = n, nd;
}
var rd, _5;
function ox() {
  if (_5) return rd;
  _5 = 1;
  var e = hs();
  function t(n, r, o) {
    var i = n == null ? void 0 : e(n, r);
    return i === void 0 ? o : i;
  }
  return rd = t, rd;
}
var z$ = ox();
const Zn = /* @__PURE__ */ Ht(z$);
var od, k5;
function ix() {
  if (k5) return od;
  k5 = 1;
  var e = Qh(), t = Oi(), n = Dl(), r = rr(), o = Ni();
  function i(a, s, l, c) {
    if (!r(a))
      return a;
    s = t(s, a);
    for (var f = -1, u = s.length, h = u - 1, m = a; m != null && ++f < u; ) {
      var g = o(s[f]), p = l;
      if (g === "__proto__" || g === "constructor" || g === "prototype")
        return a;
      if (f != h) {
        var v = m[g];
        p = c ? c(v, g, m) : void 0, p === void 0 && (p = r(v) ? v : n(s[f + 1]) ? [] : {});
      }
      e(m, g, p), m = m[g];
    }
    return a;
  }
  return od = i, od;
}
var id, S5;
function Y$() {
  if (S5) return id;
  S5 = 1;
  var e = ix();
  function t(n, r, o) {
    return n == null ? n : e(n, r, o);
  }
  return id = t, id;
}
var G$ = Y$();
const ca = /* @__PURE__ */ Ht(G$);
function Fl(e, t, n) {
  e.prototype = t.prototype = n, n.constructor = e;
}
function t4(e, t) {
  var n = Object.create(e.prototype);
  for (var r in t) n[r] = t[r];
  return n;
}
function Di() {
}
var bo = 0.7, ci = 1 / bo, ni = "\\s*([+-]?\\d+)\\s*", Aa = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", zn = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", K$ = /^#([0-9a-f]{3,8})$/, Z$ = new RegExp(`^rgb\\(${ni},${ni},${ni}\\)$`), X$ = new RegExp(`^rgb\\(${zn},${zn},${zn}\\)$`), Q$ = new RegExp(`^rgba\\(${ni},${ni},${ni},${Aa}\\)$`), J$ = new RegExp(`^rgba\\(${zn},${zn},${zn},${Aa}\\)$`), eF = new RegExp(`^hsl\\(${Aa},${zn},${zn}\\)$`), tF = new RegExp(`^hsla\\(${Aa},${zn},${zn},${Aa}\\)$`), M5 = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
Fl(Di, Oa, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: E5,
  // Deprecated! Use color.formatHex.
  formatHex: E5,
  formatHex8: nF,
  formatHsl: rF,
  formatRgb: L5,
  toString: L5
});
function E5() {
  return this.rgb().formatHex();
}
function nF() {
  return this.rgb().formatHex8();
}
function rF() {
  return sx(this).formatHsl();
}
function L5() {
  return this.rgb().formatRgb();
}
function Oa(e) {
  var t, n;
  return e = (e + "").trim().toLowerCase(), (t = K$.exec(e)) ? (n = t[1].length, t = parseInt(t[1], 16), n === 6 ? T5(t) : n === 3 ? new Qt(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : n === 8 ? Ns(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : n === 4 ? Ns(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = Z$.exec(e)) ? new Qt(t[1], t[2], t[3], 1) : (t = X$.exec(e)) ? new Qt(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = Q$.exec(e)) ? Ns(t[1], t[2], t[3], t[4]) : (t = J$.exec(e)) ? Ns(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = eF.exec(e)) ? A5(t[1], t[2] / 100, t[3] / 100, 1) : (t = tF.exec(e)) ? A5(t[1], t[2] / 100, t[3] / 100, t[4]) : M5.hasOwnProperty(e) ? T5(M5[e]) : e === "transparent" ? new Qt(NaN, NaN, NaN, 0) : null;
}
function T5(e) {
  return new Qt(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function Ns(e, t, n, r) {
  return r <= 0 && (e = t = n = NaN), new Qt(e, t, n, r);
}
function ax(e) {
  return e instanceof Di || (e = Oa(e)), e ? (e = e.rgb(), new Qt(e.r, e.g, e.b, e.opacity)) : new Qt();
}
function ui(e, t, n, r) {
  return arguments.length === 1 ? ax(e) : new Qt(e, t, n, r ?? 1);
}
function Qt(e, t, n, r) {
  this.r = +e, this.g = +t, this.b = +n, this.opacity = +r;
}
Fl(Qt, ui, t4(Di, {
  brighter(e) {
    return e = e == null ? ci : Math.pow(ci, e), new Qt(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? bo : Math.pow(bo, e), new Qt(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Qt(so(this.r), so(this.g), so(this.b), c0(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: P5,
  // Deprecated! Use color.formatHex.
  formatHex: P5,
  formatHex8: oF,
  formatRgb: R5,
  toString: R5
}));
function P5() {
  return `#${no(this.r)}${no(this.g)}${no(this.b)}`;
}
function oF() {
  return `#${no(this.r)}${no(this.g)}${no(this.b)}${no((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function R5() {
  const e = c0(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${so(this.r)}, ${so(this.g)}, ${so(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function c0(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function so(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function no(e) {
  return e = so(e), (e < 16 ? "0" : "") + e.toString(16);
}
function A5(e, t, n, r) {
  return r <= 0 ? e = t = n = NaN : n <= 0 || n >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new Tn(e, t, n, r);
}
function sx(e) {
  if (e instanceof Tn) return new Tn(e.h, e.s, e.l, e.opacity);
  if (e instanceof Di || (e = Oa(e)), !e) return new Tn();
  if (e instanceof Tn) return e;
  e = e.rgb();
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, o = Math.min(t, n, r), i = Math.max(t, n, r), a = NaN, s = i - o, l = (i + o) / 2;
  return s ? (t === i ? a = (n - r) / s + (n < r) * 6 : n === i ? a = (r - t) / s + 2 : a = (t - n) / s + 4, s /= l < 0.5 ? i + o : 2 - i - o, a *= 60) : s = l > 0 && l < 1 ? 0 : a, new Tn(a, s, l, e.opacity);
}
function iF(e, t, n, r) {
  return arguments.length === 1 ? sx(e) : new Tn(e, t, n, r ?? 1);
}
function Tn(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
Fl(Tn, iF, t4(Di, {
  brighter(e) {
    return e = e == null ? ci : Math.pow(ci, e), new Tn(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? bo : Math.pow(bo, e), new Tn(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * t, o = 2 * n - r;
    return new Qt(
      ad(e >= 240 ? e - 240 : e + 120, o, r),
      ad(e, o, r),
      ad(e < 120 ? e + 240 : e - 120, o, r),
      this.opacity
    );
  },
  clamp() {
    return new Tn(O5(this.h), Ds(this.s), Ds(this.l), c0(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = c0(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${O5(this.h)}, ${Ds(this.s) * 100}%, ${Ds(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function O5(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function Ds(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function ad(e, t, n) {
  return (e < 60 ? t + (n - t) * e / 60 : e < 180 ? n : e < 240 ? t + (n - t) * (240 - e) / 60 : t) * 255;
}
const aF = Math.PI / 180, sF = 180 / Math.PI;
var lx = -0.14861, n4 = 1.78277, r4 = -0.29227, Wl = -0.90649, Na = 1.97294, N5 = Na * Wl, D5 = Na * n4, I5 = n4 * r4 - Wl * lx;
function lF(e) {
  if (e instanceof lo) return new lo(e.h, e.s, e.l, e.opacity);
  e instanceof Qt || (e = ax(e));
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, o = (I5 * r + N5 * t - D5 * n) / (I5 + N5 - D5), i = r - o, a = (Na * (n - o) - r4 * i) / Wl, s = Math.sqrt(a * a + i * i) / (Na * o * (1 - o)), l = s ? Math.atan2(a, i) * sF - 120 : NaN;
  return new lo(l < 0 ? l + 360 : l, s, o, e.opacity);
}
function Xn(e, t, n, r) {
  return arguments.length === 1 ? lF(e) : new lo(e, t, n, r ?? 1);
}
function lo(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
Fl(lo, Xn, t4(Di, {
  brighter(e) {
    return e = e == null ? ci : Math.pow(ci, e), new lo(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? bo : Math.pow(bo, e), new lo(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = isNaN(this.h) ? 0 : (this.h + 120) * aF, t = +this.l, n = isNaN(this.s) ? 0 : this.s * t * (1 - t), r = Math.cos(e), o = Math.sin(e);
    return new Qt(
      255 * (t + n * (lx * r + n4 * o)),
      255 * (t + n * (r4 * r + Wl * o)),
      255 * (t + n * (Na * r)),
      this.opacity
    );
  }
}));
function cF(e, t, n, r, o) {
  var i = e * e, a = i * e;
  return ((1 - 3 * e + 3 * i - a) * t + (4 - 6 * i + 3 * a) * n + (1 + 3 * e + 3 * i - 3 * a) * r + a * o) / 6;
}
function uF(e) {
  var t = e.length - 1;
  return function(n) {
    var r = n <= 0 ? n = 0 : n >= 1 ? (n = 1, t - 1) : Math.floor(n * t), o = e[r], i = e[r + 1], a = r > 0 ? e[r - 1] : 2 * o - i, s = r < t - 1 ? e[r + 2] : 2 * i - o;
    return cF((n - r / t) * t, a, o, i, s);
  };
}
const ql = (e) => () => e;
function cx(e, t) {
  return function(n) {
    return e + n * t;
  };
}
function dF(e, t, n) {
  return e = Math.pow(e, n), t = Math.pow(t, n) - e, n = 1 / n, function(r) {
    return Math.pow(e + r * t, n);
  };
}
function fF(e, t) {
  var n = t - e;
  return n ? cx(e, n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n) : ql(isNaN(e) ? t : e);
}
function hF(e) {
  return (e = +e) == 1 ? ri : function(t, n) {
    return n - t ? dF(t, n, e) : ql(isNaN(t) ? n : t);
  };
}
function ri(e, t) {
  var n = t - e;
  return n ? cx(e, n) : ql(isNaN(e) ? t : e);
}
const B5 = function e(t) {
  var n = hF(t);
  function r(o, i) {
    var a = n((o = ui(o)).r, (i = ui(i)).r), s = n(o.g, i.g), l = n(o.b, i.b), c = ri(o.opacity, i.opacity);
    return function(f) {
      return o.r = a(f), o.g = s(f), o.b = l(f), o.opacity = c(f), o + "";
    };
  }
  return r.gamma = e, r;
}(1);
function mF(e) {
  return function(t) {
    var n = t.length, r = new Array(n), o = new Array(n), i = new Array(n), a, s;
    for (a = 0; a < n; ++a)
      s = ui(t[a]), r[a] = s.r || 0, o[a] = s.g || 0, i[a] = s.b || 0;
    return r = e(r), o = e(o), i = e(i), s.opacity = 1, function(l) {
      return s.r = r(l), s.g = o(l), s.b = i(l), s + "";
    };
  };
}
var pF = mF(uF);
function gF(e, t) {
  t || (t = []);
  var n = e ? Math.min(t.length, e.length) : 0, r = t.slice(), o;
  return function(i) {
    for (o = 0; o < n; ++o) r[o] = e[o] * (1 - i) + t[o] * i;
    return r;
  };
}
function vF(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function bF(e, t) {
  var n = t ? t.length : 0, r = e ? Math.min(n, e.length) : 0, o = new Array(r), i = new Array(n), a;
  for (a = 0; a < r; ++a) o[a] = o4(e[a], t[a]);
  for (; a < n; ++a) i[a] = t[a];
  return function(s) {
    for (a = 0; a < r; ++a) i[a] = o[a](s);
    return i;
  };
}
function yF(e, t) {
  var n = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(r) {
    return n.setTime(e * (1 - r) + t * r), n;
  };
}
function u0(e, t) {
  return e = +e, t = +t, function(n) {
    return e * (1 - n) + t * n;
  };
}
function CF(e, t) {
  var n = {}, r = {}, o;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (o in t)
    o in e ? n[o] = o4(e[o], t[o]) : r[o] = t[o];
  return function(i) {
    for (o in n) r[o] = n[o](i);
    return r;
  };
}
var o9 = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, sd = new RegExp(o9.source, "g");
function wF(e) {
  return function() {
    return e;
  };
}
function xF(e) {
  return function(t) {
    return e(t) + "";
  };
}
function ux(e, t) {
  var n = o9.lastIndex = sd.lastIndex = 0, r, o, i, a = -1, s = [], l = [];
  for (e = e + "", t = t + ""; (r = o9.exec(e)) && (o = sd.exec(t)); )
    (i = o.index) > n && (i = t.slice(n, i), s[a] ? s[a] += i : s[++a] = i), (r = r[0]) === (o = o[0]) ? s[a] ? s[a] += o : s[++a] = o : (s[++a] = null, l.push({ i: a, x: u0(r, o) })), n = sd.lastIndex;
  return n < t.length && (i = t.slice(n), s[a] ? s[a] += i : s[++a] = i), s.length < 2 ? l[0] ? xF(l[0].x) : wF(t) : (t = l.length, function(c) {
    for (var f = 0, u; f < t; ++f) s[(u = l[f]).i] = u.x(c);
    return s.join("");
  });
}
function o4(e, t) {
  var n = typeof t, r;
  return t == null || n === "boolean" ? ql(t) : (n === "number" ? u0 : n === "string" ? (r = Oa(t)) ? (t = r, B5) : ux : t instanceof Oa ? B5 : t instanceof Date ? yF : vF(t) ? gF : Array.isArray(t) ? bF : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? CF : u0)(e, t);
}
function _F(e, t) {
  return e = +e, t = +t, function(n) {
    return Math.round(e * (1 - n) + t * n);
  };
}
function dx(e) {
  return function t(n) {
    n = +n;
    function r(o, i) {
      var a = e((o = Xn(o)).h, (i = Xn(i)).h), s = ri(o.s, i.s), l = ri(o.l, i.l), c = ri(o.opacity, i.opacity);
      return function(f) {
        return o.h = a(f), o.s = s(f), o.l = l(Math.pow(f, n)), o.opacity = c(f), o + "";
      };
    }
    return r.gamma = t, r;
  }(1);
}
dx(fF);
var i4 = dx(ri), ld, $5;
function kF() {
  if ($5) return ld;
  $5 = 1;
  var e = _r(), t = on(), n = _n(), r = "[object String]";
  function o(i) {
    return typeof i == "string" || !t(i) && n(i) && e(i) == r;
  }
  return ld = o, ld;
}
var SF = kF();
const MF = /* @__PURE__ */ Ht(SF);
var cd, F5;
function fx() {
  if (F5) return cd;
  F5 = 1;
  function e(t) {
    var n = t == null ? 0 : t.length;
    return n ? t[n - 1] : void 0;
  }
  return cd = e, cd;
}
var EF = fx();
const ye = /* @__PURE__ */ Ht(EF);
on();
function Ys(e, t) {
  return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function LF(e, t) {
  return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function a4(e) {
  let t, n, r;
  e.length !== 2 ? (t = Ys, n = (s, l) => Ys(e(s), l), r = (s, l) => e(s) - l) : (t = e === Ys || e === LF ? e : TF, n = e, r = e);
  function o(s, l, c = 0, f = s.length) {
    if (c < f) {
      if (t(l, l) !== 0) return f;
      do {
        const u = c + f >>> 1;
        n(s[u], l) < 0 ? c = u + 1 : f = u;
      } while (c < f);
    }
    return c;
  }
  function i(s, l, c = 0, f = s.length) {
    if (c < f) {
      if (t(l, l) !== 0) return f;
      do {
        const u = c + f >>> 1;
        n(s[u], l) <= 0 ? c = u + 1 : f = u;
      } while (c < f);
    }
    return c;
  }
  function a(s, l, c = 0, f = s.length) {
    const u = o(s, l, c, f - 1);
    return u > c && r(s[u - 1], l) > -r(s[u], l) ? u - 1 : u;
  }
  return { left: o, center: a, right: i };
}
function TF() {
  return 0;
}
function PF(e) {
  return e === null ? NaN : +e;
}
const RF = a4(Ys), AF = RF.right;
a4(PF).center;
class W5 extends Map {
  constructor(t, n = DF) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: n } }), t != null) for (const [r, o] of t) this.set(r, o);
  }
  get(t) {
    return super.get(q5(this, t));
  }
  has(t) {
    return super.has(q5(this, t));
  }
  set(t, n) {
    return super.set(OF(this, t), n);
  }
  delete(t) {
    return super.delete(NF(this, t));
  }
}
function q5({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) ? e.get(r) : n;
}
function OF({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) ? e.get(r) : (e.set(r, n), n);
}
function NF({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) && (n = e.get(r), e.delete(r)), n;
}
function DF(e) {
  return e !== null && typeof e == "object" ? e.valueOf() : e;
}
const IF = Math.sqrt(50), BF = Math.sqrt(10), $F = Math.sqrt(2);
function d0(e, t, n) {
  const r = (t - e) / Math.max(0, n), o = Math.floor(Math.log10(r)), i = r / Math.pow(10, o), a = i >= IF ? 10 : i >= BF ? 5 : i >= $F ? 2 : 1;
  let s, l, c;
  return o < 0 ? (c = Math.pow(10, -o) / a, s = Math.round(e * c), l = Math.round(t * c), s / c < e && ++s, l / c > t && --l, c = -c) : (c = Math.pow(10, o) * a, s = Math.round(e / c), l = Math.round(t / c), s * c < e && ++s, l * c > t && --l), l < s && 0.5 <= n && n < 2 ? d0(e, t, n * 2) : [s, l, c];
}
function i9(e, t, n) {
  if (t = +t, e = +e, n = +n, !(n > 0)) return [];
  if (e === t) return [e];
  const r = t < e, [o, i, a] = r ? d0(t, e, n) : d0(e, t, n);
  if (!(i >= o)) return [];
  const s = i - o + 1, l = new Array(s);
  if (r)
    if (a < 0) for (let c = 0; c < s; ++c) l[c] = (i - c) / -a;
    else for (let c = 0; c < s; ++c) l[c] = (i - c) * a;
  else if (a < 0) for (let c = 0; c < s; ++c) l[c] = (o + c) / -a;
  else for (let c = 0; c < s; ++c) l[c] = (o + c) * a;
  return l;
}
function a9(e, t, n) {
  return t = +t, e = +e, n = +n, d0(e, t, n)[2];
}
function s9(e, t, n) {
  t = +t, e = +e, n = +n;
  const r = t < e, o = r ? a9(t, e, n) : a9(e, t, n);
  return (r ? -1 : 1) * (o < 0 ? 1 / -o : o);
}
function FF(e, t, n) {
  e = +e, t = +t, n = (o = arguments.length) < 2 ? (t = e, e = 0, 1) : o < 3 ? 1 : +n;
  for (var r = -1, o = Math.max(0, Math.ceil((t - e) / n)) | 0, i = new Array(o); ++r < o; )
    i[r] = e + r * n;
  return i;
}
function Lo(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(t).domain(e);
      break;
  }
  return this;
}
const j5 = Symbol("implicit");
function ro() {
  var e = new W5(), t = [], n = [], r = j5;
  function o(i) {
    let a = e.get(i);
    if (a === void 0) {
      if (r !== j5) return r;
      e.set(i, a = t.push(i) - 1);
    }
    return n[a % n.length];
  }
  return o.domain = function(i) {
    if (!arguments.length) return t.slice();
    t = [], e = new W5();
    for (const a of i)
      e.has(a) || e.set(a, t.push(a) - 1);
    return o;
  }, o.range = function(i) {
    return arguments.length ? (n = Array.from(i), o) : n.slice();
  }, o.unknown = function(i) {
    return arguments.length ? (r = i, o) : r;
  }, o.copy = function() {
    return ro(t, n).unknown(r);
  }, Lo.apply(o, arguments), o;
}
function s4() {
  var e = ro().unknown(void 0), t = e.domain, n = e.range, r = 0, o = 1, i, a, s = !1, l = 0, c = 0, f = 0.5;
  delete e.unknown;
  function u() {
    var h = t().length, m = o < r, g = m ? o : r, p = m ? r : o;
    i = (p - g) / Math.max(1, h - l + c * 2), s && (i = Math.floor(i)), g += (p - g - i * (h - l)) * f, a = i * (1 - l), s && (g = Math.round(g), a = Math.round(a));
    var v = FF(h).map(function(y) {
      return g + i * y;
    });
    return n(m ? v.reverse() : v);
  }
  return e.domain = function(h) {
    return arguments.length ? (t(h), u()) : t();
  }, e.range = function(h) {
    return arguments.length ? ([r, o] = h, r = +r, o = +o, u()) : [r, o];
  }, e.rangeRound = function(h) {
    return [r, o] = h, r = +r, o = +o, s = !0, u();
  }, e.bandwidth = function() {
    return a;
  }, e.step = function() {
    return i;
  }, e.round = function(h) {
    return arguments.length ? (s = !!h, u()) : s;
  }, e.padding = function(h) {
    return arguments.length ? (l = Math.min(1, c = +h), u()) : l;
  }, e.paddingInner = function(h) {
    return arguments.length ? (l = Math.min(1, h), u()) : l;
  }, e.paddingOuter = function(h) {
    return arguments.length ? (c = +h, u()) : c;
  }, e.align = function(h) {
    return arguments.length ? (f = Math.max(0, Math.min(1, h)), u()) : f;
  }, e.copy = function() {
    return s4(t(), [r, o]).round(s).paddingInner(l).paddingOuter(c).align(f);
  }, Lo.apply(u(), arguments);
}
function hx(e) {
  var t = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return hx(t());
  }, e;
}
function WF() {
  return hx(s4.apply(null, arguments).paddingInner(1));
}
function qF(e) {
  return function() {
    return e;
  };
}
function jF(e) {
  return +e;
}
var H5 = [0, 1];
function Ko(e) {
  return e;
}
function l9(e, t) {
  return (t -= e = +e) ? function(n) {
    return (n - e) / t;
  } : qF(isNaN(t) ? NaN : 0.5);
}
function HF(e, t) {
  var n;
  return e > t && (n = e, e = t, t = n), function(r) {
    return Math.max(e, Math.min(t, r));
  };
}
function VF(e, t, n) {
  var r = e[0], o = e[1], i = t[0], a = t[1];
  return o < r ? (r = l9(o, r), i = n(a, i)) : (r = l9(r, o), i = n(i, a)), function(s) {
    return i(r(s));
  };
}
function UF(e, t, n) {
  var r = Math.min(e.length, t.length) - 1, o = new Array(r), i = new Array(r), a = -1;
  for (e[r] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++a < r; )
    o[a] = l9(e[a], e[a + 1]), i[a] = n(t[a], t[a + 1]);
  return function(s) {
    var l = AF(e, s, 1, r) - 1;
    return i[l](o[l](s));
  };
}
function jl(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function l4() {
  var e = H5, t = H5, n = o4, r, o, i, a = Ko, s, l, c;
  function f() {
    var h = Math.min(e.length, t.length);
    return a !== Ko && (a = HF(e[0], e[h - 1])), s = h > 2 ? UF : VF, l = c = null, u;
  }
  function u(h) {
    return h == null || isNaN(h = +h) ? i : (l || (l = s(e.map(r), t, n)))(r(a(h)));
  }
  return u.invert = function(h) {
    return a(o((c || (c = s(t, e.map(r), u0)))(h)));
  }, u.domain = function(h) {
    return arguments.length ? (e = Array.from(h, jF), f()) : e.slice();
  }, u.range = function(h) {
    return arguments.length ? (t = Array.from(h), f()) : t.slice();
  }, u.rangeRound = function(h) {
    return t = Array.from(h), n = _F, f();
  }, u.clamp = function(h) {
    return arguments.length ? (a = h ? !0 : Ko, f()) : a !== Ko;
  }, u.interpolate = function(h) {
    return arguments.length ? (n = h, f()) : n;
  }, u.unknown = function(h) {
    return arguments.length ? (i = h, u) : i;
  }, function(h, m) {
    return r = h, o = m, f();
  };
}
function mx() {
  return l4()(Ko, Ko);
}
function zF(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function f0(e, t) {
  if ((n = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0) return null;
  var n, r = e.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +e.slice(n + 1)
  ];
}
function di(e) {
  return e = f0(Math.abs(e)), e ? e[1] : NaN;
}
function YF(e, t) {
  return function(n, r) {
    for (var o = n.length, i = [], a = 0, s = e[0], l = 0; o > 0 && s > 0 && (l + s + 1 > r && (s = Math.max(1, r - l)), i.push(n.substring(o -= s, o + s)), !((l += s + 1) > r)); )
      s = e[a = (a + 1) % e.length];
    return i.reverse().join(t);
  };
}
function GF(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(n) {
      return e[+n];
    });
  };
}
var KF = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function Da(e) {
  if (!(t = KF.exec(e))) throw new Error("invalid format: " + e);
  var t;
  return new c4({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
Da.prototype = c4.prototype;
function c4(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
c4.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function ZF(e) {
  e: for (var t = e.length, n = 1, r = -1, o; n < t; ++n)
    switch (e[n]) {
      case ".":
        r = o = n;
        break;
      case "0":
        r === 0 && (r = n), o = n;
        break;
      default:
        if (!+e[n]) break e;
        r > 0 && (r = 0);
        break;
    }
  return r > 0 ? e.slice(0, r) + e.slice(o + 1) : e;
}
var px;
function XF(e, t) {
  var n = f0(e, t);
  if (!n) return e + "";
  var r = n[0], o = n[1], i = o - (px = Math.max(-8, Math.min(8, Math.floor(o / 3))) * 3) + 1, a = r.length;
  return i === a ? r : i > a ? r + new Array(i - a + 1).join("0") : i > 0 ? r.slice(0, i) + "." + r.slice(i) : "0." + new Array(1 - i).join("0") + f0(e, Math.max(0, t + i - 1))[0];
}
function V5(e, t) {
  var n = f0(e, t);
  if (!n) return e + "";
  var r = n[0], o = n[1];
  return o < 0 ? "0." + new Array(-o).join("0") + r : r.length > o + 1 ? r.slice(0, o + 1) + "." + r.slice(o + 1) : r + new Array(o - r.length + 2).join("0");
}
const U5 = {
  "%": (e, t) => (e * 100).toFixed(t),
  b: (e) => Math.round(e).toString(2),
  c: (e) => e + "",
  d: zF,
  e: (e, t) => e.toExponential(t),
  f: (e, t) => e.toFixed(t),
  g: (e, t) => e.toPrecision(t),
  o: (e) => Math.round(e).toString(8),
  p: (e, t) => V5(e * 100, t),
  r: V5,
  s: XF,
  X: (e) => Math.round(e).toString(16).toUpperCase(),
  x: (e) => Math.round(e).toString(16)
};
function z5(e) {
  return e;
}
var Y5 = Array.prototype.map, G5 = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function QF(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? z5 : YF(Y5.call(e.grouping, Number), e.thousands + ""), n = e.currency === void 0 ? "" : e.currency[0] + "", r = e.currency === void 0 ? "" : e.currency[1] + "", o = e.decimal === void 0 ? "." : e.decimal + "", i = e.numerals === void 0 ? z5 : GF(Y5.call(e.numerals, String)), a = e.percent === void 0 ? "%" : e.percent + "", s = e.minus === void 0 ? "−" : e.minus + "", l = e.nan === void 0 ? "NaN" : e.nan + "";
  function c(u) {
    u = Da(u);
    var h = u.fill, m = u.align, g = u.sign, p = u.symbol, v = u.zero, y = u.width, C = u.comma, w = u.precision, _ = u.trim, x = u.type;
    x === "n" ? (C = !0, x = "g") : U5[x] || (w === void 0 && (w = 12), _ = !0, x = "g"), (v || h === "0" && m === "=") && (v = !0, h = "0", m = "=");
    var k = p === "$" ? n : p === "#" && /[boxX]/.test(x) ? "0" + x.toLowerCase() : "", S = p === "$" ? r : /[%p]/.test(x) ? a : "", T = U5[x], L = /[defgprs%]/.test(x);
    w = w === void 0 ? 6 : /[gprs]/.test(x) ? Math.max(1, Math.min(21, w)) : Math.max(0, Math.min(20, w));
    function R(M) {
      var A = k, O = S, I, W, N;
      if (x === "c")
        O = T(M) + O, M = "";
      else {
        M = +M;
        var H = M < 0 || 1 / M < 0;
        if (M = isNaN(M) ? l : T(Math.abs(M), w), _ && (M = ZF(M)), H && +M == 0 && g !== "+" && (H = !1), A = (H ? g === "(" ? g : s : g === "-" || g === "(" ? "" : g) + A, O = (x === "s" ? G5[8 + px / 3] : "") + O + (H && g === "(" ? ")" : ""), L) {
          for (I = -1, W = M.length; ++I < W; )
            if (N = M.charCodeAt(I), 48 > N || N > 57) {
              O = (N === 46 ? o + M.slice(I + 1) : M.slice(I)) + O, M = M.slice(0, I);
              break;
            }
        }
      }
      C && !v && (M = t(M, 1 / 0));
      var q = A.length + M.length + O.length, D = q < y ? new Array(y - q + 1).join(h) : "";
      switch (C && v && (M = t(D + M, D.length ? y - O.length : 1 / 0), D = ""), m) {
        case "<":
          M = A + M + O + D;
          break;
        case "=":
          M = A + D + M + O;
          break;
        case "^":
          M = D.slice(0, q = D.length >> 1) + A + M + O + D.slice(q);
          break;
        default:
          M = D + A + M + O;
          break;
      }
      return i(M);
    }
    return R.toString = function() {
      return u + "";
    }, R;
  }
  function f(u, h) {
    var m = c((u = Da(u), u.type = "f", u)), g = Math.max(-8, Math.min(8, Math.floor(di(h) / 3))) * 3, p = Math.pow(10, -g), v = G5[8 + g / 3];
    return function(y) {
      return m(p * y) + v;
    };
  }
  return {
    format: c,
    formatPrefix: f
  };
}
var Is, u4, gx;
JF({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function JF(e) {
  return Is = QF(e), u4 = Is.format, gx = Is.formatPrefix, Is;
}
function eW(e) {
  return Math.max(0, -di(Math.abs(e)));
}
function tW(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(di(t) / 3))) * 3 - di(Math.abs(e)));
}
function nW(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, di(t) - di(e)) + 1;
}
function rW(e, t, n, r) {
  var o = s9(e, t, n), i;
  switch (r = Da(r ?? ",f"), r.type) {
    case "s": {
      var a = Math.max(Math.abs(e), Math.abs(t));
      return r.precision == null && !isNaN(i = tW(o, a)) && (r.precision = i), gx(r, a);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(i = nW(o, Math.max(Math.abs(e), Math.abs(t)))) && (r.precision = i - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(i = eW(o)) && (r.precision = i - (r.type === "%") * 2);
      break;
    }
  }
  return u4(r);
}
function vx(e) {
  var t = e.domain;
  return e.ticks = function(n) {
    var r = t();
    return i9(r[0], r[r.length - 1], n ?? 10);
  }, e.tickFormat = function(n, r) {
    var o = t();
    return rW(o[0], o[o.length - 1], n ?? 10, r);
  }, e.nice = function(n) {
    n == null && (n = 10);
    var r = t(), o = 0, i = r.length - 1, a = r[o], s = r[i], l, c, f = 10;
    for (s < a && (c = a, a = s, s = c, c = o, o = i, i = c); f-- > 0; ) {
      if (c = a9(a, s, n), c === l)
        return r[o] = a, r[i] = s, t(r);
      if (c > 0)
        a = Math.floor(a / c) * c, s = Math.ceil(s / c) * c;
      else if (c < 0)
        a = Math.ceil(a * c) / c, s = Math.floor(s * c) / c;
      else
        break;
      l = c;
    }
    return e;
  }, e;
}
function bx() {
  var e = mx();
  return e.copy = function() {
    return jl(e, bx());
  }, Lo.apply(e, arguments), vx(e);
}
function yx(e, t) {
  e = e.slice();
  var n = 0, r = e.length - 1, o = e[n], i = e[r], a;
  return i < o && (a = n, n = r, r = a, a = o, o = i, i = a), e[n] = t.floor(o), e[r] = t.ceil(i), e;
}
function K5(e) {
  return Math.log(e);
}
function Z5(e) {
  return Math.exp(e);
}
function oW(e) {
  return -Math.log(-e);
}
function iW(e) {
  return -Math.exp(-e);
}
function aW(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function sW(e) {
  return e === 10 ? aW : e === Math.E ? Math.exp : (t) => Math.pow(e, t);
}
function lW(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), (t) => Math.log(t) / e);
}
function X5(e) {
  return (t, n) => -e(-t, n);
}
function cW(e) {
  const t = e(K5, Z5), n = t.domain;
  let r = 10, o, i;
  function a() {
    return o = lW(r), i = sW(r), n()[0] < 0 ? (o = X5(o), i = X5(i), e(oW, iW)) : e(K5, Z5), t;
  }
  return t.base = function(s) {
    return arguments.length ? (r = +s, a()) : r;
  }, t.domain = function(s) {
    return arguments.length ? (n(s), a()) : n();
  }, t.ticks = (s) => {
    const l = n();
    let c = l[0], f = l[l.length - 1];
    const u = f < c;
    u && ([c, f] = [f, c]);
    let h = o(c), m = o(f), g, p;
    const v = s == null ? 10 : +s;
    let y = [];
    if (!(r % 1) && m - h < v) {
      if (h = Math.floor(h), m = Math.ceil(m), c > 0) {
        for (; h <= m; ++h)
          for (g = 1; g < r; ++g)
            if (p = h < 0 ? g / i(-h) : g * i(h), !(p < c)) {
              if (p > f) break;
              y.push(p);
            }
      } else for (; h <= m; ++h)
        for (g = r - 1; g >= 1; --g)
          if (p = h > 0 ? g / i(-h) : g * i(h), !(p < c)) {
            if (p > f) break;
            y.push(p);
          }
      y.length * 2 < v && (y = i9(c, f, v));
    } else
      y = i9(h, m, Math.min(m - h, v)).map(i);
    return u ? y.reverse() : y;
  }, t.tickFormat = (s, l) => {
    if (s == null && (s = 10), l == null && (l = r === 10 ? "s" : ","), typeof l != "function" && (!(r % 1) && (l = Da(l)).precision == null && (l.trim = !0), l = u4(l)), s === 1 / 0) return l;
    const c = Math.max(1, r * s / t.ticks().length);
    return (f) => {
      let u = f / i(Math.round(o(f)));
      return u * r < r - 0.5 && (u *= r), u <= c ? l(f) : "";
    };
  }, t.nice = () => n(yx(n(), {
    floor: (s) => i(Math.floor(o(s))),
    ceil: (s) => i(Math.ceil(o(s)))
  })), t;
}
function Cx() {
  const e = cW(l4()).domain([1, 10]);
  return e.copy = () => jl(e, Cx()).base(e.base()), Lo.apply(e, arguments), e;
}
function Q5(e) {
  return function(t) {
    return Math.sign(t) * Math.log1p(Math.abs(t / e));
  };
}
function J5(e) {
  return function(t) {
    return Math.sign(t) * Math.expm1(Math.abs(t)) * e;
  };
}
function uW(e) {
  var t = 1, n = e(Q5(t), J5(t));
  return n.constant = function(r) {
    return arguments.length ? e(Q5(t = +r), J5(t)) : t;
  }, vx(n);
}
function wx() {
  var e = uW(l4());
  return e.copy = function() {
    return jl(e, wx()).constant(e.constant());
  }, Lo.apply(e, arguments);
}
const ud = /* @__PURE__ */ new Date(), dd = /* @__PURE__ */ new Date();
function Vt(e, t, n, r) {
  function o(i) {
    return e(i = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+i)), i;
  }
  return o.floor = (i) => (e(i = /* @__PURE__ */ new Date(+i)), i), o.ceil = (i) => (e(i = new Date(i - 1)), t(i, 1), e(i), i), o.round = (i) => {
    const a = o(i), s = o.ceil(i);
    return i - a < s - i ? a : s;
  }, o.offset = (i, a) => (t(i = /* @__PURE__ */ new Date(+i), a == null ? 1 : Math.floor(a)), i), o.range = (i, a, s) => {
    const l = [];
    if (i = o.ceil(i), s = s == null ? 1 : Math.floor(s), !(i < a) || !(s > 0)) return l;
    let c;
    do
      l.push(c = /* @__PURE__ */ new Date(+i)), t(i, s), e(i);
    while (c < i && i < a);
    return l;
  }, o.filter = (i) => Vt((a) => {
    if (a >= a) for (; e(a), !i(a); ) a.setTime(a - 1);
  }, (a, s) => {
    if (a >= a)
      if (s < 0) for (; ++s <= 0; )
        for (; t(a, -1), !i(a); )
          ;
      else for (; --s >= 0; )
        for (; t(a, 1), !i(a); )
          ;
  }), n && (o.count = (i, a) => (ud.setTime(+i), dd.setTime(+a), e(ud), e(dd), Math.floor(n(ud, dd))), o.every = (i) => (i = Math.floor(i), !isFinite(i) || !(i > 0) ? null : i > 1 ? o.filter(r ? (a) => r(a) % i === 0 : (a) => o.count(0, a) % i === 0) : o)), o;
}
const h0 = Vt(() => {
}, (e, t) => {
  e.setTime(+e + t);
}, (e, t) => t - e);
h0.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? Vt((t) => {
  t.setTime(Math.floor(t / e) * e);
}, (t, n) => {
  t.setTime(+t + n * e);
}, (t, n) => (n - t) / e) : h0);
h0.range;
const fr = 1e3, yn = fr * 60, hr = yn * 60, Cr = hr * 24, d4 = Cr * 7, e7 = Cr * 30, fd = Cr * 365, oo = Vt((e) => {
  e.setTime(e - e.getMilliseconds());
}, (e, t) => {
  e.setTime(+e + t * fr);
}, (e, t) => (t - e) / fr, (e) => e.getUTCSeconds());
oo.range;
const f4 = Vt((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * fr);
}, (e, t) => {
  e.setTime(+e + t * yn);
}, (e, t) => (t - e) / yn, (e) => e.getMinutes());
f4.range;
const h4 = Vt((e) => {
  e.setUTCSeconds(0, 0);
}, (e, t) => {
  e.setTime(+e + t * yn);
}, (e, t) => (t - e) / yn, (e) => e.getUTCMinutes());
h4.range;
const m4 = Vt((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * fr - e.getMinutes() * yn);
}, (e, t) => {
  e.setTime(+e + t * hr);
}, (e, t) => (t - e) / hr, (e) => e.getHours());
m4.range;
const p4 = Vt((e) => {
  e.setUTCMinutes(0, 0, 0);
}, (e, t) => {
  e.setTime(+e + t * hr);
}, (e, t) => (t - e) / hr, (e) => e.getUTCHours());
p4.range;
const ms = Vt(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * yn) / Cr,
  (e) => e.getDate() - 1
);
ms.range;
const Hl = Vt((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Cr, (e) => e.getUTCDate() - 1);
Hl.range;
const xx = Vt((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Cr, (e) => Math.floor(e / Cr));
xx.range;
function To(e) {
  return Vt((t) => {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, (t, n) => {
    t.setDate(t.getDate() + n * 7);
  }, (t, n) => (n - t - (n.getTimezoneOffset() - t.getTimezoneOffset()) * yn) / d4);
}
const Vl = To(0), m0 = To(1), dW = To(2), fW = To(3), fi = To(4), hW = To(5), mW = To(6);
Vl.range;
m0.range;
dW.range;
fW.range;
fi.range;
hW.range;
mW.range;
function Po(e) {
  return Vt((t) => {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, (t, n) => {
    t.setUTCDate(t.getUTCDate() + n * 7);
  }, (t, n) => (n - t) / d4);
}
const Ul = Po(0), p0 = Po(1), pW = Po(2), gW = Po(3), hi = Po(4), vW = Po(5), bW = Po(6);
Ul.range;
p0.range;
pW.range;
gW.range;
hi.range;
vW.range;
bW.range;
const g4 = Vt((e) => {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setMonth(e.getMonth() + t);
}, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
g4.range;
const v4 = Vt((e) => {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCMonth(e.getUTCMonth() + t);
}, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
v4.range;
const wr = Vt((e) => {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setFullYear(e.getFullYear() + t);
}, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
wr.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Vt((t) => {
  t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, n) => {
  t.setFullYear(t.getFullYear() + n * e);
});
wr.range;
const xr = Vt((e) => {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
xr.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Vt((t) => {
  t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, n) => {
  t.setUTCFullYear(t.getUTCFullYear() + n * e);
});
xr.range;
function _x(e, t, n, r, o, i) {
  const a = [
    [oo, 1, fr],
    [oo, 5, 5 * fr],
    [oo, 15, 15 * fr],
    [oo, 30, 30 * fr],
    [i, 1, yn],
    [i, 5, 5 * yn],
    [i, 15, 15 * yn],
    [i, 30, 30 * yn],
    [o, 1, hr],
    [o, 3, 3 * hr],
    [o, 6, 6 * hr],
    [o, 12, 12 * hr],
    [r, 1, Cr],
    [r, 2, 2 * Cr],
    [n, 1, d4],
    [t, 1, e7],
    [t, 3, 3 * e7],
    [e, 1, fd]
  ];
  function s(c, f, u) {
    const h = f < c;
    h && ([c, f] = [f, c]);
    const m = u && typeof u.range == "function" ? u : l(c, f, u), g = m ? m.range(c, +f + 1) : [];
    return h ? g.reverse() : g;
  }
  function l(c, f, u) {
    const h = Math.abs(f - c) / u, m = a4(([, , v]) => v).right(a, h);
    if (m === a.length) return e.every(s9(c / fd, f / fd, u));
    if (m === 0) return h0.every(Math.max(s9(c, f, u), 1));
    const [g, p] = a[h / a[m - 1][2] < a[m][2] / h ? m - 1 : m];
    return g.every(p);
  }
  return [s, l];
}
const [yW, CW] = _x(xr, v4, Ul, xx, p4, h4), [wW, xW] = _x(wr, g4, Vl, ms, m4, f4);
function hd(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function md(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function Ui(e, t, n) {
  return { y: e, m: t, d: n, H: 0, M: 0, S: 0, L: 0 };
}
function _W(e) {
  var t = e.dateTime, n = e.date, r = e.time, o = e.periods, i = e.days, a = e.shortDays, s = e.months, l = e.shortMonths, c = zi(o), f = Yi(o), u = zi(i), h = Yi(i), m = zi(a), g = Yi(a), p = zi(s), v = Yi(s), y = zi(l), C = Yi(l), w = {
    a: H,
    A: q,
    b: D,
    B: $,
    c: null,
    d: a7,
    e: a7,
    f: zW,
    g: nq,
    G: oq,
    H: HW,
    I: VW,
    j: UW,
    L: kx,
    m: YW,
    M: GW,
    p: U,
    q: B,
    Q: c7,
    s: u7,
    S: KW,
    u: ZW,
    U: XW,
    V: QW,
    w: JW,
    W: eq,
    x: null,
    X: null,
    y: tq,
    Y: rq,
    Z: iq,
    "%": l7
  }, _ = {
    a: K,
    A: X,
    b: Z,
    B: G,
    c: null,
    d: s7,
    e: s7,
    f: cq,
    g: yq,
    G: wq,
    H: aq,
    I: sq,
    j: lq,
    L: Mx,
    m: uq,
    M: dq,
    p: V,
    q: Y,
    Q: c7,
    s: u7,
    S: fq,
    u: hq,
    U: mq,
    V: pq,
    w: gq,
    W: vq,
    x: null,
    X: null,
    y: bq,
    Y: Cq,
    Z: xq,
    "%": l7
  }, x = {
    a: R,
    A: M,
    b: A,
    B: O,
    c: I,
    d: o7,
    e: o7,
    f: FW,
    g: r7,
    G: n7,
    H: i7,
    I: i7,
    j: DW,
    L: $W,
    m: NW,
    M: IW,
    p: L,
    q: OW,
    Q: qW,
    s: jW,
    S: BW,
    u: LW,
    U: TW,
    V: PW,
    w: EW,
    W: RW,
    x: W,
    X: N,
    y: r7,
    Y: n7,
    Z: AW,
    "%": WW
  };
  w.x = k(n, w), w.X = k(r, w), w.c = k(t, w), _.x = k(n, _), _.X = k(r, _), _.c = k(t, _);
  function k(P, F) {
    return function(z) {
      var E = [], re = -1, ee = 0, oe = P.length, ue, le, Ae;
      for (z instanceof Date || (z = /* @__PURE__ */ new Date(+z)); ++re < oe; )
        P.charCodeAt(re) === 37 && (E.push(P.slice(ee, re)), (le = t7[ue = P.charAt(++re)]) != null ? ue = P.charAt(++re) : le = ue === "e" ? " " : "0", (Ae = F[ue]) && (ue = Ae(z, le)), E.push(ue), ee = re + 1);
      return E.push(P.slice(ee, re)), E.join("");
    };
  }
  function S(P, F) {
    return function(z) {
      var E = Ui(1900, void 0, 1), re = T(E, P, z += "", 0), ee, oe;
      if (re != z.length) return null;
      if ("Q" in E) return new Date(E.Q);
      if ("s" in E) return new Date(E.s * 1e3 + ("L" in E ? E.L : 0));
      if (F && !("Z" in E) && (E.Z = 0), "p" in E && (E.H = E.H % 12 + E.p * 12), E.m === void 0 && (E.m = "q" in E ? E.q : 0), "V" in E) {
        if (E.V < 1 || E.V > 53) return null;
        "w" in E || (E.w = 1), "Z" in E ? (ee = md(Ui(E.y, 0, 1)), oe = ee.getUTCDay(), ee = oe > 4 || oe === 0 ? p0.ceil(ee) : p0(ee), ee = Hl.offset(ee, (E.V - 1) * 7), E.y = ee.getUTCFullYear(), E.m = ee.getUTCMonth(), E.d = ee.getUTCDate() + (E.w + 6) % 7) : (ee = hd(Ui(E.y, 0, 1)), oe = ee.getDay(), ee = oe > 4 || oe === 0 ? m0.ceil(ee) : m0(ee), ee = ms.offset(ee, (E.V - 1) * 7), E.y = ee.getFullYear(), E.m = ee.getMonth(), E.d = ee.getDate() + (E.w + 6) % 7);
      } else ("W" in E || "U" in E) && ("w" in E || (E.w = "u" in E ? E.u % 7 : "W" in E ? 1 : 0), oe = "Z" in E ? md(Ui(E.y, 0, 1)).getUTCDay() : hd(Ui(E.y, 0, 1)).getDay(), E.m = 0, E.d = "W" in E ? (E.w + 6) % 7 + E.W * 7 - (oe + 5) % 7 : E.w + E.U * 7 - (oe + 6) % 7);
      return "Z" in E ? (E.H += E.Z / 100 | 0, E.M += E.Z % 100, md(E)) : hd(E);
    };
  }
  function T(P, F, z, E) {
    for (var re = 0, ee = F.length, oe = z.length, ue, le; re < ee; ) {
      if (E >= oe) return -1;
      if (ue = F.charCodeAt(re++), ue === 37) {
        if (ue = F.charAt(re++), le = x[ue in t7 ? F.charAt(re++) : ue], !le || (E = le(P, z, E)) < 0) return -1;
      } else if (ue != z.charCodeAt(E++))
        return -1;
    }
    return E;
  }
  function L(P, F, z) {
    var E = c.exec(F.slice(z));
    return E ? (P.p = f.get(E[0].toLowerCase()), z + E[0].length) : -1;
  }
  function R(P, F, z) {
    var E = m.exec(F.slice(z));
    return E ? (P.w = g.get(E[0].toLowerCase()), z + E[0].length) : -1;
  }
  function M(P, F, z) {
    var E = u.exec(F.slice(z));
    return E ? (P.w = h.get(E[0].toLowerCase()), z + E[0].length) : -1;
  }
  function A(P, F, z) {
    var E = y.exec(F.slice(z));
    return E ? (P.m = C.get(E[0].toLowerCase()), z + E[0].length) : -1;
  }
  function O(P, F, z) {
    var E = p.exec(F.slice(z));
    return E ? (P.m = v.get(E[0].toLowerCase()), z + E[0].length) : -1;
  }
  function I(P, F, z) {
    return T(P, t, F, z);
  }
  function W(P, F, z) {
    return T(P, n, F, z);
  }
  function N(P, F, z) {
    return T(P, r, F, z);
  }
  function H(P) {
    return a[P.getDay()];
  }
  function q(P) {
    return i[P.getDay()];
  }
  function D(P) {
    return l[P.getMonth()];
  }
  function $(P) {
    return s[P.getMonth()];
  }
  function U(P) {
    return o[+(P.getHours() >= 12)];
  }
  function B(P) {
    return 1 + ~~(P.getMonth() / 3);
  }
  function K(P) {
    return a[P.getUTCDay()];
  }
  function X(P) {
    return i[P.getUTCDay()];
  }
  function Z(P) {
    return l[P.getUTCMonth()];
  }
  function G(P) {
    return s[P.getUTCMonth()];
  }
  function V(P) {
    return o[+(P.getUTCHours() >= 12)];
  }
  function Y(P) {
    return 1 + ~~(P.getUTCMonth() / 3);
  }
  return {
    format: function(P) {
      var F = k(P += "", w);
      return F.toString = function() {
        return P;
      }, F;
    },
    parse: function(P) {
      var F = S(P += "", !1);
      return F.toString = function() {
        return P;
      }, F;
    },
    utcFormat: function(P) {
      var F = k(P += "", _);
      return F.toString = function() {
        return P;
      }, F;
    },
    utcParse: function(P) {
      var F = S(P += "", !0);
      return F.toString = function() {
        return P;
      }, F;
    }
  };
}
var t7 = { "-": "", _: " ", 0: "0" }, Gt = /^\s*\d+/, kW = /^%/, SW = /[\\^$*+?|[\]().{}]/g;
function Ke(e, t, n) {
  var r = e < 0 ? "-" : "", o = (r ? -e : e) + "", i = o.length;
  return r + (i < n ? new Array(n - i + 1).join(t) + o : o);
}
function MW(e) {
  return e.replace(SW, "\\$&");
}
function zi(e) {
  return new RegExp("^(?:" + e.map(MW).join("|") + ")", "i");
}
function Yi(e) {
  return new Map(e.map((t, n) => [t.toLowerCase(), n]));
}
function EW(e, t, n) {
  var r = Gt.exec(t.slice(n, n + 1));
  return r ? (e.w = +r[0], n + r[0].length) : -1;
}
function LW(e, t, n) {
  var r = Gt.exec(t.slice(n, n + 1));
  return r ? (e.u = +r[0], n + r[0].length) : -1;
}
function TW(e, t, n) {
  var r = Gt.exec(t.slice(n, n + 2));
  return r ? (e.U = +r[0], n + r[0].length) : -1;
}
function PW(e, t, n) {
  var r = Gt.exec(t.slice(n, n + 2));
  return r ? (e.V = +r[0], n + r[0].length) : -1;
}
function RW(e, t, n) {
  var r = Gt.exec(t.slice(n, n + 2));
  return r ? (e.W = +r[0], n + r[0].length) : -1;
}
function n7(e, t, n) {
  var r = Gt.exec(t.slice(n, n + 4));
  return r ? (e.y = +r[0], n + r[0].length) : -1;
}
function r7(e, t, n) {
  var r = Gt.exec(t.slice(n, n + 2));
  return r ? (e.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}
function AW(e, t, n) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(n, n + 6));
  return r ? (e.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}
function OW(e, t, n) {
  var r = Gt.exec(t.slice(n, n + 1));
  return r ? (e.q = r[0] * 3 - 3, n + r[0].length) : -1;
}
function NW(e, t, n) {
  var r = Gt.exec(t.slice(n, n + 2));
  return r ? (e.m = r[0] - 1, n + r[0].length) : -1;
}
function o7(e, t, n) {
  var r = Gt.exec(t.slice(n, n + 2));
  return r ? (e.d = +r[0], n + r[0].length) : -1;
}
function DW(e, t, n) {
  var r = Gt.exec(t.slice(n, n + 3));
  return r ? (e.m = 0, e.d = +r[0], n + r[0].length) : -1;
}
function i7(e, t, n) {
  var r = Gt.exec(t.slice(n, n + 2));
  return r ? (e.H = +r[0], n + r[0].length) : -1;
}
function IW(e, t, n) {
  var r = Gt.exec(t.slice(n, n + 2));
  return r ? (e.M = +r[0], n + r[0].length) : -1;
}
function BW(e, t, n) {
  var r = Gt.exec(t.slice(n, n + 2));
  return r ? (e.S = +r[0], n + r[0].length) : -1;
}
function $W(e, t, n) {
  var r = Gt.exec(t.slice(n, n + 3));
  return r ? (e.L = +r[0], n + r[0].length) : -1;
}
function FW(e, t, n) {
  var r = Gt.exec(t.slice(n, n + 6));
  return r ? (e.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}
function WW(e, t, n) {
  var r = kW.exec(t.slice(n, n + 1));
  return r ? n + r[0].length : -1;
}
function qW(e, t, n) {
  var r = Gt.exec(t.slice(n));
  return r ? (e.Q = +r[0], n + r[0].length) : -1;
}
function jW(e, t, n) {
  var r = Gt.exec(t.slice(n));
  return r ? (e.s = +r[0], n + r[0].length) : -1;
}
function a7(e, t) {
  return Ke(e.getDate(), t, 2);
}
function HW(e, t) {
  return Ke(e.getHours(), t, 2);
}
function VW(e, t) {
  return Ke(e.getHours() % 12 || 12, t, 2);
}
function UW(e, t) {
  return Ke(1 + ms.count(wr(e), e), t, 3);
}
function kx(e, t) {
  return Ke(e.getMilliseconds(), t, 3);
}
function zW(e, t) {
  return kx(e, t) + "000";
}
function YW(e, t) {
  return Ke(e.getMonth() + 1, t, 2);
}
function GW(e, t) {
  return Ke(e.getMinutes(), t, 2);
}
function KW(e, t) {
  return Ke(e.getSeconds(), t, 2);
}
function ZW(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function XW(e, t) {
  return Ke(Vl.count(wr(e) - 1, e), t, 2);
}
function Sx(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? fi(e) : fi.ceil(e);
}
function QW(e, t) {
  return e = Sx(e), Ke(fi.count(wr(e), e) + (wr(e).getDay() === 4), t, 2);
}
function JW(e) {
  return e.getDay();
}
function eq(e, t) {
  return Ke(m0.count(wr(e) - 1, e), t, 2);
}
function tq(e, t) {
  return Ke(e.getFullYear() % 100, t, 2);
}
function nq(e, t) {
  return e = Sx(e), Ke(e.getFullYear() % 100, t, 2);
}
function rq(e, t) {
  return Ke(e.getFullYear() % 1e4, t, 4);
}
function oq(e, t) {
  var n = e.getDay();
  return e = n >= 4 || n === 0 ? fi(e) : fi.ceil(e), Ke(e.getFullYear() % 1e4, t, 4);
}
function iq(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + Ke(t / 60 | 0, "0", 2) + Ke(t % 60, "0", 2);
}
function s7(e, t) {
  return Ke(e.getUTCDate(), t, 2);
}
function aq(e, t) {
  return Ke(e.getUTCHours(), t, 2);
}
function sq(e, t) {
  return Ke(e.getUTCHours() % 12 || 12, t, 2);
}
function lq(e, t) {
  return Ke(1 + Hl.count(xr(e), e), t, 3);
}
function Mx(e, t) {
  return Ke(e.getUTCMilliseconds(), t, 3);
}
function cq(e, t) {
  return Mx(e, t) + "000";
}
function uq(e, t) {
  return Ke(e.getUTCMonth() + 1, t, 2);
}
function dq(e, t) {
  return Ke(e.getUTCMinutes(), t, 2);
}
function fq(e, t) {
  return Ke(e.getUTCSeconds(), t, 2);
}
function hq(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function mq(e, t) {
  return Ke(Ul.count(xr(e) - 1, e), t, 2);
}
function Ex(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? hi(e) : hi.ceil(e);
}
function pq(e, t) {
  return e = Ex(e), Ke(hi.count(xr(e), e) + (xr(e).getUTCDay() === 4), t, 2);
}
function gq(e) {
  return e.getUTCDay();
}
function vq(e, t) {
  return Ke(p0.count(xr(e) - 1, e), t, 2);
}
function bq(e, t) {
  return Ke(e.getUTCFullYear() % 100, t, 2);
}
function yq(e, t) {
  return e = Ex(e), Ke(e.getUTCFullYear() % 100, t, 2);
}
function Cq(e, t) {
  return Ke(e.getUTCFullYear() % 1e4, t, 4);
}
function wq(e, t) {
  var n = e.getUTCDay();
  return e = n >= 4 || n === 0 ? hi(e) : hi.ceil(e), Ke(e.getUTCFullYear() % 1e4, t, 4);
}
function xq() {
  return "+0000";
}
function l7() {
  return "%";
}
function c7(e) {
  return +e;
}
function u7(e) {
  return Math.floor(+e / 1e3);
}
var qo, Lx, Tx;
_q({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function _q(e) {
  return qo = _W(e), Lx = qo.format, qo.parse, Tx = qo.utcFormat, qo.utcParse, qo;
}
function kq(e) {
  return new Date(e);
}
function Sq(e) {
  return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function b4(e, t, n, r, o, i, a, s, l, c) {
  var f = mx(), u = f.invert, h = f.domain, m = c(".%L"), g = c(":%S"), p = c("%I:%M"), v = c("%I %p"), y = c("%a %d"), C = c("%b %d"), w = c("%B"), _ = c("%Y");
  function x(k) {
    return (l(k) < k ? m : s(k) < k ? g : a(k) < k ? p : i(k) < k ? v : r(k) < k ? o(k) < k ? y : C : n(k) < k ? w : _)(k);
  }
  return f.invert = function(k) {
    return new Date(u(k));
  }, f.domain = function(k) {
    return arguments.length ? h(Array.from(k, Sq)) : h().map(kq);
  }, f.ticks = function(k) {
    var S = h();
    return e(S[0], S[S.length - 1], k ?? 10);
  }, f.tickFormat = function(k, S) {
    return S == null ? x : c(S);
  }, f.nice = function(k) {
    var S = h();
    return (!k || typeof k.range != "function") && (k = t(S[0], S[S.length - 1], k ?? 10)), k ? h(yx(S, k)) : f;
  }, f.copy = function() {
    return jl(f, b4(e, t, n, r, o, i, a, s, l, c));
  }, f;
}
function Mq() {
  return Lo.apply(b4(wW, xW, wr, g4, Vl, ms, m4, f4, oo, Lx).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function Eq() {
  return Lo.apply(b4(yW, CW, xr, v4, Ul, Hl, p4, h4, oo, Tx).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function De(e) {
  for (var t = e.length / 6 | 0, n = new Array(t), r = 0; r < t; ) n[r] = "#" + e.slice(r * 6, ++r * 6);
  return n;
}
const Lq = De("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"), Tq = De("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666"), Pq = De("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666"), Rq = De("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928"), Aq = De("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2"), Oq = De("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc"), Nq = De("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999"), Dq = De("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3"), Px = De("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f"), Iq = De("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab"), vt = (e) => pF(e[e.length - 1]);
var zl = new Array(3).concat(
  "d8b365f5f5f55ab4ac",
  "a6611adfc27d80cdc1018571",
  "a6611adfc27df5f5f580cdc1018571",
  "8c510ad8b365f6e8c3c7eae55ab4ac01665e",
  "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e",
  "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e",
  "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e",
  "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30",
  "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30"
).map(De);
const Bq = vt(zl);
var Yl = new Array(3).concat(
  "af8dc3f7f7f77fbf7b",
  "7b3294c2a5cfa6dba0008837",
  "7b3294c2a5cff7f7f7a6dba0008837",
  "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837",
  "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837",
  "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837",
  "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837",
  "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b",
  "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b"
).map(De);
const $q = vt(Yl);
var Gl = new Array(3).concat(
  "e9a3c9f7f7f7a1d76a",
  "d01c8bf1b6dab8e1864dac26",
  "d01c8bf1b6daf7f7f7b8e1864dac26",
  "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221",
  "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221",
  "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221",
  "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221",
  "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419",
  "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419"
).map(De);
const Fq = vt(Gl);
var Kl = new Array(3).concat(
  "998ec3f7f7f7f1a340",
  "5e3c99b2abd2fdb863e66101",
  "5e3c99b2abd2f7f7f7fdb863e66101",
  "542788998ec3d8daebfee0b6f1a340b35806",
  "542788998ec3d8daebf7f7f7fee0b6f1a340b35806",
  "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806",
  "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806",
  "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08",
  "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08"
).map(De);
const Wq = vt(Kl);
var Zl = new Array(3).concat(
  "ef8a62f7f7f767a9cf",
  "ca0020f4a58292c5de0571b0",
  "ca0020f4a582f7f7f792c5de0571b0",
  "b2182bef8a62fddbc7d1e5f067a9cf2166ac",
  "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac",
  "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac",
  "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac",
  "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061",
  "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061"
).map(De);
const qq = vt(Zl);
var Xl = new Array(3).concat(
  "ef8a62ffffff999999",
  "ca0020f4a582bababa404040",
  "ca0020f4a582ffffffbababa404040",
  "b2182bef8a62fddbc7e0e0e09999994d4d4d",
  "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d",
  "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d",
  "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d",
  "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a",
  "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a"
).map(De);
const jq = vt(Xl);
var Ql = new Array(3).concat(
  "fc8d59ffffbf91bfdb",
  "d7191cfdae61abd9e92c7bb6",
  "d7191cfdae61ffffbfabd9e92c7bb6",
  "d73027fc8d59fee090e0f3f891bfdb4575b4",
  "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4",
  "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4",
  "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4",
  "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695",
  "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695"
).map(De);
const Hq = vt(Ql);
var Jl = new Array(3).concat(
  "fc8d59ffffbf91cf60",
  "d7191cfdae61a6d96a1a9641",
  "d7191cfdae61ffffbfa6d96a1a9641",
  "d73027fc8d59fee08bd9ef8b91cf601a9850",
  "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850",
  "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850",
  "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850",
  "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837",
  "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837"
).map(De);
const Vq = vt(Jl);
var ec = new Array(3).concat(
  "fc8d59ffffbf99d594",
  "d7191cfdae61abdda42b83ba",
  "d7191cfdae61ffffbfabdda42b83ba",
  "d53e4ffc8d59fee08be6f59899d5943288bd",
  "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd",
  "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd",
  "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd",
  "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2",
  "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2"
).map(De);
const Uq = vt(ec);
var tc = new Array(3).concat(
  "e5f5f999d8c92ca25f",
  "edf8fbb2e2e266c2a4238b45",
  "edf8fbb2e2e266c2a42ca25f006d2c",
  "edf8fbccece699d8c966c2a42ca25f006d2c",
  "edf8fbccece699d8c966c2a441ae76238b45005824",
  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824",
  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b"
).map(De);
const zq = vt(tc);
var nc = new Array(3).concat(
  "e0ecf49ebcda8856a7",
  "edf8fbb3cde38c96c688419d",
  "edf8fbb3cde38c96c68856a7810f7c",
  "edf8fbbfd3e69ebcda8c96c68856a7810f7c",
  "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b",
  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b",
  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b"
).map(De);
const Yq = vt(nc);
var rc = new Array(3).concat(
  "e0f3dba8ddb543a2ca",
  "f0f9e8bae4bc7bccc42b8cbe",
  "f0f9e8bae4bc7bccc443a2ca0868ac",
  "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac",
  "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e",
  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e",
  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081"
).map(De);
const Gq = vt(rc);
var oc = new Array(3).concat(
  "fee8c8fdbb84e34a33",
  "fef0d9fdcc8afc8d59d7301f",
  "fef0d9fdcc8afc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000"
).map(De);
const Kq = vt(oc);
var ic = new Array(3).concat(
  "ece2f0a6bddb1c9099",
  "f6eff7bdc9e167a9cf02818a",
  "f6eff7bdc9e167a9cf1c9099016c59",
  "f6eff7d0d1e6a6bddb67a9cf1c9099016c59",
  "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450",
  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450",
  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636"
).map(De);
const Zq = vt(ic);
var ac = new Array(3).concat(
  "ece7f2a6bddb2b8cbe",
  "f1eef6bdc9e174a9cf0570b0",
  "f1eef6bdc9e174a9cf2b8cbe045a8d",
  "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d",
  "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b",
  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b",
  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858"
).map(De);
const Xq = vt(ac);
var sc = new Array(3).concat(
  "e7e1efc994c7dd1c77",
  "f1eef6d7b5d8df65b0ce1256",
  "f1eef6d7b5d8df65b0dd1c77980043",
  "f1eef6d4b9dac994c7df65b0dd1c77980043",
  "f1eef6d4b9dac994c7df65b0e7298ace125691003f",
  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f",
  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f"
).map(De);
const Qq = vt(sc);
var lc = new Array(3).concat(
  "fde0ddfa9fb5c51b8a",
  "feebe2fbb4b9f768a1ae017e",
  "feebe2fbb4b9f768a1c51b8a7a0177",
  "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177",
  "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177",
  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177",
  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a"
).map(De);
const Jq = vt(lc);
var cc = new Array(3).concat(
  "edf8b17fcdbb2c7fb8",
  "ffffcca1dab441b6c4225ea8",
  "ffffcca1dab441b6c42c7fb8253494",
  "ffffccc7e9b47fcdbb41b6c42c7fb8253494",
  "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84",
  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84",
  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58"
).map(De);
const ej = vt(cc);
var uc = new Array(3).concat(
  "f7fcb9addd8e31a354",
  "ffffccc2e69978c679238443",
  "ffffccc2e69978c67931a354006837",
  "ffffccd9f0a3addd8e78c67931a354006837",
  "ffffccd9f0a3addd8e78c67941ab5d238443005a32",
  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32",
  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529"
).map(De);
const tj = vt(uc);
var dc = new Array(3).concat(
  "fff7bcfec44fd95f0e",
  "ffffd4fed98efe9929cc4c02",
  "ffffd4fed98efe9929d95f0e993404",
  "ffffd4fee391fec44ffe9929d95f0e993404",
  "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04",
  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04",
  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506"
).map(De);
const nj = vt(dc);
var fc = new Array(3).concat(
  "ffeda0feb24cf03b20",
  "ffffb2fecc5cfd8d3ce31a1c",
  "ffffb2fecc5cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026"
).map(De);
const rj = vt(fc);
var hc = new Array(3).concat(
  "deebf79ecae13182bd",
  "eff3ffbdd7e76baed62171b5",
  "eff3ffbdd7e76baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b"
).map(De);
const oj = vt(hc);
var mc = new Array(3).concat(
  "e5f5e0a1d99b31a354",
  "edf8e9bae4b374c476238b45",
  "edf8e9bae4b374c47631a354006d2c",
  "edf8e9c7e9c0a1d99b74c47631a354006d2c",
  "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32",
  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32",
  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b"
).map(De);
const ij = vt(mc);
var pc = new Array(3).concat(
  "f0f0f0bdbdbd636363",
  "f7f7f7cccccc969696525252",
  "f7f7f7cccccc969696636363252525",
  "f7f7f7d9d9d9bdbdbd969696636363252525",
  "f7f7f7d9d9d9bdbdbd969696737373525252252525",
  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525",
  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000"
).map(De);
const aj = vt(pc);
var gc = new Array(3).concat(
  "efedf5bcbddc756bb1",
  "f2f0f7cbc9e29e9ac86a51a3",
  "f2f0f7cbc9e29e9ac8756bb154278f",
  "f2f0f7dadaebbcbddc9e9ac8756bb154278f",
  "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486",
  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486",
  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d"
).map(De);
const sj = vt(gc);
var vc = new Array(3).concat(
  "fee0d2fc9272de2d26",
  "fee5d9fcae91fb6a4acb181d",
  "fee5d9fcae91fb6a4ade2d26a50f15",
  "fee5d9fcbba1fc9272fb6a4ade2d26a50f15",
  "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d",
  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d",
  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d"
).map(De);
const lj = vt(vc);
var bc = new Array(3).concat(
  "fee6cefdae6be6550d",
  "feeddefdbe85fd8d3cd94701",
  "feeddefdbe85fd8d3ce6550da63603",
  "feeddefdd0a2fdae6bfd8d3ce6550da63603",
  "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04",
  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04",
  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704"
).map(De);
const cj = vt(bc);
function uj(e) {
  return e = Math.max(0, Math.min(1, e)), "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - e * (35.34 - e * (2381.73 - e * (6402.7 - e * (7024.72 - e * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + e * (170.73 + e * (52.82 - e * (131.46 - e * (176.58 - e * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + e * (442.36 - e * (2482.43 - e * (6167.24 - e * (6614.94 - e * 2475.67))))))) + ")";
}
const dj = i4(Xn(300, 0.5, 0), Xn(-240, 0.5, 1));
var fj = i4(Xn(-100, 0.75, 0.35), Xn(80, 1.5, 0.8)), hj = i4(Xn(260, 0.75, 0.35), Xn(80, 1.5, 0.8)), Bs = Xn();
function mj(e) {
  (e < 0 || e > 1) && (e -= Math.floor(e));
  var t = Math.abs(e - 0.5);
  return Bs.h = 360 * e - 100, Bs.s = 1.5 - 1.5 * t, Bs.l = 0.8 - 0.9 * t, Bs + "";
}
var $s = ui(), pj = Math.PI / 3, gj = Math.PI * 2 / 3;
function vj(e) {
  var t;
  return e = (0.5 - e) * Math.PI, $s.r = 255 * (t = Math.sin(e)) * t, $s.g = 255 * (t = Math.sin(e + pj)) * t, $s.b = 255 * (t = Math.sin(e + gj)) * t, $s + "";
}
function bj(e) {
  return e = Math.max(0, Math.min(1, e)), "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + e * (1172.33 - e * (10793.56 - e * (33300.12 - e * (38394.49 - e * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + e * (557.33 + e * (1225.33 - e * (3574.96 - e * (1073.77 + e * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + e * (3211.1 - e * (15327.97 - e * (27814 - e * (22569.18 - e * 6838.66))))))) + ")";
}
function yc(e) {
  var t = e.length;
  return function(n) {
    return e[Math.max(0, Math.min(t - 1, Math.floor(n * t)))];
  };
}
const yj = yc(De("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var Cj = yc(De("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf")), wj = yc(De("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4")), xj = yc(De("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921")), _j = Ll();
const y4 = /* @__PURE__ */ Ht(_j);
var pd, d7;
function kj() {
  if (d7) return pd;
  d7 = 1;
  var e = "__lodash_hash_undefined__";
  function t(n) {
    return this.__data__.set(n, e), this;
  }
  return pd = t, pd;
}
var gd, f7;
function Sj() {
  if (f7) return gd;
  f7 = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return gd = e, gd;
}
var vd, h7;
function C4() {
  if (h7) return vd;
  h7 = 1;
  var e = Vh(), t = kj(), n = Sj();
  function r(o) {
    var i = -1, a = o == null ? 0 : o.length;
    for (this.__data__ = new e(); ++i < a; )
      this.add(o[i]);
  }
  return r.prototype.add = r.prototype.push = t, r.prototype.has = n, vd = r, vd;
}
var bd, m7;
function Mj() {
  if (m7) return bd;
  m7 = 1;
  function e(t, n, r, o) {
    for (var i = t.length, a = r + (o ? 1 : -1); o ? a-- : ++a < i; )
      if (n(t[a], a, t))
        return a;
    return -1;
  }
  return bd = e, bd;
}
var yd, p7;
function Ej() {
  if (p7) return yd;
  p7 = 1;
  function e(t) {
    return t !== t;
  }
  return yd = e, yd;
}
var Cd, g7;
function Lj() {
  if (g7) return Cd;
  g7 = 1;
  function e(t, n, r) {
    for (var o = r - 1, i = t.length; ++o < i; )
      if (t[o] === n)
        return o;
    return -1;
  }
  return Cd = e, Cd;
}
var wd, v7;
function Tj() {
  if (v7) return wd;
  v7 = 1;
  var e = Mj(), t = Ej(), n = Lj();
  function r(o, i, a) {
    return i === i ? n(o, i, a) : e(o, t, a);
  }
  return wd = r, wd;
}
var xd, b7;
function Rx() {
  if (b7) return xd;
  b7 = 1;
  var e = Tj();
  function t(n, r) {
    var o = n == null ? 0 : n.length;
    return !!o && e(n, r, 0) > -1;
  }
  return xd = t, xd;
}
var _d, y7;
function Ax() {
  if (y7) return _d;
  y7 = 1;
  function e(t, n, r) {
    for (var o = -1, i = t == null ? 0 : t.length; ++o < i; )
      if (r(n, t[o]))
        return !0;
    return !1;
  }
  return _d = e, _d;
}
var kd, C7;
function w4() {
  if (C7) return kd;
  C7 = 1;
  function e(t, n) {
    return t.has(n);
  }
  return kd = e, kd;
}
var Sd, w7;
function Pj() {
  if (w7) return Sd;
  w7 = 1;
  var e = C4(), t = Rx(), n = Ax(), r = $l(), o = Ri(), i = w4(), a = 200;
  function s(l, c, f, u) {
    var h = -1, m = t, g = !0, p = l.length, v = [], y = c.length;
    if (!p)
      return v;
    f && (c = r(c, o(f))), u ? (m = n, g = !1) : c.length >= a && (m = i, g = !1, c = new e(c));
    e:
      for (; ++h < p; ) {
        var C = l[h], w = f == null ? C : f(C);
        if (C = u || C !== 0 ? C : 0, g && w === w) {
          for (var _ = y; _--; )
            if (c[_] === w)
              continue e;
          v.push(C);
        } else m(c, w, u) || v.push(C);
      }
    return v;
  }
  return Sd = s, Sd;
}
var Md, x7;
function Rj() {
  if (x7) return Md;
  x7 = 1;
  var e = Pj(), t = Jh(), n = Xw(), r = t(function(o, i) {
    return n(o) ? e(o, i) : [];
  });
  return Md = r, Md;
}
var Aj = Rj();
const Ox = /* @__PURE__ */ Ht(Aj);
function Et(e) {
  return function() {
    return e;
  };
}
const _7 = 1e-12, c9 = Math.PI, u9 = 2 * c9, Qr = 1e-6, Oj = u9 - Qr;
function Nx(e) {
  this._ += e[0];
  for (let t = 1, n = e.length; t < n; ++t)
    this._ += arguments[t] + e[t];
}
function Nj(e) {
  let t = Math.floor(e);
  if (!(t >= 0)) throw new Error(`invalid digits: ${e}`);
  if (t > 15) return Nx;
  const n = 10 ** t;
  return function(r) {
    this._ += r[0];
    for (let o = 1, i = r.length; o < i; ++o)
      this._ += Math.round(arguments[o] * n) / n + r[o];
  };
}
let Dj = class {
  constructor(t) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = t == null ? Nx : Nj(t);
  }
  moveTo(t, n) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(t, n) {
    this._append`L${this._x1 = +t},${this._y1 = +n}`;
  }
  quadraticCurveTo(t, n, r, o) {
    this._append`Q${+t},${+n},${this._x1 = +r},${this._y1 = +o}`;
  }
  bezierCurveTo(t, n, r, o, i, a) {
    this._append`C${+t},${+n},${+r},${+o},${this._x1 = +i},${this._y1 = +a}`;
  }
  arcTo(t, n, r, o, i) {
    if (t = +t, n = +n, r = +r, o = +o, i = +i, i < 0) throw new Error(`negative radius: ${i}`);
    let a = this._x1, s = this._y1, l = r - t, c = o - n, f = a - t, u = s - n, h = f * f + u * u;
    if (this._x1 === null)
      this._append`M${this._x1 = t},${this._y1 = n}`;
    else if (h > Qr) if (!(Math.abs(u * l - c * f) > Qr) || !i)
      this._append`L${this._x1 = t},${this._y1 = n}`;
    else {
      let m = r - a, g = o - s, p = l * l + c * c, v = m * m + g * g, y = Math.sqrt(p), C = Math.sqrt(h), w = i * Math.tan((c9 - Math.acos((p + h - v) / (2 * y * C))) / 2), _ = w / C, x = w / y;
      Math.abs(_ - 1) > Qr && this._append`L${t + _ * f},${n + _ * u}`, this._append`A${i},${i},0,0,${+(u * m > f * g)},${this._x1 = t + x * l},${this._y1 = n + x * c}`;
    }
  }
  arc(t, n, r, o, i, a) {
    if (t = +t, n = +n, r = +r, a = !!a, r < 0) throw new Error(`negative radius: ${r}`);
    let s = r * Math.cos(o), l = r * Math.sin(o), c = t + s, f = n + l, u = 1 ^ a, h = a ? o - i : i - o;
    this._x1 === null ? this._append`M${c},${f}` : (Math.abs(this._x1 - c) > Qr || Math.abs(this._y1 - f) > Qr) && this._append`L${c},${f}`, r && (h < 0 && (h = h % u9 + u9), h > Oj ? this._append`A${r},${r},0,1,${u},${t - s},${n - l}A${r},${r},0,1,${u},${this._x1 = c},${this._y1 = f}` : h > Qr && this._append`A${r},${r},0,${+(h >= c9)},${u},${this._x1 = t + r * Math.cos(i)},${this._y1 = n + r * Math.sin(i)}`);
  }
  rect(t, n, r, o) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}h${r = +r}v${+o}h${-r}Z`;
  }
  toString() {
    return this._;
  }
};
function Dx(e) {
  let t = 3;
  return e.digits = function(n) {
    if (!arguments.length) return t;
    if (n == null)
      t = null;
    else {
      const r = Math.floor(n);
      if (!(r >= 0)) throw new RangeError(`invalid digits: ${n}`);
      t = r;
    }
    return e;
  }, () => new Dj(t);
}
function x4(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function Ix(e) {
  this._context = e;
}
Ix.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function _4(e) {
  return new Ix(e);
}
function Bx(e) {
  return e[0];
}
function $x(e) {
  return e[1];
}
function Fx(e, t) {
  var n = Et(!0), r = null, o = _4, i = null, a = Dx(s);
  e = typeof e == "function" ? e : e === void 0 ? Bx : Et(e), t = typeof t == "function" ? t : t === void 0 ? $x : Et(t);
  function s(l) {
    var c, f = (l = x4(l)).length, u, h = !1, m;
    for (r == null && (i = o(m = a())), c = 0; c <= f; ++c)
      !(c < f && n(u = l[c], c, l)) === h && ((h = !h) ? i.lineStart() : i.lineEnd()), h && i.point(+e(u, c, l), +t(u, c, l));
    if (m) return i = null, m + "" || null;
  }
  return s.x = function(l) {
    return arguments.length ? (e = typeof l == "function" ? l : Et(+l), s) : e;
  }, s.y = function(l) {
    return arguments.length ? (t = typeof l == "function" ? l : Et(+l), s) : t;
  }, s.defined = function(l) {
    return arguments.length ? (n = typeof l == "function" ? l : Et(!!l), s) : n;
  }, s.curve = function(l) {
    return arguments.length ? (o = l, r != null && (i = o(r)), s) : o;
  }, s.context = function(l) {
    return arguments.length ? (l == null ? r = i = null : i = o(r = l), s) : r;
  }, s;
}
function Ij(e, t, n) {
  var r = null, o = Et(!0), i = null, a = _4, s = null, l = Dx(c);
  e = typeof e == "function" ? e : e === void 0 ? Bx : Et(+e), t = typeof t == "function" ? t : Et(t === void 0 ? 0 : +t), n = typeof n == "function" ? n : n === void 0 ? $x : Et(+n);
  function c(u) {
    var h, m, g, p = (u = x4(u)).length, v, y = !1, C, w = new Array(p), _ = new Array(p);
    for (i == null && (s = a(C = l())), h = 0; h <= p; ++h) {
      if (!(h < p && o(v = u[h], h, u)) === y)
        if (y = !y)
          m = h, s.areaStart(), s.lineStart();
        else {
          for (s.lineEnd(), s.lineStart(), g = h - 1; g >= m; --g)
            s.point(w[g], _[g]);
          s.lineEnd(), s.areaEnd();
        }
      y && (w[h] = +e(v, h, u), _[h] = +t(v, h, u), s.point(r ? +r(v, h, u) : w[h], n ? +n(v, h, u) : _[h]));
    }
    if (C) return s = null, C + "" || null;
  }
  function f() {
    return Fx().defined(o).curve(a).context(i);
  }
  return c.x = function(u) {
    return arguments.length ? (e = typeof u == "function" ? u : Et(+u), r = null, c) : e;
  }, c.x0 = function(u) {
    return arguments.length ? (e = typeof u == "function" ? u : Et(+u), c) : e;
  }, c.x1 = function(u) {
    return arguments.length ? (r = u == null ? null : typeof u == "function" ? u : Et(+u), c) : r;
  }, c.y = function(u) {
    return arguments.length ? (t = typeof u == "function" ? u : Et(+u), n = null, c) : t;
  }, c.y0 = function(u) {
    return arguments.length ? (t = typeof u == "function" ? u : Et(+u), c) : t;
  }, c.y1 = function(u) {
    return arguments.length ? (n = u == null ? null : typeof u == "function" ? u : Et(+u), c) : n;
  }, c.lineX0 = c.lineY0 = function() {
    return f().x(e).y(t);
  }, c.lineY1 = function() {
    return f().x(e).y(n);
  }, c.lineX1 = function() {
    return f().x(r).y(t);
  }, c.defined = function(u) {
    return arguments.length ? (o = typeof u == "function" ? u : Et(!!u), c) : o;
  }, c.curve = function(u) {
    return arguments.length ? (a = u, i != null && (s = a(i)), c) : a;
  }, c.context = function(u) {
    return arguments.length ? (u == null ? i = s = null : s = a(i = u), c) : i;
  }, c;
}
function Hr() {
}
function g0(e, t, n) {
  e._context.bezierCurveTo(
    (2 * e._x0 + e._x1) / 3,
    (2 * e._y0 + e._y1) / 3,
    (e._x0 + 2 * e._x1) / 3,
    (e._y0 + 2 * e._y1) / 3,
    (e._x0 + 4 * e._x1 + t) / 6,
    (e._y0 + 4 * e._y1 + n) / 6
  );
}
function Cc(e) {
  this._context = e;
}
Cc.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        g0(this, this._x1, this._y1);
      // falls through
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      // falls through
      default:
        g0(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function Bj(e) {
  return new Cc(e);
}
function Wx(e) {
  this._context = e;
}
Wx.prototype = {
  areaStart: Hr,
  areaEnd: Hr,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x2 = e, this._y2 = t;
        break;
      case 1:
        this._point = 2, this._x3 = e, this._y3 = t;
        break;
      case 2:
        this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
        break;
      default:
        g0(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function $j(e) {
  return new Wx(e);
}
function qx(e) {
  this._context = e;
}
qx.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var n = (this._x0 + 4 * this._x1 + e) / 6, r = (this._y0 + 4 * this._y1 + t) / 6;
        this._line ? this._context.lineTo(n, r) : this._context.moveTo(n, r);
        break;
      case 3:
        this._point = 4;
      // falls through
      default:
        g0(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function Fj(e) {
  return new qx(e);
}
function jx(e, t) {
  this._basis = new Cc(e), this._beta = t;
}
jx.prototype = {
  lineStart: function() {
    this._x = [], this._y = [], this._basis.lineStart();
  },
  lineEnd: function() {
    var e = this._x, t = this._y, n = e.length - 1;
    if (n > 0)
      for (var r = e[0], o = t[0], i = e[n] - r, a = t[n] - o, s = -1, l; ++s <= n; )
        l = s / n, this._basis.point(
          this._beta * e[s] + (1 - this._beta) * (r + l * i),
          this._beta * t[s] + (1 - this._beta) * (o + l * a)
        );
    this._x = this._y = null, this._basis.lineEnd();
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
const Wj = function e(t) {
  function n(r) {
    return t === 1 ? new Cc(r) : new jx(r, t);
  }
  return n.beta = function(r) {
    return e(+r);
  }, n;
}(0.85);
function v0(e, t, n) {
  e._context.bezierCurveTo(
    e._x1 + e._k * (e._x2 - e._x0),
    e._y1 + e._k * (e._y2 - e._y0),
    e._x2 + e._k * (e._x1 - t),
    e._y2 + e._k * (e._y1 - n),
    e._x2,
    e._y2
  );
}
function k4(e, t) {
  this._context = e, this._k = (1 - t) / 6;
}
k4.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        v0(this, this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2, this._x1 = e, this._y1 = t;
        break;
      case 2:
        this._point = 3;
      // falls through
      default:
        v0(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const qj = function e(t) {
  function n(r) {
    return new k4(r, t);
  }
  return n.tension = function(r) {
    return e(+r);
  }, n;
}(0);
function S4(e, t) {
  this._context = e, this._k = (1 - t) / 6;
}
S4.prototype = {
  areaStart: Hr,
  areaEnd: Hr,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x3 = e, this._y3 = t;
        break;
      case 1:
        this._point = 2, this._context.moveTo(this._x4 = e, this._y4 = t);
        break;
      case 2:
        this._point = 3, this._x5 = e, this._y5 = t;
        break;
      default:
        v0(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const jj = function e(t) {
  function n(r) {
    return new S4(r, t);
  }
  return n.tension = function(r) {
    return e(+r);
  }, n;
}(0);
function M4(e, t) {
  this._context = e, this._k = (1 - t) / 6;
}
M4.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      // falls through
      default:
        v0(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const Hj = function e(t) {
  function n(r) {
    return new M4(r, t);
  }
  return n.tension = function(r) {
    return e(+r);
  }, n;
}(0);
function E4(e, t, n) {
  var r = e._x1, o = e._y1, i = e._x2, a = e._y2;
  if (e._l01_a > _7) {
    var s = 2 * e._l01_2a + 3 * e._l01_a * e._l12_a + e._l12_2a, l = 3 * e._l01_a * (e._l01_a + e._l12_a);
    r = (r * s - e._x0 * e._l12_2a + e._x2 * e._l01_2a) / l, o = (o * s - e._y0 * e._l12_2a + e._y2 * e._l01_2a) / l;
  }
  if (e._l23_a > _7) {
    var c = 2 * e._l23_2a + 3 * e._l23_a * e._l12_a + e._l12_2a, f = 3 * e._l23_a * (e._l23_a + e._l12_a);
    i = (i * c + e._x1 * e._l23_2a - t * e._l12_2a) / f, a = (a * c + e._y1 * e._l23_2a - n * e._l12_2a) / f;
  }
  e._context.bezierCurveTo(r, o, i, a, e._x2, e._y2);
}
function Hx(e, t) {
  this._context = e, this._alpha = t;
}
Hx.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        this.point(this._x2, this._y2);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    if (e = +e, t = +t, this._point) {
      var n = this._x2 - e, r = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
      // falls through
      default:
        E4(this, e, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const Vj = function e(t) {
  function n(r) {
    return t ? new Hx(r, t) : new k4(r, 0);
  }
  return n.alpha = function(r) {
    return e(+r);
  }, n;
}(0.5);
function Vx(e, t) {
  this._context = e, this._alpha = t;
}
Vx.prototype = {
  areaStart: Hr,
  areaEnd: Hr,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(e, t) {
    if (e = +e, t = +t, this._point) {
      var n = this._x2 - e, r = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._x3 = e, this._y3 = t;
        break;
      case 1:
        this._point = 2, this._context.moveTo(this._x4 = e, this._y4 = t);
        break;
      case 2:
        this._point = 3, this._x5 = e, this._y5 = t;
        break;
      default:
        E4(this, e, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const Uj = function e(t) {
  function n(r) {
    return t ? new Vx(r, t) : new S4(r, 0);
  }
  return n.alpha = function(r) {
    return e(+r);
  }, n;
}(0.5);
function Ux(e, t) {
  this._context = e, this._alpha = t;
}
Ux.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    if (e = +e, t = +t, this._point) {
      var n = this._x2 - e, r = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      // falls through
      default:
        E4(this, e, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const zj = function e(t) {
  function n(r) {
    return t ? new Ux(r, t) : new M4(r, 0);
  }
  return n.alpha = function(r) {
    return e(+r);
  }, n;
}(0.5);
function zx(e) {
  this._context = e;
}
zx.prototype = {
  areaStart: Hr,
  areaEnd: Hr,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(e, t) {
    e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
  }
};
function Yj(e) {
  return new zx(e);
}
function k7(e) {
  return e < 0 ? -1 : 1;
}
function S7(e, t, n) {
  var r = e._x1 - e._x0, o = t - e._x1, i = (e._y1 - e._y0) / (r || o < 0 && -0), a = (n - e._y1) / (o || r < 0 && -0), s = (i * o + a * r) / (r + o);
  return (k7(i) + k7(a)) * Math.min(Math.abs(i), Math.abs(a), 0.5 * Math.abs(s)) || 0;
}
function M7(e, t) {
  var n = e._x1 - e._x0;
  return n ? (3 * (e._y1 - e._y0) / n - t) / 2 : t;
}
function Ed(e, t, n) {
  var r = e._x0, o = e._y0, i = e._x1, a = e._y1, s = (i - r) / 3;
  e._context.bezierCurveTo(r + s, o + s * t, i - s, a - s * n, i, a);
}
function b0(e) {
  this._context = e;
}
b0.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        Ed(this, this._t0, M7(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    var n = NaN;
    if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, Ed(this, M7(this, n = S7(this, e, t)), n);
          break;
        default:
          Ed(this, this._t0, n = S7(this, e, t));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = n;
    }
  }
};
function Yx(e) {
  this._context = new Gx(e);
}
(Yx.prototype = Object.create(b0.prototype)).point = function(e, t) {
  b0.prototype.point.call(this, t, e);
};
function Gx(e) {
  this._context = e;
}
Gx.prototype = {
  moveTo: function(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function(e, t, n, r, o, i) {
    this._context.bezierCurveTo(t, e, r, n, i, o);
  }
};
function Gj(e) {
  return new b0(e);
}
function Kj(e) {
  return new Yx(e);
}
function Kx(e) {
  this._context = e;
}
Kx.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, t = this._y, n = e.length;
    if (n)
      if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), n === 2)
        this._context.lineTo(e[1], t[1]);
      else
        for (var r = E7(e), o = E7(t), i = 0, a = 1; a < n; ++i, ++a)
          this._context.bezierCurveTo(r[0][i], o[0][i], r[1][i], o[1][i], e[a], t[a]);
    (this._line || this._line !== 0 && n === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
function E7(e) {
  var t, n = e.length - 1, r, o = new Array(n), i = new Array(n), a = new Array(n);
  for (o[0] = 0, i[0] = 2, a[0] = e[0] + 2 * e[1], t = 1; t < n - 1; ++t) o[t] = 1, i[t] = 4, a[t] = 4 * e[t] + 2 * e[t + 1];
  for (o[n - 1] = 2, i[n - 1] = 7, a[n - 1] = 8 * e[n - 1] + e[n], t = 1; t < n; ++t) r = o[t] / i[t - 1], i[t] -= r, a[t] -= r * a[t - 1];
  for (o[n - 1] = a[n - 1] / i[n - 1], t = n - 2; t >= 0; --t) o[t] = (a[t] - o[t + 1]) / i[t];
  for (i[n - 1] = (e[n] + o[n - 1]) / 2, t = 0; t < n - 1; ++t) i[t] = 2 * e[t + 1] - o[t + 1];
  return [o, i];
}
function Zj(e) {
  return new Kx(e);
}
function wc(e, t) {
  this._context = e, this._t = t;
}
wc.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(e, t);
        else {
          var n = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(n, this._y), this._context.lineTo(n, t);
        }
        break;
      }
    }
    this._x = e, this._y = t;
  }
};
function Xj(e) {
  return new wc(e, 0.5);
}
function Qj(e) {
  return new wc(e, 0);
}
function Jj(e) {
  return new wc(e, 1);
}
function L7(e, t) {
  if ((a = e.length) > 1)
    for (var n = 1, r, o, i = e[t[0]], a, s = i.length; n < a; ++n)
      for (o = i, i = e[t[n]], r = 0; r < s; ++r)
        i[r][1] += i[r][0] = isNaN(o[r][1]) ? o[r][0] : o[r][1];
}
function T7(e) {
  for (var t = e.length, n = new Array(t); --t >= 0; ) n[t] = t;
  return n;
}
function eH(e, t) {
  return e[t];
}
function tH(e) {
  const t = [];
  return t.key = e, t;
}
function nH() {
  var e = Et([]), t = T7, n = L7, r = eH;
  function o(i) {
    var a = Array.from(e.apply(this, arguments), tH), s, l = a.length, c = -1, f;
    for (const u of i)
      for (s = 0, ++c; s < l; ++s)
        (a[s][c] = [0, +r(u, a[s].key, c, i)]).data = u;
    for (s = 0, f = x4(t(a)); s < l; ++s)
      a[f[s]].index = s;
    return n(a, f), a;
  }
  return o.keys = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : Et(Array.from(i)), o) : e;
  }, o.value = function(i) {
    return arguments.length ? (r = typeof i == "function" ? i : Et(+i), o) : r;
  }, o.order = function(i) {
    return arguments.length ? (t = i == null ? T7 : typeof i == "function" ? i : Et(Array.from(i)), o) : t;
  }, o.offset = function(i) {
    return arguments.length ? (n = i ?? L7, o) : n;
  }, o;
}
function rH(e, t) {
  if ((l = e.length) > 0)
    for (var n, r = 0, o, i, a, s, l, c = e[t[0]].length; r < c; ++r)
      for (a = s = 0, n = 0; n < l; ++n)
        (i = (o = e[t[n]][r])[1] - o[0]) > 0 ? (o[0] = a, o[1] = a += i) : i < 0 ? (o[1] = s, o[0] = s += i) : (o[0] = 0, o[1] = i);
}
function oH(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function y0(e, t) {
  if ((n = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0) return null;
  var n, r = e.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +e.slice(n + 1)
  ];
}
function iH(e) {
  return e = y0(Math.abs(e)), e ? e[1] : NaN;
}
function aH(e, t) {
  return function(n, r) {
    for (var o = n.length, i = [], a = 0, s = e[0], l = 0; o > 0 && s > 0 && (l + s + 1 > r && (s = Math.max(1, r - l)), i.push(n.substring(o -= s, o + s)), !((l += s + 1) > r)); )
      s = e[a = (a + 1) % e.length];
    return i.reverse().join(t);
  };
}
function sH(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(n) {
      return e[+n];
    });
  };
}
var lH = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function d9(e) {
  if (!(t = lH.exec(e))) throw new Error("invalid format: " + e);
  var t;
  return new L4({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
d9.prototype = L4.prototype;
function L4(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
L4.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function cH(e) {
  e: for (var t = e.length, n = 1, r = -1, o; n < t; ++n)
    switch (e[n]) {
      case ".":
        r = o = n;
        break;
      case "0":
        r === 0 && (r = n), o = n;
        break;
      default:
        if (!+e[n]) break e;
        r > 0 && (r = 0);
        break;
    }
  return r > 0 ? e.slice(0, r) + e.slice(o + 1) : e;
}
var Zx;
function uH(e, t) {
  var n = y0(e, t);
  if (!n) return e + "";
  var r = n[0], o = n[1], i = o - (Zx = Math.max(-8, Math.min(8, Math.floor(o / 3))) * 3) + 1, a = r.length;
  return i === a ? r : i > a ? r + new Array(i - a + 1).join("0") : i > 0 ? r.slice(0, i) + "." + r.slice(i) : "0." + new Array(1 - i).join("0") + y0(e, Math.max(0, t + i - 1))[0];
}
function P7(e, t) {
  var n = y0(e, t);
  if (!n) return e + "";
  var r = n[0], o = n[1];
  return o < 0 ? "0." + new Array(-o).join("0") + r : r.length > o + 1 ? r.slice(0, o + 1) + "." + r.slice(o + 1) : r + new Array(o - r.length + 2).join("0");
}
const R7 = {
  "%": function(e, t) {
    return (e * 100).toFixed(t);
  },
  b: function(e) {
    return Math.round(e).toString(2);
  },
  c: function(e) {
    return e + "";
  },
  d: oH,
  e: function(e, t) {
    return e.toExponential(t);
  },
  f: function(e, t) {
    return e.toFixed(t);
  },
  g: function(e, t) {
    return e.toPrecision(t);
  },
  o: function(e) {
    return Math.round(e).toString(8);
  },
  p: function(e, t) {
    return P7(e * 100, t);
  },
  r: P7,
  s: uH,
  X: function(e) {
    return Math.round(e).toString(16).toUpperCase();
  },
  x: function(e) {
    return Math.round(e).toString(16);
  }
};
function A7(e) {
  return e;
}
var O7 = Array.prototype.map, N7 = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function dH(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? A7 : aH(O7.call(e.grouping, Number), e.thousands + ""), n = e.currency === void 0 ? "" : e.currency[0] + "", r = e.currency === void 0 ? "" : e.currency[1] + "", o = e.decimal + "", i = e.numerals === void 0 ? A7 : sH(O7.call(e.numerals, String)), a = e.percent === void 0 ? "%" : e.percent + "", s = e.minus + "", l = e.nan === void 0 ? "NaN" : e.nan + "";
  function c(u) {
    u = d9(u);
    var h = u.fill, m = u.align, g = u.sign, p = u.symbol, v = u.zero, y = u.width, C = u.comma, w = u.precision, _ = u.trim, x = u.type;
    x === "n" ? (C = !0, x = "g") : R7[x] || (w === void 0 && (w = 12), _ = !0, x = "g"), (v || h === "0" && m === "=") && (v = !0, h = "0", m = "=");
    var k = p === "$" ? n : p === "#" && /[boxX]/.test(x) ? "0" + x.toLowerCase() : "", S = p === "$" ? r : /[%p]/.test(x) ? a : "", T = R7[x], L = /[defgprs%]/.test(x);
    w = w === void 0 ? 6 : /[gprs]/.test(x) ? Math.max(1, Math.min(21, w)) : Math.max(0, Math.min(20, w));
    function R(M) {
      var A = k, O = S, I, W, N;
      if (x === "c")
        O = T(M) + O, M = "";
      else {
        M = +M;
        var H = M < 0 || 1 / M < 0;
        if (M = isNaN(M) ? l : T(Math.abs(M), w), _ && (M = cH(M)), H && +M == 0 && g !== "+" && (H = !1), A = (H ? g === "(" ? g : s : g === "-" || g === "(" ? "" : g) + A, O = (x === "s" ? N7[8 + Zx / 3] : "") + O + (H && g === "(" ? ")" : ""), L) {
          for (I = -1, W = M.length; ++I < W; )
            if (N = M.charCodeAt(I), 48 > N || N > 57) {
              O = (N === 46 ? o + M.slice(I + 1) : M.slice(I)) + O, M = M.slice(0, I);
              break;
            }
        }
      }
      C && !v && (M = t(M, 1 / 0));
      var q = A.length + M.length + O.length, D = q < y ? new Array(y - q + 1).join(h) : "";
      switch (C && v && (M = t(D + M, D.length ? y - O.length : 1 / 0), D = ""), m) {
        case "<":
          M = A + M + O + D;
          break;
        case "=":
          M = A + D + M + O;
          break;
        case "^":
          M = D.slice(0, q = D.length >> 1) + A + M + O + D.slice(q);
          break;
        default:
          M = D + A + M + O;
          break;
      }
      return i(M);
    }
    return R.toString = function() {
      return u + "";
    }, R;
  }
  function f(u, h) {
    var m = c((u = d9(u), u.type = "f", u)), g = Math.max(-8, Math.min(8, Math.floor(iH(h) / 3))) * 3, p = Math.pow(10, -g), v = N7[8 + g / 3];
    return function(y) {
      return m(p * y) + v;
    };
  }
  return {
    format: c,
    formatPrefix: f
  };
}
var Fs, T4;
fH({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""],
  minus: "-"
});
function fH(e) {
  return Fs = dH(e), T4 = Fs.format, Fs.formatPrefix, Fs;
}
var Ld = /* @__PURE__ */ new Date(), Td = /* @__PURE__ */ new Date();
function Ft(e, t, n, r) {
  function o(i) {
    return e(i = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+i)), i;
  }
  return o.floor = function(i) {
    return e(i = /* @__PURE__ */ new Date(+i)), i;
  }, o.ceil = function(i) {
    return e(i = new Date(i - 1)), t(i, 1), e(i), i;
  }, o.round = function(i) {
    var a = o(i), s = o.ceil(i);
    return i - a < s - i ? a : s;
  }, o.offset = function(i, a) {
    return t(i = /* @__PURE__ */ new Date(+i), a == null ? 1 : Math.floor(a)), i;
  }, o.range = function(i, a, s) {
    var l = [], c;
    if (i = o.ceil(i), s = s == null ? 1 : Math.floor(s), !(i < a) || !(s > 0)) return l;
    do
      l.push(c = /* @__PURE__ */ new Date(+i)), t(i, s), e(i);
    while (c < i && i < a);
    return l;
  }, o.filter = function(i) {
    return Ft(function(a) {
      if (a >= a) for (; e(a), !i(a); ) a.setTime(a - 1);
    }, function(a, s) {
      if (a >= a)
        if (s < 0) for (; ++s <= 0; )
          for (; t(a, -1), !i(a); )
            ;
        else for (; --s >= 0; )
          for (; t(a, 1), !i(a); )
            ;
    });
  }, n && (o.count = function(i, a) {
    return Ld.setTime(+i), Td.setTime(+a), e(Ld), e(Td), Math.floor(n(Ld, Td));
  }, o.every = function(i) {
    return i = Math.floor(i), !isFinite(i) || !(i > 0) ? null : i > 1 ? o.filter(r ? function(a) {
      return r(a) % i === 0;
    } : function(a) {
      return o.count(0, a) % i === 0;
    }) : o;
  }), o;
}
var Ia = Ft(function() {
}, function(e, t) {
  e.setTime(+e + t);
}, function(e, t) {
  return t - e;
});
Ia.every = function(e) {
  return e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? Ft(function(t) {
    t.setTime(Math.floor(t / e) * e);
  }, function(t, n) {
    t.setTime(+t + n * e);
  }, function(t, n) {
    return (n - t) / e;
  }) : Ia;
};
Ia.range;
var C0 = 1e3, yo = 6e4, w0 = 36e5, Xx = 864e5, Qx = 6048e5, f9 = Ft(function(e) {
  e.setTime(e - e.getMilliseconds());
}, function(e, t) {
  e.setTime(+e + t * C0);
}, function(e, t) {
  return (t - e) / C0;
}, function(e) {
  return e.getUTCSeconds();
});
f9.range;
var Jx = Ft(function(e) {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * C0);
}, function(e, t) {
  e.setTime(+e + t * yo);
}, function(e, t) {
  return (t - e) / yo;
}, function(e) {
  return e.getMinutes();
});
Jx.range;
var e_ = Ft(function(e) {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * C0 - e.getMinutes() * yo);
}, function(e, t) {
  e.setTime(+e + t * w0);
}, function(e, t) {
  return (t - e) / w0;
}, function(e) {
  return e.getHours();
});
e_.range;
var P4 = Ft(function(e) {
  e.setHours(0, 0, 0, 0);
}, function(e, t) {
  e.setDate(e.getDate() + t);
}, function(e, t) {
  return (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * yo) / Xx;
}, function(e) {
  return e.getDate() - 1;
});
P4.range;
function Ro(e) {
  return Ft(function(t) {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setDate(t.getDate() + n * 7);
  }, function(t, n) {
    return (n - t - (n.getTimezoneOffset() - t.getTimezoneOffset()) * yo) / Qx;
  });
}
var x0 = Ro(0), Ba = Ro(1), t_ = Ro(2), n_ = Ro(3), Co = Ro(4), r_ = Ro(5), o_ = Ro(6);
x0.range;
Ba.range;
t_.range;
n_.range;
Co.range;
r_.range;
o_.range;
var i_ = Ft(function(e) {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, function(e, t) {
  e.setMonth(e.getMonth() + t);
}, function(e, t) {
  return t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12;
}, function(e) {
  return e.getMonth();
});
i_.range;
var Vr = Ft(function(e) {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, function(e, t) {
  e.setFullYear(e.getFullYear() + t);
}, function(e, t) {
  return t.getFullYear() - e.getFullYear();
}, function(e) {
  return e.getFullYear();
});
Vr.every = function(e) {
  return !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Ft(function(t) {
    t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setFullYear(t.getFullYear() + n * e);
  });
};
Vr.range;
var a_ = Ft(function(e) {
  e.setUTCSeconds(0, 0);
}, function(e, t) {
  e.setTime(+e + t * yo);
}, function(e, t) {
  return (t - e) / yo;
}, function(e) {
  return e.getUTCMinutes();
});
a_.range;
var s_ = Ft(function(e) {
  e.setUTCMinutes(0, 0, 0);
}, function(e, t) {
  e.setTime(+e + t * w0);
}, function(e, t) {
  return (t - e) / w0;
}, function(e) {
  return e.getUTCHours();
});
s_.range;
var R4 = Ft(function(e) {
  e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCDate(e.getUTCDate() + t);
}, function(e, t) {
  return (t - e) / Xx;
}, function(e) {
  return e.getUTCDate() - 1;
});
R4.range;
function Ao(e) {
  return Ft(function(t) {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setUTCDate(t.getUTCDate() + n * 7);
  }, function(t, n) {
    return (n - t) / Qx;
  });
}
var _0 = Ao(0), $a = Ao(1), l_ = Ao(2), c_ = Ao(3), wo = Ao(4), u_ = Ao(5), d_ = Ao(6);
_0.range;
$a.range;
l_.range;
c_.range;
wo.range;
u_.range;
d_.range;
var f_ = Ft(function(e) {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCMonth(e.getUTCMonth() + t);
}, function(e, t) {
  return t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12;
}, function(e) {
  return e.getUTCMonth();
});
f_.range;
var Ur = Ft(function(e) {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, function(e, t) {
  return t.getUTCFullYear() - e.getUTCFullYear();
}, function(e) {
  return e.getUTCFullYear();
});
Ur.every = function(e) {
  return !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Ft(function(t) {
    t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setUTCFullYear(t.getUTCFullYear() + n * e);
  });
};
Ur.range;
function Pd(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function Rd(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function Gi(e, t, n) {
  return { y: e, m: t, d: n, H: 0, M: 0, S: 0, L: 0 };
}
function hH(e) {
  var t = e.dateTime, n = e.date, r = e.time, o = e.periods, i = e.days, a = e.shortDays, s = e.months, l = e.shortMonths, c = Ki(o), f = Zi(o), u = Ki(i), h = Zi(i), m = Ki(a), g = Zi(a), p = Ki(s), v = Zi(s), y = Ki(l), C = Zi(l), w = {
    a: H,
    A: q,
    b: D,
    B: $,
    c: null,
    d: W7,
    e: W7,
    f: IH,
    g: zH,
    G: GH,
    H: OH,
    I: NH,
    j: DH,
    L: h_,
    m: BH,
    M: $H,
    p: U,
    q: B,
    Q: H7,
    s: V7,
    S: FH,
    u: WH,
    U: qH,
    V: jH,
    w: HH,
    W: VH,
    x: null,
    X: null,
    y: UH,
    Y: YH,
    Z: KH,
    "%": j7
  }, _ = {
    a: K,
    A: X,
    b: Z,
    B: G,
    c: null,
    d: q7,
    e: q7,
    f: JH,
    g: cV,
    G: dV,
    H: ZH,
    I: XH,
    j: QH,
    L: p_,
    m: eV,
    M: tV,
    p: V,
    q: Y,
    Q: H7,
    s: V7,
    S: nV,
    u: rV,
    U: oV,
    V: iV,
    w: aV,
    W: sV,
    x: null,
    X: null,
    y: lV,
    Y: uV,
    Z: fV,
    "%": j7
  }, x = {
    a: R,
    A: M,
    b: A,
    B: O,
    c: I,
    d: $7,
    e: $7,
    f: TH,
    g: B7,
    G: I7,
    H: F7,
    I: F7,
    j: SH,
    L: LH,
    m: kH,
    M: MH,
    p: L,
    q: _H,
    Q: RH,
    s: AH,
    S: EH,
    u: bH,
    U: yH,
    V: CH,
    w: vH,
    W: wH,
    x: W,
    X: N,
    y: B7,
    Y: I7,
    Z: xH,
    "%": PH
  };
  w.x = k(n, w), w.X = k(r, w), w.c = k(t, w), _.x = k(n, _), _.X = k(r, _), _.c = k(t, _);
  function k(P, F) {
    return function(z) {
      var E = [], re = -1, ee = 0, oe = P.length, ue, le, Ae;
      for (z instanceof Date || (z = /* @__PURE__ */ new Date(+z)); ++re < oe; )
        P.charCodeAt(re) === 37 && (E.push(P.slice(ee, re)), (le = D7[ue = P.charAt(++re)]) != null ? ue = P.charAt(++re) : le = ue === "e" ? " " : "0", (Ae = F[ue]) && (ue = Ae(z, le)), E.push(ue), ee = re + 1);
      return E.push(P.slice(ee, re)), E.join("");
    };
  }
  function S(P, F) {
    return function(z) {
      var E = Gi(1900, void 0, 1), re = T(E, P, z += "", 0), ee, oe;
      if (re != z.length) return null;
      if ("Q" in E) return new Date(E.Q);
      if ("s" in E) return new Date(E.s * 1e3 + ("L" in E ? E.L : 0));
      if (F && !("Z" in E) && (E.Z = 0), "p" in E && (E.H = E.H % 12 + E.p * 12), E.m === void 0 && (E.m = "q" in E ? E.q : 0), "V" in E) {
        if (E.V < 1 || E.V > 53) return null;
        "w" in E || (E.w = 1), "Z" in E ? (ee = Rd(Gi(E.y, 0, 1)), oe = ee.getUTCDay(), ee = oe > 4 || oe === 0 ? $a.ceil(ee) : $a(ee), ee = R4.offset(ee, (E.V - 1) * 7), E.y = ee.getUTCFullYear(), E.m = ee.getUTCMonth(), E.d = ee.getUTCDate() + (E.w + 6) % 7) : (ee = Pd(Gi(E.y, 0, 1)), oe = ee.getDay(), ee = oe > 4 || oe === 0 ? Ba.ceil(ee) : Ba(ee), ee = P4.offset(ee, (E.V - 1) * 7), E.y = ee.getFullYear(), E.m = ee.getMonth(), E.d = ee.getDate() + (E.w + 6) % 7);
      } else ("W" in E || "U" in E) && ("w" in E || (E.w = "u" in E ? E.u % 7 : "W" in E ? 1 : 0), oe = "Z" in E ? Rd(Gi(E.y, 0, 1)).getUTCDay() : Pd(Gi(E.y, 0, 1)).getDay(), E.m = 0, E.d = "W" in E ? (E.w + 6) % 7 + E.W * 7 - (oe + 5) % 7 : E.w + E.U * 7 - (oe + 6) % 7);
      return "Z" in E ? (E.H += E.Z / 100 | 0, E.M += E.Z % 100, Rd(E)) : Pd(E);
    };
  }
  function T(P, F, z, E) {
    for (var re = 0, ee = F.length, oe = z.length, ue, le; re < ee; ) {
      if (E >= oe) return -1;
      if (ue = F.charCodeAt(re++), ue === 37) {
        if (ue = F.charAt(re++), le = x[ue in D7 ? F.charAt(re++) : ue], !le || (E = le(P, z, E)) < 0) return -1;
      } else if (ue != z.charCodeAt(E++))
        return -1;
    }
    return E;
  }
  function L(P, F, z) {
    var E = c.exec(F.slice(z));
    return E ? (P.p = f.get(E[0].toLowerCase()), z + E[0].length) : -1;
  }
  function R(P, F, z) {
    var E = m.exec(F.slice(z));
    return E ? (P.w = g.get(E[0].toLowerCase()), z + E[0].length) : -1;
  }
  function M(P, F, z) {
    var E = u.exec(F.slice(z));
    return E ? (P.w = h.get(E[0].toLowerCase()), z + E[0].length) : -1;
  }
  function A(P, F, z) {
    var E = y.exec(F.slice(z));
    return E ? (P.m = C.get(E[0].toLowerCase()), z + E[0].length) : -1;
  }
  function O(P, F, z) {
    var E = p.exec(F.slice(z));
    return E ? (P.m = v.get(E[0].toLowerCase()), z + E[0].length) : -1;
  }
  function I(P, F, z) {
    return T(P, t, F, z);
  }
  function W(P, F, z) {
    return T(P, n, F, z);
  }
  function N(P, F, z) {
    return T(P, r, F, z);
  }
  function H(P) {
    return a[P.getDay()];
  }
  function q(P) {
    return i[P.getDay()];
  }
  function D(P) {
    return l[P.getMonth()];
  }
  function $(P) {
    return s[P.getMonth()];
  }
  function U(P) {
    return o[+(P.getHours() >= 12)];
  }
  function B(P) {
    return 1 + ~~(P.getMonth() / 3);
  }
  function K(P) {
    return a[P.getUTCDay()];
  }
  function X(P) {
    return i[P.getUTCDay()];
  }
  function Z(P) {
    return l[P.getUTCMonth()];
  }
  function G(P) {
    return s[P.getUTCMonth()];
  }
  function V(P) {
    return o[+(P.getUTCHours() >= 12)];
  }
  function Y(P) {
    return 1 + ~~(P.getUTCMonth() / 3);
  }
  return {
    format: function(P) {
      var F = k(P += "", w);
      return F.toString = function() {
        return P;
      }, F;
    },
    parse: function(P) {
      var F = S(P += "", !1);
      return F.toString = function() {
        return P;
      }, F;
    },
    utcFormat: function(P) {
      var F = k(P += "", _);
      return F.toString = function() {
        return P;
      }, F;
    },
    utcParse: function(P) {
      var F = S(P += "", !0);
      return F.toString = function() {
        return P;
      }, F;
    }
  };
}
var D7 = { "-": "", _: " ", 0: "0" }, Kt = /^\s*\d+/, mH = /^%/, pH = /[\\^$*+?|[\]().{}]/g;
function Ze(e, t, n) {
  var r = e < 0 ? "-" : "", o = (r ? -e : e) + "", i = o.length;
  return r + (i < n ? new Array(n - i + 1).join(t) + o : o);
}
function gH(e) {
  return e.replace(pH, "\\$&");
}
function Ki(e) {
  return new RegExp("^(?:" + e.map(gH).join("|") + ")", "i");
}
function Zi(e) {
  return new Map(e.map((t, n) => [t.toLowerCase(), n]));
}
function vH(e, t, n) {
  var r = Kt.exec(t.slice(n, n + 1));
  return r ? (e.w = +r[0], n + r[0].length) : -1;
}
function bH(e, t, n) {
  var r = Kt.exec(t.slice(n, n + 1));
  return r ? (e.u = +r[0], n + r[0].length) : -1;
}
function yH(e, t, n) {
  var r = Kt.exec(t.slice(n, n + 2));
  return r ? (e.U = +r[0], n + r[0].length) : -1;
}
function CH(e, t, n) {
  var r = Kt.exec(t.slice(n, n + 2));
  return r ? (e.V = +r[0], n + r[0].length) : -1;
}
function wH(e, t, n) {
  var r = Kt.exec(t.slice(n, n + 2));
  return r ? (e.W = +r[0], n + r[0].length) : -1;
}
function I7(e, t, n) {
  var r = Kt.exec(t.slice(n, n + 4));
  return r ? (e.y = +r[0], n + r[0].length) : -1;
}
function B7(e, t, n) {
  var r = Kt.exec(t.slice(n, n + 2));
  return r ? (e.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}
function xH(e, t, n) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(n, n + 6));
  return r ? (e.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}
function _H(e, t, n) {
  var r = Kt.exec(t.slice(n, n + 1));
  return r ? (e.q = r[0] * 3 - 3, n + r[0].length) : -1;
}
function kH(e, t, n) {
  var r = Kt.exec(t.slice(n, n + 2));
  return r ? (e.m = r[0] - 1, n + r[0].length) : -1;
}
function $7(e, t, n) {
  var r = Kt.exec(t.slice(n, n + 2));
  return r ? (e.d = +r[0], n + r[0].length) : -1;
}
function SH(e, t, n) {
  var r = Kt.exec(t.slice(n, n + 3));
  return r ? (e.m = 0, e.d = +r[0], n + r[0].length) : -1;
}
function F7(e, t, n) {
  var r = Kt.exec(t.slice(n, n + 2));
  return r ? (e.H = +r[0], n + r[0].length) : -1;
}
function MH(e, t, n) {
  var r = Kt.exec(t.slice(n, n + 2));
  return r ? (e.M = +r[0], n + r[0].length) : -1;
}
function EH(e, t, n) {
  var r = Kt.exec(t.slice(n, n + 2));
  return r ? (e.S = +r[0], n + r[0].length) : -1;
}
function LH(e, t, n) {
  var r = Kt.exec(t.slice(n, n + 3));
  return r ? (e.L = +r[0], n + r[0].length) : -1;
}
function TH(e, t, n) {
  var r = Kt.exec(t.slice(n, n + 6));
  return r ? (e.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}
function PH(e, t, n) {
  var r = mH.exec(t.slice(n, n + 1));
  return r ? n + r[0].length : -1;
}
function RH(e, t, n) {
  var r = Kt.exec(t.slice(n));
  return r ? (e.Q = +r[0], n + r[0].length) : -1;
}
function AH(e, t, n) {
  var r = Kt.exec(t.slice(n));
  return r ? (e.s = +r[0], n + r[0].length) : -1;
}
function W7(e, t) {
  return Ze(e.getDate(), t, 2);
}
function OH(e, t) {
  return Ze(e.getHours(), t, 2);
}
function NH(e, t) {
  return Ze(e.getHours() % 12 || 12, t, 2);
}
function DH(e, t) {
  return Ze(1 + P4.count(Vr(e), e), t, 3);
}
function h_(e, t) {
  return Ze(e.getMilliseconds(), t, 3);
}
function IH(e, t) {
  return h_(e, t) + "000";
}
function BH(e, t) {
  return Ze(e.getMonth() + 1, t, 2);
}
function $H(e, t) {
  return Ze(e.getMinutes(), t, 2);
}
function FH(e, t) {
  return Ze(e.getSeconds(), t, 2);
}
function WH(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function qH(e, t) {
  return Ze(x0.count(Vr(e) - 1, e), t, 2);
}
function m_(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? Co(e) : Co.ceil(e);
}
function jH(e, t) {
  return e = m_(e), Ze(Co.count(Vr(e), e) + (Vr(e).getDay() === 4), t, 2);
}
function HH(e) {
  return e.getDay();
}
function VH(e, t) {
  return Ze(Ba.count(Vr(e) - 1, e), t, 2);
}
function UH(e, t) {
  return Ze(e.getFullYear() % 100, t, 2);
}
function zH(e, t) {
  return e = m_(e), Ze(e.getFullYear() % 100, t, 2);
}
function YH(e, t) {
  return Ze(e.getFullYear() % 1e4, t, 4);
}
function GH(e, t) {
  var n = e.getDay();
  return e = n >= 4 || n === 0 ? Co(e) : Co.ceil(e), Ze(e.getFullYear() % 1e4, t, 4);
}
function KH(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + Ze(t / 60 | 0, "0", 2) + Ze(t % 60, "0", 2);
}
function q7(e, t) {
  return Ze(e.getUTCDate(), t, 2);
}
function ZH(e, t) {
  return Ze(e.getUTCHours(), t, 2);
}
function XH(e, t) {
  return Ze(e.getUTCHours() % 12 || 12, t, 2);
}
function QH(e, t) {
  return Ze(1 + R4.count(Ur(e), e), t, 3);
}
function p_(e, t) {
  return Ze(e.getUTCMilliseconds(), t, 3);
}
function JH(e, t) {
  return p_(e, t) + "000";
}
function eV(e, t) {
  return Ze(e.getUTCMonth() + 1, t, 2);
}
function tV(e, t) {
  return Ze(e.getUTCMinutes(), t, 2);
}
function nV(e, t) {
  return Ze(e.getUTCSeconds(), t, 2);
}
function rV(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function oV(e, t) {
  return Ze(_0.count(Ur(e) - 1, e), t, 2);
}
function g_(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? wo(e) : wo.ceil(e);
}
function iV(e, t) {
  return e = g_(e), Ze(wo.count(Ur(e), e) + (Ur(e).getUTCDay() === 4), t, 2);
}
function aV(e) {
  return e.getUTCDay();
}
function sV(e, t) {
  return Ze($a.count(Ur(e) - 1, e), t, 2);
}
function lV(e, t) {
  return Ze(e.getUTCFullYear() % 100, t, 2);
}
function cV(e, t) {
  return e = g_(e), Ze(e.getUTCFullYear() % 100, t, 2);
}
function uV(e, t) {
  return Ze(e.getUTCFullYear() % 1e4, t, 4);
}
function dV(e, t) {
  var n = e.getUTCDay();
  return e = n >= 4 || n === 0 ? wo(e) : wo.ceil(e), Ze(e.getUTCFullYear() % 1e4, t, 4);
}
function fV() {
  return "+0000";
}
function j7() {
  return "%";
}
function H7(e) {
  return +e;
}
function V7(e) {
  return Math.floor(+e / 1e3);
}
var jo, A4, v_, b_;
hV({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function hV(e) {
  return jo = hH(e), A4 = jo.format, v_ = jo.parse, jo.utcFormat, b_ = jo.utcParse, jo;
}
var mV = Zh();
const O4 = /* @__PURE__ */ Ht(mV);
var Ad, U7;
function pV() {
  if (U7) return Ad;
  U7 = 1;
  var e = hs(), t = ix(), n = Oi();
  function r(o, i, a) {
    for (var s = -1, l = i.length, c = {}; ++s < l; ) {
      var f = i[s], u = e(o, f);
      a(u, f) && t(c, n(f, o), u);
    }
    return c;
  }
  return Ad = r, Ad;
}
var Od, z7;
function gV() {
  if (z7) return Od;
  z7 = 1;
  function e(t, n) {
    return t != null && n in Object(t);
  }
  return Od = e, Od;
}
var Nd, Y7;
function vV() {
  if (Y7) return Nd;
  Y7 = 1;
  var e = Oi(), t = Al(), n = on(), r = Dl(), o = Kh(), i = Ni();
  function a(s, l, c) {
    l = e(l, s);
    for (var f = -1, u = l.length, h = !1; ++f < u; ) {
      var m = i(l[f]);
      if (!(h = s != null && c(s, m)))
        break;
      s = s[m];
    }
    return h || ++f != u ? h : (u = s == null ? 0 : s.length, !!u && o(u) && r(m, u) && (n(s) || t(s)));
  }
  return Nd = a, Nd;
}
var Dd, G7;
function y_() {
  if (G7) return Dd;
  G7 = 1;
  var e = gV(), t = vV();
  function n(r, o) {
    return r != null && t(r, o, e);
  }
  return Dd = n, Dd;
}
var Id, K7;
function bV() {
  if (K7) return Id;
  K7 = 1;
  var e = pV(), t = y_();
  function n(r, o) {
    return e(r, o, function(i, a) {
      return t(r, a);
    });
  }
  return Id = n, Id;
}
var Bd, Z7;
function N4() {
  if (Z7) return Bd;
  Z7 = 1;
  function e(t, n) {
    for (var r = -1, o = n.length, i = t.length; ++r < o; )
      t[i + r] = n[r];
    return t;
  }
  return Bd = e, Bd;
}
var $d, X7;
function yV() {
  if (X7) return $d;
  X7 = 1;
  var e = Ti(), t = Al(), n = on(), r = e ? e.isConcatSpreadable : void 0;
  function o(i) {
    return n(i) || t(i) || !!(r && i && i[r]);
  }
  return $d = o, $d;
}
var Fd, Q7;
function C_() {
  if (Q7) return Fd;
  Q7 = 1;
  var e = N4(), t = yV();
  function n(r, o, i, a, s) {
    var l = -1, c = r.length;
    for (i || (i = t), s || (s = []); ++l < c; ) {
      var f = r[l];
      o > 0 && i(f) ? o > 1 ? n(f, o - 1, i, a, s) : e(s, f) : a || (s[s.length] = f);
    }
    return s;
  }
  return Fd = n, Fd;
}
var Wd, J7;
function CV() {
  if (J7) return Wd;
  J7 = 1;
  var e = C_();
  function t(n) {
    var r = n == null ? 0 : n.length;
    return r ? e(n, 1) : [];
  }
  return Wd = t, Wd;
}
var qd, em;
function w_() {
  if (em) return qd;
  em = 1;
  var e = CV(), t = ex(), n = tx();
  function r(o) {
    return n(t(o, void 0, e), o + "");
  }
  return qd = r, qd;
}
var jd, tm;
function wV() {
  if (tm) return jd;
  tm = 1;
  var e = bV(), t = w_(), n = t(function(r, o) {
    return r == null ? {} : e(r, o);
  });
  return jd = n, jd;
}
var xV = wV();
const _V = /* @__PURE__ */ Ht(xV);
var Hd, nm;
function kV() {
  if (nm) return Hd;
  nm = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length; ++r < o; )
      if (n(t[r], r, t))
        return !0;
    return !1;
  }
  return Hd = e, Hd;
}
var Vd, rm;
function x_() {
  if (rm) return Vd;
  rm = 1;
  var e = C4(), t = kV(), n = w4(), r = 1, o = 2;
  function i(a, s, l, c, f, u) {
    var h = l & r, m = a.length, g = s.length;
    if (m != g && !(h && g > m))
      return !1;
    var p = u.get(a), v = u.get(s);
    if (p && v)
      return p == s && v == a;
    var y = -1, C = !0, w = l & o ? new e() : void 0;
    for (u.set(a, s), u.set(s, a); ++y < m; ) {
      var _ = a[y], x = s[y];
      if (c)
        var k = h ? c(x, _, y, s, a, u) : c(_, x, y, a, s, u);
      if (k !== void 0) {
        if (k)
          continue;
        C = !1;
        break;
      }
      if (w) {
        if (!t(s, function(S, T) {
          if (!n(w, T) && (_ === S || f(_, S, l, c, u)))
            return w.push(T);
        })) {
          C = !1;
          break;
        }
      } else if (!(_ === x || f(_, x, l, c, u))) {
        C = !1;
        break;
      }
    }
    return u.delete(a), u.delete(s), C;
  }
  return Vd = i, Vd;
}
var Ud, om;
function SV() {
  if (om) return Ud;
  om = 1;
  function e(t) {
    var n = -1, r = Array(t.size);
    return t.forEach(function(o, i) {
      r[++n] = [i, o];
    }), r;
  }
  return Ud = e, Ud;
}
var zd, im;
function D4() {
  if (im) return zd;
  im = 1;
  function e(t) {
    var n = -1, r = Array(t.size);
    return t.forEach(function(o) {
      r[++n] = o;
    }), r;
  }
  return zd = e, zd;
}
var Yd, am;
function MV() {
  if (am) return Yd;
  am = 1;
  var e = Ti(), t = zw(), n = ds(), r = x_(), o = SV(), i = D4(), a = 1, s = 2, l = "[object Boolean]", c = "[object Date]", f = "[object Error]", u = "[object Map]", h = "[object Number]", m = "[object RegExp]", g = "[object Set]", p = "[object String]", v = "[object Symbol]", y = "[object ArrayBuffer]", C = "[object DataView]", w = e ? e.prototype : void 0, _ = w ? w.valueOf : void 0;
  function x(k, S, T, L, R, M, A) {
    switch (T) {
      case C:
        if (k.byteLength != S.byteLength || k.byteOffset != S.byteOffset)
          return !1;
        k = k.buffer, S = S.buffer;
      case y:
        return !(k.byteLength != S.byteLength || !M(new t(k), new t(S)));
      case l:
      case c:
      case h:
        return n(+k, +S);
      case f:
        return k.name == S.name && k.message == S.message;
      case m:
      case p:
        return k == S + "";
      case u:
        var O = o;
      case g:
        var I = L & a;
        if (O || (O = i), k.size != S.size && !I)
          return !1;
        var W = A.get(k);
        if (W)
          return W == S;
        L |= s, A.set(k, S);
        var N = r(O(k), O(S), L, R, M, A);
        return A.delete(k), N;
      case v:
        if (_)
          return _.call(k) == _.call(S);
    }
    return !1;
  }
  return Yd = x, Yd;
}
var Gd, sm;
function __() {
  if (sm) return Gd;
  sm = 1;
  var e = N4(), t = on();
  function n(r, o, i) {
    var a = o(r);
    return t(r) ? a : e(a, i(r));
  }
  return Gd = n, Gd;
}
var Kd, lm;
function k_() {
  if (lm) return Kd;
  lm = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length, i = 0, a = []; ++r < o; ) {
      var s = t[r];
      n(s, r, t) && (a[i++] = s);
    }
    return a;
  }
  return Kd = e, Kd;
}
var Zd, cm;
function S_() {
  if (cm) return Zd;
  cm = 1;
  function e() {
    return [];
  }
  return Zd = e, Zd;
}
var Xd, um;
function I4() {
  if (um) return Xd;
  um = 1;
  var e = k_(), t = S_(), n = Object.prototype, r = n.propertyIsEnumerable, o = Object.getOwnPropertySymbols, i = o ? function(a) {
    return a == null ? [] : (a = Object(a), e(o(a), function(s) {
      return r.call(a, s);
    }));
  } : t;
  return Xd = i, Xd;
}
var Qd, dm;
function EV() {
  if (dm) return Qd;
  dm = 1;
  var e = Kw(), t = e(Object.keys, Object);
  return Qd = t, Qd;
}
var Jd, fm;
function LV() {
  if (fm) return Jd;
  fm = 1;
  var e = Gh(), t = EV(), n = Object.prototype, r = n.hasOwnProperty;
  function o(i) {
    if (!e(i))
      return t(i);
    var a = [];
    for (var s in Object(i))
      r.call(i, s) && s != "constructor" && a.push(s);
    return a;
  }
  return Jd = o, Jd;
}
var ef, hm;
function ps() {
  if (hm) return ef;
  hm = 1;
  var e = Jw(), t = LV(), n = Pi();
  function r(o) {
    return n(o) ? e(o) : t(o);
  }
  return ef = r, ef;
}
var tf, mm;
function M_() {
  if (mm) return tf;
  mm = 1;
  var e = __(), t = I4(), n = ps();
  function r(o) {
    return e(o, n, t);
  }
  return tf = r, tf;
}
var nf, pm;
function TV() {
  if (pm) return nf;
  pm = 1;
  var e = M_(), t = 1, n = Object.prototype, r = n.hasOwnProperty;
  function o(i, a, s, l, c, f) {
    var u = s & t, h = e(i), m = h.length, g = e(a), p = g.length;
    if (m != p && !u)
      return !1;
    for (var v = m; v--; ) {
      var y = h[v];
      if (!(u ? y in a : r.call(a, y)))
        return !1;
    }
    var C = f.get(i), w = f.get(a);
    if (C && w)
      return C == a && w == i;
    var _ = !0;
    f.set(i, a), f.set(a, i);
    for (var x = u; ++v < m; ) {
      y = h[v];
      var k = i[y], S = a[y];
      if (l)
        var T = u ? l(S, k, y, a, i, f) : l(k, S, y, i, a, f);
      if (!(T === void 0 ? k === S || c(k, S, s, l, f) : T)) {
        _ = !1;
        break;
      }
      x || (x = y == "constructor");
    }
    if (_ && !x) {
      var L = i.constructor, R = a.constructor;
      L != R && "constructor" in i && "constructor" in a && !(typeof L == "function" && L instanceof L && typeof R == "function" && R instanceof R) && (_ = !1);
    }
    return f.delete(i), f.delete(a), _;
  }
  return nf = o, nf;
}
var rf, gm;
function PV() {
  if (gm) return rf;
  gm = 1;
  var e = Eo(), t = nr(), n = e(t, "DataView");
  return rf = n, rf;
}
var of, vm;
function RV() {
  if (vm) return of;
  vm = 1;
  var e = Eo(), t = nr(), n = e(t, "Promise");
  return of = n, of;
}
var af, bm;
function E_() {
  if (bm) return af;
  bm = 1;
  var e = Eo(), t = nr(), n = e(t, "Set");
  return af = n, af;
}
var sf, ym;
function AV() {
  if (ym) return sf;
  ym = 1;
  var e = Eo(), t = nr(), n = e(t, "WeakMap");
  return sf = n, sf;
}
var lf, Cm;
function xc() {
  if (Cm) return lf;
  Cm = 1;
  var e = PV(), t = Hh(), n = RV(), r = E_(), o = AV(), i = _r(), a = qw(), s = "[object Map]", l = "[object Object]", c = "[object Promise]", f = "[object Set]", u = "[object WeakMap]", h = "[object DataView]", m = a(e), g = a(t), p = a(n), v = a(r), y = a(o), C = i;
  return (e && C(new e(new ArrayBuffer(1))) != h || t && C(new t()) != s || n && C(n.resolve()) != c || r && C(new r()) != f || o && C(new o()) != u) && (C = function(w) {
    var _ = i(w), x = _ == l ? w.constructor : void 0, k = x ? a(x) : "";
    if (k)
      switch (k) {
        case m:
          return h;
        case g:
          return s;
        case p:
          return c;
        case v:
          return f;
        case y:
          return u;
      }
    return _;
  }), lf = C, lf;
}
var cf, wm;
function OV() {
  if (wm) return cf;
  wm = 1;
  var e = Rl(), t = x_(), n = MV(), r = TV(), o = xc(), i = on(), a = Ol(), s = Xh(), l = 1, c = "[object Arguments]", f = "[object Array]", u = "[object Object]", h = Object.prototype, m = h.hasOwnProperty;
  function g(p, v, y, C, w, _) {
    var x = i(p), k = i(v), S = x ? f : o(p), T = k ? f : o(v);
    S = S == c ? u : S, T = T == c ? u : T;
    var L = S == u, R = T == u, M = S == T;
    if (M && a(p)) {
      if (!a(v))
        return !1;
      x = !0, L = !1;
    }
    if (M && !L)
      return _ || (_ = new e()), x || s(p) ? t(p, v, y, C, w, _) : n(p, v, S, y, C, w, _);
    if (!(y & l)) {
      var A = L && m.call(p, "__wrapped__"), O = R && m.call(v, "__wrapped__");
      if (A || O) {
        var I = A ? p.value() : p, W = O ? v.value() : v;
        return _ || (_ = new e()), w(I, W, y, C, _);
      }
    }
    return M ? (_ || (_ = new e()), r(p, v, y, C, w, _)) : !1;
  }
  return cf = g, cf;
}
var uf, xm;
function B4() {
  if (xm) return uf;
  xm = 1;
  var e = OV(), t = _n();
  function n(r, o, i, a, s) {
    return r === o ? !0 : r == null || o == null || !t(r) && !t(o) ? r !== r && o !== o : e(r, o, i, a, n, s);
  }
  return uf = n, uf;
}
var df, _m;
function NV() {
  if (_m) return df;
  _m = 1;
  var e = B4();
  function t(n, r) {
    return e(n, r);
  }
  return df = t, df;
}
var DV = NV();
const IV = /* @__PURE__ */ Ht(DV);
var BV = { background: "transparent", text: { fontFamily: "sans-serif", fontSize: 11, fill: "#333333", outlineWidth: 0, outlineColor: "transparent", outlineOpacity: 1 }, axis: { domain: { line: { stroke: "transparent", strokeWidth: 1 } }, ticks: { line: { stroke: "#777777", strokeWidth: 1 }, text: {} }, legend: { text: { fontSize: 12 } } }, grid: { line: { stroke: "#dddddd", strokeWidth: 1 } }, legends: { hidden: { symbol: { fill: "#333333", opacity: 0.6 }, text: { fill: "#333333", opacity: 0.6 } }, text: {}, ticks: { line: { stroke: "#777777", strokeWidth: 1 }, text: { fontSize: 10 } }, title: { text: {} } }, labels: { text: {} }, markers: { lineColor: "#000000", lineStrokeWidth: 1, text: {} }, dots: { text: {} }, tooltip: { container: { background: "white", color: "inherit", fontSize: "inherit", borderRadius: "2px", boxShadow: "0 1px 2px rgba(0, 0, 0, 0.25)", padding: "5px 9px" }, basic: { whiteSpace: "pre", display: "flex", alignItems: "center" }, chip: { marginRight: 7 }, table: {}, tableCell: { padding: "3px 5px" }, tableCellValue: { fontWeight: "bold" } }, crosshair: { line: { stroke: "#000000", strokeWidth: 1, strokeOpacity: 0.75, strokeDasharray: "6 6" } }, annotations: { text: { fontSize: 13, outlineWidth: 2, outlineColor: "#ffffff", outlineOpacity: 1 }, link: { stroke: "#000000", strokeWidth: 1, outlineWidth: 2, outlineColor: "#ffffff", outlineOpacity: 1 }, outline: { fill: "none", stroke: "#000000", strokeWidth: 2, outlineWidth: 2, outlineColor: "#ffffff", outlineOpacity: 1 }, symbol: { fill: "#000000", outlineWidth: 2, outlineColor: "#ffffff", outlineOpacity: 1 } } };
function wn() {
  return wn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, wn.apply(this, arguments);
}
function h9(e, t) {
  return h9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, h9(e, t);
}
function _c(e, t) {
  if (e == null) return {};
  var n, r, o = {}, i = Object.keys(e);
  for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
  return o;
}
var $V = ["axis.ticks.text", "axis.legend.text", "legends.title.text", "legends.text", "legends.ticks.text", "legends.title.text", "labels.text", "dots.text", "markers.text", "annotations.text"], FV = function(e, t) {
  return wn({}, t, e);
}, WV = function(e, t) {
  var n = q$({}, e, t);
  return $V.forEach(function(r) {
    ca(n, r, FV(Zn(n, r), n.text));
  }), n;
}, L_ = _o(), T_ = function(e) {
  var t = e.children, n = e.animate, r = n === void 0 || n, o = e.config, i = o === void 0 ? "default" : o, a = Te(function() {
    var s = MF(i) ? Wh[i] : i;
    return { animate: r, config: s };
  }, [r, i]);
  return b(L_.Provider, { value: a, children: t });
}, k0 = { animate: J.bool, motionConfig: J.oneOfType([J.oneOf(Object.keys(Wh)), J.shape({ mass: J.number, tension: J.number, friction: J.number, clamp: J.bool, precision: J.number, velocity: J.number, duration: J.number, easing: J.func })]) };
T_.propTypes = { children: J.node.isRequired, animate: k0.animate, config: k0.motionConfig };
var kn = function() {
  return Yn(L_);
}, $4 = function(e) {
  var t = kn(), n = t.animate, r = t.config, o = function(s) {
    var l = Lt();
    return dn(function() {
      l.current = s;
    }, [s]), l.current;
  }(e), i = Te(function() {
    return ux(o, e);
  }, [o, e]), a = tr({ from: { value: 0 }, to: { value: 1 }, reset: !0, config: r, immediate: !n }).value;
  return e9(a, i);
}, qV = { nivo: ["#d76445", "#f47560", "#e8c1a0", "#97e3d5", "#61cdbb", "#00b0a7"], BrBG: ye(zl), PRGn: ye(Yl), PiYG: ye(Gl), PuOr: ye(Kl), RdBu: ye(Zl), RdGy: ye(Xl), RdYlBu: ye(Ql), RdYlGn: ye(Jl), spectral: ye(ec), blues: ye(hc), greens: ye(mc), greys: ye(pc), oranges: ye(bc), purples: ye(gc), reds: ye(vc), BuGn: ye(tc), BuPu: ye(nc), GnBu: ye(rc), OrRd: ye(oc), PuBuGn: ye(ic), PuBu: ye(ac), PuRd: ye(sc), RdPu: ye(lc), YlGnBu: ye(cc), YlGn: ye(uc), YlOrBr: ye(dc), YlOrRd: ye(fc) }, jV = Object.keys(qV);
ye(zl), ye(Yl), ye(Gl), ye(Kl), ye(Zl), ye(Xl), ye(Ql), ye(Jl), ye(ec), ye(hc), ye(mc), ye(pc), ye(bc), ye(gc), ye(vc), ye(tc), ye(nc), ye(rc), ye(oc), ye(ic), ye(ac), ye(sc), ye(lc), ye(cc), ye(uc), ye(dc), ye(fc);
J.oneOfType([J.oneOf(jV), J.func, J.arrayOf(J.string)]);
var m9 = { basis: Bj, basisClosed: $j, basisOpen: Fj, bundle: Wj, cardinal: qj, cardinalClosed: jj, cardinalOpen: Hj, catmullRom: Vj, catmullRomClosed: Uj, catmullRomOpen: zj, linear: _4, linearClosed: Yj, monotoneX: Gj, monotoneY: Kj, natural: Zj, step: Xj, stepAfter: Jj, stepBefore: Qj }, F4 = Object.keys(m9);
F4.filter(function(e) {
  return e.endsWith("Closed");
});
Ox(F4, "bundle", "basisClosed", "basisOpen", "cardinalClosed", "cardinalOpen", "catmullRomClosed", "catmullRomOpen", "linearClosed");
Ox(F4, "bundle", "basisClosed", "basisOpen", "cardinalClosed", "cardinalOpen", "catmullRomClosed", "catmullRomOpen", "linearClosed");
var P_ = function(e) {
  if (!m9[e]) throw new TypeError("'" + e + "', is not a valid curve interpolator identifier.");
  return m9[e];
};
J.shape({ top: J.number, right: J.number, bottom: J.number, left: J.number }).isRequired;
var HV = ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"];
J.oneOf(HV);
ro(Px);
var R_ = { top: 0, right: 0, bottom: 0, left: 0 }, kc = function(e, t, n) {
  return n === void 0 && (n = {}), Te(function() {
    var r = wn({}, R_, n);
    return { margin: r, innerWidth: e - r.left - r.right, innerHeight: t - r.top - r.bottom, outerWidth: e, outerHeight: t };
  }, [e, t, n.top, n.right, n.bottom, n.left]);
}, A_ = function() {
  var e = Lt(null), t = Yt({ left: 0, top: 0, width: 0, height: 0 }), n = t[0], r = t[1], o = Yt(function() {
    return typeof ResizeObserver > "u" ? null : new ResizeObserver(function(i) {
      var a = i[0];
      return r(a.contentRect);
    });
  })[0];
  return dn(function() {
    return e.current && o !== null && o.observe(e.current), function() {
      o !== null && o.disconnect();
    };
  }, []), [e, n];
}, VV = function(e) {
  return Te(function() {
    return WV(BV, e);
  }, [e]);
}, UV = function(e) {
  return typeof e == "function" ? e : typeof e == "string" ? e.indexOf("time:") === 0 ? A4(e.slice("5")) : T4(e) : function(t) {
    return "" + t;
  };
}, Fa = function(e) {
  return Te(function() {
    return UV(e);
  }, [e]);
}, O_ = _o(), zV = {}, N_ = function(e) {
  var t = e.theme, n = t === void 0 ? zV : t, r = e.children, o = VV(n);
  return b(O_.Provider, { value: o, children: r });
};
N_.propTypes = { children: J.node.isRequired, theme: J.object };
var xt = function() {
  return Yn(O_);
}, YV = ["outlineWidth", "outlineColor", "outlineOpacity"], W4 = function(e) {
  return e.outlineWidth, e.outlineColor, e.outlineOpacity, _c(e, YV);
}, D_ = function(e) {
  var t = e.children, n = e.condition, r = e.wrapper;
  return n ? YS(r, {}, t) : t;
};
D_.propTypes = { children: J.node.isRequired, condition: J.bool.isRequired, wrapper: J.element.isRequired };
var GV = { position: "relative" }, Sc = function(e) {
  var t = e.children, n = e.theme, r = e.renderWrapper, o = r === void 0 || r, i = e.isInteractive, a = i === void 0 || i, s = e.animate, l = e.motionConfig, c = Lt(null);
  return b(N_, { theme: n, children: b(T_, { animate: s, config: l, children: b(GB, { container: c, children: ie(D_, { condition: o, wrapper: b("div", { style: GV, ref: c }), children: [t, a && b(YB, {})] }) }) }) });
};
Sc.propTypes = { children: J.element.isRequired, isInteractive: J.bool, renderWrapper: J.bool, theme: J.object, animate: J.bool, motionConfig: J.oneOfType([J.string, k0.motionConfig]) };
J.func.isRequired, J.bool, J.bool, J.object.isRequired, J.bool.isRequired, J.oneOfType([J.string, k0.motionConfig]);
var gs = function(e) {
  var t = e.children, n = A_(), r = n[0], o = n[1], i = o.width > 0 && o.height > 0;
  return b("div", { ref: r, style: { width: "100%", height: "100%" }, children: i && t({ width: o.width, height: o.height }) });
};
gs.propTypes = { children: J.func.isRequired };
var KV = ["id", "colors"], I_ = function(e) {
  var t = e.id, n = e.colors, r = _c(e, KV);
  return b("linearGradient", wn({ id: t, x1: 0, x2: 0, y1: 0, y2: 1 }, r, { children: n.map(function(o) {
    var i = o.offset, a = o.color, s = o.opacity;
    return b("stop", { offset: i + "%", stopColor: a, stopOpacity: s !== void 0 ? s : 1 }, i);
  }) }));
};
I_.propTypes = { id: J.string.isRequired, colors: J.arrayOf(J.shape({ offset: J.number.isRequired, color: J.string.isRequired, opacity: J.number })).isRequired, gradientTransform: J.string };
var B_ = { linearGradient: I_ }, Xi = { color: "#000000", background: "#ffffff", size: 4, padding: 4, stagger: !1 }, p9 = lt(function(e) {
  var t = e.id, n = e.background, r = n === void 0 ? Xi.background : n, o = e.color, i = o === void 0 ? Xi.color : o, a = e.size, s = a === void 0 ? Xi.size : a, l = e.padding, c = l === void 0 ? Xi.padding : l, f = e.stagger, u = f === void 0 ? Xi.stagger : f, h = s + c, m = s / 2, g = c / 2;
  return u === !0 && (h = 2 * s + 2 * c), ie("pattern", { id: t, width: h, height: h, patternUnits: "userSpaceOnUse", children: [b("rect", { width: h, height: h, fill: r }), b("circle", { cx: g + m, cy: g + m, r: m, fill: i }), u && b("circle", { cx: 1.5 * c + s + m, cy: 1.5 * c + s + m, r: m, fill: i })] });
});
p9.displayName = "PatternDots", p9.propTypes = { id: J.string.isRequired, color: J.string.isRequired, background: J.string.isRequired, size: J.number.isRequired, padding: J.number.isRequired, stagger: J.bool.isRequired };
var Wa = function(e) {
  return e * Math.PI / 180;
}, ZV = function(e) {
  return 180 * e / Math.PI;
}, XV = function(e, t) {
  return { x: Math.cos(e) * t, y: Math.sin(e) * t };
}, QV = function(e) {
  var t = e % 360;
  return t < 0 && (t += 360), t;
}, JV = { svg: { align: { left: "start", center: "middle", right: "end", start: "start", middle: "middle", end: "end" }, baseline: { top: "text-before-edge", center: "central", bottom: "alphabetic" } }, canvas: { align: { left: "left", center: "center", right: "right", start: "left", middle: "center", end: "right" }, baseline: { top: "top", center: "middle", bottom: "bottom" } } }, Qi = { spacing: 5, rotation: 0, background: "#000000", color: "#ffffff", lineWidth: 2 }, g9 = lt(function(e) {
  var t = e.id, n = e.spacing, r = n === void 0 ? Qi.spacing : n, o = e.rotation, i = o === void 0 ? Qi.rotation : o, a = e.background, s = a === void 0 ? Qi.background : a, l = e.color, c = l === void 0 ? Qi.color : l, f = e.lineWidth, u = f === void 0 ? Qi.lineWidth : f, h = Math.round(i) % 360, m = Math.abs(r);
  h > 180 ? h -= 360 : h > 90 ? h -= 180 : h < -180 ? h += 360 : h < -90 && (h += 180);
  var g, p = m, v = m;
  return h === 0 ? g = `
                M 0 0 L ` + p + ` 0
                M 0 ` + v + " L " + p + " " + v + `
            ` : h === 90 ? g = `
                M 0 0 L 0 ` + v + `
                M ` + p + " 0 L " + p + " " + v + `
            ` : (p = Math.abs(m / Math.sin(Wa(h))), v = m / Math.sin(Wa(90 - h)), g = h > 0 ? `
                    M 0 ` + -v + " L " + 2 * p + " " + v + `
                    M ` + -p + " " + -v + " L " + p + " " + v + `
                    M ` + -p + " 0 L " + p + " " + 2 * v + `
                ` : `
                    M ` + -p + " " + v + " L " + p + " " + -v + `
                    M ` + -p + " " + 2 * v + " L " + 2 * p + " " + -v + `
                    M 0 ` + 2 * v + " L " + 2 * p + ` 0
                `), ie("pattern", { id: t, width: p, height: v, patternUnits: "userSpaceOnUse", children: [b("rect", { width: p, height: v, fill: s, stroke: "rgba(255, 0, 0, 0.1)", strokeWidth: 0 }), b("path", { d: g, strokeWidth: u, stroke: c, strokeLinecap: "square" })] });
});
g9.displayName = "PatternLines", g9.propTypes = { id: J.string.isRequired, spacing: J.number.isRequired, rotation: J.number.isRequired, background: J.string.isRequired, color: J.string.isRequired, lineWidth: J.number.isRequired };
var Ji = { color: "#000000", background: "#ffffff", size: 4, padding: 4, stagger: !1 }, v9 = lt(function(e) {
  var t = e.id, n = e.color, r = n === void 0 ? Ji.color : n, o = e.background, i = o === void 0 ? Ji.background : o, a = e.size, s = a === void 0 ? Ji.size : a, l = e.padding, c = l === void 0 ? Ji.padding : l, f = e.stagger, u = f === void 0 ? Ji.stagger : f, h = s + c, m = c / 2;
  return u === !0 && (h = 2 * s + 2 * c), ie("pattern", { id: t, width: h, height: h, patternUnits: "userSpaceOnUse", children: [b("rect", { width: h, height: h, fill: i }), b("rect", { x: m, y: m, width: s, height: s, fill: r }), u && b("rect", { x: 1.5 * c + s, y: 1.5 * c + s, width: s, height: s, fill: r })] });
});
v9.displayName = "PatternSquares", v9.propTypes = { id: J.string.isRequired, color: J.string.isRequired, background: J.string.isRequired, size: J.number.isRequired, padding: J.number.isRequired, stagger: J.bool.isRequired };
var $_ = { patternDots: p9, patternLines: g9, patternSquares: v9 }, eU = ["type"], b9 = wn({}, B_, $_), F_ = function(e) {
  var t = e.defs;
  return !t || t.length < 1 ? null : b("defs", { "aria-hidden": !0, children: t.map(function(n) {
    var r = n.type, o = _c(n, eU);
    return b9[r] ? $t(b9[r], wn({ key: o.id }, o)) : null;
  }) });
};
F_.propTypes = { defs: J.arrayOf(J.shape({ type: J.oneOf(Object.keys(b9)).isRequired, id: J.string.isRequired })) };
var tU = lt(F_), q4 = function(e) {
  var t = e.width, n = e.height, r = e.margin, o = e.defs, i = e.children, a = e.role, s = e.ariaLabel, l = e.ariaLabelledBy, c = e.ariaDescribedBy, f = e.isFocusable, u = xt();
  return ie("svg", { xmlns: "http://www.w3.org/2000/svg", width: t, height: n, role: a, "aria-label": s, "aria-labelledby": l, "aria-describedby": c, focusable: f, tabIndex: f ? 0 : void 0, children: [b(tU, { defs: o }), b("rect", { width: t, height: n, fill: u.background }), b("g", { transform: "translate(" + r.left + "," + r.top + ")", children: i })] });
};
q4.propTypes = { width: J.number.isRequired, height: J.number.isRequired, margin: J.shape({ top: J.number.isRequired, left: J.number.isRequired }).isRequired, defs: J.array, children: J.oneOfType([J.arrayOf(J.node), J.node]).isRequired, role: J.string, isFocusable: J.bool, ariaLabel: J.string, ariaLabelledBy: J.string, ariaDescribedBy: J.string };
var W_ = function(e) {
  var t = e.size, n = e.color, r = e.borderWidth, o = e.borderColor;
  return b("circle", { r: t / 2, fill: n, stroke: o, strokeWidth: r, style: { pointerEvents: "none" } });
};
W_.propTypes = { size: J.number.isRequired, color: J.string.isRequired, borderWidth: J.number.isRequired, borderColor: J.string.isRequired };
var nU = lt(W_), q_ = function(e) {
  var t = e.x, n = e.y, r = e.symbol, o = r === void 0 ? nU : r, i = e.size, a = e.datum, s = e.color, l = e.borderWidth, c = e.borderColor, f = e.label, u = e.labelTextAnchor, h = u === void 0 ? "middle" : u, m = e.labelYOffset, g = m === void 0 ? -12 : m, p = xt(), v = kn(), y = v.animate, C = v.config, w = tr({ transform: "translate(" + t + ", " + n + ")", config: C, immediate: !y });
  return ie(_t.g, { transform: w.transform, style: { pointerEvents: "none" }, children: [$t(o, { size: i, color: s, datum: a, borderWidth: l, borderColor: c }), f && b("text", { textAnchor: h, y: g, style: W4(p.dots.text), children: f })] });
};
q_.propTypes = { x: J.number.isRequired, y: J.number.isRequired, datum: J.object.isRequired, size: J.number.isRequired, color: J.string.isRequired, borderWidth: J.number.isRequired, borderColor: J.string.isRequired, symbol: J.oneOfType([J.func, J.object]), label: J.oneOfType([J.string, J.number]), labelTextAnchor: J.oneOf(["start", "middle", "end"]), labelYOffset: J.number };
var rU = lt(q_), j_ = function(e) {
  var t = e.width, n = e.height, r = e.axis, o = e.scale, i = e.value, a = e.lineStyle, s = e.textStyle, l = e.legend, c = e.legendNode, f = e.legendPosition, u = f === void 0 ? "top-right" : f, h = e.legendOffsetX, m = h === void 0 ? 14 : h, g = e.legendOffsetY, p = g === void 0 ? 14 : g, v = e.legendOrientation, y = v === void 0 ? "horizontal" : v, C = xt(), w = 0, _ = 0, x = 0, k = 0;
  if (r === "y" ? (x = o(i), _ = t) : (w = o(i), k = n), l && !c) {
    var S = function(T) {
      var L = T.axis, R = T.width, M = T.height, A = T.position, O = T.offsetX, I = T.offsetY, W = T.orientation, N = 0, H = 0, q = W === "vertical" ? -90 : 0, D = "start";
      if (L === "x") switch (A) {
        case "top-left":
          N = -O, H = I, D = "end";
          break;
        case "top":
          H = -I, D = W === "horizontal" ? "middle" : "start";
          break;
        case "top-right":
          N = O, H = I, D = W === "horizontal" ? "start" : "end";
          break;
        case "right":
          N = O, H = M / 2, D = W === "horizontal" ? "start" : "middle";
          break;
        case "bottom-right":
          N = O, H = M - I, D = "start";
          break;
        case "bottom":
          H = M + I, D = W === "horizontal" ? "middle" : "end";
          break;
        case "bottom-left":
          H = M - I, N = -O, D = W === "horizontal" ? "end" : "start";
          break;
        case "left":
          N = -O, H = M / 2, D = W === "horizontal" ? "end" : "middle";
      }
      else switch (A) {
        case "top-left":
          N = O, H = -I, D = "start";
          break;
        case "top":
          N = R / 2, H = -I, D = W === "horizontal" ? "middle" : "start";
          break;
        case "top-right":
          N = R - O, H = -I, D = W === "horizontal" ? "end" : "start";
          break;
        case "right":
          N = R + O, D = W === "horizontal" ? "start" : "middle";
          break;
        case "bottom-right":
          N = R - O, H = I, D = "end";
          break;
        case "bottom":
          N = R / 2, H = I, D = W === "horizontal" ? "middle" : "end";
          break;
        case "bottom-left":
          N = O, H = I, D = W === "horizontal" ? "start" : "end";
          break;
        case "left":
          N = -O, D = W === "horizontal" ? "end" : "middle";
      }
      return { x: N, y: H, rotation: q, textAnchor: D };
    }({ axis: r, width: t, height: n, position: u, offsetX: m, offsetY: p, orientation: y });
    c = b("text", { transform: "translate(" + S.x + ", " + S.y + ") rotate(" + S.rotation + ")", textAnchor: S.textAnchor, dominantBaseline: "central", style: s, children: l });
  }
  return ie("g", { transform: "translate(" + w + ", " + x + ")", children: [b("line", { x1: 0, x2: _, y1: 0, y2: k, stroke: C.markers.lineColor, strokeWidth: C.markers.lineStrokeWidth, style: a }), c] });
};
j_.propTypes = { width: J.number.isRequired, height: J.number.isRequired, axis: J.oneOf(["x", "y"]).isRequired, scale: J.func.isRequired, value: J.oneOfType([J.number, J.string, J.instanceOf(Date)]).isRequired, lineStyle: J.object, textStyle: J.object, legend: J.string, legendPosition: J.oneOf(["top-left", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left"]), legendOffsetX: J.number.isRequired, legendOffsetY: J.number.isRequired, legendOrientation: J.oneOf(["horizontal", "vertical"]).isRequired };
var oU = lt(j_), H_ = function(e) {
  var t = e.markers, n = e.width, r = e.height, o = e.xScale, i = e.yScale;
  return t && t.length !== 0 ? t.map(function(a, s) {
    return b(oU, wn({}, a, { width: n, height: r, scale: a.axis === "y" ? i : o }), s);
  }) : null;
};
H_.propTypes = { width: J.number.isRequired, height: J.number.isRequired, xScale: J.func.isRequired, yScale: J.func.isRequired, markers: J.arrayOf(J.shape({ axis: J.oneOf(["x", "y"]).isRequired, value: J.oneOfType([J.number, J.string, J.instanceOf(Date)]).isRequired, lineStyle: J.object, textStyle: J.object })) };
var V_ = lt(H_), iU = ["theme", "renderWrapper", "animate", "motionConfig"], U_ = function(e) {
  return function(t) {
    var n, r;
    function o() {
      return t.apply(this, arguments) || this;
    }
    return r = t, (n = o).prototype = Object.create(r.prototype), n.prototype.constructor = n, h9(n, r), o.prototype.render = function() {
      var i = this.props, a = i.theme, s = i.renderWrapper, l = i.animate, c = i.motionConfig, f = _c(i, iU);
      return b(Sc, { theme: a, renderWrapper: s, isInteractive: f.isInteractive, animate: l, motionConfig: c, children: b(e, wn({}, f)) });
    }, o;
  }(GS);
}, aU = function(e, t) {
  var n = y4(e) ? e : function(r) {
    return Zn(r, e);
  };
  return n;
}, z_ = function(e) {
  return y4(e) ? e : function(t) {
    return Zn(t, e);
  };
}, ff = function(e) {
  return Te(function() {
    return z_(e);
  }, [e]);
}, sU = function(e, t, n, r) {
  var o = n - e, i = r - t;
  return o *= o, i *= i, Math.sqrt(o + i);
}, Y_ = function(e, t, n, r, o, i) {
  return e <= o && o <= e + n && t <= i && i <= t + r;
}, pa = function(e, t) {
  var n, r = "touches" in t ? t.touches[0] : t, o = r.clientX, i = r.clientY, a = e.getBoundingClientRect(), s = (n = e.getBBox !== void 0 ? e.getBBox() : { width: e.offsetWidth || 0, height: e.offsetHeight || 0 }).width === a.width ? 1 : n.width / a.width;
  return [(o - a.left) * s, (i - a.top) * s];
}, lU = Object.keys(B_), cU = Object.keys($_), uU = function(e, t, n) {
  if (e === "*") return !0;
  if (y4(e)) return e(t);
  if (O4(e)) {
    var r = n ? Zn(t, n) : t;
    return IV(_V(r, Object.keys(e)), e);
  }
  return !1;
}, G_ = function(e, t, n, r) {
  var o = r === void 0 ? {} : r, i = o.dataKey, a = o.colorKey, s = a === void 0 ? "color" : a, l = o.targetKey, c = l === void 0 ? "fill" : l, f = [], u = {};
  return e.length && t.length && (f = [].concat(e), t.forEach(function(h) {
    for (var m = function() {
      var p = n[g], v = p.id, y = p.match;
      if (uU(y, h, i)) {
        var C = e.find(function(R) {
          return R.id === v;
        });
        if (C) {
          if (cU.includes(C.type)) if (C.background === "inherit" || C.color === "inherit") {
            var w = Zn(h, s), _ = C.background, x = C.color, k = v;
            C.background === "inherit" && (k = k + ".bg." + w, _ = w), C.color === "inherit" && (k = k + ".fg." + w, x = w), ca(h, c, "url(#" + k + ")"), u[k] || (f.push(wn({}, C, { id: k, background: _, color: x })), u[k] = 1);
          } else ca(h, c, "url(#" + v + ")");
          else if (lU.includes(C.type))
            if (C.colors.map(function(R) {
              return R.color;
            }).includes("inherit")) {
              var S = Zn(h, s), T = v, L = wn({}, C, { colors: C.colors.map(function(R, M) {
                return R.color !== "inherit" ? R : (T = T + "." + M + "." + S, wn({}, R, { color: R.color === "inherit" ? S : R.color }));
              }) });
              L.id = T, ca(h, c, "url(#" + T + ")"), u[T] || (f.push(L), u[T] = 1);
            } else ca(h, c, "url(#" + v + ")");
        }
        return "break";
      }
    }, g = 0; g < n.length && m() !== "break"; g++)
      ;
  })), f;
}, hf, km;
function dU() {
  if (km) return hf;
  km = 1;
  function e() {
  }
  return hf = e, hf;
}
var mf, Sm;
function fU() {
  if (Sm) return mf;
  Sm = 1;
  var e = E_(), t = dU(), n = D4(), r = 1 / 0, o = e && 1 / n(new e([, -0]))[1] == r ? function(i) {
    return new e(i);
  } : t;
  return mf = o, mf;
}
var pf, Mm;
function K_() {
  if (Mm) return pf;
  Mm = 1;
  var e = C4(), t = Rx(), n = Ax(), r = w4(), o = fU(), i = D4(), a = 200;
  function s(l, c, f) {
    var u = -1, h = t, m = l.length, g = !0, p = [], v = p;
    if (f)
      g = !1, h = n;
    else if (m >= a) {
      var y = c ? null : o(l);
      if (y)
        return i(y);
      g = !1, h = r, v = new e();
    } else
      v = c ? [] : p;
    e:
      for (; ++u < m; ) {
        var C = l[u], w = c ? c(C) : C;
        if (C = f || C !== 0 ? C : 0, g && w === w) {
          for (var _ = v.length; _--; )
            if (v[_] === w)
              continue e;
          c && v.push(w), p.push(C);
        } else h(v, w, f) || (v !== p && v.push(w), p.push(C));
      }
    return p;
  }
  return pf = s, pf;
}
var gf, Em;
function hU() {
  if (Em) return gf;
  Em = 1;
  var e = K_();
  function t(n) {
    return n && n.length ? e(n) : [];
  }
  return gf = t, gf;
}
var mU = hU();
const Lm = /* @__PURE__ */ Ht(mU);
var vf, Tm;
function pU() {
  if (Tm) return vf;
  Tm = 1;
  var e = Rl(), t = B4(), n = 1, r = 2;
  function o(i, a, s, l) {
    var c = s.length, f = c, u = !l;
    if (i == null)
      return !f;
    for (i = Object(i); c--; ) {
      var h = s[c];
      if (u && h[2] ? h[1] !== i[h[0]] : !(h[0] in i))
        return !1;
    }
    for (; ++c < f; ) {
      h = s[c];
      var m = h[0], g = i[m], p = h[1];
      if (u && h[2]) {
        if (g === void 0 && !(m in i))
          return !1;
      } else {
        var v = new e();
        if (l)
          var y = l(g, p, m, i, a, v);
        if (!(y === void 0 ? t(p, g, n | r, l, v) : y))
          return !1;
      }
    }
    return !0;
  }
  return vf = o, vf;
}
var bf, Pm;
function Z_() {
  if (Pm) return bf;
  Pm = 1;
  var e = rr();
  function t(n) {
    return n === n && !e(n);
  }
  return bf = t, bf;
}
var yf, Rm;
function gU() {
  if (Rm) return yf;
  Rm = 1;
  var e = Z_(), t = ps();
  function n(r) {
    for (var o = t(r), i = o.length; i--; ) {
      var a = o[i], s = r[a];
      o[i] = [a, s, e(s)];
    }
    return o;
  }
  return yf = n, yf;
}
var Cf, Am;
function X_() {
  if (Am) return Cf;
  Am = 1;
  function e(t, n) {
    return function(r) {
      return r == null ? !1 : r[t] === n && (n !== void 0 || t in Object(r));
    };
  }
  return Cf = e, Cf;
}
var wf, Om;
function vU() {
  if (Om) return wf;
  Om = 1;
  var e = pU(), t = gU(), n = X_();
  function r(o) {
    var i = t(o);
    return i.length == 1 && i[0][2] ? n(i[0][0], i[0][1]) : function(a) {
      return a === o || e(a, o, i);
    };
  }
  return wf = r, wf;
}
var xf, Nm;
function bU() {
  if (Nm) return xf;
  Nm = 1;
  var e = B4(), t = ox(), n = y_(), r = e4(), o = Z_(), i = X_(), a = Ni(), s = 1, l = 2;
  function c(f, u) {
    return r(f) && o(u) ? i(a(f), u) : function(h) {
      var m = t(h, f);
      return m === void 0 && m === u ? n(h, f) : e(u, m, s | l);
    };
  }
  return xf = c, xf;
}
var _f, Dm;
function yU() {
  if (Dm) return _f;
  Dm = 1;
  function e(t) {
    return function(n) {
      return n == null ? void 0 : n[t];
    };
  }
  return _f = e, _f;
}
var kf, Im;
function CU() {
  if (Im) return kf;
  Im = 1;
  var e = hs();
  function t(n) {
    return function(r) {
      return e(r, n);
    };
  }
  return kf = t, kf;
}
var Sf, Bm;
function wU() {
  if (Bm) return Sf;
  Bm = 1;
  var e = yU(), t = CU(), n = e4(), r = Ni();
  function o(i) {
    return n(i) ? e(r(i)) : t(i);
  }
  return Sf = o, Sf;
}
var Mf, $m;
function j4() {
  if ($m) return Mf;
  $m = 1;
  var e = vU(), t = bU(), n = Il(), r = on(), o = wU();
  function i(a) {
    return typeof a == "function" ? a : a == null ? n : typeof a == "object" ? r(a) ? t(a[0], a[1]) : e(a) : o(a);
  }
  return Mf = i, Mf;
}
var Ef, Fm;
function xU() {
  if (Fm) return Ef;
  Fm = 1;
  var e = j4(), t = K_();
  function n(r, o) {
    return r && r.length ? t(r, e(o, 2)) : [];
  }
  return Ef = n, Ef;
}
var _U = xU();
const y9 = /* @__PURE__ */ Ht(_U);
var Lf, Wm;
function kU() {
  if (Wm) return Lf;
  Wm = 1;
  var e = Vw(), t = ps();
  function n(r, o) {
    return r && e(r, o, t);
  }
  return Lf = n, Lf;
}
var Tf, qm;
function SU() {
  if (qm) return Tf;
  qm = 1;
  var e = Pi();
  function t(n, r) {
    return function(o, i) {
      if (o == null)
        return o;
      if (!e(o))
        return n(o, i);
      for (var a = o.length, s = r ? a : -1, l = Object(o); (r ? s-- : ++s < a) && i(l[s], s, l) !== !1; )
        ;
      return o;
    };
  }
  return Tf = t, Tf;
}
var Pf, jm;
function Q_() {
  if (jm) return Pf;
  jm = 1;
  var e = kU(), t = SU(), n = t(e);
  return Pf = n, Pf;
}
var Rf, Hm;
function MU() {
  if (Hm) return Rf;
  Hm = 1;
  var e = Q_(), t = Pi();
  function n(r, o) {
    var i = -1, a = t(r) ? Array(r.length) : [];
    return e(r, function(s, l, c) {
      a[++i] = o(s, l, c);
    }), a;
  }
  return Rf = n, Rf;
}
var Af, Vm;
function EU() {
  if (Vm) return Af;
  Vm = 1;
  function e(t, n) {
    var r = t.length;
    for (t.sort(n); r--; )
      t[r] = t[r].value;
    return t;
  }
  return Af = e, Af;
}
var Of, Um;
function LU() {
  if (Um) return Of;
  Um = 1;
  var e = Bl();
  function t(n, r) {
    if (n !== r) {
      var o = n !== void 0, i = n === null, a = n === n, s = e(n), l = r !== void 0, c = r === null, f = r === r, u = e(r);
      if (!c && !u && !s && n > r || s && l && f && !c && !u || i && l && f || !o && f || !a)
        return 1;
      if (!i && !s && !u && n < r || u && o && a && !i && !s || c && o && a || !l && a || !f)
        return -1;
    }
    return 0;
  }
  return Of = t, Of;
}
var Nf, zm;
function TU() {
  if (zm) return Nf;
  zm = 1;
  var e = LU();
  function t(n, r, o) {
    for (var i = -1, a = n.criteria, s = r.criteria, l = a.length, c = o.length; ++i < l; ) {
      var f = e(a[i], s[i]);
      if (f) {
        if (i >= c)
          return f;
        var u = o[i];
        return f * (u == "desc" ? -1 : 1);
      }
    }
    return n.index - r.index;
  }
  return Nf = t, Nf;
}
var Df, Ym;
function PU() {
  if (Ym) return Df;
  Ym = 1;
  var e = $l(), t = hs(), n = j4(), r = MU(), o = EU(), i = Ri(), a = TU(), s = Il(), l = on();
  function c(f, u, h) {
    u.length ? u = e(u, function(p) {
      return l(p) ? function(v) {
        return t(v, p.length === 1 ? p[0] : p);
      } : p;
    }) : u = [s];
    var m = -1;
    u = e(u, i(n));
    var g = r(f, function(p, v, y) {
      var C = e(u, function(w) {
        return w(p);
      });
      return { criteria: C, index: ++m, value: p };
    });
    return o(g, function(p, v) {
      return a(p, v, h);
    });
  }
  return Df = c, Df;
}
var If, Gm;
function RU() {
  if (Gm) return If;
  Gm = 1;
  var e = C_(), t = PU(), n = Jh(), r = nx(), o = n(function(i, a) {
    if (i == null)
      return [];
    var s = a.length;
    return s > 1 && r(i, a[0], a[1]) ? a = [] : s > 2 && r(a[0], a[1], a[2]) && (a = [a[0]]), t(i, e(a, 1), []);
  });
  return If = o, If;
}
var AU = RU();
const OU = /* @__PURE__ */ Ht(AU);
var Bf, Km;
function NU() {
  if (Km) return Bf;
  Km = 1;
  var e = _r(), t = _n(), n = "[object Date]";
  function r(o) {
    return t(o) && e(o) == n;
  }
  return Bf = r, Bf;
}
var $f, Zm;
function DU() {
  if (Zm) return $f;
  Zm = 1;
  var e = NU(), t = Ri(), n = Nl(), r = n && n.isDate, o = r ? t(r) : e;
  return $f = o, $f;
}
var IU = DU();
const BU = /* @__PURE__ */ Ht(IU);
function eo() {
  return eo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, eo.apply(this, arguments);
}
var Ho = [function(e) {
  return e.setMilliseconds(0);
}, function(e) {
  return e.setSeconds(0);
}, function(e) {
  return e.setMinutes(0);
}, function(e) {
  return e.setHours(0);
}, function(e) {
  return e.setDate(1);
}, function(e) {
  return e.setMonth(0);
}], $U = { millisecond: [], second: Ho.slice(0, 1), minute: Ho.slice(0, 2), hour: Ho.slice(0, 3), day: Ho.slice(0, 4), month: Ho.slice(0, 5), year: Ho.slice(0, 6) }, FU = function(e) {
  return function(t) {
    return $U[e].forEach(function(n) {
      n(t);
    }), t;
  };
}, J_ = function(e) {
  var t = e.format, n = t === void 0 ? "native" : t, r = e.precision, o = r === void 0 ? "millisecond" : r, i = e.useUTC, a = i === void 0 || i, s = FU(o);
  return function(l) {
    if (l === void 0) return l;
    if (n === "native" || l instanceof Date) return s(l);
    var c = a ? b_(n) : v_(n);
    return s(c(l));
  };
}, WU = function(e, t, n, r) {
  var o, i, a, s, l = e.min, c = l === void 0 ? 0 : l, f = e.max, u = f === void 0 ? "auto" : f, h = e.stacked, m = h !== void 0 && h, g = e.reverse, p = g !== void 0 && g, v = e.clamp, y = v !== void 0 && v, C = e.nice, w = C !== void 0 && C;
  c === "auto" ? o = m === !0 ? (i = t.minStacked) != null ? i : 0 : t.min : o = c, u === "auto" ? a = m === !0 ? (s = t.maxStacked) != null ? s : 0 : t.max : a = u;
  var _ = bx().rangeRound(r === "x" ? [0, n] : [n, 0]).domain(p ? [a, o] : [o, a]).clamp(y);
  return w === !0 ? _.nice() : typeof w == "number" && _.nice(w), qU(_, m);
}, qU = function(e, t) {
  t === void 0 && (t = !1);
  var n = e;
  return n.type = "linear", n.stacked = t, n;
}, jU = function(e, t, n) {
  var r = WF().range([0, n]).domain(t.all);
  return r.type = "point", r;
}, HU = function(e, t, n, r) {
  var o = e.round, i = o === void 0 || o, a = s4().range(r === "x" ? [0, n] : [n, 0]).domain(t.all).round(i);
  return VU(a);
}, VU = function(e) {
  var t = e;
  return t.type = "band", t;
}, UU = function(e, t, n) {
  var r, o, i = e.format, a = i === void 0 ? "native" : i, s = e.precision, l = s === void 0 ? "millisecond" : s, c = e.min, f = c === void 0 ? "auto" : c, u = e.max, h = u === void 0 ? "auto" : u, m = e.useUTC, g = m === void 0 || m, p = e.nice, v = p !== void 0 && p, y = J_({ format: a, precision: l, useUTC: g });
  r = f === "auto" ? y(t.min) : a !== "native" ? y(f) : f, o = h === "auto" ? y(t.max) : a !== "native" ? y(h) : h;
  var C = g ? Eq() : Mq();
  C.range([0, n]), r && o && C.domain([r, o]), v === !0 ? C.nice() : typeof v != "object" && typeof v != "number" || C.nice(v);
  var w = C;
  return w.type = "time", w.useUTC = g, w;
}, zU = function(e, t, n, r) {
  var o, i = e.base, a = i === void 0 ? 10 : i, s = e.min, l = s === void 0 ? "auto" : s, c = e.max, f = c === void 0 ? "auto" : c;
  if (t.all.some(function(p) {
    return p === 0;
  })) throw new Error("a log scale domain must not include or cross zero");
  var u, h, m = !1;
  if (t.all.filter(function(p) {
    return p != null;
  }).forEach(function(p) {
    m || (o === void 0 ? o = Math.sign(p) : Math.sign(p) !== o && (m = !0));
  }), m) throw new Error("a log scale domain must be strictly-positive or strictly-negative");
  u = l === "auto" ? t.min : l, h = f === "auto" ? t.max : f;
  var g = Cx().domain([u, h]).rangeRound(r === "x" ? [0, n] : [n, 0]).base(a).nice();
  return g.type = "log", g;
}, YU = function(e, t, n, r) {
  var o, i, a = e.constant, s = a === void 0 ? 1 : a, l = e.min, c = l === void 0 ? "auto" : l, f = e.max, u = f === void 0 ? "auto" : f, h = e.reverse, m = h !== void 0 && h;
  o = c === "auto" ? t.min : c, i = u === "auto" ? t.max : u;
  var g = wx().constant(s).rangeRound(r === "x" ? [0, n] : [n, 0]).nice();
  m === !0 ? g.domain([i, o]) : g.domain([o, i]);
  var p = g;
  return p.type = "symlog", p;
}, GU = function(e) {
  return e === "x" ? "y" : "x";
}, KU = function(e, t) {
  return e === t;
}, ZU = function(e, t) {
  return e.getTime() === t.getTime();
};
function qa(e, t, n, r) {
  switch (e.type) {
    case "linear":
      return WU(e, t, n, r);
    case "point":
      return jU(e, t, n);
    case "band":
      return HU(e, t, n, r);
    case "time":
      return UU(e, t, n);
    case "log":
      return zU(e, t, n, r);
    case "symlog":
      return YU(e, t, n, r);
    default:
      throw new Error("invalid scale spec");
  }
}
var Xm = function(e, t, n) {
  var r;
  if ("stacked" in n && n.stacked) {
    var o = e.data[t === "x" ? "xStacked" : "yStacked"];
    return o == null ? null : n(o);
  }
  return (r = n(e.data[t])) != null ? r : null;
}, XU = function(e, t, n, r, o) {
  var i = e.map(function(f) {
    return function(u) {
      return eo({}, u, { data: u.data.map(function(h) {
        return { data: eo({}, h) };
      }) });
    }(f);
  }), a = QU(i, t, n);
  "stacked" in t && t.stacked === !0 && JU(a, i), "stacked" in n && n.stacked === !0 && ez(a, i);
  var s = qa(t, a.x, r, "x"), l = qa(n, a.y, o, "y"), c = i.map(function(f) {
    return eo({}, f, { data: f.data.map(function(u) {
      return eo({}, u, { position: { x: Xm(u, "x", s), y: Xm(u, "y", l) } });
    }) });
  });
  return eo({}, a, { series: c, xScale: s, yScale: l });
}, QU = function(e, t, n) {
  return { x: Qm(e, "x", t), y: Qm(e, "y", n) };
}, Qm = function(e, t, n, r) {
  var o = {}, i = o.getValue, a = i === void 0 ? function(g) {
    return g.data[t];
  } : i, s = o.setValue, l = s === void 0 ? function(g, p) {
    g.data[t] = p;
  } : s;
  if (n.type === "linear") e.forEach(function(g) {
    g.data.forEach(function(p) {
      var v = a(p);
      v && l(p, parseFloat(String(v)));
    });
  });
  else if (n.type === "time" && n.format !== "native") {
    var c = J_(n);
    e.forEach(function(g) {
      g.data.forEach(function(p) {
        var v = a(p);
        v && l(p, c(v));
      });
    });
  }
  var f = [];
  switch (e.forEach(function(g) {
    g.data.forEach(function(p) {
      f.push(a(p));
    });
  }), n.type) {
    case "linear":
      var u = OU(Lm(f).filter(function(g) {
        return g !== null;
      }), function(g) {
        return g;
      });
      return { all: u, min: Math.min.apply(Math, u), max: Math.max.apply(Math, u) };
    case "time":
      var h = y9(f, function(g) {
        return g.getTime();
      }).slice(0).sort(function(g, p) {
        return p.getTime() - g.getTime();
      }).reverse();
      return { all: h, min: h[0], max: ye(h) };
    default:
      var m = Lm(f);
      return { all: m, min: m[0], max: ye(m) };
  }
}, ek = function(e, t, n) {
  var r = GU(e), o = [];
  t[r].all.forEach(function(i) {
    var a = BU(i) ? ZU : KU, s = [];
    n.forEach(function(l) {
      var c = l.data.find(function(m) {
        return a(m.data[r], i);
      }), f = null, u = null;
      if (c !== void 0) {
        if ((f = c.data[e]) !== null) {
          var h = ye(s);
          h === void 0 ? u = f : h !== null && (u = h + f);
        }
        c.data[e === "x" ? "xStacked" : "yStacked"] = u;
      }
      s.push(u), u !== null && o.push(u);
    });
  }), t[e].minStacked = Math.min.apply(Math, o), t[e].maxStacked = Math.max.apply(Math, o);
}, JU = function(e, t) {
  return ek("x", e, t);
}, ez = function(e, t) {
  return ek("y", e, t);
}, tk = function(e) {
  var t = e.bandwidth();
  if (t === 0) return e;
  var n = t / 2;
  return e.round() && (n = Math.round(n)), function(r) {
    var o;
    return ((o = e(r)) != null ? o : 0) + n;
  };
}, nk = { millisecond: [Ia, Ia], second: [f9, f9], minute: [Jx, a_], hour: [e_, s_], day: [Ft(function(e) {
  return e.setHours(0, 0, 0, 0);
}, function(e, t) {
  return e.setDate(e.getDate() + t);
}, function(e, t) {
  return (t.getTime() - e.getTime()) / 864e5;
}, function(e) {
  return Math.floor(e.getTime() / 864e5);
}), Ft(function(e) {
  return e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  return e.setUTCDate(e.getUTCDate() + t);
}, function(e, t) {
  return (t.getTime() - e.getTime()) / 864e5;
}, function(e) {
  return Math.floor(e.getTime() / 864e5);
})], week: [x0, _0], sunday: [x0, _0], monday: [Ba, $a], tuesday: [t_, l_], wednesday: [n_, c_], thursday: [Co, wo], friday: [r_, u_], saturday: [o_, d_], month: [i_, f_], year: [Vr, Ur] }, tz = Object.keys(nk), nz = new RegExp("^every\\s*(\\d+)?\\s*(" + tz.join("|") + ")s?$", "i"), rk = function(e, t) {
  if (Array.isArray(t)) return t;
  if (typeof t == "string" && "useUTC" in e) {
    var n = t.match(nz);
    if (n) {
      var r = n[1], o = n[2], i = nk[o][e.useUTC ? 1 : 0];
      if (o === "day") {
        var a, s, l = e.domain(), c = l[0], f = l[1], u = new Date(f);
        return u.setDate(u.getDate() + 1), (a = (s = i.every(Number(r ?? 1))) == null ? void 0 : s.range(c, u)) != null ? a : [];
      }
      if (r === void 0) return e.ticks(i);
      var h = i.every(Number(r));
      if (h) return e.ticks(h);
    }
    throw new Error("Invalid tickValues: " + t);
  }
  if ("ticks" in e) {
    if (t === void 0) return e.ticks();
    if (typeof (m = t) == "number" && isFinite(m) && Math.floor(m) === m) return e.ticks(t);
  }
  var m;
  return e.domain();
};
function xn() {
  return xn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, xn.apply(this, arguments);
}
var ok = function(e) {
  var t, n = e.axis, r = e.scale, o = e.ticksPosition, i = e.tickValues, a = e.tickSize, s = e.tickPadding, l = e.tickRotation, c = e.truncateTickAt, f = e.engine, u = f === void 0 ? "svg" : f, h = rk(r, i), m = JV[u], g = "bandwidth" in r ? tk(r) : r, p = { lineX: 0, lineY: 0 }, v = { textX: 0, textY: 0 }, y = typeof document == "object" && document.dir === "rtl", C = m.align.center, w = m.baseline.center;
  return n === "x" ? (t = function(_) {
    var x;
    return { x: (x = g(_)) != null ? x : 0, y: 0 };
  }, p.lineY = a * (o === "after" ? 1 : -1), v.textY = (a + s) * (o === "after" ? 1 : -1), w = o === "after" ? m.baseline.top : m.baseline.bottom, l === 0 ? C = m.align.center : o === "after" && l < 0 || o === "before" && l > 0 ? (C = m.align[y ? "left" : "right"], w = m.baseline.center) : (o === "after" && l > 0 || o === "before" && l < 0) && (C = m.align[y ? "right" : "left"], w = m.baseline.center)) : (t = function(_) {
    var x;
    return { x: 0, y: (x = g(_)) != null ? x : 0 };
  }, p.lineX = a * (o === "after" ? 1 : -1), v.textX = (a + s) * (o === "after" ? 1 : -1), C = o === "after" ? m.align.left : m.align.right), { ticks: h.map(function(_) {
    var x = typeof _ == "string" ? function(k) {
      var S = String(k).length;
      return c && c > 0 && S > c ? "" + String(k).slice(0, c).concat("...") : "" + k;
    }(_) : _;
    return xn({ key: _ instanceof Date ? "" + _.valueOf() : "" + _, value: x }, t(_), p, v);
  }), textAlign: C, textBaseline: w };
}, ik = function(e, t) {
  if (e === void 0 || typeof e == "function") return e;
  if (t.type === "time") {
    var n = A4(e);
    return function(r) {
      return n(r instanceof Date ? r : new Date(r));
    };
  }
  return T4(e);
}, C9 = function(e) {
  var t, n = e.width, r = e.height, o = e.scale, i = e.axis, a = e.values, s = (t = a, (Array.isArray(t) ? a : void 0) || rk(o, a)), l = "bandwidth" in o ? tk(o) : o, c = i === "x" ? s.map(function(f) {
    var u, h;
    return { key: f instanceof Date ? "" + f.valueOf() : "" + f, x1: (u = l(f)) != null ? u : 0, x2: (h = l(f)) != null ? h : 0, y1: 0, y2: r };
  }) : s.map(function(f) {
    var u, h;
    return { key: f instanceof Date ? "" + f.valueOf() : "" + f, x1: 0, x2: n, y1: (u = l(f)) != null ? u : 0, y2: (h = l(f)) != null ? h : 0 };
  });
  return c;
}, rz = lt(function(e) {
  var t, n = e.value, r = e.format, o = e.lineX, i = e.lineY, a = e.onClick, s = e.textBaseline, l = e.textAnchor, c = e.animatedProps, f = xt(), u = f.axis.ticks.line, h = f.axis.ticks.text, m = (t = r == null ? void 0 : r(n)) != null ? t : n, g = Te(function() {
    var p = { opacity: c.opacity };
    return a ? { style: xn({}, p, { cursor: "pointer" }), onClick: function(v) {
      return a(v, m);
    } } : { style: p };
  }, [c.opacity, a, m]);
  return ie(_t.g, xn({ transform: c.transform }, g, { children: [b("line", { x1: 0, x2: o, y1: 0, y2: i, style: u }), h.outlineWidth > 0 && b(_t.text, { dominantBaseline: s, textAnchor: l, transform: c.textTransform, style: h, strokeWidth: 2 * h.outlineWidth, stroke: h.outlineColor, strokeLinejoin: "round", children: "" + m }), b(_t.text, { dominantBaseline: s, textAnchor: l, transform: c.textTransform, style: W4(h), children: "" + m })] }));
}), oz = function(e) {
  var t = e.axis, n = e.scale, r = e.x, o = r === void 0 ? 0 : r, i = e.y, a = i === void 0 ? 0 : i, s = e.length, l = e.ticksPosition, c = e.tickValues, f = e.tickSize, u = f === void 0 ? 5 : f, h = e.tickPadding, m = h === void 0 ? 5 : h, g = e.tickRotation, p = g === void 0 ? 0 : g, v = e.format, y = e.renderTick, C = y === void 0 ? rz : y, w = e.truncateTickAt, _ = e.legend, x = e.legendPosition, k = x === void 0 ? "end" : x, S = e.legendOffset, T = S === void 0 ? 0 : S, L = e.onClick, R = e.ariaHidden, M = xt(), A = M.axis.legend.text, O = Te(function() {
    return ik(v, n);
  }, [v, n]), I = ok({ axis: t, scale: n, ticksPosition: l, tickValues: c, tickSize: u, tickPadding: m, tickRotation: p, truncateTickAt: w }), W = I.ticks, N = I.textAlign, H = I.textBaseline, q = null;
  if (_ !== void 0) {
    var D, $ = 0, U = 0, B = 0;
    t === "y" ? (B = -90, $ = T, k === "start" ? (D = "start", U = s) : k === "middle" ? (D = "middle", U = s / 2) : k === "end" && (D = "end")) : (U = T, k === "start" ? D = "start" : k === "middle" ? (D = "middle", $ = s / 2) : k === "end" && (D = "end", $ = s)), q = ie(St, { children: [A.outlineWidth > 0 && b("text", { transform: "translate(" + $ + ", " + U + ") rotate(" + B + ")", textAnchor: D, style: xn({ dominantBaseline: "central" }, A), strokeWidth: 2 * A.outlineWidth, stroke: A.outlineColor, strokeLinejoin: "round", children: _ }), b("text", { transform: "translate(" + $ + ", " + U + ") rotate(" + B + ")", textAnchor: D, style: xn({ dominantBaseline: "central" }, A), children: _ })] });
  }
  var K = kn(), X = K.animate, Z = K.config, G = tr({ transform: "translate(" + o + "," + a + ")", lineX2: t === "x" ? s : 0, lineY2: t === "x" ? 0 : s, config: Z, immediate: !X }), V = be(function(F) {
    return { opacity: 1, transform: "translate(" + F.x + "," + F.y + ")", textTransform: "translate(" + F.textX + "," + F.textY + ") rotate(" + p + ")" };
  }, [p]), Y = be(function(F) {
    return { opacity: 0, transform: "translate(" + F.x + "," + F.y + ")", textTransform: "translate(" + F.textX + "," + F.textY + ") rotate(" + p + ")" };
  }, [p]), P = Sl(W, { keys: function(F) {
    return F.key;
  }, initial: V, from: Y, enter: V, update: V, leave: { opacity: 0 }, config: Z, immediate: !X });
  return ie(_t.g, { transform: G.transform, "aria-hidden": R, children: [P(function(F, z, E, re) {
    return d.createElement(C, xn({ tickIndex: re, format: O, rotate: p, textBaseline: H, textAnchor: N, truncateTickAt: w, animatedProps: F }, z, L ? { onClick: L } : {}));
  }), b(_t.line, { style: M.axis.domain.line, x1: 0, x2: G.lineX2, y1: 0, y2: G.lineY2 }), q] });
}, iz = lt(oz), ak = ["top", "right", "bottom", "left"], sk = lt(function(e) {
  var t = e.xScale, n = e.yScale, r = e.width, o = e.height, i = { top: e.top, right: e.right, bottom: e.bottom, left: e.left };
  return b(St, { children: ak.map(function(a) {
    var s = i[a];
    if (!s) return null;
    var l = a === "top" || a === "bottom";
    return b(iz, xn({}, s, { axis: l ? "x" : "y", x: a === "right" ? r : 0, y: a === "bottom" ? o : 0, scale: l ? t : n, length: l ? r : o, ticksPosition: a === "top" || a === "left" ? "before" : "after", truncateTickAt: s.truncateTickAt }), a);
  }) });
}), az = lt(function(e) {
  var t = e.animatedProps, n = xt();
  return b(_t.line, xn({}, t, n.grid.line));
}), Jm = lt(function(e) {
  var t = e.lines, n = kn(), r = n.animate, o = n.config, i = Sl(t, { keys: function(a) {
    return a.key;
  }, initial: function(a) {
    return { opacity: 1, x1: a.x1, x2: a.x2, y1: a.y1, y2: a.y2 };
  }, from: function(a) {
    return { opacity: 0, x1: a.x1, x2: a.x2, y1: a.y1, y2: a.y2 };
  }, enter: function(a) {
    return { opacity: 1, x1: a.x1, x2: a.x2, y1: a.y1, y2: a.y2 };
  }, update: function(a) {
    return { opacity: 1, x1: a.x1, x2: a.x2, y1: a.y1, y2: a.y2 };
  }, leave: { opacity: 0 }, config: o, immediate: !r });
  return b("g", { children: i(function(a, s) {
    return $t(az, xn({}, s, { key: s.key, animatedProps: a }));
  }) });
}), lk = lt(function(e) {
  var t = e.width, n = e.height, r = e.xScale, o = e.yScale, i = e.xValues, a = e.yValues, s = Te(function() {
    return !!r && C9({ width: t, height: n, scale: r, axis: "x", values: i });
  }, [r, i, t, n]), l = Te(function() {
    return !!o && C9({ width: t, height: n, scale: o, axis: "y", values: a });
  }, [n, t, o, a]);
  return ie(St, { children: [s && b(Jm, { lines: s }), l && b(Jm, { lines: l })] });
}), sz = function(e, t) {
  var n, r = t.axis, o = t.scale, i = t.x, a = i === void 0 ? 0 : i, s = t.y, l = s === void 0 ? 0 : s, c = t.length, f = t.ticksPosition, u = t.tickValues, h = t.tickSize, m = h === void 0 ? 5 : h, g = t.tickPadding, p = g === void 0 ? 5 : g, v = t.tickRotation, y = v === void 0 ? 0 : v, C = t.format, w = t.legend, _ = t.legendPosition, x = _ === void 0 ? "end" : _, k = t.legendOffset, S = k === void 0 ? 0 : k, T = t.theme, L = ok({ axis: r, scale: o, ticksPosition: f, tickValues: u, tickSize: m, tickPadding: p, tickRotation: y, engine: "canvas" }), R = L.ticks, M = L.textAlign, A = L.textBaseline;
  e.save(), e.translate(a, l), e.textAlign = M, e.textBaseline = A;
  var O = T.axis.ticks.text;
  e.font = (O.fontWeight ? O.fontWeight + " " : "") + O.fontSize + "px " + O.fontFamily, ((n = T.axis.domain.line.strokeWidth) != null ? n : 0) > 0 && (e.lineWidth = Number(T.axis.domain.line.strokeWidth), e.lineCap = "square", T.axis.domain.line.stroke && (e.strokeStyle = T.axis.domain.line.stroke), e.beginPath(), e.moveTo(0, 0), e.lineTo(r === "x" ? c : 0, r === "x" ? 0 : c), e.stroke());
  var I = typeof C == "function" ? C : function(D) {
    return "" + D;
  };
  if (R.forEach(function(D) {
    var $;
    (($ = T.axis.ticks.line.strokeWidth) != null ? $ : 0) > 0 && (e.lineWidth = Number(T.axis.ticks.line.strokeWidth), e.lineCap = "square", T.axis.ticks.line.stroke && (e.strokeStyle = T.axis.ticks.line.stroke), e.beginPath(), e.moveTo(D.x, D.y), e.lineTo(D.x + D.lineX, D.y + D.lineY), e.stroke());
    var U = I(D.value);
    e.save(), e.translate(D.x + D.textX, D.y + D.textY), e.rotate(Wa(y)), O.outlineWidth > 0 && (e.strokeStyle = O.outlineColor, e.lineWidth = 2 * O.outlineWidth, e.lineJoin = "round", e.strokeText("" + U, 0, 0)), T.axis.ticks.text.fill && (e.fillStyle = O.fill), e.fillText("" + U, 0, 0), e.restore();
  }), w !== void 0) {
    var W = 0, N = 0, H = 0, q = "center";
    r === "y" ? (H = -90, W = S, x === "start" ? (q = "start", N = c) : x === "middle" ? (q = "center", N = c / 2) : x === "end" && (q = "end")) : (N = S, x === "start" ? q = "start" : x === "middle" ? (q = "center", W = c / 2) : x === "end" && (q = "end", W = c)), e.translate(W, N), e.rotate(Wa(H)), e.font = (T.axis.legend.text.fontWeight ? T.axis.legend.text.fontWeight + " " : "") + T.axis.legend.text.fontSize + "px " + T.axis.legend.text.fontFamily, T.axis.legend.text.fill && (e.fillStyle = T.axis.legend.text.fill), e.textAlign = q, e.textBaseline = "middle", e.fillText(w, 0, 0);
  }
  e.restore();
}, ck = function(e, t) {
  var n = t.xScale, r = t.yScale, o = t.width, i = t.height, a = t.top, s = t.right, l = t.bottom, c = t.left, f = t.theme, u = { top: a, right: s, bottom: l, left: c };
  ak.forEach(function(h) {
    var m = u[h];
    if (!m) return null;
    var g = h === "top" || h === "bottom", p = h === "top" || h === "left" ? "before" : "after", v = g ? n : r, y = ik(m.format, v);
    sz(e, xn({}, m, { axis: g ? "x" : "y", x: h === "right" ? o : 0, y: h === "bottom" ? i : 0, scale: v, format: y, length: g ? o : i, ticksPosition: p, theme: f }));
  });
}, S0 = function(e, t) {
  var n = t.width, r = t.height, o = t.scale, i = t.axis, a = t.values;
  C9({ width: n, height: r, scale: o, axis: i, values: a }).forEach(function(s) {
    e.beginPath(), e.moveTo(s.x1, s.y1), e.lineTo(s.x2, s.y2), e.stroke();
  });
}, Ff, ep;
function lz() {
  if (ep) return Ff;
  ep = 1;
  var e = Q_();
  function t(n, r) {
    var o = [];
    return e(n, function(i, a, s) {
      r(i, a, s) && o.push(i);
    }), o;
  }
  return Ff = t, Ff;
}
var Wf, tp;
function cz() {
  if (tp) return Wf;
  tp = 1;
  var e = k_(), t = lz(), n = j4(), r = on();
  function o(i, a) {
    var s = r(i) ? e : t;
    return s(i, n(a, 3));
  }
  return Wf = o, Wf;
}
var uz = cz();
const dz = /* @__PURE__ */ Ht(uz);
var qf, np;
function fz() {
  if (np) return qf;
  np = 1;
  var e = _r(), t = _n(), n = "[object Number]";
  function r(o) {
    return typeof o == "number" || t(o) && e(o) == n;
  }
  return qf = r, qf;
}
var hz = fz();
const rp = /* @__PURE__ */ Ht(hz);
var jf, op;
function mz() {
  if (op) return jf;
  op = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length; ++r < o && n(t[r], r, t) !== !1; )
      ;
    return t;
  }
  return jf = e, jf;
}
var Hf, ip;
function pz() {
  if (ip) return Hf;
  ip = 1;
  var e = Ai(), t = ps();
  function n(r, o) {
    return r && e(o, t(o), r);
  }
  return Hf = n, Hf;
}
var Vf, ap;
function gz() {
  if (ap) return Vf;
  ap = 1;
  var e = Ai(), t = fs();
  function n(r, o) {
    return r && e(o, t(o), r);
  }
  return Vf = n, Vf;
}
var Uf, sp;
function vz() {
  if (sp) return Uf;
  sp = 1;
  var e = Ai(), t = I4();
  function n(r, o) {
    return e(r, t(r), o);
  }
  return Uf = n, Uf;
}
var zf, lp;
function uk() {
  if (lp) return zf;
  lp = 1;
  var e = N4(), t = Yh(), n = I4(), r = S_(), o = Object.getOwnPropertySymbols, i = o ? function(a) {
    for (var s = []; a; )
      e(s, n(a)), a = t(a);
    return s;
  } : r;
  return zf = i, zf;
}
var Yf, cp;
function bz() {
  if (cp) return Yf;
  cp = 1;
  var e = Ai(), t = uk();
  function n(r, o) {
    return e(r, t(r), o);
  }
  return Yf = n, Yf;
}
var Gf, up;
function dk() {
  if (up) return Gf;
  up = 1;
  var e = __(), t = uk(), n = fs();
  function r(o) {
    return e(o, n, t);
  }
  return Gf = r, Gf;
}
var Kf, dp;
function yz() {
  if (dp) return Kf;
  dp = 1;
  var e = Object.prototype, t = e.hasOwnProperty;
  function n(r) {
    var o = r.length, i = new r.constructor(o);
    return o && typeof r[0] == "string" && t.call(r, "index") && (i.index = r.index, i.input = r.input), i;
  }
  return Kf = n, Kf;
}
var Zf, fp;
function Cz() {
  if (fp) return Zf;
  fp = 1;
  var e = zh();
  function t(n, r) {
    var o = r ? e(n.buffer) : n.buffer;
    return new n.constructor(o, n.byteOffset, n.byteLength);
  }
  return Zf = t, Zf;
}
var Xf, hp;
function wz() {
  if (hp) return Xf;
  hp = 1;
  var e = /\w*$/;
  function t(n) {
    var r = new n.constructor(n.source, e.exec(n));
    return r.lastIndex = n.lastIndex, r;
  }
  return Xf = t, Xf;
}
var Qf, mp;
function xz() {
  if (mp) return Qf;
  mp = 1;
  var e = Ti(), t = e ? e.prototype : void 0, n = t ? t.valueOf : void 0;
  function r(o) {
    return n ? Object(n.call(o)) : {};
  }
  return Qf = r, Qf;
}
var Jf, pp;
function _z() {
  if (pp) return Jf;
  pp = 1;
  var e = zh(), t = Cz(), n = wz(), r = xz(), o = Yw(), i = "[object Boolean]", a = "[object Date]", s = "[object Map]", l = "[object Number]", c = "[object RegExp]", f = "[object Set]", u = "[object String]", h = "[object Symbol]", m = "[object ArrayBuffer]", g = "[object DataView]", p = "[object Float32Array]", v = "[object Float64Array]", y = "[object Int8Array]", C = "[object Int16Array]", w = "[object Int32Array]", _ = "[object Uint8Array]", x = "[object Uint8ClampedArray]", k = "[object Uint16Array]", S = "[object Uint32Array]";
  function T(L, R, M) {
    var A = L.constructor;
    switch (R) {
      case m:
        return e(L);
      case i:
      case a:
        return new A(+L);
      case g:
        return t(L, M);
      case p:
      case v:
      case y:
      case C:
      case w:
      case _:
      case x:
      case k:
      case S:
        return o(L, M);
      case s:
        return new A();
      case l:
      case u:
        return new A(L);
      case c:
        return n(L);
      case f:
        return new A();
      case h:
        return r(L);
    }
  }
  return Jf = T, Jf;
}
var e2, gp;
function kz() {
  if (gp) return e2;
  gp = 1;
  var e = xc(), t = _n(), n = "[object Map]";
  function r(o) {
    return t(o) && e(o) == n;
  }
  return e2 = r, e2;
}
var t2, vp;
function Sz() {
  if (vp) return t2;
  vp = 1;
  var e = kz(), t = Ri(), n = Nl(), r = n && n.isMap, o = r ? t(r) : e;
  return t2 = o, t2;
}
var n2, bp;
function Mz() {
  if (bp) return n2;
  bp = 1;
  var e = xc(), t = _n(), n = "[object Set]";
  function r(o) {
    return t(o) && e(o) == n;
  }
  return n2 = r, n2;
}
var r2, yp;
function Ez() {
  if (yp) return r2;
  yp = 1;
  var e = Mz(), t = Ri(), n = Nl(), r = n && n.isSet, o = r ? t(r) : e;
  return r2 = o, r2;
}
var o2, Cp;
function Lz() {
  if (Cp) return o2;
  Cp = 1;
  var e = Rl(), t = mz(), n = Qh(), r = pz(), o = gz(), i = Uw(), a = Gw(), s = vz(), l = bz(), c = M_(), f = dk(), u = xc(), h = yz(), m = _z(), g = Zw(), p = on(), v = Ol(), y = Sz(), C = rr(), w = Ez(), _ = ps(), x = fs(), k = 1, S = 2, T = 4, L = "[object Arguments]", R = "[object Array]", M = "[object Boolean]", A = "[object Date]", O = "[object Error]", I = "[object Function]", W = "[object GeneratorFunction]", N = "[object Map]", H = "[object Number]", q = "[object Object]", D = "[object RegExp]", $ = "[object Set]", U = "[object String]", B = "[object Symbol]", K = "[object WeakMap]", X = "[object ArrayBuffer]", Z = "[object DataView]", G = "[object Float32Array]", V = "[object Float64Array]", Y = "[object Int8Array]", P = "[object Int16Array]", F = "[object Int32Array]", z = "[object Uint8Array]", E = "[object Uint8ClampedArray]", re = "[object Uint16Array]", ee = "[object Uint32Array]", oe = {};
  oe[L] = oe[R] = oe[X] = oe[Z] = oe[M] = oe[A] = oe[G] = oe[V] = oe[Y] = oe[P] = oe[F] = oe[N] = oe[H] = oe[q] = oe[D] = oe[$] = oe[U] = oe[B] = oe[z] = oe[E] = oe[re] = oe[ee] = !0, oe[O] = oe[I] = oe[K] = !1;
  function ue(le, Ae, Ie, bt, He, Me) {
    var Pe, rt = Ae & k, ft = Ae & S, Xe = Ae & T;
    if (Ie && (Pe = He ? Ie(le, bt, He, Me) : Ie(le)), Pe !== void 0)
      return Pe;
    if (!C(le))
      return le;
    var ht = p(le);
    if (ht) {
      if (Pe = h(le), !rt)
        return a(le, Pe);
    } else {
      var Ge = u(le), Ve = Ge == I || Ge == W;
      if (v(le))
        return i(le, rt);
      if (Ge == q || Ge == L || Ve && !He) {
        if (Pe = ft || Ve ? {} : g(le), !rt)
          return ft ? l(le, o(Pe, le)) : s(le, r(Pe, le));
      } else {
        if (!oe[Ge])
          return He ? le : {};
        Pe = m(le, Ge, rt);
      }
    }
    Me || (Me = new e());
    var Be = Me.get(le);
    if (Be)
      return Be;
    Me.set(le, Pe), w(le) ? le.forEach(function(it) {
      Pe.add(ue(it, Ae, Ie, it, le, Me));
    }) : y(le) && le.forEach(function(it, mt) {
      Pe.set(mt, ue(it, Ae, Ie, mt, le, Me));
    });
    var ct = Xe ? ft ? f : c : ft ? x : _, ot = ht ? void 0 : ct(le);
    return t(ot || le, function(it, mt) {
      ot && (mt = it, it = le[mt]), n(Pe, mt, ue(it, Ae, Ie, mt, le, Me));
    }), Pe;
  }
  return o2 = ue, o2;
}
var i2, wp;
function Tz() {
  if (wp) return i2;
  wp = 1;
  function e(t, n, r) {
    var o = -1, i = t.length;
    n < 0 && (n = -n > i ? 0 : i + n), r = r > i ? i : r, r < 0 && (r += i), i = n > r ? 0 : r - n >>> 0, n >>>= 0;
    for (var a = Array(i); ++o < i; )
      a[o] = t[o + n];
    return a;
  }
  return i2 = e, i2;
}
var a2, xp;
function Pz() {
  if (xp) return a2;
  xp = 1;
  var e = hs(), t = Tz();
  function n(r, o) {
    return o.length < 2 ? r : e(r, t(o, 0, -1));
  }
  return a2 = n, a2;
}
var s2, _p;
function Rz() {
  if (_p) return s2;
  _p = 1;
  var e = Oi(), t = fx(), n = Pz(), r = Ni();
  function o(i, a) {
    return a = e(a, i), i = n(i, a), i == null || delete i[r(t(a))];
  }
  return s2 = o, s2;
}
var l2, kp;
function Az() {
  if (kp) return l2;
  kp = 1;
  var e = Zh();
  function t(n) {
    return e(n) ? void 0 : n;
  }
  return l2 = t, l2;
}
var c2, Sp;
function Oz() {
  if (Sp) return c2;
  Sp = 1;
  var e = $l(), t = Lz(), n = Rz(), r = Oi(), o = Ai(), i = Az(), a = w_(), s = dk(), l = 1, c = 2, f = 4, u = a(function(h, m) {
    var g = {};
    if (h == null)
      return g;
    var p = !1;
    m = e(m, function(y) {
      return y = r(y, h), p || (p = y.length > 1), y;
    }), o(h, s(h), g), p && (g = t(g, l | c | f, i));
    for (var v = m.length; v--; )
      n(g, m[v]);
    return g;
  });
  return c2 = u, c2;
}
var Nz = Oz();
const fk = /* @__PURE__ */ Ht(Nz);
function Qn() {
  return Qn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Qn.apply(this, arguments);
}
var w9 = { dotSize: 4, noteWidth: 120, noteTextOffset: 8 }, Dz = function(e) {
  var t = typeof e;
  return KS(e) || t === "string" || t === "function" || t === "object";
}, Iz = function(e) {
  var t = typeof e;
  return t === "string" || t === "function";
}, ja = function(e) {
  return e.type === "circle";
}, x9 = function(e) {
  return e.type === "dot";
}, Ha = function(e) {
  return e.type === "rect";
}, Bz = function(e) {
  var t = e.data, n = e.annotations, r = e.getPosition, o = e.getDimensions;
  return n.reduce(function(i, a) {
    var s = a.offset || 0;
    return [].concat(i, dz(t, a.match).map(function(l) {
      var c = r(l), f = o(l);
      return (ja(a) || Ha(a)) && (f.size = f.size + 2 * s, f.width = f.width + 2 * s, f.height = f.height + 2 * s), Qn({}, fk(a, ["match", "offset"]), c, f, { size: a.size || f.size, datum: l });
    }));
  }, []);
}, $z = function(e, t, n, r) {
  var o = Math.atan2(r - t, n - e);
  return QV(ZV(o));
}, hk = function(e) {
  var t, n, r = e.x, o = e.y, i = e.noteX, a = e.noteY, s = e.noteWidth, l = s === void 0 ? w9.noteWidth : s, c = e.noteTextOffset, f = c === void 0 ? w9.noteTextOffset : c;
  if (rp(i)) t = r + i;
  else {
    if (i.abs === void 0) throw new Error("noteX should be either a number or an object containing an 'abs' property");
    t = i.abs;
  }
  if (rp(a)) n = o + a;
  else {
    if (a.abs === void 0) throw new Error("noteY should be either a number or an object containing an 'abs' property");
    n = a.abs;
  }
  var u = r, h = o, m = $z(r, o, t, n);
  if (ja(e)) {
    var g = XV(Wa(m), e.size / 2);
    u += g.x, h += g.y;
  }
  if (Ha(e)) {
    var p = Math.round((m + 90) / 45) % 8;
    p === 0 && (h -= e.height / 2), p === 1 && (u += e.width / 2, h -= e.height / 2), p === 2 && (u += e.width / 2), p === 3 && (u += e.width / 2, h += e.height / 2), p === 4 && (h += e.height / 2), p === 5 && (u -= e.width / 2, h += e.height / 2), p === 6 && (u -= e.width / 2), p === 7 && (u -= e.width / 2, h -= e.height / 2);
  }
  var v = t, y = t;
  return (m + 90) % 360 > 180 ? (v -= l, y -= l) : y += l, { points: [[u, h], [t, n], [y, n]], text: [v, n - f], angle: m + 90 };
}, mk = function(e) {
  var t = e.data, n = e.annotations, r = e.getPosition, o = e.getDimensions;
  return Te(function() {
    return Bz({ data: t, annotations: n, getPosition: r, getDimensions: o });
  }, [t, n, r, o]);
}, Fz = function(e) {
  var t = e.annotations;
  return Te(function() {
    return t.map(function(n) {
      return Qn({}, n, { computed: hk(Qn({}, n)) });
    });
  }, [t]);
}, Wz = function(e) {
  return Te(function() {
    return hk(e);
  }, [e]);
}, qz = function(e) {
  var t = e.datum, n = e.x, r = e.y, o = e.note, i = xt(), a = kn(), s = a.animate, l = a.config, c = tr({ x: n, y: r, config: l, immediate: !s });
  return typeof o == "function" ? $t(o, { x: n, y: r, datum: t }) : ie(St, { children: [i.annotations.text.outlineWidth > 0 && b(_t.text, { x: c.x, y: c.y, style: Qn({}, i.annotations.text, { strokeLinejoin: "round", strokeWidth: 2 * i.annotations.text.outlineWidth, stroke: i.annotations.text.outlineColor }), children: o }), b(_t.text, { x: c.x, y: c.y, style: fk(i.annotations.text, ["outlineWidth", "outlineColor"]), children: o })] });
}, Mp = function(e) {
  var t = e.points, n = e.isOutline, r = n !== void 0 && n, o = xt(), i = Te(function() {
    var l = t[0];
    return t.slice(1).reduce(function(c, f) {
      return c + " L" + f[0] + "," + f[1];
    }, "M" + l[0] + "," + l[1]);
  }, [t]), a = $4(i);
  if (r && o.annotations.link.outlineWidth <= 0) return null;
  var s = Qn({}, o.annotations.link);
  return r && (s.strokeLinecap = "square", s.strokeWidth = o.annotations.link.strokeWidth + 2 * o.annotations.link.outlineWidth, s.stroke = o.annotations.link.outlineColor, s.opacity = o.annotations.link.outlineOpacity), b(_t.path, { fill: "none", d: a, style: s });
}, jz = function(e) {
  var t = e.x, n = e.y, r = e.size, o = xt(), i = kn(), a = i.animate, s = i.config, l = tr({ x: t, y: n, radius: r / 2, config: s, immediate: !a });
  return ie(St, { children: [o.annotations.outline.outlineWidth > 0 && b(_t.circle, { cx: l.x, cy: l.y, r: l.radius, style: Qn({}, o.annotations.outline, { fill: "none", strokeWidth: o.annotations.outline.strokeWidth + 2 * o.annotations.outline.outlineWidth, stroke: o.annotations.outline.outlineColor, opacity: o.annotations.outline.outlineOpacity }) }), b(_t.circle, { cx: l.x, cy: l.y, r: l.radius, style: o.annotations.outline })] });
}, Hz = function(e) {
  var t = e.x, n = e.y, r = e.size, o = r === void 0 ? w9.dotSize : r, i = xt(), a = kn(), s = a.animate, l = a.config, c = tr({ x: t, y: n, radius: o / 2, config: l, immediate: !s });
  return ie(St, { children: [i.annotations.outline.outlineWidth > 0 && b(_t.circle, { cx: c.x, cy: c.y, r: c.radius, style: Qn({}, i.annotations.outline, { fill: "none", strokeWidth: 2 * i.annotations.outline.outlineWidth, stroke: i.annotations.outline.outlineColor, opacity: i.annotations.outline.outlineOpacity }) }), b(_t.circle, { cx: c.x, cy: c.y, r: c.radius, style: i.annotations.symbol })] });
}, Vz = function(e) {
  var t = e.x, n = e.y, r = e.width, o = e.height, i = e.borderRadius, a = i === void 0 ? 6 : i, s = xt(), l = kn(), c = l.animate, f = l.config, u = tr({ x: t - r / 2, y: n - o / 2, width: r, height: o, config: f, immediate: !c });
  return ie(St, { children: [s.annotations.outline.outlineWidth > 0 && b(_t.rect, { x: u.x, y: u.y, rx: a, ry: a, width: u.width, height: u.height, style: Qn({}, s.annotations.outline, { fill: "none", strokeWidth: s.annotations.outline.strokeWidth + 2 * s.annotations.outline.outlineWidth, stroke: s.annotations.outline.outlineColor, opacity: s.annotations.outline.outlineOpacity }) }), b(_t.rect, { x: u.x, y: u.y, rx: a, ry: a, width: u.width, height: u.height, style: s.annotations.outline })] });
}, Uz = function(e) {
  var t = e.datum, n = e.x, r = e.y, o = e.note, i = Wz(e);
  if (!Dz(o)) throw new Error("note should be a valid react element");
  return ie(St, { children: [b(Mp, { points: i.points, isOutline: !0 }), ja(e) && b(jz, { x: n, y: r, size: e.size }), x9(e) && b(Hz, { x: n, y: r, size: e.size }), Ha(e) && b(Vz, { x: n, y: r, width: e.width, height: e.height, borderRadius: e.borderRadius }), b(Mp, { points: i.points }), b(qz, { datum: t, x: i.text[0], y: i.text[1], note: o })] });
}, Ep = function(e, t) {
  t.forEach(function(n, r) {
    var o = n[0], i = n[1];
    r === 0 ? e.moveTo(o, i) : e.lineTo(o, i);
  });
}, zz = function(e, t) {
  var n = t.annotations, r = t.theme;
  n.length !== 0 && (e.save(), n.forEach(function(o) {
    if (!Iz(o.note)) throw new Error("note is invalid for canvas implementation");
    r.annotations.link.outlineWidth > 0 && (e.lineCap = "square", e.strokeStyle = r.annotations.link.outlineColor, e.lineWidth = r.annotations.link.strokeWidth + 2 * r.annotations.link.outlineWidth, e.beginPath(), Ep(e, o.computed.points), e.stroke(), e.lineCap = "butt"), ja(o) && r.annotations.outline.outlineWidth > 0 && (e.strokeStyle = r.annotations.outline.outlineColor, e.lineWidth = r.annotations.outline.strokeWidth + 2 * r.annotations.outline.outlineWidth, e.beginPath(), e.arc(o.x, o.y, o.size / 2, 0, 2 * Math.PI), e.stroke()), x9(o) && r.annotations.symbol.outlineWidth > 0 && (e.strokeStyle = r.annotations.symbol.outlineColor, e.lineWidth = 2 * r.annotations.symbol.outlineWidth, e.beginPath(), e.arc(o.x, o.y, o.size / 2, 0, 2 * Math.PI), e.stroke()), Ha(o) && r.annotations.outline.outlineWidth > 0 && (e.strokeStyle = r.annotations.outline.outlineColor, e.lineWidth = r.annotations.outline.strokeWidth + 2 * r.annotations.outline.outlineWidth, e.beginPath(), e.rect(o.x - o.width / 2, o.y - o.height / 2, o.width, o.height), e.stroke()), e.strokeStyle = r.annotations.link.stroke, e.lineWidth = r.annotations.link.strokeWidth, e.beginPath(), Ep(e, o.computed.points), e.stroke(), ja(o) && (e.strokeStyle = r.annotations.outline.stroke, e.lineWidth = r.annotations.outline.strokeWidth, e.beginPath(), e.arc(o.x, o.y, o.size / 2, 0, 2 * Math.PI), e.stroke()), x9(o) && (e.fillStyle = r.annotations.symbol.fill, e.beginPath(), e.arc(o.x, o.y, o.size / 2, 0, 2 * Math.PI), e.fill()), Ha(o) && (e.strokeStyle = r.annotations.outline.stroke, e.lineWidth = r.annotations.outline.strokeWidth, e.beginPath(), e.rect(o.x - o.width / 2, o.y - o.height / 2, o.width, o.height), e.stroke()), typeof o.note == "function" ? o.note(e, { datum: o.datum, x: o.computed.text[0], y: o.computed.text[1], theme: r }) : (e.font = r.annotations.text.fontSize + "px " + r.annotations.text.fontFamily, e.textAlign = "left", e.textBaseline = "alphabetic", e.fillStyle = r.annotations.text.fill, e.strokeStyle = r.annotations.text.outlineColor, e.lineWidth = 2 * r.annotations.text.outlineWidth, r.annotations.text.outlineWidth > 0 && (e.lineJoin = "round", e.strokeText(o.note, o.computed.text[0], o.computed.text[1]), e.lineJoin = "miter"), e.fillText(o.note, o.computed.text[0], o.computed.text[1]));
  }), e.restore());
};
function M0() {
  return M0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, M0.apply(this, arguments);
}
function Lp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Yz(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = function(o, i) {
    if (o) {
      if (typeof o == "string") return Lp(o, i);
      var a = Object.prototype.toString.call(o).slice(8, -1);
      return a === "Object" && o.constructor && (a = o.constructor.name), a === "Map" || a === "Set" ? Array.from(o) : a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? Lp(o, i) : void 0;
    }
  }(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var pk = { nivo: ["#e8c1a0", "#f47560", "#f1e15b", "#e8a838", "#61cdbb", "#97e3d5"], category10: Lq, accent: Tq, dark2: Pq, paired: Rq, pastel1: Aq, pastel2: Oq, set1: Nq, set2: Dq, set3: Px, tableau10: Iq }, Gz = Object.keys(pk), gk = { brown_blueGreen: zl, purpleRed_green: Yl, pink_yellowGreen: Gl, purple_orange: Kl, red_blue: Zl, red_grey: Xl, red_yellow_blue: Ql, red_yellow_green: Jl, spectral: ec }, Kz = Object.keys(gk), Zz = { brown_blueGreen: Bq, purpleRed_green: $q, pink_yellowGreen: Fq, purple_orange: Wq, red_blue: qq, red_grey: jq, red_yellow_blue: Hq, red_yellow_green: Vq, spectral: Uq }, vk = { blues: hc, greens: mc, greys: pc, oranges: bc, purples: gc, reds: vc, blue_green: tc, blue_purple: nc, green_blue: rc, orange_red: oc, purple_blue_green: ic, purple_blue: ac, purple_red: sc, red_purple: lc, yellow_green_blue: cc, yellow_green: uc, yellow_orange_brown: dc, yellow_orange_red: fc }, Xz = Object.keys(vk), Qz = { blues: oj, greens: ij, greys: aj, oranges: cj, purples: sj, reds: lj, turbo: bj, viridis: yj, inferno: wj, magma: Cj, plasma: xj, cividis: uj, warm: fj, cool: hj, cubehelixDefault: dj, blue_green: zq, blue_purple: Yq, green_blue: Gq, orange_red: Kq, purple_blue_green: Zq, purple_blue: Xq, purple_red: Qq, red_purple: Jq, yellow_green_blue: ej, yellow_green: tj, yellow_orange_brown: nj, yellow_orange_red: rj }, u2 = M0({}, pk, gk, vk), Jz = function(e) {
  return Gz.includes(e);
}, eY = function(e) {
  return Kz.includes(e);
}, tY = function(e) {
  return Xz.includes(e);
}, nY = { rainbow: mj, sinebow: vj };
M0({}, Zz, Qz, nY);
var rY = function(e, t) {
  if (typeof e == "function") return e;
  if (O4(e)) {
    if (function(l) {
      return l.theme !== void 0;
    }(e)) {
      if (t === void 0) throw new Error("Unable to use color from theme as no theme was provided");
      var n = Zn(t, e.theme);
      if (n === void 0) throw new Error("Color from theme is undefined at path: '" + e.theme + "'");
      return function() {
        return n;
      };
    }
    if (function(l) {
      return l.from !== void 0;
    }(e)) {
      var r = function(l) {
        return Zn(l, e.from);
      };
      if (Array.isArray(e.modifiers)) {
        for (var o, i = [], a = function() {
          var l = o.value, c = l[0], f = l[1];
          if (c === "brighter") i.push(function(u) {
            return u.brighter(f);
          });
          else if (c === "darker") i.push(function(u) {
            return u.darker(f);
          });
          else {
            if (c !== "opacity") throw new Error("Invalid color modifier: '" + c + "', must be one of: 'brighter', 'darker', 'opacity'");
            i.push(function(u) {
              return u.opacity = f, u;
            });
          }
        }, s = Yz(e.modifiers); !(o = s()).done; ) a();
        return i.length === 0 ? r : function(l) {
          return i.reduce(function(c, f) {
            return f(c);
          }, ui(r(l))).toString();
        };
      }
      return r;
    }
    throw new Error("Invalid color spec, you should either specify 'theme' or 'from' when using a config object");
  }
  return function() {
    return e;
  };
}, mi = function(e, t) {
  return Te(function() {
    return rY(e, t);
  }, [e, t]);
};
J.oneOfType([J.string, J.func, J.shape({ theme: J.string.isRequired }), J.shape({ from: J.string.isRequired, modifiers: J.arrayOf(J.array) })]);
var oY = function(e, t) {
  if (typeof e == "function") return e;
  var n = typeof t == "function" ? t : function(u) {
    return Zn(u, t);
  };
  if (Array.isArray(e)) {
    var r = ro(e), o = function(u) {
      return r(n(u));
    };
    return o.scale = r, o;
  }
  if (O4(e)) {
    if (function(u) {
      return u.datum !== void 0;
    }(e)) return function(u) {
      return Zn(u, e.datum);
    };
    if (function(u) {
      return u.scheme !== void 0;
    }(e)) {
      if (Jz(e.scheme)) {
        var i = ro(u2[e.scheme]), a = function(u) {
          return i(n(u));
        };
        return a.scale = i, a;
      }
      if (eY(e.scheme)) {
        if (e.size !== void 0 && (e.size < 3 || e.size > 11)) throw new Error("Invalid size '" + e.size + "' for diverging color scheme '" + e.scheme + "', must be between 3~11");
        var s = ro(u2[e.scheme][e.size || 11]), l = function(u) {
          return s(n(u));
        };
        return l.scale = s, l;
      }
      if (tY(e.scheme)) {
        if (e.size !== void 0 && (e.size < 3 || e.size > 9)) throw new Error("Invalid size '" + e.size + "' for sequential color scheme '" + e.scheme + "', must be between 3~9");
        var c = ro(u2[e.scheme][e.size || 9]), f = function(u) {
          return c(n(u));
        };
        return f.scale = c, f;
      }
    }
    throw new Error("Invalid colors, when using an object, you should either pass a 'datum' or a 'scheme' property");
  }
  return function() {
    return e;
  };
}, bk = function(e, t) {
  return Te(function() {
    return oY(e, t);
  }, [e, t]);
}, iY = function(e) {
  var t = e.x, n = e.y, r = e.size, o = e.fill, i = e.opacity, a = i === void 0 ? 1 : i, s = e.borderWidth, l = s === void 0 ? 0 : s, c = e.borderColor;
  return b("circle", { r: r / 2, cx: t + r / 2, cy: n + r / 2, fill: o, opacity: a, strokeWidth: l, stroke: c === void 0 ? "transparent" : c, style: { pointerEvents: "none" } });
}, aY = function(e) {
  var t = e.x, n = e.y, r = e.size, o = e.fill, i = e.opacity, a = i === void 0 ? 1 : i, s = e.borderWidth, l = s === void 0 ? 0 : s, c = e.borderColor;
  return b("g", { transform: "translate(" + t + "," + n + ")", children: b("path", { d: `
                    M` + r / 2 + ` 0
                    L` + 0.8 * r + " " + r / 2 + `
                    L` + r / 2 + " " + r + `
                    L` + 0.2 * r + " " + r / 2 + `
                    L` + r / 2 + ` 0
                `, fill: o, opacity: a, strokeWidth: l, stroke: c === void 0 ? "transparent" : c, style: { pointerEvents: "none" } }) });
}, sY = function(e) {
  var t = e.x, n = e.y, r = e.size, o = e.fill, i = e.opacity, a = i === void 0 ? 1 : i, s = e.borderWidth, l = s === void 0 ? 0 : s, c = e.borderColor;
  return b("rect", { x: t, y: n, fill: o, opacity: a, strokeWidth: l, stroke: c === void 0 ? "transparent" : c, width: r, height: r, style: { pointerEvents: "none" } });
}, lY = function(e) {
  var t = e.x, n = e.y, r = e.size, o = e.fill, i = e.opacity, a = i === void 0 ? 1 : i, s = e.borderWidth, l = s === void 0 ? 0 : s, c = e.borderColor;
  return b("g", { transform: "translate(" + t + "," + n + ")", children: b("path", { d: `
                M` + r / 2 + ` 0
                L` + r + " " + r + `
                L0 ` + r + `
                L` + r / 2 + ` 0
            `, fill: o, opacity: a, strokeWidth: l, stroke: c === void 0 ? "transparent" : c, style: { pointerEvents: "none" } }) });
};
function io() {
  return io = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, io.apply(this, arguments);
}
var cY = { top: 0, right: 0, bottom: 0, left: 0 }, H4 = function(e) {
  var t, n = e.direction, r = e.itemsSpacing, o = e.padding, i = e.itemCount, a = e.itemWidth, s = e.itemHeight;
  if (typeof o != "number" && (typeof (t = o) != "object" || Array.isArray(t) || t === null)) throw new Error("Invalid property padding, must be one of: number, object");
  var l = typeof o == "number" ? { top: o, right: o, bottom: o, left: o } : io({}, cY, o), c = l.left + l.right, f = l.top + l.bottom, u = a + c, h = s + f, m = (i - 1) * r;
  return n === "row" ? u = a * i + m + c : n === "column" && (h = s * i + m + f), { width: u, height: h, padding: l };
}, yk = function(e) {
  var t = e.anchor, n = e.translateX, r = e.translateY, o = e.containerWidth, i = e.containerHeight, a = e.width, s = e.height, l = n, c = r;
  switch (t) {
    case "top":
      l += (o - a) / 2;
      break;
    case "top-right":
      l += o - a;
      break;
    case "right":
      l += o - a, c += (i - s) / 2;
      break;
    case "bottom-right":
      l += o - a, c += i - s;
      break;
    case "bottom":
      l += (o - a) / 2, c += i - s;
      break;
    case "bottom-left":
      c += i - s;
      break;
    case "left":
      c += (i - s) / 2;
      break;
    case "center":
      l += (o - a) / 2, c += (i - s) / 2;
  }
  return { x: l, y: c };
}, Ck = function(e) {
  var t, n, r, o, i, a, s = e.direction, l = e.justify, c = e.symbolSize, f = e.symbolSpacing, u = e.width, h = e.height;
  switch (s) {
    case "left-to-right":
      t = 0, n = (h - c) / 2, o = h / 2, a = "central", l ? (r = u, i = "end") : (r = c + f, i = "start");
      break;
    case "right-to-left":
      t = u - c, n = (h - c) / 2, o = h / 2, a = "central", l ? (r = 0, i = "start") : (r = u - c - f, i = "end");
      break;
    case "top-to-bottom":
      t = (u - c) / 2, n = 0, r = u / 2, i = "middle", l ? (o = h, a = "alphabetic") : (o = c + f, a = "text-before-edge");
      break;
    case "bottom-to-top":
      t = (u - c) / 2, n = h - c, r = u / 2, i = "middle", l ? (o = 0, a = "text-before-edge") : (o = h - c - f, a = "alphabetic");
  }
  return { symbolX: t, symbolY: n, labelX: r, labelY: o, labelAnchor: i, labelAlignment: a };
}, uY = { circle: iY, diamond: aY, square: sY, triangle: lY }, dY = function(e) {
  var t, n, r, o, i, a, s, l, c, f, u, h = e.x, m = e.y, g = e.width, p = e.height, v = e.data, y = e.direction, C = y === void 0 ? "left-to-right" : y, w = e.justify, _ = w !== void 0 && w, x = e.textColor, k = e.background, S = k === void 0 ? "transparent" : k, T = e.opacity, L = T === void 0 ? 1 : T, R = e.symbolShape, M = R === void 0 ? "square" : R, A = e.symbolSize, O = A === void 0 ? 16 : A, I = e.symbolSpacing, W = I === void 0 ? 8 : I, N = e.symbolBorderWidth, H = N === void 0 ? 0 : N, q = e.symbolBorderColor, D = q === void 0 ? "transparent" : q, $ = e.onClick, U = e.onMouseEnter, B = e.onMouseLeave, K = e.toggleSerie, X = e.effects, Z = Yt({}), G = Z[0], V = Z[1], Y = xt(), P = be(function(bt) {
    if (X) {
      var He = X.filter(function(Me) {
        return Me.on === "hover";
      }).reduce(function(Me, Pe) {
        return io({}, Me, Pe.style);
      }, {});
      V(He);
    }
    U == null || U(v, bt);
  }, [U, v, X]), F = be(function(bt) {
    if (X) {
      var He = X.filter(function(Me) {
        return Me.on !== "hover";
      }).reduce(function(Me, Pe) {
        return io({}, Me, Pe.style);
      }, {});
      V(He);
    }
    B == null || B(v, bt);
  }, [B, v, X]), z = Ck({ direction: C, justify: _, symbolSize: (t = G.symbolSize) != null ? t : O, symbolSpacing: W, width: g, height: p }), E = z.symbolX, re = z.symbolY, ee = z.labelX, oe = z.labelY, ue = z.labelAnchor, le = z.labelAlignment, Ae = [$, U, B, K].some(function(bt) {
    return bt !== void 0;
  }), Ie = typeof M == "function" ? M : uY[M];
  return ie("g", { transform: "translate(" + h + "," + m + ")", style: { opacity: (n = G.itemOpacity) != null ? n : L }, children: [b("rect", { width: g, height: p, fill: (r = G.itemBackground) != null ? r : S, style: { cursor: Ae ? "pointer" : "auto" }, onClick: function(bt) {
    $ == null || $(v, bt), K == null || K(v.id);
  }, onMouseEnter: P, onMouseLeave: F }), d.createElement(Ie, io({ id: v.id, x: E, y: re, size: (o = G.symbolSize) != null ? o : O, fill: (i = (a = v.fill) != null ? a : v.color) != null ? i : "black", borderWidth: (s = G.symbolBorderWidth) != null ? s : H, borderColor: (l = G.symbolBorderColor) != null ? l : D }, v.hidden ? Y.legends.hidden.symbol : void 0)), b("text", { textAnchor: ue, style: io({}, W4(Y.legends.text), { fill: (c = (f = (u = G.itemTextColor) != null ? u : x) != null ? f : Y.legends.text.fill) != null ? c : "black", dominantBaseline: le, pointerEvents: "none", userSelect: "none" }, v.hidden ? Y.legends.hidden.text : void 0), x: ee, y: oe, children: v.label })] });
}, fY = function(e) {
  var t = e.data, n = e.x, r = e.y, o = e.direction, i = e.padding, a = i === void 0 ? 0 : i, s = e.justify, l = e.effects, c = e.itemWidth, f = e.itemHeight, u = e.itemDirection, h = u === void 0 ? "left-to-right" : u, m = e.itemsSpacing, g = m === void 0 ? 0 : m, p = e.itemTextColor, v = e.itemBackground, y = v === void 0 ? "transparent" : v, C = e.itemOpacity, w = C === void 0 ? 1 : C, _ = e.symbolShape, x = e.symbolSize, k = e.symbolSpacing, S = e.symbolBorderWidth, T = e.symbolBorderColor, L = e.onClick, R = e.onMouseEnter, M = e.onMouseLeave, A = e.toggleSerie, O = H4({ itemCount: t.length, itemWidth: c, itemHeight: f, itemsSpacing: g, direction: o, padding: a }).padding, I = o === "row" ? c + g : 0, W = o === "column" ? f + g : 0;
  return b("g", { transform: "translate(" + n + "," + r + ")", children: t.map(function(N, H) {
    return b(dY, { data: N, x: H * I + O.left, y: H * W + O.top, width: c, height: f, direction: h, justify: s, effects: l, textColor: p, background: y, opacity: w, symbolShape: _, symbolSize: x, symbolSpacing: k, symbolBorderWidth: S, symbolBorderColor: T, onClick: L, onMouseEnter: R, onMouseLeave: M, toggleSerie: A }, H);
  }) });
}, wk = function(e) {
  var t = e.data, n = e.containerWidth, r = e.containerHeight, o = e.translateX, i = o === void 0 ? 0 : o, a = e.translateY, s = a === void 0 ? 0 : a, l = e.anchor, c = e.direction, f = e.padding, u = f === void 0 ? 0 : f, h = e.justify, m = e.itemsSpacing, g = m === void 0 ? 0 : m, p = e.itemWidth, v = e.itemHeight, y = e.itemDirection, C = e.itemTextColor, w = e.itemBackground, _ = e.itemOpacity, x = e.symbolShape, k = e.symbolSize, S = e.symbolSpacing, T = e.symbolBorderWidth, L = e.symbolBorderColor, R = e.onClick, M = e.onMouseEnter, A = e.onMouseLeave, O = e.toggleSerie, I = e.effects, W = H4({ itemCount: t.length, itemsSpacing: g, itemWidth: p, itemHeight: v, direction: c, padding: u }), N = W.width, H = W.height, q = yk({ anchor: l, translateX: i, translateY: s, containerWidth: n, containerHeight: r, width: N, height: H }), D = q.x, $ = q.y;
  return b(fY, { data: t, x: D, y: $, direction: c, padding: u, justify: h, effects: I, itemsSpacing: g, itemWidth: p, itemHeight: v, itemDirection: y, itemTextColor: C, itemBackground: w, itemOpacity: _, symbolShape: x, symbolSize: k, symbolSpacing: S, symbolBorderWidth: T, symbolBorderColor: L, onClick: R, onMouseEnter: M, onMouseLeave: A, toggleSerie: typeof O == "boolean" ? void 0 : O });
}, hY = { start: "left", middle: "center", end: "right" }, xk = function(e, t) {
  var n = t.data, r = t.containerWidth, o = t.containerHeight, i = t.translateX, a = i === void 0 ? 0 : i, s = t.translateY, l = s === void 0 ? 0 : s, c = t.anchor, f = t.direction, u = t.padding, h = u === void 0 ? 0 : u, m = t.justify, g = m !== void 0 && m, p = t.itemsSpacing, v = p === void 0 ? 0 : p, y = t.itemWidth, C = t.itemHeight, w = t.itemDirection, _ = w === void 0 ? "left-to-right" : w, x = t.itemTextColor, k = t.symbolSize, S = k === void 0 ? 16 : k, T = t.symbolSpacing, L = T === void 0 ? 8 : T, R = t.theme, M = H4({ itemCount: n.length, itemWidth: y, itemHeight: C, itemsSpacing: v, direction: f, padding: h }), A = M.width, O = M.height, I = M.padding, W = yk({ anchor: c, translateX: a, translateY: l, containerWidth: r, containerHeight: o, width: A, height: O }), N = W.x, H = W.y, q = f === "row" ? y + v : 0, D = f === "column" ? C + v : 0;
  e.save(), e.translate(N, H), e.font = R.legends.text.fontSize + "px " + (R.legends.text.fontFamily || "sans-serif"), n.forEach(function($, U) {
    var B, K, X = U * q + I.left, Z = U * D + I.top, G = Ck({ direction: _, justify: g, symbolSize: S, symbolSpacing: L, width: y, height: C }), V = G.symbolX, Y = G.symbolY, P = G.labelX, F = G.labelY, z = G.labelAnchor, E = G.labelAlignment;
    e.fillStyle = (B = $.color) != null ? B : "black", e.fillRect(X + V, Z + Y, S, S), e.textAlign = hY[z], E === "central" && (e.textBaseline = "middle"), e.fillStyle = (K = x ?? R.legends.text.fill) != null ? K : "black", e.fillText(String($.label), X + P, Z + F);
  }), e.restore();
};
function Ye() {
  return Ye = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ye.apply(this, arguments);
}
function Ii(e, t) {
  if (e == null) return {};
  var n, r, o = {}, i = Object.keys(e);
  for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
  return o;
}
var Tp, mY = function(e) {
  var t = e.bars, n = e.annotations, r = mk({ data: t, annotations: n, getPosition: function(o) {
    return { x: o.x + o.width / 2, y: o.y + o.height / 2 };
  }, getDimensions: function(o) {
    var i = o.height, a = o.width;
    return { width: a, height: i, size: Math.max(a, i) };
  } });
  return b(St, { children: r.map(function(o, i) {
    return b(Uz, Ye({}, o), i);
  }) });
}, pY = function(e) {
  var t = e.width, n = e.height, r = e.legends, o = e.toggleSerie;
  return b(St, { children: r.map(function(i, a) {
    var s, l = i[0], c = i[1];
    return b(wk, Ye({}, l, { containerWidth: t, containerHeight: n, data: (s = l.data) != null ? s : c, toggleSerie: l.toggleSerie && l.dataFrom === "keys" ? o : void 0 }), a);
  }) });
}, gY = ["data"], vY = function(e) {
  var t, n = e.bar, r = n.data, o = Ii(n, gY), i = e.style, a = i.borderColor, s = i.color, l = i.height, c = i.labelColor, f = i.labelOpacity, u = i.labelX, h = i.labelY, m = i.transform, g = i.width, p = i.textAnchor, v = e.borderRadius, y = e.borderWidth, C = e.label, w = e.shouldRenderLabel, _ = e.isInteractive, x = e.onClick, k = e.onMouseEnter, S = e.onMouseLeave, T = e.tooltip, L = e.isFocusable, R = e.ariaLabel, M = e.ariaLabelledBy, A = e.ariaDescribedBy, O = e.ariaDisabled, I = e.ariaHidden, W = xt(), N = Li(), H = N.showTooltipFromEvent, q = N.showTooltipAt, D = N.hideTooltip, $ = Te(function() {
    return function() {
      return $t(T, Ye({}, o, r));
    };
  }, [T, o, r]), U = be(function(V) {
    x == null || x(Ye({ color: o.color }, r), V);
  }, [o, r, x]), B = be(function(V) {
    return H($(), V);
  }, [H, $]), K = be(function(V) {
    k == null || k(r, V), H($(), V);
  }, [r, k, H, $]), X = be(function(V) {
    S == null || S(r, V), D();
  }, [r, D, S]), Z = be(function() {
    q($(), [o.absX + o.width / 2, o.absY]);
  }, [q, $, o]), G = be(function() {
    D();
  }, [D]);
  return ie(_t.g, { transform: m, children: [b(_t.rect, { width: e9(g, function(V) {
    return Math.max(V, 0);
  }), height: e9(l, function(V) {
    return Math.max(V, 0);
  }), rx: v, ry: v, fill: (t = r.fill) != null ? t : s, strokeWidth: y, stroke: a, focusable: L, tabIndex: L ? 0 : void 0, "aria-label": R ? R(r) : void 0, "aria-labelledby": M ? M(r) : void 0, "aria-describedby": A ? A(r) : void 0, "aria-disabled": O ? O(r) : void 0, "aria-hidden": I ? I(r) : void 0, onMouseEnter: _ ? K : void 0, onMouseMove: _ ? B : void 0, onMouseLeave: _ ? X : void 0, onClick: _ ? U : void 0, onFocus: _ && L ? Z : void 0, onBlur: _ && L ? G : void 0 }), w && b(_t.text, { x: u, y: h, textAnchor: p, dominantBaseline: "central", fillOpacity: f, style: Ye({}, W.labels.text, { pointerEvents: "none", fill: c }), children: C })] });
}, bY = ["color", "label"], yY = function(e) {
  var t = e.color, n = e.label, r = Ii(e, bY);
  return b(Iw, { id: n, value: r.formattedValue, enableChip: !0, color: t });
}, et = { indexBy: "id", keys: ["value"], groupMode: "stacked", layout: "vertical", reverse: !1, minValue: "auto", maxValue: "auto", valueScale: { type: "linear" }, indexScale: { type: "band", round: !0 }, padding: 0.1, innerPadding: 0, axisBottom: {}, axisLeft: {}, enableGridX: !1, enableGridY: !0, enableLabel: !0, label: "formattedValue", labelPosition: "middle", labelOffset: 0, labelSkipWidth: 0, labelSkipHeight: 0, labelTextColor: { from: "theme", theme: "labels.text.fill" }, colorBy: "id", colors: { scheme: "nivo" }, borderRadius: 0, borderWidth: 0, borderColor: { from: "color" }, isInteractive: !0, tooltip: yY, tooltipLabel: function(e) {
  return e.id + " - " + e.indexValue;
}, legends: [], initialHiddenIds: [], annotations: [], markers: [], enableTotals: !1, totalsOffset: 10 }, gt = Ye({}, et, { layers: ["grid", "axes", "bars", "totals", "markers", "legends", "annotations"], barComponent: vY, defs: [], fill: [], animate: !0, motionConfig: "default", role: "img", isFocusable: !1 }), Wt = Ye({}, et, { layers: ["grid", "axes", "bars", "totals", "legends", "annotations"], pixelRatio: typeof window < "u" && (Tp = window.devicePixelRatio) != null ? Tp : 1 }), _k = function(e, t, n, r, o, i) {
  return qa(r, { all: e.map(t), min: 0, max: 0 }, o, i).padding(n);
}, kk = function(e, t) {
  return e.map(function(n) {
    return Ye({}, t.reduce(function(r, o) {
      return r[o] = null, r;
    }, {}), n);
  });
}, Mc = function(e) {
  return Object.keys(e).reduce(function(t, n) {
    return e[n] && (t[n] = e[n]), t;
  }, {});
}, Ec = function(e) {
  return [e, Number(e)];
};
function Sk(e, t, n, r) {
  return e === void 0 && (e = et.layout), t === void 0 && (t = et.reverse), n === void 0 && (n = et.labelPosition), r === void 0 && (r = et.labelOffset), function(o, i) {
    var a = r * (t ? -1 : 1);
    if (e === "horizontal") {
      var s = o / 2;
      return n === "start" ? s = t ? o : 0 : n === "end" && (s = t ? 0 : o), { labelX: s + a, labelY: i / 2, textAnchor: n === "middle" ? "middle" : t ? "end" : "start" };
    }
    var l = i / 2;
    return n === "start" ? l = t ? 0 : i : n === "end" && (l = t ? i : 0), { labelX: o / 2, labelY: l - a, textAnchor: "middle" };
  };
}
var CY = ["layout", "minValue", "maxValue", "reverse", "width", "height", "padding", "innerPadding", "valueScale", "indexScale", "hiddenIds"], V4 = function(e, t) {
  return e > t;
}, Mk = function(e, t) {
  return e < t;
}, Ek = function(e, t) {
  return Array.from(" ".repeat(t - e), function(n, r) {
    return e + r;
  });
}, wY = function(e) {
  return V4(e, 0) ? 0 : e;
}, xY = function(e, t, n, r) {
  var o = e.data, i = e.formatValue, a = e.getColor, s = e.getIndex, l = e.getTooltipLabel, c = e.innerPadding, f = c === void 0 ? 0 : c, u = e.keys, h = e.xScale, m = e.yScale, g = e.margin, p = n ? Mk : V4, v = o.map(Mc), y = [];
  return u.forEach(function(C, w) {
    return Ek(0, h.domain().length).forEach(function(_) {
      var x, k, S, T = Ec(o[_][C]), L = T[0], R = T[1], M = s(o[_]), A = ((x = h(M)) != null ? x : 0) + t * w + f * w, O = p(k = R, 0) ? (S = m(k)) != null ? S : 0 : r, I = function(N, H) {
        var q;
        return p(N, 0) ? r - H : ((q = m(N)) != null ? q : 0) - r;
      }(R, O), W = { id: C, value: L === null ? L : R, formattedValue: i(R), hidden: !1, index: _, indexValue: M, data: v[_] };
      y.push({ key: C + "." + W.indexValue, index: y.length, data: W, x: A, y: O, absX: g.left + A, absY: g.top + O, width: t, height: I, color: a(W), label: l(W) });
    });
  }), y;
}, _Y = function(e, t, n, r) {
  var o = e.data, i = e.formatValue, a = e.getIndex, s = e.getColor, l = e.getTooltipLabel, c = e.keys, f = e.innerPadding, u = f === void 0 ? 0 : f, h = e.xScale, m = e.yScale, g = e.margin, p = n ? Mk : V4, v = o.map(Mc), y = [];
  return c.forEach(function(C, w) {
    return Ek(0, m.domain().length).forEach(function(_) {
      var x, k, S, T = Ec(o[_][C]), L = T[0], R = T[1], M = a(o[_]), A = p(k = R, 0) ? r : (S = h(k)) != null ? S : 0, O = ((x = m(M)) != null ? x : 0) + t * w + u * w, I = function(N, H) {
        var q;
        return p(N, 0) ? ((q = h(N)) != null ? q : 0) - r : r - H;
      }(R, A), W = { id: C, value: L === null ? L : R, formattedValue: i(R), hidden: !1, index: _, indexValue: M, data: v[_] };
      y.push({ key: C + "." + W.indexValue, index: y.length, data: W, x: A, y: O, absX: g.left + A, absY: g.top + O, width: I, height: t, color: s(W), label: l(W) });
    });
  }), y;
}, kY = function(e) {
  var t, n, r = e.layout, o = e.minValue, i = e.maxValue, a = e.reverse, s = e.width, l = e.height, c = e.padding, f = c === void 0 ? 0 : c, u = e.innerPadding, h = u === void 0 ? 0 : u, m = e.valueScale, g = e.indexScale, p = e.hiddenIds, v = p === void 0 ? [] : p, y = Ii(e, CY), C = y.keys.filter(function($) {
    return !v.includes($);
  }), w = kk(y.data, C), _ = r === "vertical" ? ["y", "x", s] : ["x", "y", l], x = _[0], k = _[1], S = _[2], T = _k(w, y.getIndex, f, g, S, k), L = Ye({ max: i, min: o, reverse: a }, m), R = L.min === "auto" ? wY : function($) {
    return $;
  }, M = w.reduce(function($, U) {
    return [].concat($, C.map(function(B) {
      return U[B];
    }));
  }, []).filter(Boolean), A = R(Math.min.apply(Math, M)), O = (n = Math.max.apply(Math, M), isFinite(n) ? n : 0), I = qa(L, { all: M, min: A, max: O }, x === "x" ? s : l, x), W = r === "vertical" ? [T, I] : [I, T], N = W[0], H = W[1], q = (T.bandwidth() - h * (C.length - 1)) / C.length, D = [Ye({}, y, { data: w, keys: C, innerPadding: h, xScale: N, yScale: H }), q, L.reverse, (t = I(0)) != null ? t : 0];
  return { xScale: N, yScale: H, bars: q > 0 ? r === "vertical" ? xY.apply(void 0, D) : _Y.apply(void 0, D) : [] };
}, SY = ["data", "layout", "minValue", "maxValue", "reverse", "width", "height", "padding", "valueScale", "indexScale", "hiddenIds"], MY = function e(t) {
  var n;
  return t.some(Array.isArray) ? e((n = []).concat.apply(n, t)) : t;
}, EY = function(e, t, n) {
  var r = e.formatValue, o = e.getColor, i = e.getIndex, a = e.getTooltipLabel, s = e.innerPadding, l = e.stackedData, c = e.xScale, f = e.yScale, u = e.margin, h = [];
  return l.forEach(function(m) {
    return c.domain().forEach(function(g, p) {
      var v, y, C = m[p], w = (v = c(i(C.data))) != null ? v : 0, _ = ((y = function(R) {
        return f(R[n ? 0 : 1]);
      }(C)) != null ? y : 0) + 0.5 * s, x = function(R, M) {
        var A;
        return ((A = f(R[n ? 1 : 0])) != null ? A : 0) - M;
      }(C, _) - s, k = Ec(C.data[m.key]), S = k[0], T = k[1], L = { id: m.key, value: S === null ? S : T, formattedValue: r(T), hidden: !1, index: p, indexValue: g, data: Mc(C.data) };
      h.push({ key: m.key + "." + g, index: h.length, data: L, x: w, y: _, absX: u.left + w, absY: u.top + _, width: t, height: x, color: o(L), label: a(L) });
    });
  }), h;
}, LY = function(e, t, n) {
  var r = e.formatValue, o = e.getColor, i = e.getIndex, a = e.getTooltipLabel, s = e.innerPadding, l = e.stackedData, c = e.xScale, f = e.yScale, u = e.margin, h = [];
  return l.forEach(function(m) {
    return f.domain().forEach(function(g, p) {
      var v, y, C = m[p], w = (v = f(i(C.data))) != null ? v : 0, _ = ((y = function(R) {
        return c(R[n ? 1 : 0]);
      }(C)) != null ? y : 0) + 0.5 * s, x = function(R, M) {
        var A;
        return ((A = c(R[n ? 0 : 1])) != null ? A : 0) - M;
      }(C, _) - s, k = Ec(C.data[m.key]), S = k[0], T = k[1], L = { id: m.key, value: S === null ? S : T, formattedValue: r(T), hidden: !1, index: p, indexValue: g, data: Mc(C.data) };
      h.push({ key: m.key + "." + g, index: h.length, data: L, x: _, y: w, absX: u.left + _, absY: u.top + w, width: x, height: t, color: o(L), label: a(L) });
    });
  }), h;
}, TY = function(e) {
  var t, n = e.data, r = e.layout, o = e.minValue, i = e.maxValue, a = e.reverse, s = e.width, l = e.height, c = e.padding, f = c === void 0 ? 0 : c, u = e.valueScale, h = e.indexScale, m = e.hiddenIds, g = m === void 0 ? [] : m, p = Ii(e, SY), v = p.keys.filter(function(q) {
    return !g.includes(q);
  }), y = nH().keys(v).offset(rH)(kk(n, v)), C = r === "vertical" ? ["y", "x", s] : ["x", "y", l], w = C[0], _ = C[1], x = C[2], k = _k(n, p.getIndex, f, h, x, _), S = Ye({ max: i, min: o, reverse: a }, u), T = (t = MY(y), u.type === "log" ? t.filter(function(q) {
    return q !== 0;
  }) : t), L = Math.min.apply(Math, T), R = Math.max.apply(Math, T), M = qa(S, { all: T, min: L, max: R }, w === "x" ? s : l, w), A = r === "vertical" ? [k, M] : [M, k], O = A[0], I = A[1], W = p.innerPadding > 0 ? p.innerPadding : 0, N = k.bandwidth(), H = [Ye({}, p, { innerPadding: W, stackedData: y, xScale: O, yScale: I }), N, S.reverse];
  return { xScale: O, yScale: I, bars: N > 0 ? r === "vertical" ? EY.apply(void 0, H) : LY.apply(void 0, H) : [] };
}, PY = function(e) {
  var t = e.bars, n = e.direction, r = e.from, o = e.groupMode, i = e.layout, a = e.legendLabel, s = e.reverse, l = z_(a ?? (r === "indexes" ? "indexValue" : "id"));
  return r === "indexes" ? function(c, f, u) {
    var h = y9(c.map(function(m) {
      var g, p;
      return { id: (g = m.data.indexValue) != null ? g : "", label: u(m.data), hidden: m.data.hidden, color: (p = m.color) != null ? p : "#000" };
    }), function(m) {
      return m.id;
    });
    return f === "horizontal" && h.reverse(), h;
  }(t, i, l) : function(c, f, u, h, m, g) {
    var p = y9(c.map(function(v) {
      var y;
      return { id: v.data.id, label: g(v.data), hidden: v.data.hidden, color: (y = v.color) != null ? y : "#000" };
    }), function(v) {
      return v.id;
    });
    return (f === "vertical" && h === "stacked" && u === "column" && m !== !0 || f === "horizontal" && h === "stacked" && m === !0) && p.reverse(), p;
  }(t, i, n, o, s, l);
}, Pp = function(e, t, n) {
  var r = e.get(t) || 0;
  e.set(t, r + n);
}, RY = function(e, t, n) {
  var r = e.get(t) || 0;
  e.set(t, r + (n > 0 ? n : 0));
}, AY = function(e, t, n) {
  var r = e.get(t) || 0;
  e.set(t, Math.max(r, Number(n)));
}, OY = function(e, t) {
  var n = e.get(t) || 0;
  e.set(t, n + 1);
}, Lk = function(e) {
  var t = e.indexBy, n = t === void 0 ? et.indexBy : t, r = e.keys, o = r === void 0 ? et.keys : r, i = e.label, a = i === void 0 ? et.label : i, s = e.tooltipLabel, l = s === void 0 ? et.tooltipLabel : s, c = e.valueFormat, f = e.colors, u = f === void 0 ? et.colors : f, h = e.colorBy, m = h === void 0 ? et.colorBy : h, g = e.borderColor, p = g === void 0 ? et.borderColor : g, v = e.labelTextColor, y = v === void 0 ? et.labelTextColor : v, C = e.groupMode, w = C === void 0 ? et.groupMode : C, _ = e.layout, x = _ === void 0 ? et.layout : _, k = e.reverse, S = k === void 0 ? et.reverse : k, T = e.data, L = e.minValue, R = L === void 0 ? et.minValue : L, M = e.maxValue, A = M === void 0 ? et.maxValue : M, O = e.margin, I = e.width, W = e.height, N = e.padding, H = N === void 0 ? et.padding : N, q = e.innerPadding, D = q === void 0 ? et.innerPadding : q, $ = e.valueScale, U = $ === void 0 ? et.valueScale : $, B = e.indexScale, K = B === void 0 ? et.indexScale : B, X = e.initialHiddenIds, Z = X === void 0 ? et.initialHiddenIds : X, G = e.enableLabel, V = G === void 0 ? et.enableLabel : G, Y = e.labelSkipWidth, P = Y === void 0 ? et.labelSkipWidth : Y, F = e.labelSkipHeight, z = F === void 0 ? et.labelSkipHeight : F, E = e.legends, re = E === void 0 ? et.legends : E, ee = e.legendLabel, oe = e.totalsOffset, ue = oe === void 0 ? et.totalsOffset : oe, le = Yt(Z ?? []), Ae = le[0], Ie = le[1], bt = be(function(pe) {
    Ie(function(ae) {
      return ae.indexOf(pe) > -1 ? ae.filter(function(ge) {
        return ge !== pe;
      }) : [].concat(ae, [pe]);
    });
  }, []), He = ff(n), Me = ff(a), Pe = ff(l), rt = Fa(c), ft = xt(), Xe = bk(u, m), ht = mi(p, ft), Ge = mi(y, ft), Ve = (w === "grouped" ? kY : TY)({ layout: x, reverse: S, data: T, getIndex: He, keys: o, minValue: R, maxValue: A, width: I, height: W, getColor: Xe, padding: H, innerPadding: D, valueScale: U, indexScale: K, hiddenIds: Ae, formatValue: rt, getTooltipLabel: Pe, margin: O }), Be = Ve.bars, ct = Ve.xScale, ot = Ve.yScale, it = Te(function() {
    return Be.filter(function(pe) {
      return pe.data.value !== null;
    }).map(function(pe, ae) {
      return Ye({}, pe, { index: ae });
    });
  }, [Be]), mt = be(function(pe) {
    var ae = pe.width, ge = pe.height;
    return !!V && !(P > 0 && ae < P) && !(z > 0 && ge < z);
  }, [V, P, z]), Qe = Te(function() {
    return o.map(function(pe) {
      var ae = Be.find(function(ge) {
        return ge.data.id === pe;
      });
      return Ye({}, ae, { data: Ye({ id: pe }, ae == null ? void 0 : ae.data, { hidden: Ae.includes(pe) }) });
    });
  }, [Ae, o, Be]), ut = Te(function() {
    return re.map(function(pe) {
      return [pe, PY({ bars: pe.dataFrom === "keys" ? Qe : Be, direction: pe.direction, from: pe.dataFrom, groupMode: w, layout: x, legendLabel: ee, reverse: S })];
    });
  }, [re, Qe, Be, w, x, ee, S]), Dt = Te(function() {
    return function(pe, ae, ge, we, We, Oe, de) {
      we === void 0 && (we = et.layout), We === void 0 && (We = et.groupMode);
      var xe = [];
      if (pe.length === 0) return xe;
      var Ee = /* @__PURE__ */ new Map(), me = pe[0].width, Pt = pe[0].height;
      if (We === "stacked") {
        var qe = /* @__PURE__ */ new Map();
        pe.forEach(function(se) {
          var ve = se.data, $e = ve.indexValue, Fe = ve.value;
          Pp(Ee, $e, Number(Fe)), RY(qe, $e, Number(Fe));
        }), qe.forEach(function(se, ve) {
          var $e, Fe, je, Rt = Ee.get(ve) || 0;
          we === "vertical" ? ($e = ae(ve), Fe = ge(se), je = ge(se / 2)) : ($e = ae(se), Fe = ge(ve), je = ae(se / 2)), $e += we === "vertical" ? me / 2 : Oe, Fe += we === "vertical" ? -Oe : Pt / 2, xe.push({ key: "total_" + ve, x: $e, y: Fe, value: Rt, formattedValue: de(Rt), animationOffset: je });
        });
      } else if (We === "grouped") {
        var yt = /* @__PURE__ */ new Map(), Mt = /* @__PURE__ */ new Map();
        pe.forEach(function(se) {
          var ve = se.data, $e = ve.indexValue, Fe = ve.value;
          Pp(Ee, $e, Number(Fe)), AY(yt, $e, Number(Fe)), OY(Mt, $e);
        }), yt.forEach(function(se, ve) {
          var $e, Fe, je, Rt = Ee.get(ve) || 0, Ut = Mt.get(ve);
          we === "vertical" ? ($e = ae(ve), Fe = ge(se), je = ge(se / 2)) : ($e = ae(se), Fe = ge(ve), je = ae(se / 2)), $e += we === "vertical" ? Ut * me / 2 : Oe, Fe += we === "vertical" ? -Oe : Ut * Pt / 2, xe.push({ key: "total_" + ve, x: $e, y: Fe, value: Rt, formattedValue: de(Rt), animationOffset: je });
        });
      }
      return xe;
    }(Be, ct, ot, x, w, ue, rt);
  }, [Be, ct, ot, x, w, ue, rt]);
  return { bars: Be, barsWithValue: it, xScale: ct, yScale: ot, getIndex: He, getLabel: Me, getTooltipLabel: Pe, formatValue: rt, getColor: Xe, getBorderColor: ht, getLabelColor: Ge, shouldRenderBarLabel: mt, hiddenIds: Ae, toggleSerie: bt, legendsWithData: ut, barTotals: Dt };
}, NY = function(e) {
  var t = e.data, n = e.springConfig, r = e.animate, o = e.layout, i = o === void 0 ? gt.layout : o, a = xt();
  return Sl(t, { keys: function(s) {
    return s.key;
  }, from: function(s) {
    return { x: i === "vertical" ? s.x : s.animationOffset, y: i === "vertical" ? s.animationOffset : s.y, labelOpacity: 0 };
  }, enter: function(s) {
    return { x: s.x, y: s.y, labelOpacity: 1 };
  }, update: function(s) {
    return { x: s.x, y: s.y, labelOpacity: 1 };
  }, leave: function(s) {
    return { x: i === "vertical" ? s.x : s.animationOffset, y: i === "vertical" ? s.animationOffset : s.y, labelOpacity: 0 };
  }, config: n, immediate: !r, initial: r ? void 0 : null })(function(s, l) {
    return b(_t.text, { x: s.x, y: s.y, fillOpacity: s.labelOpacity, style: Ye({}, a.labels.text, { pointerEvents: "none", fill: a.text.fill }), fontWeight: "bold", fontSize: a.labels.text.fontSize, fontFamily: a.labels.text.fontFamily, textAnchor: i === "vertical" ? "middle" : "start", alignmentBaseline: i === "vertical" ? "alphabetic" : "middle", children: l.formattedValue }, l.key);
  });
}, DY = ["isInteractive", "animate", "motionConfig", "theme", "renderWrapper"], IY = function(e) {
  var t = e.data, n = e.indexBy, r = e.keys, o = e.margin, i = e.width, a = e.height, s = e.groupMode, l = e.layout, c = e.reverse, f = e.minValue, u = e.maxValue, h = e.valueScale, m = e.indexScale, g = e.padding, p = e.innerPadding, v = e.axisTop, y = e.axisRight, C = e.axisBottom, w = C === void 0 ? gt.axisBottom : C, _ = e.axisLeft, x = _ === void 0 ? gt.axisLeft : _, k = e.enableGridX, S = k === void 0 ? gt.enableGridX : k, T = e.enableGridY, L = T === void 0 ? gt.enableGridY : T, R = e.gridXValues, M = e.gridYValues, A = e.layers, O = A === void 0 ? gt.layers : A, I = e.barComponent, W = I === void 0 ? gt.barComponent : I, N = e.enableLabel, H = N === void 0 ? gt.enableLabel : N, q = e.label, D = e.labelSkipWidth, $ = D === void 0 ? gt.labelSkipWidth : D, U = e.labelSkipHeight, B = U === void 0 ? gt.labelSkipHeight : U, K = e.labelTextColor, X = e.labelPosition, Z = X === void 0 ? gt.labelPosition : X, G = e.labelOffset, V = G === void 0 ? gt.labelOffset : G, Y = e.markers, P = Y === void 0 ? gt.markers : Y, F = e.colorBy, z = e.colors, E = e.defs, re = E === void 0 ? gt.defs : E, ee = e.fill, oe = ee === void 0 ? gt.fill : ee, ue = e.borderRadius, le = ue === void 0 ? gt.borderRadius : ue, Ae = e.borderWidth, Ie = Ae === void 0 ? gt.borderWidth : Ae, bt = e.borderColor, He = e.annotations, Me = He === void 0 ? gt.annotations : He, Pe = e.legendLabel, rt = e.tooltipLabel, ft = e.valueFormat, Xe = e.isInteractive, ht = Xe === void 0 ? gt.isInteractive : Xe, Ge = e.tooltip, Ve = Ge === void 0 ? gt.tooltip : Ge, Be = e.onClick, ct = e.onMouseEnter, ot = e.onMouseLeave, it = e.legends, mt = e.role, Qe = mt === void 0 ? gt.role : mt, ut = e.ariaLabel, Dt = e.ariaLabelledBy, pe = e.ariaDescribedBy, ae = e.isFocusable, ge = ae === void 0 ? gt.isFocusable : ae, we = e.barAriaLabel, We = e.barAriaLabelledBy, Oe = e.barAriaDescribedBy, de = e.barAriaHidden, xe = e.barAriaDisabled, Ee = e.initialHiddenIds, me = e.enableTotals, Pt = me === void 0 ? gt.enableTotals : me, qe = e.totalsOffset, yt = qe === void 0 ? gt.totalsOffset : qe, Mt = kn(), se = Mt.animate, ve = Mt.config, $e = kc(i, a, o), Fe = $e.outerWidth, je = $e.outerHeight, Rt = $e.margin, Ut = $e.innerWidth, It = $e.innerHeight, pt = Lk({ indexBy: n, label: q, tooltipLabel: rt, valueFormat: ft, colors: z, colorBy: F, borderColor: bt, labelTextColor: K, groupMode: s, layout: l, reverse: c, data: t, keys: r, minValue: f, maxValue: u, margin: Rt, width: Ut, height: It, padding: g, innerPadding: p, valueScale: h, indexScale: m, enableLabel: H, labelSkipWidth: $, labelSkipHeight: B, legends: it, legendLabel: Pe, initialHiddenIds: Ee, totalsOffset: yt }), Mr = pt.bars, Oo = pt.barsWithValue, zt = pt.xScale, ar = pt.yScale, $i = pt.getLabel, _e = pt.getTooltipLabel, Se = pt.getBorderColor, Ue = pt.getLabelColor, Je = pt.shouldRenderBarLabel, ze = pt.toggleSerie, Bt = pt.legendsWithData, Ct = pt.barTotals, at = pt.getColor, sr = Sk(l, c, Z, V), No = Sl(Oo, { keys: function(he) {
    return he.key;
  }, from: function(he) {
    return Ye({ borderColor: Se(he), color: he.color, height: 0, labelColor: Ue(he), labelOpacity: 0 }, sr(he.width, he.height), { transform: "translate(" + he.x + ", " + (he.y + he.height) + ")", width: he.width }, l === "vertical" ? {} : { height: he.height, transform: "translate(" + he.x + ", " + he.y + ")", width: 0 });
  }, enter: function(he) {
    return Ye({ borderColor: Se(he), color: he.color, height: he.height, labelColor: Ue(he), labelOpacity: 1 }, sr(he.width, he.height), { transform: "translate(" + he.x + ", " + he.y + ")", width: he.width });
  }, update: function(he) {
    return Ye({ borderColor: Se(he), color: he.color, height: he.height, labelColor: Ue(he), labelOpacity: 1 }, sr(he.width, he.height), { transform: "translate(" + he.x + ", " + he.y + ")", width: he.width });
  }, leave: function(he) {
    return Ye({ borderColor: Se(he), color: he.color, height: 0, labelColor: Ue(he), labelOpacity: 0 }, sr(he.width, he.height), { labelY: 0, transform: "translate(" + he.x + ", " + (he.y + he.height) + ")", width: he.width }, l === "vertical" ? {} : Ye({}, sr(he.width, he.height), { labelX: 0, height: he.height, transform: "translate(" + he.x + ", " + he.y + ")", width: 0 }));
  }, config: ve, immediate: !se, initial: se ? void 0 : null }), $n = Te(function() {
    return { borderRadius: le, borderWidth: Ie, enableLabel: H, isInteractive: ht, labelSkipWidth: $, labelSkipHeight: B, onClick: Be, onMouseEnter: ct, onMouseLeave: ot, getTooltipLabel: _e, tooltip: Ve, isFocusable: ge, ariaLabel: we, ariaLabelledBy: We, ariaDescribedBy: Oe, ariaHidden: de, ariaDisabled: xe };
  }, [le, Ie, H, _e, ht, B, $, Be, ct, ot, Ve, ge, we, We, Oe, de, xe]), lr = G_(re, Mr, oe, { dataKey: "data", targetKey: "data.fill" }), an = { annotations: null, axes: null, bars: null, grid: null, legends: null, markers: null, totals: null };
  O.includes("annotations") && (an.annotations = b(mY, { bars: Mr, annotations: Me }, "annotations")), O.includes("axes") && (an.axes = b(sk, { xScale: zt, yScale: ar, width: Ut, height: It, top: v, right: y, bottom: w, left: x }, "axes")), O.includes("bars") && (an.bars = b(C2, { children: No(function(he, Fn) {
    return $t(W, Ye({}, $n, { bar: Fn, style: he, shouldRenderLabel: Je(Fn), label: $i(Fn.data) }));
  }) }, "bars")), O.includes("grid") && (an.grid = b(lk, { width: Ut, height: It, xScale: S ? zt : null, yScale: L ? ar : null, xValues: R, yValues: M }, "grid")), O.includes("legends") && (an.legends = b(pY, { width: Ut, height: It, legends: Bt, toggleSerie: ze }, "legends")), O.includes("markers") && (an.markers = b(V_, { markers: P, width: Ut, height: It, xScale: zt, yScale: ar }, "markers")), O.includes("totals") && Pt && (an.totals = b(NY, { data: Ct, springConfig: ve, animate: se, layout: l }, "totals"));
  var Do = Te(function() {
    return Ye({}, $n, { margin: Rt, width: i, height: a, innerWidth: Ut, innerHeight: It, bars: Mr, legendData: Bt, enableLabel: H, xScale: zt, yScale: ar, tooltip: Ve, getTooltipLabel: _e, onClick: Be, onMouseEnter: ct, onMouseLeave: ot, getColor: at });
  }, [$n, Rt, i, a, Ut, It, Mr, Bt, H, zt, ar, Ve, _e, Be, ct, ot, at]);
  return b(q4, { width: Fe, height: je, margin: Rt, defs: lr, role: Qe, ariaLabel: ut, ariaLabelledBy: Dt, ariaDescribedBy: pe, isFocusable: ge, children: O.map(function(he, Fn) {
    var fn;
    return typeof he == "function" ? b(C2, { children: $t(he, Do) }, Fn) : (fn = an == null ? void 0 : an[he]) != null ? fn : null;
  }) });
}, BY = function(e) {
  var t = e.isInteractive, n = t === void 0 ? gt.isInteractive : t, r = e.animate, o = r === void 0 ? gt.animate : r, i = e.motionConfig, a = i === void 0 ? gt.motionConfig : i, s = e.theme, l = e.renderWrapper, c = Ii(e, DY);
  return b(Sc, { animate: o, isInteractive: n, motionConfig: a, renderWrapper: l, theme: s, children: b(IY, Ye({ isInteractive: n }, c)) });
}, $Y = ["isInteractive", "renderWrapper", "theme"], d2 = function(e, t, n, r) {
  return e.find(function(o) {
    return Y_(o.x + t.left, o.y + t.top, o.width, o.height, n, r);
  });
}, FY = function(e) {
  var t = e.data, n = e.indexBy, r = e.keys, o = e.margin, i = e.width, a = e.height, s = e.groupMode, l = e.layout, c = e.reverse, f = e.minValue, u = e.maxValue, h = e.valueScale, m = e.indexScale, g = e.padding, p = e.innerPadding, v = e.axisTop, y = e.axisRight, C = e.axisBottom, w = C === void 0 ? Wt.axisBottom : C, _ = e.axisLeft, x = _ === void 0 ? Wt.axisLeft : _, k = e.enableGridX, S = k === void 0 ? Wt.enableGridX : k, T = e.enableGridY, L = T === void 0 ? Wt.enableGridY : T, R = e.gridXValues, M = e.gridYValues, A = e.labelPosition, O = A === void 0 ? Wt.labelPosition : A, I = e.labelOffset, W = I === void 0 ? Wt.labelOffset : I, N = e.layers, H = N === void 0 ? Wt.layers : N, q = e.renderBar, D = q === void 0 ? function(_e, Se) {
    var Ue = Se.bar, Je = Ue.color, ze = Ue.height, Bt = Ue.width, Ct = Ue.x, at = Ue.y, sr = Se.borderColor, No = Se.borderRadius, $n = Se.borderWidth, lr = Se.label, an = Se.labelColor, Do = Se.shouldRenderLabel, he = Se.labelX, Fn = Se.labelY, fn = Se.textAnchor;
    if (_e.fillStyle = Je, $n > 0 && (_e.strokeStyle = sr, _e.lineWidth = $n), _e.beginPath(), No > 0) {
      var Mn = Math.min(No, ze);
      _e.moveTo(Ct + Mn, at), _e.lineTo(Ct + Bt - Mn, at), _e.quadraticCurveTo(Ct + Bt, at, Ct + Bt, at + Mn), _e.lineTo(Ct + Bt, at + ze - Mn), _e.quadraticCurveTo(Ct + Bt, at + ze, Ct + Bt - Mn, at + ze), _e.lineTo(Ct + Mn, at + ze), _e.quadraticCurveTo(Ct, at + ze, Ct, at + ze - Mn), _e.lineTo(Ct, at + Mn), _e.quadraticCurveTo(Ct, at, Ct + Mn, at), _e.closePath();
    } else _e.rect(Ct, at, Bt, ze);
    _e.fill(), $n > 0 && _e.stroke(), Do && (_e.textBaseline = "middle", _e.textAlign = fn === "middle" ? "center" : fn, _e.fillStyle = an, _e.fillText(lr, Ct + he, at + Fn));
  } : q, $ = e.enableLabel, U = $ === void 0 ? Wt.enableLabel : $, B = e.label, K = e.labelSkipWidth, X = K === void 0 ? Wt.labelSkipWidth : K, Z = e.labelSkipHeight, G = Z === void 0 ? Wt.labelSkipHeight : Z, V = e.labelTextColor, Y = e.colorBy, P = e.colors, F = e.borderRadius, z = F === void 0 ? Wt.borderRadius : F, E = e.borderWidth, re = E === void 0 ? Wt.borderWidth : E, ee = e.borderColor, oe = e.annotations, ue = oe === void 0 ? Wt.annotations : oe, le = e.legendLabel, Ae = e.tooltipLabel, Ie = e.valueFormat, bt = e.isInteractive, He = bt === void 0 ? Wt.isInteractive : bt, Me = e.tooltip, Pe = Me === void 0 ? Wt.tooltip : Me, rt = e.onClick, ft = e.onMouseEnter, Xe = e.onMouseLeave, ht = e.legends, Ge = e.pixelRatio, Ve = Ge === void 0 ? Wt.pixelRatio : Ge, Be = e.canvasRef, ct = e.enableTotals, ot = ct === void 0 ? Wt.enableTotals : ct, it = e.totalsOffset, mt = it === void 0 ? Wt.totalsOffset : it, Qe = Lt(null), ut = xt(), Dt = kc(i, a, o), pe = Dt.margin, ae = Dt.innerWidth, ge = Dt.innerHeight, we = Dt.outerWidth, We = Dt.outerHeight, Oe = Lk({ indexBy: n, label: B, tooltipLabel: Ae, valueFormat: Ie, colors: P, colorBy: Y, borderColor: ee, labelTextColor: V, groupMode: s, layout: l, reverse: c, data: t, keys: r, minValue: f, maxValue: u, margin: pe, width: ae, height: ge, padding: g, innerPadding: p, valueScale: h, indexScale: m, enableLabel: U, labelSkipWidth: X, labelSkipHeight: G, legends: ht, legendLabel: le, totalsOffset: mt }), de = Oe.bars, xe = Oe.barsWithValue, Ee = Oe.xScale, me = Oe.yScale, Pt = Oe.getLabel, qe = Oe.getTooltipLabel, yt = Oe.getBorderColor, Mt = Oe.getLabelColor, se = Oe.shouldRenderBarLabel, ve = Oe.legendsWithData, $e = Oe.barTotals, Fe = Oe.getColor, je = Li(), Rt = je.showTooltipFromEvent, Ut = je.hideTooltip, It = Fz({ annotations: mk({ data: de, annotations: ue, getPosition: function(_e) {
    return { x: _e.x, y: _e.y };
  }, getDimensions: function(_e) {
    var Se = _e.width, Ue = _e.height;
    return { width: Se, height: Ue, size: Math.max(Se, Ue) };
  } }) }), pt = Te(function() {
    return { borderRadius: z, borderWidth: re, isInteractive: He, isFocusable: !1, labelSkipWidth: X, labelSkipHeight: G, margin: pe, width: i, height: a, innerWidth: ae, innerHeight: ge, bars: de, legendData: ve, enableLabel: U, xScale: Ee, yScale: me, tooltip: Pe, getTooltipLabel: qe, onClick: rt, onMouseEnter: ft, onMouseLeave: Xe, getColor: Fe };
  }, [z, re, He, X, G, pe, i, a, ae, ge, de, ve, U, Ee, me, Pe, qe, rt, ft, Xe, Fe]), Mr = Fa(Ie), Oo = Sk(l, c, O, W);
  dn(function() {
    var _e, Se = (_e = Qe.current) == null ? void 0 : _e.getContext("2d");
    Qe.current && Se && (Qe.current.width = we * Ve, Qe.current.height = We * Ve, Se.scale(Ve, Ve), Se.fillStyle = ut.background, Se.fillRect(0, 0, we, We), Se.translate(pe.left, pe.top), H.forEach(function(Ue) {
      Ue === "grid" ? typeof ut.grid.line.strokeWidth == "number" && ut.grid.line.strokeWidth > 0 && (Se.lineWidth = ut.grid.line.strokeWidth, Se.strokeStyle = ut.grid.line.stroke, S && S0(Se, { width: ae, height: ge, scale: Ee, axis: "x", values: R }), L && S0(Se, { width: ae, height: ge, scale: me, axis: "y", values: M })) : Ue === "axes" ? ck(Se, { xScale: Ee, yScale: me, width: ae, height: ge, top: v, right: y, bottom: w, left: x, theme: ut }) : Ue === "bars" ? xe.forEach(function(Je) {
        D(Se, Ye({ bar: Je, borderColor: yt(Je), borderRadius: z, borderWidth: re, label: Pt(Je.data), labelColor: Mt(Je), shouldRenderLabel: se(Je) }, Oo(Je.width, Je.height)));
      }) : Ue === "legends" ? ve.forEach(function(Je) {
        var ze = Je[0], Bt = Je[1];
        xk(Se, Ye({}, ze, { data: Bt, containerWidth: ae, containerHeight: ge, theme: ut }));
      }) : Ue === "annotations" ? zz(Se, { annotations: It, theme: ut }) : Ue === "totals" && ot ? function(Je, ze, Bt, Ct) {
        Ct === void 0 && (Ct = Wt.layout), Je.fillStyle = Bt.text.fill, Je.font = "bold " + Bt.labels.text.fontSize + "px " + Bt.labels.text.fontFamily, Je.textBaseline = Ct === "vertical" ? "alphabetic" : "middle", Je.textAlign = Ct === "vertical" ? "center" : "start", ze.forEach(function(at) {
          Je.fillText(at.formattedValue, at.x, at.y);
        });
      }(Se, $e, ut, l) : typeof Ue == "function" && Ue(Se, pt);
    }), Se.save());
  }, [w, x, y, v, xe, z, re, It, S, L, yt, Pt, Mt, R, M, s, a, ge, ae, pt, H, l, ve, pe.left, pe.top, We, we, Ve, D, Ee, me, c, se, ut, i, $e, ot, Mr, Oo]);
  var zt = be(function(_e) {
    if (de && Qe.current) {
      var Se = pa(Qe.current, _e), Ue = Se[0], Je = Se[1], ze = d2(de, pe, Ue, Je);
      ze !== void 0 ? (Rt($t(Pe, Ye({}, ze.data, { color: ze.color, label: ze.label, value: Number(ze.data.value) })), _e), _e.type === "mouseenter" && (ft == null || ft(ze.data, _e))) : Ut();
    }
  }, [Ut, pe, ft, de, Rt, Pe]), ar = be(function(_e) {
    if (de && Qe.current) {
      Ut();
      var Se = pa(Qe.current, _e), Ue = Se[0], Je = Se[1], ze = d2(de, pe, Ue, Je);
      ze && (Xe == null || Xe(ze.data, _e));
    }
  }, [Ut, pe, Xe, de]), $i = be(function(_e) {
    if (de && Qe.current) {
      var Se = pa(Qe.current, _e), Ue = Se[0], Je = Se[1], ze = d2(de, pe, Ue, Je);
      ze !== void 0 && (rt == null || rt(Ye({}, ze.data, { color: ze.color }), _e));
    }
  }, [pe, rt, de]);
  return b("canvas", { ref: function(_e) {
    Qe.current = _e, Be && "current" in Be && (Be.current = _e);
  }, width: we * Ve, height: We * Ve, style: { width: we, height: We, cursor: He ? "auto" : "normal" }, onMouseEnter: He ? zt : void 0, onMouseMove: He ? zt : void 0, onMouseLeave: He ? ar : void 0, onClick: He ? $i : void 0 });
}, WY = fe(function(e, t) {
  var n = e.isInteractive, r = e.renderWrapper, o = e.theme, i = Ii(e, $Y);
  return b(Sc, { isInteractive: n, renderWrapper: r, theme: o, animate: !1, children: b(FY, Ye({}, i, { canvasRef: t })) });
}), qY = function(e) {
  return b(gs, { children: function(t) {
    var n = t.width, r = t.height;
    return b(BY, Ye({ width: n, height: r }, e));
  } });
};
fe(function(e, t) {
  return b(gs, { children: function(n) {
    var r = n.width, o = n.height;
    return b(WY, Ye({ width: r, height: o }, e, { ref: t }));
  } });
});
function Tk({
  axisBottom: e,
  axisLeft: t,
  areaOpacity: n,
  gradientFillColor: r
}) {
  return Te(() => {
    const o = {
      text: {
        fontFamily: "Outfit, sans-serif"
      },
      axis: {
        ticks: {
          text: {
            fontSize: 10,
            fontWeight: 300,
            fill: "hsl(var(--ring))"
          }
        }
      },
      grid: {
        line: {
          stroke: "hsl(var(--muted))",
          strokeWidth: 1
        }
      },
      legends: {
        text: {
          fontSize: 12,
          fontWeight: 300,
          fill: "hsl(var(--secondary-foreground))"
        }
      },
      labels: {
        text: {
          fontSize: 12,
          fontWeight: 700
        }
      }
    }, i = {
      enableGridX: !1,
      enableGridY: !0
    }, a = {
      curve: "monotoneX",
      lineWidth: 1
    }, s = {
      pointSize: 5,
      pointColor: "hsl(var(--background))",
      pointBorderWidth: 1,
      pointBorderColor: { from: "serieColor" }
    }, l = {
      enableArea: !0,
      areaOpacity: n,
      defs: [
        {
          id: "gradientFill",
          type: "linearGradient",
          colors: [
            { offset: 0, color: r || "inherit" },
            { offset: 100, color: r || "inherit", opacity: 0 }
          ]
        }
      ],
      fill: [
        {
          match: "*",
          id: "gradientFill"
        }
      ]
    }, c = {};
    return e !== null && (c.axisBottom = {
      tickSize: 0,
      tickRotation: 0,
      tickPadding: 5,
      ...e
    }), t !== null && (c.axisLeft = {
      tickSize: 0,
      tickValues: 6,
      tickPadding: 10,
      ...t
    }), {
      theme: o,
      grid: i,
      axes: c,
      lineConfig: a,
      pointDefinition: s,
      gradientConfig: l
    };
  }, [e, t, n, r]);
}
function Pk({ className: e, ...t }) {
  const { theme: n, grid: r, axes: o } = Tk({
    axisBottom: t.axisBottom,
    axisLeft: t.axisLeft
  });
  return /* @__PURE__ */ b("div", { className: e, children: /* @__PURE__ */ b(qY, { ...t, theme: n, ...r, ...o }) });
}
Pk.displayName = "LBBarChart";
const jY = Dn(
  "relative w-full rounded-lg border px-4 py-3 text-sm [&>svg+div]:-translate-y-0.75 [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground [&>svg~*]:pl-7",
  {
    variants: {
      variant: {
        default: "bg-background text-foreground",
        destructive: "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive",
        success: "border-success/50 bg-white text-success dark:border-success [&>svg]:text-success"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), HY = d.forwardRef(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ b(
  "div",
  {
    ref: r,
    role: "alert",
    className: Q("flex gap-4", jY({ variant: t }), e),
    ...n
  }
));
HY.displayName = "LBAlert";
const VY = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  "h5",
  {
    ref: n,
    className: Q("mb-1 font-medium leading-none tracking-tight", e),
    ...t
  }
));
VY.displayName = "LBAlertTitle";
const UY = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  "div",
  {
    ref: n,
    className: Q("text-sm [&_p]:leading-relaxed", e),
    ...t
  }
));
UY.displayName = "LBAlertDescription";
var f2, Rp;
function zY() {
  if (Rp) return f2;
  Rp = 1;
  var e = rx(), t = 0;
  function n(r) {
    var o = ++t;
    return e(r) + o;
  }
  return f2 = n, f2;
}
var YY = zY();
const GY = /* @__PURE__ */ Ht(YY), gr = 11102230246251565e-32, Zt = 134217729, KY = (3 + 8 * gr) * gr;
function h2(e, t, n, r, o) {
  let i, a, s, l, c = t[0], f = r[0], u = 0, h = 0;
  f > c == f > -c ? (i = c, c = t[++u]) : (i = f, f = r[++h]);
  let m = 0;
  if (u < e && h < n)
    for (f > c == f > -c ? (a = c + i, s = i - (a - c), c = t[++u]) : (a = f + i, s = i - (a - f), f = r[++h]), i = a, s !== 0 && (o[m++] = s); u < e && h < n; )
      f > c == f > -c ? (a = i + c, l = a - i, s = i - (a - l) + (c - l), c = t[++u]) : (a = i + f, l = a - i, s = i - (a - l) + (f - l), f = r[++h]), i = a, s !== 0 && (o[m++] = s);
  for (; u < e; )
    a = i + c, l = a - i, s = i - (a - l) + (c - l), c = t[++u], i = a, s !== 0 && (o[m++] = s);
  for (; h < n; )
    a = i + f, l = a - i, s = i - (a - l) + (f - l), f = r[++h], i = a, s !== 0 && (o[m++] = s);
  return (i !== 0 || m === 0) && (o[m++] = i), m;
}
function ZY(e, t) {
  let n = t[0];
  for (let r = 1; r < e; r++) n += t[r];
  return n;
}
function vs(e) {
  return new Float64Array(e);
}
const XY = (3 + 16 * gr) * gr, QY = (2 + 12 * gr) * gr, JY = (9 + 64 * gr) * gr * gr, Vo = vs(4), Ap = vs(8), Op = vs(12), Np = vs(16), tn = vs(4);
function eG(e, t, n, r, o, i, a) {
  let s, l, c, f, u, h, m, g, p, v, y, C, w, _, x, k, S, T;
  const L = e - o, R = n - o, M = t - i, A = r - i;
  _ = L * A, h = Zt * L, m = h - (h - L), g = L - m, h = Zt * A, p = h - (h - A), v = A - p, x = g * v - (_ - m * p - g * p - m * v), k = M * R, h = Zt * M, m = h - (h - M), g = M - m, h = Zt * R, p = h - (h - R), v = R - p, S = g * v - (k - m * p - g * p - m * v), y = x - S, u = x - y, Vo[0] = x - (y + u) + (u - S), C = _ + y, u = C - _, w = _ - (C - u) + (y - u), y = w - k, u = w - y, Vo[1] = w - (y + u) + (u - k), T = C + y, u = T - C, Vo[2] = C - (T - u) + (y - u), Vo[3] = T;
  let O = ZY(4, Vo), I = QY * a;
  if (O >= I || -O >= I || (u = e - L, s = e - (L + u) + (u - o), u = n - R, c = n - (R + u) + (u - o), u = t - M, l = t - (M + u) + (u - i), u = r - A, f = r - (A + u) + (u - i), s === 0 && l === 0 && c === 0 && f === 0) || (I = JY * a + KY * Math.abs(O), O += L * f + A * s - (M * c + R * l), O >= I || -O >= I)) return O;
  _ = s * A, h = Zt * s, m = h - (h - s), g = s - m, h = Zt * A, p = h - (h - A), v = A - p, x = g * v - (_ - m * p - g * p - m * v), k = l * R, h = Zt * l, m = h - (h - l), g = l - m, h = Zt * R, p = h - (h - R), v = R - p, S = g * v - (k - m * p - g * p - m * v), y = x - S, u = x - y, tn[0] = x - (y + u) + (u - S), C = _ + y, u = C - _, w = _ - (C - u) + (y - u), y = w - k, u = w - y, tn[1] = w - (y + u) + (u - k), T = C + y, u = T - C, tn[2] = C - (T - u) + (y - u), tn[3] = T;
  const W = h2(4, Vo, 4, tn, Ap);
  _ = L * f, h = Zt * L, m = h - (h - L), g = L - m, h = Zt * f, p = h - (h - f), v = f - p, x = g * v - (_ - m * p - g * p - m * v), k = M * c, h = Zt * M, m = h - (h - M), g = M - m, h = Zt * c, p = h - (h - c), v = c - p, S = g * v - (k - m * p - g * p - m * v), y = x - S, u = x - y, tn[0] = x - (y + u) + (u - S), C = _ + y, u = C - _, w = _ - (C - u) + (y - u), y = w - k, u = w - y, tn[1] = w - (y + u) + (u - k), T = C + y, u = T - C, tn[2] = C - (T - u) + (y - u), tn[3] = T;
  const N = h2(W, Ap, 4, tn, Op);
  _ = s * f, h = Zt * s, m = h - (h - s), g = s - m, h = Zt * f, p = h - (h - f), v = f - p, x = g * v - (_ - m * p - g * p - m * v), k = l * c, h = Zt * l, m = h - (h - l), g = l - m, h = Zt * c, p = h - (h - c), v = c - p, S = g * v - (k - m * p - g * p - m * v), y = x - S, u = x - y, tn[0] = x - (y + u) + (u - S), C = _ + y, u = C - _, w = _ - (C - u) + (y - u), y = w - k, u = w - y, tn[1] = w - (y + u) + (u - k), T = C + y, u = T - C, tn[2] = C - (T - u) + (y - u), tn[3] = T;
  const H = h2(N, Op, 4, tn, Np);
  return Np[H - 1];
}
function Ws(e, t, n, r, o, i) {
  const a = (t - i) * (n - o), s = (e - o) * (r - i), l = a - s, c = Math.abs(a + s);
  return Math.abs(l) >= XY * c ? l : -eG(e, t, n, r, o, i, c);
}
const Dp = Math.pow(2, -52), qs = new Uint32Array(512);
class E0 {
  static from(t, n = iG, r = aG) {
    const o = t.length, i = new Float64Array(o * 2);
    for (let a = 0; a < o; a++) {
      const s = t[a];
      i[2 * a] = n(s), i[2 * a + 1] = r(s);
    }
    return new E0(i);
  }
  constructor(t) {
    const n = t.length >> 1;
    if (n > 0 && typeof t[0] != "number") throw new Error("Expected coords to contain numbers.");
    this.coords = t;
    const r = Math.max(2 * n - 5, 0);
    this._triangles = new Uint32Array(r * 3), this._halfedges = new Int32Array(r * 3), this._hashSize = Math.ceil(Math.sqrt(n)), this._hullPrev = new Uint32Array(n), this._hullNext = new Uint32Array(n), this._hullTri = new Uint32Array(n), this._hullHash = new Int32Array(this._hashSize), this._ids = new Uint32Array(n), this._dists = new Float64Array(n), this.update();
  }
  update() {
    const { coords: t, _hullPrev: n, _hullNext: r, _hullTri: o, _hullHash: i } = this, a = t.length >> 1;
    let s = 1 / 0, l = 1 / 0, c = -1 / 0, f = -1 / 0;
    for (let L = 0; L < a; L++) {
      const R = t[2 * L], M = t[2 * L + 1];
      R < s && (s = R), M < l && (l = M), R > c && (c = R), M > f && (f = M), this._ids[L] = L;
    }
    const u = (s + c) / 2, h = (l + f) / 2;
    let m, g, p;
    for (let L = 0, R = 1 / 0; L < a; L++) {
      const M = m2(u, h, t[2 * L], t[2 * L + 1]);
      M < R && (m = L, R = M);
    }
    const v = t[2 * m], y = t[2 * m + 1];
    for (let L = 0, R = 1 / 0; L < a; L++) {
      if (L === m) continue;
      const M = m2(v, y, t[2 * L], t[2 * L + 1]);
      M < R && M > 0 && (g = L, R = M);
    }
    let C = t[2 * g], w = t[2 * g + 1], _ = 1 / 0;
    for (let L = 0; L < a; L++) {
      if (L === m || L === g) continue;
      const R = rG(v, y, C, w, t[2 * L], t[2 * L + 1]);
      R < _ && (p = L, _ = R);
    }
    let x = t[2 * p], k = t[2 * p + 1];
    if (_ === 1 / 0) {
      for (let M = 0; M < a; M++)
        this._dists[M] = t[2 * M] - t[0] || t[2 * M + 1] - t[1];
      Zo(this._ids, this._dists, 0, a - 1);
      const L = new Uint32Array(a);
      let R = 0;
      for (let M = 0, A = -1 / 0; M < a; M++) {
        const O = this._ids[M], I = this._dists[O];
        I > A && (L[R++] = O, A = I);
      }
      this.hull = L.subarray(0, R), this.triangles = new Uint32Array(0), this.halfedges = new Uint32Array(0);
      return;
    }
    if (Ws(v, y, C, w, x, k) < 0) {
      const L = g, R = C, M = w;
      g = p, C = x, w = k, p = L, x = R, k = M;
    }
    const S = oG(v, y, C, w, x, k);
    this._cx = S.x, this._cy = S.y;
    for (let L = 0; L < a; L++)
      this._dists[L] = m2(t[2 * L], t[2 * L + 1], S.x, S.y);
    Zo(this._ids, this._dists, 0, a - 1), this._hullStart = m;
    let T = 3;
    r[m] = n[p] = g, r[g] = n[m] = p, r[p] = n[g] = m, o[m] = 0, o[g] = 1, o[p] = 2, i.fill(-1), i[this._hashKey(v, y)] = m, i[this._hashKey(C, w)] = g, i[this._hashKey(x, k)] = p, this.trianglesLen = 0, this._addTriangle(m, g, p, -1, -1, -1);
    for (let L = 0, R, M; L < this._ids.length; L++) {
      const A = this._ids[L], O = t[2 * A], I = t[2 * A + 1];
      if (L > 0 && Math.abs(O - R) <= Dp && Math.abs(I - M) <= Dp || (R = O, M = I, A === m || A === g || A === p)) continue;
      let W = 0;
      for (let $ = 0, U = this._hashKey(O, I); $ < this._hashSize && (W = i[(U + $) % this._hashSize], !(W !== -1 && W !== r[W])); $++)
        ;
      W = n[W];
      let N = W, H;
      for (; H = r[N], Ws(O, I, t[2 * N], t[2 * N + 1], t[2 * H], t[2 * H + 1]) >= 0; )
        if (N = H, N === W) {
          N = -1;
          break;
        }
      if (N === -1) continue;
      let q = this._addTriangle(N, A, r[N], -1, -1, o[N]);
      o[A] = this._legalize(q + 2), o[N] = q, T++;
      let D = r[N];
      for (; H = r[D], Ws(O, I, t[2 * D], t[2 * D + 1], t[2 * H], t[2 * H + 1]) < 0; )
        q = this._addTriangle(D, A, H, o[A], -1, o[D]), o[A] = this._legalize(q + 2), r[D] = D, T--, D = H;
      if (N === W)
        for (; H = n[N], Ws(O, I, t[2 * H], t[2 * H + 1], t[2 * N], t[2 * N + 1]) < 0; )
          q = this._addTriangle(H, A, N, -1, o[N], o[H]), this._legalize(q + 2), o[H] = q, r[N] = N, T--, N = H;
      this._hullStart = n[A] = N, r[N] = n[D] = A, r[A] = D, i[this._hashKey(O, I)] = A, i[this._hashKey(t[2 * N], t[2 * N + 1])] = N;
    }
    this.hull = new Uint32Array(T);
    for (let L = 0, R = this._hullStart; L < T; L++)
      this.hull[L] = R, R = r[R];
    this.triangles = this._triangles.subarray(0, this.trianglesLen), this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
  }
  _hashKey(t, n) {
    return Math.floor(tG(t - this._cx, n - this._cy) * this._hashSize) % this._hashSize;
  }
  _legalize(t) {
    const { _triangles: n, _halfedges: r, coords: o } = this;
    let i = 0, a = 0;
    for (; ; ) {
      const s = r[t], l = t - t % 3;
      if (a = l + (t + 2) % 3, s === -1) {
        if (i === 0) break;
        t = qs[--i];
        continue;
      }
      const c = s - s % 3, f = l + (t + 1) % 3, u = c + (s + 2) % 3, h = n[a], m = n[t], g = n[f], p = n[u];
      if (nG(
        o[2 * h],
        o[2 * h + 1],
        o[2 * m],
        o[2 * m + 1],
        o[2 * g],
        o[2 * g + 1],
        o[2 * p],
        o[2 * p + 1]
      )) {
        n[t] = p, n[s] = h;
        const y = r[u];
        if (y === -1) {
          let w = this._hullStart;
          do {
            if (this._hullTri[w] === u) {
              this._hullTri[w] = t;
              break;
            }
            w = this._hullPrev[w];
          } while (w !== this._hullStart);
        }
        this._link(t, y), this._link(s, r[a]), this._link(a, u);
        const C = c + (s + 1) % 3;
        i < qs.length && (qs[i++] = C);
      } else {
        if (i === 0) break;
        t = qs[--i];
      }
    }
    return a;
  }
  _link(t, n) {
    this._halfedges[t] = n, n !== -1 && (this._halfedges[n] = t);
  }
  // add a new triangle given vertex indices and adjacent half-edge ids
  _addTriangle(t, n, r, o, i, a) {
    const s = this.trianglesLen;
    return this._triangles[s] = t, this._triangles[s + 1] = n, this._triangles[s + 2] = r, this._link(s, o), this._link(s + 1, i), this._link(s + 2, a), this.trianglesLen += 3, s;
  }
}
function tG(e, t) {
  const n = e / (Math.abs(e) + Math.abs(t));
  return (t > 0 ? 3 - n : 1 + n) / 4;
}
function m2(e, t, n, r) {
  const o = e - n, i = t - r;
  return o * o + i * i;
}
function nG(e, t, n, r, o, i, a, s) {
  const l = e - a, c = t - s, f = n - a, u = r - s, h = o - a, m = i - s, g = l * l + c * c, p = f * f + u * u, v = h * h + m * m;
  return l * (u * v - p * m) - c * (f * v - p * h) + g * (f * m - u * h) < 0;
}
function rG(e, t, n, r, o, i) {
  const a = n - e, s = r - t, l = o - e, c = i - t, f = a * a + s * s, u = l * l + c * c, h = 0.5 / (a * c - s * l), m = (c * f - s * u) * h, g = (a * u - l * f) * h;
  return m * m + g * g;
}
function oG(e, t, n, r, o, i) {
  const a = n - e, s = r - t, l = o - e, c = i - t, f = a * a + s * s, u = l * l + c * c, h = 0.5 / (a * c - s * l), m = e + (c * f - s * u) * h, g = t + (a * u - l * f) * h;
  return { x: m, y: g };
}
function Zo(e, t, n, r) {
  if (r - n <= 20)
    for (let o = n + 1; o <= r; o++) {
      const i = e[o], a = t[i];
      let s = o - 1;
      for (; s >= n && t[e[s]] > a; ) e[s + 1] = e[s--];
      e[s + 1] = i;
    }
  else {
    const o = n + r >> 1;
    let i = n + 1, a = r;
    ea(e, o, i), t[e[n]] > t[e[r]] && ea(e, n, r), t[e[i]] > t[e[r]] && ea(e, i, r), t[e[n]] > t[e[i]] && ea(e, n, i);
    const s = e[i], l = t[s];
    for (; ; ) {
      do
        i++;
      while (t[e[i]] < l);
      do
        a--;
      while (t[e[a]] > l);
      if (a < i) break;
      ea(e, i, a);
    }
    e[n + 1] = e[a], e[a] = s, r - i + 1 >= a - n ? (Zo(e, t, i, r), Zo(e, t, n, a - 1)) : (Zo(e, t, n, a - 1), Zo(e, t, i, r));
  }
}
function ea(e, t, n) {
  const r = e[t];
  e[t] = e[n], e[n] = r;
}
function iG(e) {
  return e[0];
}
function aG(e) {
  return e[1];
}
const Ip = 1e-6;
class ao {
  constructor() {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "";
  }
  moveTo(t, n) {
    this._ += `M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
  }
  lineTo(t, n) {
    this._ += `L${this._x1 = +t},${this._y1 = +n}`;
  }
  arc(t, n, r) {
    t = +t, n = +n, r = +r;
    const o = t + r, i = n;
    if (r < 0) throw new Error("negative radius");
    this._x1 === null ? this._ += `M${o},${i}` : (Math.abs(this._x1 - o) > Ip || Math.abs(this._y1 - i) > Ip) && (this._ += "L" + o + "," + i), r && (this._ += `A${r},${r},0,1,1,${t - r},${n}A${r},${r},0,1,1,${this._x1 = o},${this._y1 = i}`);
  }
  rect(t, n, r, o) {
    this._ += `M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}h${+r}v${+o}h${-r}Z`;
  }
  value() {
    return this._ || null;
  }
}
class _9 {
  constructor() {
    this._ = [];
  }
  moveTo(t, n) {
    this._.push([t, n]);
  }
  closePath() {
    this._.push(this._[0].slice());
  }
  lineTo(t, n) {
    this._.push([t, n]);
  }
  value() {
    return this._.length ? this._ : null;
  }
}
class sG {
  constructor(t, [n, r, o, i] = [0, 0, 960, 500]) {
    if (!((o = +o) >= (n = +n)) || !((i = +i) >= (r = +r))) throw new Error("invalid bounds");
    this.delaunay = t, this._circumcenters = new Float64Array(t.points.length * 2), this.vectors = new Float64Array(t.points.length * 2), this.xmax = o, this.xmin = n, this.ymax = i, this.ymin = r, this._init();
  }
  update() {
    return this.delaunay.update(), this._init(), this;
  }
  _init() {
    const { delaunay: { points: t, hull: n, triangles: r }, vectors: o } = this;
    let i, a;
    const s = this.circumcenters = this._circumcenters.subarray(0, r.length / 3 * 2);
    for (let p = 0, v = 0, y = r.length, C, w; p < y; p += 3, v += 2) {
      const _ = r[p] * 2, x = r[p + 1] * 2, k = r[p + 2] * 2, S = t[_], T = t[_ + 1], L = t[x], R = t[x + 1], M = t[k], A = t[k + 1], O = L - S, I = R - T, W = M - S, N = A - T, H = (O * N - I * W) * 2;
      if (Math.abs(H) < 1e-9) {
        if (i === void 0) {
          i = a = 0;
          for (const D of n) i += t[D * 2], a += t[D * 2 + 1];
          i /= n.length, a /= n.length;
        }
        const q = 1e9 * Math.sign((i - S) * N - (a - T) * W);
        C = (S + M) / 2 - q * N, w = (T + A) / 2 + q * W;
      } else {
        const q = 1 / H, D = O * O + I * I, $ = W * W + N * N;
        C = S + (N * D - I * $) * q, w = T + (O * $ - W * D) * q;
      }
      s[v] = C, s[v + 1] = w;
    }
    let l = n[n.length - 1], c, f = l * 4, u, h = t[2 * l], m, g = t[2 * l + 1];
    o.fill(0);
    for (let p = 0; p < n.length; ++p)
      l = n[p], c = f, u = h, m = g, f = l * 4, h = t[2 * l], g = t[2 * l + 1], o[c + 2] = o[f] = m - g, o[c + 3] = o[f + 1] = h - u;
  }
  render(t) {
    const n = t == null ? t = new ao() : void 0, { delaunay: { halfedges: r, inedges: o, hull: i }, circumcenters: a, vectors: s } = this;
    if (i.length <= 1) return null;
    for (let f = 0, u = r.length; f < u; ++f) {
      const h = r[f];
      if (h < f) continue;
      const m = Math.floor(f / 3) * 2, g = Math.floor(h / 3) * 2, p = a[m], v = a[m + 1], y = a[g], C = a[g + 1];
      this._renderSegment(p, v, y, C, t);
    }
    let l, c = i[i.length - 1];
    for (let f = 0; f < i.length; ++f) {
      l = c, c = i[f];
      const u = Math.floor(o[c] / 3) * 2, h = a[u], m = a[u + 1], g = l * 4, p = this._project(h, m, s[g + 2], s[g + 3]);
      p && this._renderSegment(h, m, p[0], p[1], t);
    }
    return n && n.value();
  }
  renderBounds(t) {
    const n = t == null ? t = new ao() : void 0;
    return t.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin), n && n.value();
  }
  renderCell(t, n) {
    const r = n == null ? n = new ao() : void 0, o = this._clip(t);
    if (o === null || !o.length) return;
    n.moveTo(o[0], o[1]);
    let i = o.length;
    for (; o[0] === o[i - 2] && o[1] === o[i - 1] && i > 1; ) i -= 2;
    for (let a = 2; a < i; a += 2)
      (o[a] !== o[a - 2] || o[a + 1] !== o[a - 1]) && n.lineTo(o[a], o[a + 1]);
    return n.closePath(), r && r.value();
  }
  *cellPolygons() {
    const { delaunay: { points: t } } = this;
    for (let n = 0, r = t.length / 2; n < r; ++n) {
      const o = this.cellPolygon(n);
      o && (o.index = n, yield o);
    }
  }
  cellPolygon(t) {
    const n = new _9();
    return this.renderCell(t, n), n.value();
  }
  _renderSegment(t, n, r, o, i) {
    let a;
    const s = this._regioncode(t, n), l = this._regioncode(r, o);
    s === 0 && l === 0 ? (i.moveTo(t, n), i.lineTo(r, o)) : (a = this._clipSegment(t, n, r, o, s, l)) && (i.moveTo(a[0], a[1]), i.lineTo(a[2], a[3]));
  }
  contains(t, n, r) {
    return n = +n, n !== n || (r = +r, r !== r) ? !1 : this.delaunay._step(t, n, r) === t;
  }
  *neighbors(t) {
    const n = this._clip(t);
    if (n) for (const r of this.delaunay.neighbors(t)) {
      const o = this._clip(r);
      if (o) {
        e: for (let i = 0, a = n.length; i < a; i += 2)
          for (let s = 0, l = o.length; s < l; s += 2)
            if (n[i] === o[s] && n[i + 1] === o[s + 1] && n[(i + 2) % a] === o[(s + l - 2) % l] && n[(i + 3) % a] === o[(s + l - 1) % l]) {
              yield r;
              break e;
            }
      }
    }
  }
  _cell(t) {
    const { circumcenters: n, delaunay: { inedges: r, halfedges: o, triangles: i } } = this, a = r[t];
    if (a === -1) return null;
    const s = [];
    let l = a;
    do {
      const c = Math.floor(l / 3);
      if (s.push(n[c * 2], n[c * 2 + 1]), l = l % 3 === 2 ? l - 2 : l + 1, i[l] !== t) break;
      l = o[l];
    } while (l !== a && l !== -1);
    return s;
  }
  _clip(t) {
    if (t === 0 && this.delaunay.hull.length === 1)
      return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
    const n = this._cell(t);
    if (n === null) return null;
    const { vectors: r } = this, o = t * 4;
    return this._simplify(r[o] || r[o + 1] ? this._clipInfinite(t, n, r[o], r[o + 1], r[o + 2], r[o + 3]) : this._clipFinite(t, n));
  }
  _clipFinite(t, n) {
    const r = n.length;
    let o = null, i, a, s = n[r - 2], l = n[r - 1], c, f = this._regioncode(s, l), u, h = 0;
    for (let m = 0; m < r; m += 2)
      if (i = s, a = l, s = n[m], l = n[m + 1], c = f, f = this._regioncode(s, l), c === 0 && f === 0)
        u = h, h = 0, o ? o.push(s, l) : o = [s, l];
      else {
        let g, p, v, y, C;
        if (c === 0) {
          if ((g = this._clipSegment(i, a, s, l, c, f)) === null) continue;
          [p, v, y, C] = g;
        } else {
          if ((g = this._clipSegment(s, l, i, a, f, c)) === null) continue;
          [y, C, p, v] = g, u = h, h = this._edgecode(p, v), u && h && this._edge(t, u, h, o, o.length), o ? o.push(p, v) : o = [p, v];
        }
        u = h, h = this._edgecode(y, C), u && h && this._edge(t, u, h, o, o.length), o ? o.push(y, C) : o = [y, C];
      }
    if (o)
      u = h, h = this._edgecode(o[0], o[1]), u && h && this._edge(t, u, h, o, o.length);
    else if (this.contains(t, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2))
      return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
    return o;
  }
  _clipSegment(t, n, r, o, i, a) {
    const s = i < a;
    for (s && ([t, n, r, o, i, a] = [r, o, t, n, a, i]); ; ) {
      if (i === 0 && a === 0) return s ? [r, o, t, n] : [t, n, r, o];
      if (i & a) return null;
      let l, c, f = i || a;
      f & 8 ? (l = t + (r - t) * (this.ymax - n) / (o - n), c = this.ymax) : f & 4 ? (l = t + (r - t) * (this.ymin - n) / (o - n), c = this.ymin) : f & 2 ? (c = n + (o - n) * (this.xmax - t) / (r - t), l = this.xmax) : (c = n + (o - n) * (this.xmin - t) / (r - t), l = this.xmin), i ? (t = l, n = c, i = this._regioncode(t, n)) : (r = l, o = c, a = this._regioncode(r, o));
    }
  }
  _clipInfinite(t, n, r, o, i, a) {
    let s = Array.from(n), l;
    if ((l = this._project(s[0], s[1], r, o)) && s.unshift(l[0], l[1]), (l = this._project(s[s.length - 2], s[s.length - 1], i, a)) && s.push(l[0], l[1]), s = this._clipFinite(t, s))
      for (let c = 0, f = s.length, u, h = this._edgecode(s[f - 2], s[f - 1]); c < f; c += 2)
        u = h, h = this._edgecode(s[c], s[c + 1]), u && h && (c = this._edge(t, u, h, s, c), f = s.length);
    else this.contains(t, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2) && (s = [this.xmin, this.ymin, this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax]);
    return s;
  }
  _edge(t, n, r, o, i) {
    for (; n !== r; ) {
      let a, s;
      switch (n) {
        case 5:
          n = 4;
          continue;
        // top-left
        case 4:
          n = 6, a = this.xmax, s = this.ymin;
          break;
        // top
        case 6:
          n = 2;
          continue;
        // top-right
        case 2:
          n = 10, a = this.xmax, s = this.ymax;
          break;
        // right
        case 10:
          n = 8;
          continue;
        // bottom-right
        case 8:
          n = 9, a = this.xmin, s = this.ymax;
          break;
        // bottom
        case 9:
          n = 1;
          continue;
        // bottom-left
        case 1:
          n = 5, a = this.xmin, s = this.ymin;
          break;
      }
      (o[i] !== a || o[i + 1] !== s) && this.contains(t, a, s) && (o.splice(i, 0, a, s), i += 2);
    }
    return i;
  }
  _project(t, n, r, o) {
    let i = 1 / 0, a, s, l;
    if (o < 0) {
      if (n <= this.ymin) return null;
      (a = (this.ymin - n) / o) < i && (l = this.ymin, s = t + (i = a) * r);
    } else if (o > 0) {
      if (n >= this.ymax) return null;
      (a = (this.ymax - n) / o) < i && (l = this.ymax, s = t + (i = a) * r);
    }
    if (r > 0) {
      if (t >= this.xmax) return null;
      (a = (this.xmax - t) / r) < i && (s = this.xmax, l = n + (i = a) * o);
    } else if (r < 0) {
      if (t <= this.xmin) return null;
      (a = (this.xmin - t) / r) < i && (s = this.xmin, l = n + (i = a) * o);
    }
    return [s, l];
  }
  _edgecode(t, n) {
    return (t === this.xmin ? 1 : t === this.xmax ? 2 : 0) | (n === this.ymin ? 4 : n === this.ymax ? 8 : 0);
  }
  _regioncode(t, n) {
    return (t < this.xmin ? 1 : t > this.xmax ? 2 : 0) | (n < this.ymin ? 4 : n > this.ymax ? 8 : 0);
  }
  _simplify(t) {
    if (t && t.length > 4) {
      for (let n = 0; n < t.length; n += 2) {
        const r = (n + 2) % t.length, o = (n + 4) % t.length;
        (t[n] === t[r] && t[r] === t[o] || t[n + 1] === t[r + 1] && t[r + 1] === t[o + 1]) && (t.splice(r, 2), n -= 2);
      }
      t.length || (t = null);
    }
    return t;
  }
}
const lG = 2 * Math.PI, Uo = Math.pow;
function cG(e) {
  return e[0];
}
function uG(e) {
  return e[1];
}
function dG(e) {
  const { triangles: t, coords: n } = e;
  for (let r = 0; r < t.length; r += 3) {
    const o = 2 * t[r], i = 2 * t[r + 1], a = 2 * t[r + 2];
    if ((n[a] - n[o]) * (n[i + 1] - n[o + 1]) - (n[i] - n[o]) * (n[a + 1] - n[o + 1]) > 1e-10) return !1;
  }
  return !0;
}
function fG(e, t, n) {
  return [e + Math.sin(e + t) * n, t + Math.cos(e - t) * n];
}
class U4 {
  static from(t, n = cG, r = uG, o) {
    return new U4("length" in t ? hG(t, n, r, o) : Float64Array.from(mG(t, n, r, o)));
  }
  constructor(t) {
    this._delaunator = new E0(t), this.inedges = new Int32Array(t.length / 2), this._hullIndex = new Int32Array(t.length / 2), this.points = this._delaunator.coords, this._init();
  }
  update() {
    return this._delaunator.update(), this._init(), this;
  }
  _init() {
    const t = this._delaunator, n = this.points;
    if (t.hull && t.hull.length > 2 && dG(t)) {
      this.collinear = Int32Array.from({ length: n.length / 2 }, (h, m) => m).sort((h, m) => n[2 * h] - n[2 * m] || n[2 * h + 1] - n[2 * m + 1]);
      const l = this.collinear[0], c = this.collinear[this.collinear.length - 1], f = [n[2 * l], n[2 * l + 1], n[2 * c], n[2 * c + 1]], u = 1e-8 * Math.hypot(f[3] - f[1], f[2] - f[0]);
      for (let h = 0, m = n.length / 2; h < m; ++h) {
        const g = fG(n[2 * h], n[2 * h + 1], u);
        n[2 * h] = g[0], n[2 * h + 1] = g[1];
      }
      this._delaunator = new E0(n);
    } else
      delete this.collinear;
    const r = this.halfedges = this._delaunator.halfedges, o = this.hull = this._delaunator.hull, i = this.triangles = this._delaunator.triangles, a = this.inedges.fill(-1), s = this._hullIndex.fill(-1);
    for (let l = 0, c = r.length; l < c; ++l) {
      const f = i[l % 3 === 2 ? l - 2 : l + 1];
      (r[l] === -1 || a[f] === -1) && (a[f] = l);
    }
    for (let l = 0, c = o.length; l < c; ++l)
      s[o[l]] = l;
    o.length <= 2 && o.length > 0 && (this.triangles = new Int32Array(3).fill(-1), this.halfedges = new Int32Array(3).fill(-1), this.triangles[0] = o[0], a[o[0]] = 1, o.length === 2 && (a[o[1]] = 0, this.triangles[1] = o[1], this.triangles[2] = o[1]));
  }
  voronoi(t) {
    return new sG(this, t);
  }
  *neighbors(t) {
    const { inedges: n, hull: r, _hullIndex: o, halfedges: i, triangles: a, collinear: s } = this;
    if (s) {
      const u = s.indexOf(t);
      u > 0 && (yield s[u - 1]), u < s.length - 1 && (yield s[u + 1]);
      return;
    }
    const l = n[t];
    if (l === -1) return;
    let c = l, f = -1;
    do {
      if (yield f = a[c], c = c % 3 === 2 ? c - 2 : c + 1, a[c] !== t) return;
      if (c = i[c], c === -1) {
        const u = r[(o[t] + 1) % r.length];
        u !== f && (yield u);
        return;
      }
    } while (c !== l);
  }
  find(t, n, r = 0) {
    if (t = +t, t !== t || (n = +n, n !== n)) return -1;
    const o = r;
    let i;
    for (; (i = this._step(r, t, n)) >= 0 && i !== r && i !== o; ) r = i;
    return i;
  }
  _step(t, n, r) {
    const { inedges: o, hull: i, _hullIndex: a, halfedges: s, triangles: l, points: c } = this;
    if (o[t] === -1 || !c.length) return (t + 1) % (c.length >> 1);
    let f = t, u = Uo(n - c[t * 2], 2) + Uo(r - c[t * 2 + 1], 2);
    const h = o[t];
    let m = h;
    do {
      let g = l[m];
      const p = Uo(n - c[g * 2], 2) + Uo(r - c[g * 2 + 1], 2);
      if (p < u && (u = p, f = g), m = m % 3 === 2 ? m - 2 : m + 1, l[m] !== t) break;
      if (m = s[m], m === -1) {
        if (m = i[(a[t] + 1) % i.length], m !== g && Uo(n - c[m * 2], 2) + Uo(r - c[m * 2 + 1], 2) < u)
          return m;
        break;
      }
    } while (m !== h);
    return f;
  }
  render(t) {
    const n = t == null ? t = new ao() : void 0, { points: r, halfedges: o, triangles: i } = this;
    for (let a = 0, s = o.length; a < s; ++a) {
      const l = o[a];
      if (l < a) continue;
      const c = i[a] * 2, f = i[l] * 2;
      t.moveTo(r[c], r[c + 1]), t.lineTo(r[f], r[f + 1]);
    }
    return this.renderHull(t), n && n.value();
  }
  renderPoints(t, n) {
    n === void 0 && (!t || typeof t.moveTo != "function") && (n = t, t = null), n = n == null ? 2 : +n;
    const r = t == null ? t = new ao() : void 0, { points: o } = this;
    for (let i = 0, a = o.length; i < a; i += 2) {
      const s = o[i], l = o[i + 1];
      t.moveTo(s + n, l), t.arc(s, l, n, 0, lG);
    }
    return r && r.value();
  }
  renderHull(t) {
    const n = t == null ? t = new ao() : void 0, { hull: r, points: o } = this, i = r[0] * 2, a = r.length;
    t.moveTo(o[i], o[i + 1]);
    for (let s = 1; s < a; ++s) {
      const l = 2 * r[s];
      t.lineTo(o[l], o[l + 1]);
    }
    return t.closePath(), n && n.value();
  }
  hullPolygon() {
    const t = new _9();
    return this.renderHull(t), t.value();
  }
  renderTriangle(t, n) {
    const r = n == null ? n = new ao() : void 0, { points: o, triangles: i } = this, a = i[t *= 3] * 2, s = i[t + 1] * 2, l = i[t + 2] * 2;
    return n.moveTo(o[a], o[a + 1]), n.lineTo(o[s], o[s + 1]), n.lineTo(o[l], o[l + 1]), n.closePath(), r && r.value();
  }
  *trianglePolygons() {
    const { triangles: t } = this;
    for (let n = 0, r = t.length / 3; n < r; ++n)
      yield this.trianglePolygon(n);
  }
  trianglePolygon(t) {
    const n = new _9();
    return this.renderTriangle(t, n), n.value();
  }
}
function hG(e, t, n, r) {
  const o = e.length, i = new Float64Array(o * 2);
  for (let a = 0; a < o; ++a) {
    const s = e[a];
    i[a * 2] = t.call(r, s, a, e), i[a * 2 + 1] = n.call(r, s, a, e);
  }
  return i;
}
function* mG(e, t, n, r) {
  let o = 0;
  for (const i of e)
    yield t.call(r, i, o, e), yield n.call(r, i, o, e), ++o;
}
var z4 = function(e) {
  return [e.x, e.y];
}, bs = R_, Rk = "cursor", Ak = "top", pG = function(e) {
  var t = e.points, n = e.getNodePosition, r = n === void 0 ? z4 : n, o = e.margin, i = o === void 0 ? bs : o;
  return t.map(function(a) {
    var s = r(a), l = s[0], c = s[1];
    return [l + i.left, c + i.top];
  });
}, gG = function(e) {
  var t = e.points, n = e.width, r = e.height, o = e.margin, i = o === void 0 ? bs : o, a = e.debug, s = U4.from(t), l = a ? s.voronoi([0, 0, i.left + n + i.right, i.top + r + i.bottom]) : void 0;
  return { points: t, delaunay: s, voronoi: l };
}, Ok = function(e) {
  var t = e.points, n = e.getNodePosition, r = n === void 0 ? z4 : n, o = e.width, i = e.height, a = e.margin, s = a === void 0 ? bs : a, l = e.debug;
  return Te(function() {
    return gG({ points: pG({ points: t, margin: s, getNodePosition: r }), width: o, height: i, margin: s, debug: l });
  }, [t, o, i, s, l]);
}, vG = function(e) {
  var t = e.elementRef, n = e.nodes, r = e.getNodePosition, o = r === void 0 ? z4 : r, i = e.delaunay, a = e.setCurrent, s = e.margin, l = s === void 0 ? bs : s, c = e.detectionRadius, f = c === void 0 ? 1 / 0 : c, u = e.isInteractive, h = u === void 0 || u, m = e.onMouseEnter, g = e.onMouseMove, p = e.onMouseLeave, v = e.onClick, y = e.onTouchStart, C = e.onTouchMove, w = e.onTouchEnd, _ = e.enableTouchCrosshair, x = _ !== void 0 && _, k = e.tooltip, S = e.tooltipPosition, T = S === void 0 ? Rk : S, L = e.tooltipAnchor, R = L === void 0 ? Ak : L, M = Yt(null), A = M[0], O = M[1], I = Lt(null);
  dn(function() {
    I.current = A;
  }, [I, A]);
  var W = be(function(Y) {
    if (!t.current) return null;
    var P = pa(t.current, Y), F = P[0], z = P[1], E = i.find(F, z), re = E !== void 0 ? n[E] : null;
    if (re && f !== 1 / 0) {
      var ee = o(re), oe = ee[0], ue = ee[1];
      sU(F, z, oe + l.left, ue + l.top) > f && (E = null, re = null);
    }
    return E === null || re === null ? null : [E, re];
  }, [t, i, n, o, l, f]), N = Li(), H = N.showTooltipAt, q = N.showTooltipFromEvent, D = N.hideTooltip, $ = Te(function() {
    if (k) return T === "cursor" ? function(Y, P) {
      q(k(Y), P, R);
    } : function(Y) {
      var P = o(Y), F = P[0], z = P[1];
      H(k(Y), [F + l.left, z + l.top], R);
    };
  }, [H, q, k, T, R, o, l]), U = be(function(Y) {
    var P = W(Y);
    if (O(P), a == null || a(P ? P[1] : null), P) {
      var F = P[1];
      $ == null || $(F, Y), m == null || m(P[1], Y);
    }
  }, [W, O, a, $, m]), B = be(function(Y) {
    var P = W(Y);
    if (O(P), P) {
      var F = P[0], z = P[1];
      if (a == null || a(z), $ == null || $(z, Y), I.current) {
        var E = I.current, re = E[0], ee = E[1];
        F !== re ? p == null || p(ee, Y) : g == null || g(z, Y);
      } else m == null || m(z, Y);
    } else a == null || a(null), D == null || D(), I.current && (p == null || p(I.current[1], Y));
  }, [W, O, I, m, g, p, $, D]), K = be(function(Y) {
    O(null), a == null || a(null), D(), p && I.current && p(I.current[1], Y);
  }, [O, a, I, D, p]), X = be(function(Y) {
    var P = W(Y);
    O(P), P && (v == null || v(P[1], Y));
  }, [W, O, v]), Z = be(function(Y) {
    var P = W(Y);
    x && (O(P), a == null || a(P ? P[1] : null)), P && (y == null || y(P[1], Y));
  }, [W, O, a, x, y]), G = be(function(Y) {
    var P = W(Y);
    x && (O(P), a == null || a(P ? P[1] : null)), P && (C == null || C(P[1], Y));
  }, [W, O, a, x, C]), V = be(function(Y) {
    x && (O(null), a == null || a(null)), w && I.current && w(I.current[1], Y);
  }, [x, O, a, w, I]);
  return { current: A, handleMouseEnter: h ? U : void 0, handleMouseMove: h ? B : void 0, handleMouseLeave: h ? K : void 0, handleClick: h ? X : void 0, handleTouchStart: h ? Z : void 0, handleTouchMove: h ? G : void 0, handleTouchEnd: h ? V : void 0 };
}, bG = function(e) {
  var t = e.nodes, n = e.width, r = e.height, o = e.margin, i = o === void 0 ? bs : o, a = e.getNodePosition, s = e.setCurrent, l = e.onMouseEnter, c = e.onMouseMove, f = e.onMouseLeave, u = e.onClick, h = e.onTouchStart, m = e.onTouchMove, g = e.onTouchEnd, p = e.enableTouchCrosshair, v = p !== void 0 && p, y = e.detectionRadius, C = y === void 0 ? 1 / 0 : y, w = e.tooltip, _ = e.tooltipPosition, x = _ === void 0 ? Rk : _, k = e.tooltipAnchor, S = k === void 0 ? Ak : k, T = e.debug, L = Lt(null), R = Ok({ points: t, getNodePosition: a, width: n, height: r, margin: i, debug: T }), M = R.delaunay, A = R.voronoi, O = vG({ elementRef: L, nodes: t, delaunay: M, margin: i, detectionRadius: C, setCurrent: s, onMouseEnter: l, onMouseMove: c, onMouseLeave: f, onClick: u, onTouchStart: h, onTouchMove: m, onTouchEnd: g, enableTouchCrosshair: v, tooltip: w, tooltipPosition: x, tooltipAnchor: S }), I = O.current, W = O.handleMouseEnter, N = O.handleMouseMove, H = O.handleMouseLeave, q = O.handleClick, D = O.handleTouchStart, $ = O.handleTouchMove, U = O.handleTouchEnd, B = Te(function() {
    if (T && A) return A.render();
  }, [T, A]);
  return ie("g", { ref: L, transform: "translate(" + -i.left + "," + -i.top + ")", children: [T && A && ie(St, { children: [b("path", { d: B, stroke: "red", strokeWidth: 1, opacity: 0.75 }), C < 1 / 0 && b("path", { stroke: "red", strokeWidth: 0.35, fill: "none", d: M.renderPoints(void 0, C) }), I && b("path", { fill: "pink", opacity: 0.35, d: A.renderCell(I[0]) })] }), b("rect", { "data-ref": "mesh-interceptor", width: i.left + n + i.right, height: i.top + r + i.bottom, fill: "red", opacity: 0, style: { cursor: "auto" }, onMouseEnter: W, onMouseMove: N, onMouseLeave: H, onTouchStart: D, onTouchMove: $, onTouchEnd: U, onClick: q })] });
}, yG = function(e, t) {
  e.save(), e.globalAlpha = 0.75, e.beginPath(), t.render(e), e.strokeStyle = "red", e.lineWidth = 1, e.stroke(), e.restore();
}, CG = function(e, t, n) {
  e.save(), e.globalAlpha = 0.35, e.beginPath(), t.renderCell(n, e), e.fillStyle = "pink", e.fill(), e.restore();
};
function rn() {
  return rn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, rn.apply(this, arguments);
}
var Y4 = lt(function(e) {
  var t = e.point;
  return b(Iw, { id: ie("span", { children: ["x: ", b("strong", { children: t.data.xFormatted }), ", y:", " ", b("strong", { children: t.data.yFormatted })] }), enableChip: !0, color: t.serieColor });
}), Nk = lt(function(e) {
  var t = e.slice, n = e.axis, r = xt(), o = n === "x" ? "y" : "x";
  return b(Bw, { rows: t.points.map(function(i) {
    return [b(Dw, { color: i.serieColor, style: r.tooltip.chip }, "chip"), i.serieId, b("span", { style: r.tooltip.tableCellValue, children: i.data[o + "Formatted"] }, "value")];
  }) });
}), Dk = { curve: "linear", xScale: { type: "point" }, yScale: { type: "linear", min: 0, max: "auto" }, layers: ["grid", "markers", "axes", "areas", "crosshair", "lines", "points", "slices", "mesh", "legends"], axisBottom: {}, axisLeft: {}, enableGridX: !0, enableGridY: !0, enablePoints: !0, pointSize: 6, pointColor: { from: "color" }, pointBorderWidth: 0, pointBorderColor: { theme: "background" }, enablePointLabel: !1, pointLabel: "yFormatted", colors: { scheme: "nivo" }, enableArea: !1, areaBaselineValue: 0, areaOpacity: 0.2, areaBlendMode: "normal", lineWidth: 2, legends: [], isInteractive: !0, tooltip: Y4, enableSlices: !1, debugSlices: !1, sliceTooltip: Nk, debugMesh: !1, enableCrosshair: !0, crosshairType: "bottom-left" }, ur = rn({}, Dk, { enablePointLabel: !1, useMesh: !1, enableTouchCrosshair: !1, animate: !0, motionConfig: "gentle", defs: [], fill: [], role: "img", initialHiddenIds: [] });
rn({}, Dk, { pixelRatio: typeof window < "u" && window.devicePixelRatio || 1 });
var wG = function(e) {
  var t = e.curve;
  return Te(function() {
    return Fx().defined(function(n) {
      return n.x !== null && n.y !== null;
    }).x(function(n) {
      return n.x;
    }).y(function(n) {
      return n.y;
    }).curve(P_(t));
  }, [t]);
}, xG = function(e) {
  var t = e.curve, n = e.yScale, r = e.areaBaselineValue;
  return Te(function() {
    return Ij().defined(function(o) {
      return o.x !== null && o.y !== null;
    }).x(function(o) {
      return o.x;
    }).y1(function(o) {
      return o.y;
    }).curve(P_(t)).y0(n(r));
  }, [t, n, r]);
}, _G = function(e) {
  var t = e.componentId, n = e.enableSlices, r = e.points, o = e.width, i = e.height;
  return Te(function() {
    if (n === !1) return [];
    if (n === "x") {
      var a = /* @__PURE__ */ new Map();
      return r.forEach(function(l) {
        l.data.x !== null && l.data.y !== null && (a.has(l.x) ? a.get(l.x).push(l) : a.set(l.x, [l]));
      }), Array.from(a.entries()).sort(function(l, c) {
        return l[0] - c[0];
      }).map(function(l, c, f) {
        var u, h, m = l[0], g = l[1], p = f[c - 1], v = f[c + 1];
        return u = p ? m - (m - p[0]) / 2 : m, h = v ? m - u + (v[0] - m) / 2 : o - u, { id: "slice:" + t + ":" + m, x0: u, x: m, y0: 0, y: 0, width: h, height: i, points: g.reverse() };
      });
    }
    if (n === "y") {
      var s = /* @__PURE__ */ new Map();
      return r.forEach(function(l) {
        l.data.x !== null && l.data.y !== null && (s.has(l.y) ? s.get(l.y).push(l) : s.set(l.y, [l]));
      }), Array.from(s.entries()).sort(function(l, c) {
        return l[0] - c[0];
      }).map(function(l, c, f) {
        var u, h, m = l[0], g = l[1], p = f[c - 1], v = f[c + 1];
        return u = p ? m - (m - p[0]) / 2 : m, h = v ? m - u + (v[0] - m) / 2 : i - u, { id: m, x0: 0, x: 0, y0: u, y: m, width: o, height: h, points: g.reverse() };
      });
    }
  }, [t, n, i, r, o]);
}, kG = "line", Ik = function(e) {
  var t = e.data, n = e.xScale, r = n === void 0 ? ur.xScale : n, o = e.xFormat, i = e.yScale, a = i === void 0 ? ur.yScale : i, s = e.yFormat, l = e.width, c = e.height, f = e.colors, u = f === void 0 ? ur.colors : f, h = e.curve, m = h === void 0 ? ur.curve : h, g = e.areaBaselineValue, p = g === void 0 ? ur.areaBaselineValue : g, v = e.pointColor, y = v === void 0 ? ur.pointColor : v, C = e.pointBorderColor, w = C === void 0 ? ur.pointBorderColor : C, _ = e.enableSlices, x = _ === void 0 ? ur.enableSlicesTooltip : _, k = e.initialHiddenIds, S = k === void 0 ? ur.initialHiddenIds : k, T = Yt(GY(kG))[0], L = Fa(o), R = Fa(s), M = bk(u, "id"), A = xt(), O = mi(y, A), I = mi(w, A), W = Yt(S ?? []), N = W[0], H = W[1], q = Te(function() {
    return XU(t.filter(function(Y) {
      return N.indexOf(Y.id) === -1;
    }), r, a, l, c);
  }, [t, N, r, a, l, c]), D = q.xScale, $ = q.yScale, U = q.series, B = Te(function() {
    var Y = t.map(function(F) {
      return { id: F.id, label: F.id, color: M(F) };
    }), P = Y.map(function(F) {
      return rn({}, U.find(function(z) {
        return z.id === F.id;
      }), { color: F.color });
    }).filter(function(F) {
      return !!F.id;
    });
    return { legendData: Y.map(function(F) {
      return rn({}, F, { hidden: !P.find(function(z) {
        return z.id === F.id;
      }) });
    }).reverse(), series: P };
  }, [t, U, M]), K = B.legendData, X = B.series, Z = be(function(Y) {
    H(function(P) {
      return P.indexOf(Y) > -1 ? P.filter(function(F) {
        return F !== Y;
      }) : [].concat(P, [Y]);
    });
  }, []), G = function(Y) {
    var P = Y.series, F = Y.getPointColor, z = Y.getPointBorderColor, E = Y.formatX, re = Y.formatY;
    return Te(function() {
      return P.reduce(function(ee, oe) {
        return [].concat(ee, oe.data.filter(function(ue) {
          return ue.position.x !== null && ue.position.y !== null;
        }).map(function(ue, le) {
          var Ae = { id: oe.id + "." + le, index: ee.length + le, serieId: oe.id, serieColor: oe.color, x: ue.position.x, y: ue.position.y };
          return Ae.color = F(oe), Ae.borderColor = z(Ae), Ae.data = rn({}, ue.data, { xFormatted: E(ue.data.x), yFormatted: re(ue.data.y) }), Ae;
        }));
      }, []);
    }, [P, F, z, E, re]);
  }({ series: X, getPointColor: O, getPointBorderColor: I, formatX: L, formatY: R }), V = _G({ componentId: T, enableSlices: x, points: G, width: l, height: c });
  return { legendData: K, toggleSerie: Z, lineGenerator: wG({ curve: m }), areaGenerator: xG({ curve: m, yScale: $, areaBaselineValue: p }), getColor: M, series: X, xScale: D, yScale: $, slices: V, points: G };
}, SG = function(e) {
  var t = e.areaBlendMode, n = e.areaOpacity, r = e.color, o = e.fill, i = e.path, a = kn(), s = a.animate, l = a.config, c = $4(i), f = tr({ color: r, config: l, immediate: !s });
  return b(_t.path, { d: c, fill: o || f.color, fillOpacity: n, strokeWidth: 0, style: { mixBlendMode: t } });
}, MG = lt(function(e) {
  var t = e.areaGenerator, n = e.areaOpacity, r = e.areaBlendMode, o = e.lines.slice(0).reverse();
  return b("g", { children: o.map(function(i) {
    return b(SG, rn({ path: t(i.data.map(function(a) {
      return a.position;
    })) }, rn({ areaOpacity: n, areaBlendMode: r }, i)), i.id);
  }) });
}), EG = lt(function(e) {
  var t = e.lineGenerator, n = e.points, r = e.color, o = e.thickness, i = Te(function() {
    return t(n);
  }, [t, n]), a = $4(i);
  return b(_t.path, { d: a, fill: "none", strokeWidth: o, stroke: r });
}), LG = lt(function(e) {
  var t = e.lines, n = e.lineGenerator, r = e.lineWidth;
  return t.slice(0).reverse().map(function(o) {
    var i = o.id, a = o.data, s = o.color;
    return b(EG, { id: i, points: a.map(function(l) {
      return l.position;
    }), lineGenerator: n, color: s, thickness: r }, i);
  });
}), TG = lt(function(e) {
  var t = e.slice, n = e.slices, r = e.axis, o = e.debug, i = e.tooltip, a = e.isCurrent, s = e.setCurrent, l = e.onMouseEnter, c = e.onMouseMove, f = e.onMouseLeave, u = e.onClick, h = e.onTouchStart, m = e.onTouchMove, g = e.onTouchEnd, p = Li(), v = p.showTooltipFromEvent, y = p.hideTooltip, C = be(function(L) {
    v($t(i, { slice: t, axis: r }), L, "right"), s(t), l && l(t, L);
  }, [v, i, t, r, s, l]), w = be(function(L) {
    v($t(i, { slice: t, axis: r }), L, "right"), c && c(t, L);
  }, [v, i, t, r, c]), _ = be(function(L) {
    y(), s(null), f && f(t, L);
  }, [y, s, f, t]), x = be(function(L) {
    u && u(t, L);
  }, [t, u]), k = be(function(L) {
    v($t(i, { slice: t, axis: r }), L, "right"), s(t), h && h(t, L);
  }, [r, h, s, v, t, i]), S = be(function(L) {
    var R = L.touches[0], M = document.elementFromPoint(R.clientX, R.clientY), A = M == null ? void 0 : M.getAttribute("data-ref");
    if (A) {
      var O = n.find(function(I) {
        return I.id === A;
      });
      O && (v($t(i, { slice: O, axis: r }), L, "right"), s(O));
    }
    m && m(t, L);
  }, [r, m, s, v, t, n, i]), T = be(function(L) {
    y(), s(null), g && g(t, L);
  }, [y, s, g, t]);
  return b("rect", { x: t.x0, y: t.y0, width: t.width, height: t.height, stroke: "red", strokeWidth: o ? 1 : 0, strokeOpacity: 0.75, fill: "red", fillOpacity: a && o ? 0.35 : 0, onMouseEnter: C, onMouseMove: w, onMouseLeave: _, onClick: x, onTouchStart: k, onTouchMove: S, onTouchEnd: T, "data-ref": t.id });
}), PG = lt(function(e) {
  var t = e.slices, n = e.axis, r = e.debug, o = e.height, i = e.tooltip, a = e.current, s = e.setCurrent, l = e.onMouseEnter, c = e.onMouseMove, f = e.onMouseLeave, u = e.onClick, h = e.onTouchStart, m = e.onTouchMove, g = e.onTouchEnd;
  return t.map(function(p) {
    return b(TG, { slice: p, slices: t, axis: n, debug: r, height: o, tooltip: i, setCurrent: s, isCurrent: a !== null && a.id === p.id, onMouseEnter: l, onMouseMove: c, onMouseLeave: f, onClick: u, onTouchStart: h, onTouchMove: m, onTouchEnd: g }, p.id);
  });
}), RG = lt(function(e) {
  var t = e.points, n = e.symbol, r = e.size, o = e.borderWidth, i = e.enableLabel, a = e.label, s = e.labelYOffset, l = xt(), c = aU(a), f = t.slice(0).reverse().map(function(u) {
    return { id: u.id, x: u.x, y: u.y, datum: u.data, fill: u.color, stroke: u.borderColor, label: i ? c(u) : null };
  });
  return b("g", { children: f.map(function(u) {
    return b(rU, { x: u.x, y: u.y, datum: u.datum, symbol: n, size: r, color: u.fill, borderWidth: o, borderColor: u.stroke, label: u.label, labelYOffset: s, theme: l }, u.id);
  }) });
}), AG = lt(function(e) {
  var t = e.points, n = e.width, r = e.height, o = e.margin, i = e.setCurrent, a = e.onMouseEnter, s = e.onMouseMove, l = e.onMouseLeave, c = e.onClick, f = e.onTouchStart, u = e.onTouchMove, h = e.onTouchEnd, m = e.tooltip, g = e.debug, p = e.enableTouchCrosshair, v = Li(), y = v.showTooltipAt, C = v.hideTooltip, w = be(function(R, M) {
    y($t(m, { point: R }), [R.x + o.left, R.y + o.top], "top"), a && a(R, M);
  }, [y, m, a, o]), _ = be(function(R, M) {
    y($t(m, { point: R }), [R.x + o.left, R.y + o.top], "top"), s && s(R, M);
  }, [y, m, o.left, o.top, s]), x = be(function(R, M) {
    C(), l && l(R, M);
  }, [C, l]), k = be(function(R, M) {
    c && c(R, M);
  }, [c]), S = be(function(R, M) {
    y($t(m, { point: R }), [R.x + o.left, R.y + o.top], "top"), f && f(R, M);
  }, [o.left, o.top, f, y, m]), T = be(function(R, M) {
    y($t(m, { point: R }), [R.x + o.left, R.y + o.top], "top"), u && u(R, M);
  }, [o.left, o.top, u, y, m]), L = be(function(R, M) {
    C(), h && h(R, M);
  }, [h, C]);
  return b(bG, { nodes: t, width: n, height: r, setCurrent: i, onMouseEnter: w, onMouseMove: _, onMouseLeave: x, onClick: k, onTouchStart: S, onTouchMove: T, onTouchEnd: L, enableTouchCrosshair: p, debug: g });
}), OG = U_(function(e) {
  var t = e.data, n = e.xScale, r = n === void 0 ? { type: "point" } : n, o = e.xFormat, i = e.yScale, a = i === void 0 ? { type: "linear", min: 0, max: "auto" } : i, s = e.yFormat, l = e.layers, c = l === void 0 ? ["grid", "markers", "axes", "areas", "crosshair", "lines", "points", "slices", "mesh", "legends"] : l, f = e.curve, u = f === void 0 ? "linear" : f, h = e.areaBaselineValue, m = h === void 0 ? 0 : h, g = e.colors, p = g === void 0 ? { scheme: "nivo" } : g, v = e.margin, y = e.width, C = e.height, w = e.axisTop, _ = e.axisRight, x = e.axisBottom, k = x === void 0 ? {} : x, S = e.axisLeft, T = S === void 0 ? {} : S, L = e.enableGridX, R = L === void 0 || L, M = e.enableGridY, A = M === void 0 || M, O = e.gridXValues, I = e.gridYValues, W = e.lineWidth, N = W === void 0 ? 2 : W, H = e.enableArea, q = H !== void 0 && H, D = e.areaOpacity, $ = D === void 0 ? 0.2 : D, U = e.areaBlendMode, B = U === void 0 ? "normal" : U, K = e.enablePoints, X = K === void 0 || K, Z = e.pointSymbol, G = e.pointSize, V = G === void 0 ? 6 : G, Y = e.pointColor, P = Y === void 0 ? { from: "color" } : Y, F = e.pointBorderWidth, z = F === void 0 ? 0 : F, E = e.pointBorderColor, re = E === void 0 ? { theme: "background" } : E, ee = e.enablePointLabel, oe = ee !== void 0 && ee, ue = e.pointLabel, le = ue === void 0 ? "data.yFormatted" : ue, Ae = e.pointLabelYOffset, Ie = e.defs, bt = Ie === void 0 ? [] : Ie, He = e.fill, Me = He === void 0 ? [] : He, Pe = e.markers, rt = e.legends, ft = rt === void 0 ? [] : rt, Xe = e.isInteractive, ht = Xe === void 0 || Xe, Ge = e.useMesh, Ve = Ge !== void 0 && Ge, Be = e.debugMesh, ct = Be !== void 0 && Be, ot = e.onMouseEnter, it = e.onMouseMove, mt = e.onMouseLeave, Qe = e.onClick, ut = e.onTouchStart, Dt = e.onTouchMove, pe = e.onTouchEnd, ae = e.tooltip, ge = ae === void 0 ? Y4 : ae, we = e.enableSlices, We = we !== void 0 && we, Oe = e.debugSlices, de = Oe !== void 0 && Oe, xe = e.sliceTooltip, Ee = xe === void 0 ? Nk : xe, me = e.enableCrosshair, Pt = me === void 0 || me, qe = e.crosshairType, yt = qe === void 0 ? "bottom-left" : qe, Mt = e.enableTouchCrosshair, se = Mt !== void 0 && Mt, ve = e.role, $e = ve === void 0 ? "img" : ve, Fe = e.initialHiddenIds, je = Fe === void 0 ? [] : Fe, Rt = kc(y, C, v), Ut = Rt.margin, It = Rt.innerWidth, pt = Rt.innerHeight, Mr = Rt.outerWidth, Oo = Rt.outerHeight, zt = Ik({ data: t, xScale: r, xFormat: o, yScale: a, yFormat: s, width: It, height: pt, colors: p, curve: u, areaBaselineValue: m, pointColor: P, pointBorderColor: re, enableSlices: We, initialHiddenIds: je }), ar = zt.legendData, $i = zt.toggleSerie, _e = zt.lineGenerator, Se = zt.areaGenerator, Ue = zt.series, Je = zt.xScale, ze = zt.yScale, Bt = zt.slices, Ct = zt.points, at = xt(), sr = mi(P, at), No = mi(re, at), $n = Yt(null), lr = $n[0], an = $n[1], Do = Yt(null), he = Do[0], Fn = Do[1], fn = { grid: b(lk, { theme: at, width: It, height: pt, xScale: R ? Je : null, yScale: A ? ze : null, xValues: O, yValues: I }, "grid"), markers: b(V_, { markers: Pe, width: It, height: pt, xScale: Je, yScale: ze, theme: at }, "markers"), axes: b(sk, { xScale: Je, yScale: ze, width: It, height: pt, theme: at, top: w, right: _, bottom: k, left: T }, "axes"), areas: null, lines: b(LG, { lines: Ue, lineGenerator: _e, lineWidth: N }, "lines"), slices: null, points: null, crosshair: null, mesh: null, legends: ft.map(function(Xr, Rc) {
    return b(wk, rn({}, Xr, { containerWidth: It, containerHeight: pt, data: Xr.data || ar, theme: at, toggleSerie: Xr.toggleSerie ? $i : void 0 }), "legend." + Rc);
  }) }, Mn = G_(bt, Ue, Me);
  return q && (fn.areas = b(MG, { areaGenerator: Se, areaOpacity: $, areaBlendMode: B, lines: Ue }, "areas")), ht && We !== !1 && (fn.slices = b(PG, { slices: Bt, axis: We, debug: de, height: pt, tooltip: Ee, current: he, setCurrent: Fn, onMouseEnter: ot, onMouseMove: it, onMouseLeave: mt, onClick: Qe, onTouchStart: ut, onTouchMove: Dt, onTouchEnd: pe }, "slices")), X && (fn.points = b(RG, { points: Ct, symbol: Z, size: V, color: sr, borderWidth: z, borderColor: No, enableLabel: oe, label: le, labelYOffset: Ae }, "points")), ht && Pt && (lr !== null && (fn.crosshair = b(n9, { width: It, height: pt, x: lr.x, y: lr.y, type: yt }, "crosshair")), he !== null && (fn.crosshair = b(n9, { width: It, height: pt, x: he.x, y: he.y, type: We }, "crosshair"))), ht && Ve && We === !1 && (fn.mesh = b(AG, { points: Ct, width: It, height: pt, margin: Ut, current: lr, setCurrent: an, onMouseEnter: ot, onMouseMove: it, onMouseLeave: mt, onClick: Qe, onTouchStart: ut, onTouchMove: Dt, onTouchEnd: pe, tooltip: ge, enableTouchCrosshair: se, debug: ct }, "mesh")), b(q4, { defs: Mn, width: Mr, height: Oo, margin: Ut, role: $e, children: c.map(function(Xr, Rc) {
    return typeof Xr == "function" ? b(C2, { children: Xr(rn({}, e, { innerWidth: It, innerHeight: pt, series: Ue, slices: Bt, points: Ct, xScale: Je, yScale: ze, lineGenerator: _e, areaGenerator: Se, currentPoint: lr, setCurrentPoint: an, currentSlice: he, setCurrentSlice: Fn })) }, Rc) : fn[Xr];
  }) });
}), NG = function(e) {
  return b(gs, { children: function(t) {
    var n = t.width, r = t.height;
    return b(OG, rn({ width: n, height: r }, e));
  } });
}, DG = U_(function(e) {
  var t = Lt(null), n = e.width, r = e.height, o = e.margin, i = e.pixelRatio, a = i === void 0 ? typeof window < "u" && window.devicePixelRatio || 1 : i, s = e.data, l = e.xScale, c = l === void 0 ? { type: "point" } : l, f = e.xFormat, u = e.yScale, h = u === void 0 ? { type: "linear", min: 0, max: "auto" } : u, m = e.yFormat, g = e.curve, p = g === void 0 ? "linear" : g, v = e.layers, y = v === void 0 ? ["grid", "markers", "axes", "areas", "crosshair", "lines", "points", "slices", "mesh", "legends"] : v, C = e.colors, w = C === void 0 ? { scheme: "nivo" } : C, _ = e.lineWidth, x = _ === void 0 ? 2 : _, k = e.enableArea, S = k !== void 0 && k, T = e.areaBaselineValue, L = T === void 0 ? 0 : T, R = e.areaOpacity, M = R === void 0 ? 0.2 : R, A = e.enablePoints, O = A === void 0 || A, I = e.pointSize, W = I === void 0 ? 6 : I, N = e.pointColor, H = N === void 0 ? { from: "color" } : N, q = e.pointBorderWidth, D = q === void 0 ? 0 : q, $ = e.pointBorderColor, U = $ === void 0 ? { theme: "background" } : $, B = e.enableGridX, K = B === void 0 || B, X = e.gridXValues, Z = e.enableGridY, G = Z === void 0 || Z, V = e.gridYValues, Y = e.axisTop, P = e.axisRight, F = e.axisBottom, z = F === void 0 ? {} : F, E = e.axisLeft, re = E === void 0 ? {} : E, ee = e.legends, oe = ee === void 0 ? [] : ee, ue = e.isInteractive, le = ue === void 0 || ue, Ae = e.debugMesh, Ie = Ae !== void 0 && Ae, bt = e.onMouseLeave, He = e.onClick, Me = e.tooltip, Pe = Me === void 0 ? Y4 : Me, rt = e.canvasRef, ft = kc(n, r, o), Xe = ft.margin, ht = ft.innerWidth, Ge = ft.innerHeight, Ve = ft.outerWidth, Be = ft.outerHeight, ct = xt(), ot = Yt(null), it = ot[0], mt = ot[1], Qe = Ik({ data: s, xScale: c, xFormat: f, yScale: h, yFormat: m, width: ht, height: Ge, colors: w, curve: p, areaBaselineValue: L, pointColor: H, pointBorderColor: U }), ut = Qe.lineGenerator, Dt = Qe.areaGenerator, pe = Qe.series, ae = Qe.xScale, ge = Qe.yScale, we = Qe.points, We = Ok({ points: we, width: ht, height: Ge, debug: Ie }), Oe = We.delaunay, de = We.voronoi;
  dn(function() {
    rt && (rt.current = t.current), t.current.width = Ve * a, t.current.height = Be * a;
    var se = t.current.getContext("2d");
    se.scale(a, a), se.fillStyle = ct.background, se.fillRect(0, 0, Ve, Be), se.translate(Xe.left, Xe.top), y.forEach(function(ve) {
      if (typeof ve == "function" && ve({ ctx: se, innerWidth: ht, innerHeight: Ge, series: pe, points: we, xScale: ae, yScale: ge, lineWidth: x, lineGenerator: ut, areaGenerator: Dt, currentPoint: it, setCurrentPoint: mt }), ve === "grid" && ct.grid.line.strokeWidth > 0 && (se.lineWidth = ct.grid.line.strokeWidth, se.strokeStyle = ct.grid.line.stroke, K && S0(se, { width: ht, height: Ge, scale: ae, axis: "x", values: X }), G && S0(se, { width: ht, height: Ge, scale: ge, axis: "y", values: V })), ve === "axes" && ck(se, { xScale: ae, yScale: ge, width: ht, height: Ge, top: Y, right: P, bottom: z, left: re, theme: ct }), ve === "areas" && S === !0) {
        se.save(), se.globalAlpha = M, Dt.context(se);
        for (var $e = pe.length - 1; $e >= 0; $e--) se.fillStyle = pe[$e].color, se.beginPath(), Dt(pe[$e].data.map(function(je) {
          return je.position;
        })), se.fill();
        se.restore();
      }
      if (ve === "lines" && (ut.context(se), pe.forEach(function(je) {
        se.strokeStyle = je.color, se.lineWidth = x, se.beginPath(), ut(je.data.map(function(Rt) {
          return Rt.position;
        })), se.stroke();
      })), ve === "points" && O === !0 && W > 0 && we.forEach(function(je) {
        se.fillStyle = je.color, se.beginPath(), se.arc(je.x, je.y, W / 2, 0, 2 * Math.PI), se.fill(), D > 0 && (se.strokeStyle = je.borderColor, se.lineWidth = D, se.stroke());
      }), ve === "mesh" && Ie === !0 && (yG(se, de), it && CG(se, de, it.index)), ve === "legends") {
        var Fe = pe.map(function(je) {
          return { id: je.id, label: je.id, color: je.color };
        }).reverse();
        oe.forEach(function(je) {
          xk(se, rn({}, je, { data: je.data || Fe, containerWidth: ht, containerHeight: Ge, theme: ct }));
        });
      }
    });
  }, [t, Ve, Be, y, ct, ut, pe, ae, ge, K, X, G, V, Y, P, z, re, oe, we, O, W, it]);
  var xe = be(function(se) {
    var ve = pa(t.current, se), $e = ve[0], Fe = ve[1];
    if (!Y_(Xe.left, Xe.top, ht, Ge, $e, Fe)) return null;
    var je = Oe.find($e - Xe.left, Fe - Xe.top);
    return we[je];
  }, [t, Xe, ht, Ge, Oe]), Ee = Li(), me = Ee.showTooltipFromEvent, Pt = Ee.hideTooltip, qe = be(function(se) {
    var ve = xe(se);
    mt(ve), ve ? me($t(Pe, { point: ve }), se) : Pt();
  }, [xe, mt, me, Pt, Pe]), yt = be(function(se) {
    Pt(), mt(null), it && bt && bt(it, se);
  }, [Pt, mt, bt]), Mt = be(function(se) {
    if (He) {
      var ve = xe(se);
      ve && He(ve, se);
    }
  }, [xe, He]);
  return b("canvas", { ref: t, width: Ve * a, height: Be * a, style: { width: Ve, height: Be, cursor: le ? "auto" : "normal" }, onMouseEnter: le ? qe : void 0, onMouseMove: le ? qe : void 0, onMouseLeave: le ? yt : void 0, onClick: le ? Mt : void 0 });
}), IG = fe(function(e, t) {
  return b(DG, rn({}, e, { canvasRef: t }));
});
fe(function(e, t) {
  return b(gs, { children: function(n) {
    var r = n.width, o = n.height;
    return b(IG, rn({ width: r, height: o }, e, { ref: t }));
  } });
});
function BG({ className: e, ...t }) {
  const { theme: n, grid: r, axes: o, lineConfig: i, pointDefinition: a, gradientConfig: s } = Tk({
    axisBottom: t.axisBottom,
    axisLeft: t.axisLeft,
    areaOpacity: t == null ? void 0 : t.areaOpacity,
    gradientFillColor: t == null ? void 0 : t.gradientFillColor
  });
  return /* @__PURE__ */ b("div", { className: e, children: /* @__PURE__ */ b(
    NG,
    {
      ...t,
      theme: n,
      ...r,
      ...o,
      ...i,
      ...a,
      ...s
    }
  ) });
}
BG.displayName = "LBLineChart";
const $G = fe(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  "div",
  {
    className: Q(
      co({ variant: "outline", size: "default" }),
      "flex-wrap h-fit justify-start",
      e
    ),
    ref: n,
    ...t,
    role: "toolbar",
    "aria-label": "Filter Chip Bar"
  }
));
$G.displayName = "LBFilterChipBar";
const FG = fe(
  ({ className: e, onClick: t, children: n, disabled: r, ...o }, i) => /* @__PURE__ */ ie(
    "div",
    {
      className: Q(
        co({ variant: "ghost", size: "sm" }),
        "[&_svg]:size-3 focus-within:bg-indigo-100 focus-within:text-accent-foreground",
        e
      ),
      ref: i,
      ...o,
      children: [
        n,
        /* @__PURE__ */ ie(
          "button",
          {
            onClick: t,
            disabled: r,
            className: "disabled:text-muted-foreground",
            children: [
              /* @__PURE__ */ b("span", { className: "sr-only", children: "Remove filter" }),
              /* @__PURE__ */ b(ts, {})
            ]
          }
        )
      ]
    }
  )
);
FG.displayName = "LBFilterChip";
const WG = fe(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  "div",
  {
    className: Q("text-sm  text-slate-500 font-bold text-center", e),
    ref: n,
    ...t
  }
));
WG.displayName = "LBFilterChipLabel";
var qG = "Separator", Bp = "horizontal", jG = ["horizontal", "vertical"], Bk = d.forwardRef((e, t) => {
  const { decorative: n, orientation: r = Bp, ...o } = e, i = HG(r) ? r : Bp, s = n ? { role: "none" } : { "aria-orientation": i === "vertical" ? i : void 0, role: "separator" };
  return /* @__PURE__ */ b(
    ce.div,
    {
      "data-orientation": i,
      ...s,
      ...o,
      ref: t
    }
  );
});
Bk.displayName = qG;
function HG(e) {
  return jG.includes(e);
}
var VG = Bk;
const UG = d.forwardRef(
  ({ className: e, orientation: t = "horizontal", decorative: n = !0, ...r }, o) => /* @__PURE__ */ b(
    VG,
    {
      ref: o,
      decorative: n,
      orientation: t,
      className: Q(
        "shrink-0 bg-border",
        t === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
        e
      ),
      ...r
    }
  )
);
UG.displayName = "LBSeparator";
const zG = $C;
zG.displayName = "LBCollapsible";
const YG = yh;
YG.displayName = "LBCollapsibleTrigger";
const GG = wh;
GG.displayName = "LBCollapsibleContent";
function KG(e, t) {
  return d.useReducer((n, r) => t[n][r] ?? n, e);
}
var G4 = "ScrollArea", [$k, qee] = Ot(G4), [ZG, Sn] = $k(G4), Fk = d.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: n,
      type: r = "hover",
      dir: o,
      scrollHideDelay: i = 600,
      ...a
    } = e, [s, l] = d.useState(null), [c, f] = d.useState(null), [u, h] = d.useState(null), [m, g] = d.useState(null), [p, v] = d.useState(null), [y, C] = d.useState(0), [w, _] = d.useState(0), [x, k] = d.useState(!1), [S, T] = d.useState(!1), L = ke(t, (M) => l(M)), R = ko(o);
    return /* @__PURE__ */ b(
      ZG,
      {
        scope: n,
        type: r,
        dir: R,
        scrollHideDelay: i,
        scrollArea: s,
        viewport: c,
        onViewportChange: f,
        content: u,
        onContentChange: h,
        scrollbarX: m,
        onScrollbarXChange: g,
        scrollbarXEnabled: x,
        onScrollbarXEnabledChange: k,
        scrollbarY: p,
        onScrollbarYChange: v,
        scrollbarYEnabled: S,
        onScrollbarYEnabledChange: T,
        onCornerWidthChange: C,
        onCornerHeightChange: _,
        children: /* @__PURE__ */ b(
          ce.div,
          {
            dir: R,
            ...a,
            ref: L,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": y + "px",
              "--radix-scroll-area-corner-height": w + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
Fk.displayName = G4;
var Wk = "ScrollAreaViewport", qk = d.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, children: r, nonce: o, ...i } = e, a = Sn(Wk, n), s = d.useRef(null), l = ke(t, s, a.onViewportChange);
    return /* @__PURE__ */ ie(St, { children: [
      /* @__PURE__ */ b(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: o
        }
      ),
      /* @__PURE__ */ b(
        ce.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...i,
          ref: l,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: a.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: a.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ b("div", { ref: a.onContentChange, style: { minWidth: "100%", display: "table" }, children: r })
        }
      )
    ] });
  }
);
qk.displayName = Wk;
var or = "ScrollAreaScrollbar", jk = d.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, o = Sn(or, e.__scopeScrollArea), { onScrollbarXEnabledChange: i, onScrollbarYEnabledChange: a } = o, s = e.orientation === "horizontal";
    return d.useEffect(() => (s ? i(!0) : a(!0), () => {
      s ? i(!1) : a(!1);
    }), [s, i, a]), o.type === "hover" ? /* @__PURE__ */ b(XG, { ...r, ref: t, forceMount: n }) : o.type === "scroll" ? /* @__PURE__ */ b(QG, { ...r, ref: t, forceMount: n }) : o.type === "auto" ? /* @__PURE__ */ b(Hk, { ...r, ref: t, forceMount: n }) : o.type === "always" ? /* @__PURE__ */ b(K4, { ...r, ref: t }) : null;
  }
);
jk.displayName = or;
var XG = d.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, o = Sn(or, e.__scopeScrollArea), [i, a] = d.useState(!1);
  return d.useEffect(() => {
    const s = o.scrollArea;
    let l = 0;
    if (s) {
      const c = () => {
        window.clearTimeout(l), a(!0);
      }, f = () => {
        l = window.setTimeout(() => a(!1), o.scrollHideDelay);
      };
      return s.addEventListener("pointerenter", c), s.addEventListener("pointerleave", f), () => {
        window.clearTimeout(l), s.removeEventListener("pointerenter", c), s.removeEventListener("pointerleave", f);
      };
    }
  }, [o.scrollArea, o.scrollHideDelay]), /* @__PURE__ */ b(Nt, { present: n || i, children: /* @__PURE__ */ b(
    Hk,
    {
      "data-state": i ? "visible" : "hidden",
      ...r,
      ref: t
    }
  ) });
}), QG = d.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, o = Sn(or, e.__scopeScrollArea), i = e.orientation === "horizontal", a = Tc(() => l("SCROLL_END"), 100), [s, l] = KG("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return d.useEffect(() => {
    if (s === "idle") {
      const c = window.setTimeout(() => l("HIDE"), o.scrollHideDelay);
      return () => window.clearTimeout(c);
    }
  }, [s, o.scrollHideDelay, l]), d.useEffect(() => {
    const c = o.viewport, f = i ? "scrollLeft" : "scrollTop";
    if (c) {
      let u = c[f];
      const h = () => {
        const m = c[f];
        u !== m && (l("SCROLL"), a()), u = m;
      };
      return c.addEventListener("scroll", h), () => c.removeEventListener("scroll", h);
    }
  }, [o.viewport, i, l, a]), /* @__PURE__ */ b(Nt, { present: n || s !== "hidden", children: /* @__PURE__ */ b(
    K4,
    {
      "data-state": s === "hidden" ? "hidden" : "visible",
      ...r,
      ref: t,
      onPointerEnter: ne(e.onPointerEnter, () => l("POINTER_ENTER")),
      onPointerLeave: ne(e.onPointerLeave, () => l("POINTER_LEAVE"))
    }
  ) });
}), Hk = d.forwardRef((e, t) => {
  const n = Sn(or, e.__scopeScrollArea), { forceMount: r, ...o } = e, [i, a] = d.useState(!1), s = e.orientation === "horizontal", l = Tc(() => {
    if (n.viewport) {
      const c = n.viewport.offsetWidth < n.viewport.scrollWidth, f = n.viewport.offsetHeight < n.viewport.scrollHeight;
      a(s ? c : f);
    }
  }, 10);
  return pi(n.viewport, l), pi(n.content, l), /* @__PURE__ */ b(Nt, { present: r || i, children: /* @__PURE__ */ b(
    K4,
    {
      "data-state": i ? "visible" : "hidden",
      ...o,
      ref: t
    }
  ) });
}), K4 = d.forwardRef((e, t) => {
  const { orientation: n = "vertical", ...r } = e, o = Sn(or, e.__scopeScrollArea), i = d.useRef(null), a = d.useRef(0), [s, l] = d.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), c = Gk(s.viewport, s.content), f = {
    ...r,
    sizes: s,
    onSizesChange: l,
    hasThumb: c > 0 && c < 1,
    onThumbChange: (h) => i.current = h,
    onThumbPointerUp: () => a.current = 0,
    onThumbPointerDown: (h) => a.current = h
  };
  function u(h, m) {
    return oK(h, a.current, s, m);
  }
  return n === "horizontal" ? /* @__PURE__ */ b(
    JG,
    {
      ...f,
      ref: t,
      onThumbPositionChange: () => {
        if (o.viewport && i.current) {
          const h = o.viewport.scrollLeft, m = $p(h, s, o.dir);
          i.current.style.transform = `translate3d(${m}px, 0, 0)`;
        }
      },
      onWheelScroll: (h) => {
        o.viewport && (o.viewport.scrollLeft = h);
      },
      onDragScroll: (h) => {
        o.viewport && (o.viewport.scrollLeft = u(h, o.dir));
      }
    }
  ) : n === "vertical" ? /* @__PURE__ */ b(
    eK,
    {
      ...f,
      ref: t,
      onThumbPositionChange: () => {
        if (o.viewport && i.current) {
          const h = o.viewport.scrollTop, m = $p(h, s);
          i.current.style.transform = `translate3d(0, ${m}px, 0)`;
        }
      },
      onWheelScroll: (h) => {
        o.viewport && (o.viewport.scrollTop = h);
      },
      onDragScroll: (h) => {
        o.viewport && (o.viewport.scrollTop = u(h));
      }
    }
  ) : null;
}), JG = d.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: r, ...o } = e, i = Sn(or, e.__scopeScrollArea), [a, s] = d.useState(), l = d.useRef(null), c = ke(t, l, i.onScrollbarXChange);
  return d.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ b(
    Uk,
    {
      "data-orientation": "horizontal",
      ...o,
      ref: c,
      sizes: n,
      style: {
        bottom: 0,
        left: i.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: i.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": Lc(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (f) => e.onThumbPointerDown(f.x),
      onDragScroll: (f) => e.onDragScroll(f.x),
      onWheelScroll: (f, u) => {
        if (i.viewport) {
          const h = i.viewport.scrollLeft + f.deltaX;
          e.onWheelScroll(h), Zk(h, u) && f.preventDefault();
        }
      },
      onResize: () => {
        l.current && i.viewport && a && r({
          content: i.viewport.scrollWidth,
          viewport: i.viewport.offsetWidth,
          scrollbar: {
            size: l.current.clientWidth,
            paddingStart: T0(a.paddingLeft),
            paddingEnd: T0(a.paddingRight)
          }
        });
      }
    }
  );
}), eK = d.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: r, ...o } = e, i = Sn(or, e.__scopeScrollArea), [a, s] = d.useState(), l = d.useRef(null), c = ke(t, l, i.onScrollbarYChange);
  return d.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ b(
    Uk,
    {
      "data-orientation": "vertical",
      ...o,
      ref: c,
      sizes: n,
      style: {
        top: 0,
        right: i.dir === "ltr" ? 0 : void 0,
        left: i.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": Lc(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (f) => e.onThumbPointerDown(f.y),
      onDragScroll: (f) => e.onDragScroll(f.y),
      onWheelScroll: (f, u) => {
        if (i.viewport) {
          const h = i.viewport.scrollTop + f.deltaY;
          e.onWheelScroll(h), Zk(h, u) && f.preventDefault();
        }
      },
      onResize: () => {
        l.current && i.viewport && a && r({
          content: i.viewport.scrollHeight,
          viewport: i.viewport.offsetHeight,
          scrollbar: {
            size: l.current.clientHeight,
            paddingStart: T0(a.paddingTop),
            paddingEnd: T0(a.paddingBottom)
          }
        });
      }
    }
  );
}), [tK, Vk] = $k(or), Uk = d.forwardRef((e, t) => {
  const {
    __scopeScrollArea: n,
    sizes: r,
    hasThumb: o,
    onThumbChange: i,
    onThumbPointerUp: a,
    onThumbPointerDown: s,
    onThumbPositionChange: l,
    onDragScroll: c,
    onWheelScroll: f,
    onResize: u,
    ...h
  } = e, m = Sn(or, n), [g, p] = d.useState(null), v = ke(t, (L) => p(L)), y = d.useRef(null), C = d.useRef(""), w = m.viewport, _ = r.content - r.viewport, x = qt(f), k = qt(l), S = Tc(u, 10);
  function T(L) {
    if (y.current) {
      const R = L.clientX - y.current.left, M = L.clientY - y.current.top;
      c({ x: R, y: M });
    }
  }
  return d.useEffect(() => {
    const L = (R) => {
      const M = R.target;
      (g == null ? void 0 : g.contains(M)) && x(R, _);
    };
    return document.addEventListener("wheel", L, { passive: !1 }), () => document.removeEventListener("wheel", L, { passive: !1 });
  }, [w, g, _, x]), d.useEffect(k, [r, k]), pi(g, S), pi(m.content, S), /* @__PURE__ */ b(
    tK,
    {
      scope: n,
      scrollbar: g,
      hasThumb: o,
      onThumbChange: qt(i),
      onThumbPointerUp: qt(a),
      onThumbPositionChange: k,
      onThumbPointerDown: qt(s),
      children: /* @__PURE__ */ b(
        ce.div,
        {
          ...h,
          ref: v,
          style: { position: "absolute", ...h.style },
          onPointerDown: ne(e.onPointerDown, (L) => {
            L.button === 0 && (L.target.setPointerCapture(L.pointerId), y.current = g.getBoundingClientRect(), C.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", m.viewport && (m.viewport.style.scrollBehavior = "auto"), T(L));
          }),
          onPointerMove: ne(e.onPointerMove, T),
          onPointerUp: ne(e.onPointerUp, (L) => {
            const R = L.target;
            R.hasPointerCapture(L.pointerId) && R.releasePointerCapture(L.pointerId), document.body.style.webkitUserSelect = C.current, m.viewport && (m.viewport.style.scrollBehavior = ""), y.current = null;
          })
        }
      )
    }
  );
}), L0 = "ScrollAreaThumb", zk = d.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, o = Vk(L0, e.__scopeScrollArea);
    return /* @__PURE__ */ b(Nt, { present: n || o.hasThumb, children: /* @__PURE__ */ b(nK, { ref: t, ...r }) });
  }
), nK = d.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, style: r, ...o } = e, i = Sn(L0, n), a = Vk(L0, n), { onThumbPositionChange: s } = a, l = ke(
      t,
      (u) => a.onThumbChange(u)
    ), c = d.useRef(void 0), f = Tc(() => {
      c.current && (c.current(), c.current = void 0);
    }, 100);
    return d.useEffect(() => {
      const u = i.viewport;
      if (u) {
        const h = () => {
          if (f(), !c.current) {
            const m = iK(u, s);
            c.current = m, s();
          }
        };
        return s(), u.addEventListener("scroll", h), () => u.removeEventListener("scroll", h);
      }
    }, [i.viewport, f, s]), /* @__PURE__ */ b(
      ce.div,
      {
        "data-state": a.hasThumb ? "visible" : "hidden",
        ...o,
        ref: l,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...r
        },
        onPointerDownCapture: ne(e.onPointerDownCapture, (u) => {
          const m = u.target.getBoundingClientRect(), g = u.clientX - m.left, p = u.clientY - m.top;
          a.onThumbPointerDown({ x: g, y: p });
        }),
        onPointerUp: ne(e.onPointerUp, a.onThumbPointerUp)
      }
    );
  }
);
zk.displayName = L0;
var Z4 = "ScrollAreaCorner", Yk = d.forwardRef(
  (e, t) => {
    const n = Sn(Z4, e.__scopeScrollArea), r = !!(n.scrollbarX && n.scrollbarY);
    return n.type !== "scroll" && r ? /* @__PURE__ */ b(rK, { ...e, ref: t }) : null;
  }
);
Yk.displayName = Z4;
var rK = d.forwardRef((e, t) => {
  const { __scopeScrollArea: n, ...r } = e, o = Sn(Z4, n), [i, a] = d.useState(0), [s, l] = d.useState(0), c = !!(i && s);
  return pi(o.scrollbarX, () => {
    var u;
    const f = ((u = o.scrollbarX) == null ? void 0 : u.offsetHeight) || 0;
    o.onCornerHeightChange(f), l(f);
  }), pi(o.scrollbarY, () => {
    var u;
    const f = ((u = o.scrollbarY) == null ? void 0 : u.offsetWidth) || 0;
    o.onCornerWidthChange(f), a(f);
  }), c ? /* @__PURE__ */ b(
    ce.div,
    {
      ...r,
      ref: t,
      style: {
        width: i,
        height: s,
        position: "absolute",
        right: o.dir === "ltr" ? 0 : void 0,
        left: o.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function T0(e) {
  return e ? parseInt(e, 10) : 0;
}
function Gk(e, t) {
  const n = e / t;
  return isNaN(n) ? 0 : n;
}
function Lc(e) {
  const t = Gk(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, r = (e.scrollbar.size - n) * t;
  return Math.max(r, 18);
}
function oK(e, t, n, r = "ltr") {
  const o = Lc(n), i = o / 2, a = t || i, s = o - a, l = n.scrollbar.paddingStart + a, c = n.scrollbar.size - n.scrollbar.paddingEnd - s, f = n.content - n.viewport, u = r === "ltr" ? [0, f] : [f * -1, 0];
  return Kk([l, c], u)(e);
}
function $p(e, t, n = "ltr") {
  const r = Lc(t), o = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, i = t.scrollbar.size - o, a = t.content - t.viewport, s = i - r, l = n === "ltr" ? [0, a] : [a * -1, 0], c = T2(e, l);
  return Kk([0, a], [0, s])(c);
}
function Kk(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
function Zk(e, t) {
  return e > 0 && e < t;
}
var iK = (e, t = () => {
}) => {
  let n = { left: e.scrollLeft, top: e.scrollTop }, r = 0;
  return function o() {
    const i = { left: e.scrollLeft, top: e.scrollTop }, a = n.left !== i.left, s = n.top !== i.top;
    (a || s) && t(), n = i, r = window.requestAnimationFrame(o);
  }(), () => window.cancelAnimationFrame(r);
};
function Tc(e, t) {
  const n = qt(e), r = d.useRef(0);
  return d.useEffect(() => () => window.clearTimeout(r.current), []), d.useCallback(() => {
    window.clearTimeout(r.current), r.current = window.setTimeout(n, t);
  }, [n, t]);
}
function pi(e, t) {
  const n = qt(t);
  At(() => {
    let r = 0;
    if (e) {
      const o = new ResizeObserver(() => {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(n);
      });
      return o.observe(e), () => {
        window.cancelAnimationFrame(r), o.unobserve(e);
      };
    }
  }, [e, n]);
}
var aK = Fk, sK = qk, lK = Yk;
const cK = fe(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ ie(
  aK,
  {
    ref: r,
    className: Q("relative overflow-hidden", e),
    ...n,
    children: [
      /* @__PURE__ */ b(sK, { className: "size-full rounded-[inherit]", children: t }),
      /* @__PURE__ */ b(Xk, {}),
      /* @__PURE__ */ b(lK, {})
    ]
  }
));
cK.displayName = "LBScrollArea";
const Xk = fe(({ className: e, orientation: t = "vertical", ...n }, r) => /* @__PURE__ */ b(
  jk,
  {
    ref: r,
    orientation: t,
    className: Q(
      "flex touch-none select-none transition-colors",
      t === "vertical" && "h-full w-2 border-l border-l-transparent p-[1px]",
      t === "horizontal" && "h-2 flex-col border-t border-t-transparent p-[1px]",
      e
    ),
    ...n,
    children: /* @__PURE__ */ b(zk, { className: "relative flex-1 rounded-full bg-border" })
  }
));
Xk.displayName = "LBScrollBar";
var Qk = "AlertDialog", [uK, jee] = Ot(Qk, [
  fy
]), kr = fy(), Jk = (e) => {
  const { __scopeAlertDialog: t, ...n } = e, r = kr(t);
  return /* @__PURE__ */ b(rl, { ...r, ...n, modal: !0 });
};
Jk.displayName = Qk;
var dK = "AlertDialogTrigger", eS = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, o = kr(n);
    return /* @__PURE__ */ b(rh, { ...o, ...r, ref: t });
  }
);
eS.displayName = dK;
var fK = "AlertDialogPortal", tS = (e) => {
  const { __scopeAlertDialog: t, ...n } = e, r = kr(t);
  return /* @__PURE__ */ b(ol, { ...r, ...n });
};
tS.displayName = fK;
var hK = "AlertDialogOverlay", nS = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, o = kr(n);
    return /* @__PURE__ */ b(rs, { ...o, ...r, ref: t });
  }
);
nS.displayName = hK;
var oi = "AlertDialogContent", [mK, pK] = uK(oi), gK = /* @__PURE__ */ og("AlertDialogContent"), rS = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, children: r, ...o } = e, i = kr(n), a = d.useRef(null), s = ke(t, a), l = d.useRef(null);
    return /* @__PURE__ */ b(
      EA,
      {
        contentName: oi,
        titleName: oS,
        docsSlug: "alert-dialog",
        children: /* @__PURE__ */ b(mK, { scope: n, cancelRef: l, children: /* @__PURE__ */ ie(
          Si,
          {
            role: "alertdialog",
            ...i,
            ...o,
            ref: s,
            onOpenAutoFocus: ne(o.onOpenAutoFocus, (c) => {
              var f;
              c.preventDefault(), (f = l.current) == null || f.focus({ preventScroll: !0 });
            }),
            onPointerDownOutside: (c) => c.preventDefault(),
            onInteractOutside: (c) => c.preventDefault(),
            children: [
              /* @__PURE__ */ b(gK, { children: r }),
              /* @__PURE__ */ b(bK, { contentRef: a })
            ]
          }
        ) })
      }
    );
  }
);
rS.displayName = oi;
var oS = "AlertDialogTitle", iS = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, o = kr(n);
    return /* @__PURE__ */ b(il, { ...o, ...r, ref: t });
  }
);
iS.displayName = oS;
var aS = "AlertDialogDescription", sS = d.forwardRef((e, t) => {
  const { __scopeAlertDialog: n, ...r } = e, o = kr(n);
  return /* @__PURE__ */ b(oh, { ...o, ...r, ref: t });
});
sS.displayName = aS;
var vK = "AlertDialogAction", lS = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, o = kr(n);
    return /* @__PURE__ */ b(os, { ...o, ...r, ref: t });
  }
);
lS.displayName = vK;
var cS = "AlertDialogCancel", uS = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, { cancelRef: o } = pK(cS, n), i = kr(n), a = ke(t, o);
    return /* @__PURE__ */ b(os, { ...i, ...r, ref: a });
  }
);
uS.displayName = cS;
var bK = ({ contentRef: e }) => {
  const t = `\`${oi}\` requires a description for the component to be accessible for screen reader users.

You can add a description to the \`${oi}\` by passing a \`${aS}\` component as a child, which also benefits sighted users by adding visible context to the dialog.

Alternatively, you can use your own component as a description by assigning it an \`id\` and passing the same value to the \`aria-describedby\` prop in \`${oi}\`. If the description is confusing or duplicative for sighted users, you can use the \`@radix-ui/react-visually-hidden\` primitive as a wrapper around your description component.

For more information, see https://radix-ui.com/primitives/docs/components/alert-dialog`;
  return d.useEffect(() => {
    var r;
    document.getElementById(
      (r = e.current) == null ? void 0 : r.getAttribute("aria-describedby")
    ) || console.warn(t);
  }, [t, e]), null;
}, yK = Jk, CK = eS, wK = tS, xK = nS, _K = rS, kK = lS, SK = uS, MK = iS, EK = sS;
const LK = yK;
LK.displayName = "LBAlertDialog";
const TK = CK;
TK.displayName = "LBAlertDialogTrigger";
const dS = wK;
dS.displayName = "LBAlertDialogPortal";
const fS = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  xK,
  {
    className: Q(
      "fixed inset-0 z-50 bg-black/25  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t,
    ref: n
  }
));
fS.displayName = "LBAlertDialogOverlay";
const PK = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ ie(dS, { children: [
  /* @__PURE__ */ b(fS, {}),
  /* @__PURE__ */ b(
    _K,
    {
      ref: n,
      className: Q(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
        e
      ),
      ...t
    }
  )
] }));
PK.displayName = "LBAlertDialogContent";
function RK({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ b(
    "div",
    {
      className: Q(
        "flex flex-col space-y-2 text-center sm:text-left",
        e
      ),
      ...t
    }
  );
}
RK.displayName = "LBAlertDialogHeader";
function AK({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ b(
    "div",
    {
      className: Q(
        "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
        e
      ),
      ...t
    }
  );
}
AK.displayName = "LBAlertDialogFooter";
const OK = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  MK,
  {
    ref: n,
    className: Q("text-lg font-semibold", e),
    ...t
  }
));
OK.displayName = "LBAlertDialogTitle";
const NK = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  EK,
  {
    ref: n,
    className: Q("text-sm text-muted-foreground", e),
    ...t
  }
));
NK.displayName = "LBAlertDialogDescription";
const DK = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  kK,
  {
    ref: n,
    className: Q(co(), e),
    ...t
  }
));
DK.displayName = "LBAlertDialogAction";
const IK = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  SK,
  {
    ref: n,
    className: Q(
      co({ variant: "outline" }),
      "mt-2 sm:mt-0",
      e
    ),
    ...t
  }
));
IK.displayName = "LBAlertDialogCancel";
var X4 = "Progress", Q4 = 100, [BK, Hee] = Ot(X4), [$K, FK] = BK(X4), hS = d.forwardRef(
  (e, t) => {
    const {
      __scopeProgress: n,
      value: r = null,
      max: o,
      getValueLabel: i = WK,
      ...a
    } = e;
    (o || o === 0) && !Fp(o) && console.error(qK(`${o}`, "Progress"));
    const s = Fp(o) ? o : Q4;
    r !== null && !Wp(r, s) && console.error(jK(`${r}`, "Progress"));
    const l = Wp(r, s) ? r : null, c = P0(l) ? i(l, s) : void 0;
    return /* @__PURE__ */ b($K, { scope: n, value: l, max: s, children: /* @__PURE__ */ b(
      ce.div,
      {
        "aria-valuemax": s,
        "aria-valuemin": 0,
        "aria-valuenow": P0(l) ? l : void 0,
        "aria-valuetext": c,
        role: "progressbar",
        "data-state": gS(l, s),
        "data-value": l ?? void 0,
        "data-max": s,
        ...a,
        ref: t
      }
    ) });
  }
);
hS.displayName = X4;
var mS = "ProgressIndicator", pS = d.forwardRef(
  (e, t) => {
    const { __scopeProgress: n, ...r } = e, o = FK(mS, n);
    return /* @__PURE__ */ b(
      ce.div,
      {
        "data-state": gS(o.value, o.max),
        "data-value": o.value ?? void 0,
        "data-max": o.max,
        ...r,
        ref: t
      }
    );
  }
);
pS.displayName = mS;
function WK(e, t) {
  return `${Math.round(e / t * 100)}%`;
}
function gS(e, t) {
  return e == null ? "indeterminate" : e === t ? "complete" : "loading";
}
function P0(e) {
  return typeof e == "number";
}
function Fp(e) {
  return P0(e) && !isNaN(e) && e > 0;
}
function Wp(e, t) {
  return P0(e) && !isNaN(e) && e <= t && e >= 0;
}
function qK(e, t) {
  return `Invalid prop \`max\` of value \`${e}\` supplied to \`${t}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${Q4}\`.`;
}
function jK(e, t) {
  return `Invalid prop \`value\` of value \`${e}\` supplied to \`${t}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${Q4} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var HK = hS, VK = pS;
const UK = fe(({ className: e, value: t, ...n }, r) => /* @__PURE__ */ b(
  HK,
  {
    ref: r,
    className: Q(
      "relative h-2 w-full overflow-hidden rounded-full bg-primary/20",
      e
    ),
    ...n,
    children: /* @__PURE__ */ b(
      VK,
      {
        className: "size-full flex-1 bg-primary transition-all",
        style: { transform: `translateX(-${100 - (t || 0)}%)` }
      }
    )
  }
));
UK.displayName = "LBProgress";
const vS = 6048e5, zK = 864e5, qp = Symbol.for("constructDateFrom");
function jt(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && qp in e ? e[qp](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function dt(e, t) {
  return jt(t || e, e);
}
function bS(e, t, n) {
  const r = dt(e, n == null ? void 0 : n.in);
  return isNaN(t) ? jt(e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function yS(e, t, n) {
  const r = dt(e, n == null ? void 0 : n.in);
  if (isNaN(t)) return jt(e, NaN);
  if (!t)
    return r;
  const o = r.getDate(), i = jt(e, r.getTime());
  i.setMonth(r.getMonth() + t + 1, 0);
  const a = i.getDate();
  return o >= a ? i : (r.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    o
  ), r);
}
let YK = {};
function ys() {
  return YK;
}
function gi(e, t) {
  var s, l, c, f;
  const n = ys(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((f = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : f.weekStartsOn) ?? 0, o = dt(e, t == null ? void 0 : t.in), i = o.getDay(), a = (i < r ? 7 : 0) + i - r;
  return o.setDate(o.getDate() - a), o.setHours(0, 0, 0, 0), o;
}
function Va(e, t) {
  return gi(e, { ...t, weekStartsOn: 1 });
}
function CS(e, t) {
  const n = dt(e, t == null ? void 0 : t.in), r = n.getFullYear(), o = jt(n, 0);
  o.setFullYear(r + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const i = Va(o), a = jt(n, 0);
  a.setFullYear(r, 0, 4), a.setHours(0, 0, 0, 0);
  const s = Va(a);
  return n.getTime() >= i.getTime() ? r + 1 : n.getTime() >= s.getTime() ? r : r - 1;
}
function jp(e) {
  const t = dt(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function Bi(e, ...t) {
  const n = jt.bind(
    null,
    t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function Ua(e, t) {
  const n = dt(e, t == null ? void 0 : t.in);
  return n.setHours(0, 0, 0, 0), n;
}
function Ar(e, t, n) {
  const [r, o] = Bi(
    n == null ? void 0 : n.in,
    e,
    t
  ), i = Ua(r), a = Ua(o), s = +i - jp(i), l = +a - jp(a);
  return Math.round((s - l) / zK);
}
function GK(e, t) {
  const n = CS(e, t), r = jt(e, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), Va(r);
}
function KK(e, t, n) {
  return bS(e, t * 7, n);
}
function ZK(e, t, n) {
  return yS(e, t * 12, n);
}
function XK(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = jt.bind(null, o));
    const i = dt(o, r);
    (!n || n < i || isNaN(+i)) && (n = i);
  }), jt(r, n || NaN);
}
function QK(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = jt.bind(null, o));
    const i = dt(o, r);
    (!n || n > i || isNaN(+i)) && (n = i);
  }), jt(r, n || NaN);
}
function JK(e, t, n) {
  const [r, o] = Bi(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return +Ua(r) == +Ua(o);
}
function wS(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function eZ(e) {
  return !(!wS(e) && typeof e != "number" || isNaN(+dt(e)));
}
function tZ(e, t, n) {
  const [r, o] = Bi(
    n == null ? void 0 : n.in,
    e,
    t
  ), i = r.getFullYear() - o.getFullYear(), a = r.getMonth() - o.getMonth();
  return i * 12 + a;
}
function nZ(e, t) {
  const n = dt(e, t == null ? void 0 : t.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function rZ(e, t) {
  const [n, r] = Bi(e, t.start, t.end);
  return { start: n, end: r };
}
function oZ(e, t) {
  const { start: n, end: r } = rZ(t == null ? void 0 : t.in, e);
  let o = +n > +r;
  const i = o ? +n : +r, a = o ? r : n;
  a.setHours(0, 0, 0, 0), a.setDate(1);
  let s = 1;
  const l = [];
  for (; +a <= i; )
    l.push(jt(n, a)), a.setMonth(a.getMonth() + s);
  return o ? l.reverse() : l;
}
function iZ(e, t) {
  const n = dt(e, t == null ? void 0 : t.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function aZ(e, t) {
  const n = dt(e, t == null ? void 0 : t.in), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function xS(e, t) {
  const n = dt(e, t == null ? void 0 : t.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function _S(e, t) {
  var s, l, c, f;
  const n = ys(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((f = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : f.weekStartsOn) ?? 0, o = dt(e, t == null ? void 0 : t.in), i = o.getDay(), a = (i < r ? -7 : 0) + 6 - (i - r);
  return o.setDate(o.getDate() + a), o.setHours(23, 59, 59, 999), o;
}
function sZ(e, t) {
  return _S(e, { ...t, weekStartsOn: 1 });
}
const lZ = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, cZ = (e, t, n) => {
  let r;
  const o = lZ[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function p2(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const uZ = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, dZ = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, fZ = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, hZ = {
  date: p2({
    formats: uZ,
    defaultWidth: "full"
  }),
  time: p2({
    formats: dZ,
    defaultWidth: "full"
  }),
  dateTime: p2({
    formats: fZ,
    defaultWidth: "full"
  })
}, mZ = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, pZ = (e, t, n, r) => mZ[e];
function ta(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const a = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : a;
      o = e.formattingValues[s] || e.formattingValues[a];
    } else {
      const a = e.defaultWidth, s = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[s] || e.values[a];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[i];
  };
}
const gZ = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, vZ = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, bZ = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, yZ = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, CZ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, wZ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, xZ = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, _Z = {
  ordinalNumber: xZ,
  era: ta({
    values: gZ,
    defaultWidth: "wide"
  }),
  quarter: ta({
    values: vZ,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: ta({
    values: bZ,
    defaultWidth: "wide"
  }),
  day: ta({
    values: yZ,
    defaultWidth: "wide"
  }),
  dayPeriod: ta({
    values: CZ,
    defaultWidth: "wide",
    formattingValues: wZ,
    defaultFormattingWidth: "wide"
  })
};
function na(e) {
  return (t, n = {}) => {
    const r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(o);
    if (!i)
      return null;
    const a = i[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? SZ(s, (u) => u.test(a)) : (
      // [TODO] -- I challenge you to fix the type
      kZ(s, (u) => u.test(a))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(c)
    ) : c;
    const f = t.slice(a.length);
    return { value: c, rest: f };
  };
}
function kZ(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function SZ(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function MZ(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const o = r[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let a = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    const s = t.slice(o.length);
    return { value: a, rest: s };
  };
}
const EZ = /^(\d+)(th|st|nd|rd)?/i, LZ = /\d+/i, TZ = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, PZ = {
  any: [/^b/i, /^(a|c)/i]
}, RZ = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, AZ = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, OZ = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, NZ = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, DZ = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, IZ = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, BZ = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, $Z = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, FZ = {
  ordinalNumber: MZ({
    matchPattern: EZ,
    parsePattern: LZ,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: na({
    matchPatterns: TZ,
    defaultMatchWidth: "wide",
    parsePatterns: PZ,
    defaultParseWidth: "any"
  }),
  quarter: na({
    matchPatterns: RZ,
    defaultMatchWidth: "wide",
    parsePatterns: AZ,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: na({
    matchPatterns: OZ,
    defaultMatchWidth: "wide",
    parsePatterns: NZ,
    defaultParseWidth: "any"
  }),
  day: na({
    matchPatterns: DZ,
    defaultMatchWidth: "wide",
    parsePatterns: IZ,
    defaultParseWidth: "any"
  }),
  dayPeriod: na({
    matchPatterns: BZ,
    defaultMatchWidth: "any",
    parsePatterns: $Z,
    defaultParseWidth: "any"
  })
}, J4 = {
  code: "en-US",
  formatDistance: cZ,
  formatLong: hZ,
  formatRelative: pZ,
  localize: _Z,
  match: FZ,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function WZ(e, t) {
  const n = dt(e, t == null ? void 0 : t.in);
  return Ar(n, xS(n)) + 1;
}
function kS(e, t) {
  const n = dt(e, t == null ? void 0 : t.in), r = +Va(n) - +GK(n);
  return Math.round(r / vS) + 1;
}
function SS(e, t) {
  var f, u, h, m;
  const n = dt(e, t == null ? void 0 : t.in), r = n.getFullYear(), o = ys(), i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((u = (f = t == null ? void 0 : t.locale) == null ? void 0 : f.options) == null ? void 0 : u.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((m = (h = o.locale) == null ? void 0 : h.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, a = jt((t == null ? void 0 : t.in) || e, 0);
  a.setFullYear(r + 1, 0, i), a.setHours(0, 0, 0, 0);
  const s = gi(a, t), l = jt((t == null ? void 0 : t.in) || e, 0);
  l.setFullYear(r, 0, i), l.setHours(0, 0, 0, 0);
  const c = gi(l, t);
  return +n >= +s ? r + 1 : +n >= +c ? r : r - 1;
}
function qZ(e, t) {
  var s, l, c, f;
  const n = ys(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((f = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : f.firstWeekContainsDate) ?? 1, o = SS(e, t), i = jt((t == null ? void 0 : t.in) || e, 0);
  return i.setFullYear(o, 0, r), i.setHours(0, 0, 0, 0), gi(i, t);
}
function MS(e, t) {
  const n = dt(e, t == null ? void 0 : t.in), r = +gi(n, t) - +qZ(n, t);
  return Math.round(r / vS) + 1;
}
function st(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const Pr = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return st(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : st(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return st(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return st(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return st(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return st(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return st(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return st(o, t.length);
  }
}, zo = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Hp = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return Pr.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const o = SS(e, r), i = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const a = i % 100;
      return st(a, 2);
    }
    return t === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : st(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = CS(e);
    return st(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return st(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return st(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return st(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Pr.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return st(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const o = MS(e, r);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : st(o, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = kS(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : st(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : Pr.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = WZ(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : st(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const o = e.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(i);
      // Padded numerical value
      case "ee":
        return st(i, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const o = e.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(i);
      // Padded numerical value
      case "cc":
        return st(i, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      // 2
      case "i":
        return String(o);
      // 02
      case "ii":
        return st(o, t.length);
      // 2nd
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = zo.noon : r === 0 ? o = zo.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = zo.evening : r >= 12 ? o = zo.afternoon : r >= 4 ? o = zo.morning : o = zo.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return Pr.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : Pr.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : st(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : st(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Pr.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : Pr.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Pr.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return Up(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Jr(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return Jr(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return Up(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Jr(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return Jr(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Vp(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + Jr(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Vp(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + Jr(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(+e / 1e3);
    return st(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return st(+e, t.length);
  }
};
function Vp(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? n + String(o) : n + String(o) + t + st(i, 2);
}
function Up(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + st(Math.abs(e) / 60, 2) : Jr(e, t);
}
function Jr(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = st(Math.trunc(r / 60), 2), i = st(r % 60, 2);
  return n + o + t + i;
}
const zp = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, ES = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, jZ = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return zp(e, t);
  let i;
  switch (r) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", zp(r, t)).replace("{{time}}", ES(o, t));
}, HZ = {
  p: ES,
  P: jZ
}, VZ = /^D+$/, UZ = /^Y+$/, zZ = ["D", "DD", "YY", "YYYY"];
function YZ(e) {
  return VZ.test(e);
}
function GZ(e) {
  return UZ.test(e);
}
function KZ(e, t, n) {
  const r = ZZ(e, t, n);
  if (console.warn(r), zZ.includes(e)) throw new RangeError(r);
}
function ZZ(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const XZ = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, QZ = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, JZ = /^'([^]*?)'?$/, eX = /''/g, tX = /[a-zA-Z]/;
function ga(e, t, n) {
  var f, u, h, m, g, p, v, y;
  const r = ys(), o = (n == null ? void 0 : n.locale) ?? r.locale ?? J4, i = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((u = (f = n == null ? void 0 : n.locale) == null ? void 0 : f.options) == null ? void 0 : u.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((m = (h = r.locale) == null ? void 0 : h.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, a = (n == null ? void 0 : n.weekStartsOn) ?? ((p = (g = n == null ? void 0 : n.locale) == null ? void 0 : g.options) == null ? void 0 : p.weekStartsOn) ?? r.weekStartsOn ?? ((y = (v = r.locale) == null ? void 0 : v.options) == null ? void 0 : y.weekStartsOn) ?? 0, s = dt(e, n == null ? void 0 : n.in);
  if (!eZ(s))
    throw new RangeError("Invalid time value");
  let l = t.match(QZ).map((C) => {
    const w = C[0];
    if (w === "p" || w === "P") {
      const _ = HZ[w];
      return _(C, o.formatLong);
    }
    return C;
  }).join("").match(XZ).map((C) => {
    if (C === "''")
      return { isToken: !1, value: "'" };
    const w = C[0];
    if (w === "'")
      return { isToken: !1, value: nX(C) };
    if (Hp[w])
      return { isToken: !0, value: C };
    if (w.match(tX))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + w + "`"
      );
    return { isToken: !1, value: C };
  });
  o.localize.preprocessor && (l = o.localize.preprocessor(s, l));
  const c = {
    firstWeekContainsDate: i,
    weekStartsOn: a,
    locale: o
  };
  return l.map((C) => {
    if (!C.isToken) return C.value;
    const w = C.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && GZ(w) || !(n != null && n.useAdditionalDayOfYearTokens) && YZ(w)) && KZ(w, t, String(e));
    const _ = Hp[w[0]];
    return _(s, w, o.localize, c);
  }).join("");
}
function nX(e) {
  const t = e.match(JZ);
  return t ? t[1].replace(eX, "'") : e;
}
function rX(e, t) {
  const n = dt(e, t == null ? void 0 : t.in), r = n.getFullYear(), o = n.getMonth(), i = jt(n, 0);
  return i.setFullYear(r, o + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function oX(e, t) {
  return dt(e, t == null ? void 0 : t.in).getMonth();
}
function iX(e, t) {
  return dt(e, t == null ? void 0 : t.in).getFullYear();
}
function aX(e, t) {
  return +dt(e) > +dt(t);
}
function sX(e, t) {
  return +dt(e) < +dt(t);
}
function lX(e, t, n) {
  const [r, o] = Bi(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear() && r.getMonth() === o.getMonth();
}
function cX(e, t, n) {
  const [r, o] = Bi(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear();
}
function uX(e, t, n) {
  const r = dt(e, n == null ? void 0 : n.in), o = r.getFullYear(), i = r.getDate(), a = jt(e, 0);
  a.setFullYear(o, t, 15), a.setHours(0, 0, 0, 0);
  const s = rX(a);
  return r.setMonth(t, Math.min(i, s)), r;
}
function dX(e, t, n) {
  const r = dt(e, n == null ? void 0 : n.in);
  return isNaN(+r) ? jt(e, NaN) : (r.setFullYear(t), r);
}
const g2 = {}, ua = {};
function va(e, t) {
  try {
    const r = (g2[e] || (g2[e] = new Intl.DateTimeFormat("en-GB", {
      timeZone: e,
      hour: "numeric",
      timeZoneName: "longOffset"
    }).format))(t).split("GMT")[1] || "";
    return r in ua ? ua[r] : Yp(r, r.split(":"));
  } catch {
    if (e in ua) return ua[e];
    const n = e == null ? void 0 : e.match(fX);
    return n ? Yp(e, n.slice(1)) : NaN;
  }
}
const fX = /([+-]\d\d):?(\d\d)?/;
function Yp(e, t) {
  const n = +t[0], r = +(t[1] || 0);
  return ua[e] = n > 0 ? n * 60 + r : n * 60 - r;
}
class Vn extends Date {
  //#region static
  constructor(...t) {
    super(), t.length > 1 && typeof t[t.length - 1] == "string" && (this.timeZone = t.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(va(this.timeZone, this)) ? this.setTime(NaN) : t.length ? typeof t[0] == "number" && (t.length === 1 || t.length === 2 && typeof t[1] != "number") ? this.setTime(t[0]) : typeof t[0] == "string" ? this.setTime(+new Date(t[0])) : t[0] instanceof Date ? this.setTime(+t[0]) : (this.setTime(+new Date(...t)), LS(this), k9(this)) : this.setTime(Date.now());
  }
  static tz(t, ...n) {
    return n.length ? new Vn(...n, t) : new Vn(Date.now(), t);
  }
  //#endregion
  //#region time zone
  withTimeZone(t) {
    return new Vn(+this, t);
  }
  getTimezoneOffset() {
    return -va(this.timeZone, this);
  }
  //#endregion
  //#region time
  setTime(t) {
    return Date.prototype.setTime.apply(this, arguments), k9(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new Vn(+new Date(t), this.timeZone);
  }
  //#endregion
}
const Gp = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (!Gp.test(e)) return;
  const t = e.replace(Gp, "$1UTC");
  Vn.prototype[t] && (e.startsWith("get") ? Vn.prototype[e] = function() {
    return this.internal[t]();
  } : (Vn.prototype[e] = function() {
    return Date.prototype[t].apply(this.internal, arguments), hX(this), +this;
  }, Vn.prototype[t] = function() {
    return Date.prototype[t].apply(this, arguments), k9(this), +this;
  }));
});
function k9(e) {
  e.internal.setTime(+e), e.internal.setUTCMinutes(e.internal.getUTCMinutes() - e.getTimezoneOffset());
}
function hX(e) {
  Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), LS(e);
}
function LS(e) {
  const t = va(e.timeZone, e), n = /* @__PURE__ */ new Date(+e);
  n.setUTCHours(n.getUTCHours() - 1);
  const r = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), o = -(/* @__PURE__ */ new Date(+n)).getTimezoneOffset(), i = r - o, a = Date.prototype.getHours.apply(e) !== e.internal.getUTCHours();
  i && a && e.internal.setUTCMinutes(e.internal.getUTCMinutes() + i);
  const s = r - t;
  s && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + s);
  const l = va(e.timeZone, e), f = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - l, u = l !== t, h = f - s;
  if (u && h) {
    Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + h);
    const m = va(e.timeZone, e), g = l - m;
    g && (e.internal.setUTCMinutes(e.internal.getUTCMinutes() + g), Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + g));
  }
}
class Xt extends Vn {
  //#region static
  static tz(t, ...n) {
    return n.length ? new Xt(...n, t) : new Xt(Date.now(), t);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [t, n, r] = this.tzComponents(), o = `${t}${n}:${r}`;
    return this.internal.toISOString().slice(0, -1) + o;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [t, n, r, o] = this.internal.toUTCString().split(" ");
    return `${t == null ? void 0 : t.slice(0, -1)} ${r} ${n} ${o}`;
  }
  toTimeString() {
    const t = this.internal.toUTCString().split(" ")[4], [n, r, o] = this.tzComponents();
    return `${t} GMT${n}${r}${o} (${mX(this.timeZone, this)})`;
  }
  toLocaleString(t, n) {
    return Date.prototype.toLocaleString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleDateString(t, n) {
    return Date.prototype.toLocaleDateString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleTimeString(t, n) {
    return Date.prototype.toLocaleTimeString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const t = this.getTimezoneOffset(), n = t > 0 ? "-" : "+", r = String(Math.floor(Math.abs(t) / 60)).padStart(2, "0"), o = String(Math.abs(t) % 60).padStart(2, "0");
    return [n, r, o];
  }
  //#endregion
  withTimeZone(t) {
    return new Xt(+this, t);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new Xt(+new Date(t), this.timeZone);
  }
  //#endregion
}
function mX(e, t) {
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: e,
    timeZoneName: "long"
  }).format(t).slice(12);
}
var Ce;
(function(e) {
  e.Root = "root", e.Chevron = "chevron", e.Day = "day", e.DayButton = "day_button", e.CaptionLabel = "caption_label", e.Dropdowns = "dropdowns", e.Dropdown = "dropdown", e.DropdownRoot = "dropdown_root", e.Footer = "footer", e.MonthGrid = "month_grid", e.MonthCaption = "month_caption", e.MonthsDropdown = "months_dropdown", e.Month = "month", e.Months = "months", e.Nav = "nav", e.NextMonthButton = "button_next", e.PreviousMonthButton = "button_previous", e.Week = "week", e.Weeks = "weeks", e.Weekday = "weekday", e.Weekdays = "weekdays", e.WeekNumber = "week_number", e.WeekNumberHeader = "week_number_header", e.YearsDropdown = "years_dropdown";
})(Ce || (Ce = {}));
var kt;
(function(e) {
  e.disabled = "disabled", e.hidden = "hidden", e.outside = "outside", e.focused = "focused", e.today = "today";
})(kt || (kt = {}));
var Rn;
(function(e) {
  e.range_end = "range_end", e.range_middle = "range_middle", e.range_start = "range_start", e.selected = "selected";
})(Rn || (Rn = {}));
var mn;
(function(e) {
  e.weeks_before_enter = "weeks_before_enter", e.weeks_before_exit = "weeks_before_exit", e.weeks_after_enter = "weeks_after_enter", e.weeks_after_exit = "weeks_after_exit", e.caption_after_enter = "caption_after_enter", e.caption_after_exit = "caption_after_exit", e.caption_before_enter = "caption_before_enter", e.caption_before_exit = "caption_before_exit";
})(mn || (mn = {}));
const Kp = 5, pX = 4;
function gX(e, t) {
  const n = t.startOfMonth(e), r = n.getDay() > 0 ? n.getDay() : 7, o = t.addDays(e, -r + 1), i = t.addDays(o, Kp * 7 - 1);
  return t.getMonth(e) === t.getMonth(i) ? Kp : pX;
}
function TS(e, t) {
  const n = t.startOfMonth(e), r = n.getDay();
  return r === 1 ? n : r === 0 ? t.addDays(n, -1 * 6) : t.addDays(n, -1 * (r - 1));
}
function vX(e, t) {
  const n = TS(e, t), r = gX(e, t);
  return t.addDays(n, r * 7 - 1);
}
class Sr {
  /**
   * Creates an instance of `DateLib`.
   *
   * @param options Configuration options for the date library.
   * @param overrides Custom overrides for the date library functions.
   */
  constructor(t, n) {
    this.Date = Date, this.today = () => {
      var r;
      return (r = this.overrides) != null && r.today ? this.overrides.today() : this.options.timeZone ? Xt.tz(this.options.timeZone) : new this.Date();
    }, this.newDate = (r, o, i) => {
      var a;
      return (a = this.overrides) != null && a.newDate ? this.overrides.newDate(r, o, i) : this.options.timeZone ? new Xt(r, o, i, this.options.timeZone) : new Date(r, o, i);
    }, this.addDays = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.addDays ? this.overrides.addDays(r, o) : bS(r, o);
    }, this.addMonths = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.addMonths ? this.overrides.addMonths(r, o) : yS(r, o);
    }, this.addWeeks = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.addWeeks ? this.overrides.addWeeks(r, o) : KK(r, o);
    }, this.addYears = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.addYears ? this.overrides.addYears(r, o) : ZK(r, o);
    }, this.differenceInCalendarDays = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(r, o) : Ar(r, o);
    }, this.differenceInCalendarMonths = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(r, o) : tZ(r, o);
    }, this.eachMonthOfInterval = (r) => {
      var o;
      return (o = this.overrides) != null && o.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(r) : oZ(r);
    }, this.endOfBroadcastWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(r) : vX(r, this);
    }, this.endOfISOWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfISOWeek ? this.overrides.endOfISOWeek(r) : sZ(r);
    }, this.endOfMonth = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfMonth ? this.overrides.endOfMonth(r) : nZ(r);
    }, this.endOfWeek = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.endOfWeek ? this.overrides.endOfWeek(r, o) : _S(r, this.options);
    }, this.endOfYear = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfYear ? this.overrides.endOfYear(r) : aZ(r);
    }, this.format = (r, o, i) => {
      var s;
      const a = (s = this.overrides) != null && s.format ? this.overrides.format(r, o, this.options) : ga(r, o, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(a) : a;
    }, this.getISOWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.getISOWeek ? this.overrides.getISOWeek(r) : kS(r);
    }, this.getMonth = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.getMonth ? this.overrides.getMonth(r, this.options) : oX(r, this.options);
    }, this.getYear = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.getYear ? this.overrides.getYear(r, this.options) : iX(r, this.options);
    }, this.getWeek = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.getWeek ? this.overrides.getWeek(r, this.options) : MS(r, this.options);
    }, this.isAfter = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.isAfter ? this.overrides.isAfter(r, o) : aX(r, o);
    }, this.isBefore = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.isBefore ? this.overrides.isBefore(r, o) : sX(r, o);
    }, this.isDate = (r) => {
      var o;
      return (o = this.overrides) != null && o.isDate ? this.overrides.isDate(r) : wS(r);
    }, this.isSameDay = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.isSameDay ? this.overrides.isSameDay(r, o) : JK(r, o);
    }, this.isSameMonth = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.isSameMonth ? this.overrides.isSameMonth(r, o) : lX(r, o);
    }, this.isSameYear = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.isSameYear ? this.overrides.isSameYear(r, o) : cX(r, o);
    }, this.max = (r) => {
      var o;
      return (o = this.overrides) != null && o.max ? this.overrides.max(r) : XK(r);
    }, this.min = (r) => {
      var o;
      return (o = this.overrides) != null && o.min ? this.overrides.min(r) : QK(r);
    }, this.setMonth = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.setMonth ? this.overrides.setMonth(r, o) : uX(r, o);
    }, this.setYear = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.setYear ? this.overrides.setYear(r, o) : dX(r, o);
    }, this.startOfBroadcastWeek = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(r, this) : TS(r, this);
    }, this.startOfDay = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfDay ? this.overrides.startOfDay(r) : Ua(r);
    }, this.startOfISOWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfISOWeek ? this.overrides.startOfISOWeek(r) : Va(r);
    }, this.startOfMonth = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfMonth ? this.overrides.startOfMonth(r) : iZ(r);
    }, this.startOfWeek = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.startOfWeek ? this.overrides.startOfWeek(r, this.options) : gi(r, this.options);
    }, this.startOfYear = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfYear ? this.overrides.startOfYear(r) : xS(r);
    }, this.options = { locale: J4, ...t }, this.overrides = n;
  }
  /**
   * Generates a mapping of Arabic digits (0-9) to the target numbering system
   * digits.
   *
   * @since 9.5.0
   * @returns A record mapping Arabic digits to the target numerals.
   */
  getDigitMap() {
    const { numerals: t = "latn" } = this.options, n = new Intl.NumberFormat("en-US", {
      numberingSystem: t
    }), r = {};
    for (let o = 0; o < 10; o++)
      r[o.toString()] = n.format(o);
    return r;
  }
  /**
   * Replaces Arabic digits in a string with the target numbering system digits.
   *
   * @since 9.5.0
   * @param input The string containing Arabic digits.
   * @returns The string with digits replaced.
   */
  replaceDigits(t) {
    const n = this.getDigitMap();
    return t.replace(/\d/g, (r) => n[r] || r);
  }
  /**
   * Formats a number using the configured numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number as a string.
   */
  formatNumber(t) {
    return this.replaceDigits(t.toString());
  }
}
const ir = new Sr();
class PS {
  constructor(t, n, r = ir) {
    this.date = t, this.displayMonth = n, this.outside = !!(n && !r.isSameMonth(t, n)), this.dateLib = r;
  }
  /**
   * Checks if this day is equal to another `CalendarDay`, considering both the
   * date and the displayed month.
   *
   * @param day The `CalendarDay` to compare with.
   * @returns `true` if the days are equal, otherwise `false`.
   */
  isEqualTo(t) {
    return this.dateLib.isSameDay(t.date, this.date) && this.dateLib.isSameMonth(t.displayMonth, this.displayMonth);
  }
}
class bX {
  constructor(t, n) {
    this.date = t, this.weeks = n;
  }
}
class yX {
  constructor(t, n) {
    this.days = n, this.weekNumber = t;
  }
}
function mr(e, t, n = !1, r = ir) {
  let { from: o, to: i } = e;
  const { differenceInCalendarDays: a, isSameDay: s } = r;
  return o && i ? (a(i, o) < 0 && ([o, i] = [i, o]), a(t, o) >= (n ? 1 : 0) && a(i, t) >= (n ? 1 : 0)) : !n && i ? s(i, t) : !n && o ? s(o, t) : !1;
}
function RS(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function e8(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function AS(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function OS(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function NS(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function DS(e, t) {
  return Array.isArray(e) && e.every(t.isDate);
}
function pr(e, t, n = ir) {
  const r = Array.isArray(t) ? t : [t], { isSameDay: o, differenceInCalendarDays: i, isAfter: a } = n;
  return r.some((s) => {
    if (typeof s == "boolean")
      return s;
    if (n.isDate(s))
      return o(e, s);
    if (DS(s, n))
      return s.includes(e);
    if (e8(s))
      return mr(s, e, !1, n);
    if (NS(s))
      return Array.isArray(s.dayOfWeek) ? s.dayOfWeek.includes(e.getDay()) : s.dayOfWeek === e.getDay();
    if (RS(s)) {
      const l = i(s.before, e), c = i(s.after, e), f = l > 0, u = c < 0;
      return a(s.before, s.after) ? u && f : f || u;
    }
    return AS(s) ? i(e, s.after) > 0 : OS(s) ? i(s.before, e) > 0 : typeof s == "function" ? s(e) : !1;
  });
}
function CX(e, t, n) {
  const { disabled: r, hidden: o, modifiers: i, showOutsideDays: a, broadcastCalendar: s, today: l } = t, { isSameDay: c, isSameMonth: f, startOfMonth: u, isBefore: h, endOfMonth: m, isAfter: g } = n, p = t.startMonth && u(t.startMonth), v = t.endMonth && m(t.endMonth), y = {
    [kt.focused]: [],
    [kt.outside]: [],
    [kt.disabled]: [],
    [kt.hidden]: [],
    [kt.today]: []
  }, C = {};
  for (const w of e) {
    const { date: _, displayMonth: x } = w, k = !!(x && !f(_, x)), S = !!(p && h(_, p)), T = !!(v && g(_, v)), L = !!(r && pr(_, r, n)), R = !!(o && pr(_, o, n)) || S || T || // Broadcast calendar will show outside days as default
    !s && !a && k || s && a === !1 && k, M = c(_, l ?? n.today());
    k && y.outside.push(w), L && y.disabled.push(w), R && y.hidden.push(w), M && y.today.push(w), i && Object.keys(i).forEach((A) => {
      const O = i == null ? void 0 : i[A];
      O && pr(_, O, n) && (C[A] ? C[A].push(w) : C[A] = [w]);
    });
  }
  return (w) => {
    const _ = {
      [kt.focused]: !1,
      [kt.disabled]: !1,
      [kt.hidden]: !1,
      [kt.outside]: !1,
      [kt.today]: !1
    }, x = {};
    for (const k in y) {
      const S = y[k];
      _[k] = S.some((T) => T === w);
    }
    for (const k in C)
      x[k] = C[k].some((S) => S === w);
    return {
      ..._,
      // custom modifiers should override all the previous ones
      ...x
    };
  };
}
function wX(e, t, n = {}) {
  return Object.entries(e).filter(([, o]) => o === !0).reduce((o, [i]) => (n[i] ? o.push(n[i]) : t[kt[i]] ? o.push(t[kt[i]]) : t[Rn[i]] && o.push(t[Rn[i]]), o), [t[Ce.Day]]);
}
function xX(e) {
  return j.createElement("button", { ...e });
}
function _X(e) {
  return j.createElement("span", { ...e });
}
function kX(e) {
  const { size: t = 24, orientation: n = "left", className: r } = e;
  return j.createElement(
    "svg",
    { className: r, width: t, height: t, viewBox: "0 0 24 24" },
    n === "up" && j.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
    n === "down" && j.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
    n === "left" && j.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
    n === "right" && j.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
  );
}
function SX(e) {
  const { day: t, modifiers: n, ...r } = e;
  return j.createElement("td", { ...r });
}
function MX(e) {
  const { day: t, modifiers: n, ...r } = e, o = j.useRef(null);
  return j.useEffect(() => {
    var i;
    n.focused && ((i = o.current) == null || i.focus());
  }, [n.focused]), j.createElement("button", { ref: o, ...r });
}
function EX(e) {
  const { options: t, className: n, components: r, classNames: o, ...i } = e, a = [o[Ce.Dropdown], n].join(" "), s = t == null ? void 0 : t.find(({ value: l }) => l === i.value);
  return j.createElement(
    "span",
    { "data-disabled": i.disabled, className: o[Ce.DropdownRoot] },
    j.createElement(r.Select, { className: a, ...i }, t == null ? void 0 : t.map(({ value: l, label: c, disabled: f }) => j.createElement(r.Option, { key: l, value: l, disabled: f }, c))),
    j.createElement(
      "span",
      { className: o[Ce.CaptionLabel], "aria-hidden": !0 },
      s == null ? void 0 : s.label,
      j.createElement(r.Chevron, { orientation: "down", size: 18, className: o[Ce.Chevron] })
    )
  );
}
function LX(e) {
  return j.createElement("div", { ...e });
}
function TX(e) {
  return j.createElement("div", { ...e });
}
function PX(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return j.createElement("div", { ...r }, e.children);
}
function RX(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return j.createElement("div", { ...r });
}
function AX(e) {
  return j.createElement("table", { ...e });
}
function OX(e) {
  return j.createElement("div", { ...e });
}
const IS = _o(void 0);
function xo() {
  const e = Yn(IS);
  if (e === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return e;
}
function NX(e) {
  const { components: t } = xo();
  return j.createElement(t.Dropdown, { ...e });
}
function DX(e) {
  const { onPreviousClick: t, onNextClick: n, previousMonth: r, nextMonth: o, ...i } = e, { components: a, classNames: s, labels: { labelPrevious: l, labelNext: c } } = xo(), f = be((h) => {
    o && (n == null || n(h));
  }, [o, n]), u = be((h) => {
    r && (t == null || t(h));
  }, [r, t]);
  return j.createElement(
    "nav",
    { ...i },
    j.createElement(
      a.PreviousMonthButton,
      { type: "button", className: s[Ce.PreviousMonthButton], tabIndex: r ? void 0 : -1, "aria-disabled": r ? void 0 : !0, "aria-label": l(r), onClick: u },
      j.createElement(a.Chevron, { disabled: r ? void 0 : !0, className: s[Ce.Chevron], orientation: "left" })
    ),
    j.createElement(
      a.NextMonthButton,
      { type: "button", className: s[Ce.NextMonthButton], tabIndex: o ? void 0 : -1, "aria-disabled": o ? void 0 : !0, "aria-label": c(o), onClick: f },
      j.createElement(a.Chevron, { disabled: o ? void 0 : !0, orientation: "right", className: s[Ce.Chevron] })
    )
  );
}
function IX(e) {
  const { components: t } = xo();
  return j.createElement(t.Button, { ...e });
}
function BX(e) {
  return j.createElement("option", { ...e });
}
function $X(e) {
  const { components: t } = xo();
  return j.createElement(t.Button, { ...e });
}
function FX(e) {
  const { rootRef: t, ...n } = e;
  return j.createElement("div", { ...n, ref: t });
}
function WX(e) {
  return j.createElement("select", { ...e });
}
function qX(e) {
  const { week: t, ...n } = e;
  return j.createElement("tr", { ...n });
}
function jX(e) {
  return j.createElement("th", { ...e });
}
function HX(e) {
  return j.createElement(
    "thead",
    { "aria-hidden": !0 },
    j.createElement("tr", { ...e })
  );
}
function VX(e) {
  const { week: t, ...n } = e;
  return j.createElement("th", { ...n });
}
function UX(e) {
  return j.createElement("th", { ...e });
}
function zX(e) {
  return j.createElement("tbody", { ...e });
}
function YX(e) {
  const { components: t } = xo();
  return j.createElement(t.Dropdown, { ...e });
}
const GX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: xX,
  CaptionLabel: _X,
  Chevron: kX,
  Day: SX,
  DayButton: MX,
  Dropdown: EX,
  DropdownNav: LX,
  Footer: TX,
  Month: PX,
  MonthCaption: RX,
  MonthGrid: AX,
  Months: OX,
  MonthsDropdown: NX,
  Nav: DX,
  NextMonthButton: IX,
  Option: BX,
  PreviousMonthButton: $X,
  Root: FX,
  Select: WX,
  Week: qX,
  WeekNumber: VX,
  WeekNumberHeader: UX,
  Weekday: jX,
  Weekdays: HX,
  Weeks: zX,
  YearsDropdown: YX
}, Symbol.toStringTag, { value: "Module" }));
function KX(e) {
  return {
    ...GX,
    ...e
  };
}
function ZX(e) {
  const t = {
    "data-mode": e.mode ?? void 0,
    "data-required": "required" in e ? e.required : void 0,
    "data-multiple-months": e.numberOfMonths && e.numberOfMonths > 1 || void 0,
    "data-week-numbers": e.showWeekNumber || void 0,
    "data-broadcast-calendar": e.broadcastCalendar || void 0,
    "data-nav-layout": e.navLayout || void 0
  };
  return Object.entries(e).forEach(([n, r]) => {
    n.startsWith("data-") && (t[n] = r);
  }), t;
}
function XX() {
  const e = {};
  for (const t in Ce)
    e[Ce[t]] = `rdp-${Ce[t]}`;
  for (const t in kt)
    e[kt[t]] = `rdp-${kt[t]}`;
  for (const t in Rn)
    e[Rn[t]] = `rdp-${Rn[t]}`;
  for (const t in mn)
    e[mn[t]] = `rdp-${mn[t]}`;
  return e;
}
function BS(e, t, n) {
  return (n ?? new Sr(t)).format(e, "LLLL y");
}
const QX = BS;
function JX(e, t, n) {
  return (n ?? new Sr(t)).format(e, "d");
}
function eQ(e, t = ir) {
  return t.format(e, "LLLL");
}
function tQ(e, t = ir) {
  return e < 10 ? t.formatNumber(`0${e.toLocaleString()}`) : t.formatNumber(`${e.toLocaleString()}`);
}
function nQ() {
  return "";
}
function rQ(e, t, n) {
  return (n ?? new Sr(t)).format(e, "cccccc");
}
function $S(e, t = ir) {
  return t.format(e, "yyyy");
}
const oQ = $S, iQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: BS,
  formatDay: JX,
  formatMonthCaption: QX,
  formatMonthDropdown: eQ,
  formatWeekNumber: tQ,
  formatWeekNumberHeader: nQ,
  formatWeekdayName: rQ,
  formatYearCaption: oQ,
  formatYearDropdown: $S
}, Symbol.toStringTag, { value: "Module" }));
function aQ(e) {
  return e != null && e.formatMonthCaption && !e.formatCaption && (e.formatCaption = e.formatMonthCaption), e != null && e.formatYearCaption && !e.formatYearDropdown && (e.formatYearDropdown = e.formatYearCaption), {
    ...iQ,
    ...e
  };
}
function sQ(e, t, n, r, o) {
  const { startOfMonth: i, startOfYear: a, endOfYear: s, eachMonthOfInterval: l, getMonth: c } = o;
  return l({
    start: a(e),
    end: s(e)
  }).map((h) => {
    const m = r.formatMonthDropdown(h, o), g = c(h), p = t && h < i(t) || n && h > i(n) || !1;
    return { value: g, label: m, disabled: p };
  });
}
function lQ(e, t = {}, n = {}) {
  let r = { ...t == null ? void 0 : t[Ce.Day] };
  return Object.entries(e).filter(([, o]) => o === !0).forEach(([o]) => {
    r = {
      ...r,
      ...n == null ? void 0 : n[o]
    };
  }), r;
}
function cQ(e, t, n) {
  const r = e.today(), o = t ? e.startOfISOWeek(r) : e.startOfWeek(r), i = [];
  for (let a = 0; a < 7; a++) {
    const s = e.addDays(o, a);
    i.push(s);
  }
  return i;
}
function uQ(e, t, n, r) {
  if (!e || !t)
    return;
  const { startOfYear: o, endOfYear: i, addYears: a, getYear: s, isBefore: l, isSameYear: c } = r, f = o(e), u = i(t), h = [];
  let m = f;
  for (; l(m, u) || c(m, u); )
    h.push(m), m = a(m, 1);
  return h.map((g) => {
    const p = n.formatYearDropdown(g, r);
    return {
      value: s(g),
      label: p,
      disabled: !1
    };
  });
}
function FS(e, t, n) {
  return (n ?? new Sr(t)).format(e, "LLLL y");
}
const dQ = FS;
function fQ(e, t, n, r) {
  let o = (r ?? new Sr(n)).format(e, "PPPP");
  return t != null && t.today && (o = `Today, ${o}`), o;
}
function WS(e, t, n, r) {
  let o = (r ?? new Sr(n)).format(e, "PPPP");
  return t.today && (o = `Today, ${o}`), t.selected && (o = `${o}, selected`), o;
}
const hQ = WS;
function mQ() {
  return "";
}
function pQ(e) {
  return "Choose the Month";
}
function qS(e) {
  return "Go to the Next Month";
}
function jS(e) {
  return "Go to the Previous Month";
}
function gQ(e, t, n) {
  return (n ?? new Sr(t)).format(e, "cccc");
}
function vQ(e, t) {
  return `Week ${e}`;
}
function bQ(e) {
  return "Week Number";
}
function yQ(e) {
  return "Choose the Year";
}
const CQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: dQ,
  labelDay: hQ,
  labelDayButton: WS,
  labelGrid: FS,
  labelGridcell: fQ,
  labelMonthDropdown: pQ,
  labelNav: mQ,
  labelNext: qS,
  labelPrevious: jS,
  labelWeekNumber: vQ,
  labelWeekNumberHeader: bQ,
  labelWeekday: gQ,
  labelYearDropdown: yQ
}, Symbol.toStringTag, { value: "Module" })), Cs = (e) => e instanceof HTMLElement ? e : null, v2 = (e) => [
  ...e.querySelectorAll("[data-animated-month]") ?? []
], wQ = (e) => Cs(e.querySelector("[data-animated-month]")), b2 = (e) => Cs(e.querySelector("[data-animated-caption]")), y2 = (e) => Cs(e.querySelector("[data-animated-weeks]")), xQ = (e) => Cs(e.querySelector("[data-animated-nav]")), _Q = (e) => Cs(e.querySelector("[data-animated-weekdays]"));
function kQ(e, t, { classNames: n, months: r, focused: o, dateLib: i }) {
  const a = Lt(null), s = Lt(r), l = Lt(!1);
  S9(() => {
    const c = s.current;
    if (s.current = r, !t || !e.current || // safety check because the ref can be set to anything by consumers
    !(e.current instanceof HTMLElement) || // validation required for the animation to work as expected
    r.length === 0 || c.length === 0 || r.length !== c.length)
      return;
    const f = i.isSameMonth(r[0].date, c[0].date), u = i.isAfter(r[0].date, c[0].date), h = u ? n[mn.caption_after_enter] : n[mn.caption_before_enter], m = u ? n[mn.weeks_after_enter] : n[mn.weeks_before_enter], g = a.current, p = e.current.cloneNode(!0);
    if (p instanceof HTMLElement ? (v2(p).forEach((w) => {
      if (!(w instanceof HTMLElement))
        return;
      const _ = wQ(w);
      _ && w.contains(_) && w.removeChild(_);
      const x = b2(w);
      x && x.classList.remove(h);
      const k = y2(w);
      k && k.classList.remove(m);
    }), a.current = p) : a.current = null, l.current || f || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    o)
      return;
    const v = g instanceof HTMLElement ? v2(g) : [], y = v2(e.current);
    if (y && y.every((C) => C instanceof HTMLElement) && v && v.every((C) => C instanceof HTMLElement)) {
      l.current = !0, e.current.style.isolation = "isolate";
      const C = xQ(e.current);
      C && (C.style.zIndex = "1"), y.forEach((w, _) => {
        const x = v[_];
        if (!x)
          return;
        w.style.position = "relative", w.style.overflow = "hidden";
        const k = b2(w);
        k && k.classList.add(h);
        const S = y2(w);
        S && S.classList.add(m);
        const T = () => {
          l.current = !1, e.current && (e.current.style.isolation = ""), C && (C.style.zIndex = ""), k && k.classList.remove(h), S && S.classList.remove(m), w.style.position = "", w.style.overflow = "", w.contains(x) && w.removeChild(x);
        };
        x.style.pointerEvents = "none", x.style.position = "absolute", x.style.overflow = "hidden", x.setAttribute("aria-hidden", "true");
        const L = _Q(x);
        L && (L.style.opacity = "0");
        const R = b2(x);
        R && (R.classList.add(u ? n[mn.caption_before_exit] : n[mn.caption_after_exit]), R.addEventListener("animationend", T));
        const M = y2(x);
        M && M.classList.add(u ? n[mn.weeks_before_exit] : n[mn.weeks_after_exit]), w.insertBefore(x, w.firstChild);
      });
    }
  });
}
function SQ(e, t, n, r) {
  const o = e[0], i = e[e.length - 1], { ISOWeek: a, fixedWeeks: s, broadcastCalendar: l } = n ?? {}, { addDays: c, differenceInCalendarDays: f, differenceInCalendarMonths: u, endOfBroadcastWeek: h, endOfISOWeek: m, endOfMonth: g, endOfWeek: p, isAfter: v, startOfBroadcastWeek: y, startOfISOWeek: C, startOfWeek: w } = r, _ = l ? y(o, r) : a ? C(o) : w(o), x = l ? h(i) : a ? m(g(i)) : p(g(i)), k = f(x, _), S = u(i, o) + 1, T = [];
  for (let M = 0; M <= k; M++) {
    const A = c(_, M);
    if (t && v(A, t))
      break;
    T.push(A);
  }
  const R = (l ? 35 : 42) * S;
  if (s && T.length < R) {
    const M = R - T.length;
    for (let A = 0; A < M; A++) {
      const O = c(T[T.length - 1], 1);
      T.push(O);
    }
  }
  return T;
}
function MQ(e) {
  const t = [];
  return e.reduce((n, r) => {
    const o = r.weeks.reduce((i, a) => [...i, ...a.days], t);
    return [...n, ...o];
  }, t);
}
function EQ(e, t, n, r) {
  const { numberOfMonths: o = 1 } = n, i = [];
  for (let a = 0; a < o; a++) {
    const s = r.addMonths(e, a);
    if (t && s > t)
      break;
    i.push(s);
  }
  return i;
}
function Zp(e, t) {
  const { month: n, defaultMonth: r, today: o = t.today(), numberOfMonths: i = 1, endMonth: a, startMonth: s } = e;
  let l = n || r || o;
  const { differenceInCalendarMonths: c, addMonths: f, startOfMonth: u } = t;
  if (a && c(a, l) < 0) {
    const h = -1 * (i - 1);
    l = f(a, h);
  }
  return s && c(l, s) < 0 && (l = s), u(l);
}
function LQ(e, t, n, r) {
  const { addDays: o, endOfBroadcastWeek: i, endOfISOWeek: a, endOfMonth: s, endOfWeek: l, getISOWeek: c, getWeek: f, startOfBroadcastWeek: u, startOfISOWeek: h, startOfWeek: m } = r, g = e.reduce((p, v) => {
    const y = n.broadcastCalendar ? u(v, r) : n.ISOWeek ? h(v) : m(v), C = n.broadcastCalendar ? i(v) : n.ISOWeek ? a(s(v)) : l(s(v)), w = t.filter((S) => S >= y && S <= C), _ = n.broadcastCalendar ? 35 : 42;
    if (n.fixedWeeks && w.length < _) {
      const S = t.filter((T) => {
        const L = _ - w.length;
        return T > C && T <= o(C, L);
      });
      w.push(...S);
    }
    const x = w.reduce((S, T) => {
      const L = n.ISOWeek ? c(T) : f(T), R = S.find((A) => A.weekNumber === L), M = new PS(T, v, r);
      return R ? R.days.push(M) : S.push(new yX(L, [M])), S;
    }, []), k = new bX(v, x);
    return p.push(k), p;
  }, []);
  return n.reverseMonths ? g.reverse() : g;
}
function TQ(e, t) {
  let { startMonth: n, endMonth: r } = e;
  const { startOfYear: o, startOfDay: i, startOfMonth: a, endOfMonth: s, addYears: l, endOfYear: c, newDate: f, today: u } = t, { fromYear: h, toYear: m, fromMonth: g, toMonth: p } = e;
  !n && g && (n = g), !n && h && (n = t.newDate(h, 0, 1)), !r && p && (r = p), !r && m && (r = f(m, 11, 31));
  const v = e.captionLayout === "dropdown" || e.captionLayout === "dropdown-years";
  return n ? n = a(n) : h ? n = f(h, 0, 1) : !n && v && (n = o(l(e.today ?? u(), -100))), r ? r = s(r) : m ? r = f(m, 11, 31) : !r && v && (r = c(e.today ?? u())), [
    n && i(n),
    r && i(r)
  ];
}
function PQ(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: i = 1 } = n, { startOfMonth: a, addMonths: s, differenceInCalendarMonths: l } = r, c = o ? i : 1, f = a(e);
  if (!t)
    return s(f, c);
  if (!(l(t, e) < i))
    return s(f, c);
}
function RQ(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: i } = n, { startOfMonth: a, addMonths: s, differenceInCalendarMonths: l } = r, c = o ? i ?? 1 : 1, f = a(e);
  if (!t)
    return s(f, -c);
  if (!(l(f, t) <= 0))
    return s(f, -c);
}
function AQ(e) {
  const t = [];
  return e.reduce((n, r) => [...n, ...r.weeks], t);
}
function Pc(e, t) {
  const [n, r] = Yt(e);
  return [t === void 0 ? n : t, r];
}
function OQ(e, t) {
  const [n, r] = TQ(e, t), { startOfMonth: o, endOfMonth: i } = t, a = Zp(e, t), [s, l] = Pc(
    a,
    // initialMonth is always computed from props.month if provided
    e.month ? a : void 0
  );
  dn(() => {
    const k = Zp(e, t);
    l(k);
  }, [e.timeZone]);
  const c = EQ(s, r, e, t), f = SQ(c, e.endMonth ? i(e.endMonth) : void 0, e, t), u = LQ(c, f, e, t), h = AQ(u), m = MQ(u), g = RQ(s, n, e, t), p = PQ(s, r, e, t), { disableNavigation: v, onMonthChange: y } = e, C = (k) => h.some((S) => S.days.some((T) => T.isEqualTo(k))), w = (k) => {
    if (v)
      return;
    let S = o(k);
    n && S < o(n) && (S = o(n)), r && S > o(r) && (S = o(r)), l(S), y == null || y(S);
  };
  return {
    months: u,
    weeks: h,
    days: m,
    navStart: n,
    navEnd: r,
    previousMonth: g,
    nextMonth: p,
    goToMonth: w,
    goToDay: (k) => {
      C(k) || w(k.date);
    }
  };
}
var qn;
(function(e) {
  e[e.Today = 0] = "Today", e[e.Selected = 1] = "Selected", e[e.LastFocused = 2] = "LastFocused", e[e.FocusedModifier = 3] = "FocusedModifier";
})(qn || (qn = {}));
function Xp(e) {
  return !e[kt.disabled] && !e[kt.hidden] && !e[kt.outside];
}
function NQ(e, t, n, r) {
  let o, i = -1;
  for (const a of e) {
    const s = t(a);
    Xp(s) && (s[kt.focused] && i < qn.FocusedModifier ? (o = a, i = qn.FocusedModifier) : r != null && r.isEqualTo(a) && i < qn.LastFocused ? (o = a, i = qn.LastFocused) : n(a.date) && i < qn.Selected ? (o = a, i = qn.Selected) : s[kt.today] && i < qn.Today && (o = a, i = qn.Today));
  }
  return o || (o = e.find((a) => Xp(t(a)))), o;
}
function DQ(e, t, n, r, o, i, a) {
  const { ISOWeek: s, broadcastCalendar: l } = i, { addDays: c, addMonths: f, addWeeks: u, addYears: h, endOfBroadcastWeek: m, endOfISOWeek: g, endOfWeek: p, max: v, min: y, startOfBroadcastWeek: C, startOfISOWeek: w, startOfWeek: _ } = a;
  let k = {
    day: c,
    week: u,
    month: f,
    year: h,
    startOfWeek: (S) => l ? C(S, a) : s ? w(S) : _(S),
    endOfWeek: (S) => l ? m(S) : s ? g(S) : p(S)
  }[e](n, t === "after" ? 1 : -1);
  return t === "before" && r ? k = v([r, k]) : t === "after" && o && (k = y([o, k])), k;
}
function HS(e, t, n, r, o, i, a, s = 0) {
  if (s > 365)
    return;
  const l = DQ(e, t, n.date, r, o, i, a), c = !!(i.disabled && pr(l, i.disabled, a)), f = !!(i.hidden && pr(l, i.hidden, a)), u = l, h = new PS(l, u, a);
  return !c && !f ? h : HS(e, t, h, r, o, i, a, s + 1);
}
function IQ(e, t, n, r, o) {
  const { autoFocus: i } = e, [a, s] = Yt(), l = NQ(t.days, n, r || (() => !1), a), [c, f] = Yt(i ? l : void 0);
  return {
    isFocusTarget: (p) => !!(l != null && l.isEqualTo(p)),
    setFocused: f,
    focused: c,
    blur: () => {
      s(c), f(void 0);
    },
    moveFocus: (p, v) => {
      if (!c)
        return;
      const y = HS(p, v, c, t.navStart, t.navEnd, e, o);
      y && (t.goToDay(y), f(y));
    }
  };
}
function BQ(e, t) {
  const { selected: n, required: r, onSelect: o } = e, [i, a] = Pc(n, o ? n : void 0), s = o ? n : i, { isSameDay: l } = t, c = (m) => (s == null ? void 0 : s.some((g) => l(g, m))) ?? !1, { min: f, max: u } = e;
  return {
    selected: s,
    select: (m, g, p) => {
      let v = [...s ?? []];
      if (c(m)) {
        if ((s == null ? void 0 : s.length) === f || r && (s == null ? void 0 : s.length) === 1)
          return;
        v = s == null ? void 0 : s.filter((y) => !l(y, m));
      } else
        (s == null ? void 0 : s.length) === u ? v = [m] : v = [...v, m];
      return o || a(v), o == null || o(v, m, g, p), v;
    },
    isSelected: c
  };
}
function $Q(e, t, n = 0, r = 0, o = !1, i = ir) {
  const { from: a, to: s } = t || {}, { isSameDay: l, isAfter: c, isBefore: f } = i;
  let u;
  if (!a && !s)
    u = { from: e, to: n > 0 ? void 0 : e };
  else if (a && !s)
    l(a, e) ? o ? u = { from: a, to: void 0 } : u = void 0 : f(e, a) ? u = { from: e, to: a } : u = { from: a, to: e };
  else if (a && s)
    if (l(a, e) && l(s, e))
      o ? u = { from: a, to: s } : u = void 0;
    else if (l(a, e))
      u = { from: a, to: n > 0 ? void 0 : e };
    else if (l(s, e))
      u = { from: e, to: n > 0 ? void 0 : e };
    else if (f(e, a))
      u = { from: e, to: s };
    else if (c(e, a))
      u = { from: a, to: e };
    else if (c(e, s))
      u = { from: a, to: e };
    else
      throw new Error("Invalid range");
  if (u != null && u.from && (u != null && u.to)) {
    const h = i.differenceInCalendarDays(u.to, u.from);
    r > 0 && h > r ? u = { from: e, to: void 0 } : n > 1 && h < n && (u = { from: e, to: void 0 });
  }
  return u;
}
function FQ(e, t, n = ir) {
  const r = Array.isArray(t) ? t : [t];
  let o = e.from;
  const i = n.differenceInCalendarDays(e.to, e.from), a = Math.min(i, 6);
  for (let s = 0; s <= a; s++) {
    if (r.includes(o.getDay()))
      return !0;
    o = n.addDays(o, 1);
  }
  return !1;
}
function Qp(e, t, n = ir) {
  return mr(e, t.from, !1, n) || mr(e, t.to, !1, n) || mr(t, e.from, !1, n) || mr(t, e.to, !1, n);
}
function WQ(e, t, n = ir) {
  const r = Array.isArray(t) ? t : [t];
  if (r.filter((s) => typeof s != "function").some((s) => typeof s == "boolean" ? s : n.isDate(s) ? mr(e, s, !1, n) : DS(s, n) ? s.some((l) => mr(e, l, !1, n)) : e8(s) ? s.from && s.to ? Qp(e, { from: s.from, to: s.to }, n) : !1 : NS(s) ? FQ(e, s.dayOfWeek, n) : RS(s) ? n.isAfter(s.before, s.after) ? Qp(e, {
    from: n.addDays(s.after, 1),
    to: n.addDays(s.before, -1)
  }, n) : pr(e.from, s, n) || pr(e.to, s, n) : AS(s) || OS(s) ? pr(e.from, s, n) || pr(e.to, s, n) : !1))
    return !0;
  const a = r.filter((s) => typeof s == "function");
  if (a.length) {
    let s = e.from;
    const l = n.differenceInCalendarDays(e.to, e.from);
    for (let c = 0; c <= l; c++) {
      if (a.some((f) => f(s)))
        return !0;
      s = n.addDays(s, 1);
    }
  }
  return !1;
}
function qQ(e, t) {
  const { disabled: n, excludeDisabled: r, selected: o, required: i, onSelect: a } = e, [s, l] = Pc(o, a ? o : void 0), c = a ? o : s;
  return {
    selected: c,
    select: (h, m, g) => {
      const { min: p, max: v } = e, y = h ? $Q(h, c, p, v, i, t) : void 0;
      return r && n && (y != null && y.from) && y.to && WQ({ from: y.from, to: y.to }, n, t) && (y.from = h, y.to = void 0), a || l(y), a == null || a(y, h, m, g), y;
    },
    isSelected: (h) => c && mr(c, h, !1, t)
  };
}
function jQ(e, t) {
  const { selected: n, required: r, onSelect: o } = e, [i, a] = Pc(n, o ? n : void 0), s = o ? n : i, { isSameDay: l } = t;
  return {
    selected: s,
    select: (u, h, m) => {
      let g = u;
      return !r && s && s && l(u, s) && (g = void 0), o || a(g), o == null || o(g, u, h, m), g;
    },
    isSelected: (u) => s ? l(s, u) : !1
  };
}
function HQ(e, t) {
  const n = jQ(e, t), r = BQ(e, t), o = qQ(e, t);
  switch (e.mode) {
    case "single":
      return n;
    case "multiple":
      return r;
    case "range":
      return o;
    default:
      return;
  }
}
function VQ(e) {
  var pe;
  let t = e;
  t.timeZone && (t = {
    ...e
  }, t.today && (t.today = new Xt(t.today, t.timeZone)), t.month && (t.month = new Xt(t.month, t.timeZone)), t.defaultMonth && (t.defaultMonth = new Xt(t.defaultMonth, t.timeZone)), t.startMonth && (t.startMonth = new Xt(t.startMonth, t.timeZone)), t.endMonth && (t.endMonth = new Xt(t.endMonth, t.timeZone)), t.mode === "single" && t.selected ? t.selected = new Xt(t.selected, t.timeZone) : t.mode === "multiple" && t.selected ? t.selected = (pe = t.selected) == null ? void 0 : pe.map((ae) => new Xt(ae, t.timeZone)) : t.mode === "range" && t.selected && (t.selected = {
    from: t.selected.from ? new Xt(t.selected.from, t.timeZone) : void 0,
    to: t.selected.to ? new Xt(t.selected.to, t.timeZone) : void 0
  }));
  const { components: n, formatters: r, labels: o, dateLib: i, locale: a, classNames: s } = Te(() => {
    const ae = { ...J4, ...t.locale };
    return {
      dateLib: new Sr({
        locale: ae,
        weekStartsOn: t.broadcastCalendar ? 1 : t.weekStartsOn,
        firstWeekContainsDate: t.firstWeekContainsDate,
        useAdditionalWeekYearTokens: t.useAdditionalWeekYearTokens,
        useAdditionalDayOfYearTokens: t.useAdditionalDayOfYearTokens,
        timeZone: t.timeZone,
        numerals: t.numerals
      }, t.dateLib),
      components: KX(t.components),
      formatters: aQ(t.formatters),
      labels: { ...CQ, ...t.labels },
      locale: ae,
      classNames: { ...XX(), ...t.classNames }
    };
  }, [
    t.locale,
    t.broadcastCalendar,
    t.weekStartsOn,
    t.firstWeekContainsDate,
    t.useAdditionalWeekYearTokens,
    t.useAdditionalDayOfYearTokens,
    t.timeZone,
    t.numerals,
    t.dateLib,
    t.components,
    t.formatters,
    t.labels,
    t.classNames
  ]), { captionLayout: l, mode: c, navLayout: f, numberOfMonths: u = 1, onDayBlur: h, onDayClick: m, onDayFocus: g, onDayKeyDown: p, onDayMouseEnter: v, onDayMouseLeave: y, onNextClick: C, onPrevClick: w, showWeekNumber: _, styles: x } = t, { formatCaption: k, formatDay: S, formatMonthDropdown: T, formatWeekNumber: L, formatWeekNumberHeader: R, formatWeekdayName: M, formatYearDropdown: A } = r, O = OQ(t, i), { days: I, months: W, navStart: N, navEnd: H, previousMonth: q, nextMonth: D, goToMonth: $ } = O, U = CX(I, t, i), { isSelected: B, select: K, selected: X } = HQ(t, i) ?? {}, { blur: Z, focused: G, isFocusTarget: V, moveFocus: Y, setFocused: P } = IQ(t, O, U, B ?? (() => !1), i), { labelDayButton: F, labelGridcell: z, labelGrid: E, labelMonthDropdown: re, labelNav: ee, labelPrevious: oe, labelNext: ue, labelWeekday: le, labelWeekNumber: Ae, labelWeekNumberHeader: Ie, labelYearDropdown: bt } = o, He = Te(() => cQ(i, t.ISOWeek), [i, t.ISOWeek]), Me = c !== void 0 || m !== void 0, Pe = be(() => {
    q && ($(q), w == null || w(q));
  }, [q, $, w]), rt = be(() => {
    D && ($(D), C == null || C(D));
  }, [$, D, C]), ft = be((ae, ge) => (we) => {
    we.preventDefault(), we.stopPropagation(), P(ae), K == null || K(ae.date, ge, we), m == null || m(ae.date, ge, we);
  }, [K, m, P]), Xe = be((ae, ge) => (we) => {
    P(ae), g == null || g(ae.date, ge, we);
  }, [g, P]), ht = be((ae, ge) => (we) => {
    Z(), h == null || h(ae.date, ge, we);
  }, [Z, h]), Ge = be((ae, ge) => (we) => {
    const We = {
      ArrowLeft: ["day", t.dir === "rtl" ? "after" : "before"],
      ArrowRight: ["day", t.dir === "rtl" ? "before" : "after"],
      ArrowDown: ["week", "after"],
      ArrowUp: ["week", "before"],
      PageUp: [we.shiftKey ? "year" : "month", "before"],
      PageDown: [we.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (We[we.key]) {
      we.preventDefault(), we.stopPropagation();
      const [Oe, de] = We[we.key];
      Y(Oe, de);
    }
    p == null || p(ae.date, ge, we);
  }, [Y, p, t.dir]), Ve = be((ae, ge) => (we) => {
    v == null || v(ae.date, ge, we);
  }, [v]), Be = be((ae, ge) => (we) => {
    y == null || y(ae.date, ge, we);
  }, [y]), ct = be((ae) => (ge) => {
    const we = Number(ge.target.value), We = i.setMonth(i.startOfMonth(ae), we);
    $(We);
  }, [i, $]), ot = be((ae) => (ge) => {
    const we = Number(ge.target.value), We = i.setYear(i.startOfMonth(ae), we);
    $(We);
  }, [i, $]), { className: it, style: mt } = Te(() => ({
    className: [s[Ce.Root], t.className].filter(Boolean).join(" "),
    style: { ...x == null ? void 0 : x[Ce.Root], ...t.style }
  }), [s, t.className, t.style, x]), Qe = ZX(t), ut = Lt(null);
  kQ(ut, !!t.animate, {
    classNames: s,
    months: W,
    focused: G,
    dateLib: i
  });
  const Dt = {
    dayPickerProps: t,
    selected: X,
    select: K,
    isSelected: B,
    months: W,
    nextMonth: D,
    previousMonth: q,
    goToMonth: $,
    getModifiers: U,
    components: n,
    classNames: s,
    styles: x,
    labels: o,
    formatters: r
  };
  return j.createElement(
    IS.Provider,
    { value: Dt },
    j.createElement(
      n.Root,
      { rootRef: t.animate ? ut : void 0, className: it, style: mt, dir: t.dir, id: t.id, lang: t.lang, nonce: t.nonce, title: t.title, role: t.role, "aria-label": t["aria-label"], ...Qe },
      j.createElement(
        n.Months,
        { className: s[Ce.Months], style: x == null ? void 0 : x[Ce.Months] },
        !t.hideNavigation && !f && j.createElement(n.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: s[Ce.Nav], style: x == null ? void 0 : x[Ce.Nav], "aria-label": ee(), onPreviousClick: Pe, onNextClick: rt, previousMonth: q, nextMonth: D }),
        W.map((ae, ge) => {
          const we = sQ(ae.date, N, H, r, i), We = uQ(N, H, r, i);
          return j.createElement(
            n.Month,
            { "data-animated-month": t.animate ? "true" : void 0, className: s[Ce.Month], style: x == null ? void 0 : x[Ce.Month], key: ge, displayIndex: ge, calendarMonth: ae },
            f === "around" && !t.hideNavigation && ge === 0 && j.createElement(
              n.PreviousMonthButton,
              { type: "button", className: s[Ce.PreviousMonthButton], tabIndex: q ? void 0 : -1, "aria-disabled": q ? void 0 : !0, "aria-label": oe(q), onClick: Pe, "data-animated-button": t.animate ? "true" : void 0 },
              j.createElement(n.Chevron, { disabled: q ? void 0 : !0, className: s[Ce.Chevron], orientation: t.dir === "rtl" ? "right" : "left" })
            ),
            j.createElement(n.MonthCaption, { "data-animated-caption": t.animate ? "true" : void 0, className: s[Ce.MonthCaption], style: x == null ? void 0 : x[Ce.MonthCaption], calendarMonth: ae, displayIndex: ge }, l != null && l.startsWith("dropdown") ? j.createElement(
              n.DropdownNav,
              { className: s[Ce.Dropdowns], style: x == null ? void 0 : x[Ce.Dropdowns] },
              l === "dropdown" || l === "dropdown-months" ? j.createElement(n.MonthsDropdown, { className: s[Ce.MonthsDropdown], "aria-label": re(), classNames: s, components: n, disabled: !!t.disableNavigation, onChange: ct(ae.date), options: we, style: x == null ? void 0 : x[Ce.Dropdown], value: i.getMonth(ae.date) }) : j.createElement("span", null, T(ae.date, i)),
              l === "dropdown" || l === "dropdown-years" ? j.createElement(n.YearsDropdown, { className: s[Ce.YearsDropdown], "aria-label": bt(i.options), classNames: s, components: n, disabled: !!t.disableNavigation, onChange: ot(ae.date), options: We, style: x == null ? void 0 : x[Ce.Dropdown], value: i.getYear(ae.date) }) : j.createElement("span", null, A(ae.date, i)),
              j.createElement("span", { role: "status", "aria-live": "polite", style: {
                border: 0,
                clip: "rect(0 0 0 0)",
                height: "1px",
                margin: "-1px",
                overflow: "hidden",
                padding: 0,
                position: "absolute",
                width: "1px",
                whiteSpace: "nowrap",
                wordWrap: "normal"
              } }, k(ae.date, i.options, i))
            ) : j.createElement(n.CaptionLabel, { className: s[Ce.CaptionLabel], role: "status", "aria-live": "polite" }, k(ae.date, i.options, i))),
            f === "around" && !t.hideNavigation && ge === u - 1 && j.createElement(
              n.NextMonthButton,
              { type: "button", className: s[Ce.NextMonthButton], tabIndex: D ? void 0 : -1, "aria-disabled": D ? void 0 : !0, "aria-label": ue(D), onClick: rt, "data-animated-button": t.animate ? "true" : void 0 },
              j.createElement(n.Chevron, { disabled: D ? void 0 : !0, className: s[Ce.Chevron], orientation: t.dir === "rtl" ? "left" : "right" })
            ),
            ge === u - 1 && f === "after" && !t.hideNavigation && j.createElement(n.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: s[Ce.Nav], style: x == null ? void 0 : x[Ce.Nav], "aria-label": ee(), onPreviousClick: Pe, onNextClick: rt, previousMonth: q, nextMonth: D }),
            j.createElement(
              n.MonthGrid,
              { role: "grid", "aria-multiselectable": c === "multiple" || c === "range", "aria-label": E(ae.date, i.options, i) || void 0, className: s[Ce.MonthGrid], style: x == null ? void 0 : x[Ce.MonthGrid] },
              !t.hideWeekdays && j.createElement(
                n.Weekdays,
                { "data-animated-weekdays": t.animate ? "true" : void 0, className: s[Ce.Weekdays], style: x == null ? void 0 : x[Ce.Weekdays] },
                _ && j.createElement(n.WeekNumberHeader, { "aria-label": Ie(i.options), className: s[Ce.WeekNumberHeader], style: x == null ? void 0 : x[Ce.WeekNumberHeader], scope: "col" }, R()),
                He.map((Oe, de) => j.createElement(n.Weekday, { "aria-label": le(Oe, i.options, i), className: s[Ce.Weekday], key: de, style: x == null ? void 0 : x[Ce.Weekday], scope: "col" }, M(Oe, i.options, i)))
              ),
              j.createElement(n.Weeks, { "data-animated-weeks": t.animate ? "true" : void 0, className: s[Ce.Weeks], style: x == null ? void 0 : x[Ce.Weeks] }, ae.weeks.map((Oe, de) => j.createElement(
                n.Week,
                { className: s[Ce.Week], key: Oe.weekNumber, style: x == null ? void 0 : x[Ce.Week], week: Oe },
                _ && j.createElement(n.WeekNumber, { week: Oe, style: x == null ? void 0 : x[Ce.WeekNumber], "aria-label": Ae(Oe.weekNumber, {
                  locale: a
                }), className: s[Ce.WeekNumber], scope: "row", role: "rowheader" }, L(Oe.weekNumber, i)),
                Oe.days.map((xe) => {
                  const { date: Ee } = xe, me = U(xe);
                  if (me[kt.focused] = !me.hidden && !!(G != null && G.isEqualTo(xe)), me[Rn.selected] = (B == null ? void 0 : B(Ee)) || me.selected, e8(X)) {
                    const { from: Mt, to: se } = X;
                    me[Rn.range_start] = !!(Mt && se && i.isSameDay(Ee, Mt)), me[Rn.range_end] = !!(Mt && se && i.isSameDay(Ee, se)), me[Rn.range_middle] = mr(X, Ee, !0, i);
                  }
                  const Pt = lQ(me, x, t.modifiersStyles), qe = wX(me, s, t.modifiersClassNames), yt = !Me && !me.hidden ? z(Ee, me, i.options, i) : void 0;
                  return j.createElement(n.Day, { key: `${i.format(Ee, "yyyy-MM-dd")}_${i.format(xe.displayMonth, "yyyy-MM")}`, day: xe, modifiers: me, className: qe.join(" "), style: Pt, role: "gridcell", "aria-selected": me.selected || void 0, "aria-label": yt, "data-day": i.format(Ee, "yyyy-MM-dd"), "data-month": xe.outside ? i.format(Ee, "yyyy-MM") : void 0, "data-selected": me.selected || void 0, "data-disabled": me.disabled || void 0, "data-hidden": me.hidden || void 0, "data-outside": xe.outside || void 0, "data-focused": me.focused || void 0, "data-today": me.today || void 0 }, !me.hidden && Me ? j.createElement(n.DayButton, { className: s[Ce.DayButton], style: x == null ? void 0 : x[Ce.DayButton], type: "button", day: xe, modifiers: me, disabled: me.disabled || void 0, tabIndex: V(xe) ? 0 : -1, "aria-label": F(Ee, me, i.options, i), onClick: ft(xe, me), onBlur: ht(xe, me), onFocus: Xe(xe, me), onKeyDown: Ge(xe, me), onMouseEnter: Ve(xe, me), onMouseLeave: Be(xe, me) }, S(Ee, i.options, i)) : !me.hidden && S(xe.date, i.options, i));
                })
              )))
            )
          );
        })
      ),
      t.footer && j.createElement(n.Footer, { className: s[Ce.Footer], style: x == null ? void 0 : x[Ce.Footer], role: "status", "aria-live": "polite" }, t.footer)
    )
  );
}
function t8({
  className: e,
  showOutsideDays: t = !0,
  yearRange: n = 12,
  numberOfMonths: r,
  ...o
}) {
  const [i, a] = d.useState("days"), [s, l] = d.useState(
    d.useMemo(() => {
      const B = (/* @__PURE__ */ new Date()).getFullYear();
      return {
        from: B - Math.floor(n / 2 - 1),
        to: B + Math.ceil(n / 2)
      };
    }, [n])
  ), { onNextClick: c, onPrevClick: f, startMonth: u, endMonth: h } = o, m = i === "years" ? 1 : r, g = Q("relative flex", o.monthsClassName), p = Q(
    "relative mx-10 flex h-7 items-center justify-center",
    o.monthCaptionClassName
  ), v = Q("flex flex-row", o.weekdaysClassName), y = Q(
    "w-8 text-sm font-normal text-muted-foreground",
    o.weekdayClassName
  ), C = Q("w-full overflow-x-hidden", o.monthClassName), w = Q(
    "relative flex items-center justify-center pt-1",
    o.captionClassName
  ), _ = Q(
    "truncate text-sm font-medium",
    o.captionLabelClassName
  ), x = co({
    variant: "outline",
    className: "absolute h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100"
  }), k = Q(
    x,
    "right-0",
    o.buttonNextClassName
  ), S = Q(
    x,
    "left-0",
    o.buttonPreviousClassName
  ), T = Q("flex items-start", o.navClassName), L = Q("mx-auto mt-4", o.monthGridClassName), R = Q("mt-2 flex w-max items-start", o.weekClassName), M = Q(
    "size-8 flex flex-1 items-center justify-center p-0 text-sm",
    o.dayClassName
  ), A = Q(
    co({ variant: "ghost" }),
    "size-8 rounded-full p-0 font-normal transition-none aria-selected:opacity-100",
    o.dayButtonClassName
  ), O = "bg-accent [&>button]:bg-primary [&>button]:text-primary-foreground [&>button]:hover:bg-primary [&>button]:hover:text-primary-foreground", I = Q(
    O,
    "day-range-start rounded-s-full",
    o.rangeStartClassName
  ), W = Q(
    O,
    "day-range-end rounded-e-full",
    o.rangeEndClassName
  ), N = Q(
    "bg-accent !text-foreground [&>button]:bg-transparent [&>button]:!text-foreground [&>button]:hover:bg-transparent [&>button]:hover:!text-foreground",
    o.rangeMiddleClassName
  ), H = Q(
    "[&>button]:bg-primary [&>button]:text-primary-foreground [&>button]:hover:bg-primary [&>button]:hover:text-primary-foreground",
    o.selectedClassName
  ), q = Q(
    "[&>button]:bg-accent [&>button]:text-accent-foreground",
    o.todayClassName
  ), D = Q(
    "day-outside text-muted-foreground opacity-50 aria-selected:bg-accent/50 aria-selected:text-muted-foreground aria-selected:opacity-30",
    o.outsideClassName
  ), $ = Q(
    "text-muted-foreground opacity-50",
    o.disabledClassName
  ), U = Q("invisible hidden", o.hiddenClassName);
  return /* @__PURE__ */ b(
    VQ,
    {
      showOutsideDays: t,
      className: Q("p-3", e),
      style: {
        width: 248.8 * (m ?? 1) + "px"
      },
      classNames: {
        months: g,
        month_caption: p,
        weekdays: v,
        weekday: y,
        month: C,
        caption: w,
        caption_label: _,
        button_next: k,
        button_previous: S,
        nav: T,
        month_grid: L,
        week: R,
        day: M,
        day_button: A,
        range_start: I,
        range_middle: N,
        range_end: W,
        selected: H,
        today: q,
        outside: D,
        disabled: $,
        hidden: U
      },
      components: {
        Chevron: ({ orientation: B }) => /* @__PURE__ */ b(B === "left" ? T8 : P8, { className: "size-4" }),
        Nav: ({ className: B, ...K }) => {
          const { nextMonth: X, previousMonth: Z, goToMonth: G } = xo(), V = i === "years" ? u && Ar(
            new Date(s.from - 1, 0, 1),
            u
          ) < 0 || h && Ar(
            new Date(s.from - 1, 0, 1),
            h
          ) > 0 : !Z, Y = i === "years" ? u && Ar(
            new Date(s.to + 1, 0, 1),
            u
          ) < 0 || h && Ar(
            new Date(s.to + 1, 0, 1),
            h
          ) > 0 : !X, P = d.useCallback(() => {
            if (Z) {
              if (i === "years") {
                l((z) => ({
                  from: z.from - (z.to - z.from + 1),
                  to: z.to - (z.to - z.from + 1)
                })), f == null || f(
                  new Date(
                    s.from - (s.to - s.from),
                    0,
                    1
                  )
                );
                return;
              }
              G(Z), f == null || f(Z);
            }
          }, [Z, G]), F = d.useCallback(() => {
            if (X) {
              if (i === "years") {
                l((z) => ({
                  from: z.from + (z.to - z.from + 1),
                  to: z.to + (z.to - z.from + 1)
                })), c == null || c(
                  new Date(
                    s.from + (s.to - s.from),
                    0,
                    1
                  )
                );
                return;
              }
              G(X), c == null || c(X);
            }
          }, [G, X]);
          return /* @__PURE__ */ ie("nav", { className: Q("flex items-center", B), ...K, children: [
            /* @__PURE__ */ b(
              Or,
              {
                variant: "outline",
                className: "absolute left-0 size-7 bg-transparent p-0 opacity-80 hover:opacity-100",
                type: "button",
                tabIndex: V ? void 0 : -1,
                disabled: V,
                "aria-label": i === "years" ? `Go to the previous ${s.to - s.from + 1} years` : jS(),
                onClick: P,
                children: /* @__PURE__ */ b(T8, { className: "size-4" })
              }
            ),
            /* @__PURE__ */ b(
              Or,
              {
                variant: "outline",
                className: "absolute right-0 size-7 bg-transparent p-0 opacity-80 hover:opacity-100",
                type: "button",
                tabIndex: Y ? void 0 : -1,
                disabled: Y,
                "aria-label": i === "years" ? `Go to the next ${s.to - s.from + 1} years` : qS(),
                onClick: F,
                children: /* @__PURE__ */ b(P8, { className: "size-4" })
              }
            )
          ] });
        },
        CaptionLabel: ({ children: B }) => /* @__PURE__ */ b(
          Or,
          {
            className: "h-7 w-full truncate text-sm font-medium",
            variant: "ghost",
            size: "sm",
            onClick: () => a((K) => K === "days" ? "years" : "days"),
            children: i === "days" ? B : s.from + " - " + s.to
          }
        ),
        MonthGrid: ({ className: B, children: K, ...X }) => {
          const { goToMonth: Z } = xo();
          return i === "years" ? /* @__PURE__ */ b(
            "div",
            {
              className: Q("grid grid-cols-4 gap-y-2", B),
              ...X,
              children: Array.from(
                { length: s.to - s.from + 1 },
                (G, V) => {
                  const Y = Ar(
                    new Date(s.from + V, 11, 31),
                    u
                  ) < 0, P = Ar(
                    new Date(s.from + V, 0, 0),
                    h
                  ) > 0, F = Y || P;
                  return /* @__PURE__ */ b(
                    Or,
                    {
                      className: Q(
                        "h-7 w-full text-sm font-normal text-foreground",
                        s.from + V === (/* @__PURE__ */ new Date()).getFullYear() && "bg-accent font-medium text-accent-foreground"
                      ),
                      variant: "ghost",
                      onClick: () => {
                        a("days"), Z(
                          new Date(
                            s.from + V,
                            (/* @__PURE__ */ new Date()).getMonth()
                          )
                        );
                      },
                      disabled: i === "years" ? F : void 0,
                      children: s.from + V
                    },
                    V
                  );
                }
              )
            }
          ) : /* @__PURE__ */ b("table", { className: B, ...X, children: K });
        }
      },
      numberOfMonths: m,
      ...o
    }
  );
}
t8.displayName = "LBCalendar";
function UQ({
  placeholder: e,
  selected: t,
  className: n,
  ...r
}) {
  return /* @__PURE__ */ ie(J0, { children: [
    /* @__PURE__ */ b(el, { asChild: !0, children: /* @__PURE__ */ ie(
      Or,
      {
        variant: "outline",
        className: Q(
          "justify-start text-left font-normal rounded-md",
          !t && "text-muted-foreground",
          n
        ),
        children: [
          /* @__PURE__ */ b(Zv, {}),
          t ? ga(t, "PPP") : /* @__PURE__ */ b("span", { children: e })
        ]
      }
    ) }),
    /* @__PURE__ */ b(tl, { className: "w-auto p-0", children: /* @__PURE__ */ b(t8, { ...r, mode: "single", selected: t, autoFocus: !0 }) })
  ] });
}
UQ.displayName = "LBDatePicker";
function zQ({
  className: e,
  selected: t,
  placeholder: n,
  ...r
}) {
  return /* @__PURE__ */ b("div", { className: Q("grid gap-2", e), children: /* @__PURE__ */ ie(J0, { children: [
    /* @__PURE__ */ b(el, { asChild: !0, children: /* @__PURE__ */ ie(
      Or,
      {
        id: "date",
        variant: "outline",
        className: Q(
          "justify-start text-left font-normal rounded-md",
          !t && "text-muted-foreground",
          e
        ),
        children: [
          /* @__PURE__ */ b(Zv, {}),
          t != null && t.from ? t.to ? /* @__PURE__ */ ie(St, { children: [
            ga(t.from, "LLL dd, y"),
            " -",
            " ",
            ga(t.to, "LLL dd, y")
          ] }) : ga(t.from, "LLL dd, y") : /* @__PURE__ */ b("span", { children: n })
        ]
      }
    ) }),
    /* @__PURE__ */ b(tl, { className: "w-auto p-0", align: "start", children: /* @__PURE__ */ b(
      t8,
      {
        autoFocus: !0,
        defaultMonth: t == null ? void 0 : t.from,
        selected: t,
        numberOfMonths: 2,
        ...r,
        mode: "range"
      }
    ) })
  ] }) });
}
zQ.displayName = "LBDateRangePicker";
function YQ() {
  return /* @__PURE__ */ ie("div", { className: "flex size-full items-end  justify-between", children: [
    /* @__PURE__ */ b(hn, { className: "h-28 w-4" }),
    /* @__PURE__ */ b(hn, { className: "h-32 w-4" }),
    /* @__PURE__ */ b(hn, { className: "h-36 w-4" }),
    /* @__PURE__ */ b(hn, { className: "h-12 w-4" }),
    /* @__PURE__ */ b(hn, { className: "h-8 w-4" }),
    /* @__PURE__ */ b(hn, { className: "h-14 w-4" }),
    /* @__PURE__ */ b(hn, { className: "h-28 w-4" }),
    /* @__PURE__ */ b(hn, { className: "h-20 w-4" }),
    /* @__PURE__ */ b(hn, { className: "h-28 w-4" })
  ] });
}
YQ.displayName = "LBBarChartSkeleton";
const GQ = Dn("flex items-center rounded-full", {
  variants: {
    size: {
      default: "size-14",
      sm: "size-8",
      lg: "size-16"
    }
  },
  defaultVariants: {
    size: "default"
  }
});
function KQ({
  size: e,
  className: t,
  ...n
}) {
  return /* @__PURE__ */ b(
    hn,
    {
      className: Q(GQ({ size: e }), t),
      ...n
    }
  );
}
KQ.displayName = "LBCircleSkeleton";
const ZQ = Dn(
  "flex items-center rounded-full p-4",
  {
    variants: {
      size: {
        default: "size-36",
        sm: "size-20",
        lg: "size-52"
      }
    },
    defaultVariants: {
      size: "default"
    }
  }
);
function XQ({
  size: e,
  ...t
}) {
  return /* @__PURE__ */ b(
    hn,
    {
      className: Q(ZQ({ size: e })),
      ...t,
      children: /* @__PURE__ */ b("div", { className: "m-auto size-full rounded-full bg-background" })
    }
  );
}
XQ.displayName = "LBDoughnutChartSkeleton";
function Vee() {
  return /* @__PURE__ */ b("div", { className: "size-full animate-pulse", children: /* @__PURE__ */ ie(
    "svg",
    {
      width: "100%",
      height: "100%",
      viewBox: "0 0 512 142",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ b("g", { clipPath: "url(#clip0_23513_22363)", children: /* @__PURE__ */ b(
          "path",
          {
            d: "M0 37.2686C28.4856 81.292 75.1182 124.684 94.9919 124.684C122.153 124.684 156.583 24.6907 192.304 24.6904C232.879 24.6901 231.974 96.817 304.88 96.817C326.522 96.817 329.735 117.307 352.932 123.045C381.219 130.041 384.372 126.323 410.097 126.323C430.744 126.323 493.451 64.9963 512 41.0828",
            stroke: "#181818",
            strokeOpacity: "0.03",
            strokeWidth: "8",
            strokeLinecap: "round"
          }
        ) }),
        /* @__PURE__ */ b("defs", { children: /* @__PURE__ */ b("clipPath", { id: "clip0_23513_22363", children: /* @__PURE__ */ b("rect", { width: "512", height: "142", fill: "white" }) }) })
      ]
    }
  ) });
}
function QQ({
  className: e
}) {
  return /* @__PURE__ */ b(hn, { className: Q("h-4 w-full", e) });
}
QQ.displayName = "LBProgressBarChartSkeleton";
const JQ = fe(({ children: e, variant: t, ...n }, r) => /* @__PURE__ */ ie(
  Gv,
  {
    ref: r,
    ...n,
    className: "relative flex cursor-default select-none items-center py-1 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-secondary focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
    style: void 0,
    children: [
      /* @__PURE__ */ b("span", { className: "absolute left-2 flex size-3 items-center justify-center", children: /* @__PURE__ */ b(Y9, { children: /* @__PURE__ */ b(G9, { className: "size-2 fill-current" }) }) }),
      /* @__PURE__ */ b(Qy, { variant: t, children: e })
    ]
  }
));
JQ.displayName = "LBJiraStatusPickerItem";
function eJ({
  value: e,
  label: t,
  variant: n,
  onValueChange: r,
  children: o
}) {
  return /* @__PURE__ */ ie(Qv, { children: [
    /* @__PURE__ */ ie(
      Jv,
      {
        className: Q(
          fh({ variant: n }),
          "group transition-all duration-300 hover:brightness-95"
        ),
        children: [
          t,
          /* @__PURE__ */ b(V0, { className: "duration-300 group-data-[state=open]:-rotate-180" })
        ]
      }
    ),
    /* @__PURE__ */ b(tb, { align: "start", children: /* @__PURE__ */ b(eb, { value: e, onValueChange: r, children: o }) })
  ] });
}
eJ.displayName = "LBJiraStatusPicker";
const tJ = fe(({ className: e, children: t, variant: n, ...r }, o) => /* @__PURE__ */ ie(
  Z9,
  {
    ref: o,
    className: Q(
      fh({ variant: n }),
      "relative hover:brightness-95 transition-all",
      e
    ),
    ...r,
    children: [
      /* @__PURE__ */ b(X9, { className: "absolute inset-x-0 -bottom-2 h-1 bg-slate-600" }),
      t
    ]
  }
));
tJ.displayName = "LBJiraStatusCheckbox";
function nJ(e) {
  return /* @__PURE__ */ b(
    "div",
    {
      className: "flex h-20 flex-col justify-center space-y-2 bg-white px-6 text-center sm:text-left",
      ...e
    }
  );
}
nJ.displayName = "LBWizardHeader";
const rJ = fe(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ ie(ih, { children: [
  /* @__PURE__ */ b(sh, {}),
  /* @__PURE__ */ ie(
    Si,
    {
      ref: r,
      ...n,
      className: Q(
        "justify-stretch flex flex-col bg-slate-100 fixed left-1/2 top-1/2 z-50 min-w-[797px] -translate-x-1/2 -translate-y-1/2 border shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]",
        e
      ),
      style: void 0,
      children: [
        t,
        /* @__PURE__ */ ie(ah, { className: "absolute right-8 top-9 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground", children: [
          /* @__PURE__ */ b(ts, { className: "size-3" }),
          /* @__PURE__ */ b("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
rJ.displayName = "LBWizard";
const oJ = fe((e, t) => /* @__PURE__ */ b(
  il,
  {
    ref: t,
    ...e,
    className: "text-xl font-medium leading-5 tracking-tight",
    style: void 0
  }
));
oJ.displayName = "LBWizardTitle";
function iJ({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ b(
    "div",
    {
      ...t,
      className: Q(
        "size-full p-2 flex flex-row gap-4 justify-stretch",
        e
      ),
      style: void 0
    }
  );
}
iJ.displayName = "LBWizardContent";
function aJ({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ b(
    "aside",
    {
      ...t,
      className: Q("grow-0 p-4", e),
      style: void 0
    }
  );
}
aJ.displayName = "LBWizardSidebar";
function sJ({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ b(
    "main",
    {
      ...t,
      className: Q(
        "p-6 grow-1 bg-white rounded-md border w-full min-h-[560px] overflow-auto",
        e
      ),
      style: void 0
    }
  );
}
sJ.displayName = "LBWizardMain";
function Uee({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ b(
    Pk,
    {
      ...t,
      className: e,
      groupMode: "stacked",
      layout: "horizontal",
      enableGridY: !1,
      axisTop: null,
      axisRight: null,
      axisBottom: null,
      axisLeft: null
    }
  );
}
function lJ(e) {
  var y;
  const {
    open: t,
    value: n,
    onChange: r,
    placeholder: o,
    options: i,
    className: a,
    searchPlaceholder: s,
    disabled: l,
    emptyMessage: c,
    popoverClassname: f,
    onSearch: u,
    isLoading: h,
    loadingMessage: m
  } = e, [g, p] = Yt(t);
  function v(C) {
    C.key === "ArrowDown" && !g && (C.preventDefault(), p(!0));
  }
  return dn(() => {
    p(t);
  }, [t]), dn(() => {
    i.find((C) => C.value === n) || r == null || r(void 0);
  }, [i]), /* @__PURE__ */ ie(J0, { open: g, onOpenChange: p, children: [
    /* @__PURE__ */ ie(
      el,
      {
        disabled: l,
        onKeyDown: v,
        className: Q(
          "flex h-9 items-center justify-between whitespace-nowrap rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1",
          a
        ),
        role: "combobox",
        children: [
          n ? (y = i.find((C) => C.value === n)) == null ? void 0 : y.label : /* @__PURE__ */ b("span", { className: "text-muted-foreground", children: o }),
          /* @__PURE__ */ b(UP, { className: "opacity-50" })
        ]
      }
    ),
    /* @__PURE__ */ b(
      tl,
      {
        className: Q("p-0", f),
        align: "start",
        role: "listbox",
        children: /* @__PURE__ */ ie(
          ch,
          {
            onChange: (C) => {
              u == null || u(C.target.value);
            },
            children: [
              /* @__PURE__ */ b($y, { placeholder: s, className: "h-9" }),
              /* @__PURE__ */ b(Fy, { children: h ? /* @__PURE__ */ b(Hy, { children: m }) : /* @__PURE__ */ ie(St, { children: [
                /* @__PURE__ */ b(Wy, { children: c }),
                /* @__PURE__ */ b(qy, { children: i.map((C) => /* @__PURE__ */ ie(
                  jy,
                  {
                    className: "py-2",
                    value: C.label,
                    onSelect: () => {
                      r == null || r(C.value === n ? "" : C.value), p(!1);
                    },
                    children: [
                      C.label,
                      /* @__PURE__ */ b(
                        U0,
                        {
                          className: Q(
                            "ml-auto",
                            n === C.value ? "opacity-100" : "opacity-0"
                          )
                        }
                      )
                    ]
                  },
                  C.value
                )) })
              ] }) })
            ]
          }
        )
      }
    )
  ] });
}
lJ.displayName = "LBCombobox";
const Jp = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 13 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { opacity: 0.7, fillRule: "evenodd", clipRule: "evenodd", d: "M0.5 23.9898C0.66582 23.9966 0.832509 24 0.999999 24C7.62742 24 13 18.6274 13 12C13 5.37258 7.62742 0 0.999999 0C0.832509 0 0.66582 0.0034314 0.5 0.0102277C6.89554 0.272356 12 5.54007 12 12C12 18.4599 6.89554 23.7276 0.5 23.9898Z", fill: "currentColor" })), cJ = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 11 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M6.29248 0.493669C6.21974 0.345539 6.1069 0.220768 5.96683 0.13351C5.82677 0.0462528 5.66504 0 5.49999 0C5.33495 0 5.17322 0.0462528 5.03315 0.13351C4.89309 0.220768 4.78025 0.345539 4.70751 0.493669L0.0762716 9.92834C0.0205237 10.0418 -0.00540404 10.1675 0.000936839 10.2937C0.00727772 10.4199 0.0456779 10.5424 0.112511 10.6497C0.179344 10.7569 0.272409 10.8454 0.382917 10.9067C0.493421 10.968 0.617725 11.0001 0.744093 11H10.2559C10.3823 11.0001 10.5066 10.968 10.6171 10.9067C10.7276 10.8454 10.8207 10.7569 10.8875 10.6497C10.9543 10.5424 10.9927 10.4199 10.9991 10.2937C11.0054 10.1675 10.9795 10.0418 10.9237 9.92834L6.29248 0.493669Z", fill: "#F59E0B" }), /* @__PURE__ */ d.createElement("path", { d: "M5.5 7.5V3", stroke: "white", strokeMiterlimit: 10, strokeLinecap: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M5 9.5C5 9.26746 5.22386 9 5.5 9C5.77614 9 6 9.26746 6 9.5C6 9.73254 5.77614 10 5.5 10C5.22386 10 5 9.73254 5 9.5Z", fill: "white" })), uJ = fe(
  ({
    avatarUrl: e,
    className: t,
    initials: n,
    disabled: r,
    github: o,
    warning: i,
    group: a,
    color: s,
    hideRipples: l,
    ...c
  }, f) => /* @__PURE__ */ ie(
    "div",
    {
      ref: f,
      className: Q("relative inline-block size-fit [&_svg.ripple]:h-6", {
        "grayscale opacity-50": r
      }),
      style: { "--lb-portrait-color": s },
      children: [
        /* @__PURE__ */ ie(
          iC,
          {
            className: Q(
              "size-6 text-white bg-[var(--lb-portrait-color)]",
              {
                "border border-[var(--lb-portrait-color)] bg-white text-[var(--lb-portrait-color)]": a,
                "border-slate-600 text-slate-600": !s && a
              },
              t
            ),
            ...c,
            children: [
              /* @__PURE__ */ b(
                aC,
                {
                  src: e,
                  className: Q({ "grayscale opacity-75": r })
                }
              ),
              /* @__PURE__ */ b(sC, { className: "bg-inherit text-[8px] font-semibold text-inherit", children: n })
            ]
          }
        ),
        a && !l && /* @__PURE__ */ ie(St, { children: [
          /* @__PURE__ */ b(
            Jp,
            {
              className: Q(
                "ripple absolute -right-0.75 top-0 text-[var(--lb-portrait-color)] opacity-75",
                { "text-slate-600": !s }
              )
            }
          ),
          /* @__PURE__ */ b(
            Jp,
            {
              className: Q(
                "ripple absolute right-[-4.5px] top-0 text-[var(--lb-portrait-color)] opacity-40",
                { "text-slate-600": !s }
              )
            }
          )
        ] }),
        o && /* @__PURE__ */ b(fJ, { className: "absolute bottom-[-2px] right-[-2px] size-[10px] rounded-full bg-white ring-white" }),
        i && /* @__PURE__ */ b(cJ, { className: "absolute bottom-[-2px] right-[-2px] size-[11px]" })
      ]
    }
  )
);
uJ.displayName = "LBPortrait";
const dJ = [
  "#3B48B3",
  "#5467FF",
  "#8795FF",
  "#B36A00",
  "#FF9800",
  "#FFB74C",
  "#0276AB",
  "#03A9F4",
  "#4FC3F7",
  "#B30000",
  "#F61C3B",
  "#F96076",
  "#008114",
  "#00B81D",
  "#4CCD61",
  "#6A6538",
  "#979050",
  "#B6B184",
  "#798B0D",
  "#ADC613",
  "#C6D75A",
  "#669BB2",
  "#5BCEFF",
  "#8CDDFF",
  "#786AB2",
  "#AC98FF",
  "#C5B7FF",
  "#8B11A9",
  "#C618F1",
  "#D75DF5",
  "#A9687F",
  "#F294B6",
  "#F6B4CC",
  "#B25132",
  "#FF7448",
  "#FF9E7F"
];
function eg({
  color: e = "transparent",
  ...t
}) {
  return /* @__PURE__ */ b(
    "div",
    {
      className: "size-6 cursor-pointer rounded-full bg-[var(--lb-swatch-color)]",
      style: { "--lb-swatch-color": e },
      ...t
    }
  );
}
const VS = fe(({ children: e, position: t = "popper", flex: n, ...r }, o) => /* @__PURE__ */ b(Vb, { children: /* @__PURE__ */ b(
  Ub,
  {
    ref: o,
    position: t,
    className: "relative z-50 mt-1 w-fit rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
    ...r,
    children: /* @__PURE__ */ b(
      zb,
      {
        className: Q("grid grid-cols-12 gap-2 p-2", { flex: n }),
        children: e
      }
    )
  }
) }));
VS.displayName = "LBColorPickerContent";
const US = fe(({ children: e, ...t }, n) => /* @__PURE__ */ b(
  Yb,
  {
    className: 'rounded-full data-[state="checked"]:ring-1 data-[state="checked"]:ring-ring',
    ref: n,
    ...t,
    children: /* @__PURE__ */ b(Gb, { children: e })
  }
));
US.displayName = "LBColorPickerItem";
function zee({
  value: e,
  onValueChange: t,
  className: n,
  palette: r = dJ
}) {
  return /* @__PURE__ */ ie(Kb, { value: e, onValueChange: t, children: [
    /* @__PURE__ */ b(Xb, { className: n, children: /* @__PURE__ */ ie(Zb, { children: [
      /* @__PURE__ */ b("span", { className: "sr-only", children: e }),
      /* @__PURE__ */ b(eg, { color: e })
    ] }) }),
    /* @__PURE__ */ b(VS, { align: "start", flex: r.length < 12, children: r.map((o) => /* @__PURE__ */ ie(US, { value: o, children: [
      /* @__PURE__ */ b(eg, { color: o }),
      /* @__PURE__ */ b("span", { className: "sr-only", children: o })
    ] }, o)) })
  ] });
}
const Yee = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17830_6798)" }, /* @__PURE__ */ d.createElement("path", { d: "M8.04677 1.59712C7.95965 1.68418 7.89054 1.78756 7.84339 1.90134C7.79624 2.01512 7.77197 2.13708 7.77197 2.26024C7.77197 2.38341 7.79624 2.50537 7.84339 2.61915C7.89054 2.73293 7.95965 2.83631 8.04677 2.92337L13.4311 8.30774C13.5184 8.39479 13.6218 8.4638 13.7357 8.51084C13.8496 8.55789 13.9716 8.58204 14.0948 8.58192C14.2181 8.58181 14.34 8.55743 14.4538 8.51017C14.5676 8.46291 14.671 8.3937 14.758 8.3065C14.8451 8.21929 14.9141 8.11579 14.9611 8.00192C15.0082 7.88804 15.0323 7.76601 15.0322 7.6428C15.0321 7.51959 15.0077 7.3976 14.9604 7.28382C14.9132 7.17003 14.844 7.06666 14.7568 6.97962L9.3749 1.59712C9.2878 1.50972 9.18431 1.44037 9.07035 1.39306C8.9564 1.34574 8.83422 1.32138 8.71083 1.32138C8.58745 1.32138 8.46527 1.34574 8.35132 1.39306C8.23736 1.44037 8.13387 1.50972 8.04677 1.59712Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M1.24334 8.40086C1.41915 8.22511 1.65756 8.12637 1.90615 8.12637C2.15474 8.12637 2.39316 8.22511 2.56896 8.40086L7.95334 13.7852C8.04042 13.8724 8.10947 13.9759 8.15656 14.0898C8.20364 14.2037 8.22783 14.3258 8.22774 14.449C8.22765 14.5723 8.20329 14.6943 8.15605 14.8081C8.10881 14.9219 8.03961 15.0253 7.9524 15.1124C7.86519 15.1995 7.76169 15.2686 7.6478 15.3156C7.5339 15.3627 7.41185 15.3869 7.28861 15.3868C7.16537 15.3867 7.04336 15.3624 6.92953 15.3151C6.8157 15.2679 6.7123 15.1987 6.62521 15.1115L1.24334 9.72961C1.15584 9.6425 1.08642 9.53897 1.03904 9.42496C0.991672 9.31094 0.967285 9.1887 0.967285 9.06524C0.967285 8.94177 0.991672 8.81953 1.03904 8.70551C1.08642 8.5915 1.15584 8.48797 1.24334 8.40086Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M4.59766 10.4304L10.0755 4.95255L11.4013 6.27837L5.92348 11.7562L4.59766 10.4304Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M2.69953 13.6542C2.33342 13.2881 2.33342 12.6945 2.69953 12.3284L3.27185 11.7561L4.59767 13.0819L4.02536 13.6542C3.65924 14.0203 3.06565 14.0203 2.69953 13.6542V13.6542Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M11.4023 3.62582L11.9747 3.05351C12.3408 2.68739 12.9344 2.68739 13.3005 3.05351V3.05351C13.6666 3.41962 13.6666 4.01322 13.3005 4.37933L12.7282 4.95165L11.4023 3.62582Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17830_6798" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), Gee = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17378_25)" }, /* @__PURE__ */ d.createElement("path", { d: "M22.1888 9.31512L12 1.62762L1.80192 9.31512C1.5911 9.50967 1.46433 9.77868 1.44849 10.0651V21.8045C1.44923 22.0474 1.54607 22.2802 1.71785 22.452C1.88964 22.6238 2.12242 22.7206 2.36536 22.7214H8.47974V17.8023C8.47974 16.8699 8.85013 15.9757 9.50944 15.3164C10.1687 14.6571 11.063 14.2867 11.9954 14.2867C12.9278 14.2867 13.822 14.6571 14.4813 15.3164C15.1406 15.9757 15.511 16.8699 15.511 17.8023V22.7242H21.6244C21.8675 22.7234 22.1003 22.6266 22.2723 22.4549C22.4442 22.2831 22.5412 22.0503 22.5422 21.8073V10.0651C22.526 9.77878 22.3993 9.50991 22.1888 9.31512Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17378_25" }, /* @__PURE__ */ d.createElement("rect", { width: 24, height: 24, fill: "white", transform: "translate(0 0.177307)" })))), Kee = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17821_3437)" }, /* @__PURE__ */ d.createElement("path", { d: "M21.7868 4.58356L18.6771 7.69231H16.4852V5.50044L19.5939 2.39075C18.6334 1.8661 17.536 1.64614 16.4475 1.76009C15.359 1.87404 14.3309 2.31651 13.4999 3.0287C12.6688 3.7409 12.0742 4.68911 11.7949 5.74734C11.5156 6.80558 11.565 7.92374 11.9364 8.95325L2.23981 18.6461C1.80332 19.0825 1.55811 19.6746 1.55811 20.2918C1.55811 20.9091 1.80332 21.5011 2.23981 21.9376C2.6763 22.3741 3.26831 22.6193 3.8856 22.6193C4.50289 22.6193 5.0949 22.3741 5.53139 21.9376L15.2252 12.2401C16.2547 12.6115 17.3728 12.6609 18.4311 12.3816C19.4893 12.1024 20.4375 11.5077 21.1497 10.6767C21.8619 9.84565 22.3044 8.81758 22.4184 7.72907C22.5323 6.64055 22.3114 5.54407 21.7868 4.58356Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17821_3437" }, /* @__PURE__ */ d.createElement("rect", { width: 24, height: 24, fill: "white", transform: "translate(0 0.177307)" })))), Zee = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17378_34)" }, /* @__PURE__ */ d.createElement("path", { d: "M22.5469 1.63043L1.45312 22.7242", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M22.5469 7.95856V1.63043H16.2188", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M2.85938 7.25824C2.85938 8.00416 3.15569 8.71953 3.68314 9.24698C4.21058 9.77442 4.92595 10.0707 5.67188 10.0707C6.4178 10.0707 7.13317 9.77442 7.66061 9.24698C8.18806 8.71953 8.48438 8.00416 8.48438 7.25824C8.48438 6.51232 8.18806 5.79695 7.66061 5.2695C7.13317 4.74206 6.4178 4.44574 5.67188 4.44574C4.92595 4.44574 4.21058 4.74206 3.68314 5.2695C3.15569 5.79695 2.85938 6.51232 2.85938 7.25824Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M14.1094 18.5082C14.1094 19.2542 14.4057 19.9695 14.9331 20.497C15.4606 21.0244 16.176 21.3207 16.9219 21.3207C17.6678 21.3207 18.3832 21.0244 18.9106 20.497C19.4381 19.9695 19.7344 19.2542 19.7344 18.5082C19.7344 17.7623 19.4381 17.0469 18.9106 16.5195C18.3832 15.9921 17.6678 15.6957 16.9219 15.6957C16.176 15.6957 15.4606 15.9921 14.9331 16.5195C14.4057 17.0469 14.1094 17.7623 14.1094 18.5082Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17378_34" }, /* @__PURE__ */ d.createElement("rect", { width: 24, height: 24, fill: "white", transform: "translate(0 0.177307)" })))), Xee = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M9.42188 14.9898C10.9752 14.9898 12.2344 13.7307 12.2344 12.1773C12.2344 10.624 10.9752 9.36481 9.42188 9.36481C7.86858 9.36481 6.60938 10.624 6.60938 12.1773C6.60938 13.7307 7.86858 14.9898 9.42188 14.9898Z", stroke: "currentColor", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M6.60938 12.1773H1.45312", stroke: "currentColor", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M10.8691 9.66944C10.5762 9.96234 10.5762 10.4372 10.8691 10.7301C11.162 11.023 11.6369 11.023 11.9297 10.7301L10.8691 9.66944ZM11.9297 10.7301L20.2647 2.39514L19.204 1.33448L10.8691 9.66944L11.9297 10.7301Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M16.4531 1.86481H19.7344V4.67731", stroke: "currentColor", strokeWidth: 1.3, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M12.2344 11.4273C11.8202 11.4273 11.4844 11.7631 11.4844 12.1773C11.4844 12.5915 11.8202 12.9273 12.2344 12.9273V11.4273ZM12.2344 12.9273H22.5469V11.4273H12.2344V12.9273Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M20.2031 9.83356L22.5469 12.1773L20.2031 14.5211", stroke: "currentColor", strokeWidth: 1.3, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M11.9297 13.6245C11.6369 13.3317 11.162 13.3317 10.8691 13.6245C10.5762 13.9174 10.5762 14.3923 10.8691 14.6852L11.9297 13.6245ZM10.8691 14.6852L19.204 23.0201L20.2647 21.9595L11.9297 13.6245L10.8691 14.6852Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M16.4531 22.4898H19.7344V19.6773", stroke: "currentColor", strokeWidth: 1.3, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" })), Qee = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M3.91406 8.31012C3.91406 9.33576 4.3215 10.3194 5.04674 11.0446C5.77197 11.7699 6.75561 12.1773 7.78125 12.1773C8.80689 12.1773 9.79053 11.7699 10.5158 11.0446C11.241 10.3194 11.6484 9.33576 11.6484 8.31012C11.6484 7.28448 11.241 6.30084 10.5158 5.57561C9.79053 4.85037 8.80689 4.44293 7.78125 4.44293C6.75561 4.44293 5.77197 4.85037 5.04674 5.57561C4.3215 6.30084 3.91406 7.28448 3.91406 8.31012Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M1.45312 19.9117C1.45313 18.2334 2.11984 16.6238 3.30659 15.437C4.49334 14.2503 6.10293 13.5836 7.78125 13.5836C9.45957 13.5836 11.0692 14.2503 12.2559 15.437C13.4427 16.6238 14.1094 18.2334 14.1094 19.9117", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M14.1101 5.06732C14.6941 4.6879 15.3696 4.4732 16.0654 4.44588C16.7613 4.41856 17.4516 4.57964 18.0635 4.91211C18.6753 5.24458 19.1861 5.7361 19.5418 6.33478C19.8975 6.93346 20.0849 7.61707 20.0843 8.31345C20.0837 9.00982 19.8951 9.69311 19.5384 10.2912C19.1816 10.8892 18.67 11.3799 18.0576 11.7113C17.4451 12.0427 16.7545 12.2026 16.0587 12.174C15.3629 12.1455 14.6878 11.9296 14.1045 11.5492", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M14.8125 13.7401C15.7393 13.5302 16.7014 13.5314 17.6276 13.7437C18.5539 13.956 19.4204 14.374 20.1632 14.9667C20.906 15.5594 21.5059 16.3116 21.9185 17.1676C22.3311 18.0236 22.5459 18.9614 22.5469 19.9117", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), Jee = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17378_89)" }, /* @__PURE__ */ d.createElement("path", { d: "M9.1875 9.36485C9.1876 8.84925 9.32943 8.3436 9.59749 7.90317C9.86555 7.46273 10.2495 7.10445 10.7075 6.86749C11.1653 6.63054 11.6797 6.52402 12.194 6.55959C12.7084 6.59515 13.2031 6.77143 13.624 7.06915C14.045 7.36687 14.376 7.77458 14.5808 8.24772C14.7858 8.72085 14.8567 9.24121 14.7858 9.75192C14.7149 10.2626 14.5051 10.7441 14.1791 11.1435C13.8532 11.543 13.4236 11.8452 12.9375 12.017C12.6632 12.114 12.4257 12.2937 12.2578 12.5312C12.0899 12.7689 11.9998 13.0527 12 13.3436V14.2867", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M12 17.8023C11.8058 17.8023 11.6484 17.6449 11.6484 17.4507C11.6484 17.2566 11.8058 17.0992 12 17.0992", stroke: "currentColor", strokeWidth: 1.3 }), /* @__PURE__ */ d.createElement("path", { d: "M12 17.8023C12.1942 17.8023 12.3516 17.6449 12.3516 17.4507C12.3516 17.2566 12.1942 17.0992 12 17.0992", stroke: "currentColor", strokeWidth: 1.3 }), /* @__PURE__ */ d.createElement("path", { d: "M12 22.7242C17.8249 22.7242 22.5469 18.0022 22.5469 12.1773C22.5469 6.35243 17.8249 1.63043 12 1.63043C6.17513 1.63043 1.45312 6.35243 1.45312 12.1773C1.45312 18.0022 6.17513 22.7242 12 22.7242Z", stroke: "currentColor", strokeWidth: 1.3, strokeMiterlimit: 10 })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17378_89" }, /* @__PURE__ */ d.createElement("rect", { width: 24, height: 24, fill: "white", transform: "translate(0 0.177307)" })))), ete = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M0.778883 1.00007C0.551723 0.997078 0.334883 1.09665 0.186546 1.27205C0.0382088 1.44747 -0.0264454 1.68077 0.00992316 1.90938L3.27417 22.1102C3.35813 22.6205 3.78937 22.9957 4.2969 22.9999H19.9569C20.3378 23.0049 20.6649 22.7248 20.7258 22.3415L23.9901 1.91329C24.0265 1.68469 23.9618 1.45139 23.8135 1.27597C23.6651 1.10056 23.4483 1.001 23.2211 1.00398L0.778883 1.00007ZM14.5241 15.6001H9.52585L8.17251 8.39217H15.7353L14.5241 15.6001Z", fill: "#2684FF" }), /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23 9H15.9057L14.7151 15.9079H9.8017L4 22.752C4.18388 22.91 4.41833 22.9979 4.66142 22.9999H20.0594C20.434 23.0047 20.7555 22.7363 20.8154 22.3689L23 9Z", fill: "url(#paint0_linear_17893_199583)" }), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("linearGradient", { id: "paint0_linear_17893_199583", x1: 24.6403, y1: 10.9345, x2: 16.5126, y2: 22.5462, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ d.createElement("stop", { offset: 0.18, stopColor: "#0052CC" }), /* @__PURE__ */ d.createElement("stop", { offset: 1, stopColor: "#2684FF" })))), tte = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_43_616)" }, /* @__PURE__ */ d.createElement("path", { d: "M5.14016 15.1181C5.14016 16.4976 4.0252 17.6126 2.64567 17.6126C1.26614 17.6126 0.151184 16.4976 0.151184 15.1181C0.151184 13.7386 1.26614 12.6236 2.64567 12.6236H5.14016V15.1181ZM6.3874 15.1181C6.3874 13.7386 7.50237 12.6236 8.88189 12.6236C10.2614 12.6236 11.3764 13.7386 11.3764 15.1181V21.3543C11.3764 22.7339 10.2614 23.8488 8.88189 23.8488C7.50237 23.8488 6.3874 22.7339 6.3874 21.3543V15.1181Z", fill: "#E01E5A" }), /* @__PURE__ */ d.createElement("path", { d: "M8.8819 5.10236C7.50237 5.10236 6.38741 3.9874 6.38741 2.60788C6.38741 1.22835 7.50237 0.113388 8.8819 0.113388C10.2614 0.113388 11.3764 1.22835 11.3764 2.60788V5.10236H8.8819ZM8.8819 6.36851C10.2614 6.36851 11.3764 7.48347 11.3764 8.863C11.3764 10.2425 10.2614 11.3575 8.8819 11.3575H2.62678C1.24725 11.3575 0.132294 10.2425 0.132294 8.863C0.132294 7.48347 1.24725 6.36851 2.62678 6.36851H8.8819Z", fill: "#36C5F0" }), /* @__PURE__ */ d.createElement("path", { d: "M18.8787 8.863C18.8787 7.48347 19.9937 6.36851 21.3732 6.36851C22.7528 6.36851 23.8677 7.48347 23.8677 8.863C23.8677 10.2425 22.7528 11.3575 21.3732 11.3575H18.8787V8.863ZM17.6315 8.863C17.6315 10.2425 16.5165 11.3575 15.137 11.3575C13.7575 11.3575 12.6425 10.2425 12.6425 8.863V2.60788C12.6425 1.22835 13.7575 0.113388 15.137 0.113388C16.5165 0.113388 17.6315 1.22835 17.6315 2.60788V8.863Z", fill: "#2EB67D" }), /* @__PURE__ */ d.createElement("path", { d: "M15.137 18.8598C16.5165 18.8598 17.6315 19.9748 17.6315 21.3543C17.6315 22.7339 16.5165 23.8488 15.137 23.8488C13.7575 23.8488 12.6425 22.7339 12.6425 21.3543V18.8598H15.137ZM15.137 17.6126C13.7575 17.6126 12.6425 16.4976 12.6425 15.1181C12.6425 13.7386 13.7575 12.6236 15.137 12.6236H21.3921C22.7717 12.6236 23.8866 13.7386 23.8866 15.1181C23.8866 16.4976 22.7717 17.6126 21.3921 17.6126H15.137Z", fill: "#ECB22E" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_43_616" }, /* @__PURE__ */ d.createElement("rect", { width: 24, height: 24, fill: "white" })))), nte = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M22.9974 0H11.4402C11.4402 1.38366 11.9898 2.71065 12.9682 3.68905C13.9466 4.66744 15.2736 5.2171 16.6573 5.2171H18.7862V7.27253C18.7881 10.1512 21.1213 12.4844 24 12.4863V1.00265C24 0.4489 23.5511 0 22.9974 0Z", fill: "#2684FF" }), /* @__PURE__ */ d.createElement("path", { d: "M17.2789 5.75853H5.72177C5.72361 8.63725 8.05681 10.9704 10.9355 10.9723H13.0645V13.0344C13.0682 15.9131 15.4029 18.2448 18.2816 18.2448V6.76118C18.2816 6.20743 17.8327 5.75853 17.2789 5.75853Z", fill: "url(#paint0_linear_18118_199873)" }), /* @__PURE__ */ d.createElement("path", { d: "M11.5572 11.5137H0C0 14.395 2.33578 16.7308 5.2171 16.7308H7.35274V18.7862C7.35457 21.6623 9.68371 23.9945 12.5598 24V12.5164C12.5598 11.9626 12.1109 11.5137 11.5572 11.5137Z", fill: "url(#paint1_linear_18118_199873)" }), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("linearGradient", { id: "paint0_linear_18118_199873", x1: 1236.97, y1: 7.76388, x2: 748.332, y2: 517.636, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ d.createElement("stop", { offset: 0.18, stopColor: "#0052CC" }), /* @__PURE__ */ d.createElement("stop", { offset: 1, stopColor: "#2684FF" })), /* @__PURE__ */ d.createElement("linearGradient", { id: "paint1_linear_18118_199873", x1: 1264.34, y1: 17.1953, x2: 699.101, y2: 573.305, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ d.createElement("stop", { offset: 0.18, stopColor: "#0052CC" }), /* @__PURE__ */ d.createElement("stop", { offset: 1, stopColor: "#2684FF" })))), fJ = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_43_449)" }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.0099 0C5.36875 0 0 5.40833 0 12.0992C0 17.4475 3.43994 21.9748 8.21205 23.5771C8.80869 23.6976 9.02724 23.3168 9.02724 22.9965C9.02724 22.716 9.00757 21.7545 9.00757 20.7527C5.6667 21.474 4.97099 19.3104 4.97099 19.3104C4.43409 17.9082 3.63858 17.5478 3.63858 17.5478C2.54511 16.8066 3.71823 16.8066 3.71823 16.8066C4.93117 16.8868 5.56763 18.0486 5.56763 18.0486C6.64118 19.8913 8.37111 19.3707 9.06706 19.0501C9.16638 18.2688 9.48473 17.728 9.82275 17.4276C7.15817 17.1471 4.35469 16.1055 4.35469 11.458C4.35469 10.1359 4.8316 9.05428 5.58729 8.21304C5.46807 7.91263 5.0504 6.67043 5.70677 5.00787C5.70677 5.00787 6.72083 4.6873 9.00732 6.24981C9.98625 5.98497 10.9958 5.85024 12.0099 5.84911C13.024 5.84911 14.0577 5.98948 15.0123 6.24981C17.299 4.6873 18.3131 5.00787 18.3131 5.00787C18.9695 6.67043 18.5515 7.91263 18.4323 8.21304C19.2079 9.05428 19.6652 10.1359 19.6652 11.458C19.6652 16.1055 16.8617 17.1269 14.1772 17.4276C14.6148 17.8081 14.9924 18.5292 14.9924 19.6711C14.9924 21.2936 14.9727 22.5957 14.9727 22.9962C14.9727 23.3168 15.1915 23.6976 15.7879 23.5774C20.56 21.9745 23.9999 17.4475 23.9999 12.0992C24.0196 5.40833 18.6312 0 12.0099 0Z", fill: "#24292F" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_43_449" }, /* @__PURE__ */ d.createElement("rect", { width: 24, height: 24, fill: "white" })))), rte = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17893_199590)" }, /* @__PURE__ */ d.createElement("path", { d: "M23.8689 12.8259L22.523 8.81649L19.8621 0.862476C19.8306 0.772415 19.7714 0.694418 19.693 0.639433C19.6146 0.584448 19.5208 0.555236 19.4249 0.555897C19.3292 0.555592 19.2358 0.58497 19.1577 0.63993C19.0797 0.69489 19.0208 0.772691 18.9894 0.862476L16.3285 8.81138H7.49024L4.82934 0.860772C4.79785 0.771166 4.73893 0.69359 4.66084 0.638918C4.58275 0.584245 4.48939 0.555216 4.39385 0.555897C4.29811 0.555338 4.2046 0.584615 4.12648 0.639611C4.04836 0.694606 3.98957 0.772551 3.95837 0.862476L1.3009 8.81138L-0.0432697 12.8259C-0.102759 13.0047 -0.102702 13.1979 -0.0431073 13.3767C0.0164873 13.5555 0.132453 13.7106 0.287629 13.8188L11.9119 22.0147L23.5328 13.8188C23.6887 13.7111 23.8055 13.5563 23.866 13.3775C23.9266 13.1987 23.9275 13.0053 23.8689 12.8259Z", fill: "#FC6D26" }), /* @__PURE__ */ d.createElement("path", { d: "M11.7701 22.0147L16.2886 8.74412H7.25333L11.7701 22.0147Z", fill: "#E24329" }), /* @__PURE__ */ d.createElement("path", { d: "M11.771 22.0147L7.4162 8.74412H1.32391L11.771 22.0147Z", fill: "#FC6D26" }), /* @__PURE__ */ d.createElement("path", { d: "M1.28439 8.74412L-0.0437996 12.7744C-0.102581 12.9542 -0.102525 13.1484 -0.0436391 13.3282C0.015247 13.5079 0.129834 13.6638 0.283165 13.7726L11.771 22.0147L1.28439 8.74583V8.74412Z", fill: "#FCA326" }), /* @__PURE__ */ d.createElement("path", { d: "M1.32391 8.74412H7.25332L4.7023 0.859977C4.67222 0.770924 4.61587 0.693757 4.54112 0.639245C4.46637 0.584732 4.37695 0.555594 4.28534 0.555896C4.19344 0.555241 4.10365 0.584215 4.02858 0.638752C3.9535 0.693289 3.8969 0.77065 3.86673 0.859977L1.32391 8.74412Z", fill: "#E24329" }), /* @__PURE__ */ d.createElement("path", { d: "M11.771 22.0147L16.2381 8.74412H22.5004L11.771 22.0147Z", fill: "#FC6D26" }), /* @__PURE__ */ d.createElement("path", { d: "M22.5085 8.74412L23.8667 12.7765C23.9272 12.9564 23.9273 13.1507 23.867 13.3307C23.8067 13.5106 23.6892 13.6665 23.5319 13.7752L11.771 22.0147L22.505 8.74412H22.5085Z", fill: "#FCA326" }), /* @__PURE__ */ d.createElement("path", { d: "M22.4969 8.74412H16.2886L18.956 0.859987C18.9873 0.770519 19.0466 0.693014 19.1253 0.638442C19.204 0.583871 19.2982 0.554996 19.3945 0.555906C19.5923 0.555906 19.7677 0.679228 19.8313 0.859987L22.5004 8.74412H22.4969Z", fill: "#E24329" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17893_199590" }, /* @__PURE__ */ d.createElement("rect", { width: 24, height: 24, fill: "white" })))), ote = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17893_199594)" }, /* @__PURE__ */ d.createElement("path", { d: "M24 4.49486V19.0869L18 24L8.7 20.6143V23.9709L3.43543 17.0914L18.78 18.2914V5.15143L24 4.49486ZM18.8846 5.22857L10.2754 0V3.43029L2.36914 5.75314L0 8.79429V15.7011L3.39086 17.1977V8.34686L18.8846 5.22857Z", fill: "url(#paint0_linear_17893_199594)" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("linearGradient", { id: "paint0_linear_17893_199594", x1: 12, y1: 23.9246, x2: 12, y2: 0.0445711, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ d.createElement("stop", { stopColor: "#0078D4" }), /* @__PURE__ */ d.createElement("stop", { offset: 0.16, stopColor: "#1380DA" }), /* @__PURE__ */ d.createElement("stop", { offset: 0.53, stopColor: "#3C91E5" }), /* @__PURE__ */ d.createElement("stop", { offset: 0.82, stopColor: "#559CEC" }), /* @__PURE__ */ d.createElement("stop", { offset: 1, stopColor: "#5EA0EF" })), /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17893_199594" }, /* @__PURE__ */ d.createElement("rect", { width: 24, height: 24, fill: "white" })))), ite = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_43_476)" }, /* @__PURE__ */ d.createElement("path", { d: "M11.9998 9.81815V14.4654H18.458C18.1744 15.96 17.3234 17.2255 16.047 18.0764L19.9416 21.0982C22.2107 19.0037 23.5198 15.9273 23.5198 12.2728C23.5198 11.4219 23.4434 10.6037 23.3015 9.81828L11.9998 9.81815Z", fill: "#4285F4" }), /* @__PURE__ */ d.createElement("path", { d: "M5.27468 14.284L4.39631 14.9564L1.28717 17.3782C3.26171 21.2945 7.30868 24 11.9996 24C15.2395 24 17.9558 22.9309 19.9413 21.0982L16.0468 18.0764C14.9777 18.7964 13.614 19.2328 11.9996 19.2328C8.87957 19.2328 6.22874 17.1273 5.27958 14.291L5.27468 14.284Z", fill: "#34A853" }), /* @__PURE__ */ d.createElement("path", { d: "M1.28718 6.62183C0.469042 8.23631 0 10.0581 0 11.9999C0 13.9417 0.469042 15.7636 1.28718 17.378C1.28718 17.3889 5.27997 14.2799 5.27997 14.2799C5.03998 13.5599 4.89812 12.7963 4.89812 11.9998C4.89812 11.2033 5.03998 10.4398 5.27997 9.71976L1.28718 6.62183Z", fill: "#FBBC05" }), /* @__PURE__ */ d.createElement("path", { d: "M11.9998 4.77818C13.7671 4.77818 15.338 5.38907 16.5925 6.56727L20.0289 3.13095C17.9452 1.18917 15.2398 0 11.9998 0C7.30893 0 3.26171 2.69454 1.28717 6.62183L5.27984 9.72001C6.22888 6.88362 8.87982 4.77818 11.9998 4.77818Z", fill: "#EA4335" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_43_476" }, /* @__PURE__ */ d.createElement("rect", { width: 24, height: 24, fill: "white" })))), ate = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M12.7497 8.00021C14.6828 8.00021 16.2499 6.43309 16.2499 4.49996C16.2499 2.56683 14.6828 0.99971 12.7497 0.99971C10.8166 0.99971 9.24945 2.56683 9.24945 4.49996C9.24945 6.43309 10.8166 8.00021 12.7497 8.00021Z", fill: "#7B83EB" }), /* @__PURE__ */ d.createElement("path", { opacity: 0.1, d: "M12.5003 5.25013H9.33002L9.34577 5.31988L9.34727 5.32588L9.36377 5.39038C9.59412 6.26391 10.153 7.01469 10.9238 7.48594C11.6945 7.95719 12.6175 8.11248 13.5 7.91938V6.24988C13.4992 5.98497 13.3936 5.73114 13.2063 5.54382C13.019 5.35651 12.7652 5.25092 12.5003 5.25013Z", fill: "black" }), /* @__PURE__ */ d.createElement("path", { opacity: 0.2, d: "M11.7507 6.00015H9.58768C9.87155 6.59867 10.3194 7.10435 10.8793 7.45842C11.4392 7.8125 12.088 8.00044 12.7504 8.0004V6.9999C12.7496 6.735 12.644 6.48116 12.4567 6.29385C12.2694 6.10653 12.0156 6.00094 11.7507 6.00015Z", fill: "black" }), /* @__PURE__ */ d.createElement("path", { d: "M20.6254 8.25008C22.0752 8.25008 23.2504 7.07482 23.2504 5.62508C23.2504 4.17533 22.0752 3.00008 20.6254 3.00008C19.1757 3.00008 18.0004 4.17533 18.0004 5.62508C18.0004 7.07482 19.1757 8.25008 20.6254 8.25008Z", fill: "#5059C9" }), /* @__PURE__ */ d.createElement("path", { d: "M22.8749 9.00023H16.9792C16.8519 9.00023 16.7298 9.0508 16.6398 9.14082C16.5498 9.23083 16.4992 9.35293 16.4992 9.48023V15.5627C16.4829 16.443 16.7696 17.3022 17.3113 17.9963C17.8529 18.6905 18.6166 19.1775 19.4744 19.3757C20.0208 19.4904 20.5859 19.4817 21.1285 19.3504C21.6711 19.2191 22.1776 18.9685 22.6111 18.6167C23.0446 18.265 23.3942 17.821 23.6344 17.3171C23.8747 16.8131 23.9996 16.262 23.9999 15.7037V10.1252C23.9999 9.82686 23.8814 9.54071 23.6704 9.32973C23.4595 9.11876 23.1733 9.00023 22.8749 9.00023Z", fill: "#5059C9" }), /* @__PURE__ */ d.createElement("path", { d: "M18.7497 10.1252V17.2502C18.7504 18.5706 18.3153 19.8544 17.5119 20.9022C16.7084 21.95 15.5816 22.7034 14.3062 23.0453C13.0308 23.3872 11.6782 23.2986 10.4584 22.7932C9.23851 22.2878 8.21958 21.3939 7.5597 20.2502C7.41537 20.0104 7.28999 19.7596 7.1847 19.5002C7.08653 19.2557 7.00387 19.0052 6.9372 18.7502C6.81355 18.2598 6.75058 17.756 6.7497 17.2502V10.1252C6.7495 9.97744 6.77846 9.83106 6.83493 9.69448C6.8914 9.5579 6.97426 9.4338 7.07876 9.32929C7.18327 9.22479 7.30736 9.14193 7.44394 9.08546C7.58052 9.029 7.7269 9.00003 7.8747 9.00023H17.6247C17.7725 9.00003 17.9189 9.029 18.0554 9.08546C18.192 9.14193 18.3161 9.22479 18.4206 9.32929C18.5251 9.4338 18.608 9.5579 18.6645 9.69448C18.7209 9.83106 18.7499 9.97744 18.7497 10.1252Z", fill: "#7B83EB" }), /* @__PURE__ */ d.createElement("path", { opacity: 0.2, d: "M11.7507 6.00015H9.58768C9.87155 6.59867 10.3194 7.10435 10.8793 7.45842C11.4392 7.8125 12.088 8.00044 12.7504 8.0004V6.9999C12.7496 6.735 12.644 6.48116 12.4567 6.29385C12.2694 6.10653 12.0156 6.00094 11.7507 6.00015Z", fill: "black" }), /* @__PURE__ */ d.createElement("path", { opacity: 0.1, d: "M13.4997 9.00023V18.5027C13.4997 18.7288 13.4223 18.9481 13.2804 19.1241C13.1385 19.3001 12.9406 19.4223 12.7197 19.4702C12.6491 19.4912 12.5758 19.5013 12.5022 19.5002H7.1847C7.08653 19.2557 7.00387 19.0052 6.9372 18.7502C6.81355 18.2598 6.75058 17.756 6.7497 17.2502V10.1252C6.7495 9.97744 6.77846 9.83106 6.83493 9.69448C6.8914 9.5579 6.97426 9.4338 7.07876 9.32929C7.18327 9.22479 7.30736 9.14193 7.44394 9.08546C7.58052 9.029 7.7269 9.00003 7.8747 9.00023H13.4997Z", fill: "black" }), /* @__PURE__ */ d.createElement("path", { opacity: 0.2, d: "M12.7497 9.00023V19.2527C12.7508 19.3263 12.7407 19.3997 12.7197 19.4702C12.6717 19.6912 12.5496 19.889 12.3736 20.031C12.1976 20.1729 11.9783 20.2502 11.7522 20.2502H7.5597C7.41537 20.0104 7.28999 19.7596 7.1847 19.5002C7.08653 19.2557 7.00387 19.0052 6.9372 18.7502C6.81355 18.2598 6.75058 17.756 6.7497 17.2502V10.1252C6.7495 9.97744 6.77846 9.83106 6.83493 9.69448C6.8914 9.5579 6.97426 9.4338 7.07876 9.32929C7.18327 9.22479 7.30736 9.14193 7.44394 9.08546C7.58052 9.029 7.7269 9.00003 7.8747 9.00023H12.7497Z", fill: "black" }), /* @__PURE__ */ d.createElement("path", { opacity: 0.2, d: "M12.7497 9.00023V17.7527C12.7485 18.0169 12.643 18.2699 12.4562 18.4568C12.2694 18.6436 12.0164 18.749 11.7522 18.7502H6.9372C6.81355 18.2598 6.75058 17.756 6.7497 17.2502V10.1252C6.7495 9.97744 6.77846 9.83106 6.83493 9.69448C6.8914 9.5579 6.97426 9.4338 7.07876 9.32929C7.18327 9.22479 7.30736 9.14193 7.44394 9.08546C7.58052 9.029 7.7269 9.00003 7.8747 9.00023H12.7497Z", fill: "black" }), /* @__PURE__ */ d.createElement("path", { opacity: 0.2, d: "M7.8747 9.00023C7.7269 9.00003 7.58052 9.029 7.44394 9.08546C7.30736 9.14193 7.18327 9.22479 7.07876 9.32929C6.97426 9.4338 6.8914 9.5579 6.83493 9.69448C6.77846 9.83106 6.7495 9.97744 6.7497 10.1252V17.2502C6.75058 17.756 6.81355 18.2598 6.9372 18.7502H11.0022C11.2664 18.749 11.5194 18.6436 11.7062 18.4568C11.893 18.2699 11.9985 18.0169 11.9997 17.7527V9.00023H7.8747Z", fill: "black" }), /* @__PURE__ */ d.createElement("path", { d: "M0.999749 6.00015H11.0002C11.2654 6.00015 11.5197 6.10548 11.7072 6.29297C11.8947 6.48046 12 6.73475 12 6.9999V17.0004C12 17.2656 11.8947 17.5198 11.7072 17.7073C11.5197 17.8948 11.2654 18.0002 11.0002 18.0002H0.999749C0.734599 18.0002 0.480309 17.8948 0.29282 17.7073C0.10533 17.5198 0 17.2656 0 17.0004L0 6.9999C0 6.73475 0.10533 6.48046 0.29282 6.29297C0.480309 6.10548 0.734599 6.00015 0.999749 6.00015Z", fill: "#4B53BC" }), /* @__PURE__ */ d.createElement("path", { d: "M8.98506 9.73145H6.74256V15.7465H5.27106V9.73145H3.01506V8.25395H8.98506V9.73145Z", fill: "white" })), ste = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17388_143)" }, /* @__PURE__ */ d.createElement("path", { d: "M12.3055 6.98773C12.3054 8.05015 12.0066 9.09113 11.443 9.99178C10.8795 10.8924 10.074 11.6164 9.11859 12.0811C8.16318 12.5458 7.09634 12.7324 6.03992 12.6196C4.9835 12.5068 3.98009 12.0992 3.14429 11.4434", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M1.00004 7.49898C0.985039 7.33232 0.977539 7.1619 0.977539 6.98773C0.97737 5.87345 1.30589 4.78387 1.92198 3.85539C2.53807 2.92691 3.41435 2.20079 4.44113 1.76793C5.4679 1.33507 6.59955 1.2147 7.69441 1.42189C8.78926 1.62908 9.79868 2.15463 10.5963 2.93273", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M10.647 10.9927L15.0313 15.3859", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M15.0312 4.80524V1.79211H12.0269", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M0.96875 11.1671L6.16875 5.96899C6.27982 5.85819 6.4303 5.79597 6.58719 5.79597C6.74407 5.79597 6.89455 5.85819 7.00562 5.96899L8.53438 7.49836C8.58929 7.55338 8.65452 7.59702 8.72632 7.62679C8.79812 7.65657 8.87508 7.6719 8.95281 7.6719C9.03054 7.6719 9.10751 7.65657 9.17931 7.62679C9.25111 7.59702 9.31633 7.55338 9.37125 7.49836L15.0312 1.79211", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17388_143" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), lte = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M10.0312 6.79211H11.5938C11.7812 6.79211 11.9688 6.91711 12.0938 7.04211L13.1562 8.66711L14.5938 9.16711C14.8438 9.22961 15.0312 9.47961 15.0312 9.72961V11.1671C15.0312 11.5421 14.7812 11.7921 14.4062 11.7921H13.1562M8.78125 11.7921H10.6604", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M11.9062 13.0421C12.5966 13.0421 13.1562 12.4825 13.1562 11.7921C13.1562 11.1017 12.5966 10.5421 11.9062 10.5421C11.2159 10.5421 10.6562 11.1017 10.6562 11.7921C10.6562 12.4825 11.2159 13.0421 11.9062 13.0421Z", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M3.15629 11.7921H1.59375C1.21875 11.7921 0.96875 11.5421 0.96875 11.1671V9.29211H9.09373V11.7921H5.65629", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M4.40625 13.0421C5.09661 13.0421 5.65625 12.4825 5.65625 11.7921C5.65625 11.1017 5.09661 10.5421 4.40625 10.5421C3.71589 10.5421 3.15625 11.1017 3.15625 11.7921C3.15625 12.4825 3.71589 13.0421 4.40625 13.0421Z", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.09377 3.66711H1.59375C1.21875 3.66711 0.96875 3.91711 0.96875 4.29211V9.29211H9.09377V3.66711Z", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.09375 6.79211H12.2188V5.79211C12.2188 5.29211 11.9062 4.79211 11.4062 4.60461L9.09375 3.66711V6.79211Z", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" })), cte = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M0.96875 8.19836H3.15625C3.34137 8.19842 3.52236 8.14366 3.67641 8.041C3.83046 7.93834 3.95066 7.79237 4.02187 7.62149L5.64687 3.79961C5.68399 3.71229 5.74673 3.63829 5.82681 3.58738C5.90688 3.53648 6.00052 3.51108 6.09534 3.51453C6.19016 3.51799 6.2817 3.55014 6.35786 3.60673C6.43402 3.66332 6.49121 3.7417 6.52187 3.83149L9.48063 13.0346C9.51129 13.1244 9.56848 13.2028 9.64464 13.2594C9.7208 13.316 9.81234 13.3481 9.90716 13.3516C10.002 13.355 10.0956 13.3296 10.1757 13.2787C10.2558 13.2278 10.3185 13.1538 10.3556 13.0665L11.9775 8.77524C12.0487 8.60436 12.1689 8.45839 12.323 8.35573C12.477 8.25307 12.658 8.19831 12.8431 8.19836H15.0306", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), ute = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M0.96875 14.4484H15.0312", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M4.25 7.88586H2.375C2.25068 7.88586 2.13145 7.93525 2.04354 8.02316C1.95564 8.11107 1.90625 8.23029 1.90625 8.35461V14.4484H4.71875V8.35461C4.71875 8.23029 4.66936 8.11107 4.58146 8.02316C4.49355 7.93525 4.37432 7.88586 4.25 7.88586Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8.9375 2.26086H7.0625C6.93818 2.26086 6.81895 2.31025 6.73104 2.39816C6.64314 2.48607 6.59375 2.60529 6.59375 2.72961V14.4484H9.40625V2.72961C9.40625 2.60529 9.35686 2.48607 9.26896 2.39816C9.18105 2.31025 9.06182 2.26086 8.9375 2.26086Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M13.625 5.07336H11.75C11.6257 5.07336 11.5065 5.12275 11.4185 5.21066C11.3306 5.29857 11.2812 5.41779 11.2812 5.54211V14.4484H14.0938V5.54211C14.0938 5.41779 14.0444 5.29857 13.9565 5.21066C13.8685 5.12275 13.7493 5.07336 13.625 5.07336Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), dte = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17390_41)" }, /* @__PURE__ */ d.createElement("path", { d: "M2.84375 3.19836C2.84375 3.69565 3.04129 4.17256 3.39292 4.52419C3.74456 4.87582 4.22147 5.07336 4.71875 5.07336C5.21603 5.07336 5.69294 4.87582 6.04458 4.52419C6.39621 4.17256 6.59375 3.69565 6.59375 3.19836C6.59375 2.70108 6.39621 2.22417 6.04458 1.87254C5.69294 1.52091 5.21603 1.32336 4.71875 1.32336C4.22147 1.32336 3.74456 1.52091 3.39292 1.87254C3.04129 2.22417 2.84375 2.70108 2.84375 3.19836Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M2.84375 13.5109C2.84375 14.0081 3.04129 14.4851 3.39292 14.8367C3.74456 15.1883 4.22147 15.3859 4.71875 15.3859C5.21603 15.3859 5.69294 15.1883 6.04458 14.8367C6.39621 14.4851 6.59375 14.0081 6.59375 13.5109C6.59375 13.0136 6.39621 12.5367 6.04458 12.185C5.69294 11.8334 5.21603 11.6359 4.71875 11.6359C4.22147 11.6359 3.74456 11.8334 3.39292 12.185C3.04129 12.5367 2.84375 13.0136 2.84375 13.5109Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.40625 3.19836C9.40625 3.69565 9.60379 4.17256 9.95542 4.52419C10.3071 4.87582 10.784 5.07336 11.2812 5.07336C11.7785 5.07336 12.2554 4.87582 12.6071 4.52419C12.9587 4.17256 13.1562 3.69565 13.1562 3.19836C13.1562 2.70108 12.9587 2.22417 12.6071 1.87254C12.2554 1.52091 11.7785 1.32336 11.2812 1.32336C10.784 1.32336 10.3071 1.52091 9.95542 1.87254C9.60379 2.22417 9.40625 2.70108 9.40625 3.19836Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M4.71875 5.07336V11.6359", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M4.71875 8.82336H7.53125C8.52581 8.82336 9.47964 8.42828 10.1829 7.72501C10.8862 7.02175 11.2812 6.06793 11.2812 5.07336", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17390_41" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), fte = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17390_49)" }, /* @__PURE__ */ d.createElement("path", { d: "M1.90625 4.60461C1.90625 4.97757 2.05441 5.33526 2.31813 5.59898C2.58185 5.86271 2.93954 6.01086 3.3125 6.01086C3.68546 6.01086 4.04315 5.86271 4.30687 5.59898C4.57059 5.33526 4.71875 4.97757 4.71875 4.60461C4.71875 4.23165 4.57059 3.87397 4.30687 3.61025C4.04315 3.34652 3.68546 3.19836 3.3125 3.19836C2.93954 3.19836 2.58185 3.34652 2.31813 3.61025C2.05441 3.87397 1.90625 4.23165 1.90625 4.60461Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M3.3125 6.94836C3.00471 6.94836 2.69994 7.00899 2.41559 7.12677C2.13123 7.24456 1.87286 7.4172 1.65522 7.63483C1.21568 8.07437 0.96875 8.67051 0.96875 9.29211V10.6984H1.90625L2.375 14.4484H4.25", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M11.2812 4.60461C11.2813 4.97757 11.4294 5.33526 11.6931 5.59898C11.9569 5.86271 12.3145 6.01086 12.6875 6.01086C13.0605 6.01086 13.4181 5.86271 13.6819 5.59898C13.9456 5.33526 14.0938 4.97757 14.0938 4.60461C14.0938 4.23165 13.9456 3.87397 13.6819 3.61025C13.4181 3.34652 13.0605 3.19836 12.6875 3.19836C12.3145 3.19836 11.9569 3.34652 11.6931 3.61025C11.4294 3.87397 11.2812 4.23165 11.2812 4.60461Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M12.6875 6.94836C13.3091 6.94836 13.9052 7.19529 14.3448 7.63483C14.7843 8.07437 15.0312 8.67051 15.0312 9.29211V10.6984H14.0938L13.625 14.4484H11.75", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M6.125 3.19836C6.125 3.69565 6.32254 4.17256 6.67417 4.52419C7.02581 4.87582 7.50272 5.07336 8 5.07336C8.49728 5.07336 8.97419 4.87582 9.32583 4.52419C9.67746 4.17256 9.875 3.69565 9.875 3.19836C9.875 2.70108 9.67746 2.22417 9.32583 1.87254C8.97419 1.52091 8.49728 1.32336 8 1.32336C7.50272 1.32336 7.02581 1.52091 6.67417 1.87254C6.32254 2.22417 6.125 2.70108 6.125 3.19836Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M11.2812 9.29211C11.2812 8.42187 10.9355 7.58727 10.3202 6.97192C9.70484 6.35657 8.87024 6.01086 8 6.01086C7.12976 6.01086 6.29516 6.35657 5.67981 6.97192C5.06445 7.58727 4.71875 8.42187 4.71875 9.29211V10.6984H6.125L6.59375 15.3859H9.40625L9.875 10.6984H11.2812V9.29211Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17390_49" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), hte = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17390_58)" }, /* @__PURE__ */ d.createElement("path", { d: "M0.96875 8.35461C0.96875 10.2194 1.70954 12.0078 3.02816 13.3265C4.34677 14.6451 6.1352 15.3859 8 15.3859C9.8648 15.3859 11.6532 14.6451 12.9718 13.3265C14.2905 12.0078 15.0312 10.2194 15.0312 8.35461C15.0312 6.48981 14.2905 4.70138 12.9718 3.38277C11.6532 2.06415 9.8648 1.32336 8 1.32336C6.1352 1.32336 4.34677 2.06415 3.02816 3.38277C1.70954 4.70138 0.96875 6.48981 0.96875 8.35461Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M5.65625 8.35461C5.65625 8.97622 5.90318 9.57236 6.34272 10.0119C6.78226 10.4514 7.3784 10.6984 8 10.6984C8.6216 10.6984 9.21774 10.4514 9.65728 10.0119C10.0968 9.57236 10.3438 8.97622 10.3438 8.35461C10.3438 7.73301 10.0968 7.13687 9.65728 6.69733C9.21774 6.25779 8.6216 6.01086 8 6.01086C7.3784 6.01086 6.78226 6.25779 6.34272 6.69733C5.90318 7.13687 5.65625 7.73301 5.65625 8.35461Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.29297 6.40899L12.2223 2.72961", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M7.06256 6.2065L5.81006 1.67337", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.875 9.76086L13.2006 13.0865", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8.83545 10.544L9.87482 15.1309", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17390_58" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), mte = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17390_67)" }, /* @__PURE__ */ d.createElement("path", { d: "M0.969238 15.3859C1.47826 15.4489 1.99493 15.3974 2.48151 15.2352C2.9681 15.073 3.41232 14.8042 3.78174 14.4484C4.04819 14.7435 4.37361 14.9794 4.73696 15.1409C5.10031 15.3024 5.4935 15.3858 5.89111 15.3858C6.28873 15.3858 6.68192 15.3024 7.04527 15.1409C7.40862 14.9794 7.73404 14.7435 8.00049 14.4484C8.26694 14.7435 8.59236 14.9794 8.95571 15.1409C9.31906 15.3024 9.71225 15.3858 10.1099 15.3858C10.5075 15.3858 10.9007 15.3024 11.264 15.1409C11.6274 14.9794 11.9528 14.7435 12.2192 14.4484C12.5887 14.8042 13.0329 15.073 13.5195 15.2352C14.006 15.3974 14.5227 15.4489 15.0317 15.3859", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M13.1569 5.5946C12.477 5.59714 11.8043 5.73361 11.1771 5.99621C10.5499 6.2588 9.98064 6.64239 9.50176 7.12505C9.02287 7.6077 8.64377 8.17998 8.3861 8.80918C8.12843 9.43839 7.99725 10.1122 8.00004 10.7921C8.67993 10.7895 9.35265 10.653 9.97978 10.3903C10.6069 10.1277 11.1762 9.74412 11.655 9.26148C12.1339 8.77884 12.513 8.2066 12.7707 7.57743C13.0284 6.94826 13.1596 6.2745 13.1569 5.5946Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.35708 7.27836C9.71099 6.25877 9.77211 5.16041 9.53349 4.10785C9.29488 3.05529 8.76608 2.09066 8.00708 1.32336C7.24511 2.09346 6.71515 3.06238 6.47775 4.1194C6.24035 5.17641 6.3051 6.2789 6.66458 7.30086", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M2.84428 5.5946C3.52409 5.59731 4.19671 5.73389 4.82373 5.99656C5.45075 6.25924 6.01988 6.64284 6.49864 7.12549C6.97739 7.60813 7.35638 8.18035 7.61397 8.80947C7.87156 9.43859 8.0027 10.1123 7.99991 10.7921C7.3201 10.7894 6.64748 10.6528 6.02046 10.3901C5.39344 10.1275 4.82431 9.74386 4.34555 9.26122C3.8668 8.77858 3.48781 8.20636 3.23022 7.57724C2.97263 6.94812 2.84149 6.27441 2.84428 5.5946Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M8.00049 13.0421V10.7915", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17390_67" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), pte = (e) => /* @__PURE__ */ d.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_17390_75)" }, /* @__PURE__ */ d.createElement("path", { d: "M7.38477 8.26648L9.98914 5.66211", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M9.98926 5.66211L10.3443 3.31836L12.3743 1.32336L12.688 2.96336L14.328 3.27711L12.333 5.30711L9.98926 5.66211Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M13.6593 6.80024C13.9905 8.0559 13.912 9.38455 13.4351 10.5924C12.9582 11.8003 12.1079 12.8243 11.0082 13.5149C9.90845 14.2056 8.61685 14.527 7.32171 14.432C6.02656 14.3371 4.79561 13.8309 3.80834 12.9873C2.82108 12.1437 2.12914 11.0067 1.83343 9.7422C1.53772 8.4777 1.65371 7.1518 2.16447 5.95784C2.67523 4.76389 3.55406 3.76432 4.67281 3.10491C5.79155 2.44549 7.09169 2.16072 8.38365 2.29211", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M10.9511 7.56524C11.1155 8.22817 11.069 8.92588 10.8181 9.56112C10.5671 10.1964 10.1242 10.7375 9.55108 11.109C8.97797 11.4806 8.30321 11.6641 7.62086 11.6339C6.93851 11.6038 6.28257 11.3615 5.74447 10.9408C5.20637 10.5201 4.81293 9.94205 4.61898 9.28715C4.42503 8.63225 4.44025 7.93315 4.6625 7.28731C4.88476 6.64146 5.30298 6.08106 5.85887 5.6842C6.41476 5.28734 7.08062 5.07381 7.76364 5.07336", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M4.57227 13.5109L4.10352 15.3859", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M11.1348 13.5109L11.6035 15.3859", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_17390_75" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.354614)" })))), gte = (e) => /* @__PURE__ */ d.createElement("svg", { width: 180, height: 40, viewBox: "0 0 180 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.66921 11.7665C11.4765 11.3803 12.617 10.3272 12.9504 9.08302C13.3123 7.72704 14.3674 6.73089 15.8982 6.28974C17.3985 5.87502 19.2058 6.06815 20.8748 6.75936C22.4036 7.39567 24.0991 7.53391 25.3778 7.00738C27.0733 6.28771 27.4636 4.54547 26.3516 2.88658C24.959 0.812975 21.8445 -0.40273 19.5371 0.121772C18.3133 0.426714 17.5347 1.14435 17.3416 2.0856C17.12 3.19153 16.0913 4.04943 14.6459 4.43773L14.5341 4.46619C13.0602 4.85245 11.2264 4.71421 9.61432 4.023C8.22378 3.41515 6.58319 3.21999 5.11133 3.55339C2.22048 4.2446 0.941749 6.84474 2.74904 9.30664C4.19447 11.242 7.16868 12.293 9.67124 11.7685L9.66921 11.7665ZM35.6625 20.1484C34.1337 20.618 33.3002 21.8357 33.2718 23.3299C33.2169 25.0457 32.3549 26.5115 30.7977 27.2576L30.6859 27.3125C29.0737 28.087 26.9879 28.0037 24.959 27.1458C23.1233 26.3712 21.068 26.3428 19.3989 27.3125C17.12 28.64 16.2011 31.7382 17.5632 34.7246C19.3989 38.7641 24.0971 40.671 27.3762 38.8454C29.0168 37.9042 29.8788 36.2453 29.9337 34.3912C29.9886 32.3176 31.0172 30.7116 32.6294 29.9106C34.1866 29.1076 36.187 29.1076 38.1346 29.9939C39.8301 30.7685 41.5825 30.8519 42.8876 30.1322C45.3068 28.7762 44.9999 25.2084 42.4424 22.5249C40.4969 20.5611 37.6609 19.5385 35.6585 20.1463L35.6625 20.1484ZM32.548 7.53594C31.1026 7.84089 30.324 8.83703 30.324 10.0812C30.324 11.1871 29.769 12.0999 28.6 12.5146L28.2951 12.6244C27.1282 13.0391 25.5709 12.9009 24.1519 12.2097C22.6516 11.49 20.9277 11.2684 19.4823 11.7401C18.0084 12.2097 17.12 13.3177 16.9248 14.6452C16.7581 15.9442 15.8412 17.0237 14.3958 17.5218L14.0075 17.66C12.5336 18.1845 10.7833 17.965 9.19756 17.2169C7.39027 16.3589 5.16622 16.1943 3.22069 17.0237C0.718125 18.1032 -0.643952 20.7583 0.30137 23.3848C1.60856 26.9811 6.08308 28.7782 9.64278 27.3125C11.5334 26.5379 12.6739 25.0173 12.924 23.3299C13.1456 21.7808 14.1742 20.5631 15.6481 19.9837L15.8433 19.9003C17.2887 19.3474 19.0675 19.4856 20.6532 20.2886C22.3203 21.1181 24.2394 21.3112 25.7681 20.6769C27.2685 20.0691 28.0207 18.8229 28.0207 17.3856C28.0207 16.0865 28.7159 15.0619 29.9113 14.6187L30.0495 14.5639C31.2165 14.1207 32.7452 14.2874 34.1927 14.9786C35.7215 15.6982 37.3621 15.9198 38.5859 15.3933C40.7551 14.509 40.6981 11.8255 38.4741 9.66647C36.862 8.06248 34.3594 7.17611 32.5521 7.53594H32.548Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M66.2137 7.10083H61.4749V31.5857H64.9593H66.2137H77.4274V27.3714H66.2137V7.10083Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M84.6362 14.7631H80.0051V31.5858H84.6362V14.7631Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M82.3371 6.82037C81.595 6.82037 80.979 7.07449 80.4911 7.58883C80.0032 8.0991 79.7593 8.71508 79.7593 9.43475C79.7593 10.1544 80.0032 10.7989 80.4911 11.2969C80.979 11.795 81.593 12.0451 82.3371 12.0451C83.0811 12.0451 83.7256 11.795 84.2013 11.2969C84.677 10.7989 84.9148 10.1768 84.9148 9.43475C84.9148 8.69272 84.677 8.0991 84.2013 7.58883C83.7256 7.07653 83.1035 6.82037 82.3371 6.82037Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M101.164 15.3383C100.198 14.7223 99.0905 14.4133 97.8382 14.4133C96.5859 14.4133 95.417 14.6918 94.4066 15.2488C93.8598 15.5517 93.3779 15.9177 92.9612 16.3466V14.7609H88.3972V31.5836H92.9612V21.9352C92.9612 21.2867 93.1055 20.6992 93.3962 20.1787C93.687 19.6542 94.0874 19.2537 94.5977 18.9772C95.108 18.6967 95.6894 18.5585 96.34 18.5585C97.3158 18.5585 98.1168 18.8736 98.7429 19.4997C99.3711 20.1259 99.6842 20.939 99.6842 21.9372V31.5856H104.283V20.8943C104.283 19.7782 104.004 18.7292 103.447 17.7432C102.89 16.7532 102.13 15.9542 101.166 15.3403L101.164 15.3383Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M119.711 15.4605C118.456 14.7408 117.042 14.381 115.462 14.381C113.789 14.381 112.28 14.7632 110.935 15.5296C109.589 16.2981 108.525 17.341 107.747 18.6644C106.968 19.9879 106.58 21.4841 106.58 23.1572C106.58 24.8303 106.974 26.3632 107.765 27.6866C108.554 29.0101 109.64 30.053 111.02 30.8215C112.402 31.5858 113.976 31.9701 115.74 31.9701C117.111 31.9701 118.377 31.7261 119.538 31.2382C120.699 30.7503 121.709 30.0184 122.569 29.0447L119.853 26.3286C119.343 26.9324 118.739 27.3715 118.042 27.65C117.346 27.9306 116.568 28.0688 115.708 28.0688C114.756 28.0688 113.919 27.8696 113.199 27.4772C112.48 27.0829 111.929 26.5075 111.544 25.7533C111.392 25.4545 111.272 25.1333 111.181 24.7917L123.474 24.7612C123.567 24.3892 123.626 24.0477 123.649 23.7326C123.671 23.4174 123.683 23.1125 123.683 22.8076C123.683 21.1832 123.333 19.7317 122.638 18.453C121.941 17.1783 120.965 16.1801 119.711 15.4605ZM113.059 18.8026C113.732 18.4083 114.521 18.2111 115.427 18.2111C116.285 18.2111 117.007 18.3859 117.586 18.7356C118.166 19.0852 118.619 19.5935 118.944 20.2664C119.101 20.5916 119.221 20.9535 119.308 21.352L111.178 21.3764C111.262 21.0633 111.372 20.7685 111.508 20.492C111.868 19.7602 112.386 19.1991 113.059 18.8026Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M138.138 16.3527C137.672 15.8709 137.127 15.4663 136.501 15.1451C135.55 14.6572 134.48 14.4133 133.297 14.4133C131.742 14.4133 130.353 14.7955 129.134 15.5639C127.914 16.3283 126.956 17.3732 126.259 18.6967C125.564 20.0201 125.214 21.5205 125.214 23.1915C125.214 24.8626 125.562 26.3264 126.259 27.6478C126.956 28.9712 127.914 30.0182 129.134 30.7826C130.353 31.551 131.728 31.9332 133.261 31.9332C134.468 31.9332 135.554 31.6893 136.517 31.2014C137.139 30.8863 137.68 30.4898 138.138 30.0141V31.5856H142.736V14.7629H138.138V16.3527ZM137.233 26.43C136.444 27.292 135.409 27.7189 134.133 27.7189C133.319 27.7189 132.588 27.5238 131.937 27.1273C131.287 26.7329 130.782 26.2003 130.423 25.5254C130.063 24.8504 129.882 24.0637 129.882 23.155C129.882 22.2462 130.063 21.4961 130.423 20.8211C130.782 20.1503 131.28 19.6136 131.921 19.2192C132.559 18.8248 133.297 18.6276 134.133 18.6276C134.968 18.6276 135.735 18.8166 136.361 19.2029C136.989 19.5851 137.487 20.1238 137.859 20.8211C138.231 21.5184 138.416 22.3072 138.416 23.1915C138.416 24.4906 138.022 25.5701 137.233 26.428V26.43Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M157.554 14.8138C156.916 14.5474 156.18 14.4133 155.342 14.4133C153.462 14.4133 152.023 15.011 151.022 16.2084C151.01 16.2226 151 16.2389 150.988 16.2531V14.7629H146.424V31.5856H150.988V22.3194C150.988 21.0448 151.295 20.1035 151.911 19.4997C152.527 18.8959 153.322 18.595 154.297 18.595C154.761 18.595 155.174 18.6581 155.533 18.7841C155.893 18.9102 156.2 19.1277 156.456 19.4286L159.313 16.1209C158.776 15.5172 158.193 15.0841 157.552 14.8138H157.554Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M178.506 20.3191C177.869 19.5709 177.062 18.9611 176.087 18.4813C176.768 18.0849 177.339 17.6173 177.792 17.0786C178.64 16.0702 179.063 14.8667 179.063 13.4721C179.063 12.3357 178.778 11.2846 178.209 10.321C177.64 9.35741 176.808 8.58082 175.717 7.9872C174.625 7.39358 173.279 7.10083 171.677 7.10083H161.748V31.5857H171.815C173.533 31.5857 175.003 31.2645 176.221 30.6282C177.441 29.9898 178.374 29.1421 179.024 28.0849C179.675 27.0278 180 25.8507 180 24.5496C180 22.9009 179.502 21.4921 178.504 20.317L178.506 20.3191ZM171.088 10.9675C172.039 10.9675 172.811 11.2115 173.403 11.6994C173.995 12.1873 174.291 12.9293 174.291 13.9275C174.291 14.9257 174.001 15.6331 173.419 16.121C172.84 16.6089 172.051 16.8529 171.051 16.8529H166.452V10.9675H171.086H171.088ZM174.275 26.6741C173.637 27.3714 172.759 27.721 171.645 27.721H166.454V20.685H171.575C172.342 20.685 173.005 20.8456 173.562 21.1729C174.119 21.4982 174.537 21.921 174.814 22.4435C175.092 22.968 175.233 23.5555 175.233 24.204C175.233 25.1555 174.914 25.9808 174.275 26.6761V26.6741Z", fill: "currentColor" })), vte = (e) => /* @__PURE__ */ d.createElement("svg", { width: 36, height: 36, viewBox: "0 0 36 36", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_3001_43460)" }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.81492 11.5226C9.27563 11.21 10.1974 10.3577 10.4669 9.35085C10.7593 8.25346 11.6121 7.44728 12.8493 7.09026C14.0619 6.75463 15.5226 6.91093 16.8716 7.47032C18.1072 7.98528 19.4776 8.09716 20.5111 7.67104C21.8814 7.08862 22.1969 5.67863 21.2981 4.3361C20.1726 2.65794 17.6554 1.67407 15.7905 2.09855C14.8013 2.34534 14.172 2.92611 14.0159 3.68787C13.8368 4.58289 13.0054 5.27719 11.8372 5.59143L11.7468 5.61447C10.5556 5.92706 9.07353 5.81519 7.77056 5.2558C6.64669 4.76387 5.32072 4.60592 4.13112 4.87574C1.79465 5.43513 0.761148 7.53942 2.22185 9.53183C3.39009 11.0981 5.79392 11.9487 7.81657 11.5242L7.81492 11.5226ZM28.8234 18.306C27.5878 18.686 26.9142 19.6716 26.8912 20.8808C26.8468 22.2694 26.1501 23.4556 24.8915 24.0595L24.8012 24.1039C23.4982 24.7307 21.8124 24.6633 20.1726 23.969C18.6889 23.3421 17.0277 23.3191 15.6787 24.1039C13.8368 25.1782 13.0942 27.6856 14.195 30.1025C15.6787 33.3716 19.4759 34.9149 22.1262 33.4374C23.4522 32.6757 24.1489 31.3331 24.1932 29.8327C24.2376 28.1545 25.069 26.8547 26.372 26.2065C27.6306 25.5566 29.2474 25.5566 30.8214 26.274C32.1918 26.9008 33.6081 26.9683 34.663 26.3858C36.6182 25.2885 36.3701 22.401 34.3031 20.2293C32.7307 18.64 30.4386 17.8124 28.8202 18.3043L28.8234 18.306ZM26.3062 8.09881C25.138 8.34559 24.5087 9.15177 24.5087 10.1587C24.5087 11.0537 24.0601 11.7924 23.1154 12.128L22.8689 12.2169C21.9258 12.5525 20.6672 12.4406 19.5203 11.8813C18.3077 11.2988 16.9143 11.1195 15.7461 11.5012C14.5549 11.8813 13.8368 12.7779 13.6791 13.8523C13.5444 14.9036 12.8033 15.7772 11.6351 16.1803L11.3213 16.2922C10.13 16.7167 8.71533 16.539 7.43373 15.9335C5.97302 15.2392 4.17548 15.106 2.60305 15.7772C0.580408 16.6509 -0.52046 18.7996 0.243575 20.9252C1.30008 23.8357 4.91652 25.2901 7.79356 24.1039C9.32163 23.477 10.2434 22.2464 10.4455 20.8808C10.6246 19.6271 11.456 18.6416 12.6472 18.1727L12.805 18.1053C13.9732 17.6578 15.4109 17.7696 16.6925 18.4195C18.0399 19.0908 19.5909 19.2471 20.8265 18.7338C22.0391 18.2418 22.6471 17.2333 22.6471 16.0701C22.6471 15.0188 23.209 14.1896 24.1751 13.8309L24.2869 13.7865C25.23 13.4278 26.4656 13.5627 27.6355 14.1221C28.8711 14.7045 30.1971 14.8838 31.1862 14.4577C32.9394 13.742 32.8934 11.5703 31.0958 9.82304C29.7929 8.52493 27.7702 7.80759 26.3095 8.09881H26.3062Z", fill: "currentColor" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_3001_43460" }, /* @__PURE__ */ d.createElement("rect", { width: 36, height: 36, fill: "white" }))));
export {
  pI as LBAccordion,
  bI as LBAccordionContent,
  gI as LBAccordionItem,
  vI as LBAccordionTrigger,
  YJ as LBAddUserIcon,
  HY as LBAlert,
  lee as LBAlertCircleIcon,
  UY as LBAlertDescription,
  LK as LBAlertDialog,
  DK as LBAlertDialogAction,
  IK as LBAlertDialogCancel,
  PK as LBAlertDialogContent,
  NK as LBAlertDialogDescription,
  AK as LBAlertDialogFooter,
  RK as LBAlertDialogHeader,
  fS as LBAlertDialogOverlay,
  dS as LBAlertDialogPortal,
  OK as LBAlertDialogTitle,
  TK as LBAlertDialogTrigger,
  VY as LBAlertTitle,
  hte as LBAllocationIcon,
  bJ as LBAnalyticsBarsIcon,
  zJ as LBAreaChartIcon,
  Vee as LBAreaChartSkeleton,
  yJ as LBArrowCornerLeftDownIcon,
  CJ as LBArrowCornerLeftUpIcon,
  wJ as LBArrowCornerRightDownIcon,
  xJ as LBArrowCornerRightUpIcon,
  _J as LBArrowDownIcon,
  kJ as LBArrowLeftIcon,
  SJ as LBArrowRightIcon,
  MJ as LBArrowUpIcon,
  iC as LBAvatar,
  sC as LBAvatarFallback,
  aC as LBAvatarImage,
  ote as LBAzureIcon,
  Pk as LBBarChart,
  YQ as LBBarChartSkeleton,
  ete as LBBitbucketIcon,
  Or as LBButton,
  EJ as LBCDPartitionIcon,
  t8 as LBCalendar,
  vR as LBCard,
  wR as LBCardContent,
  CR as LBCardDescription,
  xR as LBCardFooter,
  bR as LBCardHeader,
  yR as LBCardTitle,
  see as LBCheckCircleIcon,
  U0 as LBCheckIcon,
  cR as LBCheckbox,
  LJ as LBChevronDoubleLeftIcon,
  TJ as LBChevronDoubleRightIcon,
  V0 as LBChevronDownIcon,
  HP as LBChevronLeftIcon,
  Xv as LBChevronRightIcon,
  UP as LBChevronUpDownIcon,
  VP as LBChevronUpIcon,
  KQ as LBCircleSkeleton,
  Yee as LBCoachingIcon,
  zG as LBCollapsible,
  GG as LBCollapsibleContent,
  YG as LBCollapsibleTrigger,
  zee as LBColorPicker,
  VS as LBColorPickerContent,
  US as LBColorPickerItem,
  eg as LBColorSwatch,
  lJ as LBCombobox,
  ch as LBCommand,
  aO as LBCommandDialog,
  Wy as LBCommandEmpty,
  qy as LBCommandGroup,
  $y as LBCommandInput,
  jy as LBCommandItem,
  Fy as LBCommandList,
  Hy as LBCommandLoading,
  sO as LBCommandSeparator,
  lO as LBCommandShortcut,
  aee as LBCopyIcon,
  UQ as LBDatePicker,
  zQ as LBDateRangePicker,
  lte as LBDeliveryIcon,
  Ly as LBDialog,
  ah as LBDialogClose,
  Ty as LBDialogContent,
  DA as LBDialogDescription,
  OA as LBDialogFooter,
  AA as LBDialogHeader,
  sh as LBDialogOverlay,
  ih as LBDialogPortal,
  NA as LBDialogTitle,
  RA as LBDialogTrigger,
  XQ as LBDoughnutChartSkeleton,
  Qv as LBDropdownMenu,
  eR as LBDropdownMenuCheckboxItem,
  tb as LBDropdownMenuContent,
  GP as LBDropdownMenuGroup,
  JP as LBDropdownMenuItem,
  nR as LBDropdownMenuLabel,
  KP as LBDropdownMenuPortal,
  eb as LBDropdownMenuRadioGroup,
  tR as LBDropdownMenuRadioItem,
  rR as LBDropdownMenuSeparator,
  oR as LBDropdownMenuShortcut,
  ZP as LBDropdownMenuSub,
  QP as LBDropdownMenuSubContent,
  XP as LBDropdownMenuSubTrigger,
  Jv as LBDropdownMenuTrigger,
  dee as LBDrownHandIcon,
  BJ as LBEditIcon,
  hee as LBEditMergedAccountsIcon,
  QJ as LBEditProfileIcon,
  vee as LBExportFileIcon,
  FG as LBFilterChip,
  $G as LBFilterChipBar,
  WG as LBFilterChipLabel,
  eee as LBFilterIcon,
  tee as LBFilterOffIcon,
  fee as LBFlameIcon,
  ste as LBForecastingIcon,
  Eee as LBForm,
  vN as LBFormControl,
  bN as LBFormDescription,
  Lee as LBFormField,
  pC as LBFormFieldContext,
  pN as LBFormItem,
  gC as LBFormItemContext,
  gN as LBFormLabel,
  yN as LBFormMessage,
  dte as LBGitActivityIcon,
  fJ as LBGithubIcon,
  rte as LBGitlabIcon,
  pte as LBGoalsIcon,
  ite as LBGoogleIcon,
  PJ as LBGraphStatsAscendIcon,
  RJ as LBGraphStatsIcon,
  Jee as LBHelpIcon,
  ree as LBHideIcon,
  Gee as LBHomeIcon,
  Ree as LBHoverCard,
  PN as LBHoverCardContent,
  Aee as LBHoverCardTrigger,
  JJ as LBImportIcon,
  HO as LBInput,
  mte as LBInvestmentStrategyIcon,
  cte as LBIterationsIcon,
  nte as LBJiraIcon,
  Qy as LBJiraStatusBadge,
  tJ as LBJiraStatusCheckbox,
  eJ as LBJiraStatusPicker,
  JQ as LBJiraStatusPickerItem,
  zP as LBKebabIcon,
  cC as LBLabel,
  AJ as LBLayoutIcon,
  BG as LBLineChart,
  HJ as LBListIcon,
  OJ as LBListToDoIcon,
  gte as LBLogoFull,
  vte as LBLogoIcon,
  cee as LBLogoutIcon,
  XJ as LBLonelyUserIcon,
  oee as LBMergeAccountsIcon,
  ute as LBMetricsIcon,
  ate as LBMsTeamsIcon,
  mee as LBMultipleAccountsIcon,
  NJ as LBMultipleNeutralIcon,
  GJ as LBMultipleUsersIcon,
  jJ as LBNameIcon,
  DJ as LBOrganicPlantGrowIcon,
  JN as LBPagination,
  vh as LBPaginationButton,
  eD as LBPaginationContent,
  oD as LBPaginationEllipsis,
  tD as LBPaginationItem,
  rD as LBPaginationNext,
  nD as LBPaginationPrevious,
  FJ as LBPlusIcon,
  J0 as LBPopover,
  CA as LBPopoverAnchor,
  tl as LBPopoverContent,
  el as LBPopoverTrigger,
  uJ as LBPortrait,
  Zee as LBProductivityIcon,
  UK as LBProgress,
  Uee as LBProgressBarChart,
  QQ as LBProgressBarChartSkeleton,
  VJ as LBPublishsurveyIcon,
  gee as LBQuotesIcon,
  HN as LBRadioGroup,
  VN as LBRadioGroupItem,
  KJ as LBRemoveUserIcon,
  $J as LBReplaceSwitchIcon,
  Xee as LBResourcesIcon,
  qJ as LBSSurveyResultsIcon,
  cK as LBScrollArea,
  Xk as LBScrollBar,
  YP as LBSearchIcon,
  Kb as LBSelect,
  nA as LBSelectContent,
  tA as LBSelectGroup,
  oA as LBSelectItem,
  rA as LBSelectLabel,
  Jb as LBSelectScrollDownButton,
  Qb as LBSelectScrollUpButton,
  iA as LBSelectSeparator,
  Xb as LBSelectTrigger,
  Zb as LBSelectValue,
  UG as LBSeparator,
  Kee as LBSettingsIcon,
  iD as LBSheet,
  Nee as LBSheetClose,
  cD as LBSheetContent,
  fD as LBSheetDescription,
  uD as LBSheetHeader,
  dD as LBSheetTitle,
  aD as LBSheetTrigger,
  nee as LBShowIcon,
  hn as LBSkeleton,
  tte as LBSlackIcon,
  GD as LBStep,
  KD as LBStepper,
  Bee as LBStepperSeparator,
  WJ as LBStopSignIcon,
  UJ as LBSurveysIcon,
  gR as LBSwitch,
  UN as LBTable,
  YN as LBTableBody,
  QN as LBTableCaption,
  XN as LBTableCell,
  GN as LBTableFooter,
  ZN as LBTableHead,
  zN as LBTableHeader,
  KN as LBTableRow,
  sE as LBTabs,
  uE as LBTabsContent,
  lE as LBTabsList,
  cE as LBTabsTrigger,
  pee as LBTargetIcon,
  IJ as LBTaskListCheckIcon,
  fte as LBTeamActivityIcon,
  Qee as LBTeamsIcon,
  YO as LBTextarea,
  VD as LBToast,
  WD as LBToaster,
  kee as LBTooltip,
  PO as LBTooltipContent,
  _ee as LBTooltipProvider,
  See as LBTooltipTrigger,
  uee as LBTrophyIcon,
  iee as LBUnmergeAccountsIcon,
  ZJ as LBUserIcon,
  rJ as LBWizard,
  iJ as LBWizardContent,
  nJ as LBWizardHeader,
  sJ as LBWizardMain,
  aJ as LBWizardSidebar,
  oJ as LBWizardTitle,
  ts as LBXIcon,
  dJ as LB_COLOR_PICKER_PALETTE,
  co as buttonVariants,
  GQ as circleSkeletonVariants,
  Q as cn,
  ZQ as doughnutChartSkeletonVariants,
  fh as jiraStatusBadgeVariants,
  Iee as lbDefineStepper,
  Dee as lbToast,
  YD as stepVariants,
  jD as toastButtonVariants,
  HD as toastCloseButtonVariants,
  qD as toastVariants,
  ul as useLBFormField
};
